export const orissaBoundary = {
    type: "FeatureCollection",
    crs: { type: "name", properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" } },
  
    features: [
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Angul",
          Dist_Code: "384",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [85.243823198392974, 20.87778769961249],
              [85.251548, 20.87292100000013],
              [85.253287, 20.870081000000138],
              [85.254028, 20.862569000000171],
              [85.25254, 20.837120000000191],
              [85.248626, 20.829460000000207],
              [85.248061, 20.82404],
              [85.248458000000184, 20.818611000000143],
              [85.251099, 20.807521],
              [85.251266, 20.80157],
              [85.249771000000109, 20.79269],
              [85.250839, 20.79042000000015],
              [85.238694, 20.789101],
              [85.231109, 20.785842],
              [85.224823, 20.787380000000152],
              [85.219406, 20.78774],
              [85.214631000000153, 20.786840000000208],
              [85.211739000000165, 20.779752000000141],
              [85.207809, 20.779471000000168],
              [85.203454000000164, 20.782040000000105],
              [85.198921, 20.783501000000168],
              [85.195518, 20.78201],
              [85.193009000000117, 20.777402],
              [85.194978000000134, 20.772431000000147],
              [85.201843, 20.764721000000119],
              [85.203789000000185, 20.759000000000125],
              [85.202262000000118, 20.754052000000168],
              [85.203149000000153, 20.749651000000192],
              [85.20829, 20.746280000000176],
              [85.209922, 20.743151],
              [85.200623, 20.73021000000011],
              [85.19854, 20.723400000000137],
              [85.198898000000128, 20.712481000000132],
              [85.196320000000171, 20.71006],
              [85.192674, 20.702409],
              [85.190812, 20.686180000000203],
              [85.191712, 20.682250000000117],
              [85.191680000000119, 20.67828],
              [85.19045200000015, 20.675399],
              [85.190796, 20.67147],
              [85.18039600000013, 20.666321000000206],
              [85.166489000000155, 20.655229000000126],
              [85.161942, 20.65282],
              [85.162872, 20.655701],
              [85.162270000000134, 20.658650000000186],
              [85.158578, 20.669241],
              [85.161247, 20.672970000000184],
              [85.160492000000119, 20.677250000000125],
              [85.166001000000136, 20.684851000000201],
              [85.168731, 20.690731000000191],
              [85.169251, 20.69448],
              [85.165497000000173, 20.698191000000115],
              [85.16030100000016, 20.700800000000182],
              [85.155968, 20.70181],
              [85.152832000000146, 20.705691],
              [85.147431, 20.716740000000126],
              [85.147424000000157, 20.72540100000014],
              [85.13861, 20.7233],
              [85.134369000000135, 20.723370000000155],
              [85.130271, 20.71259],
              [85.129068000000174, 20.704800000000201],
              [85.125863, 20.700189],
              [85.118980000000164, 20.693810000000209],
              [85.11403, 20.68696100000016],
              [85.108697, 20.675771000000164],
              [85.118661, 20.655751000000119],
              [85.121216000000103, 20.645941],
              [85.130608, 20.633310000000161],
              [85.127427000000111, 20.62772],
              [85.123208, 20.609111],
              [85.116799000000171, 20.60378],
              [85.113585, 20.602920000000147],
              [85.109790551824958, 20.603171382901447],
              [85.109625753415898, 20.603182300827083],
              [85.101311230350333, 20.603733139535048],
              [85.094833775540422, 20.606860609521156],
              [85.084840039315935, 20.611143639331594],
              [85.082698524410802, 20.610072881878917],
              [85.086853000000119, 20.604691000000113],
              [85.083314, 20.600320000000117],
              [85.082610202759312, 20.594421565069975],
              [85.082466101716349, 20.593213872604956],
              [85.082122000000183, 20.590330000000105],
              [85.075378000000157, 20.583949],
              [85.071023, 20.57501000000013],
              [85.067016000000109, 20.573882],
              [85.064377000000121, 20.576312000000193],
              [85.061997000000162, 20.574591000000108],
              [85.060782000000174, 20.570842],
              [85.051438000000104, 20.570131000000167],
              [85.043427, 20.576271000000183],
              [85.020690000000158, 20.581239000000203],
              [85.003448000000148, 20.578319000000189],
              [84.993552, 20.575202],
              [84.985931, 20.57645100000013],
              [84.985238000000138, 20.570621],
              [84.983223, 20.564599],
              [84.979957000000155, 20.560911],
              [84.97779, 20.561620000000115],
              [84.974426, 20.56689],
              [84.970581000000138, 20.567899],
              [84.960106, 20.567421000000135],
              [84.951812, 20.569839000000169],
              [84.944763000000165, 20.574609000000176],
              [84.9376, 20.575161000000147],
              [84.91999800000012, 20.57364],
              [84.90483, 20.574992],
              [84.891602, 20.574199000000132],
              [84.891290000000183, 20.569160000000121],
              [84.889068000000165, 20.562691],
              [84.884377000000171, 20.558019],
              [84.875001000000154, 20.55184],
              [84.869798, 20.540759000000147],
              [84.861634, 20.53056],
              [84.854637, 20.525111],
              [84.845039000000142, 20.52208],
              [84.839959000000107, 20.527570000000132],
              [84.818886000000177, 20.554149000000159],
              [84.793998, 20.57323],
              [84.787728, 20.57517],
              [84.776061000000126, 20.592019],
              [84.771767, 20.596010000000202],
              [84.757286000000121, 20.602961000000157],
              [84.745010000000136, 20.605690000000148],
              [84.73993, 20.607331],
              [84.735062000000184, 20.61007],
              [84.727668000000151, 20.61195900000018],
              [84.713577, 20.606551000000188],
              [84.705071000000132, 20.605820000000104],
              [84.630981, 20.619020000000141],
              [84.61995, 20.6257],
              [84.611633, 20.634069000000117],
              [84.599449, 20.644150000000192],
              [84.581879, 20.66889000000014],
              [84.574280000000144, 20.675771000000164],
              [84.565018000000109, 20.681630000000151],
              [84.542388000000173, 20.689580000000145],
              [84.529069, 20.692529],
              [84.515953000000167, 20.699911000000153],
              [84.505494, 20.710019],
              [84.480439000000132, 20.72166100000015],
              [84.470131000000123, 20.728950000000165],
              [84.461274, 20.73228000000017],
              [84.450448, 20.737962],
              [84.432716, 20.737490000000143],
              [84.419671, 20.736191000000129],
              [84.409508, 20.740731],
              [84.401802000000117, 20.742951],
              [84.391776000000149, 20.74817],
              [84.376862, 20.751139],
              [84.365304, 20.757501000000101],
              [84.356299, 20.766572000000107],
              [84.350456, 20.77624000000014],
              [84.349425, 20.785481],
              [84.353523, 20.793041000000127],
              [84.352249000000128, 20.803149000000129],
              [84.354401, 20.82167],
              [84.350472000000167, 20.830472],
              [84.344879000000148, 20.836420000000199],
              [84.33612, 20.841400000000132],
              [84.326668, 20.848680000000112],
              [84.311751, 20.85783],
              [84.260696, 20.884309000000197],
              [84.261970000000176, 20.89057],
              [84.259659, 20.894251000000164],
              [84.260307, 20.900051],
              [84.266586000000174, 20.904489000000122],
              [84.264054000000144, 20.909380000000166],
              [84.268539000000132, 20.913432],
              [84.276030000000148, 20.92217],
              [84.281434, 20.923811000000107],
              [84.287957, 20.927451000000186],
              [84.293327000000133, 20.93087],
              [84.297653000000125, 20.934922000000135],
              [84.301871, 20.932661000000163],
              [84.306106000000156, 20.931661000000183],
              [84.311751, 20.940121],
              [84.320123000000166, 20.943241000000164],
              [84.325417000000115, 20.94722],
              [84.333526000000148, 20.947929],
              [84.338340000000173, 20.95037],
              [84.346877000000106, 20.950719000000156],
              [84.353813, 20.953741],
              [84.358490000000103, 20.954099],
              [84.361427000000148, 20.950361000000207],
              [84.365769, 20.94988],
              [84.371512, 20.953632000000137],
              [84.378327000000112, 20.963639000000168],
              [84.385857000000144, 20.967161],
              [84.394867000000133, 20.968941],
              [84.400619000000148, 20.974021000000103],
              [84.405098, 20.987939],
              [84.409706, 20.996621000000115],
              [84.415176, 21.000892000000128],
              [84.42359100000013, 21.003681000000192],
              [84.429168000000104, 21.009299000000109],
              [84.42814700000018, 21.014810000000121],
              [84.422073000000168, 21.0185],
              [84.403892, 21.025860000000133],
              [84.414741000000149, 21.032310000000162],
              [84.42359100000013, 21.036061000000185],
              [84.435417, 21.0296610000002],
              [84.438050000000132, 21.035521000000127],
              [84.444625, 21.036551],
              [84.451606000000169, 21.051290000000105],
              [84.464631000000153, 21.066191],
              [84.472588, 21.073851],
              [84.478415, 21.077680000000154],
              [84.490014000000116, 21.07585],
              [84.495819000000139, 21.07799],
              [84.500359000000103, 21.083419000000159],
              [84.507461, 21.084771],
              [84.515702, 21.083130000000203],
              [84.522332, 21.082692],
              [84.528588, 21.083731],
              [84.538108, 21.073851],
              [84.543396, 21.069460000000159],
              [84.549119, 21.066510000000161],
              [84.555863, 21.066941],
              [84.565162000000143, 21.06086],
              [84.573455000000124, 21.059281000000109],
              [84.582627000000159, 21.058909],
              [84.593063000000129, 21.06156000000021],
              [84.624367000000106, 21.077591000000208],
              [84.626473000000132, 21.07518],
              [84.630981, 21.07789],
              [84.645232, 21.07941900000014],
              [84.649407, 21.076892],
              [84.654251, 21.071661],
              [84.658729, 21.069781],
              [84.66195, 21.06494],
              [84.672242, 21.05908],
              [84.676666000000168, 21.059142000000175],
              [84.677598, 21.066531000000108],
              [84.666740000000104, 21.074212],
              [84.664322, 21.081480000000109],
              [84.664192, 21.090491000000149],
              [84.665710000000146, 21.102359000000146],
              [84.668053, 21.111152000000114],
              [84.67025, 21.118201000000166],
              [84.674508000000159, 21.123621],
              [84.676506, 21.136181000000132],
              [84.679009, 21.144122],
              [84.685669, 21.14865],
              [84.695159000000132, 21.15051000000016],
              [84.704583, 21.1490310000002],
              [84.71219500000015, 21.145719],
              [84.719033000000167, 21.144370000000201],
              [84.721048, 21.147470000000165],
              [84.723502, 21.154720000000165],
              [84.727477000000178, 21.15982],
              [84.738747, 21.16599],
              [84.742469000000185, 21.163312000000186],
              [84.757630000000162, 21.1452],
              [84.773003, 21.140769000000144],
              [84.78508000000015, 21.133800000000118],
              [84.788918, 21.130581],
              [84.793975000000145, 21.128562000000155],
              [84.797898, 21.132070000000162],
              [84.800147000000138, 21.1358600000002],
              [84.806342, 21.132111000000172],
              [84.810959000000125, 21.135981000000122],
              [84.812637, 21.140231000000195],
              [84.804161, 21.151],
              [84.798866, 21.151059000000142],
              [84.794616, 21.154079],
              [84.793289, 21.157699],
              [84.793221000000116, 21.161931000000148],
              [84.80069700000017, 21.16200200000014],
              [84.816963, 21.167640000000169],
              [84.844887000000185, 21.164],
              [84.851569, 21.161671000000119],
              [84.859161000000128, 21.161461000000138],
              [84.874205000000174, 21.160160000000129],
              [84.877693000000122, 21.154952000000204],
              [84.879928000000106, 21.152201],
              [84.884742000000173, 21.149580000000121],
              [84.897377, 21.146690000000142],
              [84.90368600000015, 21.140801000000121],
              [84.91623700000018, 21.13704000000012],
              [84.922416, 21.143620000000109],
              [84.928191000000183, 21.147461000000131],
              [84.930069000000103, 21.151921],
              [84.927116, 21.153601000000148],
              [84.926758, 21.15699],
              [84.927697000000165, 21.161391000000204],
              [84.922929000000153, 21.165571],
              [84.926537, 21.171141],
              [84.923072, 21.173429],
              [84.923973, 21.176032000000131],
              [84.927934, 21.175761],
              [84.933639000000127, 21.172862],
              [84.943733, 21.17069],
              [84.948738, 21.164552000000121],
              [84.945107, 21.15459],
              [84.946160000000106, 21.148069000000188],
              [84.949540000000169, 21.143411],
              [84.956658, 21.143591],
              [84.962303000000176, 21.149361000000162],
              [84.967536, 21.156062000000183],
              [84.962463, 21.159310000000172],
              [84.959664000000117, 21.163209000000162],
              [84.963958000000147, 21.175850000000192],
              [84.964156000000145, 21.180121],
              [84.964272, 21.182382],
              [84.962219000000161, 21.186359000000149],
              [84.943238000000107, 21.19003900000018],
              [84.937180000000154, 21.192291000000179],
              [84.934350000000137, 21.198511],
              [84.933167000000125, 21.205891000000115],
              [84.930398000000181, 21.213132],
              [84.926696, 21.21991],
              [84.924369, 21.226841000000146],
              [84.913017000000181, 21.23722],
              [84.897400000000161, 21.248461],
              [84.895379, 21.254382],
              [84.898781, 21.258810000000146],
              [84.915146000000149, 21.272779],
              [84.956977, 21.293820000000149],
              [84.963119000000162, 21.290531000000154],
              [84.976350000000124, 21.285230000000119],
              [84.985847, 21.283532000000147],
              [84.9935, 21.284820000000135],
              [85.001397, 21.28533],
              [85.004196, 21.291520000000101],
              [85.022981000000172, 21.288580000000191],
              [85.027443, 21.286381000000173],
              [85.031067, 21.289471],
              [85.026787, 21.296689],
              [85.021561, 21.303142000000147],
              [85.012389, 21.305282000000144],
              [85.010277, 21.310439000000141],
              [85.00681200000011, 21.312869000000145],
              [85.005126, 21.320762],
              [85.008294000000134, 21.326311000000139],
              [85.007859, 21.331970000000123],
              [85.00196, 21.345859000000186],
              [85.004173, 21.348330000000143],
              [85.005096, 21.351129000000121],
              [85.002648000000178, 21.354379000000105],
              [85.001343, 21.359211],
              [85.001456000000175, 21.362912],
              [85.003487000000163, 21.36861],
              [85.001488000000137, 21.371812],
              [85.000848000000119, 21.376021000000204],
              [85.001671, 21.378451000000151],
              [84.999268000000114, 21.382150000000134],
              [84.997917, 21.38705],
              [84.993286, 21.395661000000182],
              [84.989578, 21.40596],
              [84.989457000000172, 21.41045900000017],
              [84.992951, 21.422051],
              [84.997787000000159, 21.435078000000196],
              [85.000832, 21.438381000000103],
              [85.007865, 21.437301000000101],
              [85.014801000000119, 21.438739],
              [85.017745, 21.441891],
              [85.019029, 21.444819],
              [85.017098000000118, 21.45103],
              [85.017907, 21.452311000000176],
              [85.022536000000102, 21.449911000000206],
              [85.032227, 21.447821],
              [85.053886, 21.437829],
              [85.057106000000132, 21.43934],
              [85.060769, 21.446451],
              [85.068443000000102, 21.45041],
              [85.071152, 21.452651],
              [85.086022000000114, 21.45152],
              [85.090119000000172, 21.450260000000124],
              [85.098892, 21.450941000000164],
              [85.101807000000164, 21.451901000000184],
              [85.119399, 21.448970000000141],
              [85.125496, 21.451851000000143],
              [85.13446, 21.457551000000134],
              [85.141487, 21.452701000000101],
              [85.151146, 21.45575000000013],
              [85.153236000000149, 21.458392],
              [85.156112, 21.465441000000109],
              [85.170197, 21.478282000000146],
              [85.17891000000013, 21.497221],
              [85.193496, 21.508799],
              [85.200120000000183, 21.515872000000169],
              [85.199899000000173, 21.524701],
              [85.201209, 21.526809000000178],
              [85.202980000000181, 21.526889],
              [85.205521000000118, 21.528211],
              [85.205758000000159, 21.539670000000111],
              [85.209450000000103, 21.54951200000016],
              [85.209236, 21.551241],
              [85.207497, 21.553341],
              [85.201462, 21.555731],
              [85.198807, 21.558291000000164],
              [85.20094200000014, 21.562200000000125],
              [85.194657, 21.571870000000157],
              [85.194916, 21.57455],
              [85.189248000000163, 21.577739000000115],
              [85.18615800000012, 21.580351],
              [85.184868000000151, 21.583001000000134],
              [85.18039600000013, 21.584309000000129],
              [85.169511, 21.58448],
              [85.16031, 21.586639],
              [85.156563000000105, 21.584079000000141],
              [85.144187, 21.589631000000164],
              [85.148873000000137, 21.596412000000207],
              [85.148324000000159, 21.600282000000156],
              [85.160866000000155, 21.60922],
              [85.162796000000171, 21.611741],
              [85.162781000000138, 21.616489000000168],
              [85.164529000000172, 21.617970000000124],
              [85.170486000000139, 21.616101],
              [85.181198, 21.619160000000189],
              [85.185219, 21.619641000000165],
              [85.185570000000141, 21.624851000000145],
              [85.184549, 21.630560000000166],
              [85.18615800000012, 21.632611],
              [85.189506, 21.633760000000105],
              [85.191001, 21.635811000000153],
              [85.188621000000168, 21.638851000000155],
              [85.177695000000128, 21.64242100000012],
              [85.178819, 21.644171000000139],
              [85.179131, 21.646899],
              [85.177451000000175, 21.64999],
              [85.185196000000118, 21.654931000000143],
              [85.18794200000012, 21.658862000000109],
              [85.191224, 21.65566],
              [85.197692000000174, 21.65682],
              [85.201524000000163, 21.66144],
              [85.204979, 21.67053100000015],
              [85.215271, 21.670641],
              [85.218492, 21.67173],
              [85.241958, 21.672811000000191],
              [85.244973000000172, 21.671641000000189],
              [85.251327000000103, 21.650290000000151],
              [85.25901, 21.639241],
              [85.260291000000151, 21.635791],
              [85.258887000000172, 21.627269000000179],
              [85.259322, 21.623980000000181],
              [85.262146000000115, 21.619110000000145],
              [85.271431000000106, 21.61185],
              [85.273200000000131, 21.608350000000137],
              [85.27297900000012, 21.60366200000021],
              [85.280113000000128, 21.597351000000113],
              [85.28514, 21.599231],
              [85.286216, 21.597681],
              [85.287301000000113, 21.594342000000207],
              [85.283607000000174, 21.592029000000135],
              [85.280297, 21.588271],
              [85.281747000000138, 21.582509],
              [85.28769800000012, 21.572891],
              [85.298920000000109, 21.562370000000154],
              [85.302362000000173, 21.561331000000159],
              [85.304917, 21.562580000000136],
              [85.306863, 21.562031],
              [85.30764, 21.560119],
              [85.302772000000147, 21.554799000000109],
              [85.302011, 21.55293000000017],
              [85.302353000000139, 21.55097000000017],
              [85.29667700000013, 21.549671000000156],
              [85.295700000000167, 21.534670000000116],
              [85.297142000000107, 21.53231100000016],
              [85.298257000000135, 21.52713000000011],
              [85.301986000000142, 21.526440000000203],
              [85.305748, 21.529391000000139],
              [85.311271000000133, 21.531219],
              [85.315164000000124, 21.529542],
              [85.318238, 21.526871000000195],
              [85.317855, 21.52386],
              [85.316590000000176, 21.521351000000145],
              [85.322967000000105, 21.50531],
              [85.324387000000144, 21.49267],
              [85.325996, 21.488121000000145],
              [85.325340000000139, 21.483720000000172],
              [85.326142, 21.479041],
              [85.327751000000134, 21.476809000000113],
              [85.327218000000101, 21.474840000000139],
              [85.324891000000136, 21.472080000000172],
              [85.320975000000132, 21.46427],
              [85.318992, 21.461920000000131],
              [85.306587000000135, 21.455370000000126],
              [85.302596000000136, 21.444380000000134],
              [85.297334, 21.442091000000111],
              [85.293860000000137, 21.441050000000129],
              [85.291786000000158, 21.441191],
              [85.288452000000149, 21.4434],
              [85.28443900000012, 21.442821],
              [85.280457000000155, 21.447662],
              [85.274392000000134, 21.444851000000192],
              [85.262338, 21.45021],
              [85.257103000000129, 21.449840000000158],
              [85.253121000000178, 21.446360000000194],
              [85.254753, 21.440660000000204],
              [85.256622000000149, 21.437620000000205],
              [85.264457, 21.434461000000109],
              [85.269118, 21.42227],
              [85.277038, 21.419681],
              [85.284074000000118, 21.415161000000175],
              [85.299187000000174, 21.409099],
              [85.302628000000112, 21.399041],
              [85.301078000000174, 21.389990000000118],
              [85.309700000000163, 21.387301000000203],
              [85.324342000000144, 21.377911],
              [85.324966000000103, 21.372671000000132],
              [85.333679000000174, 21.365052000000155],
              [85.335876, 21.360412000000103],
              [85.337638000000183, 21.353889000000201],
              [85.335297000000125, 21.34998],
              [85.330985, 21.345921000000143],
              [85.328743000000117, 21.340861000000181],
              [85.3274, 21.33303],
              [85.32322, 21.31897],
              [85.320618, 21.31448000000017],
              [85.316857, 21.317541000000169],
              [85.313652, 21.32292],
              [85.309730000000158, 21.323909000000182],
              [85.306733000000165, 21.31634],
              [85.302642, 21.31304],
              [85.291176000000107, 21.308981000000127],
              [85.290610000000171, 21.30203200000016],
              [85.287217, 21.300131],
              [85.283768000000165, 21.2995],
              [85.279137, 21.294850000000107],
              [85.276901000000109, 21.29400900000018],
              [85.272667, 21.29591],
              [85.268569000000113, 21.296591],
              [85.267509000000175, 21.294201],
              [85.272247000000149, 21.287812],
              [85.272553, 21.282901000000148],
              [85.272247000000149, 21.280002000000131],
              [85.268883000000173, 21.277921],
              [85.267883, 21.27003900000016],
              [85.274987000000152, 21.2642],
              [85.281143, 21.260371000000131],
              [85.284249, 21.261351],
              [85.284812, 21.264241],
              [85.294136, 21.270801000000173],
              [85.307152, 21.25876],
              [85.314569000000162, 21.255701],
              [85.336517000000157, 21.252280000000209],
              [85.34349800000011, 21.245391],
              [85.359650000000144, 21.237781],
              [85.362923, 21.235558],
              [85.377243, 21.210581],
              [85.376479000000103, 21.204152000000132],
              [85.37719700000018, 21.19352],
              [85.388862, 21.179480000000119],
              [85.377808000000115, 21.164399],
              [85.375191000000115, 21.163720000000179],
              [85.359139000000184, 21.165621],
              [85.355156000000122, 21.163690000000198],
              [85.345367000000167, 21.163209000000162],
              [85.338990000000123, 21.165252000000116],
              [85.334908, 21.173960000000132],
              [85.333718, 21.1712300000002],
              [85.329568, 21.17082],
              [85.314826, 21.15497],
              [85.294982, 21.171132],
              [85.28514, 21.175489000000137],
              [85.279098000000133, 21.169429000000203],
              [85.267723, 21.16867000000013],
              [85.262725, 21.16465],
              [85.260467000000162, 21.157979000000179],
              [85.259774000000149, 21.15196],
              [85.256813000000108, 21.146989000000186],
              [85.255806000000106, 21.139739000000187],
              [85.254197, 21.134909],
              [85.249932000000101, 21.12809000000021],
              [85.238136, 21.11869100000018],
              [85.244873, 21.108681],
              [85.235818, 21.095649],
              [85.22718, 21.065852],
              [85.214446000000166, 21.066741],
              [85.189294, 21.075162000000141],
              [85.180268, 21.075009000000133],
              [85.173782000000173, 21.070280000000135],
              [85.166717, 21.056981],
              [85.162858000000114, 21.052111000000192],
              [85.161689, 21.047872],
              [85.163512, 21.043521000000162],
              [85.167054, 21.038771],
              [85.173141, 21.035990000000194],
              [85.194900000000118, 21.029759000000123],
              [85.212691, 21.016941],
              [85.22367, 21.011221000000202],
              [85.243631000000136, 20.99516200000016],
              [85.250557000000157, 20.987830000000141],
              [85.256348, 20.97834],
              [85.257759, 20.974461000000126],
              [85.256072000000117, 20.971131000000121],
              [85.252761, 20.968081000000147],
              [85.243683, 20.962520000000151],
              [85.240517, 20.958960000000101],
              [85.23867100000011, 20.954361],
              [85.241723, 20.93979],
              [85.241723, 20.927041000000195],
              [85.241408, 20.92403900000016],
              [85.237586000000164, 20.912220000000101],
              [85.236358, 20.901492000000129],
              [85.237076000000101, 20.897681],
              [85.239289, 20.89421000000015],
              [85.243599000000174, 20.891881000000179],
              [85.247251064567166, 20.890834204669769],
              [85.253070285130534, 20.889166235004431],
              [85.25050464990629, 20.886069778699376],
              [85.246886346322384, 20.883657576310092],
              [85.244474143933118, 20.881546899219355],
              [85.24447549799433, 20.878981985879701],
              [85.243823198392974, 20.87778769961249],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Baleshwar",
          Dist_Code: "377",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [87.123886000000184, 21.519721000000114],
                [87.123886000000184, 21.517779000000186],
                [87.123756, 21.517499],
                [87.123612, 21.514999],
                [87.123879, 21.514721000000115],
                [87.123612, 21.51444500000019],
                [87.123047, 21.514440000000143],
                [87.122498, 21.514999],
                [87.122436, 21.515290000000103],
                [87.122222000000107, 21.51555900000016],
                [87.122101, 21.515701000000199],
                [87.121948, 21.51571],
                [87.121392, 21.51555900000016],
                [87.121110000000144, 21.515564],
                [87.120834, 21.515564],
                [87.120551, 21.515557],
                [87.120278, 21.51555900000016],
                [87.119163000000171, 21.516667000000208],
                [87.118881, 21.517219],
                [87.118890000000121, 21.517499],
                [87.118890000000121, 21.517779000000186],
                [87.119095, 21.518123],
                [87.119156000000132, 21.518331],
                [87.119446000000124, 21.51875],
                [87.119446000000124, 21.51889100000016],
                [87.119719, 21.519090000000116],
                [87.120278, 21.519443000000191],
                [87.120551, 21.519441000000196],
                [87.121666000000161, 21.520555],
                [87.122436, 21.520824],
                [87.123054, 21.520824],
                [87.123658000000134, 21.520503000000126],
                [87.123886000000184, 21.519721000000114],
              ],
            ],
            [
              [
                [87.075519403542131, 21.713550357525829],
                [87.076526340285312, 21.714949995882016],
                [87.078300045285829, 21.714743679487121],
                [87.080512944021208, 21.71395845735514],
                [87.081155398492839, 21.7119597101103],
                [87.081940620624806, 21.710175114355927],
                [87.082797226586791, 21.70910435690325],
                [87.084082135529954, 21.710317882016167],
                [87.084224903190346, 21.712459396921524],
                [87.085010125322341, 21.713815689694908],
                [87.085295660643041, 21.714957830977589],
                [87.085224276812795, 21.716099972260505],
                [87.086006000000324, 21.717219000000281],
                [87.086285197372916, 21.719404686166392],
                [87.086295315559411, 21.719483896008789],
                [87.086310749627813, 21.719604721036827],
                [87.0867930000001, 21.72338],
                [87.089578000000103, 21.72155900000018],
                [87.089019, 21.724371000000186],
                [87.086243, 21.726619000000195],
                [87.085038000000139, 21.725602],
                [87.083335000000133, 21.726949000000101],
                [87.08184, 21.729611],
                [87.083075000000107, 21.732540000000135],
                [87.086357, 21.730541000000123],
                [87.088479000000163, 21.72826],
                [87.090859, 21.72707000000019],
                [87.092217000000161, 21.727849000000155],
                [87.092880000000136, 21.72969100000017],
                [87.090606, 21.73386900000019],
                [87.090348, 21.737271],
                [87.097268, 21.745991],
                [87.117385000000155, 21.74828],
                [87.118156000000155, 21.749880000000125],
                [87.10994, 21.755769],
                [87.102592, 21.762561],
                [87.099084000000104, 21.768261],
                [87.09941, 21.77396100000021],
                [87.101327, 21.778262],
                [87.103836000000143, 21.7774],
                [87.107086000000137, 21.777651],
                [87.108223, 21.781379],
                [87.111236000000105, 21.782191000000122],
                [87.114739, 21.781170000000198],
                [87.113791000000148, 21.779280000000139],
                [87.110206000000161, 21.778932000000108],
                [87.110619, 21.777651],
                [87.113616, 21.777152000000111],
                [87.117996, 21.772470000000162],
                [87.119667000000135, 21.766451],
                [87.121711000000161, 21.765720000000151],
                [87.123177, 21.766399000000199],
                [87.121627000000146, 21.769359000000115],
                [87.12227, 21.7709],
                [87.124237, 21.770759000000162],
                [87.127029000000135, 21.764379000000186],
                [87.133369000000172, 21.761061],
                [87.141403000000182, 21.758520000000196],
                [87.147087, 21.759990000000126],
                [87.155228000000122, 21.763260000000166],
                [87.157195000000158, 21.767030000000144],
                [87.160422000000125, 21.778631],
                [87.157416, 21.780349000000108],
                [87.158387000000147, 21.782802],
                [87.160493, 21.78271],
                [87.165076, 21.780981],
                [87.166847000000118, 21.783711000000149],
                [87.166863, 21.78775000000018],
                [87.165108, 21.793140000000104],
                [87.166558000000151, 21.798630000000109],
                [87.16462100000011, 21.8008],
                [87.169869, 21.805500000000102],
                [87.17217400000014, 21.803011],
                [87.173126, 21.790359],
                [87.174897, 21.785961000000153],
                [87.179818, 21.785129000000204],
                [87.176376000000147, 21.796189000000133],
                [87.175941, 21.803280000000139],
                [87.173974, 21.80735],
                [87.166366, 21.812941000000134],
                [87.161026, 21.814051000000113],
                [87.133918, 21.8291],
                [87.129014, 21.830331000000111],
                [87.125221, 21.832630000000105],
                [87.115852000000118, 21.847919000000157],
                [87.100937, 21.851789000000107],
                [87.094642, 21.86034],
                [87.092919000000151, 21.874202],
                [87.09626, 21.882101],
                [87.096123, 21.886249],
                [87.093147, 21.889869000000139],
                [87.089416, 21.892401000000174],
                [87.088538, 21.895072000000194],
                [87.08876900000017, 21.898121],
                [87.091018, 21.899231],
                [87.093537000000126, 21.907899000000153],
                [87.099556, 21.910980000000158],
                [87.101808, 21.916081000000187],
                [87.104684000000162, 21.91782000000017],
                [87.107856, 21.917419],
                [87.110336, 21.91802000000018],
                [87.112556, 21.921150000000175],
                [87.114243, 21.922171000000102],
                [87.11618, 21.920641000000153],
                [87.123512000000105, 21.920249],
                [87.130912, 21.918011000000142],
                [87.136756, 21.917970000000132],
                [87.14113, 21.919691],
                [87.14782800000016, 21.92592900000016],
                [87.151686000000126, 21.927999],
                [87.15641800000013, 21.92891],
                [87.158287, 21.930549000000148],
                [87.159896000000145, 21.933929],
                [87.159766, 21.949081000000145],
                [87.161277, 21.953899000000202],
                [87.160561000000115, 21.962441000000123],
                [87.165206, 21.967510000000168],
                [87.167442000000136, 21.973410000000168],
                [87.170852000000181, 21.97261],
                [87.174972000000167, 21.966199],
                [87.188378, 21.957010000000189],
                [87.195106, 21.95357000000012],
                [87.202912000000183, 21.95644],
                [87.209572, 21.957370000000136],
                [87.221191, 21.953210000000176],
                [87.223235, 21.953231000000184],
                [87.224402000000154, 21.954019000000184],
                [87.225617000000142, 21.957121000000139],
                [87.228737000000166, 21.956080000000153],
                [87.234848, 21.954380000000178],
                [87.235, 21.952989],
                [87.232322000000153, 21.94646200000016],
                [87.232231, 21.940361],
                [87.235429, 21.93374],
                [87.252082, 21.920972000000173],
                [87.252404000000169, 21.917802000000101],
                [87.250549000000134, 21.915181000000125],
                [87.239372000000145, 21.906830000000177],
                [87.236518, 21.902721000000152],
                [87.234809, 21.895601000000109],
                [87.24733, 21.871722000000197],
                [87.248978000000179, 21.866519],
                [87.249001000000121, 21.86380000000019],
                [87.24475, 21.85637],
                [87.247627000000122, 21.84820800000011],
                [87.255271, 21.843880000000119],
                [87.257149000000169, 21.84138],
                [87.258888000000169, 21.835010000000178],
                [87.261696, 21.833300000000119],
                [87.262261000000166, 21.829829000000128],
                [87.263574, 21.827199000000171],
                [87.263467000000148, 21.825020000000158],
                [87.267562, 21.821492],
                [87.267806000000164, 21.81971],
                [87.263268, 21.816041],
                [87.262421000000117, 21.8138590000002],
                [87.265427000000145, 21.812891],
                [87.271478, 21.81308],
                [87.273796000000161, 21.811719],
                [87.273148, 21.8058],
                [87.271653000000171, 21.80472],
                [87.27156, 21.803400000000121],
                [87.273338000000109, 21.803601],
                [87.27350600000014, 21.802040000000201],
                [87.280608, 21.799159000000195],
                [87.286987, 21.803849000000124],
                [87.292815000000104, 21.80547000000012],
                [87.294807, 21.803890000000134],
                [87.294488, 21.798421],
                [87.296569, 21.795330000000146],
                [87.29872, 21.794441000000116],
                [87.306052, 21.793860000000162],
                [87.307557, 21.792682],
                [87.309166000000161, 21.78891],
                [87.317963, 21.790551000000104],
                [87.316855, 21.78855],
                [87.317307000000113, 21.785721000000191],
                [87.322861000000131, 21.785961000000153],
                [87.32427200000015, 21.785379],
                [87.326186000000106, 21.785641000000105],
                [87.330115000000134, 21.787702000000131],
                [87.332702000000126, 21.787200000000151],
                [87.335342, 21.783631],
                [87.335731000000109, 21.781211000000205],
                [87.335006000000121, 21.780130000000153],
                [87.336670000000183, 21.77918],
                [87.339225000000141, 21.78081],
                [87.340463, 21.783959000000205],
                [87.344497, 21.785961000000153],
                [87.352082, 21.78573],
                [87.355049000000108, 21.779280000000139],
                [87.35736000000017, 21.777241000000171],
                [87.367799, 21.77464],
                [87.370454, 21.768021],
                [87.368735, 21.762631000000162],
                [87.370117, 21.760072000000143],
                [87.371666000000104, 21.760391],
                [87.373061, 21.762041000000174],
                [87.37349, 21.76641],
                [87.375427, 21.767999],
                [87.383301000000159, 21.770861],
                [87.390962, 21.770442],
                [87.392402, 21.768981000000103],
                [87.389899, 21.766540000000127],
                [87.393159000000125, 21.766139000000173],
                [87.393776, 21.763771000000183],
                [87.395242000000138, 21.762422000000122],
                [87.399932, 21.76257],
                [87.401017000000181, 21.76486],
                [87.402831000000134, 21.765521000000202],
                [87.412087, 21.763750000000179],
                [87.424820000000167, 21.765660000000135],
                [87.431396000000163, 21.764400000000133],
                [87.439309000000122, 21.764361000000115],
                [87.443671, 21.760890000000181],
                [87.442459, 21.755331000000123],
                [87.443306000000106, 21.742121000000104],
                [87.445633, 21.737930000000112],
                [87.45111, 21.735412000000107],
                [87.45137, 21.73241],
                [87.444421000000119, 21.732481],
                [87.442933000000139, 21.72905],
                [87.454194, 21.729431000000144],
                [87.462768000000139, 21.726400000000179],
                [87.465179000000134, 21.726361000000164],
                [87.466057000000134, 21.725192],
                [87.465735, 21.723578],
                [87.462319, 21.722250000000198],
                [87.460831, 21.720501],
                [87.462647, 21.717060000000114],
                [87.47083400000011, 21.707180000000101],
                [87.46929100000014, 21.698451000000144],
                [87.467529, 21.695659000000202],
                [87.469697, 21.691600000000104],
                [87.468391000000153, 21.68378],
                [87.468261, 21.677271],
                [87.465202, 21.675131],
                [87.465072000000163, 21.671101],
                [87.463493, 21.668770000000102],
                [87.464913000000124, 21.65855],
                [87.460418, 21.657130000000162],
                [87.45865, 21.644939],
                [87.460906, 21.644451],
                [87.467766000000125, 21.64565],
                [87.47074, 21.64307000000019],
                [87.477516, 21.631759],
                [87.478562, 21.627941000000185],
                [87.482086000000123, 21.62586900000019],
                [87.482658, 21.618032],
                [87.481712000000115, 21.613831000000168],
                [87.48175800000017, 21.609462000000118],
                [87.482034, 21.608703],
                [87.48111, 21.607778],
                [87.48082800000013, 21.60778],
                [87.479989, 21.607718],
                [87.479485, 21.607718],
                [87.478615, 21.607853],
                [87.478332, 21.607778],
                [87.477829000000142, 21.607500000000179],
                [87.477471, 21.607057000000104],
                [87.476960000000176, 21.606791],
                [87.476356000000166, 21.606791],
                [87.475807, 21.606982000000126],
                [87.474663, 21.60686400000014],
                [87.473899, 21.606784],
                [87.473541, 21.606381000000106],
                [87.472710000000106, 21.606472],
                [87.472144000000171, 21.606121],
                [87.471452, 21.606105],
                [87.470718000000119, 21.606324000000193],
                [87.469924000000134, 21.606504000000196],
                [87.46920900000012, 21.606451],
                [87.468521, 21.606390000000143],
                [87.467880000000122, 21.606310000000114],
                [87.467224, 21.606447],
                [87.466736000000182, 21.60652],
                [87.466392000000127, 21.60667],
                [87.465843000000163, 21.60667],
                [87.465653, 21.606485000000188],
                [87.465553000000142, 21.606387],
                [87.463889000000151, 21.606390000000143],
                [87.463607, 21.606109000000171],
                [87.463333000000119, 21.606112],
                [87.463057, 21.605834000000179],
                [87.462777000000159, 21.605834000000179],
                [87.462494, 21.605556],
                [87.462219000000161, 21.605277000000108],
                [87.461936, 21.60528000000016],
                [87.461669000000114, 21.604999000000188],
                [87.461387000000101, 21.604999000000188],
                [87.460555000000156, 21.604170000000174],
                [87.460281, 21.604170000000174],
                [87.459716000000171, 21.603611000000107],
                [87.459716000000171, 21.603060000000138],
                [87.460555000000156, 21.60222100000021],
                [87.459725, 21.601793],
                [87.459443000000178, 21.601667000000184],
                [87.458893000000131, 21.601672],
                [87.458702000000102, 21.601483],
                [87.458611, 21.601389],
                [87.458335000000133, 21.601392000000143],
                [87.457779000000173, 21.600831],
                [87.457619, 21.60068],
                [87.457077000000183, 21.600375000000206],
                [87.456391, 21.600001000000184],
                [87.455826, 21.600001000000184],
                [87.455010000000158, 21.599172000000177],
                [87.454720000000165, 21.598891000000147],
                [87.454438000000124, 21.598891000000147],
                [87.454217000000114, 21.59865700000017],
                [87.453888000000106, 21.598611000000115],
                [87.453613, 21.598333000000189],
                [87.453057000000101, 21.598333000000189],
                [87.4525, 21.597779000000166],
                [87.452767, 21.597499],
                [87.452767, 21.59694],
                [87.453057000000101, 21.596945000000115],
                [87.45333, 21.597221],
                [87.453888000000106, 21.597218000000105],
                [87.454171, 21.597499],
                [87.455010000000158, 21.597499],
                [87.455429, 21.59707700000018],
                [87.45555900000015, 21.596945000000115],
                [87.455001000000124, 21.596389],
                [87.454720000000165, 21.596389],
                [87.454171, 21.595833],
                [87.453888000000106, 21.595833],
                [87.45333, 21.595279000000115],
                [87.453057000000101, 21.595279000000115],
                [87.452218000000116, 21.59444000000013],
                [87.451789000000105, 21.594226],
                [87.45124, 21.593870000000205],
                [87.449722000000151, 21.593335000000192],
                [87.447220000000115, 21.590835],
                [87.446664, 21.590835],
                [87.446388000000169, 21.590554000000107],
                [87.446105, 21.59057],
                [87.445816000000136, 21.590281000000111],
                [87.44555600000011, 21.590281000000111],
                [87.444444000000132, 21.589171],
                [87.443612, 21.589171],
                [87.441948000000181, 21.58751200000011],
                [87.441392000000164, 21.58751200000011],
                [87.441146000000103, 21.587263000000117],
                [87.440834, 21.587222000000107],
                [87.440551, 21.586944],
                [87.440277000000123, 21.586944],
                [87.440002, 21.586666000000143],
                [87.439719000000125, 21.586671000000191],
                [87.438607000000133, 21.585561000000205],
                [87.438331, 21.585561000000205],
                [87.437768000000148, 21.585000000000143],
                [87.437499000000102, 21.585000000000143],
                [87.437424000000121, 21.58492],
                [87.437317000000149, 21.584813000000107],
                [87.436943000000142, 21.584444000000126],
                [87.436667, 21.584444000000126],
                [87.436111, 21.583890000000107],
                [87.435838, 21.583890000000107],
                [87.434447, 21.582500000000206],
                [87.434165000000149, 21.582500000000206],
                [87.433326000000179, 21.581670000000141],
                [87.433053000000129, 21.581670000000141],
                [87.432777, 21.581381000000189],
                [87.432503, 21.581388],
                [87.431389000000124, 21.580278],
                [87.431106000000142, 21.58028],
                [87.430648000000119, 21.579813000000112],
                [87.430557, 21.579719000000178],
                [87.430557, 21.579446000000125],
                [87.430274, 21.579165000000152],
                [87.430001, 21.5791700000002],
                [87.429442000000151, 21.578609000000135],
                [87.429169000000101, 21.578612],
                [87.428756, 21.578195],
                [87.428337, 21.577777],
                [87.428337, 21.577499000000152],
                [87.427781, 21.57694100000014],
                [87.426940000000101, 21.576943000000135],
                [87.426666000000168, 21.576665],
                [87.425828, 21.576392],
                [87.424157, 21.574721000000178],
                [87.423888000000133, 21.574723000000173],
                [87.423615000000126, 21.574443],
                [87.423332000000173, 21.574443],
                [87.423195000000177, 21.574306],
                [87.423059000000123, 21.574167000000156],
                [87.422783, 21.574172000000196],
                [87.421935, 21.573331000000103],
                [87.421668000000153, 21.573333],
                [87.421386, 21.573055000000178],
                [87.42111200000015, 21.573062],
                [87.42028, 21.573891],
                [87.419715, 21.573891],
                [87.419166, 21.573331000000103],
                [87.419166, 21.573055000000178],
                [87.418876, 21.572782000000128],
                [87.418876, 21.572501000000155],
                [87.418054, 21.571672000000142],
                [87.418054, 21.570550000000193],
                [87.416946, 21.569445],
                [87.416663000000128, 21.569445],
                [87.415763, 21.56883200000015],
                [87.415551, 21.568497000000146],
                [87.415704000000161, 21.568292],
                [87.416198000000151, 21.568294],
                [87.416839, 21.568162000000139],
                [87.416839, 21.56803],
                [87.41677, 21.567761000000186],
                [87.416198000000151, 21.567091000000172],
                [87.415681, 21.566512],
                [87.415038000000138, 21.56637],
                [87.414443000000105, 21.565835000000156],
                [87.41417, 21.565830000000112],
                [87.413329000000118, 21.566669],
                [87.413400000000124, 21.567011000000146],
                [87.413468, 21.567779],
                [87.41353, 21.568059000000169],
                [87.413673000000173, 21.56916700000016],
                [87.413329000000118, 21.569723000000174],
                [87.412780000000154, 21.56916700000016],
                [87.412780000000154, 21.568611000000143],
                [87.412499000000167, 21.56833000000017],
                [87.412499000000167, 21.567499000000161],
                [87.411667, 21.566669],
                [87.411667, 21.5664],
                [87.411392, 21.566111],
                [87.411392, 21.565559],
                [87.41110900000011, 21.565281000000137],
                [87.41110900000011, 21.565001000000105],
                [87.410842, 21.56472],
                [87.410836, 21.564166000000107],
                [87.40970500000013, 21.563061000000168],
                [87.409523000000121, 21.562851000000187],
                [87.409103, 21.56243400000016],
                [87.409165, 21.562222000000183],
                [87.409165, 21.561944],
                [87.40944800000014, 21.561671],
                [87.409523000000121, 21.561520000000193],
                [87.409942000000157, 21.561311],
                [87.411667, 21.562721],
                [87.412078000000164, 21.562361000000116],
                [87.412078000000164, 21.562154],
                [87.41193400000013, 21.561732000000113],
                [87.410072, 21.56005],
                [87.40970500000013, 21.560119],
                [87.409438, 21.560016],
                [87.409370000000109, 21.559991000000135],
                [87.409156000000152, 21.560059],
                [87.408889, 21.560000000000169],
                [87.408607, 21.560000000000169],
                [87.407914, 21.559779],
                [87.407768, 21.559838000000124],
                [87.407280000000156, 21.559629],
                [87.40693600000013, 21.558890000000183],
                [87.406731, 21.55861],
                [87.406113000000104, 21.557780000000204],
                [87.405967, 21.557500000000115],
                [87.404999000000117, 21.556659000000135],
                [87.404443000000114, 21.55639],
                [87.404098, 21.55631],
                [87.402916, 21.55644900000021],
                [87.402223, 21.55667000000016],
                [87.400901000000133, 21.556869000000116],
                [87.400276000000105, 21.557210000000104],
                [87.399239000000122, 21.55755900000019],
                [87.398613, 21.557780000000204],
                [87.39833, 21.557780000000204],
                [87.398056, 21.558061000000176],
                [87.397781000000109, 21.558056],
                [87.397498000000127, 21.558332],
                [87.397218, 21.55833],
                [87.395691, 21.559184000000183],
                [87.395340000000118, 21.559722],
                [87.395203000000123, 21.5598700000001],
                [87.394996, 21.560000000000169],
                [87.393036, 21.561131000000156],
                [87.392616000000132, 21.5614],
                [87.392486, 21.56168],
                [87.392356000000106, 21.56168],
                [87.391937, 21.561821],
                [87.391800000000146, 21.562088000000127],
                [87.391534000000121, 21.562231],
                [87.391114, 21.56250000000011],
                [87.390273, 21.563335000000105],
                [87.389672000000118, 21.563870000000119],
                [87.389473000000152, 21.564171000000151],
                [87.389061000000183, 21.564841000000168],
                [87.388635, 21.565117],
                [87.388145, 21.565251000000156],
                [87.386925000000176, 21.5663090000001],
                [87.386383000000109, 21.566562],
                [87.386795000000106, 21.566263],
                [87.387039000000158, 21.565415],
                [87.386766000000179, 21.564991000000127],
                [87.386848, 21.564782],
                [87.386636, 21.564513000000197],
                [87.386497000000119, 21.564235000000107],
                [87.386428, 21.563888000000183],
                [87.3864370000001, 21.563601],
                [87.386308, 21.563335000000105],
                [87.386109, 21.562781],
                [87.386109, 21.56250000000011],
                [87.385567, 21.561671],
                [87.385277, 21.56139],
                [87.385339, 21.561110000000209],
                [87.3852, 21.560832000000115],
                [87.384926000000149, 21.560294000000166],
                [87.384888, 21.560214000000141],
                [87.384598, 21.559991000000135],
                [87.384063000000182, 21.559216000000159],
                [87.384423000000126, 21.557969000000181],
                [87.384439, 21.557081],
                [87.38429300000017, 21.556520000000202],
                [87.384445000000127, 21.55611],
                [87.384017, 21.553997000000145],
                [87.383408000000131, 21.55353],
                [87.382850000000161, 21.553461],
                [87.382018, 21.55335],
                [87.382766000000146, 21.552500000000116],
                [87.383058000000162, 21.552500000000116],
                [87.38333100000014, 21.552219000000143],
                [87.383887000000172, 21.552221000000142],
                [87.3841630000001, 21.551946],
                [87.384445000000127, 21.551946],
                [87.384719, 21.552221000000142],
                [87.385002, 21.552221000000142],
                [87.385277, 21.551946],
                [87.386109, 21.551946],
                [87.386390000000148, 21.551665000000124],
                [87.386948000000103, 21.551670000000168],
                [87.387221000000153, 21.551401000000105],
                [87.387917000000158, 21.551041],
                [87.389441, 21.550831],
                [87.389587000000162, 21.550895000000192],
                [87.390266, 21.5512],
                [87.390656000000121, 21.55122300000016],
                [87.390832000000131, 21.551401000000105],
                [87.391114, 21.551401000000105],
                [87.391388000000163, 21.551112],
                [87.391388000000163, 21.550002],
                [87.391114, 21.550002],
                [87.390266, 21.54917000000011],
                [87.39, 21.54917000000011],
                [87.389168000000126, 21.548331000000129],
                [87.388885000000172, 21.548333000000124],
                [87.388336, 21.547777000000107],
                [87.388047000000128, 21.547782000000204],
                [87.38778, 21.547501],
                [87.387497, 21.547501],
                [87.387221000000153, 21.547782000000204],
                [87.386948000000103, 21.547777000000107],
                [87.386390000000148, 21.548333000000124],
                [87.386109, 21.548331000000129],
                [87.385827000000106, 21.548611],
                [87.385277, 21.548611],
                [87.385002, 21.54889200000019],
                [87.385002, 21.549165],
                [87.384719, 21.549443000000107],
                [87.384445000000127, 21.549443000000107],
                [87.3841630000001, 21.549165],
                [87.383887000000172, 21.54917000000011],
                [87.383607, 21.54889200000019],
                [87.38333100000014, 21.54889200000019],
                [87.382766000000146, 21.548331000000129],
                [87.382775, 21.5480550000002],
                [87.382499, 21.547782000000204],
                [87.382499, 21.547501],
                [87.381111, 21.546111000000106],
                [87.380838000000139, 21.546111000000106],
                [87.380555000000157, 21.545833],
                [87.380279, 21.545833],
                [87.379997000000159, 21.545555000000142],
                [87.379447000000113, 21.545555000000142],
                [87.3791650000001, 21.545833],
                [87.378891000000152, 21.545833],
                [87.378609, 21.546111000000106],
                [87.377777, 21.546111000000106],
                [87.377503, 21.546391000000195],
                [87.377221000000176, 21.546391000000195],
                [87.376961000000151, 21.546111000000106],
                [87.376106, 21.546111000000106],
                [87.375833, 21.546391000000195],
                [87.37500100000014, 21.546391000000195],
                [87.374734, 21.546672000000168],
                [87.374169, 21.546667000000124],
                [87.373886000000127, 21.546943],
                [87.37359700000016, 21.546941],
                [87.372498, 21.5480550000002],
                [87.372498, 21.548331000000129],
                [87.372781, 21.548611],
                [87.374169, 21.548611],
                [87.374442, 21.54889200000019],
                [87.374169, 21.549165],
                [87.374169, 21.549441000000169],
                [87.37359700000016, 21.550002],
                [87.372781, 21.550002],
                [87.372222000000107, 21.550555000000138],
                [87.372222000000107, 21.550833],
                [87.371666000000104, 21.550831],
                [87.371391, 21.551112],
                [87.371108, 21.550831],
                [87.369447, 21.550833],
                [87.369164, 21.550555000000138],
                [87.368606, 21.550560000000186],
                [87.368332, 21.55028],
                [87.367767, 21.55028],
                [87.3675, 21.550002],
                [87.367233000000155, 21.550002],
                [87.366944, 21.55028],
                [87.366668, 21.55028],
                [87.366386, 21.550560000000186],
                [87.366112, 21.550560000000186],
                [87.36528, 21.551390000000136],
                [87.36528, 21.552221000000142],
                [87.364166, 21.553334],
                [87.363892000000106, 21.553056000000133],
                [87.363892000000106, 21.552778],
                [87.363051000000127, 21.551941],
                [87.362222000000131, 21.551946],
                [87.36208300000014, 21.551804],
                [87.361946, 21.551665000000124],
                [87.360282, 21.551670000000168],
                [87.359999, 21.551401000000105],
                [87.359437, 21.551401000000105],
                [87.35917, 21.551670000000168],
                [87.358055000000121, 21.551665000000124],
                [87.35778, 21.551946],
                [87.357499000000118, 21.551946],
                [87.357224000000116, 21.552221000000142],
                [87.35639200000017, 21.551390000000136],
                [87.355826, 21.551401000000105],
                [87.355560000000111, 21.551670000000168],
                [87.355004000000108, 21.551670000000168],
                [87.35472100000014, 21.551401000000105],
                [87.353889, 21.551401000000105],
                [87.353607000000153, 21.551670000000168],
                [87.352219, 21.551670000000168],
                [87.351936000000109, 21.551401000000105],
                [87.351097000000124, 21.551401000000105],
                [87.350831000000184, 21.551670000000168],
                [87.350632, 21.551665000000124],
                [87.349723000000125, 21.551665000000124],
                [87.349167000000122, 21.552221000000142],
                [87.348893, 21.551946],
                [87.348335, 21.551946],
                [87.348052, 21.551665000000124],
                [87.347779, 21.551946],
                [87.346664, 21.551946],
                [87.346391000000139, 21.552221000000142],
                [87.346108000000157, 21.552219000000143],
                [87.345559, 21.552780000000208],
                [87.344169000000107, 21.552778],
                [87.343888000000149, 21.553056000000133],
                [87.343613000000161, 21.553056000000133],
                [87.343369, 21.552821],
                [87.341666, 21.552778],
                [87.341393000000124, 21.553056000000133],
                [87.340837000000121, 21.553056000000133],
                [87.340545000000105, 21.553279],
                [87.340278, 21.553334],
                [87.339996, 21.553612],
                [87.339164, 21.553612],
                [87.338653000000107, 21.553099000000142],
                [87.338334, 21.552778],
                [87.33722, 21.552778],
                [87.336944000000102, 21.553056000000133],
                [87.336670000000183, 21.553056000000133],
                [87.336388, 21.553334],
                [87.335, 21.553334],
                [87.33374800000017, 21.554241000000101],
                [87.333336, 21.554460000000116],
                [87.332032000000126, 21.55438],
                [87.331291, 21.554425],
                [87.330726, 21.554503000000121],
                [87.330596000000114, 21.554519000000194],
                [87.329940000000178, 21.554480000000179],
                [87.329284000000129, 21.554462000000111],
                [87.328636000000103, 21.554460000000116],
                [87.327957, 21.554421],
                [87.327216, 21.554460000000116],
                [87.326943000000185, 21.554460000000116],
                [87.326667, 21.554170000000109],
                [87.326394, 21.554460000000116],
                [87.323059, 21.554446000000208],
                [87.322777000000116, 21.554722000000133],
                [87.322221000000113, 21.554722000000133],
                [87.321954, 21.554460000000116],
                [87.318902000000122, 21.554241000000101],
                [87.318337, 21.554168000000114],
                [87.317779000000129, 21.554170000000109],
                [87.317428, 21.554446000000208],
                [87.317222, 21.554510000000157],
                [87.316949000000164, 21.554656000000129],
                [87.315552, 21.554722000000133],
                [87.315208, 21.554665],
                [87.313615000000183, 21.554731000000171],
                [87.313332, 21.554722000000133],
                [87.313202000000132, 21.554722000000133],
                [87.313056000000117, 21.554719000000198],
                [87.311386000000184, 21.555],
                [87.309998, 21.555],
                [87.309724000000116, 21.55508],
                [87.307778, 21.55528],
                [87.307358000000121, 21.555232],
                [87.304443000000148, 21.555556000000191],
                [87.303924, 21.555704],
                [87.303611, 21.555556000000191],
                [87.303338, 21.555560000000181],
                [87.303046, 21.555699000000114],
                [87.302727000000104, 21.555658000000104],
                [87.302513, 21.555631000000172],
                [87.30136200000014, 21.555631000000172],
                [87.300147, 21.55543],
                [87.296113000000148, 21.55502],
                [87.295281, 21.554920000000148],
                [87.294723, 21.554722000000133],
                [87.294440000000108, 21.554799000000109],
                [87.292779, 21.555],
                [87.292428, 21.554920000000148],
                [87.290832000000179, 21.554920000000148],
                [87.290283, 21.555009],
                [87.290000000000106, 21.555009],
                [87.289451000000142, 21.555059],
                [87.28923, 21.554982000000102],
                [87.288537, 21.554687],
                [87.288063, 21.554690000000104],
                [87.287498, 21.55464],
                [87.287224, 21.554569],
                [87.286666000000125, 21.554722000000133],
                [87.286393, 21.554512000000152],
                [87.28611, 21.554722000000133],
                [87.285278, 21.554719000000198],
                [87.284722, 21.554808000000147],
                [87.284515000000155, 21.554874],
                [87.284095, 21.554731000000171],
                [87.283890000000127, 21.554722000000133],
                [87.28367600000017, 21.554569],
                [87.283120000000139, 21.554621000000108],
                [87.282912, 21.554491000000208],
                [87.282776000000112, 21.554494],
                [87.282219, 21.554446000000208],
                [87.28193700000017, 21.554460000000116],
                [87.281326, 21.5544],
                [87.28083100000012, 21.554471000000145],
                [87.280410000000117, 21.554318],
                [87.280082000000135, 21.554332000000155],
                [87.279441, 21.554332000000155],
                [87.278609000000174, 21.554170000000109],
                [87.27778, 21.554170000000109],
                [87.2742930000001, 21.554250000000135],
                [87.272713, 21.554179000000143],
                [87.271111, 21.553609],
                [87.269447, 21.553612],
                [87.267731000000168, 21.55307200000021],
                [87.26568700000017, 21.55329700000015],
                [87.265297, 21.553341],
                [87.264656000000102, 21.553409],
                [87.262863, 21.553211000000143],
                [87.261292000000111, 21.553211000000143],
                [87.260513000000159, 21.553010000000192],
                [87.258637000000164, 21.552670000000145],
                [87.253272, 21.552670000000145],
                [87.252693, 21.552803000000146],
                [87.251481000000169, 21.552737000000203],
                [87.249833, 21.55247200000013],
                [87.248465, 21.551861000000194],
                [87.247825, 21.551795],
                [87.245683, 21.551590000000143],
                [87.244461, 21.551526000000191],
                [87.243103000000119, 21.551590000000143],
                [87.241883, 21.551661000000134],
                [87.240821000000139, 21.552000000000131],
                [87.239609, 21.5512],
                [87.239121000000154, 21.551253000000138],
                [87.238517000000101, 21.551212000000127],
                [87.237824000000131, 21.551071000000203],
                [87.237090000000123, 21.55092900000016],
                [87.236381, 21.550840000000104],
                [87.235732, 21.55079],
                [87.235130000000183, 21.55064],
                [87.234565000000117, 21.550357],
                [87.234168000000153, 21.550002],
                [87.232208000000171, 21.550002],
                [87.23194200000016, 21.549721000000201],
                [87.230827000000119, 21.549721000000201],
                [87.229569000000126, 21.549801000000109],
                [87.227203000000117, 21.549801000000109],
                [87.226485000000167, 21.549571],
                [87.225968, 21.549471000000146],
                [87.225387, 21.549432000000134],
                [87.225143, 21.549473000000141],
                [87.224824, 21.54953],
                [87.224168000000162, 21.549450000000199],
                [87.22368700000014, 21.549384],
                [87.223336, 21.549443000000107],
                [87.222114, 21.549316],
                [87.220902000000123, 21.54891],
                [87.220252000000173, 21.548509000000131],
                [87.218376, 21.54824],
                [87.21746, 21.547971000000182],
                [87.217232, 21.547800000000105],
                [87.216943000000114, 21.547702000000125],
                [87.214242000000112, 21.54723000000018],
                [87.213225000000122, 21.54689100000018],
                [87.211876, 21.546758000000178],
                [87.210372000000163, 21.546761000000114],
                [87.209975, 21.546726000000199],
                [87.209588000000153, 21.54669],
                [87.209016, 21.546287000000113],
                [87.20835, 21.546391000000195],
                [87.208038000000144, 21.546391000000195],
                [87.207801, 21.546138],
                [87.207496, 21.546111000000106],
                [87.207222000000101, 21.546391000000195],
                [87.206946, 21.546391000000195],
                [87.206666000000141, 21.546667000000124],
                [87.205757, 21.547162],
                [87.205483000000115, 21.547299000000177],
                [87.204925000000145, 21.547652],
                [87.204376000000181, 21.54785000000015],
                [87.20417, 21.5480710000001],
                [87.203614, 21.548199],
                [87.203332000000131, 21.548342000000158],
                [87.203056, 21.548331000000129],
                [87.202766, 21.548402000000177],
                [87.202363, 21.54842],
                [87.201882, 21.548491],
                [87.201392, 21.548491],
                [87.200898, 21.548491],
                [87.20028, 21.54806],
                [87.199997, 21.54806],
                [87.199448000000103, 21.547501],
                [87.199448000000103, 21.546941],
                [87.199845, 21.546533],
                [87.200212000000107, 21.546186000000144],
                [87.200524000000129, 21.545801],
                [87.20069, 21.545361],
                [87.200592, 21.544931000000187],
                [87.200378000000143, 21.5445],
                [87.20005, 21.5441310000001],
                [87.19964, 21.543791],
                [87.199227, 21.543449000000116],
                [87.198776000000109, 21.543230000000161],
                [87.19834000000013, 21.543050000000157],
                [87.197885000000142, 21.542895000000154],
                [87.197417000000129, 21.542743000000193],
                [87.196962000000141, 21.542556000000154],
                [87.196458000000149, 21.542433000000127],
                [87.196029, 21.542230000000181],
                [87.195587, 21.542031],
                [87.195090000000135, 21.541899000000164],
                [87.194619, 21.541710000000133],
                [87.194252, 21.541576],
                [87.194145, 21.541539],
                [87.193657, 21.541389],
                [87.193192, 21.541231000000149],
                [87.192727, 21.541051000000149],
                [87.192223, 21.540871000000202],
                [87.1916650000001, 21.540826000000202],
                [87.191512, 21.540812],
                [87.191102, 21.540773],
                [87.190575000000123, 21.540609000000181],
                [87.190003, 21.5405],
                [87.189422000000135, 21.540324],
                [87.188811, 21.540217],
                [87.188216000000153, 21.54003],
                [87.187615, 21.539914],
                [87.187050000000156, 21.539704],
                [87.186516, 21.539461],
                [87.18599, 21.539201],
                [87.185418000000126, 21.539028],
                [87.184807, 21.538879],
                [87.184219, 21.538681000000164],
                [87.183631, 21.538499],
                [87.183052000000117, 21.538301000000157],
                [87.182519, 21.538050000000165],
                [87.181999, 21.53779000000014],
                [87.181473, 21.537551000000118],
                [87.1809, 21.537377000000102],
                [87.18033500000017, 21.537211],
                [87.179802000000151, 21.537033],
                [87.179298000000159, 21.536808000000118],
                [87.178772, 21.536559000000118],
                [87.178261000000177, 21.536336000000116],
                [87.177871, 21.536277000000204],
                [87.177514, 21.536340000000106],
                [87.177072, 21.536359],
                [87.176483000000161, 21.536190000000143],
                [87.175827, 21.535930000000114],
                [87.175376, 21.535650000000199],
                [87.175057000000137, 21.535370000000107],
                [87.174713, 21.535174],
                [87.174332000000149, 21.534975000000141],
                [87.173926000000137, 21.534759],
                [87.173493, 21.534601000000119],
                [87.173049, 21.534442],
                [87.172607, 21.534271000000157],
                [87.172165000000106, 21.534102000000185],
                [87.171722, 21.533909],
                [87.171248, 21.53374],
                [87.170777, 21.533576000000203],
                [87.170325, 21.533371],
                [87.169876, 21.53320200000018],
                [87.169434000000123, 21.533049000000112],
                [87.168992000000102, 21.532890000000119],
                [87.168541000000104, 21.532739],
                [87.168105, 21.532541000000204],
                [87.167656, 21.532382000000151],
                [87.167221000000126, 21.532220000000105],
                [87.166770000000128, 21.532069000000202],
                [87.166305000000179, 21.531976000000153],
                [87.165810000000107, 21.531939000000133],
                [87.16532, 21.531869000000192],
                [87.164878, 21.531659],
                [87.164459, 21.531402],
                [87.164046000000141, 21.53116000000011],
                [87.16362, 21.530959],
                [87.163194, 21.530775],
                [87.162795, 21.530549],
                [87.16245300000017, 21.530321000000178],
                [87.162079000000105, 21.530121000000118],
                [87.16166, 21.530011000000112],
                [87.161225000000158, 21.529925000000102],
                [87.160789000000122, 21.529729000000199],
                [87.160331, 21.529519],
                [87.159866000000179, 21.529309000000122],
                [87.159477000000138, 21.529052000000146],
                [87.159119, 21.528794000000115],
                [87.158706, 21.528591],
                [87.158303000000132, 21.528379],
                [87.157852000000148, 21.52825],
                [87.157387, 21.52809000000013],
                [87.156388000000149, 21.527440000000176],
                [87.154738, 21.526830000000182],
                [87.153808000000168, 21.526027000000166],
                [87.152313000000134, 21.525020000000151],
                [87.150871, 21.524081],
                [87.149665, 21.523611],
                [87.149216, 21.523456],
                [87.148537, 21.523461000000104],
                [87.147851, 21.523110000000198],
                [87.147201000000138, 21.522739],
                [87.146584, 21.522344],
                [87.145943000000145, 21.521998],
                [87.145339, 21.521640000000101],
                [87.144699, 21.521367],
                [87.144042, 21.521100000000157],
                [87.143379, 21.520831],
                [87.142777000000166, 21.5205],
                [87.142280000000127, 21.520113000000205],
                [87.14177000000015, 21.51984],
                [87.141282000000132, 21.51963],
                [87.140831, 21.519443000000191],
                [87.139687000000123, 21.518616000000176],
                [87.138969, 21.518281000000165],
                [87.138465, 21.517811000000158],
                [87.138176, 21.517401000000174],
                [87.137971, 21.517203000000158],
                [87.137184000000147, 21.517002],
                [87.136681, 21.516733000000151],
                [87.136482000000157, 21.516505000000105],
                [87.135926, 21.516191],
                [87.135429, 21.515846000000117],
                [87.134987000000123, 21.51551100000011],
                [87.134552, 21.515211000000185],
                [87.134139000000104, 21.514921000000125],
                [87.133743, 21.514999],
                [87.132758, 21.514721000000115],
                [87.131942, 21.514158],
                [87.131737000000143, 21.514030000000158],
                [87.131461, 21.514032000000153],
                [87.130554000000103, 21.513335000000204],
                [87.129722, 21.512929000000153],
                [87.128608, 21.513032000000173],
                [87.128325000000117, 21.512900000000112],
                [87.128052, 21.513039],
                [87.127220000000122, 21.51333000000016],
                [87.127220000000122, 21.513611000000136],
                [87.129173, 21.51555900000016],
                [87.129449000000179, 21.515826],
                [87.12957700000014, 21.516099000000104],
                [87.129784, 21.51617],
                [87.130408000000145, 21.516519],
                [87.130691, 21.516726000000116],
                [87.130821000000168, 21.516799000000102],
                [87.131660000000153, 21.517569000000201],
                [87.131386, 21.517791],
                [87.131110000000135, 21.517779000000186],
                [87.130837, 21.517779000000186],
                [87.130548, 21.517499],
                [87.130279000000129, 21.517499],
                [87.129722, 21.51694],
                [87.129449000000179, 21.516945000000128],
                [87.128608, 21.516111000000191],
                [87.128334000000152, 21.516111000000191],
                [87.128052, 21.515833],
                [87.127776000000125, 21.515833],
                [87.127220000000122, 21.515279000000127],
                [87.12693700000014, 21.515290000000103],
                [87.126664000000162, 21.514999],
                [87.126388, 21.514999],
                [87.126105, 21.514721000000115],
                [87.125556000000117, 21.51472300000011],
                [87.125274, 21.514714],
                [87.124724, 21.514999],
                [87.124724, 21.515833],
                [87.124588000000173, 21.516109000000196],
                [87.124724, 21.516389000000114],
                [87.124733, 21.517219],
                [87.125000000000142, 21.517499],
                [87.125000000000142, 21.518333000000208],
                [87.125267, 21.518611000000128],
                [87.125274, 21.519167],
                [87.125000000000142, 21.519441000000196],
                [87.125000000000142, 21.520001000000203],
                [87.123612, 21.521392000000155],
                [87.123336000000137, 21.521389000000109],
                [87.122780000000134, 21.521474],
                [87.122429, 21.521474],
                [87.121948, 21.521389000000109],
                [87.121392, 21.52112],
                [87.121110000000144, 21.521100000000157],
                [87.120834, 21.521111000000182],
                [87.120551, 21.520833],
                [87.120278, 21.520833],
                [87.120002000000156, 21.520555],
                [87.119719, 21.520562],
                [87.119156000000132, 21.520282000000176],
                [87.118072000000126, 21.519172000000133],
                [87.117782000000133, 21.519172000000133],
                [87.117593, 21.518983000000155],
                [87.117499000000166, 21.51889100000016],
                [87.117233000000141, 21.51889100000016],
                [87.116387, 21.518062000000153],
                [87.115968000000152, 21.517920000000114],
                [87.115624000000125, 21.517642],
                [87.115211, 21.517373000000187],
                [87.114594000000153, 21.516676],
                [87.114167000000165, 21.516669000000203],
                [87.113892000000121, 21.516389000000114],
                [87.113053, 21.516250000000181],
                [87.112777, 21.516179000000133],
                [87.112426000000184, 21.516250000000181],
                [87.111389, 21.516389000000114],
                [87.111106, 21.516669000000203],
                [87.109443, 21.516667000000208],
                [87.109169000000151, 21.516945000000128],
                [87.108887, 21.516945000000128],
                [87.108613000000148, 21.517221],
                [87.107499000000161, 21.517221],
                [87.106949000000142, 21.517734000000182],
                [87.106972, 21.517321000000145],
                [87.10669, 21.516692000000145],
                [87.106439, 21.516341],
                [87.107223, 21.515557],
                [87.108497000000156, 21.514780000000197],
                [87.109283000000161, 21.514853],
                [87.111077000000122, 21.51458400000018],
                [87.111649, 21.514315000000121],
                [87.112296, 21.514247000000175],
                [87.114227000000113, 21.513782],
                [87.114723000000183, 21.51333000000016],
                [87.114723000000183, 21.512776000000137],
                [87.114723000000183, 21.512501],
                [87.114799, 21.512229000000154],
                [87.11473, 21.511512000000149],
                [87.114441, 21.509722],
                [87.114167000000165, 21.509444000000137],
                [87.114167000000165, 21.508891],
                [87.113892000000121, 21.50861],
                [87.113892000000121, 21.508332000000163],
                [87.113609000000153, 21.508054],
                [87.113335, 21.508054],
                [87.112221, 21.506944],
                [87.112221, 21.506666000000163],
                [87.111938, 21.50639],
                [87.111938, 21.506099000000116],
                [87.111665000000116, 21.505832],
                [87.111665000000116, 21.505556000000119],
                [87.111389, 21.505280000000194],
                [87.111389, 21.505000000000162],
                [87.109169000000151, 21.50278000000014],
                [87.10888, 21.50278000000014],
                [87.108613000000148, 21.5025],
                [87.108055, 21.5025],
                [87.106940000000108, 21.501388],
                [87.106667000000115, 21.50139],
                [87.10653000000012, 21.501251],
                [87.106391, 21.501112000000145],
                [87.106186, 21.500977000000145],
                [87.105972000000165, 21.50077],
                [87.105698, 21.500360000000111],
                [87.10398200000013, 21.498546],
                [87.103829000000104, 21.498334000000163],
                [87.103615000000133, 21.498056],
                [87.103059, 21.497499000000172],
                [87.103059, 21.497221],
                [87.101944000000103, 21.496111],
                [87.101935, 21.495831000000177],
                [87.101669000000101, 21.495555],
                [87.101386000000147, 21.495560000000122],
                [87.099679, 21.493848],
                [87.099442, 21.493611000000154],
                [87.098343, 21.492501000000168],
                [87.098129000000128, 21.492298],
                [87.097222, 21.491601000000113],
                [87.096946, 21.491389000000193],
                [87.09665000000011, 21.49112000000013],
                [87.096458, 21.490981000000144],
                [87.096367000000129, 21.490888],
                [87.096253000000132, 21.490774],
                [87.095633000000163, 21.490279000000154],
                [87.095276000000112, 21.489999],
                [87.094437000000184, 21.489169000000167],
                [87.094170000000105, 21.489169000000167],
                [87.093108, 21.488112000000111],
                [87.091941, 21.486945000000155],
                [87.091941, 21.486667],
                [87.091392, 21.486111000000104],
                [87.090836000000124, 21.486111000000104],
                [87.090469000000127, 21.485744000000121],
                [87.09028, 21.485557],
                [87.09028, 21.48528100000015],
                [87.089997000000139, 21.484992],
                [87.089997000000139, 21.484445000000104],
                [87.089448, 21.483888000000203],
                [87.089156, 21.483891],
                [87.087768, 21.482500000000126],
                [87.087501, 21.482500000000126],
                [87.085831, 21.480832000000127],
                [87.085555000000156, 21.480832000000127],
                [87.084999000000124, 21.480278000000109],
                [87.084443000000164, 21.480281000000158],
                [87.083611, 21.479722],
                [87.083335000000133, 21.479444],
                [87.082779000000102, 21.479444],
                [87.08223, 21.478934],
                [87.081665000000143, 21.478118000000105],
                [87.081099, 21.477582000000151],
                [87.080277, 21.47722],
                [87.080277, 21.476944000000113],
                [87.080001000000138, 21.476668000000185],
                [87.079721, 21.47667000000018],
                [87.079438, 21.47639],
                [87.078902000000184, 21.47639],
                [87.078057, 21.475560000000197],
                [87.077767, 21.475560000000197],
                [87.07704300000016, 21.474824],
                [87.076942, 21.474719],
                [87.076942, 21.473888],
                [87.074447000000177, 21.47139],
                [87.07389, 21.471189000000201],
                [87.073608, 21.471109000000123],
                [87.073334, 21.471052000000206],
                [87.073059, 21.47105],
                [87.072769, 21.471121],
                [87.072502000000142, 21.471109000000123],
                [87.071183000000119, 21.470909000000116],
                [87.071053000000148, 21.47088100000013],
                [87.070832, 21.470834000000135],
                [87.070267000000143, 21.470831],
                [87.069298, 21.471396],
                [87.069022000000174, 21.47146],
                [87.068817, 21.471677],
                [87.068612, 21.471946000000109],
                [87.06778, 21.472051],
                [87.06611, 21.47278],
                [87.065834, 21.472912000000115],
                [87.065483, 21.47324900000012],
                [87.064956, 21.473780000000144],
                [87.064446, 21.474029000000137],
                [87.064193000000131, 21.474391],
                [87.0638280000001, 21.474651000000105],
                [87.063598000000113, 21.474719],
                [87.062766000000153, 21.475560000000197],
                [87.061943000000127, 21.47639],
                [87.061387000000124, 21.47639],
                [87.061111, 21.47667000000018],
                [87.060555000000164, 21.476668000000185],
                [87.060279, 21.476944000000113],
                [87.059997, 21.476668000000185],
                [87.059165000000107, 21.476668000000185],
                [87.058891000000159, 21.476944000000113],
                [87.058335, 21.476944000000113],
                [87.058053000000115, 21.476668000000185],
                [87.057777, 21.476944000000113],
                [87.053337, 21.476944000000113],
                [87.053055000000114, 21.476668000000185],
                [87.052499000000111, 21.47667000000018],
                [87.052223, 21.47639],
                [87.051391000000109, 21.47639],
                [87.051108000000156, 21.47667000000018],
                [87.050003, 21.47667000000018],
                [87.04972, 21.476809000000113],
                [87.049239, 21.476739],
                [87.048888000000133, 21.476668000000185],
                [87.048332000000173, 21.47667000000018],
                [87.048056, 21.476880000000161],
                [87.0475, 21.476880000000161],
                [87.047227000000177, 21.47667000000018],
                [87.046668, 21.47667000000018],
                [87.046386, 21.47639],
                [87.04611200000015, 21.47639],
                [87.04583, 21.476121],
                [87.045563000000158, 21.476121],
                [87.045472000000103, 21.476025],
                [87.04528, 21.475829],
                [87.044998000000163, 21.475834000000127],
                [87.04444200000016, 21.47527800000011],
                [87.044166, 21.475280000000108],
                [87.043792, 21.474906],
                [87.04361, 21.474719],
                [87.04361, 21.474446],
                [87.043327, 21.474170000000122],
                [87.043327, 21.473610000000114],
                [87.04361, 21.47333400000019],
                [87.04361, 21.473056],
                [87.043892000000113, 21.472778],
                [87.043892000000113, 21.472500000000135],
                [87.043808, 21.472219000000162],
                [87.04374000000017, 21.472012],
                [87.043603000000175, 21.471665000000137],
                [87.043892000000113, 21.470560000000198],
                [87.04400600000011, 21.470442],
                [87.044166, 21.470277],
                [87.044166, 21.469721],
                [87.04444200000016, 21.469443000000119],
                [87.044647, 21.469252000000147],
                [87.044998000000163, 21.469186000000203],
                [87.045739000000168, 21.468990000000126],
                [87.045814000000163, 21.469368000000138],
                [87.04583, 21.469990000000106],
                [87.045768000000109, 21.470280000000109],
                [87.045768000000109, 21.470555000000157],
                [87.04583, 21.470834000000135],
                [87.046051, 21.471109000000123],
                [87.04611200000015, 21.47139],
                [87.04611200000015, 21.471665000000137],
                [87.046265000000147, 21.471946000000109],
                [87.046333000000104, 21.472151],
                [87.04611200000015, 21.472500000000135],
                [87.046119, 21.472778],
                [87.046051, 21.473056],
                [87.04611200000015, 21.47333400000019],
                [87.046181000000132, 21.473751],
                [87.047227000000177, 21.47500000000019],
                [87.048394000000116, 21.475472000000192],
                [87.048888000000133, 21.47527800000011],
                [87.049447, 21.475280000000108],
                [87.04972, 21.47500000000019],
                [87.050003, 21.47500000000019],
                [87.050279000000145, 21.474719],
                [87.050835000000106, 21.474722],
                [87.051332, 21.474400000000113],
                [87.05194, 21.474134000000159],
                [87.052635, 21.473712000000202],
                [87.0532690000001, 21.473359000000126],
                [87.053857, 21.47311000000013],
                [87.054443, 21.473056],
                [87.055274, 21.473594],
                [87.055557000000178, 21.473739000000133],
                [87.056106000000142, 21.474179000000159],
                [87.056945000000127, 21.474202000000101],
                [87.057503, 21.474202000000101],
                [87.058053000000115, 21.474179000000159],
                [87.058335, 21.474184000000204],
                [87.058609000000146, 21.474177000000164],
                [87.058891000000159, 21.474179000000159],
                [87.059448, 21.473890000000203],
                [87.059723000000105, 21.473610000000114],
                [87.060838000000146, 21.473612000000109],
                [87.061111, 21.47333400000019],
                [87.061387000000124, 21.47333400000019],
                [87.061943000000127, 21.472778],
                [87.061943000000127, 21.472500000000135],
                [87.061667, 21.472219000000162],
                [87.061667, 21.471665000000137],
                [87.061387000000124, 21.47139],
                [87.061387000000124, 21.470831],
                [87.062226000000109, 21.469999000000136],
                [87.062226000000109, 21.466943],
                [87.063058000000169, 21.466111000000119],
                [87.063058000000169, 21.465831],
                [87.063331, 21.465555000000162],
                [87.063331, 21.465001000000139],
                [87.063598000000113, 21.464721],
                [87.063614, 21.464445000000119],
                [87.064163, 21.463889000000162],
                [87.063058000000169, 21.462779000000118],
                [87.063058000000169, 21.462221000000163],
                [87.062499, 21.461667000000144],
                [87.062499, 21.461389],
                [87.061667, 21.460559000000156],
                [87.061387000000124, 21.460559000000156],
                [87.060539000000105, 21.459720000000171],
                [87.059723000000105, 21.459720000000171],
                [87.059448, 21.460001000000144],
                [87.059448, 21.461389],
                [87.059165000000107, 21.461669000000139],
                [87.059165000000107, 21.462779000000118],
                [87.059448, 21.463055],
                [87.059165000000107, 21.463333000000144],
                [87.058053000000115, 21.463333000000144],
                [87.057777, 21.463611],
                [87.057221, 21.463611],
                [87.056945000000127, 21.463333000000144],
                [87.056389000000124, 21.463333000000144],
                [87.056113, 21.463611],
                [87.055557000000178, 21.463611],
                [87.055482, 21.463538],
                [87.055274, 21.463333000000144],
                [87.05478, 21.463201],
                [87.054351, 21.463009000000167],
                [87.053932, 21.462759],
                [87.053497, 21.462471],
                [87.053093, 21.462171000000119],
                [87.052758, 21.461851],
                [87.052430000000115, 21.46158],
                [87.052125, 21.461304000000148],
                [87.051797000000121, 21.46102],
                [87.051491, 21.460662000000124],
                [87.051147000000171, 21.46030200000018],
                [87.050819, 21.459935000000197],
                [87.050507000000124, 21.459575],
                [87.050399000000127, 21.459447000000122],
                [87.05024, 21.459244],
                [87.05001, 21.458955000000113],
                [87.049782, 21.458699],
                [87.049447, 21.458430000000188],
                [87.048995, 21.458241000000211],
                [87.048546, 21.458009000000171],
                [87.048157, 21.457697000000103],
                [87.047699000000179, 21.45741200000014],
                [87.047227000000177, 21.457120000000142],
                [87.046821000000179, 21.456792],
                [87.046463, 21.456441],
                [87.046158, 21.456097],
                [87.045882000000105, 21.455762],
                [87.045563000000158, 21.45547],
                [87.045212, 21.455201],
                [87.044822000000153, 21.454923000000118],
                [87.044403000000145, 21.454633000000111],
                [87.043977, 21.454328],
                [87.04351900000016, 21.454020000000181],
                [87.042999000000165, 21.453681000000184],
                [87.042518000000115, 21.453302000000118],
                [87.042024000000126, 21.452851],
                [87.041511, 21.452432],
                [87.041039000000154, 21.452044000000111],
                [87.040633000000113, 21.451589000000123],
                [87.04023000000015, 21.45116900000016],
                [87.039756, 21.450861],
                [87.039261, 21.450549],
                [87.038764, 21.450253],
                [87.038293000000152, 21.449952],
                [87.03785700000013, 21.449649000000189],
                [87.037484000000163, 21.449332],
                [87.037110000000141, 21.449031],
                [87.036788000000143, 21.448710000000116],
                [87.036506, 21.448361000000197],
                [87.036200000000164, 21.448051000000131],
                [87.035859000000158, 21.447762000000179],
                [87.035462, 21.447488],
                [87.035043, 21.447219000000182],
                [87.034623, 21.446950000000125],
                [87.034224, 21.446695000000201],
                [87.033883000000102, 21.446399000000206],
                [87.033493000000163, 21.446109000000202],
                [87.03304400000016, 21.445802000000182],
                [87.032547, 21.445476000000209],
                [87.032036, 21.445170000000129],
                [87.031571000000142, 21.444874000000134],
                [87.031182, 21.444512],
                [87.030847, 21.444115],
                [87.030487000000136, 21.443732000000178],
                [87.030067, 21.443393000000182],
                [87.029618000000184, 21.4430240000002],
                [87.029151, 21.442586],
                [87.028647000000134, 21.442091000000111],
                [87.028052, 21.44167],
                [87.028052, 21.441392000000175],
                [87.027496000000141, 21.440831000000113],
                [87.027221, 21.440833000000108],
                [87.026947000000149, 21.440555000000185],
                [87.026658, 21.44056],
                [87.025559, 21.439441],
                [87.025277000000159, 21.439443000000207],
                [87.025001, 21.439167000000108],
                [87.024169, 21.439172000000152],
                [87.023613000000168, 21.438611],
                [87.02333, 21.438611],
                [87.022781000000109, 21.438055000000126],
                [87.022498000000127, 21.438062000000169],
                [87.022218, 21.437782],
                [87.021942000000124, 21.437782],
                [87.021179, 21.437301000000101],
                [87.020577000000159, 21.436929],
                [87.020057, 21.436587000000142],
                [87.019576000000129, 21.436282000000173],
                [87.019111000000166, 21.436029000000186],
                [87.018640000000104, 21.435751],
                [87.01815, 21.435441000000193],
                [87.017678, 21.435110000000176],
                [87.01724300000015, 21.434730000000165],
                [87.016814, 21.434372],
                [87.016381, 21.434023000000131],
                [87.015939000000103, 21.433706000000196],
                [87.015526, 21.433381000000107],
                [87.015130000000141, 21.433075000000198],
                [87.01473300000012, 21.43279],
                [87.014343, 21.432510000000146],
                [87.013963, 21.432239],
                [87.013557, 21.431961],
                [87.013131000000143, 21.43168],
                [87.012673, 21.431391000000129],
                [87.012199000000109, 21.431092],
                [87.011741, 21.430753],
                [87.011315000000124, 21.43039],
                [87.010872000000106, 21.430089],
                [87.010460000000108, 21.429793],
                [87.010047, 21.429549000000115],
                [87.009683, 21.429269],
                [87.009309, 21.429011],
                [87.008958000000149, 21.428699000000162],
                [87.008575000000107, 21.428412000000204],
                [87.008126, 21.428125],
                [87.007636, 21.427801],
                [87.007087, 21.427441000000151],
                [87.006531, 21.427022000000129],
                [87.005913000000106, 21.42665],
                [87.005334000000147, 21.426286000000168],
                [87.004844000000148, 21.425923000000122],
                [87.004356, 21.425718],
                [87.003960000000163, 21.425502000000105],
                [87.003609, 21.425280000000207],
                [87.003053, 21.42472],
                [87.002777000000123, 21.424722],
                [87.002503, 21.424444000000161],
                [87.002221000000162, 21.424444000000161],
                [87.001945, 21.424166],
                [87.00166200000011, 21.423890000000139],
                [87.001389, 21.423890000000139],
                [87.001106, 21.42361],
                [87.000831000000105, 21.42361],
                [87.00025800000013, 21.422780000000156],
                [87.00000100000014, 21.4225],
                [86.999732, 21.422220000000149],
                [86.998611, 21.421668000000121],
                [86.998337000000134, 21.42139],
                [86.997779000000136, 21.421110000000162],
                [86.996108, 21.420834],
                [86.995552000000117, 21.420556000000143],
                [86.995552000000117, 21.42028],
                [86.995279, 21.420000000000183],
                [86.995279, 21.419719000000153],
                [86.99472, 21.419166],
                [86.994155000000134, 21.418881000000109],
                [86.993332000000109, 21.418612],
                [86.991668, 21.41694300000017],
                [86.991112, 21.416665],
                [86.990547, 21.416111],
                [86.989998, 21.41584],
                [86.989724000000166, 21.415560000000134],
                [86.989166000000168, 21.41528],
                [86.98832, 21.415002000000182],
                [86.98832, 21.414721000000153],
                [86.986946, 21.413333],
                [86.985832, 21.412777000000116],
                [86.985549, 21.412501000000187],
                [86.985, 21.412221],
                [86.98472600000018, 21.411945000000166],
                [86.98472600000018, 21.411672000000117],
                [86.983612, 21.411391000000147],
                [86.983329, 21.411109000000117],
                [86.98278, 21.410833000000192],
                [86.98278, 21.410555],
                [86.981668000000113, 21.410555],
                [86.981668000000113, 21.410833000000192],
                [86.981109, 21.410833000000192],
                [86.980277, 21.409999],
                [86.980277, 21.409709],
                [86.980004000000108, 21.409445000000112],
                [86.980004000000108, 21.409167000000192],
                [86.979721000000126, 21.408889],
                [86.979721000000126, 21.408331],
                [86.979445, 21.408057000000149],
                [86.979445, 21.407779000000112],
                [86.979156, 21.407501000000192],
                [86.979156, 21.407221000000103],
                [86.978889, 21.406945000000174],
                [86.978889, 21.406667],
                [86.978333, 21.406111000000116],
                [86.978333, 21.405830000000144],
                [86.977501000000103, 21.405001],
                [86.976936, 21.404720000000108],
                [86.976387000000145, 21.404167000000193],
                [86.975831000000113, 21.403900000000132],
                [86.975564, 21.403610000000125],
                [86.975555, 21.403054000000107],
                [86.975281, 21.402781000000115],
                [86.975281, 21.4025],
                [86.973891, 21.40111],
                [86.973335, 21.400832000000147],
                [86.970833000000127, 21.39833],
                [86.970833000000127, 21.398056000000103],
                [86.970276, 21.397500000000147],
                [86.9697180000001, 21.39722],
                [86.969169000000107, 21.396668000000197],
                [86.968613000000147, 21.396390000000103],
                [86.968063000000129, 21.395829],
                [86.968057000000144, 21.395556],
                [86.967216000000164, 21.394710000000199],
                [86.967225, 21.394444],
                [86.966942, 21.394168000000146],
                [86.966110000000171, 21.39389],
                [86.965554000000139, 21.393329000000161],
                [86.965554000000139, 21.393056000000108],
                [86.963058, 21.39056],
                [86.962220000000158, 21.390280000000129],
                [86.961381, 21.389441000000144],
                [86.961388, 21.389165],
                [86.959441000000126, 21.387221000000174],
                [86.959441000000126, 21.386943],
                [86.958885, 21.386667000000156],
                [86.958336000000131, 21.386111000000138],
                [86.958336000000131, 21.385562],
                [86.95778000000017, 21.385001000000155],
                [86.95778000000017, 21.384721],
                [86.957222000000144, 21.384167],
                [86.956672000000125, 21.383889000000174],
                [86.956107000000131, 21.383328000000116],
                [86.955277000000166, 21.383055],
                [86.955002, 21.382779000000138],
                [86.955002, 21.382499],
                [86.95417, 21.381669000000151],
                [86.953614, 21.381389],
                [86.953055000000163, 21.38083000000017],
                [86.953055000000163, 21.380557000000177],
                [86.952499, 21.380001000000156],
                [86.951943000000185, 21.379730000000105],
                [86.950835, 21.378611],
                [86.950835, 21.378330000000116],
                [86.950553, 21.378054000000184],
                [86.950546, 21.377781000000134],
                [86.949997, 21.377501],
                [86.948891, 21.376391],
                [86.947777000000116, 21.375830000000171],
                [86.947221000000113, 21.375278000000147],
                [86.947221000000113, 21.37500000000011],
                [86.946952, 21.374720000000192],
                [86.94694500000017, 21.374444],
                [86.946662, 21.374171],
                [86.946662, 21.373891000000182],
                [86.946106, 21.373332000000115],
                [86.946113000000111, 21.373056000000187],
                [86.945830000000157, 21.372781000000142],
                [86.945267, 21.372500000000166],
                [86.945267, 21.37222],
                [86.944725000000162, 21.371666000000111],
                [86.944732, 21.371390000000186],
                [86.944442, 21.37111],
                [86.944442, 21.37083],
                [86.944169, 21.370556],
                [86.944023000000158, 21.370410000000103],
                [86.943886, 21.370000000000111],
                [86.943305000000109, 21.369859000000126],
                [86.941673, 21.367500000000174],
                [86.941384000000113, 21.367222],
                [86.940552, 21.366112],
                [86.940338, 21.365968],
                [86.940003, 21.365551000000206],
                [86.939164000000162, 21.364722000000192],
                [86.93873500000015, 21.364441],
                [86.937844, 21.363468000000179],
                [86.937767, 21.363131000000173],
                [86.936386000000113, 21.361392000000187],
                [86.936386000000113, 21.361111],
                [86.936112, 21.36056],
                [86.935836, 21.360282000000208],
                [86.935547, 21.360282000000208],
                [86.934998, 21.359721000000146],
                [86.934998, 21.359443],
                [86.933610000000144, 21.358055000000146],
                [86.933327000000176, 21.358062000000182],
                [86.933051, 21.357782],
                [86.933051, 21.357499000000129],
                [86.932219, 21.356669],
                [86.932219, 21.356109],
                [86.929168000000146, 21.353057000000145],
                [86.929168000000146, 21.35279],
                [86.928612000000143, 21.352220000000155],
                [86.928612000000143, 21.351667],
                [86.928046, 21.351111],
                [86.928046, 21.35083],
                [86.924721, 21.3475],
                [86.924721, 21.34722000000016],
                [86.923613, 21.346112000000169],
                [86.92333300000017, 21.346112000000169],
                [86.920281, 21.343056],
                [86.919999000000161, 21.343061000000144],
                [86.919716, 21.342780000000172],
                [86.919440000000108, 21.342780000000172],
                [86.91722, 21.340560000000146],
                [86.916389, 21.340560000000146],
                [86.915832000000179, 21.340000000000138],
                [86.915559, 21.340000000000138],
                [86.915283, 21.339719000000166],
                [86.913330000000116, 21.339722000000101],
                [86.913063, 21.340000000000138],
                [86.912781000000152, 21.340000000000138],
                [86.91249800000017, 21.34028],
                [86.91166600000011, 21.34028],
                [86.911393, 21.340560000000146],
                [86.911110000000107, 21.340560000000146],
                [86.91098, 21.340421],
                [86.910843, 21.34028],
                [86.910843, 21.339719000000166],
                [86.910278, 21.339166],
                [86.910285, 21.338890000000159],
                [86.909996000000135, 21.338609000000183],
                [86.910005000000169, 21.336946],
                [86.910554, 21.336390000000101],
                [86.910554, 21.336112000000181],
                [86.91166600000011, 21.335002000000138],
                [86.91166600000011, 21.334721000000165],
                [86.911393, 21.334443],
                [86.911393, 21.334167000000203],
                [86.911110000000107, 21.333892000000159],
                [86.911110000000107, 21.333331],
                [86.910834000000179, 21.333055000000165],
                [86.910843, 21.332782000000176],
                [86.910554, 21.332501000000203],
                [86.910554, 21.332221000000111],
                [86.910005000000169, 21.331667],
                [86.909996000000135, 21.331391000000163],
                [86.909722, 21.331111],
                [86.909722, 21.330833000000204],
                [86.909446, 21.330555000000111],
                [86.909446, 21.330279000000186],
                [86.90889, 21.329719],
                [86.90889, 21.329445],
                [86.907776, 21.328333],
                [86.907776, 21.328057000000168],
                [86.903892, 21.324171000000199],
                [86.903609000000117, 21.324171000000199],
                [86.902778, 21.32333],
                [86.902778, 21.32305400000012],
                [86.9011, 21.321391],
                [86.900833000000134, 21.321391],
                [86.898614, 21.319171000000207],
                [86.898331, 21.319171000000207],
                [86.896943000000121, 21.317780000000191],
                [86.896667, 21.317780000000191],
                [86.896394, 21.317500000000102],
                [86.895286000000141, 21.317500000000102],
                [86.894997, 21.317780000000191],
                [86.894174000000177, 21.317780000000191],
                [86.893609000000183, 21.31722],
                [86.893059000000136, 21.317222],
                [86.892221, 21.316390000000123],
                [86.892227, 21.31611],
                [86.891945000000121, 21.315834000000102],
                [86.891945000000121, 21.315],
                [86.891671, 21.314720000000133],
                [86.891671, 21.311387],
                [86.89138900000016, 21.311109000000155],
                [86.89138900000016, 21.310556],
                [86.891113, 21.310278000000146],
                [86.891113, 21.309721],
                [86.89083, 21.309443000000154],
                [86.89083, 21.309165],
                [86.891113, 21.30889],
                [86.890557, 21.308331000000173],
                [86.890557, 21.307502000000166],
                [86.890274, 21.307224],
                [86.890274, 21.3069430000001],
                [86.889998000000134, 21.306667000000168],
                [86.889998000000134, 21.306111000000151],
                [86.889442, 21.305562],
                [86.889442, 21.305282000000144],
                [86.889000000000166, 21.304835],
                [86.888893, 21.304726000000123],
                [86.88861, 21.30444500000015],
                [86.88861, 21.304172000000104],
                [86.888093000000126, 21.303604],
                [86.888045, 21.303328000000132],
                [86.887779, 21.303055],
                [86.887779, 21.30277900000015],
                [86.887496, 21.302499],
                [86.887496, 21.30194],
                [86.887222000000151, 21.301667000000176],
                [86.887222000000151, 21.301111000000159],
                [86.886947000000106, 21.300831],
                [86.886947000000106, 21.300277000000101],
                [86.886803000000143, 21.300133],
                [86.886108, 21.299445000000159],
                [86.886108, 21.299167],
                [86.885825, 21.298891000000133],
                [86.885825, 21.298611000000101],
                [86.885559, 21.298321],
                [86.885559, 21.298055],
                [86.885276, 21.297781000000153],
                [86.885276, 21.297501],
                [86.885003, 21.29722],
                [86.885003, 21.2969450000001],
                [86.884444, 21.296388000000203],
                [86.884453, 21.296110000000109],
                [86.884164, 21.295835],
                [86.884164, 21.295554],
                [86.883888000000169, 21.2952790000001],
                [86.883888000000169, 21.295],
                [86.883605, 21.294720000000208],
                [86.88361500000012, 21.294444000000109],
                [86.882767000000143, 21.29361],
                [86.882774, 21.293332000000127],
                [86.881942, 21.292500000000185],
                [86.881942, 21.29222],
                [86.88028, 21.290556],
                [86.880287, 21.290280000000163],
                [86.8797220000001, 21.28972],
                [86.8797220000001, 21.28944400000011],
                [86.877502, 21.28722],
                [86.877502, 21.286946],
                [86.875266000000153, 21.284719000000162],
                [86.875275, 21.284446000000113],
                [86.874726, 21.28389],
                [86.874726, 21.283612],
                [86.874168, 21.283056],
                [86.874161, 21.282780000000113],
                [86.873887000000124, 21.282502000000186],
                [86.873887000000124, 21.282221],
                [86.873611, 21.281943000000119],
                [86.873611, 21.281665],
                [86.873046000000144, 21.281111],
                [86.873046000000144, 21.280831000000145],
                [86.872223000000105, 21.280002000000131],
                [86.871948, 21.280002000000131],
                [86.8713920000001, 21.279441],
                [86.871109000000146, 21.279443],
                [86.870835, 21.27916700000014],
                [86.870826000000164, 21.278892],
                [86.869721000000183, 21.277782000000112],
                [86.869721000000183, 21.27751000000017],
                [86.868333, 21.276109],
                [86.868333, 21.275833000000144],
                [86.868057000000178, 21.275555],
                [86.868057000000178, 21.275279000000122],
                [86.868333, 21.274999],
                [86.868333, 21.274721000000167],
                [86.867501, 21.273889],
                [86.867501, 21.273611000000127],
                [86.866943, 21.273059],
                [86.866943, 21.272779],
                [86.866387, 21.272221],
                [86.866387, 21.271945000000127],
                [86.866111000000146, 21.271667],
                [86.866111000000146, 21.2708300000001],
                [86.865555000000128, 21.270276],
                [86.865281, 21.270281000000121],
                [86.864989, 21.270001],
                [86.864723000000168, 21.270001],
                [86.86444, 21.26972],
                [86.86444, 21.269166],
                [86.864167, 21.268891],
                [86.864167, 21.26861],
                [86.863608000000156, 21.268054],
                [86.863608000000156, 21.267781],
                [86.863052000000124, 21.267220000000176],
                [86.863052000000124, 21.266944],
                [86.861664, 21.265556000000171],
                [86.861655, 21.265281000000122],
                [86.861388000000133, 21.26500000000015],
                [86.861388000000133, 21.264171000000143],
                [86.860557000000128, 21.26333],
                [86.860557000000128, 21.263056],
                [86.859435000000161, 21.261939000000208],
                [86.859444, 21.261668000000149],
                [86.859178, 21.26139],
                [86.859178, 21.261110000000194],
                [86.858886, 21.260834],
                [86.858886, 21.260556000000175],
                [86.85833, 21.260000000000158],
                [86.85833, 21.259719000000185],
                [86.857589, 21.257609],
                [86.85694200000016, 21.256670000000152],
                [86.85694200000016, 21.256112000000194],
                [86.856666, 21.255831],
                [86.856666, 21.255555000000122],
                [86.856393000000168, 21.25528],
                [86.856393000000168, 21.255002000000157],
                [86.855002, 21.253611000000198],
                [86.855002, 21.253340000000147],
                [86.854446, 21.252782000000192],
                [86.854446, 21.252501],
                [86.854157000000129, 21.25222100000013],
                [86.854164000000182, 21.251943000000203],
                [86.854446, 21.251667000000104],
                [86.85360700000011, 21.250829],
                [86.853614000000135, 21.25055500000013],
                [86.853332, 21.250270000000167],
                [86.853332, 21.249999000000109],
                [86.853051, 21.249719],
                [86.853058000000132, 21.249445],
                [86.852500000000177, 21.24888900000013],
                [86.852500000000177, 21.248609],
                [86.852776, 21.248333000000112],
                [86.852219000000147, 21.247777],
                [86.852219000000147, 21.247499],
                [86.85167, 21.246940000000162],
                [86.85167, 21.246667000000112],
                [86.851112, 21.246111],
                [86.851112, 21.245559000000124],
                [86.850563000000108, 21.245001000000112],
                [86.850556, 21.244723000000185],
                [86.850280000000154, 21.244445],
                [86.850280000000154, 21.243889000000131],
                [86.849990000000147, 21.243611000000211],
                [86.849990000000147, 21.24333],
                [86.849441000000169, 21.242776],
                [86.849441000000169, 21.242501],
                [86.849168000000162, 21.24222],
                [86.849168000000162, 21.241945000000211],
                [86.84860900000011, 21.2414],
                [86.84860900000011, 21.24111],
                [86.848336, 21.240832000000122],
                [86.848336, 21.240278000000153],
                [86.847777000000164, 21.239720000000144],
                [86.847777000000164, 21.239444],
                [86.847504000000114, 21.239166000000122],
                [86.847497, 21.23889],
                [86.847221000000133, 21.238610000000158],
                [86.847221000000133, 21.23833],
                [86.846948000000154, 21.238056000000139],
                [86.846948000000154, 21.237781],
                [86.846389, 21.23722],
                [86.846389, 21.236944000000157],
                [86.84610700000016, 21.236666],
                [86.84610700000016, 21.23611],
                [86.845833, 21.235830000000188],
                [86.845833, 21.235556],
                [86.8452750000001, 21.235],
                [86.8452750000001, 21.234720000000145],
                [86.845001000000181, 21.234444],
                [86.845001000000181, 21.233888],
                [86.844719, 21.233610000000166],
                [86.844719, 21.233334],
                [86.84444500000015, 21.23305600000014],
                [86.844436000000115, 21.23278],
                [86.844719, 21.232500000000126],
                [86.845001000000181, 21.232500000000126],
                [86.8452750000001, 21.232210000000116],
                [86.845833, 21.232222],
                [86.84610700000016, 21.231946000000161],
                [86.846389, 21.23195],
                [86.846756, 21.231584],
                [86.848892, 21.229443000000167],
                [86.848892, 21.22889],
                [86.849168000000162, 21.228612000000165],
                [86.849168000000162, 21.228060000000138],
                [86.848892, 21.22778],
                [86.848892, 21.226672],
                [86.848343, 21.22611100000017],
                [86.847777000000164, 21.226672],
                [86.847504000000114, 21.226667000000187],
                [86.847221000000133, 21.226943],
                [86.847221000000133, 21.227221000000149],
                [86.846948000000154, 21.227502000000122],
                [86.846948000000154, 21.228055],
                [86.845558, 21.229443000000167],
                [86.84543700000016, 21.229443000000167],
                [86.845001000000181, 21.229443000000167],
                [86.844719, 21.229724000000143],
                [86.84444500000015, 21.229724000000143],
                [86.844176, 21.23],
                [86.843887, 21.23],
                [86.843613, 21.23028000000016],
                [86.843331, 21.23],
                [86.843331, 21.229721],
                [86.842782, 21.229165],
                [86.842782, 21.22889],
                [86.843613, 21.228060000000138],
                [86.843613, 21.22778],
                [86.843789, 21.227600000000102],
                [86.843887, 21.227502000000122],
                [86.843887, 21.227221000000149],
                [86.843613, 21.226943],
                [86.843613, 21.226667000000187],
                [86.843331, 21.226392000000143],
                [86.843331, 21.225831],
                [86.843055, 21.225555000000149],
                [86.843064000000112, 21.225001000000187],
                [86.842782, 21.224721],
                [86.842782, 21.224167],
                [86.842499, 21.223889000000149],
                [86.842499, 21.223609000000117],
                [86.842223000000132, 21.223333000000192],
                [86.842223000000132, 21.223055],
                [86.841943000000114, 21.22277900000017],
                [86.841943000000114, 21.221389],
                [86.841394000000122, 21.220831],
                [86.841394000000122, 21.220557000000152],
                [86.841111000000168, 21.22027],
                [86.841111000000168, 21.219723],
                [86.840553, 21.219167],
                [86.840553, 21.21861100000012],
                [86.840279000000109, 21.21833],
                [86.840279000000109, 21.217223],
                [86.839447000000163, 21.216391],
                [86.839447000000163, 21.216110000000121],
                [86.839721, 21.215830000000203],
                [86.839721, 21.21527900000012],
                [86.839447000000163, 21.215001000000196],
                [86.839447000000163, 21.21472],
                [86.838059, 21.213332],
                [86.838059, 21.211110000000129],
                [86.838333, 21.210832000000202],
                [86.838891000000146, 21.210830000000211],
                [86.839447000000163, 21.21139],
                [86.839447000000163, 21.211666],
                [86.839721, 21.211944000000184],
                [86.839721, 21.212220000000109],
                [86.840279000000109, 21.212778000000124],
                [86.840279000000109, 21.213054],
                [86.840553, 21.213332],
                [86.840553, 21.213891],
                [86.841111000000168, 21.21445100000016],
                [86.841111000000168, 21.215001000000196],
                [86.841667, 21.215554000000104],
                [86.841667, 21.215830000000203],
                [86.842223000000132, 21.216389000000103],
                [86.842216000000107, 21.21694],
                [86.842499, 21.21723],
                [86.842499, 21.217501],
                [86.843055, 21.218055000000103],
                [86.843064000000112, 21.21861100000012],
                [86.843331, 21.218891000000152],
                [86.843331, 21.219167],
                [86.843613, 21.219445000000174],
                [86.843613, 21.219723],
                [86.844170000000176, 21.22027700000012],
                [86.84444500000015, 21.22027700000012],
                [86.844719, 21.219999000000193],
                [86.845001000000181, 21.220001000000188],
                [86.8452750000001, 21.219721],
                [86.8452750000001, 21.219167],
                [86.845001000000181, 21.218891000000152],
                [86.845001000000181, 21.21833],
                [86.844719, 21.218055000000103],
                [86.844719, 21.217781000000169],
                [86.843887, 21.21694],
                [86.843887, 21.216389000000103],
                [86.843331, 21.215830000000203],
                [86.843331, 21.215554000000104],
                [86.843064000000112, 21.215281],
                [86.843064000000112, 21.215001000000196],
                [86.842782, 21.214723000000102],
                [86.842782, 21.214166000000198],
                [86.841943000000114, 21.213332],
                [86.841943000000114, 21.213054],
                [86.841667, 21.212778000000124],
                [86.841667, 21.212500000000198],
                [86.841394000000122, 21.212220000000109],
                [86.841394000000122, 21.211944000000184],
                [86.841111000000168, 21.211666],
                [86.841111000000168, 21.211099],
                [86.840835, 21.210832000000202],
                [86.840835, 21.210556000000103],
                [86.840553, 21.210280000000179],
                [86.840553, 21.21],
                [86.839996000000127, 21.209439],
                [86.839447000000163, 21.209444000000129],
                [86.838891000000146, 21.208888000000112],
                [86.838891000000146, 21.208061],
                [86.839447000000163, 21.207500000000206],
                [86.839447000000163, 21.207220000000117],
                [86.837777000000159, 21.205556000000112],
                [86.837501, 21.205834000000205],
                [86.836669, 21.205834000000205],
                [86.836389, 21.205556000000112],
                [86.836113000000168, 21.205556000000112],
                [86.835557, 21.206112000000129],
                [86.835281000000109, 21.206110000000134],
                [86.835007000000161, 21.20639],
                [86.834166, 21.20639],
                [86.833893000000131, 21.206110000000134],
                [86.833610000000178, 21.206112000000129],
                [86.833337000000171, 21.205834000000205],
                [86.833054, 21.205834000000205],
                [86.832222, 21.205000000000148],
                [86.83139, 21.205000000000148],
                [86.831108000000114, 21.205289],
                [86.830825000000161, 21.205000000000148],
                [86.830559, 21.205000000000148],
                [86.82972, 21.2041700000002],
                [86.82972, 21.20306],
                [86.829437, 21.202780000000125],
                [86.829437, 21.20223100000015],
                [86.829171, 21.201941000000144],
                [86.829171, 21.20154000000019],
                [86.819236000000146, 21.20855100000011],
                [86.817399, 21.210871],
                [86.813522, 21.220521],
                [86.80947200000017, 21.219561000000166],
                [86.804772, 21.22431100000011],
                [86.800271, 21.225040000000199],
                [86.791207, 21.21996200000012],
                [86.780586, 21.21673],
                [86.767967, 21.218339000000121],
                [86.76505400000012, 21.215051],
                [86.76445, 21.202980000000135],
                [86.762191, 21.197950000000155],
                [86.755418, 21.19277],
                [86.756988000000121, 21.186960000000166],
                [86.756471000000133, 21.181119],
                [86.757667000000183, 21.177402000000139],
                [86.765182, 21.176811],
                [86.771606, 21.1699190000001],
                [86.771203000000114, 21.165261000000154],
                [86.759292000000116, 21.165229000000174],
                [86.751222000000141, 21.170010000000154],
                [86.742149000000126, 21.174199],
                [86.734833, 21.175250000000116],
                [86.724663000000177, 21.170512000000141],
                [86.704506, 21.17701],
                [86.698806, 21.175501000000104],
                [86.694237, 21.1697],
                [86.691741, 21.167811],
                [86.688598, 21.160739],
                [86.679497, 21.162300000000123],
                [86.671548000000129, 21.161831],
                [86.66716000000018, 21.15807],
                [86.662933000000152, 21.151390000000159],
                [86.660813000000118, 21.145950000000195],
                [86.660820000000143, 21.143272000000131],
                [86.663193, 21.139789],
                [86.663482000000144, 21.134611],
                [86.65976, 21.12974],
                [86.655181, 21.126039000000102],
                [86.652253, 21.122101],
                [86.655038, 21.117230000000117],
                [86.655136, 21.113381000000114],
                [86.651122, 21.102751],
                [86.651077000000129, 21.097151],
                [86.653075, 21.09476],
                [86.657891000000106, 21.0919],
                [86.663361, 21.090480000000124],
                [86.658921, 21.077462000000189],
                [86.65364100000015, 21.077699000000102],
                [86.649367, 21.080762],
                [86.644784, 21.07897],
                [86.641372, 21.075800000000182],
                [86.6437770000001, 21.07162],
                [86.645837000000171, 21.06115],
                [86.644141000000133, 21.057389],
                [86.637709, 21.054912000000112],
                [86.631560000000135, 21.057011],
                [86.626526, 21.062570000000104],
                [86.623305000000158, 21.068951000000133],
                [86.624787000000168, 21.07497],
                [86.626977, 21.079009000000148],
                [86.627189000000143, 21.084021],
                [86.62358800000014, 21.08731],
                [86.618417000000179, 21.089830000000173],
                [86.603828000000107, 21.092741000000153],
                [86.596099000000137, 21.091631000000174],
                [86.589599000000163, 21.089830000000173],
                [86.587379000000141, 21.092080000000173],
                [86.587097000000128, 21.096210000000148],
                [86.587967000000148, 21.102931],
                [86.585036, 21.107161000000129],
                [86.579482000000141, 21.110730000000157],
                [86.55719, 21.141660000000112],
                [86.558448, 21.14512],
                [86.557488, 21.148550000000167],
                [86.55342, 21.151130000000133],
                [86.545288, 21.153391000000163],
                [86.534957, 21.154291],
                [86.526627, 21.150310000000157],
                [86.518226, 21.141439000000155],
                [86.506386, 21.131361000000137],
                [86.483223000000109, 21.14060000000017],
                [86.458451000000181, 21.153261],
                [86.452666, 21.153671],
                [86.44677, 21.147850000000172],
                [86.44187988773129, 21.150693800812629],
                [86.438308000000262, 21.152771000000364],
                [86.433402293703452, 21.153557017481884],
                [86.430313, 21.154052000000142],
                [86.429523091048367, 21.154785390893604],
                [86.428035927919709, 21.155826405083641],
                [86.427441062668237, 21.157759717150888],
                [86.428779509484045, 21.159098163966458],
                [86.436643666270285, 21.162340180553194],
                [86.437706, 21.163731000000205],
                [86.438736000000148, 21.171672000000164],
                [86.436562, 21.175439],
                [86.43358014156432, 21.17420193170323],
                [86.431753835741333, 21.170549320057201],
                [86.429820523674081, 21.168913440615707],
                [86.426846197416793, 21.168913440615707],
                [86.424615452723828, 21.170251887431498],
                [86.424615452723828, 21.17307749737591],
                [86.427106118530418, 21.17698896849765],
                [86.427017000000234, 21.177801000000326],
                [86.435047497189075, 21.185336765173979],
                [86.436042, 21.18627],
                [86.441193000000254, 21.188300000000364],
                [86.442584674170831, 21.190395441023551],
                [86.443299000000223, 21.191471000000369],
                [86.443947580918845, 21.194298373089104],
                [86.444184000000263, 21.195329000000182],
                [86.434282013060042, 21.199846433691501],
                [86.433984580434284, 21.200738731568656],
                [86.436024195730667, 21.202355952818376],
                [86.436539000000309, 21.205289],
                [86.43473, 21.207069],
                [86.434370747082639, 21.208657350497273],
                [86.432952000000157, 21.214930000000148],
                [86.428307, 21.216461000000201],
                [86.420127, 21.216961000000193],
                [86.41869394321337, 21.211581163865894],
                [86.41822958565011, 21.20983791989897],
                [86.417809000000233, 21.208259000000279],
                [86.41601075426432, 21.204426856981055],
                [86.417030920767772, 21.202969476261668],
                [86.417923218644916, 21.202077178384453],
                [86.417923218644916, 21.200590015255838],
                [86.416733488142015, 21.19925156844004],
                [86.415543757639099, 21.199846433691501],
                [86.412420715068933, 21.201482313132995],
                [86.41033868668886, 21.202672043635907],
                [86.409297672498809, 21.20311819257449],
                [86.409151488268748, 21.206409917841818],
                [86.408624790174528, 21.207810888073194],
                [86.405728480990064, 21.209364277714819],
                [86.405282332051442, 21.210405291904859],
                [86.405840169857967, 21.211799886420973],
                [86.404208890295521, 21.213345390874505],
                [86.403633000000283, 21.213891000000157],
                [86.4014248132452, 21.214541773305992],
                [86.399151853546343, 21.215211635805186],
                [86.398143949033937, 21.213825767100726],
                [86.396656785905321, 21.213528334475022],
                [86.394574757525191, 21.214271916039358],
                [86.391600431267918, 21.214271916039358],
                [86.387733807133458, 21.215461646542277],
                [86.383272317747497, 21.215461646542277],
                [86.380149275177402, 21.217543674922346],
                [86.37375447372419, 21.218435972799561],
                [86.373010892159911, 21.220369284866759],
                [86.370951793540641, 21.224263148749852],
                [86.369271000000353, 21.22567800000024],
                [86.367537619534559, 21.229508654636387],
                [86.365989, 21.232931000000285],
                [86.367671179476687, 21.237372972561783],
                [86.370018000000158, 21.243570000000201],
                [86.370018000000158, 21.24988],
                [86.368049000000141, 21.25499],
                [86.36033, 21.25899],
                [86.359657000000169, 21.262890000000191],
                [86.354126000000164, 21.270821],
                [86.352173, 21.276109],
                [86.352494000000135, 21.28136],
                [86.356460000000183, 21.294679000000198],
                [86.36785100000013, 21.301571],
                [86.373138, 21.301389],
                [86.378342, 21.3033010000002],
                [86.385749, 21.308379],
                [86.391228, 21.31415],
                [86.422623000000144, 21.326241000000202],
                [86.425041000000178, 21.33068900000017],
                [86.430732000000134, 21.333121000000116],
                [86.433449, 21.339341000000154],
                [86.434921, 21.346821000000201],
                [86.438018, 21.350281000000106],
                [86.443108, 21.352430000000137],
                [86.458816000000155, 21.363251000000158],
                [86.471757000000125, 21.368958],
                [86.478348000000125, 21.370540000000172],
                [86.484497000000133, 21.374900000000135],
                [86.493561000000156, 21.383912000000119],
                [86.498833, 21.391830000000137],
                [86.511726000000166, 21.402669],
                [86.524667000000107, 21.416321000000206],
                [86.529717000000161, 21.42242],
                [86.536087000000151, 21.433969000000101],
                [86.543891000000116, 21.444799000000156],
                [86.54780700000012, 21.453359000000198],
                [86.552741000000182, 21.459761000000181],
                [86.56469700000018, 21.488549000000202],
                [86.569076, 21.495412000000155],
                [86.575881, 21.509121],
                [86.580246, 21.51563],
                [86.588708000000139, 21.514299],
                [86.593957000000131, 21.511721],
                [86.602515, 21.512542000000103],
                [86.609168000000153, 21.514472000000122],
                [86.615914, 21.51767],
                [86.624657, 21.526841],
                [86.632401000000115, 21.523880000000126],
                [86.635499000000138, 21.52855],
                [86.636871000000127, 21.541861000000207],
                [86.644203000000147, 21.55324],
                [86.646477000000147, 21.559540000000137],
                [86.644387, 21.565719000000168],
                [86.645112, 21.570329],
                [86.647553, 21.573682000000183],
                [86.653969000000117, 21.57215],
                [86.66002, 21.571672000000142],
                [86.672227000000177, 21.579341000000166],
                [86.68308300000011, 21.588820000000162],
                [86.687408, 21.585581],
                [86.684922, 21.582662000000134],
                [86.689612, 21.57966],
                [86.696327, 21.580761],
                [86.70134100000017, 21.579282],
                [86.706252, 21.582580000000117],
                [86.709160000000139, 21.588150000000152],
                [86.71154, 21.590670000000152],
                [86.715927000000164, 21.590240000000104],
                [86.721413, 21.59243],
                [86.73232300000015, 21.593271],
                [86.735489000000115, 21.597150000000166],
                [86.749519000000106, 21.600231],
                [86.759987, 21.596099],
                [86.767379, 21.596501000000156],
                [86.777642000000171, 21.595520000000132],
                [86.783798, 21.594221000000115],
                [86.787629000000123, 21.59256],
                [86.794113, 21.593711000000209],
                [86.793762, 21.597959000000166],
                [86.799346, 21.60087000000015],
                [86.807906000000102, 21.601510000000129],
                [86.817611000000142, 21.600341],
                [86.825043000000136, 21.598171],
                [86.827422000000155, 21.60087000000015],
                [86.836822, 21.594962000000173],
                [86.840844000000104, 21.595520000000132],
                [86.844514, 21.59981],
                [86.850182, 21.59831900000011],
                [86.852691000000135, 21.593711000000209],
                [86.86078, 21.591712000000197],
                [86.862779000000145, 21.587049000000203],
                [86.86859, 21.596371000000197],
                [86.872672000000108, 21.595520000000132],
                [86.87368, 21.600152],
                [86.876198, 21.602921000000205],
                [86.884079000000128, 21.60576100000014],
                [86.883751, 21.60752],
                [86.87732, 21.609831],
                [86.87342, 21.61343],
                [86.870072, 21.6247],
                [86.873803000000109, 21.62999],
                [86.876588000000112, 21.629420000000149],
                [86.876182000000128, 21.624331],
                [86.87861, 21.621772000000128],
                [86.879241, 21.618209000000199],
                [86.885919000000158, 21.617361000000184],
                [86.889130000000122, 21.606371000000188],
                [86.892478, 21.603821],
                [86.897453, 21.6043],
                [86.903381000000124, 21.592250000000146],
                [86.903830000000127, 21.587391],
                [86.908981, 21.583999],
                [86.907340000000119, 21.57821000000018],
                [86.90775300000017, 21.574172000000196],
                [86.914627000000152, 21.575229],
                [86.917077000000148, 21.58198],
                [86.920119000000142, 21.586821000000153],
                [86.923561, 21.581900000000129],
                [86.935310000000115, 21.572980000000193],
                [86.946984, 21.567551000000204],
                [86.95427000000015, 21.567200000000124],
                [86.954621, 21.570051000000142],
                [86.952447000000163, 21.57169],
                [86.949867, 21.571090000000137],
                [86.948791000000185, 21.574819000000101],
                [86.94947, 21.57708000000013],
                [86.952789, 21.578568000000129],
                [86.953477000000106, 21.587790000000204],
                [86.955804, 21.590251],
                [86.95742, 21.588002000000181],
                [86.957816000000136, 21.582662000000134],
                [86.956169, 21.580111],
                [86.956178000000122, 21.576838000000176],
                [86.959662, 21.576401],
                [86.963371, 21.581071000000115],
                [86.966263000000168, 21.583129000000206],
                [86.968629, 21.579300000000156],
                [86.98121600000016, 21.583890000000107],
                [86.98620500000014, 21.588489000000148],
                [86.987199000000118, 21.588040000000145],
                [86.987343000000152, 21.58646100000021],
                [86.99524, 21.589260000000191],
                [87.002877, 21.593191000000157],
                [86.996407000000133, 21.60001],
                [86.997002000000151, 21.60197],
                [86.99524, 21.603331000000189],
                [86.997567, 21.608060000000133],
                [86.995231, 21.610572000000154],
                [86.991279, 21.611402],
                [86.988747000000131, 21.610782000000135],
                [86.986839, 21.611691000000175],
                [86.98924300000013, 21.615841],
                [86.986556, 21.618980000000185],
                [86.983657, 21.62055],
                [86.985367, 21.62388],
                [86.988266000000166, 21.625740000000174],
                [86.995263000000179, 21.615939000000132],
                [86.996101, 21.615971000000112],
                [86.997391, 21.61988],
                [87.001412000000158, 21.620229000000158],
                [87.003859000000134, 21.624281],
                [87.007171000000127, 21.626542],
                [87.006898, 21.629022000000127],
                [87.008529, 21.638211000000123],
                [87.00772, 21.6427720000002],
                [87.003677, 21.643521000000185],
                [87.002426, 21.645440000000171],
                [86.995247, 21.645201],
                [86.989036, 21.64361],
                [86.986198, 21.646031],
                [86.986686000000162, 21.658359],
                [86.984879, 21.661889],
                [86.98861, 21.66614],
                [86.991646, 21.665930000000166],
                [86.99524, 21.669711000000174],
                [87.00411200000012, 21.666960000000124],
                [87.00728500000011, 21.668941],
                [87.010788, 21.669059],
                [87.014343, 21.667391],
                [87.014747, 21.662611000000137],
                [87.019111000000166, 21.666349000000189],
                [87.020896, 21.665691],
                [87.019401, 21.6603],
                [87.02044, 21.656130000000182],
                [87.023307, 21.654881],
                [87.02671, 21.655241],
                [87.027688, 21.656481],
                [87.028169, 21.666160000000154],
                [87.029472, 21.666370000000139],
                [87.034126000000171, 21.664752000000185],
                [87.036850000000115, 21.670700000000121],
                [87.03891, 21.672120000000174],
                [87.043122, 21.669230000000191],
                [87.04528, 21.670461],
                [87.049606, 21.678239],
                [87.03411, 21.690750000000143],
                [87.033447000000109, 21.695301],
                [87.034104, 21.713550000000104],
                [87.032706, 21.714781000000183],
                [87.027045, 21.715079000000166],
                [87.026092000000105, 21.725192],
                [87.021393, 21.73361100000016],
                [87.022637, 21.735781],
                [87.043548, 21.734270000000144],
                [87.039947, 21.728150000000191],
                [87.039642, 21.720319],
                [87.040061, 21.71254],
                [87.044068000000124, 21.705632],
                [87.050377, 21.702321],
                [87.060539000000105, 21.70055],
                [87.067468000000176, 21.701361000000183],
                [87.068596, 21.70233],
                [87.067420000000126, 21.705571000000187],
                [87.068154, 21.706200000000191],
                [87.072639000000137, 21.704871000000193],
                [87.075203, 21.706501],
                [87.076279, 21.707870000000181],
                [87.075360633051474, 21.710275793417615],
                [87.074599000000305, 21.712271000000325],
                [87.075131089787959, 21.713010602840992],
                [87.075519403542131, 21.713550357525829],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Bargarh",
          Dist_Code: "370",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [83.369988231839542, 21.436212064608803],
              [83.369510011788051, 21.436641769582476],
              [83.365791000000101, 21.43984],
              [83.360946000000169, 21.442180000000171],
              [83.350289, 21.443981000000171],
              [83.347328, 21.455142],
              [83.344024078505328, 21.463244296032592],
              [83.343322753906392, 21.464904785156413],
              [83.343093929550307, 21.466632409045527],
              [83.34210205078152, 21.474121093750561],
              [83.34210205078152, 21.485473632813179],
              [83.335693359375313, 21.49188232421897],
              [83.334716796874986, 21.495483398437724],
              [83.335876464843892, 21.499694824218974],
              [83.33789062500027, 21.502685546875846],
              [83.345886230468963, 21.508300781250224],
              [83.349121093750199, 21.515930175781474],
              [83.354309082031335, 21.535278320312838],
              [83.365905761718793, 21.54968261718755],
              [83.366882324219006, 21.553100585938065],
              [83.366882324219006, 21.559326171875508],
              [83.363281250000441, 21.567687988281186],
              [83.362304687500441, 21.572509765625508],
              [83.368286132812642, 21.597106933593743],
              [83.377319335937713, 21.604675292969198],
              [83.380676269531008, 21.612670898438122],
              [83.386901855468622, 21.615478515625053],
              [83.389892578125384, 21.62048339843863],
              [83.39532470703152, 21.62432861328227],
              [83.401916503906278, 21.626892089844485],
              [83.405273437500099, 21.63189697265647],
              [83.408691406250099, 21.634277343750338],
              [83.413513183593892, 21.63629150390647],
              [83.424072265625213, 21.638488769531588],
              [83.426513671874986, 21.643676757812724],
              [83.44128417968777, 21.649291992188122],
              [83.447692871093949, 21.644714355469198],
              [83.441528320312642, 21.632507324219198],
              [83.441101074218849, 21.625915527343746],
              [83.44128417968777, 21.618103027343917],
              [83.450073242187926, 21.617126464844088],
              [83.450073242187926, 21.613525390625167],
              [83.448730468750256, 21.608276367188289],
              [83.452880859375043, 21.606323242187724],
              [83.463073730468906, 21.605529785156811],
              [83.46990966796902, 21.626892089844485],
              [83.476684570312869, 21.627319335937553],
              [83.484680175781222, 21.625488281250679],
              [83.48651123046902, 21.633300781250277],
              [83.48327636718777, 21.638488769531588],
              [83.50311279296902, 21.653320312500448],
              [83.520080566406349, 21.669677734375281],
              [83.530517578125043, 21.689086914062724],
              [83.535278320312528, 21.70910644531255],
              [83.537475585937813, 21.723083496094198],
              [83.552917480468892, 21.740295410156701],
              [83.574890136718892, 21.735107421875451],
              [83.591674804687642, 21.732116699219084],
              [83.616699218750384, 21.724121093749993],
              [83.649291992187869, 21.717102050781417],
              [83.659729003906392, 21.709899902344539],
              [83.677124023437486, 21.705078125000167],
              [83.677248916340247, 21.705001919161582],
              [83.68792724609402, 21.698486328125451],
              [83.698486328125156, 21.685485839844144],
              [83.700001677340524, 21.679975479061394],
              [83.704528808594006, 21.663513183593743],
              [83.716491699219006, 21.641906738281929],
              [83.720275878906463, 21.62768554687522],
              [83.738353757548154, 21.611501541234357],
              [83.739356491625443, 21.610446321013619],
              [83.744133000000758, 21.606201000000677],
              [83.786217000000235, 21.570591000001283],
              [83.793136000000388, 21.563020000000499],
              [83.808251000000311, 21.536240000000355],
              [83.814027000000721, 21.531472000000914],
              [83.826995000000224, 21.526150000001277],
              [83.839797000000246, 21.523769000000353],
              [83.845208000000284, 21.512002000000557],
              [83.857353000000316, 21.490060000001044],
              [83.858598000000285, 21.483681000000839],
              [83.86561500000019, 21.471900000000741],
              [83.870347, 21.45077],
              [83.879821000000547, 21.435078000000196],
              [83.877350000000192, 21.429330000000842],
              [83.876899000000364, 21.423851000000631],
              [83.864165000000455, 21.42085000000122],
              [83.860229000000388, 21.418290000000233],
              [83.848129000000242, 21.418470000000749],
              [83.84268900000022, 21.412330000000388],
              [83.842536000000536, 21.40650000000084],
              [83.844658000000635, 21.4008210000008],
              [83.856277000000247, 21.395510000000851],
              [83.86582900000046, 21.393170000000335],
              [83.87394800000024, 21.386330000000662],
              [83.8729790000002, 21.379119000000905],
              [83.875313, 21.359568000000817],
              [83.875962000000442, 21.345641000001304],
              [83.871361000000405, 21.336442000000481],
              [83.870925000000426, 21.319419000000433],
              [83.864562000000248, 21.306699000000318],
              [83.869004000000274, 21.30019000000032],
              [83.87132200000039, 21.289770000000996],
              [83.877357000000231, 21.288959000000482],
              [83.884552000000483, 21.292642000000566],
              [83.883926000000187, 21.285490000000149],
              [83.884351102044249, 21.280044012654795],
              [83.884598000000196, 21.276881000000341],
              [83.886116115357694, 21.273037579719979],
              [83.886727000000263, 21.271491000000246],
              [83.887828618582418, 21.270463051089902],
              [83.891228000000211, 21.267291000000167],
              [83.896522, 21.255150000000523],
              [83.906418, 21.241881000000426],
              [83.907241000000141, 21.235409999999881],
              [83.905197000000314, 21.222312],
              [83.888495000000191, 21.174010000000859],
              [83.880477000000255, 21.172688000000388],
              [83.866736000000216, 21.153701000000236],
              [83.855500000000276, 21.130130000000232],
              [83.852966, 21.119699000000306],
              [83.844720000000265, 21.101990000000168],
              [83.837769000000122, 21.09309],
              [83.83471, 21.092661000000131],
              [83.830856000000139, 21.094432000000264],
              [83.819978000000148, 21.097001000000372],
              [83.815681000000424, 21.099002000000379],
              [83.808700000000314, 21.10398200000088],
              [83.800874, 21.10567000000054],
              [83.792619000000258, 21.111809999999814],
              [83.789688000000226, 21.115409000000223],
              [83.784950000000421, 21.123940000000342],
              [83.779548, 21.130921000000452],
              [83.781059000000354, 21.14217100000047],
              [83.778342000000222, 21.147971000000435],
              [83.775161000000296, 21.150421000000275],
              [83.76297, 21.150882000000244],
              [83.756791, 21.14006900000032],
              [83.74664400000033, 21.137150000000528],
              [83.741821000000229, 21.13655000000028],
              [83.733674000000278, 21.128250000000261],
              [83.728074000000376, 21.128589000000598],
              [83.72013800000046, 21.12453900000019],
              [83.718352999999851, 21.12139],
              [83.715126000000211, 21.118470000000567],
              [83.711037, 21.116950000000369],
              [83.698860000000295, 21.118089000000506],
              [83.687432, 21.113791000000329],
              [83.681342000000342, 21.113030000000204],
              [83.677406000000275, 21.116180000000266],
              [83.674231000000347, 21.120660000000548],
              [83.659707000000111, 21.122222000000129],
              [83.648133000000129, 21.126012000000227],
              [83.633713, 21.126819000000349],
              [83.606637000000248, 21.125009000000144],
              [83.6008750000003, 21.122340000000289],
              [83.592522000000343, 21.106550000000706],
              [83.587709000000501, 21.102270000000598],
              [83.561761000000487, 21.083802000000556],
              [83.556671000000321, 21.08112000000056],
              [83.549713000000537, 21.079150000000421],
              [83.54493600000049, 21.07295100000038],
              [83.535888000000426, 21.067721000000851],
              [83.530801000000551, 21.065749000000604],
              [83.524369000000533, 21.065879000000727],
              [83.520821000000282, 21.062392000001005],
              [83.517564000000434, 21.060872000000298],
              [83.513046000000514, 21.06028800000086],
              [83.508269000000539, 21.056409000001217],
              [83.495720000000489, 21.059459000000796],
              [83.492568000000432, 21.059260000000503],
              [83.490531000000473, 21.057770000000854],
              [83.490615000000545, 21.047350000000954],
              [83.49253200000031, 21.043521000000673],
              [83.493127000000513, 21.039571000000869],
              [83.49183000000032, 21.037611000000702],
              [83.488769000000204, 21.037050000000871],
              [83.485993000000562, 21.037839000000755],
              [83.477202000000574, 21.045590000000796],
              [83.47371800000046, 21.044580000000732],
              [83.46629200000028, 21.052400000000826],
              [83.458801000000435, 21.056040000001069],
              [83.455170000000223, 21.052601000000603],
              [83.452180000000425, 21.051010000000186],
              [83.445297000000423, 21.046142000000824],
              [83.435807000000722, 21.04289200000067],
              [83.429543000000237, 21.031120000000662],
              [83.425537000000233, 21.027970000000774],
              [83.42057700000035, 21.027660000000875],
              [83.410684000000543, 21.032542000000714],
              [83.404266000000277, 21.037839000000755],
              [83.401168000000482, 21.0435000000009],
              [83.400589000000522, 21.055641000000943],
              [83.398529000000607, 21.058481000000366],
              [83.390923000000313, 21.063659000001046],
              [83.387359000000259, 21.065580000000462],
              [83.3830880000002, 21.065610000000838],
              [83.374238000000375, 21.059361000001044],
              [83.371850864467191, 21.059449513076849],
              [83.36808900000031, 21.059589],
              [83.363958678138005, 21.061379500684264],
              [83.359367000000233, 21.063370000000415],
              [83.356806606196784, 21.063389658835884],
              [83.35559000000039, 21.063399000000683],
              [83.352960270370417, 21.064874229613107],
              [83.351433000000313, 21.065731000000874],
              [83.349831000000265, 21.062121000000779],
              [83.347488000000382, 21.059201000000424],
              [83.341667000000527, 21.056090000000601],
              [83.337418000000113, 21.05462000000011],
              [83.331383000000272, 21.054759000000612],
              [83.326378000000247, 21.051801000000804],
              [83.321984000000484, 21.052220000000315],
              [83.317597000000404, 21.051550000000809],
              [83.313141000000527, 21.042440000000219],
              [83.312783000000579, 21.035489000000322],
              [83.306313000000415, 21.027749000000647],
              [83.302468, 21.027070000000599],
              [83.2985, 21.021320000000511],
              [83.295302000000319, 21.019211000000265],
              [83.289741000000262, 21.011510000000836],
              [83.295455000000487, 21.004561000000134],
              [83.305091000000388, 20.996691],
              [83.311997000000687, 20.994109000000261],
              [83.315796, 20.991281000000409],
              [83.320412000000474, 20.983110000000234],
              [83.322830000000167, 20.980911000000894],
              [83.327844000000411, 20.980190000000558],
              [83.331397000000237, 20.981202000000447],
              [83.336090000000397, 20.983800000000482],
              [83.346496000000215, 20.994581000000434],
              [83.350198000000248, 20.997391000000384],
              [83.350663000000381, 20.998319],
              [83.35111200000037, 20.998729000000591],
              [83.351570000000308, 20.999112000000643],
              [83.352057000000428, 20.999451000000469],
              [83.352538000000422, 20.99978200000049],
              [83.353028000000478, 21.000071000000784],
              [83.353546000000364, 21.000352000000756],
              [83.354081000000221, 21.000611000000728],
              [83.354608000000482, 21.000842000000485],
              [83.355148000000526, 21.001031000000289],
              [83.35566800000025, 21.001199000000323],
              [83.356217000000555, 21.001341000000703],
              [83.356782000000393, 21.001462000000398],
              [83.357322000000337, 21.001550000000968],
              [83.357871000000415, 21.001601000000218],
              [83.358430000000496, 21.00163],
              [83.358970000000426, 21.00163],
              [83.359512000000478, 21.001601000000218],
              [83.360046000000452, 21.001550000000968],
              [83.360618, 21.001462000000398],
              [83.361153, 21.001341000000703],
              [83.361703000000247, 21.001199000000323],
              [83.362252, 21.001031000000289],
              [83.362769000000341, 21.000842000000485],
              [83.363296, 21.000611000000728],
              [83.363831000000275, 21.000352000000756],
              [83.364326000000389, 21.000080000000985],
              [83.364852000000184, 20.99978200000049],
              [83.365340000000273, 20.999460000000507],
              [83.365807000000345, 20.999112000000643],
              [83.366279000000517, 20.998740000000449],
              [83.366708000000457, 20.998341000000661],
              [83.367150000000237, 20.997931000000673],
              [83.367950000000391, 20.997361000000748],
              [83.368508000000347, 20.99338000000068],
              [83.369408000000405, 20.992441000000607],
              [83.379036000000539, 20.989170000000339],
              [83.380829000000389, 20.986440000000581],
              [83.380401000000276, 20.975999000000908],
              [83.381385000000179, 20.971650000000235],
              [83.383605000000188, 20.970030000000513],
              [83.384973000000386, 20.966871000000761],
              [83.380898000000386, 20.959270000000682],
              [83.378067000000257, 20.956640000000501],
              [83.377037000000286, 20.953561000000825],
              [83.380173000000269, 20.951300000000284],
              [83.376289000000241, 20.944590000000396],
              [83.376130000000416, 20.939191000000442],
              [83.381791000000163, 20.936210000000866],
              [83.389848000000185, 20.92249200000094],
              [83.400017000000432, 20.915340000000523],
              [83.409186000000417, 20.905519000000417],
              [83.410652000000411, 20.897841000000877],
              [83.408828000000298, 20.893882000001092],
              [83.405984000000316, 20.89178000000032],
              [83.385750000000172, 20.884050000001135],
              [83.366562000000314, 20.879721000000693],
              [83.353370000000197, 20.874252000000801],
              [83.348365000000328, 20.873180000000215],
              [83.343552000000528, 20.872230000000506],
              [83.336922000000513, 20.877839000000442],
              [83.33246600000038, 20.880421000000744],
              [83.325813000000252, 20.880041000000571],
              [83.323541000000191, 20.878420000000741],
              [83.321480000000378, 20.87227100000052],
              [83.318916000000314, 20.869712000000725],
              [83.315566, 20.861801],
              [83.313050000000246, 20.858990000000112],
              [83.307243000000454, 20.854501000000536],
              [83.304740000000479, 20.854350000000633],
              [83.300752000000202, 20.855811000000351],
              [83.296417000000517, 20.848841000001183],
              [83.290801000000371, 20.85093100000034],
              [83.284362, 20.851590000000723],
              [83.281669000000107, 20.850270000000926],
              [83.281486000000413, 20.847392000000976],
              [83.278259000000205, 20.84176],
              [83.275627000000426, 20.839900000000508],
              [83.272506000000277, 20.840561000000488],
              [83.274567000000246, 20.849931000000421],
              [83.271599000000521, 20.857700000000701],
              [83.268174000000315, 20.863879000000164],
              [83.270241000000439, 20.866621000000574],
              [83.269569, 20.870311000000861],
              [83.266442000000524, 20.876200000000718],
              [83.259110000000518, 20.883211000000639],
              [83.25521, 20.889089000000464],
              [83.250230078939282, 20.892955524075941],
              [83.248684442427518, 20.894155591449412],
              [83.24733800000044, 20.895201000000267],
              [83.24767871610878, 20.895622802946942],
              [83.246802871888661, 20.897216802733336],
              [83.244423410882845, 20.898703965861777],
              [83.242787531441351, 20.902570589996284],
              [83.241597800938436, 20.90851924251103],
              [83.241151651999857, 20.914467895025606],
              [83.237573030656037, 20.920375545747103],
              [83.233745404694986, 20.922454611396684],
              [83.232922996822182, 20.92290132170103],
              [83.225449000000339, 20.926961000000851],
              [83.223183630257523, 20.927832504971771],
              [83.219602853534226, 20.929210057014185],
              [83.215828312484561, 20.929195825902806],
              [83.212128000000376, 20.928939000000351],
              [83.2107224078255, 20.929573918881939],
              [83.209728339109105, 20.930022948840584],
              [83.208290180018054, 20.930854215045766],
              [83.207866819838088, 20.930877735055727],
              [83.205576452330192, 20.931004977695064],
              [83.204068825836814, 20.928743537954738],
              [83.204367392967498, 20.926764085486635],
              [83.20441636745737, 20.926747284019591],
              [83.204521113784921, 20.923919133176295],
              [83.204219588486112, 20.92241150668314],
              [83.203918063187515, 20.921205405488418],
              [83.202862724642245, 20.920602354890825],
              [83.201656623447704, 20.91954701634614],
              [83.198942895759828, 20.918039389852588],
              [83.198225730950853, 20.917105063159962],
              [83.197736794564875, 20.91577795011278],
              [83.196681456019604, 20.914421086268586],
              [83.192561701370025, 20.913184904707911],
              [83.192941356806031, 20.912964459616028],
              [83.192610864487889, 20.912611934476608],
              [83.19095247534527, 20.910199732087499],
              [83.190076227462995, 20.907220489288015],
              [83.190047419313359, 20.907122541579437],
              [83.189444848851892, 20.905073802010456],
              [83.188238747657323, 20.9000986345822],
              [83.184921969372084, 20.900249397231725],
              [83.182660529631889, 20.903264650218372],
              [83.176328498360292, 20.902360074322239],
              [83.169845704439055, 20.898591008089223],
              [83.166956250698647, 20.895827182772219],
              [83.167211679518616, 20.89562881041439],
              [83.166076638205922, 20.894068128609089],
              [83.164418249063289, 20.891957451518518],
              [83.158521448802603, 20.888067253068581],
              [83.156499078004089, 20.886903063106043],
              [83.153780303586231, 20.88533798419348],
              [83.14954240327539, 20.88533798419348],
              [83.145023887084832, 20.88533798419348],
              [83.142146347305058, 20.885053881092798],
              [83.141502284795976, 20.883636943572803],
              [83.131508548571603, 20.878354540139519],
              [83.127939357062687, 20.874071510329767],
              [83.123656327252419, 20.869360177537654],
              [83.11794562083854, 20.866504824330601],
              [83.113948126348404, 20.865362683048083],
              [83.106697841586865, 20.864647866240713],
              [83.1064760000002, 20.864791000000135],
              [83.097451000000234, 20.872061000000539],
              [83.092696000000416, 20.868629000000279],
              [83.088081000000486, 20.863809000000966],
              [83.083527000000274, 20.857220000000773],
              [83.075341000000478, 20.855671999999849],
              [83.053741000000315, 20.856009],
              [83.042977000000164, 20.8552620000006],
              [83.039704000000469, 20.852741000000886],
              [83.023880000000517, 20.852809000000825],
              [83.018066000000459, 20.85355000000072],
              [83.010743000000488, 20.857320000000865],
              [83.006509000000491, 20.857081000000615],
              [82.998611000000537, 20.851590000000723],
              [82.996116000000299, 20.84831000000036],
              [82.99397300000048, 20.846799000000427],
              [82.99331000000015, 20.846920000000118],
              [82.986131000000327, 20.845261000000161],
              [82.978523000000379, 20.846321000000497],
              [82.976303000000186, 20.851150000000526],
              [82.977028000000516, 20.863530000000246],
              [82.969436000000115, 20.875740000000683],
              [82.968178000000464, 20.882650000000577],
              [82.960128000000381, 20.878600000000514],
              [82.958321000000211, 20.882668000000475],
              [82.961541000000395, 20.892820000000761],
              [82.955064000000206, 20.894930000000382],
              [82.948119000000233, 20.893672000001626],
              [82.941086000000425, 20.88803100000046],
              [82.937829000000235, 20.883831000000605],
              [82.92221000000022, 20.884061000000251],
              [82.920738000000114, 20.889540000000462],
              [82.917493407867184, 20.894298678770607],
              [82.916900000000723, 20.895169000000461],
              [82.912323000000555, 20.899931],
              [82.907981000000277, 20.902360000000719],
              [82.898858000000232, 20.901170000000317],
              [82.895768000000359, 20.903700000000352],
              [82.888657000000123, 20.903470000000706],
              [82.88378200000021, 20.906531000000481],
              [82.876525000000512, 20.897490000000285],
              [82.872094000000502, 20.895201000000267],
              [82.860801000000308, 20.882021000000403],
              [82.852669000000205, 20.874771000000401],
              [82.839042000000504, 20.869092000000588],
              [82.83318300000029, 20.865659000000559],
              [82.827300000000406, 20.860732000000208],
              [82.810172000000463, 20.841680000000729],
              [82.803308000000385, 20.83588],
              [82.796691000000379, 20.833852000000658],
              [82.787500000000236, 20.822340000000505],
              [82.777961000000374, 20.81210000000123],
              [82.768546000000455, 20.80361],
              [82.763222000000468, 20.787950000000585],
              [82.757141000000416, 20.777691000000509],
              [82.753707000000347, 20.774070000000727],
              [82.750099, 20.771602000000819],
              [82.74713800000039, 20.770011000000633],
              [82.741379000000492, 20.769252000001071],
              [82.740014000000684, 20.757731000000145],
              [82.735077000000203, 20.748382000000159],
              [82.730628000000351, 20.728492000000298],
              [82.730179000000334, 20.721590000001012],
              [82.72216800000021, 20.722178000000437],
              [82.705040000000267, 20.726691000000123],
              [82.698723000000342, 20.72611000000034],
              [82.695541000000489, 20.721880000000507],
              [82.683448, 20.725549000001021],
              [82.682053000000252, 20.731010000000417],
              [82.682794000000257, 20.735411000000393],
              [82.690292000000312, 20.748662000001154],
              [82.691062, 20.753501000000423],
              [82.689652000000336, 20.762319000000669],
              [82.684250000000276, 20.768981000000675],
              [82.683646000000223, 20.782250000000769],
              [82.679459000000222, 20.816861000000639],
              [82.682411000000215, 20.82835900000077],
              [82.680382000000563, 20.845409000000355],
              [82.681107000000324, 20.854311000000219],
              [82.678192000000351, 20.869210000000574],
              [82.678917000000453, 20.880002000000324],
              [82.687318000000502, 20.892480000000202],
              [82.689561000000239, 20.898360000000874],
              [82.689782000000591, 20.916019000000738],
              [82.69291800000039, 20.927909000000394],
              [82.694023000000513, 20.936889000000743],
              [82.6823270000002, 20.96902],
              [82.684113000000352, 20.996880000000939],
              [82.684280016203473, 20.998441474698208],
              [82.685082936555247, 21.00594817039666],
              [82.686418000000444, 21.018430000000304],
              [82.675430000000262, 21.032551000000577],
              [82.666496, 21.056940000000388],
              [82.661315000000329, 21.065571000000599],
              [82.65415900000032, 21.073320000000869],
              [82.644548000000185, 21.07573200000024],
              [82.639786000000512, 21.078291000000259],
              [82.635490000000487, 21.08413000000035],
              [82.631837000000232, 21.086959000000828],
              [82.635360000000603, 21.09198900000063],
              [82.642998000000361, 21.097762000000269],
              [82.645026000000456, 21.101880000000158],
              [82.638337000000178, 21.10647000000051],
              [82.637099000000418, 21.111619000000925],
              [82.639556000000525, 21.117000000000413],
              [82.645318000000131, 21.120669000000586],
              [82.647759000000278, 21.124961000000436],
              [82.644623000000351, 21.128810000000438],
              [82.638367000000343, 21.13161200000064],
              [82.634086000000352, 21.13635000000027],
              [82.632796000000198, 21.142661000000881],
              [82.635942000000441, 21.149450000000396],
              [82.645828000000193, 21.151711000000429],
              [82.66204900000011, 21.150752000000459],
              [82.684533000000414, 21.158061000000536],
              [82.691963000000428, 21.15685100000098],
              [82.694039000000231, 21.152801000000345],
              [82.700539000000319, 21.153261000000434],
              [82.70553500000014, 21.154891000000639],
              [82.711456000000496, 21.155770000000697],
              [82.721154000000396, 21.158941000000702],
              [82.727241000000262, 21.159191000000643],
              [82.735351000000122, 21.157872000000904],
              [82.752296000000442, 21.159741000000448],
              [82.757522000000492, 21.158560000000303],
              [82.782089000000482, 21.141020000000818],
              [82.788849000000297, 21.139272000000453],
              [82.791764000000384, 21.145111000000551],
              [82.795593000000324, 21.150590000000246],
              [82.803809000000101, 21.153070000000238],
              [82.806847000000332, 21.156641000001397],
              [82.812477000000214, 21.158560000000303],
              [82.83999700000048, 21.163360000000406],
              [82.847131000000431, 21.162681000000525],
              [82.846771000000487, 21.158170000000716],
              [82.854027000000286, 21.157010000000462],
              [82.859497000000587, 21.157302000000804],
              [82.863671000000451, 21.155381000000485],
              [82.868828000000491, 21.159750000000479],
              [82.872855000000456, 21.151059000000313],
              [82.879226000000344, 21.149090000000449],
              [82.88741200000014, 21.153772000000398],
              [82.895141000000521, 21.159820000000817],
              [82.898656022460486, 21.161363826095332],
              [82.901745572327272, 21.164703940935848],
              [82.910942093936384, 21.163196314442867],
              [82.921344716740265, 21.161236400001652],
              [82.928885289997069, 21.161042108934677],
              [82.935516405777307, 21.164553178286887],
              [82.938230133465183, 21.167417668624292],
              [82.938939659415027, 21.161741461024175],
              [82.939134709361142, 21.160181061456168],
              [82.941999199697975, 21.15897496026178],
              [82.945315977983441, 21.160934874703397],
              [82.943647182779713, 21.164370629534798],
              [82.944863690035532, 21.168774532468486],
              [82.944863690035532, 21.176463427583933],
              [82.947125129775344, 21.180835544414261],
              [82.961598344110811, 21.188373676881664],
              [82.963859783851007, 21.186262999790639],
              [82.96476435974715, 21.176614190233746],
              [82.965819698292407, 21.17510656374025],
              [82.971850204265579, 21.177971054077084],
              [82.980895963225379, 21.178574104675018],
              [82.988283333042403, 21.179780205869399],
              [82.987227994496976, 21.176614190233746],
              [82.984665029458753, 21.172995886649172],
              [82.984966554757165, 21.171488260156362],
              [82.984014670174972, 21.169711714173157],
              [82.992557453994706, 21.169995108177087],
              [82.996870227067788, 21.169102810299361],
              [82.998506106509268, 21.167615647170916],
              [82.995977929190403, 21.163005441471562],
              [82.990326709301584, 21.159287533650108],
              [82.986162652541552, 21.15333888113593],
              [82.985520113397897, 21.149590736131749],
              [82.985270354664152, 21.148133810184955],
              [82.98898826248579, 21.141590292418922],
              [82.994788198687473, 21.137574951971597],
              [83.001777865392327, 21.137128803033185],
              [83.005644489526944, 21.139656980351837],
              [83.009659829973913, 21.143523604486344],
              [83.011835098547564, 21.143958658201136],
              [83.014121319359887, 21.144415902363502],
              [83.016901170439141, 21.14256266831142],
              [83.018582808745961, 21.141441576106384],
              [83.024085312321944, 21.136533937781902],
              [83.027803220143582, 21.1350467746534],
              [83.032264709529315, 21.134600625714477],
              [83.033900588971022, 21.13147758314431],
              [83.03717234785401, 21.12671866113282],
              [83.044905596122803, 21.122257171747261],
              [83.051151681263136, 21.121662306495292],
              [83.056208035900497, 21.119877710740916],
              [83.061299965427438, 21.11706089866254],
              [83.063197702605095, 21.116011086606928],
              [83.066172028862397, 21.114672639790793],
              [83.066618177801374, 21.11273932772394],
              [83.066390099051702, 21.110233346755244],
              [83.071441, 21.108070000000502],
              [83.073519195322191, 21.107788979712261],
              [83.077850568766934, 21.107203277396646],
              [83.081565000000154, 21.106701000000211],
              [83.088708000000153, 21.107450000000362],
              [83.092088000000416, 21.105971000000576],
              [83.095176000000308, 21.104312000000615],
              [83.108276000000416, 21.107701000000358],
              [83.119843, 21.101060000000693],
              [83.134003000000675, 21.105231000000284],
              [83.137712000000221, 21.109818000000924],
              [83.148749000000564, 21.119872000000377],
              [83.153397000000197, 21.125770000000781],
              [83.161392000000177, 21.131450000000537],
              [83.167310188709081, 21.131498876028211],
              [83.169868000000392, 21.131520000000474],
              [83.176621000000452, 21.13074100000102],
              [83.182975000000212, 21.132049000000389],
              [83.190102000000351, 21.135529000000187],
              [83.192748000000435, 21.139440000000487],
              [83.193733000000393, 21.157651000000552],
              [83.199387000000158, 21.161970000000505],
              [83.200073000000245, 21.168900000001027],
              [83.199531000000306, 21.174049000000362],
              [83.202020000000203, 21.177431000000801],
              [83.20520800000034, 21.184041],
              [83.210028000000236, 21.188070000000717],
              [83.211211000000205, 21.191181000000707],
              [83.210299625491913, 21.193739714630389],
              [83.207574000000179, 21.201392000000904],
              [83.215362000000297, 21.215491000000377],
              [83.21438600000036, 21.220582000000828],
              [83.215209000000229, 21.223691000000478],
              [83.219063000000276, 21.223711000000883],
              [83.214698, 21.240420000000135],
              [83.214142, 21.250870000000756],
              [83.218354000000247, 21.260121000000591],
              [83.224900000000261, 21.266969000000522],
              [83.231872000000337, 21.265340000000602],
              [83.242447000000297, 21.276439000000718],
              [83.248368000000227, 21.277301000000641],
              [83.257302000000465, 21.275550000000514],
              [83.262756000000408, 21.272610000001006],
              [83.267677, 21.268578000001177],
              [83.271310000000469, 21.280501000000751],
              [83.274560000000392, 21.285672000000652],
              [83.274804000000515, 21.290572000000559],
              [83.272682000000302, 21.296131000000962],
              [83.258797, 21.302130000000826],
              [83.254098000000269, 21.312379000000412],
              [83.254212000000265, 21.319590000000399],
              [83.260855000000319, 21.326740000000651],
              [83.255782000000337, 21.329322000000555],
              [83.254959000000255, 21.331920000001325],
              [83.260644000000269, 21.337180000000441],
              [83.266091000000287, 21.345431000000811],
              [83.270783000000193, 21.35924000000028],
              [83.269516000000678, 21.367210000000338],
              [83.270020000000471, 21.375039000000974],
              [83.271155298767653, 21.375263196784655],
              [83.276123046875256, 21.37591552734397],
              [83.281494140624929, 21.375122070313061],
              [83.287292480468778, 21.371520996094482],
              [83.298430819200263, 21.36873641141187],
              [83.30169677734402, 21.367919921875391],
              [83.309692382812941, 21.364685058594713],
              [83.319274902343906, 21.358276367188008],
              [83.334716796875142, 21.355895996094144],
              [83.374877929687543, 21.340087890625959],
              [83.376708984375327, 21.34332275390647],
              [83.388122558593892, 21.33892822265647],
              [83.392534239439257, 21.341343037435021],
              [83.393920898437699, 21.342102050782156],
              [83.402709960937869, 21.348510742188516],
              [83.404479980469361, 21.355102539063406],
              [83.401916503906278, 21.358276367188008],
              [83.394287109375384, 21.361083984375451],
              [83.393310546875142, 21.365295410156872],
              [83.39630126953152, 21.369323730469031],
              [83.39648437500027, 21.372314453125224],
              [83.393127441406222, 21.383300781250167],
              [83.393676757812827, 21.398925781250846],
              [83.389709472656463, 21.40167236328147],
              [83.381530761718793, 21.409729003906701],
              [83.374084472656108, 21.422302246094031],
              [83.37158873457858, 21.428125634942823],
              [83.371520996093906, 21.428283691406588],
              [83.370326277989349, 21.434932557379906],
              [83.370131318396346, 21.436017549897819],
              [83.369988231839542, 21.436212064608803],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Bhadrak",
          Dist_Code: "378",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [86.948128, 20.784570000000141],
                [86.948135, 20.784237000000129],
                [86.947777000000116, 20.783902000000122],
                [86.94728, 20.783902000000122],
                [86.946708, 20.78397],
                [86.945564000000147, 20.784305],
                [86.945352000000156, 20.784372000000129],
                [86.944565, 20.784372000000129],
                [86.944283, 20.784237000000129],
                [86.943711, 20.784310000000172],
                [86.943642000000111, 20.78444],
                [86.943611, 20.785001000000129],
                [86.943611, 20.785281],
                [86.945001, 20.786671000000123],
                [86.946106, 20.786671000000123],
                [86.946213, 20.78619],
                [86.946564000000123, 20.785655],
                [86.947351, 20.785317000000131],
                [86.947838, 20.784980000000186],
                [86.948128, 20.784570000000141],
              ],
            ],
            [
              [
                [87.016511, 20.802830000000192],
                [87.016511, 20.800670000000189],
                [87.016791, 20.799049000000192],
                [87.016791, 20.79824],
                [87.016511, 20.797700000000127],
                [87.01566300000016, 20.797440000000101],
                [87.015, 20.797221],
                [87.014441000000133, 20.797221],
                [87.014168000000126, 20.797502],
                [87.013892, 20.797502],
                [87.013336, 20.79806],
                [87.013336, 20.798612],
                [87.013612000000123, 20.798881000000161],
                [87.013612000000123, 20.799165000000183],
                [87.013999000000169, 20.799583000000151],
                [87.013999000000169, 20.801203],
                [87.013427, 20.802012],
                [87.013145, 20.802283],
                [87.013154, 20.802552],
                [87.012283000000124, 20.802830000000192],
                [87.012001, 20.802830000000192],
                [87.011718, 20.80309],
                [87.011428, 20.803361000000105],
                [87.008584000000141, 20.806060000000112],
                [87.007431, 20.807140000000114],
                [87.006859, 20.807951000000113],
                [87.006576, 20.808220000000112],
                [87.005722, 20.809570000000118],
                [87.005432, 20.810381],
                [87.005149000000102, 20.81119],
                [87.004577, 20.81227],
                [87.004577, 20.815789],
                [87.004304, 20.816592],
                [87.004012, 20.816861000000127],
                [87.003433, 20.817936],
                [87.003433, 20.818741],
                [87.002868, 20.819555],
                [87.002579000000125, 20.820904000000148],
                [87.002296000000143, 20.821984000000153],
                [87.002007, 20.823333],
                [87.001724, 20.824414000000154],
                [87.001152, 20.825763],
                [87.000869, 20.826839],
                [87.00058, 20.828461000000114],
                [87.000869, 20.829539000000178],
                [87.002503, 20.832222000000108],
                [87.002777000000123, 20.832222000000108],
                [87.004876000000124, 20.8323220000002],
                [87.006592000000168, 20.8323220000002],
                [87.008302, 20.831780000000148],
                [87.009446, 20.830973000000139],
                [87.010872000000106, 20.829893000000137],
                [87.012582000000151, 20.828275000000186],
                [87.014298, 20.826654000000186],
                [87.015442, 20.825843],
                [87.016297, 20.824496000000178],
                [87.017441, 20.823680000000135],
                [87.018578000000133, 20.822875000000177],
                [87.01915, 20.821528000000111],
                [87.019722000000101, 20.81991000000016],
                [87.019996, 20.8185590000001],
                [87.019996, 20.814782],
                [87.01944, 20.813431000000204],
                [87.018790000000109, 20.81227],
                [87.018790000000109, 20.81065000000012],
                [87.018227, 20.809032000000169],
                [87.018227, 20.807685],
                [87.017366, 20.804446000000148],
                [87.016791, 20.803370000000136],
                [87.016511, 20.802830000000192],
              ],
            ],
            [
              [
                [86.430313, 21.154052000000142],
                [86.433402293703452, 21.153557017481884],
                [86.438308000000262, 21.152771000000364],
                [86.443968221503184, 21.149479349088203],
                [86.44677, 21.147850000000172],
                [86.452666, 21.153671],
                [86.458451000000181, 21.153261],
                [86.483223000000109, 21.14060000000017],
                [86.506386, 21.131361000000137],
                [86.518226, 21.141439000000155],
                [86.526627, 21.150310000000157],
                [86.534957, 21.154291],
                [86.545288, 21.153391000000163],
                [86.55342, 21.151130000000133],
                [86.557488, 21.148550000000167],
                [86.558448, 21.14512],
                [86.55719, 21.141660000000112],
                [86.579482000000141, 21.110730000000157],
                [86.585036, 21.107161000000129],
                [86.587967000000148, 21.102931],
                [86.587097000000128, 21.096210000000148],
                [86.587379000000141, 21.092080000000173],
                [86.589599000000163, 21.089830000000173],
                [86.596099000000137, 21.091631000000174],
                [86.603828000000107, 21.092741000000153],
                [86.618417000000179, 21.089830000000173],
                [86.62358800000014, 21.08731],
                [86.627189000000143, 21.084021],
                [86.626977, 21.079009000000148],
                [86.624787000000168, 21.07497],
                [86.623305000000158, 21.068951000000133],
                [86.626526, 21.062570000000104],
                [86.631560000000135, 21.057011],
                [86.637709, 21.054912000000112],
                [86.644141000000133, 21.057389],
                [86.645837000000171, 21.06115],
                [86.6437770000001, 21.07162],
                [86.641372, 21.075800000000182],
                [86.644784, 21.07897],
                [86.649367, 21.080762],
                [86.65364100000015, 21.077699000000102],
                [86.658921, 21.077462000000189],
                [86.663361, 21.090480000000124],
                [86.657891000000106, 21.0919],
                [86.653075, 21.09476],
                [86.651077000000129, 21.097151],
                [86.651122, 21.102751],
                [86.655136, 21.113381000000114],
                [86.655038, 21.117230000000117],
                [86.652253, 21.122101],
                [86.655181, 21.126039000000102],
                [86.65976, 21.12974],
                [86.663482000000144, 21.134611],
                [86.663193, 21.139789],
                [86.660820000000143, 21.143272000000131],
                [86.660813000000118, 21.145950000000195],
                [86.662933000000152, 21.151390000000159],
                [86.66716000000018, 21.15807],
                [86.671548000000129, 21.161831],
                [86.679497, 21.162300000000123],
                [86.688598, 21.160739],
                [86.691741, 21.167811],
                [86.694237, 21.1697],
                [86.698806, 21.175501000000104],
                [86.704506, 21.17701],
                [86.724663000000177, 21.170512000000141],
                [86.734833, 21.175250000000116],
                [86.742149000000126, 21.174199],
                [86.751222000000141, 21.170010000000154],
                [86.759292000000116, 21.165229000000174],
                [86.771203000000114, 21.165261000000154],
                [86.771606, 21.1699190000001],
                [86.765182, 21.176811],
                [86.757667000000183, 21.177402000000139],
                [86.756471000000133, 21.181119],
                [86.756988000000121, 21.186960000000166],
                [86.755418, 21.19277],
                [86.762191, 21.197950000000155],
                [86.76445, 21.202980000000135],
                [86.76505400000012, 21.215051],
                [86.767967, 21.218339000000121],
                [86.780586, 21.21673],
                [86.791207, 21.21996200000012],
                [86.800271, 21.225040000000199],
                [86.804772, 21.22431100000011],
                [86.80947200000017, 21.219561000000166],
                [86.813522, 21.220521],
                [86.817399, 21.210871],
                [86.819236000000146, 21.20855100000011],
                [86.829171, 21.20154000000019],
                [86.829171, 21.20139],
                [86.828881, 21.20111200000013],
                [86.828881, 21.200831000000157],
                [86.82972, 21.200002000000151],
                [86.830002, 21.200002000000151],
                [86.830825000000161, 21.199161000000171],
                [86.830834, 21.198889],
                [86.831108000000114, 21.198611000000138],
                [86.831108000000114, 21.197782000000124],
                [86.830002, 21.19666900000021],
                [86.830276, 21.196389000000121],
                [86.830276, 21.1961],
                [86.830834, 21.195555],
                [86.830559, 21.195279000000134],
                [86.830559, 21.194440000000153],
                [86.830002, 21.193889],
                [86.830002, 21.193611000000139],
                [86.829437, 21.193059000000115],
                [86.829171, 21.19305700000012],
                [86.828888000000106, 21.193333],
                [86.827767, 21.193331],
                [86.8275, 21.193611000000139],
                [86.8275, 21.193889],
                [86.826942, 21.194445],
                [86.826942, 21.194721000000182],
                [86.826668000000126, 21.194999],
                [86.826668000000126, 21.195279000000134],
                [86.826789000000176, 21.195398],
                [86.8275, 21.196111],
                [86.827773, 21.196111],
                [86.827965000000162, 21.196298],
                [86.828056, 21.196389000000121],
                [86.828612000000177, 21.196389000000121],
                [86.828888000000106, 21.196667],
                [86.828881, 21.197219],
                [86.829171, 21.197501000000152],
                [86.828612000000177, 21.198062],
                [86.827767, 21.198062],
                [86.827224, 21.198611000000138],
                [86.826385000000172, 21.198611000000138],
                [86.826385000000172, 21.198333],
                [86.826112000000123, 21.198055000000121],
                [86.826112000000123, 21.197219],
                [86.825554, 21.196667],
                [86.825280000000177, 21.196667],
                [86.824722, 21.197221],
                [86.823890000000105, 21.196389000000121],
                [86.823890000000105, 21.195828000000116],
                [86.824166, 21.195555],
                [86.824166, 21.195279000000134],
                [86.823067, 21.194169000000155],
                [86.822778000000113, 21.194169000000155],
                [86.822502, 21.193889],
                [86.822502, 21.193331],
                [86.822778000000113, 21.19305700000012],
                [86.822778000000113, 21.192779],
                [86.823067, 21.19250100000016],
                [86.823067, 21.19194],
                [86.823334000000145, 21.191667],
                [86.823327000000106, 21.191111],
                [86.823067, 21.190830000000116],
                [86.82306, 21.190555],
                [86.822502, 21.190001],
                [86.822502, 21.18944],
                [86.822219, 21.189167000000165],
                [86.822219, 21.188891],
                [86.821953, 21.18861],
                [86.821946, 21.18833200000017],
                [86.821663, 21.188054],
                [86.821663, 21.186671],
                [86.821387000000158, 21.186391000000178],
                [86.821387000000158, 21.185281000000142],
                [86.821107, 21.185000000000169],
                [86.821107, 21.18472],
                [86.820831000000155, 21.184444000000152],
                [86.820831000000155, 21.18361],
                [86.820558000000105, 21.183330000000179],
                [86.820558000000105, 21.182778000000152],
                [86.820266, 21.182500000000115],
                [86.820266, 21.181939],
                [86.819726, 21.181388],
                [86.819733, 21.180829],
                [86.819167000000135, 21.180278],
                [86.819167000000135, 21.179451],
                [86.818885, 21.17917],
                [86.818885, 21.178610000000102],
                [86.818611000000132, 21.17833400000017],
                [86.818611000000132, 21.178056],
                [86.819167000000135, 21.177500000000119],
                [86.819443, 21.177500000000119],
                [86.820275000000137, 21.17833400000017],
                [86.820558000000105, 21.17833400000017],
                [86.820831000000155, 21.178612],
                [86.821084000000141, 21.178612],
                [86.821387000000158, 21.178610000000102],
                [86.821663, 21.178890000000187],
                [86.821946, 21.178888000000192],
                [86.822112, 21.179061],
                [86.822219, 21.17917],
                [86.822502, 21.17917],
                [86.822778000000113, 21.179451],
                [86.823067, 21.179451],
                [86.823327000000106, 21.17917],
                [86.823890000000105, 21.17917],
                [86.823890000000105, 21.178610000000102],
                [86.82306, 21.177778],
                [86.823067, 21.177500000000119],
                [86.823334000000145, 21.177222000000196],
                [86.823609000000118, 21.177222000000196],
                [86.824166, 21.176665000000124],
                [86.824448000000118, 21.176670000000165],
                [86.825836, 21.17806],
                [86.826112000000123, 21.17806],
                [86.827217, 21.176941],
                [86.828332000000145, 21.176946],
                [86.828332000000145, 21.17639],
                [86.828056, 21.176112],
                [86.828056, 21.173611],
                [86.826942, 21.172502000000115],
                [86.826942, 21.172221000000146],
                [86.827224, 21.171943],
                [86.827224, 21.171667000000124],
                [86.8275, 21.171392],
                [86.8275, 21.170562000000185],
                [86.826668000000126, 21.16971900000021],
                [86.826668000000126, 21.169445000000106],
                [86.826942, 21.169181000000147],
                [86.826942, 21.168059000000195],
                [86.827217, 21.167779000000106],
                [86.827217, 21.166940000000174],
                [86.826942, 21.166667000000128],
                [86.826942, 21.165001000000125],
                [86.826668000000126, 21.16472100000021],
                [86.826668000000126, 21.164167],
                [86.826392, 21.163891000000145],
                [86.826392, 21.162501],
                [86.825836, 21.161945],
                [86.825836, 21.160552],
                [86.826112000000123, 21.160279],
                [86.826112000000123, 21.158061000000199],
                [86.825547, 21.157500000000134],
                [86.825280000000177, 21.157500000000134],
                [86.825134, 21.157359000000209],
                [86.824997, 21.157222],
                [86.824997, 21.156944000000177],
                [86.824722, 21.156671000000127],
                [86.824722, 21.15611],
                [86.825547, 21.155280000000115],
                [86.825547, 21.152219000000166],
                [86.825836, 21.151946000000176],
                [86.825836, 21.15167],
                [86.825547, 21.151390000000159],
                [86.825524000000129, 21.150519000000198],
                [86.825280000000177, 21.150278000000178],
                [86.825280000000177, 21.149722000000164],
                [86.824997, 21.149444],
                [86.824997, 21.148612000000178],
                [86.824172, 21.14778],
                [86.824722, 21.147221000000169],
                [86.824722, 21.146943],
                [86.824997, 21.146668],
                [86.824997, 21.146111000000186],
                [86.824722, 21.145831],
                [86.824722, 21.145001000000146],
                [86.824448000000118, 21.144721000000114],
                [86.824448000000118, 21.143333000000208],
                [86.824722, 21.143055000000114],
                [86.824722, 21.141389000000114],
                [86.824172, 21.140831000000102],
                [86.823609000000118, 21.140833],
                [86.823609000000118, 21.139999],
                [86.823890000000105, 21.139721000000119],
                [86.823609000000118, 21.139445000000187],
                [86.823609000000118, 21.138889000000169],
                [86.823327000000106, 21.138611],
                [86.823327000000106, 21.138330000000103],
                [86.823890000000105, 21.137777000000195],
                [86.824172, 21.137781000000182],
                [86.826668000000126, 21.135281],
                [86.826668000000126, 21.135001],
                [86.826942, 21.13472],
                [86.826942, 21.133613],
                [86.8275, 21.133054],
                [86.8275, 21.1319440000002],
                [86.827773, 21.131666000000106],
                [86.827767, 21.130561000000167],
                [86.828056, 21.130281],
                [86.828056, 21.128058],
                [86.828332000000145, 21.127780000000136],
                [86.828332000000145, 21.126939000000156],
                [86.828056, 21.126668000000105],
                [86.828056, 21.125829000000174],
                [86.828332000000145, 21.125556000000124],
                [86.828332000000145, 21.125280000000199],
                [86.828612000000177, 21.12500000000011],
                [86.828612000000177, 21.12445],
                [86.828881, 21.12417],
                [86.828881, 21.123881],
                [86.829171, 21.123612000000204],
                [86.829171, 21.12333400000011],
                [86.829444000000109, 21.123056],
                [86.829437, 21.122780000000144],
                [86.830002, 21.122222000000129],
                [86.830002, 21.121943000000151],
                [86.830276, 21.121665],
                [86.830276, 21.121112000000149],
                [86.830559, 21.120822000000139],
                [86.830559, 21.120555],
                [86.830825000000161, 21.120282000000199],
                [86.830825000000161, 21.119441000000101],
                [86.830559, 21.119167000000171],
                [86.830825000000161, 21.118892000000127],
                [86.830559, 21.118611000000154],
                [86.830825000000161, 21.118611000000154],
                [86.830825000000161, 21.117501000000171],
                [86.831108000000114, 21.117219],
                [86.831108000000114, 21.116945000000154],
                [86.83139, 21.116670000000106],
                [86.83139, 21.116109000000101],
                [86.831664000000146, 21.115833000000176],
                [86.831664000000146, 21.115555],
                [86.831947000000113, 21.115279000000154],
                [86.831947000000113, 21.114441000000109],
                [86.832222, 21.114167000000176],
                [86.832222, 21.113331],
                [86.833054, 21.112499000000177],
                [86.833045000000183, 21.112221],
                [86.833337000000171, 21.111945000000159],
                [86.833337000000171, 21.111667],
                [86.833610000000178, 21.111391000000136],
                [86.833610000000178, 21.11083],
                [86.833886, 21.110555],
                [86.833893000000131, 21.110281000000153],
                [86.834166, 21.110001],
                [86.834166, 21.10972],
                [86.834442000000124, 21.109445000000104],
                [86.834442000000124, 21.108889],
                [86.834725, 21.108613000000158],
                [86.834725, 21.108332000000186],
                [86.834998000000127, 21.108054],
                [86.835007000000161, 21.107501000000177],
                [86.834725, 21.107223],
                [86.834725, 21.106666000000185],
                [86.83583, 21.105561],
                [86.83583, 21.105000000000182],
                [86.835557, 21.10472],
                [86.835557, 21.104444000000168],
                [86.83583, 21.104166],
                [86.83583, 21.103330000000192],
                [86.836113000000168, 21.103056],
                [86.836113000000168, 21.102780000000163],
                [86.836669, 21.10222],
                [86.836669, 21.101944000000113],
                [86.8369450000001, 21.101668000000181],
                [86.836938, 21.100561],
                [86.836669, 21.100280000000108],
                [86.836669, 21.099710000000183],
                [86.8369450000001, 21.099446000000164],
                [86.837218000000107, 21.099451],
                [86.837501, 21.09917],
                [86.837777000000159, 21.09917],
                [86.839158, 21.097780000000164],
                [86.839158, 21.097219000000102],
                [86.839447000000163, 21.096946000000113],
                [86.839447000000163, 21.09639],
                [86.839721, 21.096109000000123],
                [86.839721, 21.095834000000131],
                [86.839996000000127, 21.095556],
                [86.839996000000127, 21.095280000000113],
                [86.840553, 21.094721],
                [86.840553, 21.094443000000123],
                [86.840835, 21.094165000000196],
                [86.840844000000104, 21.093901],
                [86.840553, 21.093612000000114],
                [86.840553, 21.093331000000141],
                [86.841111000000168, 21.092777000000122],
                [86.841111000000168, 21.092502000000135],
                [86.841667, 21.091941],
                [86.841667, 21.091667000000136],
                [86.841943000000114, 21.091392],
                [86.841943000000114, 21.091111000000122],
                [86.842216000000107, 21.09084],
                [86.842216000000107, 21.089999000000141],
                [86.842499, 21.089719],
                [86.842499, 21.089167000000199],
                [86.842782, 21.088889000000105],
                [86.842782, 21.087221000000167],
                [86.843055, 21.086945],
                [86.843055, 21.086667000000144],
                [86.843331, 21.086389],
                [86.843331, 21.086111000000123],
                [86.843613, 21.085831],
                [86.843613, 21.085277],
                [86.843887, 21.085001000000144],
                [86.843887, 21.08444],
                [86.843613, 21.084167],
                [86.843613, 21.083891000000104],
                [86.843887, 21.083611],
                [86.843887, 21.083061000000207],
                [86.844176, 21.082781000000118],
                [86.844176, 21.08222],
                [86.843887, 21.081945],
                [86.843887, 21.081667000000149],
                [86.844436000000115, 21.08111],
                [86.844719, 21.081113000000126],
                [86.845001000000181, 21.08083200000015],
                [86.8452750000001, 21.08083200000015],
                [86.845558, 21.080554],
                [86.845833, 21.080561],
                [86.848053, 21.078330000000101],
                [86.848053, 21.078056000000171],
                [86.84860900000011, 21.077500000000153],
                [86.84860900000011, 21.07722],
                [86.848892, 21.076944000000132],
                [86.849168000000162, 21.076666],
                [86.849168000000162, 21.07639000000017],
                [86.849441000000169, 21.07611],
                [86.849441000000169, 21.075830000000163],
                [86.849724000000123, 21.075556],
                [86.849717, 21.075280000000127],
                [86.850280000000154, 21.074720000000177],
                [86.850280000000154, 21.074444],
                [86.850556, 21.074168000000153],
                [86.850563000000108, 21.07389],
                [86.850829, 21.073610000000198],
                [86.850829, 21.073329],
                [86.851112, 21.073056000000172],
                [86.851112, 21.072771],
                [86.851388000000142, 21.072500000000158],
                [86.851388000000142, 21.071390000000171],
                [86.852219000000147, 21.07055100000019],
                [86.852219000000147, 21.070278000000197],
                [86.852782, 21.069731],
                [86.852782, 21.069441000000204],
                [86.853058000000132, 21.069166000000159],
                [86.853051, 21.06889],
                [86.853332, 21.068612000000197],
                [86.853332, 21.068331],
                [86.853614000000135, 21.06805600000018],
                [86.85360700000011, 21.067221000000181],
                [86.85389, 21.066943],
                [86.85389, 21.066668000000103],
                [86.854446, 21.066111000000198],
                [86.854446, 21.06556],
                [86.854722000000137, 21.065282000000135],
                [86.854722000000137, 21.065002000000103],
                [86.855278000000155, 21.064441],
                [86.855552, 21.064443000000207],
                [86.855834000000115, 21.064167000000108],
                [86.855827, 21.0636],
                [86.85611, 21.063333],
                [86.85611, 21.062779000000202],
                [86.856393000000168, 21.062499000000113],
                [86.856393000000168, 21.061950000000131],
                [86.856666, 21.061669000000162],
                [86.856666, 21.06138900000013],
                [86.85694200000016, 21.061109],
                [86.85694200000016, 21.060557000000184],
                [86.857215, 21.060279],
                [86.857215, 21.059721000000131],
                [86.85694200000016, 21.059445000000206],
                [86.85694200000016, 21.058889000000189],
                [86.857215, 21.058611],
                [86.857215, 21.058330000000122],
                [86.857498000000163, 21.058057000000126],
                [86.857498000000163, 21.05779],
                [86.857781000000145, 21.057501000000112],
                [86.857781000000145, 21.05694],
                [86.858054000000138, 21.056667],
                [86.858063000000158, 21.056111000000207],
                [86.85833, 21.056111000000207],
                [86.858063000000158, 21.05583],
                [86.858054000000138, 21.055555000000194],
                [86.85833, 21.055281],
                [86.85833, 21.055001],
                [86.859178, 21.054171000000103],
                [86.859435000000161, 21.054171000000103],
                [86.860557000000128, 21.053052],
                [86.860557000000128, 21.052779000000207],
                [86.861106, 21.05222000000014],
                [86.861115, 21.051944],
                [86.861664, 21.051391000000134],
                [86.861655, 21.051110000000161],
                [86.86222, 21.050561000000183],
                [86.86222, 21.050281],
                [86.863328, 21.049171000000111],
                [86.863608000000156, 21.049171000000111],
                [86.863891000000109, 21.048890000000135],
                [86.864167, 21.048890000000135],
                [86.866111000000146, 21.046939000000176],
                [86.866111000000146, 21.046388],
                [86.866387, 21.046110000000166],
                [86.866387, 21.045834],
                [86.867775000000137, 21.044446000000161],
                [86.867768, 21.04417],
                [86.868333, 21.04361],
                [86.868333, 21.043056],
                [86.868889000000124, 21.0425],
                [86.868889000000124, 21.042222000000148],
                [86.870004000000151, 21.041112000000162],
                [86.870004000000151, 21.040831000000189],
                [86.870277, 21.040556000000148],
                [86.870277, 21.04028],
                [86.870553000000115, 21.040002000000126],
                [86.870553000000115, 21.039721000000153],
                [86.870835, 21.039443],
                [86.870835, 21.039168],
                [86.871116, 21.038892000000143],
                [86.871116, 21.03861100000017],
                [86.873055000000178, 21.036667],
                [86.873055000000178, 21.036389000000153],
                [86.873611, 21.035829000000202],
                [86.873611, 21.035555],
                [86.873887000000124, 21.03527900000017],
                [86.873887000000124, 21.034999],
                [86.876107000000133, 21.032779],
                [86.876107000000133, 21.032221000000103],
                [86.876663000000107, 21.031667],
                [86.876663000000107, 21.031391000000152],
                [86.87721900000011, 21.03083],
                [86.87721900000011, 21.030277000000179],
                [86.878890000000155, 21.028611000000179],
                [86.879173000000137, 21.028611000000179],
                [86.880836, 21.026945000000179],
                [86.880836, 21.026671],
                [86.881112, 21.026391000000153],
                [86.881112, 21.02611000000018],
                [86.88138600000012, 21.025832],
                [86.88138600000012, 21.025554],
                [86.881668000000133, 21.025278000000124],
                [86.881668000000133, 21.025000000000201],
                [86.8825, 21.024171000000191],
                [86.8825, 21.02389],
                [86.882767000000143, 21.023610000000129],
                [86.882767000000143, 21.023330000000211],
                [86.88361500000012, 21.0225],
                [86.883605, 21.02222],
                [86.884164, 21.021668000000201],
                [86.884164, 21.021390000000107],
                [86.884720000000101, 21.020830000000156],
                [86.884720000000101, 21.020556],
                [86.885003, 21.02028000000012],
                [86.885003, 21.019720000000117],
                [86.885276, 21.019722000000112],
                [86.885834, 21.019166],
                [86.886101000000153, 21.01917],
                [86.888893, 21.016390000000108],
                [86.888893, 21.01611],
                [86.889169000000123, 21.015834],
                [86.889169000000123, 21.015556],
                [86.889442, 21.015280000000129],
                [86.889442, 21.015000000000207],
                [86.889718000000116, 21.014722000000113],
                [86.889725000000155, 21.014165],
                [86.890267, 21.013612000000133],
                [86.890267, 21.013331000000161],
                [86.890557, 21.013055],
                [86.890557, 21.012782000000183],
                [86.89083, 21.012490000000177],
                [86.89083, 21.011943],
                [86.891113, 21.011667000000156],
                [86.891113, 21.011111000000135],
                [86.89138900000016, 21.010831],
                [86.89138900000016, 21.010279],
                [86.891671, 21.00999900000016],
                [86.891671, 21.009450000000179],
                [86.891938, 21.00917],
                [86.891938, 21.008889000000117],
                [86.893326, 21.007499],
                [86.893326, 21.007221000000122],
                [86.893609000000183, 21.006945],
                [86.893609000000183, 21.00666700000016],
                [86.893891, 21.006389],
                [86.893891, 21.005559000000112],
                [86.894174000000177, 21.005279],
                [86.894174000000177, 21.00500100000016],
                [86.894447, 21.004721],
                [86.894447, 21.004445000000143],
                [86.894723000000141, 21.004167],
                [86.894723000000141, 21.00389100000012],
                [86.895286000000141, 21.00333],
                [86.895279000000102, 21.003055],
                [86.895546000000181, 21.002781000000137],
                [86.895546000000181, 21.002501],
                [86.896667, 21.001391],
                [86.896667, 21.000552],
                [86.896667, 21.000279],
                [86.896943000000121, 21.000001000000161],
                [86.897499000000124, 20.999451000000132],
                [86.897499000000124, 20.999171],
                [86.897782000000106, 20.998891000000125],
                [86.897782000000106, 20.998610000000152],
                [86.898614, 20.997778],
                [86.898614, 20.99694],
                [86.898887, 20.996666],
                [86.898887, 20.99611],
                [86.899170000000169, 20.995830000000176],
                [86.899170000000169, 20.994722000000191],
                [86.899445, 20.994444],
                [86.899436, 20.994171],
                [86.899719000000161, 20.99389],
                [86.899719000000161, 20.993330000000125],
                [86.900002000000129, 20.993056000000191],
                [86.900002000000129, 20.99278],
                [86.900277000000102, 20.99250000000017],
                [86.900277000000102, 20.99222],
                [86.900558, 20.991946000000151],
                [86.900558, 20.991110000000102],
                [86.900674000000123, 20.990061000000189],
                [86.901656, 20.988901000000109],
                [86.902101, 20.987497000000129],
                [86.902381000000148, 20.986891],
                [86.902946000000142, 20.986690000000117],
                [86.903313000000182, 20.986419000000122],
                [86.903313000000182, 20.986009],
                [86.903167000000153, 20.98486500000012],
                [86.902946000000142, 20.984120000000129],
                [86.903450000000106, 20.983178000000173],
                [86.904006000000138, 20.98311],
                [86.904168000000169, 20.982371000000168],
                [86.904168000000169, 20.979999],
                [86.904441, 20.979721000000151],
                [86.904441, 20.979167000000125],
                [86.904991, 20.977779],
                [86.905854, 20.976630000000167],
                [86.906281, 20.976161000000101],
                [86.906632000000144, 20.975349],
                [86.906707000000139, 20.974331],
                [86.907349000000153, 20.973389],
                [86.907349000000153, 20.972510000000163],
                [86.907493000000144, 20.971229],
                [86.907981, 20.969802000000126],
                [86.908478, 20.969121],
                [86.908546, 20.968583000000134],
                [86.908332000000129, 20.968043],
                [86.908051000000142, 20.967502],
                [86.907837, 20.966960000000135],
                [86.907981, 20.966625000000132],
                [86.90905, 20.966641000000205],
                [86.90956, 20.966290000000125],
                [86.9098520000001, 20.965880000000134],
                [86.910119000000151, 20.965073000000128],
                [86.910119000000151, 20.963452000000128],
                [86.910194000000132, 20.962981],
                [86.910262, 20.96244],
                [86.910262, 20.96177],
                [86.910119000000151, 20.961428000000176],
                [86.9098520000001, 20.960891000000171],
                [86.909904000000139, 20.960350000000169],
                [86.910476, 20.96007],
                [86.911049, 20.959742000000112],
                [86.911049, 20.959270000000167],
                [86.910843, 20.958801000000101],
                [86.910843, 20.957502],
                [86.910554, 20.957221000000114],
                [86.910554, 20.956389000000165],
                [86.910285, 20.956109],
                [86.910005000000169, 20.956111],
                [86.910005000000169, 20.955833000000151],
                [86.910554, 20.955279000000186],
                [86.911110000000107, 20.955279000000186],
                [86.911393, 20.954999],
                [86.91166600000011, 20.954999],
                [86.911942, 20.954719000000175],
                [86.911942, 20.954445],
                [86.91249800000017, 20.953887000000119],
                [86.91249800000017, 20.953609000000196],
                [86.912781000000152, 20.953333],
                [86.912781000000152, 20.952777],
                [86.91249800000017, 20.952499],
                [86.91249800000017, 20.951111],
                [86.913613, 20.950001],
                [86.913613, 20.949721000000178],
                [86.913788000000167, 20.948918],
                [86.913788000000167, 20.948310000000159],
                [86.914146000000116, 20.947501],
                [86.91465, 20.946963],
                [86.915146, 20.945814000000205],
                [86.915361000000104, 20.944871000000202],
                [86.915787000000179, 20.94426],
                [86.916573, 20.94264400000014],
                [86.916931, 20.941295],
                [86.917289000000139, 20.939811000000187],
                [86.917792000000162, 20.9392],
                [86.918358, 20.938933],
                [86.919358, 20.938664000000184],
                [86.919999000000161, 20.938056000000127],
                [86.920562, 20.937500000000107],
                [86.920555, 20.937222],
                [86.920831000000106, 20.936946000000145],
                [86.920831000000106, 20.93667],
                [86.920562, 20.936390000000127],
                [86.920562, 20.935832000000111],
                [86.920281, 20.935556],
                [86.920281, 20.935],
                [86.920562, 20.934722000000132],
                [86.920555, 20.934444000000209],
                [86.920831000000106, 20.934165],
                [86.920831000000106, 20.93389],
                [86.921669000000151, 20.933060000000122],
                [86.921669000000151, 20.93250200000011],
                [86.921936, 20.932221000000137],
                [86.921943, 20.931943],
                [86.922225000000125, 20.931668],
                [86.922225000000125, 20.931111000000154],
                [86.922501, 20.930831],
                [86.922501, 20.930555000000137],
                [86.922784, 20.93028200000014],
                [86.922784, 20.929999000000173],
                [86.923057, 20.929721],
                [86.923057, 20.928611],
                [86.924721, 20.926945],
                [86.924721, 20.926667000000172],
                [86.925826, 20.925559000000131],
                [86.925826, 20.92527],
                [86.926109000000153, 20.924999000000181],
                [86.926109000000153, 20.924721],
                [86.926392000000121, 20.924445000000155],
                [86.926392000000121, 20.924165],
                [86.926941, 20.923611],
                [86.926941, 20.92333],
                [86.927224, 20.923055],
                [86.927224, 20.92278100000015],
                [86.928612000000143, 20.921391],
                [86.928612000000143, 20.920830000000187],
                [86.928887, 20.920554],
                [86.928887, 20.92000100000018],
                [86.929168000000146, 20.919720000000208],
                [86.929168000000146, 20.919445000000163],
                [86.930558, 20.918061],
                [86.930558, 20.91694],
                [86.930831, 20.916666],
                [86.930831, 20.916390000000145],
                [86.931107000000139, 20.916110000000113],
                [86.931107000000139, 20.915561000000132],
                [86.93139700000016, 20.915278000000164],
                [86.93139700000016, 20.915],
                [86.931946000000124, 20.914444000000113],
                [86.931946000000124, 20.914168000000185],
                [86.932502000000156, 20.913610000000173],
                [86.932502000000156, 20.913330000000141],
                [86.932778, 20.913056000000207],
                [86.932778, 20.91250000000019],
                [86.933051, 20.912220000000101],
                [86.932778, 20.911946000000167],
                [86.932778, 20.911390000000203],
                [86.933051, 20.911110000000114],
                [86.933051, 20.91083400000019],
                [86.933892, 20.91],
                [86.933892, 20.909719000000106],
                [86.934166000000147, 20.909444000000114],
                [86.934166000000147, 20.909166000000194],
                [86.934455, 20.90889],
                [86.934448, 20.908612000000172],
                [86.934722000000107, 20.908334],
                [86.934998, 20.908334],
                [86.934998, 20.906665000000199],
                [86.935280000000134, 20.906392000000203],
                [86.935280000000134, 20.905831000000145],
                [86.935554, 20.905555],
                [86.935547, 20.905282000000167],
                [86.935836, 20.905002],
                [86.935836, 20.904721000000105],
                [86.936386000000113, 20.90416700000014],
                [86.936386000000113, 20.903892],
                [86.936668, 20.903609000000124],
                [86.936668, 20.903329],
                [86.936944000000139, 20.903055000000105],
                [86.936944000000139, 20.902779],
                [86.937233, 20.902499000000144],
                [86.937224, 20.902221],
                [86.937500000000156, 20.901945000000119],
                [86.937500000000156, 20.90167],
                [86.938888, 20.900279000000118],
                [86.938888, 20.899169000000139],
                [86.938606000000135, 20.898889],
                [86.938606000000135, 20.898611000000127],
                [86.938888, 20.898331],
                [86.938888, 20.897777],
                [86.938332, 20.897221],
                [86.938332, 20.896945000000127],
                [86.939447000000115, 20.895835000000144],
                [86.939447000000115, 20.895555],
                [86.939720000000122, 20.895290000000152],
                [86.940825, 20.893061],
                [86.941085, 20.892321000000148],
                [86.941299, 20.89145],
                [86.941657000000163, 20.890971000000199],
                [86.942375, 20.890162],
                [86.943054000000103, 20.889722],
                [86.944169, 20.88861],
                [86.944169, 20.88833000000016],
                [86.944442, 20.888056],
                [86.944442, 20.887780000000131],
                [86.944527000000136, 20.886810000000192],
                [86.944602000000117, 20.886269000000194],
                [86.944748000000146, 20.885330000000117],
                [86.945183, 20.884790000000173],
                [86.945892000000114, 20.88410900000013],
                [86.946457000000166, 20.883234],
                [86.9468150000001, 20.882425],
                [86.946824000000134, 20.881679000000187],
                [86.946892, 20.881144000000173],
                [86.947455, 20.880401000000116],
                [86.948105, 20.880198],
                [86.94860200000015, 20.879860000000118],
                [86.94896, 20.879254000000113],
                [86.949668, 20.878511],
                [86.950029000000114, 20.877905],
                [86.950835, 20.877221],
                [86.951667, 20.876389000000184],
                [86.951667, 20.876109],
                [86.951943000000185, 20.875833000000164],
                [86.951943000000185, 20.875555],
                [86.952766, 20.874719000000194],
                [86.952775000000116, 20.874445],
                [86.953331, 20.873889],
                [86.953055000000163, 20.873609],
                [86.953055000000163, 20.873057000000184],
                [86.953614, 20.872499],
                [86.953614, 20.872221000000135],
                [86.95417, 20.871667000000109],
                [86.95417, 20.870831],
                [86.955834, 20.869167],
                [86.955827, 20.86833],
                [86.95778000000017, 20.86638900000019],
                [86.95778000000017, 20.86611],
                [86.958053000000149, 20.865832000000118],
                [86.958053000000149, 20.865554000000198],
                [86.958885, 20.864720000000144],
                [86.958885, 20.864444],
                [86.959168, 20.864166000000118],
                [86.959168, 20.863891000000134],
                [86.959441000000126, 20.863610000000104],
                [86.959441000000126, 20.862500000000118],
                [86.959717, 20.86222],
                [86.959724, 20.861944000000101],
                [86.96, 20.861666],
                [86.96, 20.86111],
                [86.960282, 20.860830000000131],
                [86.960282, 20.860556000000194],
                [86.960556000000153, 20.86028],
                [86.960556000000153, 20.859720000000149],
                [86.960832, 20.859444],
                [86.960832, 20.859168000000121],
                [86.960556000000153, 20.858890000000194],
                [86.961381, 20.858061000000188],
                [86.961381, 20.85778],
                [86.961670000000112, 20.857500000000126],
                [86.961670000000112, 20.856390000000143],
                [86.961937, 20.856121],
                [86.961937, 20.854722000000145],
                [86.962220000000158, 20.854444],
                [86.962258000000119, 20.853550000000148],
                [86.962539, 20.852807000000151],
                [86.962539, 20.850982000000155],
                [86.962821000000162, 20.850312000000137],
                [86.963257000000141, 20.849229000000204],
                [86.963393, 20.848016],
                [86.963539, 20.847071000000195],
                [86.963685, 20.846127],
                [86.963965000000115, 20.845042000000202],
                [86.964538, 20.843900000000186],
                [86.964752, 20.842891000000176],
                [86.965180000000132, 20.841940000000189],
                [86.965324000000166, 20.840798],
                [86.965333, 20.83972],
                [86.965538, 20.839110000000169],
                [86.965752, 20.837961000000114],
                [86.965538, 20.837220000000112],
                [86.965973000000176, 20.836411000000165],
                [86.966393000000124, 20.835399],
                [86.966819, 20.834661],
                [86.966958000000119, 20.833371000000163],
                [86.967179000000144, 20.832566000000153],
                [86.967751, 20.831281],
                [86.968177000000125, 20.830674],
                [86.968681000000103, 20.830070000000202],
                [86.968970000000169, 20.829259],
                [86.969445, 20.828334],
                [86.970001, 20.827778000000134],
                [86.970001, 20.826392],
                [86.970276, 20.826112000000133],
                [86.970276, 20.823329],
                [86.970001, 20.823055000000117],
                [86.970001, 20.821950000000182],
                [86.9697180000001, 20.82167],
                [86.9697180000001, 20.821389000000121],
                [86.969438000000167, 20.821109],
                [86.969445, 20.820277000000143],
                [86.969169000000107, 20.82001],
                [86.969169000000107, 20.819441],
                [86.968888000000149, 20.819167000000157],
                [86.968888000000149, 20.818889],
                [86.968613000000147, 20.818611000000143],
                [86.968613000000147, 20.818059000000115],
                [86.96833, 20.817779],
                [86.96833, 20.816669],
                [86.968063000000129, 20.81639100000012],
                [86.968063000000129, 20.81583],
                [86.967781, 20.815555],
                [86.967781, 20.81472100000013],
                [86.967498, 20.814442000000152],
                [86.967498, 20.813889],
                [86.967225, 20.813613000000139],
                [86.967225, 20.812223],
                [86.966942, 20.811945000000144],
                [86.966942, 20.810819],
                [86.966666000000131, 20.810557],
                [86.966666000000131, 20.80861],
                [86.966393000000124, 20.808330000000179],
                [86.966393000000124, 20.8075],
                [86.966110000000171, 20.807220000000196],
                [86.966110000000171, 20.805000000000174],
                [86.965843000000106, 20.80472],
                [86.965837000000121, 20.803612],
                [86.965554000000139, 20.803334000000174],
                [86.965554000000139, 20.802778000000156],
                [86.965278, 20.8025],
                [86.964667000000105, 20.80175000000019],
                [86.964667000000105, 20.800259],
                [86.964722, 20.799165000000183],
                [86.964722, 20.79806],
                [86.964440000000181, 20.797782000000151],
                [86.964722, 20.797502],
                [86.964440000000181, 20.797221],
                [86.964446000000166, 20.79666700000012],
                [86.96415000000016, 20.7963890000002],
                [86.96415000000016, 20.795279],
                [86.963890000000148, 20.794999000000129],
                [86.963890000000148, 20.794719000000207],
                [86.964164, 20.794445000000103],
                [86.96415000000016, 20.79417],
                [86.963890000000148, 20.793889],
                [86.963890000000148, 20.793609],
                [86.963608, 20.793333000000128],
                [86.963608, 20.792499000000188],
                [86.963334000000131, 20.792221],
                [86.963334000000131, 20.791667000000128],
                [86.963058, 20.791389000000201],
                [86.963058, 20.791111000000111],
                [86.962776000000162, 20.790831],
                [86.962776000000162, 20.790555],
                [86.962609, 20.790386000000176],
                [86.962502, 20.790277],
                [86.962502, 20.790001000000128],
                [86.962220000000158, 20.789712000000176],
                [86.962220000000158, 20.789445000000111],
                [86.961112000000156, 20.788335000000128],
                [86.961112000000156, 20.78805500000021],
                [86.958047, 20.785001000000129],
                [86.95778000000017, 20.785001000000129],
                [86.957497, 20.78472000000016],
                [86.957222000000144, 20.785001000000129],
                [86.95639, 20.785001000000129],
                [86.955827, 20.78444],
                [86.955567, 20.78444],
                [86.954719, 20.785281],
                [86.954446000000161, 20.785279],
                [86.95417, 20.785554],
                [86.953887000000108, 20.785554],
                [86.953331, 20.78611300000011],
                [86.952766, 20.786111000000115],
                [86.952499, 20.786391000000204],
                [86.951943000000185, 20.786391000000204],
                [86.951667, 20.786671000000123],
                [86.951111000000125, 20.786667000000133],
                [86.950835, 20.786945],
                [86.950553, 20.786945],
                [86.95027900000018, 20.787223],
                [86.949174, 20.78722],
                [86.948891, 20.787501000000184],
                [86.948059000000157, 20.787501000000184],
                [86.947777000000116, 20.787781000000106],
                [86.947221000000113, 20.787781000000106],
                [86.946952, 20.788061000000191],
                [86.946662, 20.78805500000021],
                [86.946389, 20.788335000000128],
                [86.945557000000107, 20.78833],
                [86.945274000000126, 20.788611],
                [86.944732, 20.788611],
                [86.944442, 20.788891],
                [86.943886, 20.788891],
                [86.943611, 20.789171000000177],
                [86.943054000000103, 20.789167000000184],
                [86.942779000000129, 20.789445000000111],
                [86.942223, 20.789445000000111],
                [86.941949000000179, 20.789723000000205],
                [86.9402690000001, 20.789712000000176],
                [86.940003, 20.790001000000128],
                [86.939720000000122, 20.790001000000128],
                [86.939453, 20.790279],
                [86.935280000000134, 20.790279],
                [86.934998, 20.790559],
                [86.933334, 20.790555],
                [86.933051, 20.790833000000184],
                [86.930831, 20.790833000000184],
                [86.930558, 20.790555],
                [86.929733000000141, 20.790559],
                [86.929443000000148, 20.790279],
                [86.929168000000146, 20.790279],
                [86.928887, 20.790559],
                [86.92583600000016, 20.790555],
                [86.925553, 20.790833000000184],
                [86.925277, 20.790833000000184],
                [86.925004, 20.790555],
                [86.923889, 20.790555],
                [86.923613, 20.790833000000184],
                [86.921669000000151, 20.790833000000184],
                [86.921387, 20.790555],
                [86.921113000000148, 20.790555],
                [86.920831000000106, 20.790833000000184],
                [86.919440000000108, 20.790831],
                [86.919167, 20.791111000000111],
                [86.918052, 20.791111000000111],
                [86.917779000000138, 20.791389000000201],
                [86.916947, 20.791389000000201],
                [86.916657, 20.791669000000123],
                [86.915832000000179, 20.791667000000128],
                [86.915559, 20.791945],
                [86.915001000000174, 20.791945],
                [86.914718, 20.792223],
                [86.909996000000135, 20.792221],
                [86.909722, 20.792499000000188],
                [86.903053000000156, 20.792499000000188],
                [86.902778, 20.792779000000102],
                [86.902497000000139, 20.792779000000102],
                [86.902221, 20.79306],
                [86.901656, 20.79306],
                [86.9011, 20.792499000000188],
                [86.900558, 20.792499000000188],
                [86.900277000000102, 20.792779000000102],
                [86.898331, 20.792779000000102],
                [86.898055000000156, 20.79306],
                [86.896667, 20.793057000000196],
                [86.896385000000166, 20.793333000000128],
                [86.894997, 20.793333000000128],
                [86.894723000000141, 20.793611],
                [86.894174000000177, 20.793609],
                [86.893891, 20.793889],
                [86.893326, 20.793889],
                [86.893059000000136, 20.79417],
                [86.891938, 20.79417],
                [86.891671, 20.79445000000015],
                [86.890557, 20.79445000000015],
                [86.890267, 20.79417],
                [86.889442, 20.79417],
                [86.88916, 20.79445000000015],
                [86.888337, 20.794445000000103],
                [86.888054, 20.794721000000202],
                [86.887222000000151, 20.794719000000207],
                [86.886947000000106, 20.794999000000129],
                [86.886391000000145, 20.794999000000129],
                [86.886101000000153, 20.795279],
                [86.885825, 20.795279],
                [86.885559, 20.79556000000019],
                [86.885276, 20.79556000000019],
                [86.885003, 20.79584],
                [86.884720000000101, 20.795833000000183],
                [86.884444, 20.796111000000103],
                [86.884164, 20.796109000000108],
                [86.883888000000169, 20.7963890000002],
                [86.883605, 20.7963890000002],
                [86.883332000000138, 20.796672000000168],
                [86.883056, 20.79666700000012],
                [86.882774, 20.796943],
                [86.882224000000164, 20.796943],
                [86.881942, 20.797221],
                [86.881668000000133, 20.797221],
                [86.88138600000012, 20.797502],
                [86.879448000000181, 20.7963890000002],
                [86.879173000000137, 20.7963890000002],
                [86.878890000000155, 20.796109000000108],
                [86.878083, 20.796109000000108],
                [86.876946, 20.796111000000103],
                [86.876663000000107, 20.795833000000183],
                [86.876387000000179, 20.79584],
                [86.876107000000133, 20.79556000000019],
                [86.875831, 20.79556000000019],
                [86.875558000000169, 20.795279],
                [86.873611, 20.795279],
                [86.873338000000146, 20.794999000000129],
                [86.87278, 20.794999000000129],
                [86.872497, 20.794719000000207],
                [86.871665000000107, 20.794721000000202],
                [86.8713920000001, 20.794445000000103],
                [86.870683, 20.79445000000015],
                [86.870553000000115, 20.79445000000015],
                [86.870277, 20.79417],
                [86.869721000000183, 20.79417],
                [86.869445, 20.793889],
                [86.868606000000142, 20.793889],
                [86.868333, 20.793609],
                [86.868057000000178, 20.793611],
                [86.867982, 20.793538000000179],
                [86.867775000000137, 20.793333000000128],
                [86.867501, 20.793333000000128],
                [86.867225000000118, 20.793057000000196],
                [86.866669, 20.79306],
                [86.866387, 20.792779000000102],
                [86.866111000000146, 20.792779000000102],
                [86.865837, 20.792499000000188],
                [86.865281, 20.792499000000188],
                [86.864989, 20.792221],
                [86.86444, 20.792223],
                [86.864167, 20.791945],
                [86.863891000000109, 20.791945],
                [86.863608000000156, 20.791667000000128],
                [86.863328, 20.791669000000123],
                [86.862779000000145, 20.791111000000111],
                [86.862503, 20.791111000000111],
                [86.86222, 20.790831],
                [86.861947, 20.790833000000184],
                [86.861388000000133, 20.790277],
                [86.861106, 20.790279],
                [86.860832000000102, 20.790001000000128],
                [86.860557000000128, 20.790001000000128],
                [86.860283, 20.789712000000176],
                [86.86, 20.789723000000205],
                [86.859444, 20.789167000000184],
                [86.859178, 20.789171000000177],
                [86.858063000000158, 20.788061000000191],
                [86.857781000000145, 20.788061000000191],
                [86.857215, 20.787501000000184],
                [86.85694200000016, 20.787501000000184],
                [86.856666, 20.78722],
                [86.85611, 20.787223],
                [86.855278000000155, 20.786389000000209],
                [86.855002, 20.786391000000204],
                [86.854859000000118, 20.786250000000106],
                [86.854722000000137, 20.78611300000011],
                [86.854446, 20.78611300000011],
                [86.854348000000115, 20.786015000000187],
                [86.854164000000182, 20.785832000000138],
                [86.85389, 20.785832000000138],
                [86.853614000000135, 20.785554],
                [86.853332, 20.785554],
                [86.853058000000132, 20.785279],
                [86.852782, 20.785281],
                [86.852219000000147, 20.78472000000016],
                [86.851944000000145, 20.78472000000016],
                [86.851388000000142, 20.784166000000138],
                [86.851112, 20.784171000000178],
                [86.850829, 20.783902000000122],
                [86.850563000000108, 20.784171000000178],
                [86.850280000000154, 20.783902000000122],
                [86.849990000000147, 20.783902000000122],
                [86.849168000000162, 20.783061000000199],
                [86.848343, 20.783061000000199],
                [86.847777000000164, 20.782500000000137],
                [86.847497, 20.782500000000137],
                [86.847221000000133, 20.78222],
                [86.846948000000154, 20.782222],
                [86.846848, 20.78212700000017],
                [86.846665, 20.78194400000012],
                [86.846389, 20.78194400000012],
                [86.846253, 20.781808],
                [86.84610700000016, 20.781666],
                [86.845558, 20.781668],
                [86.8452750000001, 20.781390000000151],
                [86.845001000000181, 20.781390000000151],
                [86.844719, 20.78111],
                [86.844170000000176, 20.78111],
                [86.843887, 20.780834000000137],
                [86.843613, 20.780839000000181],
                [86.843331, 20.780559],
                [86.842782, 20.780559],
                [86.842499, 20.780281],
                [86.842216000000107, 20.780281],
                [86.841943000000114, 20.78],
                [86.841394000000122, 20.78],
                [86.841111000000168, 20.779720000000161],
                [86.840835, 20.779722000000156],
                [86.840553, 20.779444],
                [86.840279000000109, 20.779444],
                [86.839996000000127, 20.779168000000137],
                [86.839447000000163, 20.779171000000186],
                [86.838891000000146, 20.778610000000125],
                [86.838608000000164, 20.778610000000125],
                [86.838333, 20.77833],
                [86.838059, 20.778334],
                [86.837777000000159, 20.778056000000156],
                [86.837218000000107, 20.778061000000204],
                [86.836938, 20.777771000000197],
                [86.836669, 20.777778],
                [86.836389, 20.777500000000138],
                [86.836113000000168, 20.777500000000138],
                [86.83583, 20.77722],
                [86.835557, 20.777222],
                [86.835281000000109, 20.77694600000012],
                [86.835007000000161, 20.776951],
                [86.834716, 20.77667],
                [86.834442000000124, 20.77667],
                [86.833893000000131, 20.776112],
                [86.833337000000171, 20.775551000000171],
                [86.833054, 20.775554],
                [86.832496, 20.775],
                [86.832222, 20.775],
                [86.83139, 20.774170000000133],
                [86.831108000000114, 20.774170000000133],
                [86.830825000000161, 20.77389],
                [86.830559, 20.77389],
                [86.830276, 20.773612000000124],
                [86.830276, 20.773331000000152],
                [86.82972, 20.772778],
                [86.829437, 20.77278],
                [86.829171, 20.772502000000138],
                [86.828881, 20.772502000000138],
                [86.828056, 20.77167],
                [86.827767, 20.77167],
                [86.824861000000141, 20.76875],
                [86.821953, 20.765831],
                [86.821946, 20.765557000000168],
                [86.82157200000016, 20.7651840000002],
                [86.820831000000155, 20.76444500000019],
                [86.820831000000155, 20.764167],
                [86.820558000000105, 20.763891000000168],
                [86.820558000000105, 20.763611],
                [86.820008, 20.763059],
                [86.820008, 20.762770000000156],
                [86.818885, 20.761667],
                [86.818885, 20.761391],
                [86.818046000000137, 20.760561000000163],
                [86.818046000000137, 20.760281],
                [86.817779, 20.760001],
                [86.817779, 20.759730000000154],
                [86.817497000000145, 20.759451000000119],
                [86.817497000000145, 20.759171],
                [86.817223, 20.758891000000173],
                [86.817223, 20.758330000000107],
                [86.816948, 20.758054000000183],
                [86.816948, 20.757501000000101],
                [86.816674, 20.757220000000128],
                [86.816665, 20.756944000000196],
                [86.81639100000011, 20.756666000000102],
                [86.81639100000011, 20.756391000000118],
                [86.81314143921432, 20.759171628061431],
                [86.810048139906627, 20.759171628061431],
                [86.806716894498592, 20.757506005357467],
                [86.803861541291539, 20.752747083345806],
                [86.803623595191013, 20.749891730138753],
                [86.802783906784185, 20.741043023560277],
                [86.802195918587401, 20.740611832215954],
                [86.797674942676437, 20.737756479008961],
                [86.795295481670607, 20.732759610896775],
                [86.793171583343721, 20.731635194135489],
                [86.791250397960695, 20.730618095991471],
                [86.788395044753642, 20.731807826494382],
                [86.781935952514601, 20.73599640925374],
                [86.779709000000125, 20.736811],
                [86.777076, 20.737],
                [86.773927000000114, 20.735929000000109],
                [86.7697900000001, 20.731769000000149],
                [86.76416, 20.728510000000139],
                [86.760436000000126, 20.729121],
                [86.75779, 20.730871],
                [86.754752, 20.733649000000121],
                [86.753059000000107, 20.736471],
                [86.752343, 20.740931],
                [86.753891000000152, 20.747181000000122],
                [86.758073000000181, 20.752890000000143],
                [86.759636000000157, 20.757881000000104],
                [86.758109000000147, 20.762649],
                [86.755698000000137, 20.763862],
                [86.748421, 20.766189],
                [86.741401, 20.765849000000166],
                [86.730552, 20.76395],
                [86.7249, 20.75802],
                [86.70862500000014, 20.756072000000181],
                [86.707152000000107, 20.758011000000177],
                [86.70739, 20.7677],
                [86.705872, 20.770282000000115],
                [86.70176, 20.771941],
                [86.693573000000114, 20.773181000000186],
                [86.687996, 20.777771000000197],
                [86.678565, 20.780431000000188],
                [86.675026000000145, 20.785080000000104],
                [86.670905, 20.784780000000122],
                [86.661132, 20.784050000000146],
                [86.660316000000179, 20.787469],
                [86.655906000000172, 20.7920890000002],
                [86.653328, 20.792440000000109],
                [86.647179, 20.791852000000116],
                [86.641167000000152, 20.78605100000015],
                [86.64119, 20.78328],
                [86.636887, 20.78454000000016],
                [86.635934, 20.787291],
                [86.636383, 20.789871000000169],
                [86.635597, 20.79259],
                [86.631127, 20.786881],
                [86.629227, 20.786931],
                [86.624589000000171, 20.792011000000169],
                [86.620750000000143, 20.790261000000154],
                [86.617097, 20.790001000000128],
                [86.611732, 20.791111000000111],
                [86.609749000000107, 20.794571],
                [86.61206, 20.799769],
                [86.619584000000117, 20.798881000000161],
                [86.620689, 20.800939],
                [86.619957, 20.803441000000127],
                [86.615540000000166, 20.806889000000119],
                [86.615563, 20.80828200000013],
                [86.613097, 20.8073],
                [86.610718000000162, 20.809731000000109],
                [86.608619, 20.81393],
                [86.606668, 20.822522],
                [86.599060000000165, 20.824090000000119],
                [86.597480000000175, 20.828689000000164],
                [86.597389, 20.840001000000193],
                [86.595092000000122, 20.84328],
                [86.591842000000128, 20.850749],
                [86.57904900000014, 20.852632],
                [86.575738000000158, 20.855079],
                [86.565117, 20.859439000000176],
                [86.549691850463418, 20.85720064553038],
                [86.544388000000225, 20.856431000000324],
                [86.538502910140195, 20.857992645917072],
                [86.521628156888525, 20.862470468710338],
                [86.512284000000278, 20.864950000000132],
                [86.502411684531168, 20.868027439894369],
                [86.488848756797935, 20.863030571782186],
                [86.480282697177003, 20.857319865368133],
                [86.469932041801698, 20.857676784518898],
                [86.462436739633262, 20.858033703669825],
                [86.457439871521089, 20.850895320652338],
                [86.447381, 20.838380000000139],
                [86.442978000000124, 20.83936],
                [86.440265110895467, 20.840577948712276],
                [86.436318000000298, 20.842350000000348],
                [86.425018, 20.842799],
                [86.422431, 20.844641],
                [86.421059, 20.84733000000011],
                [86.418297000000152, 20.850161],
                [86.415261000000143, 20.85105],
                [86.410218000000128, 20.851111000000166],
                [86.401650000000174, 20.853391000000155],
                [86.396470000000178, 20.85755000000017],
                [86.388352000000154, 20.858911000000198],
                [86.365699, 20.853331000000136],
                [86.362527000000142, 20.85185000000018],
                [86.3602980000001, 20.849081],
                [86.353287000000179, 20.846761000000125],
                [86.349807, 20.846799],
                [86.34304, 20.849081],
                [86.335776000000109, 20.852711],
                [86.333267, 20.855262],
                [86.329682, 20.856319],
                [86.324356, 20.859212],
                [86.32476100000018, 20.862721000000132],
                [86.330689, 20.867941000000197],
                [86.331932, 20.870229000000162],
                [86.329858, 20.872882000000111],
                [86.322662, 20.872239000000203],
                [86.317078, 20.872590000000113],
                [86.309288000000123, 20.879642],
                [86.307618000000147, 20.88972],
                [86.294244, 20.89638],
                [86.286698, 20.8950010000002],
                [86.283112, 20.895892],
                [86.277023, 20.900250000000195],
                [86.277734, 20.903570000000112],
                [86.27607, 20.907310000000106],
                [86.274598000000125, 20.91634],
                [86.276366, 20.922360000000133],
                [86.284013000000158, 20.937990000000177],
                [86.286048000000136, 20.9561],
                [86.286080000000112, 20.962971000000145],
                [86.281617, 20.972070000000198],
                [86.282258, 20.983650000000118],
                [86.283386000000164, 20.98553],
                [86.285531, 20.995841000000208],
                [86.286187000000126, 21.00862],
                [86.28463, 21.012470000000114],
                [86.290305000000146, 21.012921000000173],
                [86.299073000000121, 21.009559000000134],
                [86.301521, 21.010931000000138],
                [86.301482000000178, 21.014890000000147],
                [86.299896, 21.017272000000101],
                [86.307830000000109, 21.035061],
                [86.310127000000108, 21.050641],
                [86.316299, 21.046980000000186],
                [86.321197000000126, 21.053551000000137],
                [86.319909000000138, 21.060252000000158],
                [86.316529000000102, 21.06051200000018],
                [86.315301000000119, 21.06767],
                [86.313569000000115, 21.07237],
                [86.311515, 21.075139000000199],
                [86.301697, 21.081689000000207],
                [86.302262, 21.086710000000149],
                [86.304062, 21.090049000000189],
                [86.301232, 21.092171],
                [86.300370000000129, 21.096652000000116],
                [86.301986, 21.100700000000185],
                [86.305382000000108, 21.105502000000168],
                [86.300133000000116, 21.108540000000168],
                [86.289268000000135, 21.11303],
                [86.285850000000138, 21.111940000000111],
                [86.28492, 21.112401],
                [86.28479, 21.1137],
                [86.287773, 21.115819],
                [86.285859000000173, 21.122381000000129],
                [86.281998, 21.127942000000182],
                [86.277718000000149, 21.131571],
                [86.270217, 21.132361],
                [86.268448, 21.136890000000161],
                [86.269066000000151, 21.141040000000196],
                [86.270523000000111, 21.144780000000193],
                [86.280412000000112, 21.155770000000185],
                [86.280419, 21.160390000000174],
                [86.282050000000126, 21.16315],
                [86.287666, 21.165650000000191],
                [86.287696, 21.169969000000144],
                [86.294082, 21.170211000000105],
                [86.301238, 21.168071000000104],
                [86.302269, 21.164290000000104],
                [86.30562600000016, 21.16403],
                [86.309142000000165, 21.16488],
                [86.311577000000142, 21.167941000000209],
                [86.31527800000012, 21.169311],
                [86.317391, 21.175052],
                [86.321138, 21.174279],
                [86.320816, 21.17031100000019],
                [86.323196000000152, 21.1712],
                [86.325509, 21.173509000000131],
                [86.328399, 21.174231000000184],
                [86.335038000000154, 21.17389200000019],
                [86.339523000000142, 21.181290000000157],
                [86.337951000000132, 21.18355100000019],
                [86.339156000000145, 21.184540000000133],
                [86.345383, 21.186122000000122],
                [86.347632, 21.199851],
                [86.350639000000101, 21.204362000000113],
                [86.350693000000135, 21.207981],
                [86.349602, 21.21158],
                [86.350434, 21.215151000000155],
                [86.349556, 21.222661000000183],
                [86.347892, 21.228999],
                [86.349098000000126, 21.230289000000191],
                [86.365989, 21.232931000000118],
                [86.367537619534716, 21.229508654636387],
                [86.369271000000353, 21.22567800000024],
                [86.370951793540641, 21.224263148750019],
                [86.373010892159911, 21.220369284866759],
                [86.37375447372419, 21.218435972799561],
                [86.380149275177402, 21.217543674922346],
                [86.383272317747497, 21.215461646542277],
                [86.387733807133458, 21.215461646542277],
                [86.391600431267918, 21.214271916039358],
                [86.394574757525191, 21.214271916039358],
                [86.396656785905321, 21.213528334475022],
                [86.398143949033937, 21.213825767100726],
                [86.399151853546343, 21.215211635805186],
                [86.4014248132452, 21.214541773306163],
                [86.403633000000283, 21.213891000000157],
                [86.404208890295337, 21.213345390874277],
                [86.405728480990064, 21.213677050787904],
                [86.406174629928643, 21.212636036597807],
                [86.405840169857782, 21.211799886420973],
                [86.405282332051442, 21.210405291904859],
                [86.405728480990064, 21.209364277714819],
                [86.408624790174528, 21.207810888073194],
                [86.409151488268748, 21.206409917841818],
                [86.409297672498809, 21.20311819257449],
                [86.41033868668886, 21.202672043635907],
                [86.412420715068933, 21.201482313132995],
                [86.415543757639099, 21.199846433691501],
                [86.416733488142015, 21.19925156844004],
                [86.417923218644916, 21.200590015255838],
                [86.417923218644916, 21.202077178384453],
                [86.417030920767772, 21.202969476261668],
                [86.41601075426432, 21.204426856981055],
                [86.417809000000233, 21.208259000000279],
                [86.41822958565011, 21.20983791989897],
                [86.418693943213185, 21.211581163865894],
                [86.420127, 21.216961000000193],
                [86.428307, 21.216461000000201],
                [86.432952000000157, 21.214930000000148],
                [86.43473, 21.207069],
                [86.436539000000309, 21.205289],
                [86.436024195730667, 21.202355952818376],
                [86.433984580434284, 21.200738731568656],
                [86.434282013060042, 21.199846433691501],
                [86.444184000000263, 21.195329000000182],
                [86.443299, 21.191471000000202],
                [86.442584674170831, 21.190395441023551],
                [86.441193000000254, 21.188300000000364],
                [86.436042, 21.18627],
                [86.435047497189075, 21.185336765173979],
                [86.427017000000234, 21.177801000000326],
                [86.427106118530418, 21.17698896849765],
                [86.424615452723828, 21.17307749737591],
                [86.424615452723828, 21.170251887431498],
                [86.426846197416793, 21.168913440615707],
                [86.429820523674081, 21.168913440615707],
                [86.431753835741333, 21.170549320057201],
                [86.43358014156432, 21.17420193170323],
                [86.436562, 21.175439],
                [86.438736000000148, 21.171672000000164],
                [86.437706, 21.163731000000205],
                [86.436643666270285, 21.162340180553194],
                [86.428779509484045, 21.159098163966458],
                [86.427441062668237, 21.157759717150888],
                [86.428035927919709, 21.155826405083641],
                [86.429523091048367, 21.154785390893604],
                [86.430313, 21.154052000000142],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Balangir",
          Dist_Code: "393",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [83.234215934701453, 20.922199031885153],
              [83.23757303065608, 20.920375545746985],
              [83.2411516519998, 20.914467895025606],
              [83.241597800938436, 20.908519242510916],
              [83.242787531441351, 20.902570589996227],
              [83.244423410882845, 20.898703965861834],
              [83.246802871888619, 20.897216802733276],
              [83.247678716108439, 20.895622802946942],
              [83.247338000000397, 20.895201000000267],
              [83.248684442427447, 20.894155591449355],
              [83.250230078939325, 20.892955524075884],
              [83.255210000000233, 20.889089000000919],
              [83.257446365782556, 20.885718395367572],
              [83.258334184044983, 20.884380293893852],
              [83.259110000000106, 20.883211000000525],
              [83.266442000000197, 20.87620000000015],
              [83.269569, 20.870311000000353],
              [83.270241000000155, 20.866621000000574],
              [83.268174000000258, 20.863879000000217],
              [83.271599, 20.857700000000246],
              [83.274567, 20.849931],
              [83.272506000000277, 20.840561000000431],
              [83.275627, 20.839900000000394],
              [83.278259, 20.84176],
              [83.281486000000129, 20.847392000000351],
              [83.281669, 20.850270000000361],
              [83.284362, 20.851590000000211],
              [83.290801, 20.850931000000394],
              [83.296417000000218, 20.848841],
              [83.300752000000131, 20.855811000000351],
              [83.304740000000137, 20.85435],
              [83.307243000000184, 20.854501000000479],
              [83.313050000000175, 20.858990000000173],
              [83.315566, 20.861801000000462],
              [83.318916000000272, 20.86971200000016],
              [83.321480000000108, 20.872271000000406],
              [83.323541000000134, 20.878420000000229],
              [83.325813, 20.880040999999888],
              [83.332466, 20.88042100000029],
              [83.336922000000172, 20.877839],
              [83.343552000000201, 20.872230000000396],
              [83.348365000000214, 20.873180000000268],
              [83.353370000000197, 20.874252000000293],
              [83.366562000000201, 20.879721000000693],
              [83.38575, 20.884050000000336],
              [83.405984000000146, 20.891780000000377],
              [83.408828, 20.8938820000003],
              [83.410652, 20.897841000000192],
              [83.409186, 20.905519000000361],
              [83.400017000000133, 20.915340000000466],
              [83.389848000000185, 20.922492000000371],
              [83.381791000000121, 20.93621],
              [83.37613, 20.939191000000388],
              [83.376289000000128, 20.944590000000282],
              [83.380173000000269, 20.951300000000167],
              [83.377037000000129, 20.95356100000026],
              [83.378067000000186, 20.956640000000103],
              [83.380898, 20.959270000000284],
              [83.384973, 20.966871000000307],
              [83.383605, 20.970030000000403],
              [83.381385000000122, 20.971650000000178],
              [83.380401, 20.975999000000453],
              [83.380829000000105, 20.986440000000126],
              [83.379036000000198, 20.989170000000279],
              [83.369408000000107, 20.992441],
              [83.368508000000347, 20.993380000000112],
              [83.36795, 20.997361],
              [83.367150000000194, 20.997931000000104],
              [83.366708000000173, 20.998341000000206],
              [83.366279000000233, 20.998740000000449],
              [83.365807000000217, 20.999112],
              [83.36534000000016, 20.99946000000045],
              [83.364852, 20.999782],
              [83.364326000000105, 21.000080000000473],
              [83.363831000000161, 21.000352],
              [83.363296, 21.000611000000156],
              [83.362769000000114, 21.000842000000372],
              [83.362252, 21.001031000000232],
              [83.361703000000247, 21.001199000000266],
              [83.361153, 21.001341000000131],
              [83.360618, 21.001462000000398],
              [83.360046000000168, 21.001550000000172],
              [83.359512000000208, 21.001601000000161],
              [83.358970000000156, 21.001630000000425],
              [83.35843, 21.001630000000425],
              [83.357871000000145, 21.001601000000161],
              [83.35732200000011, 21.001550000000172],
              [83.356782, 21.001462000000398],
              [83.356217000000214, 21.001341000000131],
              [83.355668000000179, 21.001199000000266],
              [83.355148, 21.001031000000232],
              [83.354608000000198, 21.000842000000372],
              [83.354081, 21.000611000000156],
              [83.353546000000151, 21.000352],
              [83.353028000000151, 21.000071000000386],
              [83.352538000000138, 20.999782],
              [83.352057000000158, 20.999451000000356],
              [83.35157, 20.999112],
              [83.351112, 20.998729000000136],
              [83.350663, 20.998319],
              [83.350198000000248, 20.997391000000327],
              [83.346496000000144, 20.994581],
              [83.336090000000155, 20.983800000000425],
              [83.331397, 20.98120200000039],
              [83.327844, 20.980190000000444],
              [83.32283, 20.980911000000329],
              [83.320412000000175, 20.983110000000117],
              [83.315796, 20.991281000000292],
              [83.311997000000176, 20.994109000000204],
              [83.305091000000161, 20.996691],
              [83.295455000000217, 21.004561000000191],
              [83.289741000000262, 21.01151],
              [83.295302000000206, 21.019211000000265],
              [83.2985, 21.021320000000511],
              [83.302468, 21.02707],
              [83.306313000000145, 21.027749],
              [83.312783000000223, 21.035489000000322],
              [83.313141000000229, 21.042440000000166],
              [83.317597000000134, 21.051550000000354],
              [83.321984, 21.052220000000258],
              [83.326378, 21.051801000000292],
              [83.331383000000272, 21.054759000000555],
              [83.337418, 21.05462000000011],
              [83.341667000000129, 21.05609],
              [83.347488, 21.059200999999796],
              [83.349831000000208, 21.062121000000158],
              [83.351433, 21.065731000000362],
              [83.355590000000277, 21.063399000000111],
              [83.35936700000012, 21.063370000000297],
              [83.368089000000268, 21.059589],
              [83.374238, 21.059361000000301],
              [83.383088000000129, 21.065610000000103],
              [83.387359000000103, 21.065580000000406],
              [83.390923000000313, 21.063659000000136],
              [83.398529, 21.058481000000253],
              [83.400589000000167, 21.055641000000143],
              [83.401168000000183, 21.0435],
              [83.404266000000277, 21.0378390000003],
              [83.410684, 21.032542],
              [83.420577, 21.02766000000042],
              [83.425537000000176, 21.02797000000032],
              [83.429543000000166, 21.031120000000552],
              [83.435807000000111, 21.042892000000158],
              [83.445297, 21.046142000000366],
              [83.45218, 21.051010000000129],
              [83.452285, 21.045410000000171],
              [83.442979000000179, 21.019309],
              [83.443528, 21.015141],
              [83.454078000000194, 21.00511000000051],
              [83.460396000000202, 20.996850999999872],
              [83.46370800000031, 20.993521],
              [83.467949, 20.99207100000012],
              [83.482171, 20.992881000000349],
              [83.488824000000122, 20.990159000000169],
              [83.49717, 20.982112000000139],
              [83.502221000000176, 20.978711],
              [83.506364000000119, 20.97785],
              [83.511857, 20.977501],
              [83.525803, 20.980860000000344],
              [83.529167000000356, 20.980730000000218],
              [83.540458, 20.976408999999872],
              [83.568154000000206, 20.970889000000167],
              [83.572869000000239, 20.971170000000249],
              [83.584618000000191, 20.97596000000021],
              [83.590469000000127, 20.977332000000157],
              [83.618698000000151, 20.98120200000039],
              [83.628861000000299, 20.980560000000192],
              [83.633941, 20.978041],
              [83.634568, 20.975821],
              [83.631019000000194, 20.968309000000541],
              [83.630547000000178, 20.964492],
              [83.629410000000107, 20.962420000000289],
              [83.624177000000117, 20.957009000000195],
              [83.619637000000168, 20.949260000000319],
              [83.613007000000124, 20.94276900000045],
              [83.610336, 20.931989000000605],
              [83.604125, 20.929042000000205],
              [83.607017000000198, 20.925610000000457],
              [83.610017000000241, 20.923652000000171],
              [83.611152, 20.919611000000252],
              [83.608369, 20.913232000000104],
              [83.61071, 20.910150000000151],
              [83.613663, 20.908181],
              [83.614723000000239, 20.904320000000322],
              [83.613716000000153, 20.899261],
              [83.609841000000287, 20.895580000000106],
              [83.59665700000015, 20.88859],
              [83.587485000000115, 20.8802],
              [83.579331000000181, 20.875161000000158],
              [83.572587000000155, 20.869021000000426],
              [83.568306, 20.859859000000366],
              [83.56662, 20.848329000000145],
              [83.568359, 20.842770000000197],
              [83.5822000000001, 20.83842100000015],
              [83.5864100000002, 20.837760000000113],
              [83.599419, 20.831819000000447],
              [83.612442, 20.827810000000451],
              [83.618415000000184, 20.822180000000337],
              [83.61900300000022, 20.816081000000164],
              [83.61695, 20.811420000000222],
              [83.610963, 20.8131],
              [83.603868000000233, 20.81382900000062],
              [83.590127000000138, 20.817832000000173],
              [83.591057000000177, 20.811042000000722],
              [83.594193, 20.804259000000453],
              [83.59355200000013, 20.801260000000177],
              [83.590332000000203, 20.798110000000175],
              [83.592308, 20.796601],
              [83.597716, 20.796551000000129],
              [83.610443, 20.798940000000123],
              [83.612708000000211, 20.795852000000192],
              [83.618233000000131, 20.79416000000014],
              [83.624207, 20.794531999999887],
              [83.629052000000101, 20.792238999999878],
              [83.631097000000111, 20.779221000000231],
              [83.630493000000101, 20.767121],
              [83.633980000000278, 20.765920000000275],
              [83.643067000000116, 20.76980100000014],
              [83.648881000000102, 20.768281000000339],
              [83.651718, 20.765031000000128],
              [83.652069, 20.756461],
              [83.645072000000283, 20.751550000000403],
              [83.646264, 20.747160000000118],
              [83.651549, 20.741239000000402],
              [83.663032, 20.741971000000145],
              [83.668420000000225, 20.741212000000356],
              [83.670578, 20.737471000000134],
              [83.666909000000118, 20.727742000000259],
              [83.662973000000235, 20.72199200000022],
              [83.663369, 20.717531000000456],
              [83.661842, 20.706881000000291],
              [83.658998, 20.701081000000155],
              [83.654487000000159, 20.698911000000173],
              [83.65088600000027, 20.695472000000102],
              [83.646018, 20.68429000000037],
              [83.643707000000205, 20.682091000000351],
              [83.639511, 20.680051],
              [83.633057000000207, 20.675151000000366],
              [83.633888000000113, 20.670472000000466],
              [83.632920000000212, 20.666100000000366],
              [83.630210000000119, 20.660899],
              [83.625396000000237, 20.657490000000276],
              [83.622566000000262, 20.652811],
              [83.621207000000283, 20.645032000000352],
              [83.622276, 20.639530000000146],
              [83.619247, 20.636141000000176],
              [83.616752000000275, 20.634580000000366],
              [83.615279000000314, 20.625691],
              [83.603608000000222, 20.614031],
              [83.599938000000151, 20.613341000000212],
              [83.596702000000192, 20.605311000000253],
              [83.590797000000222, 20.601350000000586],
              [83.588623, 20.598670000000304],
              [83.590972000000221, 20.594009000000366],
              [83.594079000000349, 20.584359],
              [83.594658, 20.578841000000686],
              [83.593559, 20.572831000000175],
              [83.593988, 20.57073000000036],
              [83.59588600000022, 20.568041000000214],
              [83.595190999999872, 20.56451900000047],
              [83.593003000000337, 20.56149],
              [83.589821000000242, 20.551690000000232],
              [83.588340000000116, 20.544980000000347],
              [83.588272, 20.536921000000113],
              [83.590995000000234, 20.530321000000182],
              [83.599107, 20.524840000000264],
              [83.595330000000146, 20.522791000000321],
              [83.580673000000246, 20.521250000000233],
              [83.575759, 20.518602],
              [83.573487000000213, 20.513111000000205],
              [83.574196000000242, 20.506660999999891],
              [83.57270700000025, 20.49888],
              [83.566627000000139, 20.484761000000383],
              [83.565033000000184, 20.479339000000206],
              [83.568124000000282, 20.476141000000549],
              [83.571221000000193, 20.476590000000208],
              [83.574722000000278, 20.479931000000303],
              [83.577781000000115, 20.480971],
              [83.590072000000163, 20.471670000000127],
              [83.593169, 20.463770000000519],
              [83.601167000000132, 20.462232000000533],
              [83.606072, 20.459410000000386],
              [83.612351, 20.453742000000371],
              [83.613807000000165, 20.450879000000437],
              [83.614876, 20.444179],
              [83.618317000000204, 20.443711000000345],
              [83.624688, 20.44067100000029],
              [83.644539000000222, 20.429058999999818],
              [83.650834000000231, 20.426901],
              [83.649466000000217, 20.42324],
              [83.651809, 20.420339000000464],
              [83.65908, 20.417552000000111],
              [83.658371, 20.414889000000123],
              [83.656051000000204, 20.412510000000108],
              [83.652518, 20.411291000000116],
              [83.651078000000254, 20.40775100000041],
              [83.653922000000122, 20.402441000000628],
              [83.653220000000132, 20.398250000000186],
              [83.647071, 20.385021],
              [83.645364000000242, 20.384],
              [83.642868000000178, 20.382861],
              [83.641601000000122, 20.380661000000142],
              [83.645569, 20.37430900000026],
              [83.64521800000027, 20.370481000000378],
              [83.646125, 20.367791000000345],
              [83.649222000000208, 20.364780000000103],
              [83.648110000000173, 20.362239],
              [83.644065000000211, 20.35972100000026],
              [83.638862000000174, 20.363242000000124],
              [83.634347, 20.36083100000041],
              [83.629807, 20.364240000000333],
              [83.622855000000115, 20.363149000000245],
              [83.620453000000211, 20.358360000000399],
              [83.619851000000239, 20.347190000000179],
              [83.617912, 20.345221],
              [83.601051000000126, 20.350192000000103],
              [83.586113, 20.35751],
              [83.579919000000217, 20.357610000000246],
              [83.574563000000211, 20.359830000000326],
              [83.569915000000137, 20.359712000000169],
              [83.568001, 20.362158999999789],
              [83.56453, 20.37245],
              [83.563971000000123, 20.382909000000151],
              [83.56086, 20.383980000000289],
              [83.558618, 20.38924],
              [83.551377, 20.391610000000124],
              [83.549599000000214, 20.394881000000389],
              [83.542703000000117, 20.396561000000244],
              [83.537347000000153, 20.393071000000415],
              [83.532706, 20.394070000000507],
              [83.523034, 20.398580000000486],
              [83.516167000000266, 20.400440000000568],
              [83.513229000000123, 20.402919000000107],
              [83.511848, 20.407731],
              [83.50801200000015, 20.408141000000107],
              [83.50102200000012, 20.410222],
              [83.495185000000149, 20.41056100000014],
              [83.492867, 20.40877],
              [83.489549, 20.402202000000209],
              [83.487329, 20.399820000000538],
              [83.484687000000221, 20.4009],
              [83.483497000000199, 20.404640000000423],
              [83.483582000000155, 20.41052000000013],
              [83.486656, 20.424371],
              [83.489311000000185, 20.428810000000336],
              [83.489327000000216, 20.434691000000381],
              [83.487686000000153, 20.442191],
              [83.484528000000154, 20.448131000000323],
              [83.482697000000186, 20.447652000000286],
              [83.480491, 20.448910000000289],
              [83.465103, 20.434661000000226],
              [83.451608000000277, 20.424250000000253],
              [83.444839, 20.416350000000413],
              [83.44284900000018, 20.414012000000408],
              [83.421883, 20.402509000000684],
              [83.416238000000277, 20.398202000000307],
              [83.41098, 20.389131000000582],
              [83.407219, 20.373158000000323],
              [83.404931, 20.367322000000282],
              [83.39769, 20.357642000000165],
              [83.388282000000103, 20.351801000000247],
              [83.384056, 20.345640000000227],
              [83.378295000000193, 20.339799],
              [83.3631290000001, 20.337472000000385],
              [83.358726000000132, 20.332180000000101],
              [83.355927000000278, 20.313329],
              [83.353028000000151, 20.309771000000175],
              [83.347848000000155, 20.309810000000422],
              [83.34210900000015, 20.3113100000005],
              [83.336486000000235, 20.311531000000283],
              [83.317519, 20.30281100000024],
              [83.30737300000014, 20.300069000000569],
              [83.297417, 20.300340000000229],
              [83.292975000000112, 20.298280000000201],
              [83.283059000000122, 20.282091000000257],
              [83.277976, 20.275671],
              [83.262412, 20.26464],
              [83.255242, 20.261422],
              [83.241729000000177, 20.257930000000439],
              [83.235733000000124, 20.25513100000034],
              [83.231719000000268, 20.251430000000251],
              [83.228852000000117, 20.246860000000193],
              [83.228287000000293, 20.240811000000118],
              [83.232986, 20.225001000000471],
              [83.224426000000136, 20.213649000000256],
              [83.219008, 20.199641000000153],
              [83.214591, 20.195760000000288],
              [83.202134000000214, 20.192220000000358],
              [83.196794000000224, 20.188731000000409],
              [83.18837000000012, 20.175861000000165],
              [83.182572000000135, 20.170949000000284],
              [83.176270000000144, 20.167451000000252],
              [83.16616000000019, 20.165712000000436],
              [83.150901, 20.166892000000185],
              [83.138108000000315, 20.164930000000137],
              [83.132392, 20.17324],
              [83.128647000000157, 20.175359000000292],
              [83.120850000000118, 20.188699000000494],
              [83.114081, 20.189590000000404],
              [83.094223000000213, 20.186180000000146],
              [83.087470000000152, 20.1914200000001],
              [83.083541, 20.19346000000041],
              [83.079666000000131, 20.191710000000281],
              [83.07895800000027, 20.188751000000362],
              [83.076501000000164, 20.184840000000118],
              [83.073144, 20.18631],
              [83.068740000000147, 20.185472000000342],
              [83.061333, 20.184430000000695],
              [83.051795000000112, 20.179680000000413],
              [83.04751700000017, 20.181251000000199],
              [83.043556000000237, 20.181422000000332],
              [83.03923, 20.179241],
              [83.034576000000158, 20.175630000000403],
              [83.031433000000249, 20.176171],
              [83.026656, 20.179790000000363],
              [83.022720000000135, 20.173251000000388],
              [83.016999000000197, 20.169219000000563],
              [83.010171000000113, 20.165871000000145],
              [83.005966000000214, 20.165279],
              [82.992309000000134, 20.169231000000529],
              [82.988984000000229, 20.167849000000157],
              [82.985572, 20.16981200000054],
              [82.983102, 20.168770000000219],
              [82.976228000000148, 20.168519000000284],
              [82.973213000000257, 20.16983],
              [82.97017700000012, 20.172879000000187],
              [82.965867, 20.172850000000377],
              [82.96156400000028, 20.17396],
              [82.952507000000111, 20.170860000000626],
              [82.947967000000148, 20.171341000000208],
              [82.938896, 20.168390000000269],
              [82.924911, 20.174210000000127],
              [82.919272, 20.172531000000387],
              [82.915589, 20.167249999999736],
              [82.906837000000266, 20.161479],
              [82.904342, 20.156720000000398],
              [82.903792000000166, 20.143369000000344],
              [82.901702, 20.142740000000224],
              [82.893883000000159, 20.143752],
              [82.876892000000211, 20.153459000000108],
              [82.869751000000164, 20.153320000000345],
              [82.861519, 20.15432],
              [82.853882, 20.157819],
              [82.845809000000131, 20.157060000000222],
              [82.832123000000294, 20.16209],
              [82.823936000000216, 20.162131],
              [82.81746600000011, 20.160520000000353],
              [82.810302000000178, 20.164369000000303],
              [82.805687000000191, 20.16801100000043],
              [82.805473000000163, 20.171191000000128],
              [82.80671000000028, 20.175639],
              [82.810699000000156, 20.183471000000278],
              [82.813728000000296, 20.183612000000263],
              [82.819818, 20.181752000000184],
              [82.824355, 20.181830000000211],
              [82.835457000000218, 20.186862],
              [82.84147600000027, 20.191370000000227],
              [82.845276, 20.204140000000503],
              [82.849549, 20.209131],
              [82.850967, 20.2130010000003],
              [82.855292000000119, 20.230159000000409],
              [82.850937, 20.233090000000168],
              [82.847138000000172, 20.234070000000195],
              [82.847473000000193, 20.245661000000151],
              [82.849084, 20.24998],
              [82.853387000000197, 20.25133],
              [82.854951000000241, 20.26550100000031],
              [82.852646, 20.27202],
              [82.848938, 20.277209],
              [82.843049, 20.28272000000015],
              [82.839240000000174, 20.282930000000299],
              [82.834892000000181, 20.277082],
              [82.832467, 20.276350000000317],
              [82.825203, 20.276140000000161],
              [82.817887, 20.27766],
              [82.813201, 20.281300000000549],
              [82.809304, 20.286100000000253],
              [82.806922000000299, 20.29041],
              [82.813081000000224, 20.29746200000022],
              [82.814927, 20.301851000000163],
              [82.81471900000011, 20.305669000000531],
              [82.812707, 20.311141000000358],
              [82.815772000000138, 20.317080000000253],
              [82.829812000000146, 20.315772000000145],
              [82.831031, 20.310090000000169],
              [82.830017, 20.304641000000167],
              [82.83078, 20.3017420000001],
              [82.835587000000189, 20.29745],
              [82.832702, 20.290189000000279],
              [82.835876, 20.287780000000332],
              [82.839881000000148, 20.287559],
              [82.843277, 20.28845],
              [82.845048, 20.290702000000458],
              [82.84536700000011, 20.292550000000343],
              [82.844788, 20.312009000000213],
              [82.848031000000262, 20.323339],
              [82.847557000000208, 20.33238],
              [82.845643, 20.335822000000231],
              [82.842087, 20.337321000000422],
              [82.837508, 20.335161000000195],
              [82.834352000000109, 20.33212],
              [82.819458000000211, 20.33958],
              [82.817046000000204, 20.341752000000493],
              [82.814209000000275, 20.349371000000698],
              [82.810013000000126, 20.353982],
              [82.806831, 20.349791],
              [82.805810000000221, 20.342511000000282],
              [82.803909000000132, 20.339680000000268],
              [82.80153, 20.337800000000236],
              [82.802239, 20.334948999999821],
              [82.805785000000228, 20.3315],
              [82.807228, 20.323471000000374],
              [82.802590000000279, 20.319191000000266],
              [82.797737000000126, 20.316061999999871],
              [82.791078, 20.317570000000611],
              [82.786925000000153, 20.319521000000119],
              [82.784867, 20.321411000000346],
              [82.788377000000224, 20.334860000000159],
              [82.785713, 20.342069000000262],
              [82.787789000000188, 20.345640000000227],
              [82.793847000000184, 20.348421000000137],
              [82.797829, 20.352840000000239],
              [82.807868, 20.359520000000199],
              [82.808242, 20.368142000000486],
              [82.809899000000129, 20.378549000000245],
              [82.804917000000131, 20.37838000000033],
              [82.798758000000177, 20.379481000000165],
              [82.795303000000317, 20.37639000000058],
              [82.79097700000014, 20.369311000000149],
              [82.788247, 20.366791000000596],
              [82.783408, 20.367709000000328],
              [82.777152, 20.36453000000051],
              [82.772475, 20.354611000000428],
              [82.768897000000138, 20.351810000000111],
              [82.76384700000014, 20.350192000000103],
              [82.757438000000136, 20.34990200000038],
              [82.750931, 20.354789],
              [82.7455, 20.356751000000482],
              [82.73793700000013, 20.357631000000307],
              [82.727622000000153, 20.353339],
              [82.722633, 20.3522290000003],
              [82.717247, 20.351931000000373],
              [82.71216500000024, 20.352970000000365],
              [82.70931100000017, 20.357401000000205],
              [82.709266000000113, 20.36251000000038],
              [82.714212000000288, 20.36593100000027],
              [82.721040000000116, 20.373970000000323],
              [82.721733000000128, 20.376969000000592],
              [82.724778000000228, 20.379791],
              [82.718232, 20.386391],
              [82.71794, 20.389169000000258],
              [82.716568000000208, 20.39105],
              [82.708801, 20.397730000000131],
              [82.705642000000225, 20.405060000000269],
              [82.703301000000167, 20.408621999999692],
              [82.698905000000181, 20.413239000000654],
              [82.691131, 20.41899200000034],
              [82.691231000000116, 20.422871000000438],
              [82.694894000000247, 20.43292],
              [82.690399, 20.440831000000109],
              [82.686593000000173, 20.444701000000347],
              [82.679284, 20.445760000000288],
              [82.679443000000134, 20.450150000000342],
              [82.684159, 20.460479000000301],
              [82.682502000000213, 20.464201000000227],
              [82.684303, 20.468759000000311],
              [82.690529, 20.471941],
              [82.694602, 20.481809000000563],
              [82.696181000000109, 20.490479000000274],
              [82.700042000000252, 20.495951000000328],
              [82.702729000000133, 20.516541000000185],
              [82.701011000000264, 20.523511000000322],
              [82.700279000000222, 20.53087],
              [82.703406000000129, 20.537081000000395],
              [82.703812000000127, 20.543342],
              [82.706009000000194, 20.553461],
              [82.706016, 20.562851000000357],
              [82.708336, 20.566181000000139],
              [82.722863000000231, 20.576991000000358],
              [82.722581000000147, 20.583299000000348],
              [82.725571, 20.593521000000461],
              [82.735802, 20.618950000000265],
              [82.734626000000148, 20.624821000000562],
              [82.725272, 20.62741],
              [82.724021000000263, 20.631469000000603],
              [82.724297, 20.63767],
              [82.726068000000268, 20.64680100000032],
              [82.720101, 20.649989000000229],
              [82.720124, 20.662269000000371],
              [82.716682, 20.667801000000278],
              [82.712951, 20.671671000000511],
              [82.697036000000125, 20.676281],
              [82.688920000000266, 20.676831000000213],
              [82.68826400000016, 20.697340000000391],
              [82.694946000000286, 20.715982000000391],
              [82.695541000000262, 20.72188],
              [82.698723000000129, 20.726110000000286],
              [82.70504000000021, 20.726691],
              [82.722168000000167, 20.722178],
              [82.730179000000291, 20.721590000000326],
              [82.730628000000294, 20.72849200000018],
              [82.735077, 20.748382000000213],
              [82.74001400000013, 20.757731000000145],
              [82.741379000000208, 20.769252000000275],
              [82.747138, 20.770011],
              [82.750099, 20.771602000000254],
              [82.753707000000233, 20.77407],
              [82.757141000000189, 20.777691000000452],
              [82.763222000000141, 20.78795000000013],
              [82.768546000000157, 20.80361],
              [82.777961000000332, 20.8121],
              [82.787500000000122, 20.822340000000388],
              [82.796691000000109, 20.833852000000658],
              [82.803308, 20.83588],
              [82.810172000000179, 20.84168000000022],
              [82.827300000000136, 20.860732],
              [82.833183, 20.865659],
              [82.839042, 20.869092000000133],
              [82.852669, 20.874771000000461],
              [82.860801000000308, 20.882021000000346],
              [82.872094000000274, 20.895201000000267],
              [82.876525000000171, 20.897490000000285],
              [82.883782, 20.906531000000538],
              [82.88865700000018, 20.903470000000649],
              [82.895768, 20.903700000000295],
              [82.89885800000016, 20.901170000000317],
              [82.907981, 20.902360000000265],
              [82.912323000000228, 20.899931000000144],
              [82.91690000000014, 20.895169000000347],
              [82.920738, 20.889540000000345],
              [82.922210000000163, 20.884061000000194],
              [82.937829, 20.883831000000548],
              [82.941086000000197, 20.888031000000403],
              [82.948119, 20.893672000000375],
              [82.955064, 20.89493],
              [82.961541, 20.892820000000249],
              [82.958321, 20.882668000000415],
              [82.960128, 20.878600000000457],
              [82.968178, 20.88265],
              [82.969436000000115, 20.875740000000171],
              [82.977028000000161, 20.863530000000306],
              [82.976303, 20.851150000000413],
              [82.978523, 20.84632100000044],
              [82.986131, 20.845261000000161],
              [82.99331000000015, 20.846920000000178],
              [82.993973000000196, 20.84679900000037],
              [82.996116000000228, 20.848310000000303],
              [82.998611000000139, 20.851590000000211],
              [83.00650900000015, 20.857081000000104],
              [83.010743000000147, 20.857320000000296],
              [83.018066000000189, 20.853550000000265],
              [83.023880000000176, 20.852809000000427],
              [83.039704000000114, 20.852741000000371],
              [83.042977000000207, 20.855262],
              [83.053741000000272, 20.856009],
              [83.075341, 20.855672],
              [83.083527000000274, 20.857220000000318],
              [83.08808100000013, 20.863809000000398],
              [83.092696000000146, 20.868629000000279],
              [83.095591737416925, 20.870719046438577],
              [83.097451, 20.872061000000482],
              [83.1064760000002, 20.864791000000192],
              [83.106697841586524, 20.864647866239913],
              [83.113948126348404, 20.865362683048026],
              [83.117945620838427, 20.866504824330601],
              [83.123656327252363, 20.869360177537597],
              [83.12793935706263, 20.87407151032971],
              [83.131508548571603, 20.878354540139519],
              [83.141502284795862, 20.883636943572803],
              [83.142146347304987, 20.885053881092741],
              [83.145023887084761, 20.88533798419348],
              [83.153780303586117, 20.88533798419348],
              [83.154661158733319, 20.885845053778208],
              [83.156499078004387, 20.886903063106043],
              [83.158521448802489, 20.888067253068581],
              [83.164418249063246, 20.891957451518458],
              [83.166076638205851, 20.894068128608971],
              [83.167211679518502, 20.895628810414333],
              [83.166956250698576, 20.895827182772106],
              [83.169845704438984, 20.898591008089166],
              [83.176328498360235, 20.902360074322129],
              [83.182660529631889, 20.903264650218254],
              [83.18492196937197, 20.900249397231615],
              [83.18823874765728, 20.900098634582257],
              [83.189444848851892, 20.905073802010513],
              [83.190047419313302, 20.90712254157938],
              [83.190076227462995, 20.907220489287962],
              [83.190952475345156, 20.910199732087442],
              [83.192610864487833, 20.912611934476665],
              [83.192941356805974, 20.912964459615971],
              [83.192561701370025, 20.913184904707798],
              [83.196681456019675, 20.914421086268469],
              [83.197736794564875, 20.915777950112663],
              [83.198225730950782, 20.917105063159848],
              [83.198942895759714, 20.918039389852535],
              [83.201656623447633, 20.919547016346083],
              [83.202862724642202, 20.920602354890882],
              [83.203918063187444, 20.921205405488305],
              [83.204219588486154, 20.92241150668314],
              [83.204521113784878, 20.923919133176238],
              [83.204416367457313, 20.926747284019477],
              [83.204367392967455, 20.926764085486635],
              [83.204068825836814, 20.928743537954681],
              [83.205576452330078, 20.931004977695007],
              [83.207866819837975, 20.930877735055667],
              [83.208290180018011, 20.930854215045649],
              [83.209728339108992, 20.930022948840584],
              [83.210722407825401, 20.929573918881939],
              [83.212128000000106, 20.928939000000351],
              [83.21582831248449, 20.929195825902749],
              [83.219602853534042, 20.929210057013044],
              [83.223183630257296, 20.927832504971317],
              [83.225449000000225, 20.926961000000794],
              [83.226028712594413, 20.926646115381793],
              [83.234215934701453, 20.922199031885153],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Boudh",
          Dist_Code: "391",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [84.377442224388219, 20.577433868902514],
              [84.3777690000001, 20.578830000000149],
              [84.373368000000127, 20.589492],
              [84.378327000000112, 20.594061],
              [84.378854, 20.596580000000127],
              [84.36431, 20.632490000000182],
              [84.367852, 20.639140000000108],
              [84.353211000000144, 20.663450000000122],
              [84.353851000000176, 20.668270000000174],
              [84.352142000000157, 20.670640000000159],
              [84.349061000000148, 20.667390000000175],
              [84.335846000000103, 20.669161000000141],
              [84.332817, 20.6774],
              [84.327286, 20.683652000000105],
              [84.320100000000181, 20.687150000000194],
              [84.31218, 20.689001000000182],
              [84.296677, 20.687360000000119],
              [84.286216, 20.68249],
              [84.276803, 20.674681000000184],
              [84.271499000000105, 20.669040000000106],
              [84.27487300000017, 20.651701],
              [84.273537000000118, 20.644351000000135],
              [84.276147, 20.639660000000159],
              [84.275818, 20.637301000000143],
              [84.267853, 20.634951],
              [84.258668000000142, 20.618619000000187],
              [84.257394, 20.611041],
              [84.254807, 20.606911000000135],
              [84.250572, 20.605801],
              [84.249175, 20.599650000000107],
              [84.242837000000151, 20.59583],
              [84.22901900000015, 20.58962200000013],
              [84.223312000000121, 20.58459200000015],
              [84.214576, 20.581611],
              [84.203087, 20.5849790000002],
              [84.191448582615322, 20.586111658036366],
              [84.18756100000023, 20.586490000000307],
              [84.184728781906045, 20.585890876941782],
              [84.181893000000201, 20.585291000000261],
              [84.179863669550556, 20.58796383318133],
              [84.171355621504048, 20.589319274159827],
              [84.165485820994178, 20.597231936401151],
              [84.161682, 20.596001000000165],
              [84.159454759005527, 20.594937538080949],
              [84.158116703423815, 20.594298643969118],
              [84.152779, 20.591750000000157],
              [84.147720000000149, 20.587869],
              [84.146111, 20.583789000000134],
              [84.143115096218111, 20.58122796800728],
              [84.140579000000102, 20.57906000000019],
              [84.138671000000144, 20.578502],
              [84.136563376582643, 20.575217025477052],
              [84.128454959637722, 20.580284786067576],
              [84.12545732467575, 20.580284786067576],
              [84.121491813441523, 20.580284786067576],
              [84.120407752251353, 20.576448877241315],
              [84.114697045837303, 20.574926022197637],
              [84.108415268781968, 20.574164594675715],
              [84.106130986216357, 20.568644245142135],
              [84.102894919248371, 20.562933538728252],
              [84.099165498510132, 20.561372385860974],
              [84.090062842213996, 20.564478509133718],
              [84.075191210927557, 20.564775941759418],
              [84.06805282791008, 20.570724594273994],
              [84.066863097407165, 20.576375814162866],
              [84.065375934278549, 20.581729601425987],
              [84.060914444892589, 20.582324466677445],
              [84.056452955506685, 20.585001360308976],
              [84.051694033495025, 20.584406495057518],
              [84.030843656957344, 20.578263080542111],
              [84.026061550305855, 20.576854066975152],
              [84.022696828728087, 20.575862675795857],
              [84.018381579413401, 20.574591218408493],
              [84.015700053042664, 20.568355111475395],
              [84.014633739570655, 20.567860037363396],
              [84.008499685042338, 20.567326641317489],
              [83.988043451589064, 20.561206750250669],
              [83.977335877062814, 20.564478509133718],
              [83.969602628793865, 20.571914324776909],
              [83.967818033039492, 20.578755275168696],
              [83.963356543653546, 20.576970679414327],
              [83.961879406343698, 20.57731155725514],
              [83.9594899195191, 20.577862977291481],
              [83.954496319753204, 20.578388619372099],
              [83.948187479741406, 20.5790527077944],
              [83.941049096723916, 20.577862977291481],
              [83.936146118106294, 20.577238961831025],
              [83.92469030230879, 20.575780948911412],
              [83.909818671022364, 20.58113473617453],
              [83.908331507893749, 20.584703927683272],
              [83.919039082419985, 20.588570551817721],
              [83.924392869683103, 20.597196097963881],
              [83.915767323536926, 20.601360154724084],
              [83.912516386611955, 20.601912780060498],
              [83.913192000000123, 20.600771000000119],
              [83.909223805770907, 20.60106272209833],
              [83.903870018507789, 20.598683261092496],
              [83.899705961747586, 20.600467856846869],
              [83.894054741858753, 20.598683261092496],
              [83.889890685098564, 20.592734608577924],
              [83.888403521969892, 20.583811629806057],
              [83.888331218000843, 20.574792688420185],
              [83.888700954595635, 20.57042716164829],
              [83.873829323309195, 20.572806622654124],
              [83.867285805543176, 20.571616892151209],
              [83.860312437684883, 20.571268223758345],
              [83.85538850051401, 20.571022026899751],
              [83.849142415373677, 20.57042716164829],
              [83.831593890455721, 20.563586211256503],
              [83.830106727327049, 20.560017019747757],
              [83.828322131572676, 20.551094040975894],
              [83.825645237941131, 20.54663255158999],
              [83.82432592844502, 20.545313242093862],
              [83.819399152800798, 20.540386466449654],
              [83.813536638258398, 20.540603596617924],
              [83.811368471906164, 20.540683899075411],
              [83.811665904531864, 20.535032679186539],
              [83.798281436374097, 20.539494168572499],
              [83.794712244865352, 20.53384294868362],
              [83.796794273245425, 20.527596863543348],
              [83.797389138496868, 20.524622537286056],
              [83.793225081736679, 20.518971317397181],
              [83.791737918608064, 20.513617530134066],
              [83.786978996596403, 20.513022664882605],
              [83.787573861847861, 20.509750905999617],
              [83.789060836217942, 20.509325296620027],
              [83.795723327034281, 20.501235129200147],
              [83.804360954993427, 20.492142889243322],
              [83.80036346475417, 20.487146026444233],
              [83.797091705871182, 20.480602508678196],
              [83.801850627882843, 20.476141019292239],
              [83.806005742199247, 20.470480788372011],
              [83.806192955459991, 20.464115537509254],
              [83.817138476086754, 20.455073585687153],
              [83.820916267961238, 20.453039390062422],
              [83.830701592578492, 20.448182352473729],
              [83.819995583965891, 20.449364132610238],
              [83.818001657886199, 20.449584231651837],
              [83.813747932911994, 20.442828565210615],
              [83.809606631023698, 20.438327150114667],
              [83.806906982520204, 20.435392749567423],
              [83.797389138496868, 20.433310721187294],
              [83.793035618929125, 20.429946637884878],
              [83.790845620730849, 20.428254366549929],
              [83.78519440084203, 20.432715855935836],
              [83.776728549191191, 20.432493070366142],
              [83.773891961064322, 20.432418423310132],
              [83.767645875923989, 20.436285047444581],
              [83.762589521286628, 20.431526125432917],
              [83.762886953912343, 20.425874905544102],
              [83.769133039052676, 20.418736522526611],
              [83.767348443298303, 20.416654494146481],
              [83.761716679588844, 20.419744052696668],
              [83.746834851425817, 20.422885147115146],
              [83.746178750045701, 20.422491486287122],
              [83.725692259158151, 20.427033402970775],
              [83.71159790671156, 20.429104983161373],
              [83.707267052901074, 20.429741529678545],
              [83.703925462591002, 20.422117218435965],
              [83.702094140323865, 20.420943293905729],
              [83.684507022474847, 20.409669500412857],
              [83.683144204118406, 20.409972348936545],
              [83.678713520831124, 20.408623813251833],
              [83.674549464070921, 20.411300706883363],
              [83.666552082123118, 20.423687532444372],
              [83.659080000000102, 20.417552000000111],
              [83.651809000000156, 20.42033900000018],
              [83.649466000000103, 20.423240000000188],
              [83.650834000000117, 20.426901],
              [83.644539000000108, 20.429059000000105],
              [83.624688, 20.440671],
              [83.618317000000147, 20.443711],
              [83.614876, 20.444179],
              [83.613807, 20.450879000000207],
              [83.612351000000146, 20.453742],
              [83.606072, 20.459410000000101],
              [83.601167000000132, 20.462232000000196],
              [83.593169, 20.46377],
              [83.59007200000012, 20.47167],
              [83.577781000000115, 20.480971],
              [83.574722000000151, 20.479931000000189],
              [83.571221, 20.476590000000154],
              [83.568124000000111, 20.476141000000151],
              [83.565033000000128, 20.479339],
              [83.566627, 20.484761000000159],
              [83.572707, 20.498880000000206],
              [83.574196000000128, 20.506661000000118],
              [83.5734870000001, 20.513111000000144],
              [83.575759000000161, 20.518602],
              [83.580673000000132, 20.521250000000176],
              [83.595330000000146, 20.522791000000147],
              [83.599107, 20.524840000000207],
              [83.604187, 20.523091],
              [83.615724, 20.526070000000168],
              [83.622552, 20.528981000000154],
              [83.634796, 20.530610000000134],
              [83.64071, 20.532320000000194],
              [83.645364000000185, 20.534911000000189],
              [83.665901000000176, 20.549441000000169],
              [83.67056200000016, 20.551510000000118],
              [83.676750000000183, 20.552691000000145],
              [83.68187800000014, 20.555510000000133],
              [83.685258, 20.561251000000134],
              [83.701814000000113, 20.577472],
              [83.705581, 20.58445000000011],
              [83.711548, 20.590681000000181],
              [83.717583, 20.5948],
              [83.72432000000012, 20.601161],
              [83.727707, 20.607301],
              [83.727638, 20.617270000000129],
              [83.72605900000012, 20.619891000000102],
              [83.711739000000122, 20.628451000000151],
              [83.711532, 20.6352],
              [83.717521000000119, 20.643539],
              [83.720963, 20.651379],
              [83.732238000000152, 20.669891000000174],
              [83.734145000000169, 20.676482000000185],
              [83.737060000000142, 20.692582000000179],
              [83.740372, 20.69895],
              [83.747597000000141, 20.705482000000128],
              [83.749573, 20.706391],
              [83.75228, 20.710639000000125],
              [83.754851000000116, 20.724519000000154],
              [83.753356, 20.726901000000105],
              [83.753609, 20.73718],
              [83.754981, 20.743169000000133],
              [83.758156, 20.74884],
              [83.759132000000122, 20.754891000000153],
              [83.758979, 20.761220000000147],
              [83.756232000000168, 20.770220000000162],
              [83.768731, 20.789249],
              [83.774085000000113, 20.79411],
              [83.781036, 20.797771000000118],
              [83.799370000000167, 20.803300000000199],
              [83.815422000000112, 20.809321000000121],
              [83.822318000000152, 20.813611000000144],
              [83.82945200000016, 20.816852],
              [83.838081, 20.818992000000204],
              [83.844818, 20.818570000000133],
              [83.862602, 20.809540000000137],
              [83.875397, 20.808902],
              [83.883896, 20.80933900000019],
              [83.891609000000102, 20.811240000000108],
              [83.897767, 20.814199000000137],
              [83.915902000000173, 20.827561000000109],
              [83.927742000000165, 20.833991],
              [83.933501, 20.83616000000017],
              [83.940200000000104, 20.836851000000134],
              [83.9477, 20.83531000000016],
              [83.963066, 20.835661],
              [83.984237, 20.837241],
              [83.993607000000154, 20.835281],
              [84.007416, 20.833970000000132],
              [84.020072000000184, 20.831422000000195],
              [84.031449, 20.822251],
              [84.039916, 20.8218],
              [84.047996000000111, 20.823361],
              [84.053612, 20.829931],
              [84.073402, 20.834941000000178],
              [84.089479000000125, 20.836742000000179],
              [84.105927, 20.840650000000206],
              [84.123039, 20.848871],
              [84.134011, 20.857931000000114],
              [84.14428, 20.865071],
              [84.153342000000109, 20.869901000000191],
              [84.175293000000167, 20.879382000000188],
              [84.189004, 20.888501000000129],
              [84.19934, 20.893091],
              [84.210961, 20.896749],
              [84.223038, 20.897490000000111],
              [84.232178, 20.895630000000207],
              [84.240692000000166, 20.89336900000017],
              [84.249442, 20.8899],
              [84.260696, 20.884309000000197],
              [84.311751, 20.85783],
              [84.326668, 20.848680000000112],
              [84.33612, 20.841400000000132],
              [84.344879000000148, 20.836420000000199],
              [84.350472000000167, 20.830472],
              [84.354401, 20.82167],
              [84.352249000000128, 20.803149000000129],
              [84.353523, 20.793041000000127],
              [84.349425, 20.785481],
              [84.350456, 20.77624000000014],
              [84.356299, 20.766572000000107],
              [84.365304, 20.757501000000101],
              [84.376862, 20.751139],
              [84.391776000000149, 20.74817],
              [84.401802000000117, 20.742951],
              [84.409508, 20.740731],
              [84.419671, 20.736191000000129],
              [84.432716, 20.737490000000143],
              [84.450448, 20.737962],
              [84.461274, 20.73228000000017],
              [84.470131000000123, 20.728950000000165],
              [84.480439000000132, 20.72166100000015],
              [84.505494, 20.710019],
              [84.515953000000167, 20.699911000000153],
              [84.529069, 20.692529],
              [84.542388000000173, 20.689580000000145],
              [84.565018000000109, 20.681630000000151],
              [84.574280000000144, 20.675771000000164],
              [84.581879, 20.66889000000014],
              [84.599449, 20.644150000000192],
              [84.611633, 20.634069000000117],
              [84.61995, 20.6257],
              [84.630981, 20.619020000000141],
              [84.705071000000132, 20.605820000000104],
              [84.713577, 20.606551000000188],
              [84.727668000000151, 20.61195900000018],
              [84.735062000000184, 20.61007],
              [84.73993, 20.607331],
              [84.745010000000136, 20.605690000000148],
              [84.757286000000121, 20.602961000000157],
              [84.771767, 20.596010000000202],
              [84.776061000000126, 20.592019],
              [84.787728, 20.57517],
              [84.78688, 20.570071000000208],
              [84.789672, 20.55426100000016],
              [84.78407300000012, 20.550400000000131],
              [84.78173, 20.543481000000149],
              [84.775291, 20.54237100000017],
              [84.770462000000165, 20.529778000000189],
              [84.764296000000158, 20.5253],
              [84.757568, 20.52615],
              [84.737977000000157, 20.534442000000123],
              [84.732528000000102, 20.533051000000111],
              [84.73008, 20.528021000000134],
              [84.723251, 20.523411],
              [84.713966000000127, 20.519689000000138],
              [84.709764000000106, 20.514962000000192],
              [84.705903, 20.501779000000109],
              [84.698211, 20.497080000000146],
              [84.693153, 20.492749000000114],
              [84.687202, 20.46346],
              [84.680862, 20.459711000000137],
              [84.678093, 20.456800000000154],
              [84.686127000000141, 20.45123000000012],
              [84.685883, 20.44612],
              [84.683, 20.444299],
              [84.682412, 20.442292],
              [84.685760000000101, 20.438659000000197],
              [84.685669, 20.43604],
              [84.679467, 20.433082],
              [84.67701, 20.430862],
              [84.67147, 20.428601],
              [84.668450000000163, 20.423739000000122],
              [84.663825000000131, 20.421301000000195],
              [84.657195000000101, 20.41935],
              [84.640792, 20.41893900000013],
              [84.634087, 20.420770000000111],
              [84.627877000000112, 20.42443],
              [84.61541, 20.428191],
              [84.598906, 20.416191000000136],
              [84.594681, 20.415979],
              [84.587983, 20.418671000000185],
              [84.563156, 20.40838900000011],
              [84.554885000000169, 20.40678],
              [84.550523, 20.410762000000197],
              [84.548462000000171, 20.414329000000116],
              [84.545128, 20.416711000000184],
              [84.540169, 20.415881],
              [84.53671300000012, 20.413041000000131],
              [84.536132000000165, 20.409071],
              [84.533593, 20.406450000000113],
              [84.529008000000118, 20.406131000000183],
              [84.524773, 20.404950000000149],
              [84.520974000000109, 20.403250000000181],
              [84.518189, 20.39972200000016],
              [84.514396000000133, 20.399040000000177],
              [84.511773000000161, 20.400271],
              [84.506073000000157, 20.392392],
              [84.497323, 20.39278],
              [84.490768, 20.39105],
              [84.482598, 20.385931000000195],
              [84.480592, 20.380541000000104],
              [84.462281, 20.385981],
              [84.456062, 20.39074],
              [84.453842, 20.396271],
              [84.454049000000154, 20.415229000000121],
              [84.451157000000109, 20.423589000000103],
              [84.458655, 20.435671],
              [84.448577, 20.46196],
              [84.443367, 20.461341],
              [84.433029, 20.47123],
              [84.422362, 20.47757],
              [84.420562000000174, 20.482290000000141],
              [84.426453, 20.491051000000137],
              [84.429070000000166, 20.496601000000108],
              [84.428436000000133, 20.502711000000144],
              [84.423759, 20.509070000000118],
              [84.416038000000171, 20.514570000000102],
              [84.400132, 20.518071],
              [84.391029000000159, 20.521580000000139],
              [84.38633800000018, 20.525569000000129],
              [84.384551, 20.530941000000148],
              [84.383637000000164, 20.538991],
              [84.37721300000014, 20.550651],
              [84.376686, 20.554332],
              [84.37902, 20.563279],
              [84.378306299124603, 20.564906255900432],
              [84.380439098601002, 20.565503439753737],
              [84.38353239790851, 20.56526549365304],
              [84.386863643316573, 20.56526549365304],
              [84.387101589417256, 20.568596739061256],
              [84.389005158221934, 20.57335566107292],
              [84.387101589417256, 20.575973068179277],
              [84.382342667405609, 20.57882842138633],
              [84.380201152500291, 20.575973068179277],
              [84.377442224388219, 20.577433868902514],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Cuttack",
          Dist_Code: "381",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [86.077421284965666, 20.594665701428536],
              [86.078078534144353, 20.595292477204733],
              [86.078221981784608, 20.599610775109561],
              [86.080601442790439, 20.603774831869764],
              [86.082683471170498, 20.606154292875594],
              [86.086252662679243, 20.607046590752983],
              [86.088483407372195, 20.607641456004441],
              [86.091027913970194, 20.607641456007453],
              [86.092350031506712, 20.607641456004441],
              [86.094559065788957, 20.606838170810871],
              [86.0956217903897, 20.606451725501525],
              [86.098447400334166, 20.604518413434274],
              [86.101570442904261, 20.604369697121225],
              [86.103503754971527, 20.606897874440104],
              [86.104693485474428, 20.608385037568773],
              [86.109154974860402, 20.606154292875594],
              [86.112426733743391, 20.604815846060031],
              [86.113913896872063, 20.604667129747153],
              [86.114954911062085, 20.608979902820234],
              [86.115995925252122, 20.613143959580437],
              [86.119118967822303, 20.61730801634064],
              [86.122836875643927, 20.619241328407664],
              [86.127000932404115, 20.621323356787965],
              [86.131164989164319, 20.625784846173698],
              [86.134436748047307, 20.628313023492574],
              [86.136667492740258, 20.629205321369788],
              [86.140279409297406, 20.632733239850829],
              [86.143062294193484, 20.635451406510068],
              [86.148118648830845, 20.637830867515898],
              [86.152970607584038, 20.640054436014104],
              [86.153656036502625, 20.641044253364889],
              [86.155032128568308, 20.643031446525121],
              [86.158826223357082, 20.644969250533386],
              [86.161800549614355, 20.644374385281932],
              [86.163287712743042, 20.641548775337519],
              [86.164180010620186, 20.639466746957218],
              [86.166343540845034, 20.638528928180612],
              [86.170426095760533, 20.639912895896025],
              [86.172210691514906, 20.641548775337519],
              [86.172508124140606, 20.645266683159146],
              [86.174441436207843, 20.648538442042135],
              [86.177861911403724, 20.649579456232171],
              [86.179795223470961, 20.649579456232171],
              [86.183513131292599, 20.652405066176634],
              [86.186338741237009, 20.652999931428095],
              [86.188272053304246, 20.65181020092518],
              [86.188866918555718, 20.648241009416431],
              [86.18856948592996, 20.643035938465967],
              [86.189015634868539, 20.639466746957218],
              [86.189135768879723, 20.637131007231172],
              [86.184851578108322, 20.63693856963874],
              [86.18143110291247, 20.637384718577316],
              [86.178676478346318, 20.636165386614429],
              [86.173549138330628, 20.63455910863291],
              [86.169087648944739, 20.634112959694271],
              [86.167946140639032, 20.634293197680446],
              [86.163436429055864, 20.635005257571486],
              [86.162097982240113, 20.634261676007153],
              [86.163882577994499, 20.632774512878537],
              [86.170690202115949, 20.631186243473959],
              [86.173903075119526, 20.629865507574998],
              [86.17712879923242, 20.629456631841773],
              [86.179398000023212, 20.629169000009817],
              [86.179961258881107, 20.628653656490311],
              [86.18184043585083, 20.626934337527921],
              [86.183364414979707, 20.621769505726544],
              [86.184851578108322, 20.620877207849382],
              [86.18752847173991, 20.620728491536504],
              [86.190354081684333, 20.623554101480917],
              [86.191986245365499, 20.626034990173078],
              [86.193237206633597, 20.626018189412996],
              [86.196303317719838, 20.625977010720018],
              [86.197770243258603, 20.625957309512948],
              [86.200297321112743, 20.625923370175197],
              [86.201782457720967, 20.626112470367442],
              [86.204482131406436, 20.623405385167867],
              [86.20507699665788, 20.618200314217795],
              [86.204928280345058, 20.614928555334807],
              [86.207605173976603, 20.611805512764644],
              [86.214297408055515, 20.605410711311489],
              [86.21786659956426, 20.603626115557116],
              [86.221287074760113, 20.603328682931355],
              [86.225219999991324, 20.603470000011551],
              [86.231743000046762, 20.604239999956572],
              [86.235407220599527, 20.604208007844868],
              [86.235754168122853, 20.604204978651463],
              [86.237517653502294, 20.604189581826457],
              [86.239875000231152, 20.604169000099372],
              [86.242016000463181, 20.603378636879537],
              [86.251179053645885, 20.59723131410373],
              [86.25474824515463, 20.592026243153665],
              [86.256235408283246, 20.587713470080413],
              [86.256830273534689, 20.583995562259016],
              [86.258614869289076, 20.582062250191765],
              [86.260250748730613, 20.580277654437392],
              [86.261589195546364, 20.576857179241525],
              [86.263225074987915, 20.574329001922816],
              [86.266050684932324, 20.573734136671359],
              [86.269768592753934, 20.573436704045431],
              [86.273189067949815, 20.573436704045431],
              [86.277055692084261, 20.571652108291058],
              [86.277782330829027, 20.569380613189534],
              [86.274767077842483, 20.560485616878449],
              [86.273108688699878, 20.555058161502867],
              [86.270093435713008, 20.552796721763226],
              [86.264515217688128, 20.551439857918805],
              [86.260746151454768, 20.552645959113359],
              [86.257429373169529, 20.551741383217571],
              [86.255620221377555, 20.549630706126713],
              [86.257278610520061, 20.549178418179164],
              [86.260746151454768, 20.549178418179164],
              [86.263459879142474, 20.548273842282693],
              [86.265118268285491, 20.547369266387072],
              [86.26722894537582, 20.547972316984268],
              [86.268590359456525, 20.546974098333575],
              [86.262355598356038, 20.538067296761536],
              [86.259238524961432, 20.534252915895472],
              [86.256374034624031, 20.531237662908776],
              [86.253660306936339, 20.530936137609835],
              [86.251097341897747, 20.52686554607828],
              [86.246272937119144, 20.52475486898771],
              [86.244765310625809, 20.520684277455242],
              [86.246272937119144, 20.515709110027554],
              [86.249288190105617, 20.511789281144893],
              [86.251851155144251, 20.512693857041025],
              [86.254866408130894, 20.513296907638612],
              [86.25863547436407, 20.510583179950849],
              [86.265872081531981, 20.507115639015975],
              [86.271902587505153, 20.506060300470889],
              [86.272807163401282, 20.503497335432254],
              [86.27115490238792, 20.500118133958775],
              [86.270740789847068, 20.499271191679096],
              [86.2705457236613, 20.497466829458737],
              [86.270394961011817, 20.495205389719096],
              [86.26722894537582, 20.490833272888544],
              [86.2675304706746, 20.487365731954011],
              [86.26722894537582, 20.484350478967311],
              [86.268435046570545, 20.480279887435241],
              [86.270244198362519, 20.47636005855275],
              [86.269616215594482, 20.475034317153806],
              [86.268116073333417, 20.476566451077694],
              [86.266402861408935, 20.47713752171898],
              [86.263357151321742, 20.476376094197231],
              [86.262405366919367, 20.473711097870869],
              [86.263737865082334, 20.471046101544115],
              [86.265831790767805, 20.470284674022704],
              [86.269641147765341, 20.470329552579582],
              [86.269791910414412, 20.467012774294513],
              [86.269119736070508, 20.465817797682966],
              [86.268435046570545, 20.464600571905006],
              [86.266324369479875, 20.463243708061324],
              [86.263007591194565, 20.461886844216789],
              [86.263158353843878, 20.46022845507451],
              [86.261349202052131, 20.459323879178893],
              [86.259992338208278, 20.457363964737507],
              [86.260896914103881, 20.452539559958719],
              [86.262404540597203, 20.450730408166741],
              [86.265872081531981, 20.449072019024296],
              [86.26798275862248, 20.445453715440291],
              [86.268736571869141, 20.44228769980429],
              [86.271751824855684, 20.439724734765715],
              [86.271148774258322, 20.437011007078009],
              [86.269339622466504, 20.437011007078009],
              [86.268435046570545, 20.435051092636566],
              [86.264967505636008, 20.435352617934988],
              [86.264665980337242, 20.433241940844475],
              [86.26798275862248, 20.431583551701859],
              [86.273560976647758, 20.431131263754306],
              [86.273108688699693, 20.429472874611289],
              [86.269038097167908, 20.427211434870966],
              [86.267831995973182, 20.423894656586576],
              [86.268440733591362, 20.422947731403493],
              [86.268856691528285, 20.422300685723368],
              [86.269188859817049, 20.421783979495498],
              [86.271355703597735, 20.418930468949775],
              [86.268902762936463, 20.414637822792479],
              [86.268849118457737, 20.413768782238318],
              [86.270394961011817, 20.41273822053585],
              [86.273410213998289, 20.411532119341128],
              [86.277028517582366, 20.411532119341128],
              [86.27748080553026, 20.409421442250558],
              [86.275370128439519, 20.405501613368298],
              [86.2737117392969, 20.401581784484957],
              [86.274616315193015, 20.398265006200571],
              [86.274314789894262, 20.395400515862999],
              [86.27099801160918, 20.395551278512126],
              [86.267745820088621, 20.395895348655525],
              [86.267463111506956, 20.39131546963176],
              [86.267415599807848, 20.390545780108649],
              [86.267444388506746, 20.390540296546927],
              [86.267379708025302, 20.387862383396335],
              [86.268887334518453, 20.385450181007052],
              [86.271751824855684, 20.386203994254057],
              [86.273862501946354, 20.385600943656865],
              [86.273661684948109, 20.383407397091155],
              [86.273108688699693, 20.382585690669824],
              [86.2705457236613, 20.381228826825968],
              [86.272204112803919, 20.380022725631413],
              [86.27129953690779, 20.378515099137751],
              [86.266324369479875, 20.378515099137751],
              [86.263459879142474, 20.377007472644376],
              [86.261650727350727, 20.374595270255266],
              [86.261499964701244, 20.370976966671602],
              [86.261325066279127, 20.37023364837739],
              [86.260896914103881, 20.368414001632964],
              [86.25818318641619, 20.36811247633403],
              [86.258006195101046, 20.370556962944697],
              [86.254328564275937, 20.370915226810546],
              [86.25150122283496, 20.368730462969602],
              [86.247785046509733, 20.365858872172961],
              [86.250461940141278, 20.360207652284142],
              [86.249825353701709, 20.357434989397625],
              [86.246408500217143, 20.356401847619107],
              [86.231016491403665, 20.352892804831917],
              [86.223579000000299, 20.354230000000591],
              [86.219655676577162, 20.354574907554301],
              [86.208515819434496, 20.355554235654491],
              [86.207411033631018, 20.355651359681186],
              [86.203559000000467, 20.355990000000528],
              [86.201339000000274, 20.356190000000193],
              [86.196577999999803, 20.35601000000042],
              [86.194151906221848, 20.355836424038269],
              [86.189779789391352, 20.355987186687567],
              [86.187066061703405, 20.358700914376012],
              [86.185128292896351, 20.361964524997738],
              [86.184201571366231, 20.363525319154231],
              [86.182241656924631, 20.366239046841994],
              [86.174854287107777, 20.367143622738293],
              [86.169426831731627, 20.366842097439356],
              [86.162190224563901, 20.367143622738293],
              [86.159325734226726, 20.365635996244404],
              [86.154953617396387, 20.364279132400721],
              [86.151033788513558, 20.363223793855635],
              [86.150129212617784, 20.358550151726142],
              [86.145950760445416, 20.348133882820601],
              [86.143202148917311, 20.347509198382394],
              [86.140954037898922, 20.346998264060172],
              [86.132863724913165, 20.345159556562972],
              [86.098956405580097, 20.345754421814771],
              [86.094203854294932, 20.347021768823989],
              [86.092419142238597, 20.347497692039493],
              [86.082503250102249, 20.350141929942076],
              [86.078864802062284, 20.354031305432951],
              [86.075248021333707, 20.357267372400766],
              [86.072583025007162, 20.358409513683448],
              [86.068966244278528, 20.358599870564085],
              [86.066110891071531, 20.362787721934122],
              [86.065920534191022, 20.366214145783143],
              [86.063636251625425, 20.367165930185021],
              [86.056593047047997, 20.370401997153007],
              [86.044981277339588, 20.376303060447011],
              [86.036795931479659, 20.380871625578376],
              [86.030514154424324, 20.382965551263677],
              [86.026135946173426, 20.382013766861796],
              [86.02289987920544, 20.38334626502461],
              [86.021757737922528, 20.389056971438542],
              [86.018521670954698, 20.383536621905129],
              [86.015285603986712, 20.380110198056794],
              [86.011859180138615, 20.376874131089206],
              [86.006338830605031, 20.363549149456045],
              [86.007700785857054, 20.362218147732502],
              [86.014714533345312, 20.355363803596273],
              [86.016072729273475, 20.352658208953184],
              [86.021272000000337, 20.342301000000127],
              [86.024811059682605, 20.339032922712075],
              [86.028442000000254, 20.335680000000703],
              [86.030251000000334, 20.332861000000484],
              [86.025162000000293, 20.325360000000153],
              [86.02552, 20.318081000000458],
              [86.028946000000232, 20.304319],
              [86.027291, 20.297541000000191],
              [86.02514600000022, 20.29280099999988],
              [86.027154, 20.289592000000308],
              [86.037018000000202, 20.286132000000347],
              [86.039017, 20.280771000000524],
              [86.041351000000219, 20.27679],
              [86.042007000000154, 20.276901],
              [86.042586, 20.27699000000035],
              [86.045326000000301, 20.26978100000019],
              [86.047288000000307, 20.267361000000161],
              [86.049813000000299, 20.267878000000106],
              [86.053597000000238, 20.265490000000391],
              [86.059434000000209, 20.266171000000266],
              [86.063896000000256, 20.264271000000289],
              [86.066674, 20.25955],
              [86.069398000000177, 20.252150000000309],
              [86.070929, 20.243339000000272],
              [86.072112, 20.241160000000484],
              [86.07372400000024, 20.238202000000339],
              [86.080857000000123, 20.235850000000248],
              [86.089386, 20.234332000000219],
              [86.095398000000145, 20.228370000000208],
              [86.121262000000328, 20.218610000000407],
              [86.123947000000257, 20.214749000000491],
              [86.134376, 20.213359],
              [86.145927000000228, 20.214599],
              [86.147538000000324, 20.210451000000315],
              [86.150193, 20.203661000000178],
              [86.146079000000199, 20.195792000000317],
              [86.139443000000227, 20.192542000000167],
              [86.13672600000028, 20.189832000000472],
              [86.137437000000347, 20.187509000000656],
              [86.142663000000354, 20.186060000000335],
              [86.145371, 20.184271000000248],
              [86.147141000000346, 20.18198],
              [86.148163000000338, 20.17453],
              [86.147301000000226, 20.169919000000444],
              [86.139832, 20.160410000000407],
              [86.142472000000211, 20.158849000000423],
              [86.141633000000226, 20.15531000000049],
              [86.147233000000298, 20.15407],
              [86.141578000000138, 20.14195200000017],
              [86.14129600000021, 20.138442000000332],
              [86.1530920000001, 20.129451000000181],
              [86.154968000000252, 20.127219000000245],
              [86.154975000000292, 20.122531000000315],
              [86.153541000000345, 20.118021],
              [86.156067000000277, 20.113761000000519],
              [86.159638000000299, 20.110171000000484],
              [86.161537, 20.104220000000506],
              [86.156905000000322, 20.097709000000343],
              [86.15191600000017, 20.086309000000533],
              [86.153320000000335, 20.083391000000173],
              [86.15741800000032, 20.081151],
              [86.162697000000136, 20.07623],
              [86.165147000000317, 20.069240000000256],
              [86.16529900000026, 20.065892000000755],
              [86.183937999999884, 20.045651],
              [86.17745200000023, 20.042921000000256],
              [86.171806, 20.043969000000114],
              [86.165917, 20.041351],
              [86.164597000000271, 20.039842000000245],
              [86.165206, 20.033241000000142],
              [86.155137000000238, 20.037982],
              [86.148133000000172, 20.034629],
              [86.142114, 20.037492000000491],
              [86.129098, 20.031641],
              [86.123254000000117, 20.032421000000166],
              [86.116592000000111, 20.034370000000305],
              [86.114181000000286, 20.038080000000146],
              [86.114577000000153, 20.04089],
              [86.116706000000292, 20.043372000000655],
              [86.123771, 20.04845000000034],
              [86.122803000000303, 20.052411000000173],
              [86.119156000000288, 20.054070000000134],
              [86.111947, 20.05913],
              [86.097940000000136, 20.059741000000365],
              [86.091316, 20.057471000000298],
              [86.084641, 20.052181000000637],
              [86.083428000000239, 20.055112000000516],
              [86.080178, 20.059251000000128],
              [86.076393000000266, 20.060968999999826],
              [86.071686000000327, 20.070530000000414],
              [86.071686000000327, 20.074592000000617],
              [86.076867, 20.07685000000037],
              [86.083802, 20.077922000000282],
              [86.086227000000335, 20.08399100000042],
              [86.079558000000119, 20.096702000000384],
              [86.077049000000144, 20.098671000000358],
              [86.072479, 20.104371000000178],
              [86.069047000000111, 20.10593],
              [86.067679, 20.107990000000139],
              [86.067299000000261, 20.111270000000271],
              [86.065011000000126, 20.114880000000365],
              [86.061959000000215, 20.117581000000197],
              [86.059541000000337, 20.117852],
              [86.057717, 20.119139999999899],
              [86.053649, 20.117549],
              [86.047181000000123, 20.12634200000036],
              [86.03826, 20.126570000000179],
              [86.034126000000327, 20.127591000000105],
              [86.034509, 20.130390000000258],
              [86.030616000000151, 20.135761],
              [86.039170000000226, 20.134652000000298],
              [86.043197000000163, 20.135481000000137],
              [86.045250000000223, 20.138759000000672],
              [86.043236, 20.149869000000646],
              [86.049790000000186, 20.154991000000219],
              [86.049187000000231, 20.157591000000419],
              [86.043252000000322, 20.161860000000498],
              [86.043808000000283, 20.164599000000287],
              [86.040756000000201, 20.166621],
              [86.040038000000138, 20.169381000000154],
              [86.037262, 20.172599000000329],
              [86.031747000000308, 20.170379000000136],
              [86.033622, 20.169531000000685],
              [86.033759, 20.167631000000309],
              [86.03189900000028, 20.1648],
              [86.029137, 20.162571000000181],
              [86.026222000000217, 20.162402000000206],
              [86.02214, 20.163290999999898],
              [86.020447, 20.168212],
              [86.025224, 20.175120000000383],
              [86.024727000000183, 20.177481000000505],
              [86.022979000000177, 20.178101000000478],
              [86.019341, 20.176971000000432],
              [86.015961000000317, 20.178880000000273],
              [86.009666000000124, 20.201120000000454],
              [86.006058000000195, 20.201259000000388],
              [86.002097, 20.216721000000401],
              [85.994148000000322, 20.218221000000362],
              [85.988441, 20.22127],
              [85.976708, 20.231870000000296],
              [85.970208000000156, 20.233210000000323],
              [85.967217000000261, 20.23662000000035],
              [85.955177, 20.244791000000358],
              [85.948319, 20.253080000000519],
              [85.945976000000115, 20.26092000000045],
              [85.940057000000181, 20.261342000000237],
              [85.936866000000265, 20.263249000000425],
              [85.932976, 20.260330000000121],
              [85.928306, 20.265360000000324],
              [85.933532000000113, 20.273230000000463],
              [85.931731, 20.279760000000348],
              [85.924974000000233, 20.281530000000252],
              [85.9215, 20.284901000000666],
              [85.916329000000118, 20.299330000000108],
              [85.910446000000235, 20.302560000000533],
              [85.908653000000228, 20.30990100000059],
              [85.910842999999858, 20.313302],
              [85.911912, 20.317160000000282],
              [85.915169000000247, 20.316321000000464],
              [85.916062, 20.309201],
              [85.923499000000248, 20.302959000000154],
              [85.926011, 20.304390000000236],
              [85.92633000000032, 20.308032000000303],
              [85.92495800000016, 20.315891],
              [85.92321000000031, 20.321219000000209],
              [85.917184000000162, 20.324390000000218],
              [85.913826000000299, 20.327421000000523],
              [85.913118, 20.33408000000065],
              [85.910859000000329, 20.338541],
              [85.903869, 20.341720000000404],
              [85.896104, 20.3439900000003],
              [85.895087, 20.347509000000283],
              [85.894691000000165, 20.360471],
              [85.893433000000172, 20.36086900000026],
              [85.889802000000131, 20.355060000000318],
              [85.888649000000314, 20.34982],
              [85.884407000000337, 20.349572000000304],
              [85.879838000000106, 20.350410000000348],
              [85.87525246752692, 20.355658768003703],
              [85.871921222118701, 20.359465905612915],
              [85.874065509964993, 20.367238949055771],
              [85.871454187091473, 20.369034233531174],
              [85.867290130331284, 20.371711127162936],
              [85.862531208319609, 20.373793155543009],
              [85.859556882062336, 20.377064914426054],
              [85.860449179939536, 20.381228971186257],
              [85.864734881819501, 20.390934868942676],
              [85.862403378095379, 20.394681928499036],
              [85.852409641871006, 20.397537281706203],
              [85.839084660238242, 20.407531017930577],
              [85.825043000000321, 20.39688200000068],
              [85.817437000000197, 20.400752000000804],
              [85.810951, 20.419402000000268],
              [85.804863000000225, 20.420489000000483],
              [85.801659, 20.426750000000531],
              [85.796150000000338, 20.427021000000419],
              [85.793007000000145, 20.421971000000209],
              [85.790031000000141, 20.419500000000703],
              [85.788886000000247, 20.419450000000317],
              [85.781486000000129, 20.425911000000607],
              [85.776864000000145, 20.414860000000484],
              [85.778747000000337, 20.409299000000484],
              [85.782760000000152, 20.409629000000219],
              [85.78147, 20.402580000000338],
              [85.770257, 20.399250000000333],
              [85.76774500000019, 20.396210000000334],
              [85.761933000000198, 20.405210000000178],
              [85.754066000000108, 20.397349],
              [85.741043000000147, 20.399460000000143],
              [85.736428000000203, 20.397819000000592],
              [85.731147, 20.401030000000159],
              [85.726769, 20.402051000000309],
              [85.709878, 20.392401],
              [85.708604, 20.389700000000285],
              [85.708732000000325, 20.384499000000172],
              [85.702888000000286, 20.380092000000612],
              [85.699898000000175, 20.369031],
              [85.695877000000209, 20.359290000000207],
              [85.695848, 20.354682000000132],
              [85.68739400000031, 20.339491000000173],
              [85.678321000000295, 20.333130000000548],
              [85.67553800000023, 20.328189000000119],
              [85.672988000000288, 20.31723100000044],
              [85.669503, 20.320150000000233],
              [85.663017000000238, 20.3237100000004],
              [85.657098, 20.324271000000287],
              [85.65274, 20.322281000000654],
              [85.645859000000243, 20.31672],
              [85.641693000000132, 20.31819000000041],
              [85.637994000000148, 20.315900000000109],
              [85.634033000000144, 20.312130000000302],
              [85.627968000000337, 20.302811000000528],
              [85.627373000000134, 20.297370000000111],
              [85.628433, 20.290911],
              [85.620698000000104, 20.284940000000514],
              [85.613067, 20.289610000000547],
              [85.60344, 20.28904000000011],
              [85.600632, 20.29136],
              [85.596710000000229, 20.290930000000166],
              [85.590896, 20.291429000000388],
              [85.578584000000234, 20.293810000000402],
              [85.56800900000033, 20.292600000000331],
              [85.561126000000158, 20.293801000000197],
              [85.553107999999824, 20.302920000000139],
              [85.547027, 20.306120000000188],
              [85.543777000000134, 20.300550000000666],
              [85.546669000000165, 20.298572000000259],
              [85.543939000000236, 20.297201999999682],
              [85.544518000000195, 20.295460000000158],
              [85.528869000000142, 20.29544],
              [85.523757000000316, 20.298070000000273],
              [85.519096000000303, 20.296650000000223],
              [85.515976000000293, 20.292561000000486],
              [85.516876000000124, 20.286319000000557],
              [85.513526000000212, 20.287101000000401],
              [85.504441000000128, 20.283851000000645],
              [85.496047000000118, 20.287021000000543],
              [85.487512000000237, 20.289090000000495],
              [85.478318000000328, 20.290180000000472],
              [85.467018, 20.288400000000248],
              [85.455337000000128, 20.287531000000108],
              [85.45294900000026, 20.279409000000268],
              [85.450433000000245, 20.274570000000264],
              [85.449227000000107, 20.268569000000632],
              [85.450469000000211, 20.262791000000384],
              [85.448502000000346, 20.259509000000428],
              [85.444131000000354, 20.256362000000305],
              [85.440985000000111, 20.256900000000194],
              [85.431420000000273, 20.261390000000116],
              [85.424943000000255, 20.265930000000193],
              [85.415749, 20.265230000000198],
              [85.402099000000163, 20.24908000000033],
              [85.397338, 20.250190000000309],
              [85.392517000000154, 20.252519],
              [85.389992000000163, 20.26368],
              [85.38949500000021, 20.270269000000606],
              [85.385040000000203, 20.271851000000364],
              [85.380158000000208, 20.27493],
              [85.376677000000342, 20.278650000000706],
              [85.373450000000304, 20.274919000000232],
              [85.365067000000167, 20.268840000000292],
              [85.355714, 20.267901000000219],
              [85.348747000000103, 20.265911000000241],
              [85.343552000000301, 20.265230000000198],
              [85.337326000000274, 20.266260000000493],
              [85.330803000000216, 20.265200000000554],
              [85.328797000000336, 20.273410000000236],
              [85.329613000000208, 20.275181000000369],
              [85.339409000000146, 20.277221000000278],
              [85.340378, 20.279760000000348],
              [85.343299000000329, 20.282570000000359],
              [85.345672000000192, 20.286371],
              [85.347397000000271, 20.291561000000677],
              [85.349900000000261, 20.294888000000466],
              [85.348792000000259, 20.299811],
              [85.348412, 20.307720000000241],
              [85.346016000000233, 20.309869000000273],
              [85.344687, 20.313051],
              [85.347008, 20.316909000000461],
              [85.347602000000194, 20.321240000000667],
              [85.350502000000333, 20.323300000000241],
              [85.348396, 20.326320000000173],
              [85.348710000000196, 20.32869],
              [85.353020000000114, 20.329121000000494],
              [85.35276, 20.334721],
              [85.354950000000116, 20.338409000000521],
              [85.361977000000124, 20.34195],
              [85.365852000000118, 20.341590000000448],
              [85.36781400000028, 20.343710000000382],
              [85.368798000000183, 20.348630000000522],
              [85.366569000000126, 20.348861000000618],
              [85.365120000000303, 20.359491000000101],
              [85.356017000000108, 20.35764200000062],
              [85.348327000000126, 20.354271000000207],
              [85.342506, 20.354050000000253],
              [85.335778000000104, 20.350629000000705],
              [85.271890000000255, 20.350989000000304],
              [85.264412000000206, 20.351550000000142],
              [85.249894000000182, 20.359001],
              [85.240342000000155, 20.359898000000381],
              [85.228866000000238, 20.36215000000038],
              [85.219399000000323, 20.364901000000479],
              [85.205758000000159, 20.366921000000612],
              [85.201653000000178, 20.369480000000234],
              [85.195732000000163, 20.37141000000025],
              [85.187812000000335, 20.370861000000101],
              [85.179284000000322, 20.36893100000048],
              [85.166817000000137, 20.371420000000168],
              [85.154090000000323, 20.371570000000695],
              [85.142403, 20.37884000000042],
              [85.130791000000258, 20.381370000000285],
              [85.127372000000136, 20.385249000000435],
              [85.115281, 20.395280000000124],
              [85.111671000000101, 20.39961900000014],
              [85.097419000000201, 20.40418],
              [85.087211000000238, 20.4056110000007],
              [85.076278000000144, 20.408702000000456],
              [85.070068000000262, 20.409192],
              [85.066697000000246, 20.413130000000361],
              [85.045761, 20.421631000000666],
              [85.035133, 20.427801000000439],
              [85.030137000000352, 20.433660000000138],
              [85.02237, 20.438039000000398],
              [85.007767000000101, 20.442962],
              [84.993477, 20.454100000000604],
              [84.939056000000321, 20.485989000000298],
              [84.926261000000167, 20.490880000000338],
              [84.887862, 20.490231],
              [84.878342, 20.49290000000013],
              [84.858163000000317, 20.50765],
              [84.845039000000313, 20.52208],
              [84.854637, 20.525111000000432],
              [84.861634, 20.530560000000257],
              [84.869798000000216, 20.540759000000712],
              [84.875001000000154, 20.551840000000592],
              [84.884377000000171, 20.558019000000623],
              [84.889068000000321, 20.562691000000306],
              [84.891290000000183, 20.569160000000689],
              [84.891602, 20.574199000000355],
              [84.904830000000317, 20.574992],
              [84.91999800000012, 20.573640000000289],
              [84.9376, 20.575161000000545],
              [84.944763000000165, 20.574609000000347],
              [84.951812000000231, 20.569839000000169],
              [84.960106000000266, 20.567421000000472],
              [84.970581000000138, 20.567899000000406],
              [84.974426, 20.56689],
              [84.97779, 20.561620000000513],
              [84.97995700000034, 20.560911000000427],
              [84.983223000000223, 20.564599000000207],
              [84.985238000000138, 20.570621],
              [84.985931000000264, 20.57645100000013],
              [84.993552, 20.575202000000214],
              [85.003448000000148, 20.57831900000053],
              [85.020690000000158, 20.581239000000544],
              [85.043427, 20.576271000000357],
              [85.051438000000104, 20.570131000000341],
              [85.060782000000401, 20.570842],
              [85.061997000000346, 20.574591000000108],
              [85.064377000000121, 20.576312000000193],
              [85.067016000000351, 20.573882000000193],
              [85.071023, 20.575010000000301],
              [85.075378000000313, 20.583949000000413],
              [85.082122000000183, 20.590330000000275],
              [85.083314000000229, 20.600320000000458],
              [85.086853000000289, 20.604691000000454],
              [85.082698524410802, 20.610072881879315],
              [85.08484003931612, 20.611143639331768],
              [85.094833775540422, 20.606860609521156],
              [85.101311230350333, 20.603733139535386],
              [85.109625753416054, 20.603182300827083],
              [85.112539256883551, 20.602989280677487],
              [85.113585, 20.602920000000321],
              [85.116799000000398, 20.603780000000423],
              [85.123208000000247, 20.609110999999697],
              [85.132621000000128, 20.603531000000256],
              [85.14012800000026, 20.603112000000234],
              [85.144538000000267, 20.60129100000017],
              [85.150238000000272, 20.602832000000316],
              [85.154213000000354, 20.602120000000177],
              [85.158250000000265, 20.597651000000265],
              [85.162361000000232, 20.594882000000148],
              [85.168351, 20.59415],
              [85.17318, 20.592001000000486],
              [85.1892, 20.576232000000342],
              [85.194442, 20.572740000000401],
              [85.203133, 20.568729000000356],
              [85.202873, 20.567510000000421],
              [85.194328, 20.561139000000136],
              [85.195703, 20.557502000000106],
              [85.198677000000117, 20.553511000000125],
              [85.2064120000001, 20.547640000000168],
              [85.206802000000252, 20.54145900000054],
              [85.212593000000126, 20.538489000000478],
              [85.219834000000262, 20.532801],
              [85.23407, 20.519000000000513],
              [85.240700000000274, 20.514121000000213],
              [85.246179, 20.511730000000281],
              [85.27163, 20.507810000000287],
              [85.276642000000138, 20.502360000000234],
              [85.282150000000257, 20.50487000000043],
              [85.286843, 20.509011000000381],
              [85.294136000000236, 20.50551000000041],
              [85.300880000000106, 20.49895099999986],
              [85.306077000000229, 20.498069],
              [85.314101000000321, 20.495309000000354],
              [85.329171, 20.497030000000276],
              [85.336220000000296, 20.491979000000182],
              [85.340735, 20.490060000000362],
              [85.364509000000211, 20.488200000000287],
              [85.372810000000285, 20.488329999999674],
              [85.380066000000255, 20.492100000000217],
              [85.383606000000256, 20.48753000000027],
              [85.389197372229987, 20.485741513933473],
              [85.391328, 20.485060000000711],
              [85.394172000000282, 20.481000000000158],
              [85.396311484979194, 20.484675286872172],
              [85.400237595639027, 20.501093567811946],
              [85.405591382901989, 20.500736648661185],
              [85.418797391484517, 20.496810538001281],
              [85.426292693652755, 20.496453618851088],
              [85.423080421294955, 20.493598265643691],
              [85.431289561765112, 20.49324134649293],
              [85.44167400000012, 20.487341000000466],
              [85.452087000000148, 20.478559000000526],
              [85.456726373023841, 20.485322377545113],
              [85.456971000000109, 20.485679000000456],
              [85.463494000000168, 20.491489000000623],
              [85.4772880000002, 20.500760000000351],
              [85.481103000000402, 20.510210000000477],
              [85.479507, 20.514030000000158],
              [85.484772000000177, 20.513891],
              [85.487259000000265, 20.515609000000261],
              [85.493989, 20.517362000000499],
              [85.497802000000249, 20.525760000000268],
              [85.505752000000243, 20.52890100000047],
              [85.508462000000264, 20.526572000000495],
              [85.513236000000219, 20.526832000000521],
              [85.521020000000163, 20.52419],
              [85.526932000000315, 20.52166900000071],
              [85.532798000000341, 20.521111],
              [85.545418, 20.516940000000258],
              [85.55224600000011, 20.517022000000278],
              [85.555672000000229, 20.513590000000356],
              [85.560332000000329, 20.514030000000158],
              [85.565376000000228, 20.508989999999866],
              [85.568809, 20.507101000000429],
              [85.571778, 20.507441000000135],
              [85.583625000000254, 20.505519],
              [85.58547100000024, 20.510989000000105],
              [85.587479000000116, 20.511390000000571],
              [85.588646, 20.512760000000238],
              [85.586807000000121, 20.51785200000074],
              [85.589043000000203, 20.523732000000162],
              [85.592758000000273, 20.527340000000262],
              [85.593856000000329, 20.529530000000133],
              [85.595306, 20.529801000000358],
              [85.598075, 20.528528999999875],
              [85.606086000000275, 20.53198000000048],
              [85.609277000000162, 20.53515],
              [85.623841000000283, 20.533560000000474],
              [85.629402, 20.533689000000145],
              [85.635781, 20.536310000000295],
              [85.639259000000195, 20.53998900000061],
              [85.64306700000013, 20.539150000000113],
              [85.643172000000305, 20.542270000000478],
              [85.644569, 20.543590000000446],
              [85.646714, 20.541388000000318],
              [85.650176000000201, 20.543029000000214],
              [85.652970000000252, 20.54330100000038],
              [85.655297, 20.547681],
              [85.655778000000254, 20.553039000000123],
              [85.659279000000168, 20.559722000000303],
              [85.670098, 20.566691000000329],
              [85.678756, 20.581590000000112],
              [85.683290000000198, 20.586759000000196],
              [85.687736, 20.59041000000013],
              [85.701705000000274, 20.596220000000354],
              [85.704857000000331, 20.598440000000547],
              [85.705803000000103, 20.602471],
              [85.709924000000328, 20.607130000000318],
              [85.709381000000164, 20.609731],
              [85.706596000000147, 20.609229000000251],
              [85.701393, 20.616541000000208],
              [85.703056000000316, 20.620281],
              [85.706589000000108, 20.614430000000532],
              [85.712273000000181, 20.621600000000281],
              [85.713700000000117, 20.624830000000195],
              [85.713356, 20.629500000000231],
              [85.722313, 20.634532000000771],
              [85.723870000000289, 20.638789000000539],
              [85.727432000000164, 20.637490000000351],
              [85.732697000000229, 20.637979999999853],
              [85.737847000000187, 20.631710000000332],
              [85.745599000000183, 20.631362000000646],
              [85.751762, 20.62842900000043],
              [85.750344000000197, 20.634270000000182],
              [85.749154000000132, 20.636301],
              [85.74952800000014, 20.638261000000394],
              [85.752983000000228, 20.639339000000401],
              [85.756707000000318, 20.635669],
              [85.759324000000319, 20.643102000000507],
              [85.758300000000332, 20.645470000000323],
              [85.759506, 20.651131000000127],
              [85.761359000000297, 20.653829],
              [85.767722, 20.653841000000394],
              [85.777046000000254, 20.655281000000169],
              [85.778892000000255, 20.656701000000218],
              [85.782952, 20.663999],
              [85.786293000000271, 20.666112000000336],
              [85.791526, 20.66354100000023],
              [85.794609000000179, 20.659309000000174],
              [85.800316, 20.656489000000242],
              [85.803566000000188, 20.653750000000453],
              [85.807847, 20.653841000000394],
              [85.812920000000176, 20.655190000000452],
              [85.819992, 20.655019000000319],
              [85.826996000000264, 20.660642000000333],
              [85.839303000000172, 20.661519000000222],
              [85.860572000000147, 20.661109000000405],
              [85.868927, 20.656141000000272],
              [85.873916000000207, 20.651480000000216],
              [85.878586000000254, 20.651439000000774],
              [85.881759, 20.652911000000355],
              [85.888252000000122, 20.660512000000431],
              [85.89073900000021, 20.665271000000185],
              [85.894408, 20.669430000000197],
              [85.900384000000301, 20.672131000000601],
              [85.902342733248062, 20.674133239861984],
              [85.904571000000175, 20.676411000000311],
              [85.906647000000348, 20.686701000000308],
              [85.906342000000151, 20.691490000000435],
              [85.921704226058509, 20.682429481439605],
              [85.930270285679612, 20.679217209081962],
              [85.941334779356609, 20.669937311158996],
              [85.952399273033777, 20.666011200499835],
              [85.961296000000331, 20.660441000000215],
              [85.96279100000018, 20.65977100000077],
              [85.966477000000154, 20.660991000000244],
              [85.972024000000289, 20.660311000000142],
              [85.975876000000184, 20.657962000000449],
              [85.978097451896744, 20.634602315222814],
              [85.983451239159862, 20.631746962015988],
              [86.00950633717369, 20.603550349096615],
              [86.029850728773383, 20.58677514900517],
              [86.035204516036501, 20.581064442591295],
              [86.038416788394429, 20.571070706366974],
              [86.043056737355684, 20.568572272310686],
              [86.049838201222229, 20.577852170233651],
              [86.054262041468334, 20.584814484603665],
              [86.061318000000298, 20.587650000000387],
              [86.069398000000177, 20.593300000000333],
              [86.074218000000229, 20.590811],
              [86.075399720217931, 20.591128295604612],
              [86.077231000008325, 20.59161999998798],
              [86.077294842780049, 20.5926418677148],
              [86.077421284965666, 20.594665701428536],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Debagarh",
          Dist_Code: "373",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [84.543791723788999, 21.35520860209089],
              [84.529529087779025, 21.358268742031893],
              [84.520011243755931, 21.356365173227228],
              [84.510969291933449, 21.352082143416734],
              [84.500499663507952, 21.34684732920368],
              [84.493361280490419, 21.347323221404846],
              [84.486222897472871, 21.35493749662373],
              [84.483843436467325, 21.363503556244719],
              [84.486585712111818, 21.373977083895166],
              [84.486835766959047, 21.381228674463951],
              [84.485458000808975, 21.382712745186605],
              [84.480102, 21.388482],
              [84.475890000000135, 21.391362],
              [84.468931058943596, 21.391837564438212],
              [84.465390304806519, 21.392079534694396],
              [84.464446242559774, 21.392144050606472],
              [84.456831967341344, 21.391192266204136],
              [84.454813702098846, 21.391293179466395],
              [84.447314123317909, 21.391668158405306],
              [84.43969984809921, 21.389288697399476],
              [84.432561465081946, 21.388336912997143],
              [84.429414594079944, 21.38692624668624],
              [84.427813783128883, 21.384764900259363],
              [84.426516430461319, 21.38301327021804],
              [84.419378047443772, 21.378373321256497],
              [84.413442232929043, 21.377384018837571],
              [84.408670472917763, 21.376588725502412],
              [84.400236957495778, 21.379272116773105],
              [84.379947046408958, 21.373114485809534],
              [84.362814927166866, 21.369783240401823],
              [84.350917622137601, 21.371686809206491],
              [84.350333424230811, 21.392356085126945],
              [84.358423591650691, 21.407584635564032],
              [84.36984500447879, 21.418054263989685],
              [84.379362848501884, 21.435186383231663],
              [84.379362848501884, 21.444664569571383],
              [84.379362848501884, 21.446092246174882],
              [84.379362848501884, 21.453746179077363],
              [84.383645878312436, 21.468022945112576],
              [84.390375699299327, 21.479127149740403],
              [84.393163722335814, 21.483727387750598],
              [84.401729781956845, 21.489438094164594],
              [84.412873591000945, 21.508097034218732],
              [84.422094002398453, 21.51077392785032],
              [84.428934952790115, 21.51315338885615],
              [84.430719548544502, 21.518804608744855],
              [84.429827250667444, 21.523860963382496],
              [84.431016981170373, 21.528322452768403],
              [84.433693874801833, 21.53129677902529],
              [84.439939959942052, 21.531891644277032],
              [84.44529374720517, 21.533676240031124],
              [84.44678091033397, 21.535758268411197],
              [84.448565506088386, 21.538137729417478],
              [84.461949974246096, 21.536650566288696],
              [84.469683222515116, 21.533973672657108],
              [84.474739577152405, 21.531891644277032],
              [84.478011336035351, 21.53129677902529],
              [84.480390797041167, 21.535460835785891],
              [84.476524172906778, 21.539327459920056],
              [84.47265754877246, 21.543194084054672],
              [84.471765250895132, 21.546763275563301],
              [84.478011336035351, 21.54854787131762],
              [84.483067690672868, 21.552117062826703],
              [84.48871891056163, 21.553901658581022],
              [84.495961529018686, 21.555303455701729],
              [84.497939321959194, 21.555686254335107],
              [84.502698243970869, 21.558363147966695],
              [84.502400811345282, 21.567286126738502],
              [84.501581821308861, 21.570459713129818],
              [84.500021350339438, 21.57650653813652],
              [84.497344456707694, 21.583347488528258],
              [84.500318782965039, 21.583942353779314],
              [84.503887974473784, 21.583347488528258],
              [84.503887974473784, 21.588106410539236],
              [84.508349463859901, 21.589593573668019],
              [84.521436499391811, 21.581562892773483],
              [84.526195421403457, 21.580075729645156],
              [84.529764612912274, 21.584537219031056],
              [84.536308130678364, 21.58364492115356],
              [84.548404104546734, 21.577696990884075],
              [84.561155282230786, 21.573414471057951],
              [84.574974372023107, 21.568773289867291],
              [84.577056400403052, 21.572045048750166],
              [84.57110774788849, 21.587214112662874],
              [84.562779634368027, 21.59167560204855],
              [84.554451520847792, 21.60000371556907],
              [84.550287464087589, 21.608331829089135],
              [84.546718272578772, 21.61903940361594],
              [84.5449336768244, 21.621716297247069],
              [84.535118400175435, 21.61903940361594],
              [84.520951, 21.621389000000132],
              [84.511627379139142, 21.625003934675526],
              [84.510134059614003, 21.625582921381689],
              [84.504482839725242, 21.632721304399176],
              [84.499723917713567, 21.646105772556663],
              [84.497641889333565, 21.65978767334013],
              [84.495137814544563, 21.668551935102183],
              [84.494072697824819, 21.672279843621023],
              [84.491395804193104, 21.677336198257986],
              [84.498692884453234, 21.68178507826428],
              [84.502201080361985, 21.683923953277137],
              [84.505617430564797, 21.680839320819356],
              [84.528148562312637, 21.679620480823811],
              [84.537666406335774, 21.682475834030804],
              [84.546232465956834, 21.687234756042468],
              [84.554351294956788, 21.684821050123666],
              [84.563840477400092, 21.681999941829638],
              [84.575737782429073, 21.684855295036638],
              [84.58811097965949, 21.689138324847132],
              [84.590876700759537, 21.691904045947691],
              [84.594773470475886, 21.695800815663457],
              [84.59049044066505, 21.706746336290276],
              [84.586207410854783, 21.717691856917323],
              [84.590966332866216, 21.726257916538312],
              [84.59858060808493, 21.730065054147641],
              [84.600484176889637, 21.740534682573294],
              [84.603339530096648, 21.752907879803381],
              [84.610012488968081, 21.760601424369263],
              [84.611380333100982, 21.760420791271368],
              [84.613128000000273, 21.760190000000641],
              [84.624470968967884, 21.757458084444799],
              [84.627822000000307, 21.756651000000595],
              [84.632866000000362, 21.762319000000154],
              [84.639382000000225, 21.763550000000347],
              [84.6481330000003, 21.76288900000031],
              [84.652798189677739, 21.761332635330056],
              [84.657692, 21.75970000000029],
              [84.66507700000038, 21.755461000000192],
              [84.666546426257156, 21.754135778914808],
              [84.671089, 21.750039000000466],
              [84.674378, 21.743152000000229],
              [84.671852, 21.73241],
              [84.678437, 21.724460000000356],
              [84.685197, 21.709689],
              [84.691353000000205, 21.702779000000188],
              [84.70004300000015, 21.703501000000639],
              [84.707291, 21.706462000000553],
              [84.71408000000028, 21.711041000000243],
              [84.717232000000223, 21.706061000000542],
              [84.719589, 21.698870000000166],
              [84.72453200000011, 21.6909],
              [84.733207000000149, 21.682679],
              [84.739404, 21.680140000000161],
              [84.742576, 21.677471000000416],
              [84.73829600000019, 21.668471000000178],
              [84.737961000000126, 21.662470000000209],
              [84.742332000000189, 21.664589999999858],
              [84.74514, 21.663179000000124],
              [84.744812000000351, 21.657160000000427],
              [84.745060468469816, 21.656424221118638],
              [84.747606250880125, 21.6565833325194],
              [84.750461604087135, 21.652776194910071],
              [84.755458472199422, 21.644686027490245],
              [84.760693286412305, 21.635644075667862],
              [84.762358909116386, 21.626840069946404],
              [84.783185141569888, 21.630415210107682],
              [84.788041282027308, 21.630885159183887],
              [84.792405552967381, 21.631307507984726],
              [84.794785013973225, 21.643204813013874],
              [84.80281569486786, 21.650938061282655],
              [84.807872049505406, 21.655994415920297],
              [84.811701699847148, 21.658228378619238],
              [84.815078000000241, 21.657962],
              [84.821365121129219, 21.656416156686415],
              [84.826592000000204, 21.655131000000207],
              [84.831219071205439, 21.654604852732742],
              [84.83821800000014, 21.653809000000361],
              [84.85188400000014, 21.655161000000131],
              [84.852882, 21.648590000000461],
              [84.859414, 21.648241],
              [84.878381, 21.653062000000315],
              [84.895379000000148, 21.654899000000338],
              [84.902314, 21.664840000000137],
              [84.910781000000142, 21.666201],
              [84.919647, 21.664501],
              [84.93618, 21.65571],
              [84.948692, 21.660560000000253],
              [84.950821, 21.665720000000185],
              [84.950577000000152, 21.673861],
              [84.953567, 21.678670000000462],
              [84.957597000000348, 21.6786],
              [84.964156000000216, 21.676772],
              [84.967955, 21.671489000000289],
              [84.973770000000144, 21.669059],
              [84.977088000000194, 21.67173900000034],
              [84.981004, 21.677041000000138],
              [84.98739, 21.673348000000257],
              [84.993988000000158, 21.677850000000486],
              [85.003257000000232, 21.672470999999856],
              [85.021317000000209, 21.667361],
              [85.024407, 21.659019000000164],
              [85.023858000000175, 21.643221],
              [85.026946000000152, 21.636632],
              [85.024537000000166, 21.63086100000077],
              [85.023986000000136, 21.627599000000142],
              [85.025032, 21.624611000000179],
              [85.02729, 21.621411],
              [85.030898000000136, 21.618699000000102],
              [85.033898000000349, 21.617589000000631],
              [85.033859, 21.613781000000237],
              [85.03044, 21.602260000000111],
              [85.045601000000133, 21.584551000000598],
              [85.049637000000104, 21.585422000000332],
              [85.062157000000113, 21.593111000000128],
              [85.070633, 21.597120000000356],
              [85.078147000000214, 21.597601000000164],
              [85.081787000000105, 21.59906000000046],
              [85.088927000000169, 21.596920000000178],
              [85.093178, 21.594342000000317],
              [85.096428000000103, 21.591161000000277],
              [85.101593000000179, 21.58835],
              [85.107277000000167, 21.588799000000332],
              [85.113877, 21.591689],
              [85.124382000000224, 21.593310000000198],
              [85.13118, 21.592559999999818],
              [85.144187000000144, 21.589631],
              [85.156563000000162, 21.584079000000425],
              [85.16031, 21.586639000000329],
              [85.169511000000156, 21.584480000000436],
              [85.18039600000013, 21.5843090000003],
              [85.184868000000151, 21.583001000000415],
              [85.18615800000012, 21.580351000000285],
              [85.18924800000012, 21.577739000000289],
              [85.194916, 21.57455],
              [85.194657, 21.571870000000214],
              [85.200942000000268, 21.562200000000523],
              [85.198807000000187, 21.558291000000278],
              [85.201462, 21.555731000000375],
              [85.207497000000131, 21.55334100000027],
              [85.209236, 21.551241000000569],
              [85.20945, 21.54951200000027],
              [85.205758000000202, 21.539670000000335],
              [85.205521, 21.528211000000276],
              [85.20298, 21.526888999999752],
              [85.201209, 21.526809000000178],
              [85.199899000000286, 21.524701000000274],
              [85.200120000000112, 21.515872000000392],
              [85.193496000000138, 21.508799000000177],
              [85.178910000000172, 21.497221000000302],
              [85.170197, 21.478282000000714],
              [85.156112000000206, 21.465441000000279],
              [85.153236000000248, 21.458392000000224],
              [85.151146000000239, 21.455750000000304],
              [85.141487, 21.452701000000154],
              [85.13446000000026, 21.457551000000187],
              [85.125496, 21.451851000000485],
              [85.119399, 21.448970000000141],
              [85.101807000000164, 21.451901000000358],
              [85.09889200000012, 21.450941000000508],
              [85.090119000000286, 21.45026],
              [85.08602200000017, 21.451520000000293],
              [85.071152, 21.452651],
              [85.068443000000215, 21.45041000000014],
              [85.060769, 21.446451],
              [85.057106000000175, 21.439340000000126],
              [85.053886, 21.437829000000413],
              [85.03222700000012, 21.4478210000002],
              [85.022536000000102, 21.449911000000149],
              [85.017907000000136, 21.452311000000456],
              [85.017098000000189, 21.45103],
              [85.019029, 21.444818999999818],
              [85.017745, 21.441891000000165],
              [85.014801, 21.438739000000393],
              [85.007865, 21.437301000000154],
              [85.000832000000159, 21.438381000000387],
              [84.99778700000023, 21.435078000000427],
              [84.992951000000147, 21.422051000000234],
              [84.989457000000286, 21.410459],
              [84.989578, 21.40596],
              [84.993286000000211, 21.395661000000469],
              [84.997917000000186, 21.38705],
              [84.999268000000228, 21.382150000000134],
              [85.001671, 21.378451000000261],
              [85.000848000000232, 21.376021],
              [85.001488000000208, 21.371812000000311],
              [85.003487000000277, 21.36861],
              [85.001456000000118, 21.362912],
              [85.001343, 21.359211],
              [85.002648000000221, 21.354379000000105],
              [85.005096, 21.351129000000121],
              [85.004173000000137, 21.34833],
              [85.00196, 21.345859000000697],
              [85.007859, 21.33197000000018],
              [85.008294, 21.326311000000256],
              [85.005126000000118, 21.320762000000283],
              [85.006812000000181, 21.312869000000312],
              [85.01027700000013, 21.310439],
              [85.012389, 21.305282],
              [85.021561, 21.303142000000658],
              [85.026787000000212, 21.296689],
              [85.031067000000107, 21.289471],
              [85.027443, 21.286381000000116],
              [85.022981000000286, 21.288580000000131],
              [85.004196000000121, 21.29152],
              [85.001397, 21.285330000000155],
              [84.9935, 21.28482],
              [84.985847000000248, 21.283532000000147],
              [84.976350000000124, 21.285230000000407],
              [84.963119000000276, 21.290531000000325],
              [84.956977000000151, 21.293820000000316],
              [84.915146000000192, 21.272779000000121],
              [84.898781, 21.25881],
              [84.895379000000148, 21.254382],
              [84.897400000000275, 21.248461000000358],
              [84.913017000000181, 21.237220000000203],
              [84.924369, 21.226841000000373],
              [84.926696, 21.219910000000251],
              [84.930398000000181, 21.213132],
              [84.933167000000182, 21.205891000000289],
              [84.934350000000137, 21.198511],
              [84.937180000000268, 21.192291],
              [84.943238, 21.190039000000745],
              [84.962219, 21.18635900000049],
              [84.96427200000015, 21.182382000000413],
              [84.964156000000216, 21.18012100000055],
              [84.963958000000304, 21.175850000000306],
              [84.959664000000117, 21.163209000000272],
              [84.962463, 21.159310000000229],
              [84.967536, 21.156062000000471],
              [84.962303000000176, 21.149361000000674],
              [84.956658000000161, 21.143591000000235],
              [84.949540000000212, 21.143411000000235],
              [84.946160000000219, 21.148069],
              [84.945107000000149, 21.154590000000322],
              [84.948738000000134, 21.164552000000178],
              [84.943733000000151, 21.170690000000373],
              [84.933639, 21.172862000000343],
              [84.927934000000135, 21.17576100000019],
              [84.923973, 21.176032],
              [84.923072000000246, 21.173429000000162],
              [84.926537000000152, 21.171141000000258],
              [84.92292900000011, 21.165571000000224],
              [84.927697000000165, 21.161391000000542],
              [84.926758, 21.156990000000174],
              [84.927116, 21.153601000000201],
              [84.930069000000159, 21.151920999999898],
              [84.928191000000126, 21.147461000000472],
              [84.922416, 21.14362],
              [84.916237000000123, 21.13704],
              [84.903686, 21.140801000000234],
              [84.897377, 21.146690000000486],
              [84.884742000000287, 21.149580000000238],
              [84.879928, 21.152201000000552],
              [84.877693000000164, 21.154952000000318],
              [84.874205000000288, 21.160160000000584],
              [84.859161000000285, 21.161461000000138],
              [84.851569000000126, 21.161671],
              [84.844887000000185, 21.164000000000211],
              [84.816963000000143, 21.167640000000571],
              [84.800697000000113, 21.162002000000708],
              [84.793221000000159, 21.161930999999864],
              [84.793289000000172, 21.157699000000314],
              [84.794616000000104, 21.154079000000131],
              [84.798866000000132, 21.151059000000256],
              [84.804161000000178, 21.151],
              [84.812637000000137, 21.140231],
              [84.810959, 21.135981000000122],
              [84.806342000000129, 21.132111000000346],
              [84.800147000000251, 21.13586],
              [84.797898, 21.132070000000105],
              [84.793975000000259, 21.128562000000326],
              [84.788918, 21.13058100000034],
              [84.785080000000264, 21.133800000000289],
              [84.773003000000173, 21.140769000000315],
              [84.757630000000105, 21.145200000000379],
              [84.742469000000298, 21.163312000000357],
              [84.738747000000131, 21.165990000000413],
              [84.737792000000169, 21.17107],
              [84.742157000000233, 21.178872000000407],
              [84.737991, 21.184159000000133],
              [84.734902000000119, 21.194520000000463],
              [84.728813, 21.193862000000301],
              [84.723817, 21.195869000000126],
              [84.720099000000104, 21.199101000000379],
              [84.720238000000208, 21.202841000000486],
              [84.715728000000269, 21.203710000000452],
              [84.718101000000132, 21.21521],
              [84.721948000000154, 21.221941000000236],
              [84.725221000000118, 21.223821000000267],
              [84.732003, 21.226200000000514],
              [84.737685000000212, 21.229959000000459],
              [84.743285000000171, 21.229731000000122],
              [84.754776000000192, 21.222280000000406],
              [84.754913, 21.231],
              [84.75789, 21.238421000000468],
              [84.762544000000204, 21.242341000000117],
              [84.765960000000334, 21.250111000000512],
              [84.754647000000134, 21.252189000000268],
              [84.751939, 21.255640000000305],
              [84.754387, 21.26201900000023],
              [84.759873000000283, 21.270231000000418],
              [84.756112, 21.274001000000222],
              [84.73969300000013, 21.284282],
              [84.734773, 21.28821100000027],
              [84.729186000000297, 21.297991000000358],
              [84.71708, 21.306061],
              [84.710823000000104, 21.313092000000321],
              [84.702438000000356, 21.31572],
              [84.694291000000177, 21.317660000000153],
              [84.685402000000153, 21.318430000000255],
              [84.672432462431274, 21.315074423506754],
              [84.670435576602515, 21.315265923057716],
              [84.654587767869984, 21.305561814478544],
              [84.659584635982284, 21.299137269762692],
              [84.644594031645653, 21.293069644197654],
              [84.639954082684298, 21.284503584576438],
              [84.62781883155445, 21.279149797313714],
              [84.622821963442206, 21.27129757599436],
              [84.609322000000276, 21.269939000000242],
              [84.604271, 21.266700000000125],
              [84.602438856013379, 21.263897921254735],
              [84.599747000000121, 21.259781000000199],
              [84.595260000000152, 21.256670000000664],
              [84.591696011965766, 21.256443122844299],
              [84.581122000000306, 21.255770000000435],
              [84.570167092915412, 21.249848164929737],
              [84.569893000000135, 21.2497],
              [84.564407000000102, 21.249160000000298],
              [84.561440000000161, 21.252652000000349],
              [84.563393000000332, 21.256260000000335],
              [84.566987, 21.25976100000025],
              [84.565057000000124, 21.29671],
              [84.562759000000113, 21.307251000000402],
              [84.563874, 21.31472],
              [84.56363, 21.318929000000249],
              [84.55902200000024, 21.324142000000617],
              [84.555567470916714, 21.331933988845545],
              [84.555022859566506, 21.333162406804828],
              [84.553557804691408, 21.336466964666663],
              [84.552955167512479, 21.337826264896417],
              [84.552025972759722, 21.339922143950609],
              [84.551459000000122, 21.341201000000179],
              [84.550590002565215, 21.343859806462429],
              [84.549466899908197, 21.347296079669146],
              [84.548524, 21.350181000000472],
              [84.543791723788999, 21.35520860209089],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Dhenkanal",
          Dist_Code: "383",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [85.243823198392974, 20.877787699612664],
              [85.24447549799433, 20.878981985879701],
              [85.244475114378332, 20.879708645669663],
              [85.244474143933118, 20.881546899219355],
              [85.246886346322384, 20.883657576310092],
              [85.25050464990629, 20.886069778699376],
              [85.253070285130534, 20.889166235004431],
              [85.243599000000174, 20.891881000000179],
              [85.239289, 20.89421000000015],
              [85.237076000000101, 20.897681],
              [85.236358, 20.901492000000129],
              [85.237586000000164, 20.912220000000101],
              [85.241408, 20.92403900000016],
              [85.241723, 20.927041000000195],
              [85.241723, 20.93979],
              [85.23867100000011, 20.954361],
              [85.240517, 20.958960000000101],
              [85.243683, 20.962520000000151],
              [85.252761, 20.968081000000147],
              [85.256072000000117, 20.971131000000121],
              [85.257759, 20.974461000000126],
              [85.256348, 20.97834],
              [85.250557000000157, 20.987830000000141],
              [85.243631000000136, 20.99516200000016],
              [85.22367, 21.011221000000202],
              [85.212691, 21.016941],
              [85.194900000000118, 21.029759000000123],
              [85.173141, 21.035990000000194],
              [85.167054, 21.038771],
              [85.163512, 21.043521000000162],
              [85.161689, 21.047872],
              [85.162858000000114, 21.052111000000192],
              [85.166717, 21.056981],
              [85.173782000000173, 21.070280000000135],
              [85.180268, 21.075009000000133],
              [85.189294, 21.075162000000141],
              [85.214446000000166, 21.066741],
              [85.22718, 21.065852],
              [85.235818, 21.095649],
              [85.244873, 21.108681],
              [85.238136, 21.11869100000018],
              [85.249932000000101, 21.12809000000021],
              [85.254197, 21.134909],
              [85.255806000000106, 21.139739000000187],
              [85.256813000000108, 21.146989000000186],
              [85.259774000000149, 21.15196],
              [85.260467000000162, 21.157979000000179],
              [85.262725, 21.16465],
              [85.267723, 21.16867000000013],
              [85.279098000000133, 21.169429000000203],
              [85.28514, 21.175489000000137],
              [85.294982, 21.171132],
              [85.314826, 21.15497],
              [85.329568, 21.17082],
              [85.333718, 21.1712300000002],
              [85.334908, 21.173960000000132],
              [85.338990000000123, 21.165252000000116],
              [85.345367000000167, 21.163209000000162],
              [85.355156000000122, 21.163690000000198],
              [85.359139000000184, 21.165621],
              [85.375191000000115, 21.163720000000179],
              [85.377808000000115, 21.164399],
              [85.388862, 21.179480000000119],
              [85.398238000000148, 21.170781000000144],
              [85.405853000000121, 21.16736],
              [85.410507, 21.16622],
              [85.412613, 21.16336],
              [85.418007000000145, 21.161359],
              [85.420617, 21.156541],
              [85.435356, 21.144452],
              [85.454681, 21.126871],
              [85.45723800000016, 21.12177],
              [85.468087, 21.117071000000116],
              [85.472488, 21.116380000000103],
              [85.486445087633086, 21.110233009948949],
              [85.49179, 21.107879000000189],
              [85.495491000000158, 21.108230000000102],
              [85.520068901240776, 21.134070583203989],
              [85.528153, 21.14257],
              [85.5312065225298, 21.147141287062421],
              [85.544656608965212, 21.155181464868626],
              [85.550843207580485, 21.155657357069622],
              [85.571088932911351, 21.144939962405825],
              [85.584015420791246, 21.137560752907966],
              [85.58974447446893, 21.134290267706881],
              [85.594070000000144, 21.131821000000169],
              [85.605172000000124, 21.13163000000014],
              [85.611556, 21.136341],
              [85.624900000000167, 21.155080000000108],
              [85.629217462812306, 21.15800819498298],
              [85.632141, 21.159991],
              [85.645317000000134, 21.159112000000103],
              [85.659249, 21.1607],
              [85.667342000000119, 21.166350000000186],
              [85.673950000000147, 21.1728],
              [85.677307, 21.177062],
              [85.678551000000112, 21.179911000000114],
              [85.681525000000164, 21.17984],
              [85.688201, 21.174601],
              [85.7003330000001, 21.17765],
              [85.70462, 21.176032000000131],
              [85.700944, 21.17270000000013],
              [85.701087000000129, 21.16558],
              [85.703681000000174, 21.16249200000021],
              [85.708474000000109, 21.159779],
              [85.71367700000016, 21.158002000000121],
              [85.717376000000144, 21.155100000000171],
              [85.722687000000164, 21.137770000000156],
              [85.709443000000164, 21.134992000000178],
              [85.702079000000126, 21.13576200000011],
              [85.694785, 21.133519000000142],
              [85.68242600000012, 21.125089],
              [85.683898, 21.118110000000112],
              [85.68010800000016, 21.11448200000012],
              [85.679169, 21.112280000000165],
              [85.681076000000161, 21.100390000000115],
              [85.690437, 21.081961000000142],
              [85.694327, 21.078319],
              [85.695481000000129, 21.074401],
              [85.698548, 21.072001000000107],
              [85.700157, 21.068331],
              [85.702667000000119, 21.067609000000115],
              [85.709235, 21.062032],
              [85.711517000000157, 21.060961],
              [85.718696000000108, 21.061799000000118],
              [85.721688, 21.06115],
              [85.724708000000177, 21.057371],
              [85.723876000000118, 21.046609],
              [85.728348, 21.033139],
              [85.728950000000154, 21.024770000000157],
              [85.724715, 21.0176],
              [85.723297000000159, 21.008561000000149],
              [85.719391, 21.003271000000151],
              [85.718117, 20.995080000000137],
              [85.714988, 20.988042000000117],
              [85.717727, 20.983181],
              [85.718598, 20.97740100000021],
              [85.732804, 20.9851],
              [85.736922, 20.986050000000144],
              [85.752213, 20.98491000000012],
              [85.758476000000115, 20.983089],
              [85.77378, 20.975771000000172],
              [85.774781, 20.971081],
              [85.781213, 20.964350000000191],
              [85.78521, 20.963689],
              [85.789543, 20.96487],
              [85.798156, 20.960531],
              [85.798737000000173, 20.956661000000107],
              [85.805428000000106, 20.950331],
              [85.808578, 20.944761000000135],
              [85.815087000000105, 20.940112],
              [85.819108, 20.933901],
              [85.817519, 20.927041000000195],
              [85.822137, 20.920142000000109],
              [85.828322, 20.91998],
              [85.835442, 20.922471],
              [85.837302000000179, 20.92609],
              [85.84953200000011, 20.92491],
              [85.856246000000155, 20.922850000000146],
              [85.864296, 20.921391],
              [85.891509000000127, 20.92374100000017],
              [85.903267000000127, 20.92307100000016],
              [85.914405, 20.921311],
              [85.914337000000145, 20.914150000000117],
              [85.916472, 20.892049000000206],
              [85.90508400000013, 20.874051000000172],
              [85.900101000000163, 20.858022000000169],
              [85.894043, 20.850111000000194],
              [85.895782, 20.8404500000002],
              [85.910522000000157, 20.83627000000018],
              [85.919745000000134, 20.83266],
              [85.937958, 20.833031],
              [85.949128, 20.82799],
              [85.953584, 20.831092],
              [85.962096, 20.82755],
              [85.965508, 20.82478100000014],
              [85.965102000000101, 20.81689],
              [85.97104, 20.815270000000108],
              [85.974517000000134, 20.812549],
              [85.994011000000143, 20.812070000000173],
              [86.010788, 20.807031000000162],
              [86.015198, 20.802420000000208],
              [86.02823, 20.802520000000126],
              [86.027715847990621, 20.792829849757933],
              [86.027466000000317, 20.788121000000327],
              [86.026554708969044, 20.786543950355334],
              [86.024637371269066, 20.783225870142413],
              [86.018429315945397, 20.769874673403869],
              [86.018072396794452, 20.763450128688074],
              [86.023069264906823, 20.758810179726705],
              [86.023069264906823, 20.754527149916211],
              [86.020538000000144, 20.747771],
              [86.020892326017403, 20.744287733288385],
              [86.021607000000117, 20.737262],
              [86.026092000000148, 20.73473000000018],
              [86.02654300000016, 20.733159],
              [86.023927, 20.727742000000202],
              [86.021568, 20.726821000000193],
              [86.020401, 20.719690000000124],
              [86.013397, 20.721871],
              [86.007895000000175, 20.718051],
              [86.004021, 20.717502],
              [85.999077, 20.719899000000165],
              [85.993881, 20.723920000000184],
              [85.988846000000166, 20.723831],
              [85.984336, 20.726901000000105],
              [85.979974000000126, 20.728811],
              [85.974969, 20.727872000000158],
              [85.964836, 20.723721],
              [85.960984, 20.721032000000147],
              [85.955696, 20.71416000000016],
              [85.950539, 20.714719],
              [85.941292, 20.7121],
              [85.935013, 20.711631000000178],
              [85.91826600000033, 20.706979],
              [85.910996651532102, 20.709912256056889],
              [85.904929025967292, 20.709198417755196],
              [85.902932000000106, 20.705921],
              [85.901412, 20.700951],
              [85.901786000000101, 20.69771900000017],
              [85.90461, 20.69486100000011],
              [85.906342000000151, 20.69149],
              [85.906647000000163, 20.686701000000134],
              [85.904571, 20.67641100000014],
              [85.900384000000116, 20.672131],
              [85.894408, 20.669430000000197],
              [85.890739, 20.665271000000185],
              [85.888252000000122, 20.660512],
              [85.881759, 20.652911000000184],
              [85.878586, 20.651439000000206],
              [85.873916, 20.65148],
              [85.868927, 20.656141],
              [85.860572000000147, 20.661109],
              [85.839303, 20.661519],
              [85.826996000000108, 20.660642000000159],
              [85.819992, 20.655019000000145],
              [85.812920000000176, 20.65519],
              [85.807847, 20.653841],
              [85.803566, 20.653750000000109],
              [85.800316, 20.656489],
              [85.794609, 20.659309000000174],
              [85.791526, 20.663541],
              [85.7862930000001, 20.666112000000108],
              [85.782952, 20.663999],
              [85.778892, 20.656701],
              [85.777046, 20.655281000000169],
              [85.767722, 20.653841],
              [85.761359000000112, 20.653829],
              [85.759506, 20.651131000000127],
              [85.758300000000176, 20.645470000000156],
              [85.759324000000134, 20.643102000000166],
              [85.756707000000162, 20.635669000000117],
              [85.752983, 20.639339],
              [85.74952800000014, 20.638261],
              [85.749154000000132, 20.636301],
              [85.750344, 20.63427],
              [85.751762, 20.628429],
              [85.745599000000183, 20.631362000000134],
              [85.737847, 20.631710000000108],
              [85.732697, 20.63798],
              [85.727432000000164, 20.637490000000181],
              [85.723870000000133, 20.638789000000198],
              [85.722313, 20.634532000000199],
              [85.713356, 20.6295],
              [85.713700000000117, 20.624830000000195],
              [85.712273, 20.621600000000107],
              [85.706589000000108, 20.614430000000194],
              [85.70305600000016, 20.620281],
              [85.701393, 20.616541000000208],
              [85.706596000000147, 20.609229],
              [85.709381000000164, 20.609731],
              [85.709924000000143, 20.607130000000151],
              [85.705803000000103, 20.602471],
              [85.704857000000146, 20.598440000000203],
              [85.701705, 20.596220000000184],
              [85.687736, 20.59041000000013],
              [85.68329, 20.586759000000196],
              [85.678756, 20.581590000000112],
              [85.670098, 20.566691000000159],
              [85.659279000000168, 20.559722000000129],
              [85.655778, 20.553039000000123],
              [85.655297, 20.547681],
              [85.65297, 20.543301000000152],
              [85.650176, 20.543029],
              [85.646714, 20.541388000000151],
              [85.644569, 20.543590000000105],
              [85.643172000000149, 20.542270000000141],
              [85.64306700000013, 20.539150000000113],
              [85.639259, 20.539989],
              [85.635781, 20.536310000000121],
              [85.629402000000127, 20.533689000000145],
              [85.623841000000127, 20.533560000000133],
              [85.609277000000162, 20.53515],
              [85.606086, 20.531980000000143],
              [85.598075, 20.528529],
              [85.595306, 20.529801000000131],
              [85.593856000000173, 20.529530000000133],
              [85.592758000000103, 20.52734],
              [85.589043, 20.523732000000162],
              [85.586807000000121, 20.517852],
              [85.588646, 20.51276],
              [85.587479000000116, 20.51139],
              [85.585471, 20.510989000000105],
              [85.583625, 20.505519],
              [85.571778, 20.507441000000135],
              [85.568809, 20.507101],
              [85.565376, 20.50899],
              [85.560332000000173, 20.514030000000158],
              [85.555672, 20.513590000000189],
              [85.55224600000011, 20.517022000000104],
              [85.545418, 20.51694],
              [85.532798000000156, 20.521111],
              [85.52693200000013, 20.521669000000198],
              [85.521020000000163, 20.52419],
              [85.513236, 20.52683200000018],
              [85.508462000000108, 20.526572000000154],
              [85.505752, 20.528901000000129],
              [85.497802, 20.525760000000101],
              [85.493989, 20.517362000000158],
              [85.487259, 20.515609],
              [85.484772000000177, 20.513891],
              [85.479507, 20.514030000000158],
              [85.481103000000175, 20.510210000000139],
              [85.477288, 20.500760000000181],
              [85.463494000000168, 20.491489000000112],
              [85.456971000000109, 20.485679],
              [85.452316984958358, 20.47889427700704],
              [85.452087000000148, 20.478559000000182],
              [85.445302262064942, 20.484281036737567],
              [85.44167400000012, 20.487341000000125],
              [85.431289561764956, 20.493241346492763],
              [85.423080421294785, 20.493598265643691],
              [85.426292693652599, 20.496453618850516],
              [85.418797391484347, 20.496810538001508],
              [85.405591382901989, 20.500736648661185],
              [85.40023759563887, 20.501093567811946],
              [85.396311484979194, 20.48467528687183],
              [85.394172000000125, 20.481000000000158],
              [85.391328, 20.4850600000002],
              [85.389197372229802, 20.485741513933473],
              [85.383606, 20.487530000000103],
              [85.380066, 20.4921],
              [85.372810000000101, 20.48833],
              [85.364509, 20.488200000000113],
              [85.340735, 20.490060000000195],
              [85.33622, 20.491979000000182],
              [85.329171, 20.497030000000105],
              [85.31410100000015, 20.495309000000187],
              [85.306077, 20.498069],
              [85.300880000000106, 20.498951],
              [85.294136, 20.50551],
              [85.286843, 20.509011000000211],
              [85.282150000000101, 20.50487],
              [85.276642000000138, 20.50236],
              [85.27163, 20.507810000000116],
              [85.246179, 20.511730000000107],
              [85.240700000000103, 20.514121],
              [85.23407, 20.519000000000172],
              [85.219834, 20.532801],
              [85.212593000000126, 20.538489000000133],
              [85.206802, 20.541459000000199],
              [85.2064120000001, 20.547640000000168],
              [85.198677000000117, 20.553511000000125],
              [85.195703, 20.557502000000106],
              [85.194328, 20.561139000000136],
              [85.202873, 20.56751],
              [85.203133, 20.568729000000186],
              [85.194442, 20.57274],
              [85.1892, 20.576232000000171],
              [85.17318, 20.592001000000149],
              [85.168351, 20.594150000000123],
              [85.162361, 20.594882000000148],
              [85.15825, 20.597651],
              [85.154213000000183, 20.602120000000177],
              [85.150238000000101, 20.602832000000145],
              [85.144538000000111, 20.60129100000017],
              [85.140128000000104, 20.603112],
              [85.132621000000128, 20.603531],
              [85.123208, 20.609111],
              [85.127427000000111, 20.62772],
              [85.130608, 20.633310000000161],
              [85.121216000000103, 20.645941],
              [85.118661, 20.655751000000119],
              [85.108697, 20.675771000000164],
              [85.11403, 20.68696100000016],
              [85.118980000000164, 20.693810000000209],
              [85.125863, 20.700189],
              [85.129068000000174, 20.704800000000201],
              [85.130271, 20.71259],
              [85.134369000000135, 20.723370000000155],
              [85.13861, 20.7233],
              [85.147424000000157, 20.72540100000014],
              [85.147431, 20.716740000000126],
              [85.152832000000146, 20.705691],
              [85.155968, 20.70181],
              [85.16030100000016, 20.700800000000182],
              [85.165497000000173, 20.698191000000115],
              [85.169251, 20.69448],
              [85.168731, 20.690731000000191],
              [85.166001000000136, 20.684851000000201],
              [85.160492000000119, 20.677250000000125],
              [85.161247, 20.672970000000184],
              [85.158578, 20.669241],
              [85.162270000000134, 20.658650000000186],
              [85.162872, 20.655701],
              [85.161942, 20.65282],
              [85.166489000000155, 20.655229000000126],
              [85.18039600000013, 20.666321000000206],
              [85.190796, 20.67147],
              [85.19045200000015, 20.675399],
              [85.191680000000119, 20.67828],
              [85.191712, 20.682250000000117],
              [85.190812, 20.686180000000203],
              [85.192674, 20.702409],
              [85.196320000000171, 20.71006],
              [85.198898000000128, 20.712481000000132],
              [85.19854, 20.723400000000137],
              [85.200623, 20.73021000000011],
              [85.209922, 20.743151],
              [85.20829, 20.746280000000176],
              [85.203149000000153, 20.749651000000192],
              [85.202262000000118, 20.754052000000168],
              [85.203789000000185, 20.759000000000125],
              [85.201843, 20.764721000000119],
              [85.194978000000134, 20.772431000000147],
              [85.193009000000117, 20.777402],
              [85.195518, 20.78201],
              [85.198921, 20.783501000000168],
              [85.203454000000164, 20.782040000000105],
              [85.207809, 20.779471000000168],
              [85.211739000000165, 20.779752000000141],
              [85.214631000000153, 20.786840000000208],
              [85.219406, 20.78774],
              [85.224823, 20.787380000000152],
              [85.231109, 20.785842],
              [85.238694, 20.789101],
              [85.250839, 20.79042000000015],
              [85.249771000000109, 20.79269],
              [85.251266, 20.80157],
              [85.251099, 20.807521],
              [85.248458000000184, 20.818611000000143],
              [85.248061, 20.82404],
              [85.248626, 20.829460000000207],
              [85.25254, 20.837120000000191],
              [85.254028, 20.862569000000171],
              [85.253287, 20.870081000000138],
              [85.251548, 20.87292100000013],
              [85.246525110925788, 20.876085468623778],
              [85.244635020077155, 20.87727624411178],
              [85.244526537871181, 20.877344588949139],
              [85.243823198392974, 20.877787699612664],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Gajapati",
          Dist_Code: "389",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [83.927575740824324, 19.399783438991673],
              [83.928443805118533, 19.401716854919638],
              [83.932198262861831, 19.401847340047421],
              [83.934339777766965, 19.403988854952726],
              [83.939098699778626, 19.403988854952726],
              [83.94076432248275, 19.405416531556167],
              [83.935767454370577, 19.407795992561997],
              [83.935767454370577, 19.408747776964386],
              [83.939040661566509, 19.412775443638505],
              [83.940923439749824, 19.413238656185396],
              [83.942328399060472, 19.413584312825428],
              [83.94328018346269, 19.414774043328347],
              [83.939489538007791, 19.416821983533843],
              [83.94065560039023, 19.41880466394252],
              [83.941679036645468, 19.420544834145453],
              [83.945816, 19.427579],
              [83.95523700000011, 19.44110100000011],
              [83.957512, 19.446501000000179],
              [83.962166, 19.452611000000157],
              [83.96254, 19.459699],
              [83.96373, 19.464490000000179],
              [83.965978220102997, 19.467967621076806],
              [83.966894634727026, 19.469385161471219],
              [83.96894, 19.472549000000122],
              [83.971267, 19.47801],
              [83.972309607733877, 19.487332732374959],
              [83.968145550973688, 19.494173682766526],
              [83.966360955219315, 19.499230037404114],
              [83.969335281476603, 19.505773555170144],
              [83.971119877230976, 19.511424775058796],
              [83.971714742482433, 19.518265725450753],
              [83.972904472985348, 19.522727214836486],
              [83.971714742482433, 19.526593838971159],
              [83.966360955219315, 19.533137356737193],
              [83.958330274324652, 19.538193711374387],
              [83.950597026055704, 19.540573172380217],
              [83.946328348278755, 19.539224328410224],
              [83.9455406714183, 19.544142363888962],
              [83.944945806166828, 19.551578179532381],
              [83.941079182032396, 19.556931966795499],
              [83.934833096892064, 19.556337101544042],
              [83.931263905383318, 19.557526832046957],
              [83.928801038372541, 19.558758265552164],
              [83.926504983371643, 19.559906293052787],
              [83.924720387617285, 19.56407034981299],
              [83.92353065711437, 19.567342108695808],
              [83.926859087483578, 19.569505588436066],
              [83.926682000000241, 19.573811],
              [83.927034252367406, 19.578007424922472],
              [83.927810000000122, 19.587249],
              [83.923279, 19.601539000000113],
              [83.920433000000102, 19.613621],
              [83.919868, 19.62315000000012],
              [83.93586, 19.627902],
              [83.94304, 19.626830000000147],
              [83.948380000000128, 19.626391],
              [83.95327700000017, 19.623941],
              [83.960701000000128, 19.616511],
              [83.968826, 19.61334],
              [83.977341, 19.614161000000134],
              [83.992203000000174, 19.61866],
              [83.996811, 19.619501000000181],
              [84.003922, 19.610341],
              [84.004998000000157, 19.613500000000155],
              [84.007339, 19.616141000000191],
              [84.01191, 19.6176910000002],
              [84.015502, 19.6176910000002],
              [84.021569, 19.625192000000133],
              [84.026572000000144, 19.624731],
              [84.031853000000112, 19.62258],
              [84.035262, 19.619350000000107],
              [84.04058, 19.617880000000177],
              [84.053885000000122, 19.62289],
              [84.061516, 19.622129000000196],
              [84.068611000000118, 19.61609100000015],
              [84.071799000000141, 19.6173490000001],
              [84.078172, 19.609769000000192],
              [84.083359, 19.609251000000139],
              [84.087464, 19.610111],
              [84.0844740000001, 19.617951],
              [84.084159000000156, 19.620321],
              [84.085472, 19.621641000000178],
              [84.10672700000012, 19.619569000000119],
              [84.112281000000152, 19.622801000000202],
              [84.120393, 19.625591000000149],
              [84.124267000000131, 19.623742],
              [84.127700000000161, 19.620460000000143],
              [84.131820000000161, 19.609092000000139],
              [84.135009, 19.596219000000129],
              [84.13923, 19.586020000000186],
              [84.143731000000159, 19.579281000000204],
              [84.148506000000154, 19.576621],
              [84.150559, 19.57397],
              [84.154801000000163, 19.57213100000012],
              [84.157317, 19.573339],
              [84.1598970000001, 19.578581000000209],
              [84.162848, 19.580261000000117],
              [84.175338000000167, 19.579112],
              [84.193307, 19.583561000000142],
              [84.197808, 19.58303],
              [84.201692, 19.581321],
              [84.208588, 19.573811],
              [84.215209, 19.568719],
              [84.220520000000164, 19.5659],
              [84.225058422721744, 19.564723206792674],
              [84.227647000000147, 19.564052000000114],
              [84.231628, 19.564220000000144],
              [84.233871000000121, 19.567721000000116],
              [84.237152662417685, 19.566561252687499],
              [84.231300467150433, 19.558665588606566],
              [84.229158952245299, 19.55295488219269],
              [84.23344198205578, 19.546887256627709],
              [84.239866526771536, 19.545459580024268],
              [84.24511616944163, 19.537883658788129],
              [84.24598, 19.529119],
              [84.251223733269669, 19.531139837568269],
              [84.251223733269669, 19.547796064609081],
              [84.250034002766753, 19.555529312878033],
              [84.253008329024041, 19.56028823488969],
              [84.260146712041518, 19.550175525614915],
              [84.256577520532772, 19.532329568071187],
              [84.258956981538617, 19.524596319802235],
              [84.269664556064853, 19.528165511310984],
              [84.277992669585259, 19.546606334106169],
              [84.281561861094005, 19.546606334106169],
              [84.289889974614397, 19.554339582375118],
              [84.296433492380444, 19.554339582375118],
              [84.305356471152308, 19.557313908632405],
              [84.322607563444578, 19.556124178129487],
              [84.326176754953323, 19.562667695895524],
              [84.319038371935818, 19.570400944164469],
              [84.322607563444578, 19.57337527042176],
              [84.330340811713512, 19.565642022152812],
              [84.342832981994135, 19.563857426398439],
              [84.348186769257254, 19.576349596679048],
              [84.35889434378349, 19.560883100141151],
              [84.369007053058255, 19.552554986620745],
              [84.377335166578675, 19.543037142597424],
              [84.373171109818458, 19.53649362483139],
              [84.377930031830132, 19.532329568071187],
              [84.375550570824302, 19.518647667287659],
              [84.369041124825728, 19.514579263538504],
              [84.369751000000164, 19.51294],
              [84.373765975069929, 19.500206844492478],
              [84.367973000000163, 19.498071],
              [84.37046, 19.49137],
              [84.37394, 19.486500000000145],
              [84.369666, 19.480360000000186],
              [84.367638000000156, 19.475510000000153],
              [84.370072, 19.472150000000163],
              [84.364248131046608, 19.468084120913769],
              [84.360084074286391, 19.45559195063316],
              [84.366032726800981, 19.444884376106923],
              [84.373765975069929, 19.448453567615669],
              [84.38090435808742, 19.439530588843805],
              [84.383878684344694, 19.429417879569026],
              [84.392801663116572, 19.428228149066111],
              [84.397870443074083, 19.428555167127964],
              [84.410052755408827, 19.428823014317565],
              [84.410647620660299, 19.426443553311739],
              [84.402914372391351, 19.41871030504279],
              [84.393928, 19.41955],
              [84.386696000000128, 19.418502],
              [84.376740301327203, 19.413951383031129],
              [84.370196783561184, 19.403838673756347],
              [84.366032726800981, 19.406218134762181],
              [84.354730287023273, 19.402054078001978],
              [84.357109748029117, 19.390156772972826],
              [84.379934264715004, 19.380293867645886],
              [84.3753600000001, 19.375989],
              [84.375428, 19.37286000000017],
              [84.377917386302826, 19.370512808073325],
              [84.376740301327203, 19.361008375651405],
              [84.369007053058255, 19.362792971405778],
              [84.373171109818458, 19.356249453639744],
              [84.383283819093251, 19.346731609616423],
              [84.395181124122388, 19.348516205370796],
              [84.4118581150681, 19.357016631186294],
              [84.433639000000184, 19.354392000000129],
              [84.423766, 19.348580000000137],
              [84.41684, 19.342340000000203],
              [84.412774000000113, 19.33488],
              [84.408981000000139, 19.325109],
              [84.41233, 19.313180000000152],
              [84.411949, 19.30039],
              [84.414016000000146, 19.296281],
              [84.421189000000183, 19.289910000000187],
              [84.41968752799481, 19.286894771639648],
              [84.420626247847778, 19.278543541695282],
              [84.425682602485139, 19.249990009625318],
              [84.423898006730766, 19.239282435099081],
              [84.4117032690759, 19.213108364034944],
              [84.399805964046763, 19.198236732748509],
              [84.394749609409331, 19.199129030625667],
              [84.388077000000166, 19.198932000000124],
              [84.382359892653525, 19.197041904147451],
              [84.356514882777645, 19.188497452728708],
              [84.361512, 19.18634],
              [84.370791648812627, 19.181359069711217],
              [84.374360840321387, 19.176005282448099],
              [84.362375671658512, 19.167922416294456],
              [84.374360840321387, 19.159943920658741],
              [84.37495570557283, 19.152210672389796],
              [84.388637606356369, 19.149236346132504],
              [84.385663280099067, 19.142097963115017],
              [84.377930031830132, 19.142692828366474],
              [84.383553000000106, 19.132101],
              [84.370391, 19.13183],
              [84.361868670040764, 19.13139038858878],
              [84.354135421771815, 19.143287693617928],
              [84.343427847245579, 19.133174984343153],
              [84.345807308251423, 19.117708487805256],
              [84.339858655736833, 19.106406048027562],
              [84.342238116742678, 19.102836856518817],
              [84.332720272719357, 19.080231976963429],
              [84.341048386239763, 19.076067920203226],
              [84.349376499760169, 19.087965225232377],
              [84.35056623026307, 19.097483069255698],
              [84.364842996298066, 19.101647126015902],
              [84.370196783561184, 19.10938037428485],
              [84.372016, 19.092822000000179],
              [84.35889434378349, 19.086180629478005],
              [84.35889434378349, 19.075473054951768],
              [84.362494250355411, 19.065908620144963],
              [84.358275, 19.057881000000176],
              [84.35505700000013, 19.047399],
              [84.351060000000174, 19.04429],
              [84.354141000000183, 19.039948000000148],
              [84.354508000000166, 19.034100000000191],
              [84.36127380478932, 19.03085816109245],
              [84.356514882777645, 19.018960856063298],
              [84.355920017526202, 19.011822473045804],
              [84.368412187806811, 19.02015058656621],
              [84.367393500028044, 19.010670457646309],
              [84.367040042753374, 19.007381107758015],
              [84.366218, 18.999731],
              [84.366006488710497, 18.995322571782193],
              [84.355369529762896, 18.977541724457744],
              [84.371430891552265, 18.960409605215713],
              [84.383923061832874, 18.960409605215713],
              [84.384993819285484, 18.966120311629819],
              [84.389276849095992, 18.968261826534953],
              [84.39677215126423, 18.967904907384192],
              [84.403196695980043, 18.972544856345561],
              [84.411048917299226, 18.963978796724458],
              [84.406765887488788, 18.961480362668393],
              [84.406052049187025, 18.958268090310579],
              [84.397485989565922, 18.953985060499971],
              [84.395701393811734, 18.951129707293088],
              [84.401769019376587, 18.945419000879038],
              [84.401412100225656, 18.941135971068601],
              [84.407836644941398, 18.940779051917612],
              [84.408193564092159, 18.93613910295624],
              [84.411405836450143, 18.935782183805483],
              [84.41559600000015, 18.93803900000017],
              [84.4203040000003, 18.949360000000237],
              [84.429620918541374, 18.958387134442656],
              [84.432474105328126, 18.952680760868301],
              [84.436043296836871, 18.946613135303433],
              [84.437114054289495, 18.939117833135182],
              [84.43675713513872, 18.92591182455271],
              [84.432831024479057, 18.922342633043961],
              [84.429389000000114, 18.913682000000158],
              [84.425217129542972, 18.909625682344366],
              [84.422148940627082, 18.906642476369992],
              [84.420327, 18.904871000000121],
              [84.41796800000013, 18.900659000000186],
              [84.409569000000118, 18.908100000000157],
              [84.406151000000122, 18.90612],
              [84.407701, 18.901122],
              [84.410720000000126, 18.898259000000159],
              [84.412086, 18.89394000000021],
              [84.409813, 18.890631000000152],
              [84.397827, 18.886120000000169],
              [84.393967, 18.88587],
              [84.386872000000139, 18.88987],
              [84.378457000000182, 18.893241],
              [84.374070000000117, 18.894029000000156],
              [84.369767, 18.895811000000148],
              [84.365318, 18.896260000000151],
              [84.364905000000121, 18.893220000000149],
              [84.367677000000157, 18.889330000000193],
              [84.374229, 18.888860000000186],
              [84.379036000000141, 18.885469000000111],
              [84.386092, 18.88303],
              [84.387626000000168, 18.877669],
              [84.386222, 18.871710000000174],
              [84.383232, 18.86928000000017],
              [84.378083000000146, 18.8741],
              [84.374070000000117, 18.876500000000188],
              [84.371353, 18.87544],
              [84.354736, 18.882930000000155],
              [84.351447, 18.883199],
              [84.351837000000145, 18.877790000000171],
              [84.353829000000118, 18.875062],
              [84.359627, 18.871901000000147],
              [84.361320000000134, 18.872680000000113],
              [84.36625, 18.871710000000174],
              [84.371567000000127, 18.86722],
              [84.371467, 18.863382000000112],
              [84.369338000000113, 18.858971],
              [84.362412, 18.851061000000122],
              [84.358337000000105, 18.851341],
              [84.355217000000195, 18.852640000000232],
              [84.34944578785597, 18.861413559663387],
              [84.335825087499003, 18.877084844948794],
              [84.330410099809328, 18.881341545587357],
              [84.319405092657334, 18.868254510055291],
              [84.32386658204328, 18.862603290166298],
              [84.326840908300582, 18.854572609271763],
              [84.335126033770479, 18.846128350831744],
              [84.335983000000212, 18.84142200000036],
              [84.337100782142429, 18.838629959440706],
              [84.337511290875383, 18.837604574448161],
              [84.338066, 18.836219],
              [84.341090576662438, 18.834535418431354],
              [84.344352000000228, 18.832720000000332],
              [84.344592531151164, 18.830969369478336],
              [84.355691872996246, 18.830480566587593],
              [84.354204709867631, 18.823639616195972],
              [84.348378731375462, 18.823089297444366],
              [84.344268, 18.822701],
              [84.342431000000119, 18.821509000000159],
              [84.34076, 18.818250000000141],
              [84.344101, 18.811941],
              [84.329323, 18.808999000000139],
              [84.329529, 18.804532],
              [84.33358800000012, 18.795051],
              [84.332222000000101, 18.792022000000195],
              [84.326958, 18.789672000000106],
              [84.315719000000101, 18.786171000000135],
              [84.312927, 18.782181],
              [84.312492, 18.77919],
              [84.308852000000158, 18.77842],
              [84.307168, 18.781661000000206],
              [84.304321000000115, 18.780720000000141],
              [84.300369000000131, 18.781741],
              [84.283921, 18.790821000000161],
              [84.278549, 18.789681000000137],
              [84.275338000000133, 18.787181],
              [84.273216, 18.78249],
              [84.268188, 18.780309],
              [84.264222000000174, 18.780519],
              [84.258889000000167, 18.77483],
              [84.252191, 18.772481],
              [84.246032, 18.77341000000018],
              [84.231163, 18.78012],
              [84.23068900000014, 18.785640000000111],
              [84.226990000000157, 18.78716],
              [84.224296000000137, 18.784270000000102],
              [84.221459, 18.786479],
              [84.216714, 18.787281000000174],
              [84.203827000000146, 18.782641000000122],
              [84.190337, 18.776740000000181],
              [84.186515, 18.77960100000012],
              [84.181510000000159, 18.777522],
              [84.179817, 18.768971],
              [84.167031000000108, 18.770140000000136],
              [84.162627, 18.768570000000121],
              [84.158188, 18.76918900000015],
              [84.160271000000179, 18.772319000000149],
              [84.159348000000165, 18.77504],
              [84.154931000000133, 18.776011],
              [84.151366, 18.77576],
              [84.148116, 18.77176],
              [84.140426, 18.767690000000126],
              [84.134979, 18.766789000000184],
              [84.131362, 18.764802],
              [84.127937, 18.761269000000137],
              [84.129487, 18.75286200000016],
              [84.122941000000182, 18.7482690000001],
              [84.118927, 18.75303],
              [84.114068, 18.755141],
              [84.107591, 18.754801000000207],
              [84.100724, 18.752679000000111],
              [84.091637, 18.745240000000134],
              [84.08878300000012, 18.747111],
              [84.085579, 18.745181],
              [84.081780000000137, 18.744641000000112],
              [84.079330000000127, 18.746111],
              [84.07788, 18.748880000000209],
              [84.069894, 18.749760000000204],
              [84.065773, 18.751699],
              [84.060463000000112, 18.762671000000179],
              [84.05861, 18.768100000000114],
              [84.053559000000163, 18.768369000000174],
              [84.049202, 18.77065],
              [84.048051, 18.774402000000176],
              [84.049721, 18.77731000000011],
              [84.047606, 18.779872000000179],
              [84.047944, 18.783480000000107],
              [84.038720000000154, 18.787429000000138],
              [84.034287, 18.790121000000109],
              [84.030777, 18.79544100000015],
              [84.03071600000014, 18.800279],
              [84.027062000000157, 18.802200000000195],
              [84.023728000000162, 18.801152000000169],
              [84.022317000000129, 18.798629000000115],
              [84.019662, 18.7976220000001],
              [84.015869, 18.8014100000002],
              [84.012496, 18.800630000000123],
              [84.007393, 18.804211000000116],
              [83.999977, 18.80479],
              [83.99154, 18.804662000000118],
              [83.982323000000164, 18.800010000000153],
              [83.969384, 18.80383],
              [83.964028, 18.80411],
              [83.955611, 18.803060000000126],
              [83.951210000000145, 18.800042000000129],
              [83.949020000000175, 18.79704],
              [83.943687000000168, 18.796288],
              [83.939789, 18.796601000000177],
              [83.936576000000102, 18.799201000000206],
              [83.935721, 18.80313],
              [83.933586, 18.806859000000198],
              [83.926393000000118, 18.806560000000157],
              [83.922653000000125, 18.808532],
              [83.920592, 18.811572],
              [83.907754000000168, 18.81639],
              [83.901979000000125, 18.816921000000146],
              [83.898551, 18.816440000000167],
              [83.89547600000013, 18.814879000000129],
              [83.89064, 18.80687],
              [83.886879, 18.805409000000104],
              [83.885352, 18.810041],
              [83.884637, 18.81781900000021],
              [83.88324, 18.819691000000201],
              [83.873916000000108, 18.817769000000165],
              [83.870178, 18.818430000000145],
              [83.866866000000101, 18.823451],
              [83.864341000000124, 18.839040000000118],
              [83.859069, 18.843011],
              [83.847977, 18.847619000000119],
              [83.843667000000124, 18.851400000000123],
              [83.837096, 18.86471],
              [83.836007000000151, 18.869109],
              [83.836693, 18.872721000000123],
              [83.842322, 18.88824],
              [83.84163600000015, 18.89763],
              [83.840271, 18.904060000000182],
              [83.837723, 18.90860900000018],
              [83.834876, 18.909299],
              [83.823052000000118, 18.905461000000113],
              [83.818451000000124, 18.90712],
              [83.816933000000105, 18.909402],
              [83.821167, 18.921960000000123],
              [83.818902000000136, 18.926099],
              [83.814888, 18.930039000000132],
              [83.813407, 18.93358100000011],
              [83.81606200000013, 18.948660000000185],
              [83.814765000000122, 18.953179000000201],
              [83.810638, 18.964830000000173],
              [83.80809, 18.968402000000136],
              [83.802535, 18.981810000000159],
              [83.791169000000181, 18.992360000000186],
              [83.788947000000164, 18.998331],
              [83.788307, 19.00781],
              [83.790764008216954, 19.012802928898676],
              [83.794036000000105, 19.019452],
              [83.795350346250061, 19.022401000203157],
              [83.80665278602774, 19.026862489589288],
              [83.811411708039415, 19.024780461208987],
              [83.812304005916559, 19.021806134951699],
              [83.814476, 19.01573],
              [83.815765013603979, 19.012284179972877],
              [83.816459000000165, 19.010429],
              [83.820634, 19.00422100000014],
              [83.82431700000015, 19.000312000000175],
              [83.828461, 18.998161000000206],
              [83.837883211729235, 19.003067879530981],
              [83.845319027372497, 19.000390985899227],
              [83.849483084132686, 18.997119227016409],
              [83.85186254513853, 18.993847468133193],
              [83.852457410389988, 18.988493680870075],
              [83.853052275641431, 18.984329624109872],
              [83.855274016737937, 18.978264808473337],
              [83.864949580670597, 18.981355297852584],
              [83.868612275510287, 18.98644237401896],
              [83.870303367933715, 18.988791113496003],
              [83.872682828939546, 18.988791113496003],
              [83.879681145735091, 18.987672248488249],
              [83.881605807711409, 18.9846270567358],
              [83.884282701342926, 18.9846270567358],
              [83.890540024840377, 18.987908669679992],
              [83.890533594258926, 18.988340113170349],
              [83.89139466974278, 18.988356882685931],
              [83.89558514112062, 19.000093553273697],
              [83.900344063132295, 19.008719099419633],
              [83.904805552518241, 19.012585723554306],
              [83.909564474529915, 19.012288290928378],
              [83.914025963915805, 19.009611397297018],
              [83.922354077436225, 19.007529368916718],
              [83.927707864699343, 19.007529368916718],
              [83.936035978219735, 19.001283283776612],
              [83.943769226488683, 18.994739766010575],
              [83.947040985371743, 18.990575709250372],
              [83.955071666266392, 18.990278276624444],
              [83.961020318780967, 18.994739766010575],
              [83.966683000000202, 18.995911000000369],
              [83.972108000000205, 18.999002000000299],
              [83.974107238750179, 19.000842481102435],
              [83.976440000000125, 19.00299],
              [83.980363, 19.011940000000205],
              [83.978318000000101, 19.016492],
              [83.973343, 19.02193],
              [83.958718, 19.034289000000168],
              [83.957733, 19.036069],
              [83.960220000000149, 19.039502000000194],
              [83.95617, 19.042802],
              [83.95591, 19.04602],
              [83.957772, 19.05061],
              [83.964019, 19.057160000000174],
              [83.969352, 19.060481000000149],
              [83.969877268326158, 19.06065432640883],
              [83.975410000000167, 19.062480000000157],
              [83.978878422521277, 19.061653960341452],
              [83.992548177108219, 19.061959539425285],
              [84.000281425377167, 19.05511858903332],
              [84.006230077891729, 19.052441695401964],
              [84.014558191412149, 19.052441695401964],
              [84.02236366817219, 19.052636832320839],
              [84.025563198564129, 19.05273912802749],
              [84.026455496441301, 19.057795482665082],
              [84.025844120137592, 19.064706106456523],
              [84.02620026256497, 19.068692623952522],
              [84.01693765241798, 19.073261979202979],
              [84.016640219792279, 19.076533738085796],
              [84.01574792191505, 19.082184957974839],
              [84.013368460909234, 19.088728475740876],
              [84.013368460909234, 19.093784830378066],
              [84.012773595657777, 19.098543752389723],
              [84.012178730406305, 19.102112943898472],
              [84.013665893534991, 19.109548759541891],
              [84.015153056663607, 19.112523085799179],
              [84.015343781441615, 19.116292818294763],
              [84.010495716075781, 19.117330720177957],
              [84.012476163032062, 19.121743497196569],
              [84.014000372929033, 19.122219812789407],
              [84.017235085043737, 19.123230660325415],
              [84.022291439681098, 19.123230660325415],
              [84.024144480850893, 19.124757736568078],
              [84.026455496441301, 19.128881880214063],
              [84.023778602809756, 19.134830532728639],
              [84.01901968079811, 19.136317695857478],
              [84.008312106271873, 19.136912561108939],
              [84.003850616885913, 19.138697156863309],
              [83.999389127499995, 19.139886887366227],
              [83.991752000000162, 19.141420000000206],
              [83.9868969572194, 19.149702164015078],
              [83.984220063587799, 19.154461086026739],
              [83.981276394570486, 19.15871305238533],
              [83.982086000000123, 19.15925000000021],
              [83.986599524593643, 19.161896901670158],
              [83.988384120348016, 19.164573795301518],
              [83.9868969572194, 19.173496774073381],
              [83.985122152298217, 19.178377487606607],
              [83.984517496213556, 19.180040291839411],
              [83.979461141576152, 19.185988944353991],
              [83.976189382693164, 19.189855568488664],
              [83.970835595430046, 19.191937596868566],
              [83.9672664039213, 19.193127327371482],
              [83.970240730178588, 19.199075979886054],
              [83.972917623810105, 19.202942604020727],
              [83.977595321623753, 19.20600096683955],
              [83.980782000000232, 19.209081000000307],
              [83.98201417843562, 19.212211761904992],
              [83.982986000000139, 19.214681000000208],
              [83.982820000000103, 19.216691],
              [83.983613178829017, 19.21849193743747],
              [83.983869721807849, 19.219074426326582],
              [83.985167196977144, 19.222020384440494],
              [83.980650872079053, 19.230306405587775],
              [83.985112361465028, 19.232091001342152],
              [83.9868969572194, 19.23744478860527],
              [83.985112361465028, 19.244583171622761],
              [83.981840602581983, 19.248449795757036],
              [83.992250744482504, 19.254101015646082],
              [83.994390648437872, 19.254406716211175],
              [83.995392154952057, 19.259271176423109],
              [84.000626969165054, 19.259747068624446],
              [84.001404013085661, 19.263632288228273],
              [84.002530537969534, 19.269264912647596],
              [84.001102861366107, 19.275451511262698],
              [84.011115000000174, 19.281022000000174],
              [84.008752, 19.288281000000207],
              [84.008373918571507, 19.291026061801912],
              [84.007562000000163, 19.296921000000104],
              [84.007991663796119, 19.298504120211526],
              [84.008823174949882, 19.301567869418246],
              [84.009239, 19.303100000000139],
              [84.011582, 19.307321000000112],
              [84.012642725302356, 19.317180526910587],
              [84.015498078509367, 19.325984532632216],
              [84.017163701213505, 19.336692107158452],
              [84.015973970710576, 19.342164867471805],
              [84.013118617503523, 19.347399681684685],
              [84.010977102598403, 19.352634495897341],
              [84.007645857190184, 19.358583148411917],
              [84.008835587693099, 19.360010825015532],
              [84.011690940900138, 19.358583148411917],
              [84.012191000000186, 19.362471000000134],
              [84.009918, 19.366341],
              [84.007406657569874, 19.375200632475011],
              [84.003540033435442, 19.377580093480841],
              [83.991982, 19.377491000000184],
              [83.989356000000129, 19.375481000000146],
              [83.983408803460847, 19.373259786788193],
              [83.981530019131512, 19.37668779560385],
              [83.981232586505755, 19.379662121861141],
              [83.977960827622766, 19.381446717615514],
              [83.971714742482433, 19.384421043872802],
              [83.967848118347987, 19.381149284989586],
              [83.964840917999467, 19.377175228568085],
              [83.961724, 19.378129],
              [83.959212, 19.380741000000167],
              [83.956885, 19.38653],
              [83.954931967700972, 19.387208657858306],
              [83.953584332711259, 19.387676946619703],
              [83.953141, 19.387831],
              [83.950914339678533, 19.387892468862557],
              [83.94637055168964, 19.388017904015836],
              [83.936855638747133, 19.384316942453772],
              [83.930081800660602, 19.386906939369162],
              [83.928765471327253, 19.387410241761298],
              [83.926148064220897, 19.391931217672262],
              [83.922627391005889, 19.393784203574963],
              [83.926823887802001, 19.39887191425208],
              [83.927575740824324, 19.399783438991673],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Ganjam",
          Dist_Code: "388",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [84.76986, 19.105973],
                [84.76986, 19.104861],
                [84.769577000000126, 19.104861],
                [84.769577000000126, 19.104311],
                [84.769301, 19.104311],
                [84.769301, 19.104031000000184],
                [84.769028000000134, 19.104031000000184],
                [84.769028000000134, 19.103751],
                [84.768752, 19.103751],
                [84.768752, 19.103470000000122],
                [84.768472, 19.103473000000175],
                [84.768472, 19.103194000000197],
                [84.767907000000136, 19.103201],
                [84.767907000000136, 19.102641],
                [84.76764, 19.102641],
                [84.76764, 19.10208],
                [84.767364000000128, 19.102082],
                [84.767364000000128, 19.101804000000126],
                [84.766808000000182, 19.101804000000126],
                [84.766808000000182, 19.101528000000197],
                [84.766532, 19.10154000000011],
                [84.766532, 19.101250000000103],
                [84.765976, 19.101250000000103],
                [84.765976, 19.10097200000018],
                [84.765687000000113, 19.10097200000018],
                [84.765687000000113, 19.101250000000103],
                [84.765137, 19.101250000000103],
                [84.765137, 19.10154000000011],
                [84.764862, 19.101528000000197],
                [84.764862, 19.101804000000126],
                [84.765137, 19.101804000000126],
                [84.765137, 19.102082],
                [84.76542, 19.102082],
                [84.76542, 19.102363000000192],
                [84.765687000000113, 19.10236],
                [84.765687000000113, 19.102921000000148],
                [84.765976, 19.102921000000148],
                [84.765976, 19.103201],
                [84.76625000000017, 19.103201],
                [84.76625000000017, 19.103751],
                [84.766525, 19.103751],
                [84.766525, 19.104585000000153],
                [84.767082000000116, 19.104580000000109],
                [84.767082000000116, 19.104861],
                [84.767371000000182, 19.104861],
                [84.767371000000182, 19.10514100000017],
                [84.767913000000121, 19.105139000000175],
                [84.767913000000121, 19.105695000000189],
                [84.768752, 19.105695000000189],
                [84.768752, 19.105973],
                [84.76986, 19.105973],
              ],
            ],
            [
              [
                [84.756531000000152, 19.110971],
                [84.756531000000152, 19.110417],
                [84.756805, 19.110417],
                [84.756805, 19.109861],
                [84.75708100000017, 19.109861],
                [84.75708100000017, 19.109583000000153],
                [84.757363, 19.109583000000153],
                [84.757363, 19.109027000000193],
                [84.75708100000017, 19.109029000000188],
                [84.75708100000017, 19.108471000000176],
                [84.757919000000101, 19.108471000000176],
                [84.757919000000101, 19.109309],
                [84.758202, 19.109309],
                [84.758202, 19.110139000000171],
                [84.758751000000174, 19.110139000000171],
                [84.758751000000174, 19.109581],
                [84.760695, 19.109583000000153],
                [84.760695, 19.109027000000193],
                [84.759857, 19.109029000000188],
                [84.759857, 19.108749],
                [84.75958300000012, 19.108749],
                [84.75958300000012, 19.108190000000203],
                [84.759307, 19.108195],
                [84.759307, 19.107639],
                [84.759034000000142, 19.107641],
                [84.759034000000142, 19.107349],
                [84.757637, 19.107361000000189],
                [84.757637, 19.10680700000017],
                [84.757919000000101, 19.106809000000165],
                [84.757919000000101, 19.10569],
                [84.758193, 19.105695000000189],
                [84.758193, 19.105139000000175],
                [84.758469000000147, 19.10514100000017],
                [84.758469000000147, 19.104861],
                [84.759857, 19.104861],
                [84.759857, 19.10514100000017],
                [84.760695, 19.10514100000017],
                [84.760695, 19.105421],
                [84.761254000000164, 19.105417],
                [84.761254000000164, 19.105695000000189],
                [84.762359000000103, 19.105695000000189],
                [84.762359000000103, 19.105973],
                [84.762642, 19.105973],
                [84.762642, 19.107361000000189],
                [84.76291800000017, 19.107361000000189],
                [84.76291800000017, 19.107085],
                [84.764306, 19.107085],
                [84.764306, 19.107361000000189],
                [84.76542, 19.107361000000189],
                [84.76542, 19.107085],
                [84.765694000000153, 19.107085],
                [84.765694000000153, 19.104861],
                [84.76542, 19.104861],
                [84.76542, 19.104031000000184],
                [84.765137, 19.104031000000184],
                [84.765137, 19.103751],
                [84.764579000000111, 19.103751],
                [84.764579000000111, 19.103201],
                [84.764296000000158, 19.103201],
                [84.764296000000158, 19.102921000000148],
                [84.764030000000147, 19.102921000000148],
                [84.764030000000147, 19.102641],
                [84.763747000000166, 19.102641],
                [84.763747000000166, 19.10236],
                [84.76291800000017, 19.102363000000192],
                [84.76291800000017, 19.102082],
                [84.762086, 19.102082],
                [84.762086, 19.102363000000192],
                [84.760406000000145, 19.10236],
                [84.760406000000145, 19.102641],
                [84.759307, 19.102641],
                [84.759307, 19.10236],
                [84.758751000000174, 19.102363000000192],
                [84.758751000000174, 19.102082],
                [84.758469000000147, 19.102082],
                [84.758469000000147, 19.101804000000126],
                [84.758193, 19.101804000000126],
                [84.758193, 19.101528000000197],
                [84.756805, 19.101528000000197],
                [84.756805, 19.101804000000126],
                [84.756531000000152, 19.101802000000131],
                [84.756531000000152, 19.104311],
                [84.75708100000017, 19.10430400000018],
                [84.75708100000017, 19.104585000000153],
                [84.757363, 19.104580000000109],
                [84.757363, 19.105421],
                [84.75708100000017, 19.105417],
                [84.75708100000017, 19.105695000000189],
                [84.756805, 19.105695000000189],
                [84.756805, 19.105973],
                [84.756531000000152, 19.10597000000018],
                [84.756531000000152, 19.106251000000153],
                [84.756249000000111, 19.106251000000153],
                [84.756249000000111, 19.106809000000165],
                [84.755973, 19.10680700000017],
                [84.755973, 19.107085],
                [84.756249000000111, 19.107085],
                [84.756249000000111, 19.107361000000189],
                [84.755966000000157, 19.107349],
                [84.755966000000157, 19.107641],
                [84.756249000000111, 19.107641],
                [84.756249000000111, 19.108749],
                [84.755966000000157, 19.108749],
                [84.755966000000157, 19.109029000000188],
                [84.75569, 19.109029000000188],
                [84.75569, 19.109309],
                [84.755417000000179, 19.109307],
                [84.755417000000179, 19.109861],
                [84.755141, 19.109861],
                [84.755141, 19.110695000000188],
                [84.755417000000179, 19.110695000000188],
                [84.755417000000179, 19.110971],
                [84.756531000000152, 19.110971],
              ],
            ],
            [
              [
                [84.78319500000012, 19.110971],
                [84.78319500000012, 19.110695000000188],
                [84.783471, 19.110695000000188],
                [84.783471, 19.110139000000171],
                [84.783204000000154, 19.110139000000171],
                [84.783204000000154, 19.109859],
                [84.782639000000117, 19.109861],
                [84.782639000000117, 19.108473000000171],
                [84.782363, 19.108473000000171],
                [84.782363, 19.107917000000153],
                [84.782081000000161, 19.107919000000148],
                [84.782081000000161, 19.107641],
                [84.781807, 19.107641],
                [84.781807, 19.105421],
                [84.781518, 19.105421],
                [84.781518, 19.104580000000109],
                [84.781251, 19.104585000000153],
                [84.781251, 19.104029000000189],
                [84.780982000000137, 19.104031000000184],
                [84.780982000000137, 19.103201],
                [84.780693, 19.103201],
                [84.780693, 19.102921000000148],
                [84.780419000000137, 19.102921000000148],
                [84.780419000000137, 19.102641],
                [84.780136000000184, 19.102641],
                [84.780136000000184, 19.10236],
                [84.779861000000139, 19.102363000000192],
                [84.779861000000139, 19.102082],
                [84.779587, 19.102082],
                [84.779587, 19.101804000000126],
                [84.779305000000107, 19.101804000000126],
                [84.779305000000107, 19.101528000000197],
                [84.779029, 19.10154000000011],
                [84.779029, 19.10097200000018],
                [84.778748, 19.10097200000018],
                [84.778748, 19.100416],
                [84.778473, 19.100421],
                [84.778473, 19.10014000000012],
                [84.778199000000129, 19.10014000000012],
                [84.77819, 19.099860000000199],
                [84.777917, 19.099860000000199],
                [84.777917, 19.099580000000113],
                [84.777641000000116, 19.099582000000105],
                [84.777641000000116, 19.09930600000018],
                [84.777358000000149, 19.099311],
                [84.777358000000149, 19.097921000000152],
                [84.777078000000117, 19.097921000000152],
                [84.777078000000117, 19.09764000000018],
                [84.776802, 19.09764000000018],
                [84.776802, 19.09708],
                [84.776526, 19.097084],
                [84.776526, 19.096528000000202],
                [84.775697, 19.096530000000193],
                [84.775697, 19.09597],
                [84.775414, 19.095972000000184],
                [84.775414, 19.095694],
                [84.775138000000169, 19.095694],
                [84.775138000000169, 19.095418],
                [84.774865000000119, 19.095418],
                [84.774865000000119, 19.094306000000181],
                [84.774582000000166, 19.094310000000174],
                [84.774582000000166, 19.09375],
                [84.774306, 19.09375],
                [84.774306, 19.092920000000102],
                [84.774033, 19.092920000000102],
                [84.774033, 19.092081000000114],
                [84.77375, 19.092084],
                [84.77375, 19.091528000000206],
                [84.773468, 19.091530000000201],
                [84.773468, 19.091250000000112],
                [84.773178, 19.091250000000112],
                [84.773178, 19.090691],
                [84.772918000000146, 19.090693000000208],
                [84.772918000000146, 19.090415000000117],
                [84.772636, 19.09042],
                [84.772636, 19.09014000000013],
                [84.772087000000141, 19.09014000000013],
                [84.772087000000141, 19.089581],
                [84.771804, 19.089583],
                [84.771804, 19.088752],
                [84.77153, 19.088752],
                [84.77153, 19.087922000000102],
                [84.771248000000156, 19.087922000000102],
                [84.771248000000156, 19.087361000000211],
                [84.770974, 19.087361000000211],
                [84.770974, 19.086532000000201],
                [84.770692000000153, 19.086532000000201],
                [84.770692000000153, 19.086240000000199],
                [84.770416, 19.086251],
                [84.770416, 19.085695000000211],
                [84.770142000000121, 19.085702],
                [84.770142000000121, 19.085139],
                [84.76986, 19.085139],
                [84.76986, 19.084579],
                [84.769584000000165, 19.084583],
                [84.769584000000165, 19.084029000000211],
                [84.769301, 19.084029000000211],
                [84.769301, 19.083749000000122],
                [84.769028000000134, 19.083749000000122],
                [84.769028000000134, 19.083179],
                [84.768752, 19.083195000000156],
                [84.768752, 19.082639000000139],
                [84.768472, 19.082639000000139],
                [84.768472, 19.082081000000183],
                [84.768196, 19.082083000000122],
                [84.768196, 19.081527000000161],
                [84.767907000000136, 19.081529000000156],
                [84.767907000000136, 19.081251],
                [84.76764, 19.081251],
                [84.76764, 19.08097100000014],
                [84.767364000000128, 19.080973000000135],
                [84.767364000000128, 19.080417000000121],
                [84.767082000000116, 19.080430000000145],
                [84.767082000000116, 19.079861000000161],
                [84.766808000000182, 19.079861000000161],
                [84.766808000000182, 19.079580000000188],
                [84.766525, 19.079585],
                [84.766525, 19.079027],
                [84.76625000000017, 19.07903100000021],
                [84.76625000000017, 19.078470000000149],
                [84.765976, 19.078473],
                [84.765976, 19.078195000000161],
                [84.765694000000153, 19.078195000000161],
                [84.765694000000153, 19.077917],
                [84.76542, 19.077921],
                [84.76542, 19.07737],
                [84.765137, 19.07737],
                [84.765137, 19.07708],
                [84.764862, 19.077085000000118],
                [84.764862, 19.075694000000166],
                [84.764579000000111, 19.075701000000205],
                [84.764579000000111, 19.07486],
                [84.764306, 19.07486300000016],
                [84.764306, 19.074582000000188],
                [84.763474, 19.074582000000188],
                [84.763474, 19.074306],
                [84.763191, 19.074306],
                [84.763191, 19.07375],
                [84.76291800000017, 19.07375],
                [84.76291800000017, 19.07347000000015],
                [84.762642, 19.073472000000145],
                [84.762642, 19.073194],
                [84.762359000000103, 19.073194],
                [84.762359000000103, 19.07264],
                [84.762086, 19.07264],
                [84.762086, 19.07236000000017],
                [84.761803, 19.07236000000017],
                [84.761803, 19.07208],
                [84.761527, 19.072082],
                [84.761527, 19.071528],
                [84.761238, 19.07153],
                [84.761254000000164, 19.071250000000187],
                [84.761147, 19.071277000000119],
                [84.761017, 19.071312000000145],
                [84.730217, 19.089305000000135],
                [84.732361000000182, 19.089305000000135],
                [84.732361000000182, 19.089583],
                [84.732917000000143, 19.089581],
                [84.732917000000143, 19.089862000000206],
                [84.733467000000175, 19.089862000000206],
                [84.733467000000175, 19.09014000000013],
                [84.733749, 19.09014000000013],
                [84.733749, 19.09042],
                [84.734025, 19.090415000000117],
                [84.734025, 19.090693000000208],
                [84.734321000000179, 19.090691],
                [84.734321000000179, 19.091530000000201],
                [84.735969000000111, 19.091530000000201],
                [84.735969000000111, 19.09181000000012],
                [84.737640000000141, 19.09180600000013],
                [84.737640000000141, 19.092084],
                [84.739303, 19.092084],
                [84.739303, 19.091528000000206],
                [84.739586, 19.091530000000201],
                [84.739586, 19.090691],
                [84.739860000000178, 19.090693000000208],
                [84.739860000000178, 19.090415000000117],
                [84.740142, 19.09042],
                [84.740142, 19.089862000000206],
                [84.740974000000151, 19.089862000000206],
                [84.740967000000111, 19.089310000000179],
                [84.74125, 19.089310000000179],
                [84.74125, 19.088471],
                [84.741806, 19.088471],
                [84.741806, 19.088193000000157],
                [84.742082000000124, 19.088193000000157],
                [84.742082000000124, 19.087917],
                [84.742638000000156, 19.087922000000102],
                [84.742638000000156, 19.087642000000184],
                [84.743752000000129, 19.087642000000184],
                [84.743752000000129, 19.087922000000102],
                [84.744026, 19.087917],
                [84.744026, 19.088193000000157],
                [84.744308000000146, 19.088193000000157],
                [84.744308000000146, 19.088471],
                [84.744858000000178, 19.088471],
                [84.744858000000178, 19.088752],
                [84.74514, 19.088752],
                [84.74514, 19.089032],
                [84.7454070000001, 19.089032],
                [84.7454070000001, 19.089310000000179],
                [84.745696, 19.089310000000179],
                [84.745696, 19.09042],
                [84.745972000000137, 19.090415000000117],
                [84.745972000000137, 19.090693000000208],
                [84.74736, 19.090693000000208],
                [84.74736, 19.090415000000117],
                [84.748192000000117, 19.09042],
                [84.748192000000117, 19.09014000000013],
                [84.749031000000102, 19.09014000000013],
                [84.749031000000102, 19.089862000000206],
                [84.749297000000112, 19.089862000000206],
                [84.749297000000112, 19.089581],
                [84.74958, 19.089583],
                [84.74958, 19.088471],
                [84.749307, 19.088471],
                [84.749307, 19.087639000000134],
                [84.750138, 19.087642000000184],
                [84.750138, 19.087361000000211],
                [84.751251000000124, 19.087361000000211],
                [84.751251000000124, 19.087642000000184],
                [84.751526000000112, 19.087642000000184],
                [84.751526000000112, 19.087922000000102],
                [84.752083000000184, 19.087922000000102],
                [84.752083000000184, 19.087081000000122],
                [84.751526000000112, 19.087083000000117],
                [84.751526000000112, 19.086805],
                [84.750968000000157, 19.086812000000119],
                [84.750968000000157, 19.085971000000139],
                [84.750695000000107, 19.085971000000139],
                [84.750695000000107, 19.084583],
                [84.750419000000164, 19.084583],
                [84.750419000000164, 19.082639000000139],
                [84.750688, 19.082639000000139],
                [84.750688, 19.082081000000183],
                [84.750968000000157, 19.082081000000183],
                [84.750968000000157, 19.082361],
                [84.751526000000112, 19.082361],
                [84.751526000000112, 19.082919],
                [84.751809, 19.082919],
                [84.751809, 19.084029000000211],
                [84.752083000000184, 19.084029000000211],
                [84.752083000000184, 19.084305000000139],
                [84.752358, 19.084305000000139],
                [84.752358, 19.084583],
                [84.752639, 19.084583],
                [84.752639, 19.084861000000153],
                [84.752908, 19.084859000000161],
                [84.752908, 19.085139],
                [84.753197, 19.085139],
                [84.753197, 19.08542],
                [84.755141, 19.08542],
                [84.755141, 19.085702],
                [84.755417000000179, 19.085695000000211],
                [84.755417000000179, 19.085971000000139],
                [84.755973, 19.085971000000139],
                [84.755973, 19.086251],
                [84.75708100000017, 19.086240000000199],
                [84.75708100000017, 19.086532000000201],
                [84.757363, 19.086532000000201],
                [84.757363, 19.086812000000119],
                [84.757637, 19.086805],
                [84.757637, 19.087083000000117],
                [84.757919000000101, 19.087081000000122],
                [84.757919000000101, 19.087361000000211],
                [84.758193, 19.087361000000211],
                [84.758202, 19.088752],
                [84.757919000000101, 19.088752],
                [84.757919000000101, 19.089583],
                [84.758202, 19.089581],
                [84.758202, 19.091530000000201],
                [84.757919000000101, 19.091530000000201],
                [84.757919000000101, 19.09181000000012],
                [84.758202, 19.09181000000012],
                [84.758202, 19.092371000000124],
                [84.758469000000147, 19.092362],
                [84.758469000000147, 19.094862000000202],
                [84.758193, 19.094862000000202],
                [84.758193, 19.095694],
                [84.757919000000101, 19.095689],
                [84.757919000000101, 19.096250000000108],
                [84.757637, 19.096250000000108],
                [84.757637, 19.09736],
                [84.757363, 19.09736],
                [84.757363, 19.098472000000125],
                [84.757637, 19.09847000000013],
                [84.757637, 19.09875],
                [84.757919000000101, 19.09875],
                [84.757919000000101, 19.099031000000192],
                [84.758202, 19.099031000000192],
                [84.758202, 19.099311],
                [84.758751000000174, 19.09930600000018],
                [84.758751000000174, 19.099582000000105],
                [84.759025000000108, 19.099582000000105],
                [84.759025000000108, 19.10014000000012],
                [84.759307, 19.10014000000012],
                [84.759307, 19.100694],
                [84.75958300000012, 19.100694],
                [84.75958300000012, 19.100416],
                [84.760406000000145, 19.100421],
                [84.760406000000145, 19.10014000000012],
                [84.761803, 19.10014000000012],
                [84.761803, 19.100421],
                [84.764862, 19.100421],
                [84.764862, 19.099860000000199],
                [84.765137, 19.099860000000199],
                [84.765137, 19.099580000000113],
                [84.765687000000113, 19.099580000000113],
                [84.765687000000113, 19.100421],
                [84.76625000000017, 19.100416],
                [84.76625000000017, 19.100694],
                [84.766808000000182, 19.100694],
                [84.766808000000182, 19.10097200000018],
                [84.767082000000116, 19.10097200000018],
                [84.767082000000116, 19.101250000000103],
                [84.76764, 19.101250000000103],
                [84.76764, 19.10154000000011],
                [84.768196, 19.101528000000197],
                [84.768196, 19.102082],
                [84.768472, 19.102082],
                [84.768472, 19.102363000000192],
                [84.769028000000134, 19.10236],
                [84.769028000000134, 19.102641],
                [84.769301, 19.102641],
                [84.769301, 19.102921000000148],
                [84.769577000000126, 19.102921000000148],
                [84.769577000000126, 19.103201],
                [84.76986, 19.103194000000197],
                [84.76986, 19.103473000000175],
                [84.770142000000121, 19.103470000000122],
                [84.770142000000121, 19.103751],
                [84.770432000000184, 19.103751],
                [84.770432000000184, 19.104031000000184],
                [84.770692000000153, 19.104031000000184],
                [84.770692000000153, 19.104311],
                [84.772087000000141, 19.10430400000018],
                [84.772087000000141, 19.104585000000153],
                [84.772362000000143, 19.104580000000109],
                [84.772362000000143, 19.104861],
                [84.772918000000146, 19.104861],
                [84.772918000000146, 19.10514100000017],
                [84.773468, 19.10514100000017],
                [84.773468, 19.105421],
                [84.774026000000148, 19.105417],
                [84.774026000000148, 19.105695000000189],
                [84.774582000000166, 19.105695000000189],
                [84.774582000000166, 19.105973],
                [84.775138000000169, 19.10597000000018],
                [84.775138000000169, 19.106251000000153],
                [84.775697, 19.106251000000153],
                [84.775697, 19.106531],
                [84.776237000000137, 19.106531],
                [84.776237000000137, 19.106809000000165],
                [84.776526, 19.10680700000017],
                [84.776526, 19.107083],
                [84.776802, 19.107085],
                [84.776802, 19.107361000000189],
                [84.777078000000117, 19.107349],
                [84.777078000000117, 19.107641],
                [84.777358000000149, 19.107641],
                [84.777358000000149, 19.107919000000148],
                [84.777917, 19.107917000000153],
                [84.777917, 19.108195],
                [84.778473, 19.108195],
                [84.778473, 19.108473000000171],
                [84.779029, 19.108471000000176],
                [84.779029, 19.108749],
                [84.779311, 19.108749],
                [84.779311, 19.109029000000188],
                [84.780136000000184, 19.109029000000188],
                [84.780136000000184, 19.109309],
                [84.780419000000137, 19.109307],
                [84.780419000000137, 19.109583000000153],
                [84.780693, 19.109583000000153],
                [84.780693, 19.109861],
                [84.780982000000137, 19.109859],
                [84.780982000000137, 19.110139000000171],
                [84.781251, 19.110139000000171],
                [84.781251, 19.110417],
                [84.781807, 19.110417],
                [84.781807, 19.110695000000188],
                [84.782363, 19.110695000000188],
                [84.782363, 19.110971],
                [84.78319500000012, 19.110971],
              ],
            ],
            [
              [
                [85.163153184138409, 19.61774520309887],
                [85.163906413775678, 19.609289612947798],
                [85.161725991710895, 19.593590574081414],
                [85.160337222266932, 19.583591434084887],
                [85.158909545663491, 19.559320931825365],
                [85.153198839249441, 19.547899518997436],
                [85.139635911516137, 19.532908914660535],
                [85.12535914548117, 19.522201340134295],
                [85.127500660386474, 19.510066089004678],
                [85.143303, 19.483361000000169],
                [85.143547000000154, 19.489451],
                [85.152657, 19.474411000000199],
                [85.164994000000135, 19.461718000000129],
                [85.164718, 19.461671000000187],
                [85.164428, 19.46139],
                [85.164169, 19.46139],
                [85.163886, 19.461110000000129],
                [85.163612000000143, 19.461110000000129],
                [85.163063, 19.460561000000151],
                [85.162781000000138, 19.460561000000151],
                [85.162215, 19.46],
                [85.161796, 19.459462000000197],
                [85.158493000000107, 19.457210000000199],
                [85.155000000000129, 19.454165000000156],
                [85.154717000000147, 19.4541700000002],
                [85.154441, 19.453890000000111],
                [85.154168000000183, 19.453890000000111],
                [85.152780000000106, 19.452499000000156],
                [85.152488000000105, 19.452499000000156],
                [85.152214000000171, 19.452271000000106],
                [85.151948000000161, 19.452224000000111],
                [85.146384, 19.448333],
                [85.146111, 19.448055000000121],
                [85.145835000000119, 19.448062],
                [85.142220000000165, 19.445279000000138],
                [85.141671, 19.444721000000126],
                [85.141389000000146, 19.444723000000121],
                [85.14083, 19.444167000000157],
                [85.140258000000173, 19.444169000000151],
                [85.139442, 19.44333000000017],
                [85.135559, 19.440001],
                [85.133888000000155, 19.438321000000141],
                [85.132012, 19.43688300000019],
                [85.129166, 19.434444000000148],
                [85.128051000000184, 19.433332000000174],
                [85.127778, 19.433332000000174],
                [85.12639, 19.431944],
                [85.126114, 19.431944],
                [85.125831, 19.431668000000169],
                [85.12554900000012, 19.431670000000164],
                [85.122964000000124, 19.43005],
                [85.121827, 19.429229000000131],
                [85.120689000000183, 19.428149000000129],
                [85.118697, 19.42654],
                [85.117271000000159, 19.425439],
                [85.115853, 19.423819000000147],
                [85.114433000000162, 19.422460000000168],
                [85.112503, 19.421111000000103],
                [85.111664, 19.420279],
                [85.111657, 19.420001000000124],
                [85.110832000000116, 19.419169000000178],
                [85.107856000000126, 19.416692],
                [85.105583000000124, 19.414800000000177],
                [85.104729000000162, 19.41377],
                [85.104302, 19.4132320000001],
                [85.103806000000162, 19.412555],
                [85.10324, 19.411881],
                [85.102805000000146, 19.41134],
                [85.10231, 19.41073],
                [85.10196, 19.410189],
                [85.101319000000146, 19.409510000000179],
                [85.101089000000101, 19.409171000000182],
                [85.100601, 19.408425000000133],
                [85.100455, 19.407949000000141],
                [85.099892000000168, 19.407548000000187],
                [85.099541, 19.407010000000124],
                [85.099168000000105, 19.406390000000151],
                [85.098343, 19.405572000000113],
                [85.098343, 19.405280000000115],
                [85.098053, 19.405],
                [85.098053, 19.404720000000165],
                [85.097221000000147, 19.403888],
                [85.097221000000147, 19.403610000000182],
                [85.096948000000154, 19.403329000000152],
                [85.096948000000154, 19.403056000000159],
                [85.096389, 19.402500000000138],
                [85.096389, 19.401950000000109],
                [85.096107000000174, 19.40167],
                [85.096107000000174, 19.401390000000159],
                [85.093887000000151, 19.399170000000133],
                [85.093613, 19.399170000000133],
                [85.093613, 19.39889],
                [85.092781000000144, 19.398060000000154],
                [85.092781000000144, 19.39778],
                [85.092209, 19.397221000000169],
                [85.092223000000146, 19.396667000000146],
                [85.091667, 19.396111000000186],
                [85.091667, 19.395562000000208],
                [85.091393, 19.395282000000115],
                [85.091393, 19.395001000000143],
                [85.091111000000154, 19.394721000000111],
                [85.090835, 19.394721000000111],
                [85.090233000000168, 19.392654000000103],
                [85.08741, 19.389917000000136],
                [85.086129, 19.387751000000147],
                [85.085267000000144, 19.385851000000169],
                [85.085105, 19.384465],
                [85.083893000000145, 19.382767000000108],
                [85.083045000000169, 19.381951],
                [85.081757, 19.381005000000126],
                [85.080558, 19.380280000000191],
                [85.07972, 19.379439],
                [85.07972, 19.379168],
                [85.077766, 19.377220000000133],
                [85.076112000000109, 19.378890000000123],
                [85.075547, 19.378890000000123],
                [85.074464, 19.37778],
                [85.074172, 19.37778],
                [85.07389, 19.3775],
                [85.073609000000133, 19.3775],
                [85.073327, 19.377220000000133],
                [85.07306, 19.377222000000128],
                [85.072777, 19.376944000000204],
                [85.072502, 19.376944000000204],
                [85.071663, 19.376112000000145],
                [85.071663, 19.375834],
                [85.068885, 19.373056],
                [85.068611000000118, 19.373060000000173],
                [85.068046, 19.372499000000111],
                [85.067779, 19.372499000000111],
                [85.067497000000159, 19.37221],
                [85.066369, 19.371761],
                [85.066184, 19.371663],
                [85.065621000000178, 19.369044],
                [85.065063, 19.366916],
                [85.06516300000014, 19.366897000000105],
                [85.065940000000111, 19.366754000000125],
                [85.066223, 19.366483000000127],
                [85.066223, 19.365806],
                [85.066008, 19.365534],
                [85.065368, 19.364992000000196],
                [85.064721000000176, 19.364445],
                [85.064155, 19.364146000000172],
                [85.063798000000176, 19.363809],
                [85.063103, 19.36367],
                [85.062501000000154, 19.363333],
                [85.061669, 19.363333],
                [85.061578000000154, 19.363242000000177],
                [85.061386, 19.363057000000133],
                [85.060837000000149, 19.363059000000131],
                [85.060548, 19.362779],
                [85.060281000000131, 19.362779],
                [85.059998000000164, 19.362501000000176],
                [85.059723000000176, 19.362501000000176],
                [85.059456000000111, 19.362221],
                [85.059166, 19.362223],
                [85.058608, 19.361667],
                [85.058328000000159, 19.361669],
                [85.058052, 19.361391000000133],
                [85.057503000000139, 19.361391000000133],
                [85.05722, 19.361111],
                [85.056947000000136, 19.361111],
                [85.05665500000012, 19.36083],
                [85.056388, 19.360835000000176],
                [85.055832000000109, 19.360276000000109],
                [85.055556000000166, 19.360001],
                [85.055556000000166, 19.35972],
                [85.055276, 19.359445],
                [85.055000000000163, 19.359445],
                [85.054727000000113, 19.359166],
                [85.053330000000173, 19.359171000000114],
                [85.053040000000152, 19.358891],
                [85.052780000000141, 19.358891],
                [85.052498000000114, 19.358610000000109],
                [85.05222400000018, 19.358613000000158],
                [85.051666000000154, 19.358054],
                [85.051392, 19.358061000000127],
                [85.050827, 19.3575],
                [85.050278, 19.3575],
                [85.050002000000148, 19.357222000000146],
                [85.049446000000145, 19.357232000000121],
                [85.049156000000124, 19.356951000000148],
                [85.048607, 19.356951000000148],
                [85.048331000000118, 19.356671],
                [85.048058, 19.356671],
                [85.047684, 19.356297000000207],
                [85.047500000000113, 19.356110000000168],
                [85.047226000000165, 19.356112000000163],
                [85.046943, 19.355832],
                [85.046670000000162, 19.355832],
                [85.046577000000113, 19.355741000000187],
                [85.046387, 19.355556000000142],
                [85.046112, 19.355561],
                [85.045829, 19.355281000000158],
                [85.045562000000174, 19.355281000000158],
                [85.044997000000123, 19.354722],
                [85.044724, 19.354722],
                [85.043892000000184, 19.353890000000142],
                [85.043609, 19.353890000000142],
                [85.043053, 19.353330000000195],
                [85.0427770000001, 19.35333200000019],
                [85.04222100000014, 19.352778000000168],
                [85.041945, 19.352780000000163],
                [85.0411, 19.351939],
                [85.040275, 19.351944000000113],
                [85.039719, 19.351388],
                [85.039436, 19.35139],
                [85.039299000000128, 19.351244],
                [85.039169000000172, 19.351110000000173],
                [85.03888700000013, 19.351110000000173],
                [85.038536, 19.350761],
                [85.038331000000127, 19.350556000000207],
                [85.038064, 19.35056000000014],
                [85.03796400000013, 19.350465],
                [85.037781, 19.350280000000108],
                [85.037499, 19.350280000000108],
                [85.037216, 19.350000000000186],
                [85.036393, 19.350000000000186],
                [85.036111000000105, 19.349719],
                [85.035552, 19.349722],
                [85.035003000000103, 19.349168],
                [85.0344470000001, 19.348610000000118],
                [85.034164000000118, 19.348612000000113],
                [85.033608000000172, 19.348056],
                [85.033332, 19.348056],
                [85.033059, 19.347778000000172],
                [85.032501, 19.347780000000167],
                [85.032227, 19.3475],
                [85.031669000000122, 19.3475],
                [85.031388000000135, 19.347219000000106],
                [85.031113, 19.347222],
                [85.030556, 19.34666500000014],
                [85.030281, 19.346670000000181],
                [85.029159, 19.345560000000145],
                [85.028893000000139, 19.345560000000145],
                [85.028343, 19.345002000000189],
                [85.028054000000154, 19.345002000000189],
                [85.027778, 19.344721],
                [85.027496000000127, 19.344724],
                [85.027222, 19.344443000000123],
                [85.026664, 19.344443000000123],
                [85.026390000000148, 19.344165000000199],
                [85.026101, 19.34417],
                [85.025834000000131, 19.343892000000206],
                [85.025558, 19.343892000000206],
                [85.024437, 19.342782000000163],
                [85.024170000000126, 19.342782000000163],
                [85.023888, 19.342501000000194],
                [85.02361200000017, 19.342501000000194],
                [85.023056000000139, 19.341941],
                [85.022782, 19.341943],
                [85.022643, 19.341806],
                [85.022500000000136, 19.34166700000014],
                [85.022217000000168, 19.341672000000184],
                [85.021668, 19.341111000000122],
                [85.021385000000109, 19.341111000000122],
                [85.020836000000116, 19.340555000000101],
                [85.020547, 19.340562000000144],
                [85.019997, 19.340001000000139],
                [85.019448, 19.340001000000139],
                [85.019172000000125, 19.339721],
                [85.01889, 19.339721],
                [85.01833300000014, 19.339167000000199],
                [85.018058000000138, 19.339167000000199],
                [85.017846000000162, 19.338957],
                [85.017768000000146, 19.338941000000144],
                [85.017502000000135, 19.338889000000105],
                [85.016930000000102, 19.338331000000146],
                [85.01667, 19.338333000000144],
                [85.016387, 19.338053],
                [85.016114, 19.337779000000122],
                [85.015831, 19.337779000000122],
                [85.015555000000148, 19.337499000000204],
                [85.015266, 19.337499000000204],
                [85.01505400000012, 19.33727500000014],
                [85.014999, 19.33722100000011],
                [85.014726000000152, 19.337223000000105],
                [85.014167, 19.336667000000141],
                [85.013894, 19.336669000000139],
                [85.013611, 19.336389],
                [85.013335000000126, 19.336389],
                [85.011674, 19.334720000000168],
                [85.011391000000103, 19.334723],
                [85.011300000000162, 19.334632000000166],
                [85.010833, 19.334167000000203],
                [85.010559000000143, 19.334169000000198],
                [85.010277, 19.333891000000104],
                [85.01000300000014, 19.333891000000104],
                [85.009721, 19.333611],
                [85.009162, 19.333611],
                [85.008889000000153, 19.33333],
                [85.008613, 19.33333500000014],
                [85.0083300000001, 19.333054000000168],
                [85.008057, 19.33306100000021],
                [85.006942, 19.331940000000142],
                [85.006669, 19.331944000000131],
                [85.006386, 19.331666],
                [85.005837, 19.331671000000135],
                [85.005548000000132, 19.331391],
                [85.005279, 19.331391],
                [85.004722000000172, 19.330830000000155],
                [85.004449000000179, 19.330835000000203],
                [85.003608, 19.33],
                [85.003325, 19.33],
                [85.000137, 19.328669],
                [85.000137, 19.328751000000121],
                [84.999863000000161, 19.328751000000121],
                [84.999863000000161, 19.328471000000203],
                [84.999581, 19.328471000000203],
                [84.999581, 19.328193000000109],
                [84.999031, 19.328193000000109],
                [84.999031, 19.327917000000181],
                [84.998466, 19.327922],
                [84.998466, 19.327641],
                [84.997643000000124, 19.327641],
                [84.997643000000124, 19.32709200000016],
                [84.997361, 19.32709200000016],
                [84.997361, 19.326812],
                [84.997094, 19.326812],
                [84.997094, 19.32625100000018],
                [84.996529000000166, 19.32625100000018],
                [84.996529000000166, 19.325969000000153],
                [84.995971000000154, 19.325971],
                [84.995971000000154, 19.325695],
                [84.995697, 19.3257],
                [84.995697, 19.325419000000117],
                [84.995141, 19.325419000000117],
                [84.995141, 19.325139000000203],
                [84.994858000000107, 19.325139000000203],
                [84.994858000000107, 19.324859000000114],
                [84.994309000000143, 19.324861000000109],
                [84.994309000000143, 19.324029],
                [84.993751, 19.324029],
                [84.993751, 19.323749000000131],
                [84.99347, 19.323749000000131],
                [84.99347, 19.323471000000207],
                [84.992638, 19.323473000000202],
                [84.992638, 19.323195000000108],
                [84.992363, 19.323195000000108],
                [84.992363, 19.322917000000185],
                [84.991531000000165, 19.32291900000018],
                [84.991531000000165, 19.322639],
                [84.991248, 19.322639],
                [84.991248, 19.32208],
                [84.99069200000018, 19.322083000000131],
                [84.99069200000018, 19.321807000000202],
                [84.990419, 19.321809000000197],
                [84.990419, 19.321529000000105],
                [84.990150000000114, 19.321529000000105],
                [84.990150000000114, 19.320961000000175],
                [84.989587, 19.320973],
                [84.989587, 19.320417000000131],
                [84.988472, 19.32042100000012],
                [84.988472, 19.320141000000199],
                [84.987358000000171, 19.320141000000199],
                [84.987358000000171, 19.31986100000011],
                [84.986808000000153, 19.31986100000011],
                [84.986808000000153, 19.319580000000137],
                [84.986252, 19.319585000000185],
                [84.986252, 19.319304],
                [84.985687000000127, 19.319311],
                [84.985687000000127, 19.319031],
                [84.985138, 19.319031],
                [84.985138, 19.318470000000158],
                [84.984864000000115, 19.318473000000203],
                [84.984864000000115, 19.318194],
                [84.984306000000103, 19.318194],
                [84.984306000000103, 19.317638],
                [84.984017000000151, 19.317641],
                [84.984017000000151, 19.317360000000118],
                [84.98375, 19.317363],
                [84.98375, 19.317082],
                [84.983474, 19.317082],
                [84.983474, 19.316804000000158],
                [84.982918, 19.316804000000158],
                [84.982918, 19.316528],
                [84.98236200000018, 19.316531000000108],
                [84.98236200000018, 19.316250000000132],
                [84.98153000000012, 19.316250000000132],
                [84.98153000000012, 19.31597],
                [84.980972000000108, 19.315972],
                [84.980972000000108, 19.315694000000118],
                [84.980415, 19.315694000000118],
                [84.980415, 19.315416],
                [84.98014, 19.315421000000125],
                [84.98014, 19.31458200000014],
                [84.979584, 19.31458200000014],
                [84.979584, 19.314028000000114],
                [84.978752, 19.314030000000113],
                [84.978752, 19.313470000000162],
                [84.978196000000111, 19.313472000000157],
                [84.978196000000111, 19.313194],
                [84.977637, 19.313194],
                [84.977637, 19.31291600000014],
                [84.977357000000126, 19.312921000000181],
                [84.977357000000126, 19.312640000000208],
                [84.976808, 19.312640000000208],
                [84.976808, 19.31209100000012],
                [84.975983000000127, 19.31209100000012],
                [84.975983000000127, 19.311811000000201],
                [84.975693000000135, 19.311811000000201],
                [84.975693000000135, 19.31153],
                [84.975135000000179, 19.31153],
                [84.975135000000179, 19.31097],
                [84.974861, 19.310972],
                [84.974861, 19.310418],
                [84.974585000000133, 19.31042],
                [84.974585000000133, 19.310140000000157],
                [84.974296, 19.310140000000157],
                [84.974296, 19.30986],
                [84.974029000000129, 19.30986],
                [84.974029000000129, 19.309579],
                [84.973197000000184, 19.30958400000014],
                [84.973197000000184, 19.309306],
                [84.972924, 19.309310000000202],
                [84.972924, 19.309021],
                [84.972641, 19.309028000000122],
                [84.972641, 19.30875],
                [84.972076000000172, 19.30875],
                [84.972076000000172, 19.308469],
                [84.971527, 19.308472000000158],
                [84.971527, 19.308196],
                [84.971253000000146, 19.3082],
                [84.971253000000146, 19.307920000000134],
                [84.970412000000167, 19.307920000000134],
                [84.970412000000167, 19.30764],
                [84.970139000000117, 19.30764],
                [84.970139000000117, 19.307359],
                [84.969863, 19.307362000000122],
                [84.969863, 19.307084],
                [84.96958, 19.307084],
                [84.96958, 19.306528],
                [84.969307, 19.30653],
                [84.969307, 19.306250000000144],
                [84.968751, 19.306250000000144],
                [84.968751, 19.305960000000137],
                [84.968475, 19.305974],
                [84.968475, 19.305696000000122],
                [84.967919000000137, 19.305696000000122],
                [84.967919000000137, 19.305415000000149],
                [84.967636000000184, 19.30542],
                [84.967636000000184, 19.304862],
                [84.967361000000139, 19.304862],
                [84.967361000000139, 19.304310000000211],
                [84.967087, 19.304310000000211],
                [84.967087, 19.304030000000122],
                [84.966798, 19.304030000000122],
                [84.966798, 19.303752],
                [84.966529, 19.303752],
                [84.966529, 19.303471],
                [84.966804, 19.303474000000161],
                [84.966804, 19.302917],
                [84.967087, 19.302920000000139],
                [84.967087, 19.302361],
                [84.967361000000139, 19.302361],
                [84.967361000000139, 19.302081000000154],
                [84.967636000000184, 19.302083000000149],
                [84.967636000000184, 19.301527000000188],
                [84.967919000000137, 19.301532],
                [84.967919000000137, 19.301251],
                [84.966529, 19.301251],
                [84.966529, 19.300971000000168],
                [84.966804, 19.300971000000168],
                [84.966804, 19.300693],
                [84.967087, 19.300693],
                [84.967087, 19.300417000000149],
                [84.967361000000139, 19.300422],
                [84.967361000000139, 19.300151000000195],
                [84.967636000000184, 19.300151000000195],
                [84.967636000000184, 19.299578],
                [84.967919000000137, 19.299583],
                [84.967919000000137, 19.299305000000167],
                [84.968482000000137, 19.29931],
                [84.968482000000137, 19.299029],
                [84.969018000000105, 19.299029],
                [84.969018000000105, 19.298469000000122],
                [84.967361000000139, 19.298469000000122],
                [84.967361000000139, 19.298749000000154],
                [84.967087, 19.298749000000154],
                [84.967087, 19.299159000000198],
                [84.967087, 19.29931],
                [84.966804, 19.299305000000167],
                [84.966804, 19.299583],
                [84.966248, 19.299583],
                [84.966248, 19.299861000000188],
                [84.965979, 19.299861000000188],
                [84.965979, 19.300151000000195],
                [84.965699000000129, 19.300151000000195],
                [84.965699000000129, 19.300422],
                [84.965416000000161, 19.300417000000149],
                [84.965416000000161, 19.300971000000168],
                [84.965141000000116, 19.300971000000168],
                [84.965141000000116, 19.301251],
                [84.964858000000135, 19.301251],
                [84.964858000000135, 19.301532],
                [84.964578000000117, 19.301532],
                [84.964578000000117, 19.301251],
                [84.964302, 19.301251],
                [84.964302, 19.300971000000168],
                [84.964028, 19.300971000000168],
                [84.964028, 19.300695],
                [84.963753, 19.300691],
                [84.963753, 19.300417000000149],
                [84.96347, 19.300422],
                [84.96347, 19.300151000000195],
                [84.963197, 19.300151000000195],
                [84.963197, 19.299861000000188],
                [84.962914000000112, 19.299861000000188],
                [84.962914000000112, 19.299583],
                [84.962638000000183, 19.299583],
                [84.962638000000183, 19.299305000000167],
                [84.962356, 19.29931],
                [84.962356, 19.299029],
                [84.961806, 19.299029],
                [84.961806, 19.298749000000154],
                [84.961517000000114, 19.298749000000154],
                [84.961517000000114, 19.298469000000122],
                [84.96125, 19.298471000000117],
                [84.96125, 19.298195000000188],
                [84.960977, 19.298195000000188],
                [84.960977, 19.297917],
                [84.960418000000146, 19.297919],
                [84.960418000000146, 19.297639000000171],
                [84.960136, 19.297639000000171],
                [84.960136, 19.297359],
                [84.959862000000143, 19.297361],
                [84.959862000000143, 19.297083000000153],
                [84.95903, 19.297083000000153],
                [84.95903, 19.296807],
                [84.958474, 19.296809],
                [84.958474, 19.296529000000188],
                [84.958192, 19.296529000000188],
                [84.958192, 19.296249],
                [84.957642000000163, 19.296249],
                [84.957642000000163, 19.295971000000176],
                [84.956528000000134, 19.295973000000171],
                [84.956528000000134, 19.295695],
                [84.955696, 19.295695],
                [84.955696, 19.29541700000015],
                [84.955407000000136, 19.295419000000145],
                [84.955407000000136, 19.295141],
                [84.954857, 19.295141],
                [84.954857, 19.29458],
                [84.954581000000175, 19.294585],
                [84.954581000000175, 19.29430700000017],
                [84.954041000000117, 19.294309000000165],
                [84.954041000000117, 19.29402],
                [84.953750000000156, 19.294027],
                [84.953750000000156, 19.29375100000015],
                [84.953476, 19.29375100000015],
                [84.953476, 19.293470000000177],
                [84.953193, 19.293473000000112],
                [84.953193, 19.292917],
                [84.95292, 19.292921],
                [84.95292, 19.29264100000017],
                [84.952079000000111, 19.29264100000017],
                [84.952079000000111, 19.292360000000198],
                [84.951805, 19.292360000000198],
                [84.951805, 19.292085000000153],
                [84.951247000000166, 19.292085000000153],
                [84.951247000000166, 19.291804000000177],
                [84.950967000000148, 19.291811],
                [84.950967000000148, 19.291531000000187],
                [84.95041800000017, 19.291531000000187],
                [84.95041800000017, 19.291251],
                [84.949859, 19.291251],
                [84.949859, 19.29097900000016],
                [84.949303000000128, 19.29097900000016],
                [84.949303000000128, 19.290701],
                [84.949027, 19.290701],
                [84.949027, 19.290421000000148],
                [84.948754000000164, 19.290421000000148],
                [84.948754000000164, 19.290141000000116],
                [84.948471, 19.290141000000116],
                [84.948471, 19.28986],
                [84.947915000000179, 19.289863000000192],
                [84.947915000000179, 19.289028000000197],
                [84.947639, 19.289031],
                [84.947639, 19.288750000000103],
                [84.94708300000012, 19.288750000000103],
                [84.94708300000012, 19.28847200000018],
                [84.94625100000016, 19.28847200000018],
                [84.94625100000016, 19.287916],
                [84.945686000000165, 19.287921],
                [84.945686000000165, 19.28764000000012],
                [84.945137, 19.28764000000012],
                [84.945137, 19.287360000000202],
                [84.944581, 19.287360000000202],
                [84.944581, 19.287080000000113],
                [84.944305000000142, 19.287082000000108],
                [84.944305000000142, 19.286528],
                [84.944031, 19.28653],
                [84.944031, 19.28625],
                [84.943749000000111, 19.28625],
                [84.943749000000111, 19.285970000000127],
                [84.943193000000107, 19.285972000000122],
                [84.943193000000107, 19.285694000000202],
                [84.942917000000179, 19.285694000000202],
                [84.942917000000179, 19.285418000000103],
                [84.942101, 19.28542],
                [84.942101, 19.28514000000018],
                [84.941811, 19.28514000000018],
                [84.941811, 19.284860000000148],
                [84.941529, 19.284860000000148],
                [84.941529, 19.284579000000118],
                [84.94097, 19.284584],
                [84.94097, 19.284306000000125],
                [84.940697, 19.284308000000117],
                [84.940697, 19.284030000000197],
                [84.940141, 19.284030000000197],
                [84.940141, 19.283750000000108],
                [84.939858, 19.283750000000108],
                [84.939858, 19.28347],
                [84.939582000000129, 19.283472],
                [84.939582000000129, 19.283194000000147],
                [84.939309, 19.283194000000147],
                [84.939309, 19.282918],
                [84.939026000000112, 19.28292],
                [84.939026000000112, 19.282640000000125],
                [84.938468000000157, 19.282640000000125],
                [84.938468000000157, 19.282360000000203],
                [84.938194, 19.282362000000198],
                [84.938194, 19.282084000000104],
                [84.937919000000164, 19.282084000000104],
                [84.937919000000164, 19.281806],
                [84.937638, 19.281810000000174],
                [84.937638, 19.28153],
                [84.937363, 19.28153],
                [84.937363, 19.28125],
                [84.936807, 19.28125],
                [84.936807, 19.28097200000013],
                [84.93624800000012, 19.28097200000013],
                [84.93624800000012, 19.280696000000198],
                [84.935966000000107, 19.280700000000191],
                [84.935966000000107, 19.28042],
                [84.935676, 19.28042],
                [84.935676, 19.28014],
                [84.935416, 19.28014],
                [84.935416, 19.279859],
                [84.935143, 19.279862000000147],
                [84.935143, 19.279584],
                [84.93486, 19.279584],
                [84.93486, 19.27930600000013],
                [84.934304, 19.27931000000012],
                [84.934304, 19.279039],
                [84.934028, 19.279039],
                [84.934028, 19.278749],
                [84.933746, 19.278749],
                [84.933746, 19.278471000000131],
                [84.933472000000137, 19.278474],
                [84.933472000000137, 19.278193000000211],
                [84.932914000000139, 19.278193000000211],
                [84.932914000000139, 19.277915000000117],
                [84.932358000000178, 19.27792],
                [84.932358000000178, 19.27764000000013],
                [84.932084, 19.27764000000013],
                [84.932084, 19.277361000000152],
                [84.931526, 19.277361000000152],
                [84.931526, 19.277081],
                [84.931252000000114, 19.277083],
                [84.931252000000114, 19.276805000000135],
                [84.93097, 19.276810000000179],
                [84.93097, 19.276532],
                [84.930687, 19.276532],
                [84.930687, 19.276252],
                [84.93042, 19.276252],
                [84.93042, 19.275980000000114],
                [84.930138000000156, 19.275980000000114],
                [84.930138000000156, 19.275691000000162],
                [84.929862, 19.275693000000157],
                [84.929862, 19.275417],
                [84.929582000000124, 19.275422000000102],
                [84.929582000000124, 19.274581000000175],
                [84.929306, 19.274583000000113],
                [84.929306, 19.274305],
                [84.929032000000106, 19.274312000000119],
                [84.929032000000106, 19.274032000000201],
                [84.92875, 19.274032000000201],
                [84.92875, 19.273751],
                [84.928467000000111, 19.273751],
                [84.928467000000111, 19.273471000000139],
                [84.928191000000183, 19.273471000000139],
                [84.928191000000183, 19.273195000000207],
                [84.927918000000133, 19.273202],
                [84.927918000000133, 19.27291],
                [84.927635000000166, 19.272917000000113],
                [84.927635000000166, 19.272639],
                [84.927359, 19.272639],
                [84.927359, 19.272359000000161],
                [84.927086, 19.272361000000156],
                [84.927086, 19.272083],
                [84.92653, 19.272083],
                [84.92653, 19.271805000000139],
                [84.925971000000146, 19.271805000000139],
                [84.925971000000146, 19.271529000000207],
                [84.925422, 19.271529000000207],
                [84.925422, 19.271249000000179],
                [84.924857, 19.271249000000179],
                [84.924857, 19.270968000000149],
                [84.924583, 19.270971],
                [84.924583, 19.270695000000156],
                [84.924308, 19.270695000000156],
                [84.924308, 19.270417],
                [84.923736000000176, 19.270419],
                [84.923736000000176, 19.270139000000139],
                [84.923469000000111, 19.270139000000139],
                [84.923469000000111, 19.269849000000129],
                [84.923196, 19.269861],
                [84.923196, 19.269583000000178],
                [84.922920000000119, 19.269583000000178],
                [84.922920000000119, 19.269307],
                [84.922637000000165, 19.269309],
                [84.922637000000165, 19.268751],
                [84.922364000000158, 19.268751],
                [84.922364000000158, 19.268471000000144],
                [84.922081, 19.268473000000139],
                [84.922081, 19.268195],
                [84.921805000000106, 19.268195],
                [84.921805000000106, 19.267917000000178],
                [84.921249, 19.267919000000116],
                [84.921249, 19.267641],
                [84.920967000000175, 19.267641],
                [84.920967000000175, 19.267080000000185],
                [84.920693, 19.267085],
                [84.920693, 19.266479000000171],
                [84.920693, 19.265973],
                [84.920417000000143, 19.265973],
                [84.920417000000143, 19.265695000000161],
                [84.919861000000182, 19.265695000000161],
                [84.919861000000182, 19.265417],
                [84.919585, 19.265421],
                [84.919585, 19.265141000000138],
                [84.919052000000178, 19.265132000000104],
                [84.919029, 19.264863],
                [84.918747, 19.264863],
                [84.918747, 19.264585000000178],
                [84.918327, 19.264585000000178],
                [84.918197000000177, 19.264585000000178],
                [84.918197000000177, 19.264304000000148],
                [84.917947, 19.264304000000148],
                [84.91570200000011, 19.264311],
                [84.91570200000011, 19.26404000000019],
                [84.915412, 19.26404000000019],
                [84.915412, 19.263750000000179],
                [84.914017000000143, 19.263750000000179],
                [84.914017000000143, 19.26347],
                [84.913475000000105, 19.263472],
                [84.913475000000105, 19.263194000000166],
                [84.913192000000137, 19.263201000000205],
                [84.913192000000137, 19.262921000000116],
                [84.912919, 19.262921000000116],
                [84.912919, 19.262641],
                [84.91263600000012, 19.262641],
                [84.91263600000012, 19.262360000000111],
                [84.91236, 19.262362],
                [84.91236, 19.262082000000188],
                [84.911248, 19.262082000000188],
                [84.911248, 19.262362],
                [84.910423000000137, 19.262360000000111],
                [84.910423000000137, 19.262641],
                [84.909858000000142, 19.262641],
                [84.909858000000142, 19.262921000000116],
                [84.909026, 19.262921000000116],
                [84.909026, 19.263201000000205],
                [84.90847, 19.263194000000166],
                [84.90847, 19.263472],
                [84.908203000000157, 19.26347],
                [84.908203000000157, 19.264311],
                [84.907914, 19.264304000000148],
                [84.907914, 19.267085],
                [84.907638000000119, 19.267080000000185],
                [84.907638000000119, 19.269309],
                [84.907365, 19.269307],
                [84.907365, 19.269861],
                [84.90625, 19.269861],
                [84.90625, 19.269583000000178],
                [84.905694, 19.269583000000178],
                [84.905694, 19.269307],
                [84.905418, 19.269309],
                [84.905418, 19.268471000000144],
                [84.905136, 19.268473000000139],
                [84.905136, 19.268195],
                [84.904862000000136, 19.268195],
                [84.904862000000136, 19.267917000000178],
                [84.904586, 19.267919000000116],
                [84.904586, 19.267080000000185],
                [84.904862000000136, 19.267085],
                [84.904862000000136, 19.266805000000144],
                [84.905136, 19.266809000000134],
                [84.905136, 19.26653100000021],
                [84.905418, 19.26653100000021],
                [84.905418, 19.266251000000178],
                [84.905701, 19.266251000000178],
                [84.905694, 19.263472],
                [84.905974000000114, 19.263472],
                [84.905974000000114, 19.263194000000166],
                [84.90625, 19.263201000000205],
                [84.90625, 19.262641],
                [84.907356, 19.262641],
                [84.907356, 19.262360000000111],
                [84.907638000000119, 19.262362],
                [84.907638000000119, 19.262082000000188],
                [84.908197, 19.262082000000188],
                [84.908197, 19.261528000000162],
                [84.90847, 19.261531],
                [84.90847, 19.26125],
                [84.90957500000016, 19.26125],
                [84.90957500000016, 19.260972000000148],
                [84.910416, 19.260972000000148],
                [84.910416, 19.260694000000111],
                [84.911529, 19.260694000000111],
                [84.911529, 19.260416000000188],
                [84.91236, 19.260421],
                [84.91237, 19.26014],
                [84.91263600000012, 19.26014],
                [84.91263600000012, 19.25958],
                [84.91236, 19.259582],
                [84.91236, 19.259306000000148],
                [84.911798, 19.259311],
                [84.911798, 19.25903],
                [84.911529, 19.25903],
                [84.911529, 19.258750000000187],
                [84.911248, 19.258750000000187],
                [84.911248, 19.25847],
                [84.9109720000001, 19.258472],
                [84.9109720000001, 19.25819400000017],
                [84.910416, 19.25819400000017],
                [84.910416, 19.257918],
                [84.910141, 19.257918],
                [84.910141, 19.25763800000021],
                [84.909858000000142, 19.257640000000148],
                [84.909858000000142, 19.257360000000116],
                [84.90957500000016, 19.257360000000116],
                [84.90957500000016, 19.257079000000143],
                [84.909302000000125, 19.257084000000187],
                [84.909302000000125, 19.256806],
                [84.909026, 19.256811000000138],
                [84.909026, 19.256530000000165],
                [84.908737, 19.256530000000165],
                [84.908737, 19.25625],
                [84.90847, 19.25625],
                [84.90847, 19.25597],
                [84.908197, 19.255972000000206],
                [84.908197, 19.255696000000107],
                [84.907914, 19.255701000000155],
                [84.907914, 19.255420000000182],
                [84.907638000000119, 19.255420000000182],
                [84.907638000000119, 19.25514],
                [84.907356, 19.25514],
                [84.907356, 19.254579000000202],
                [84.906806000000174, 19.254584],
                [84.906806000000174, 19.254306000000206],
                [84.906524000000132, 19.254306000000206],
                [84.906524000000132, 19.254028000000112],
                [84.90625, 19.254030000000107],
                [84.90625, 19.253750000000192],
                [84.905974000000114, 19.253750000000192],
                [84.905974000000114, 19.25319600000017],
                [84.905694, 19.25319600000017],
                [84.905694, 19.252915000000197],
                [84.905418, 19.25292],
                [84.905418, 19.252640000000206],
                [84.904862000000136, 19.252640000000206],
                [84.904862000000136, 19.252359],
                [84.903748000000107, 19.252362000000115],
                [84.903748000000107, 19.252084000000192],
                [84.903198, 19.252084000000192],
                [84.903192000000146, 19.25152700000012],
                [84.902932000000121, 19.251530000000169],
                [84.902932000000121, 19.251252],
                [84.9026420000001, 19.251252],
                [84.9026420000001, 19.250691],
                [84.90236, 19.250693],
                [84.90236, 19.250415000000142],
                [84.902077, 19.250420000000187],
                [84.902077, 19.250142],
                [84.901528000000141, 19.250142],
                [84.901528000000141, 19.24986100000012],
                [84.901252, 19.24986100000012],
                [84.901252, 19.249581000000202],
                [84.900969, 19.249583000000197],
                [84.900969, 19.249305000000103],
                [84.900696, 19.249310000000147],
                [84.900696, 19.24903200000011],
                [84.900406, 19.24903200000011],
                [84.900406, 19.248471],
                [84.899581000000168, 19.248471],
                [84.899581000000168, 19.248193000000121],
                [84.898749, 19.248193000000121],
                [84.898749, 19.247917000000196],
                [84.898483, 19.247922],
                [84.898483, 19.247642000000209],
                [84.898164000000165, 19.247642000000209],
                [84.897918, 19.247642000000209],
                [84.897918, 19.247361],
                [84.897836, 19.247361],
                [84.897362, 19.247361],
                [84.897362, 19.247081000000147],
                [84.897088, 19.247083000000142],
                [84.897088, 19.246805],
                [84.896530000000141, 19.246812],
                [84.896530000000141, 19.246532000000169],
                [84.896247000000159, 19.246532000000169],
                [84.896247000000159, 19.246251000000196],
                [84.895974000000109, 19.246251000000196],
                [84.895974000000109, 19.245969000000109],
                [84.895691000000156, 19.245971000000107],
                [84.895691000000156, 19.245695],
                [84.895417, 19.245700000000109],
                [84.895417, 19.245419],
                [84.895142, 19.245419],
                [84.895142, 19.245139],
                [84.894576, 19.245139],
                [84.894576, 19.244581000000203],
                [84.894303, 19.244583000000201],
                [84.894303, 19.244305000000104],
                [84.89402700000015, 19.244305000000104],
                [84.89402700000015, 19.244029],
                [84.89376, 19.244029],
                [84.89376, 19.243772],
                [84.893471000000133, 19.243749000000147],
                [84.893425, 19.243528000000133],
                [84.893357000000137, 19.243473],
                [84.893195, 19.243473],
                [84.893195, 19.24332000000015],
                [84.893195, 19.243195000000124],
                [84.893052, 19.243195000000124],
                [84.892639, 19.243195000000124],
                [84.892639, 19.242917000000197],
                [84.892083, 19.242917000000197],
                [84.892083, 19.242639000000104],
                [84.891807000000128, 19.242639000000104],
                [84.891807000000128, 19.242361],
                [84.891525, 19.242361],
                [84.891525, 19.242083000000147],
                [84.891251000000167, 19.242083000000147],
                [84.891251000000167, 19.241807],
                [84.890702, 19.241809],
                [84.890702, 19.241529000000124],
                [84.890419, 19.241529000000124],
                [84.890419, 19.240971000000112],
                [84.890137000000138, 19.240973000000103],
                [84.890137000000138, 19.240695],
                [84.889863, 19.240695],
                [84.889863, 19.240417000000146],
                [84.889581000000163, 19.240419000000141],
                [84.889549, 19.240141],
                [84.889031000000145, 19.240141],
                [84.889031000000145, 19.23987000000016],
                [84.888749, 19.23987000000016],
                [84.888749, 19.239580000000156],
                [84.888473000000118, 19.239585000000201],
                [84.888473000000118, 19.239304],
                [84.888190000000165, 19.239311],
                [84.888190000000165, 19.239031],
                [84.887917000000158, 19.239031],
                [84.887917000000158, 19.238751000000146],
                [84.887627000000165, 19.238751000000146],
                [84.887627000000165, 19.238479000000208],
                [84.887092, 19.238470000000174],
                [84.887085, 19.238195000000129],
                [84.886802, 19.23819],
                [84.886802, 19.237916000000151],
                [84.886253000000167, 19.237921000000195],
                [84.886253000000167, 19.237641000000107],
                [84.88597, 19.237641000000107],
                [84.88597, 19.237360000000134],
                [84.885697000000135, 19.237363],
                [84.885697000000135, 19.237082],
                [84.885414000000182, 19.237082],
                [84.885414000000182, 19.236804000000173],
                [84.885138, 19.236811],
                [84.885138, 19.236531000000124],
                [84.88485800000015, 19.236531000000124],
                [84.88485800000015, 19.236250000000151],
                [84.884566000000163, 19.236250000000151],
                [84.884582, 19.235831000000129],
                [84.884582, 19.235694000000134],
                [84.884423, 19.235694000000134],
                [84.884309, 19.235694000000134],
                [84.884309, 19.235416],
                [84.884026, 19.235416],
                [84.884026, 19.23533],
                [84.884026, 19.235140000000108],
                [84.883751, 19.235140000000108],
                [84.883751, 19.23486],
                [84.883468, 19.234862],
                [84.883468, 19.234582000000156],
                [84.883194000000159, 19.234582000000156],
                [84.883194000000159, 19.234306],
                [84.882919000000172, 19.234311000000101],
                [84.882919000000172, 19.233739],
                [84.882636, 19.23375],
                [84.882636, 19.23347200000017],
                [84.88208, 19.23347200000017],
                [84.88208, 19.233194],
                [84.881927000000118, 19.233194],
                [84.881806, 19.233194],
                [84.881806, 19.232916000000156],
                [84.881729, 19.232916000000156],
                [84.881531, 19.2329210000002],
                [84.881531, 19.23264],
                [84.881248, 19.23264],
                [84.881248, 19.23221900000021],
                [84.881248, 19.232084],
                [84.880416000000167, 19.232084],
                [84.880416000000167, 19.231528],
                [84.880143000000118, 19.23153],
                [84.880143000000118, 19.231250000000156],
                [84.879860000000164, 19.231250000000156],
                [84.879860000000164, 19.23097],
                [84.879584, 19.230972],
                [84.879584, 19.230694000000138],
                [84.879028000000105, 19.230694000000138],
                [84.879028000000105, 19.230418],
                [84.878761, 19.230420000000205],
                [84.878761, 19.230140000000173],
                [84.878472, 19.230140000000173],
                [84.878472, 19.229579000000111],
                [84.877914000000132, 19.229584000000152],
                [84.877914000000132, 19.229028000000138],
                [84.87764, 19.229030000000133],
                [84.87764, 19.22875],
                [84.877082, 19.22875],
                [84.877082, 19.228469],
                [84.876808, 19.228472000000178],
                [84.876808, 19.228196],
                [84.876526000000155, 19.228201000000119],
                [84.876526000000155, 19.227929000000184],
                [84.876252, 19.227929000000184],
                [84.876252, 19.22764],
                [84.87597, 19.22764],
                [84.87597, 19.22707900000017],
                [84.875694000000109, 19.227084],
                [84.875694000000109, 19.226806000000177],
                [84.875138, 19.226806000000177],
                [84.875138, 19.226528],
                [84.874579, 19.22653],
                [84.874579, 19.225972],
                [84.874306, 19.225974],
                [84.874306, 19.225696000000138],
                [84.874030000000104, 19.225696000000138],
                [84.874030000000104, 19.225415000000165],
                [84.873467, 19.22542],
                [84.873467, 19.225140000000177],
                [84.872918, 19.225140000000177],
                [84.872918, 19.224871000000118],
                [84.872628, 19.224871000000118],
                [84.872628, 19.22431],
                [84.872359, 19.22431],
                [84.872359, 19.224030000000134],
                [84.872093, 19.224030000000134],
                [84.872093, 19.223752],
                [84.871527000000114, 19.223752],
                [84.871527000000114, 19.22319100000021],
                [84.871247, 19.223193000000204],
                [84.871247, 19.222917000000106],
                [84.870971, 19.222920000000155],
                [84.870971, 19.222642],
                [84.870698, 19.222642],
                [84.870698, 19.222361],
                [84.870406000000102, 19.222361],
                [84.870406000000102, 19.222081000000166],
                [84.87014, 19.222083000000161],
                [84.87014, 19.221805],
                [84.86985700000011, 19.221805],
                [84.86985700000011, 19.221527000000204],
                [84.869027, 19.221532],
                [84.869027, 19.221251000000105],
                [84.868752000000185, 19.221251000000105],
                [84.868752000000185, 19.220971000000187],
                [84.868469, 19.220971000000187],
                [84.868469, 19.220693],
                [84.86792, 19.220693],
                [84.86792, 19.220417000000161],
                [84.867637000000101, 19.220422],
                [84.867637000000101, 19.220141],
                [84.867364000000109, 19.220141],
                [84.867364000000109, 19.219581000000115],
                [84.866805, 19.21958300000011],
                [84.866805, 19.219029],
                [84.866532000000163, 19.219029],
                [84.866532000000163, 19.218740000000135],
                [84.866249, 19.21874900000017],
                [84.866249, 19.218471],
                [84.865976, 19.218471],
                [84.865976, 19.218195000000204],
                [84.865693, 19.2182],
                [84.865693, 19.217919000000105],
                [84.865417000000122, 19.217919000000105],
                [84.865417000000122, 19.217639000000187],
                [84.865144, 19.217639000000187],
                [84.865144, 19.217081],
                [84.864861000000118, 19.217083000000169],
                [84.864861000000118, 19.216529000000204],
                [84.864585, 19.216529000000204],
                [84.864585, 19.216249000000111],
                [84.864296, 19.216249000000111],
                [84.864296, 19.215971000000192],
                [84.864029, 19.215973000000186],
                [84.864029, 19.215695],
                [84.863747000000146, 19.215699],
                [84.863747000000146, 19.215419000000164],
                [84.863473, 19.215419000000164],
                [84.863473, 19.215139],
                [84.863197, 19.215139],
                [84.863197, 19.214861000000205],
                [84.862915, 19.214861000000205],
                [84.862915, 19.214307000000186],
                [84.862641, 19.214309000000181],
                [84.862641, 19.214031],
                [84.862076000000101, 19.214031],
                [84.862076000000101, 19.213751000000169],
                [84.861527000000109, 19.213751000000169],
                [84.861527000000109, 19.213470000000196],
                [84.861251, 19.213473],
                [84.861251, 19.213195000000209],
                [84.860971000000148, 19.213195000000209],
                [84.860971000000148, 19.212917000000115],
                [84.860688, 19.212930000000139],
                [84.860688, 19.212641000000186],
                [84.86042100000013, 19.212641000000186],
                [84.86042100000013, 19.212361],
                [84.860139, 19.212361],
                [84.860139, 19.212080000000125],
                [84.859863000000118, 19.212085000000169],
                [84.859863000000118, 19.211804000000196],
                [84.859307, 19.211811],
                [84.859307, 19.211531000000203],
                [84.859017, 19.211531000000203],
                [84.859017, 19.211251000000114],
                [84.858748, 19.211251000000114],
                [84.858748, 19.210701],
                [84.858468000000173, 19.210701],
                [84.858468000000173, 19.210421000000164],
                [84.858192, 19.210421000000164],
                [84.858192, 19.209860000000102],
                [84.857919, 19.209863000000208],
                [84.857919, 19.209582],
                [84.857636, 19.209582],
                [84.857636, 19.209304000000142],
                [84.857087000000135, 19.209304000000142],
                [84.857087000000135, 19.208750000000116],
                [84.856795000000133, 19.208750000000116],
                [84.856795000000133, 19.208470000000201],
                [84.856529000000123, 19.208472000000196],
                [84.856529000000123, 19.208194000000102],
                [84.856246000000155, 19.208194000000102],
                [84.856246000000155, 19.207916],
                [84.855972, 19.207921000000109],
                [84.855972, 19.207640000000136],
                [84.855697, 19.207640000000136],
                [84.855697, 19.20736],
                [84.855416, 19.20736],
                [84.855416, 19.207082000000124],
                [84.855141, 19.207082000000124],
                [84.855141, 19.206806000000196],
                [84.854858, 19.206806000000196],
                [84.854858, 19.206528000000102],
                [84.854591000000184, 19.20653],
                [84.854591000000184, 19.20625],
                [84.8543090000001, 19.20625],
                [84.8543090000001, 19.205970000000146],
                [84.85375300000014, 19.205972000000141],
                [84.85375300000014, 19.205694],
                [84.853470000000158, 19.205694],
                [84.853470000000158, 19.205418000000119],
                [84.853203000000107, 19.205421000000165],
                [84.853203000000107, 19.205140000000195],
                [84.852914000000155, 19.205140000000195],
                [84.852914000000155, 19.204860000000103],
                [84.852638, 19.204860000000103],
                [84.852638, 19.20458],
                [84.852365, 19.204584],
                [84.852365, 19.204028],
                [84.852082, 19.20403],
                [84.852082, 19.203759000000158],
                [84.851533000000117, 19.203759000000158],
                [84.851533000000117, 19.203189],
                [84.851250000000135, 19.203194000000103],
                [84.851250000000135, 19.202918],
                [84.850983, 19.20292],
                [84.850983, 19.202640000000141],
                [84.850692, 19.202640000000141],
                [84.850692, 19.202079],
                [84.850418, 19.202084000000124],
                [84.850418, 19.201806000000197],
                [84.849586000000144, 19.201810000000187],
                [84.849586000000144, 19.20153],
                [84.849297, 19.20153],
                [84.849297, 19.20125],
                [84.849030000000127, 19.20125],
                [84.849030000000127, 19.200969],
                [84.8487480000001, 19.200972000000146],
                [84.8487480000001, 19.200696],
                [84.848458, 19.200700000000207],
                [84.848458, 19.200420000000118],
                [84.848198, 19.200420000000118],
                [84.848198, 19.199859],
                [84.847916000000154, 19.199862000000106],
                [84.847916000000154, 19.199584],
                [84.84764, 19.199584],
                [84.84764, 19.199306000000146],
                [84.84736, 19.199310000000136],
                [84.84736, 19.19903],
                [84.847077, 19.19903],
                [84.847077, 19.198471000000151],
                [84.846801000000113, 19.1984740000002],
                [84.846801000000113, 19.198193],
                [84.846528, 19.198193],
                [84.846528, 19.197640000000142],
                [84.846252000000149, 19.197640000000142],
                [84.846252000000149, 19.197362],
                [84.846177000000154, 19.197362],
                [84.845969000000167, 19.197362],
                [84.845969000000167, 19.197152],
                [84.845413000000164, 19.197083],
                [84.845413000000164, 19.19680500000015],
                [84.844857, 19.196810000000195],
                [84.844857, 19.196530000000106],
                [84.844581000000105, 19.196530000000106],
                [84.844581000000105, 19.196252],
                [84.844308, 19.196252],
                [84.844308, 19.195691000000174],
                [84.844025, 19.195693000000169],
                [84.844025, 19.19513900000015],
                [84.843483, 19.1951420000002],
                [84.843467000000132, 19.19459],
                [84.84291800000014, 19.194570000000162],
                [84.84291800000014, 19.194305],
                [84.842651, 19.194312000000131],
                [84.842651, 19.194032],
                [84.842361, 19.194032],
                [84.842361, 19.193751],
                [84.842088, 19.193751],
                [84.842088, 19.193471000000155],
                [84.841805, 19.193471000000155],
                [84.841805, 19.193195],
                [84.84153, 19.193202],
                [84.84153, 19.192359000000177],
                [84.841247000000109, 19.192361000000172],
                [84.841247000000109, 19.191921000000143],
                [84.841247000000109, 19.191805000000151],
                [84.840973000000162, 19.191805000000151],
                [84.840973000000162, 19.191529],
                [84.840698000000117, 19.191529],
                [84.840668000000136, 19.191260000000167],
                [84.840142000000156, 19.191249000000138],
                [84.840142000000156, 19.190969000000106],
                [84.839859, 19.190971000000101],
                [84.839859, 19.190695000000172],
                [84.839585, 19.190695000000172],
                [84.839585, 19.190417],
                [84.839303, 19.190419],
                [84.839303, 19.190139000000151],
                [84.839027, 19.190139000000151],
                [84.839027, 19.189859],
                [84.838754, 19.189861],
                [84.838754, 19.189583000000138],
                [84.838471000000112, 19.189583000000138],
                [84.838471000000112, 19.189027000000177],
                [84.838195, 19.189029000000172],
                [84.838195, 19.188760000000109],
                [84.837906, 19.188760000000109],
                [84.837913000000114, 19.188361000000153],
                [84.837913000000114, 19.188195],
                [84.837753000000163, 19.188195],
                [84.837639000000181, 19.188195],
                [84.837639000000181, 19.188069000000151],
                [84.837639000000181, 19.1876390000001],
                [84.837356, 19.187641],
                [84.837356, 19.187080000000204],
                [84.837083000000149, 19.187085],
                [84.837083000000149, 19.186527],
                [84.836807, 19.186531],
                [84.836807, 19.186251000000134],
                [84.836518000000154, 19.186251000000134],
                [84.836518000000154, 19.185970000000165],
                [84.835693, 19.1859730000001],
                [84.835693, 19.185695000000177],
                [84.835380000000143, 19.185695000000177],
                [84.835137000000131, 19.185695000000177],
                [84.835137000000131, 19.185430000000103],
                [84.835137000000131, 19.184860000000182],
                [84.834861, 19.184860000000182],
                [84.834861, 19.18458],
                [84.834587, 19.184585000000133],
                [84.834587, 19.184304000000161],
                [84.834298000000146, 19.184311],
                [84.834298000000146, 19.183751],
                [84.834031, 19.183751],
                [84.834031, 19.183201],
                [84.833749, 19.183201],
                [84.833749, 19.182921000000128],
                [84.833457, 19.182921000000128],
                [84.833457, 19.182631000000125],
                [84.833190000000158, 19.182638000000161],
                [84.833190000000158, 19.182363000000176],
                [84.832917000000108, 19.182363000000176],
                [84.832917000000108, 19.182082000000204],
                [84.832641000000166, 19.182082000000204],
                [84.832641000000166, 19.18180400000011],
                [84.832085000000163, 19.18180400000011],
                [84.832085000000163, 19.181528000000181],
                [84.831802, 19.181531],
                [84.831802, 19.18125],
                [84.831529, 19.18125],
                [84.831529, 19.180690000000137],
                [84.831253000000103, 19.180694],
                [84.831253000000103, 19.180416000000204],
                [84.830970000000121, 19.180421],
                [84.830970000000121, 19.180140000000105],
                [84.830697, 19.180140000000105],
                [84.830697, 19.180010000000149],
                [84.830697, 19.179860000000186],
                [84.830414000000118, 19.179860000000186],
                [84.830414000000118, 19.179582],
                [84.830138, 19.179591000000126],
                [84.830138, 19.179311],
                [84.829856000000163, 19.179311],
                [84.829856000000163, 19.17903],
                [84.829582, 19.17903],
                [84.829582, 19.178750000000203],
                [84.829307000000185, 19.178750000000203],
                [84.829307000000185, 19.178470000000111],
                [84.829026, 19.178472000000106],
                [84.829026, 19.177918],
                [84.82875, 19.177921000000136],
                [84.82875, 19.17708],
                [84.828194, 19.1770840000002],
                [84.828194, 19.176528000000186],
                [84.827919, 19.176530000000181],
                [84.827912, 19.176259000000126],
                [84.827362, 19.17625],
                [84.827362, 19.17597],
                [84.826531, 19.175972],
                [84.826531, 19.175418000000199],
                [84.826248, 19.175420000000194],
                [84.826248, 19.175160000000169],
                [84.825965, 19.175140000000106],
                [84.825958, 19.17488],
                [84.825692, 19.174860000000191],
                [84.825692, 19.174584],
                [84.825416000000118, 19.174584],
                [84.825416000000118, 19.174272],
                [84.825416000000118, 19.174028000000131],
                [84.825211, 19.17403],
                [84.825143000000111, 19.173750000000208],
                [84.8249670000001, 19.173750000000208],
                [84.824577, 19.173750000000208],
                [84.824577, 19.173469],
                [84.823752000000113, 19.173472000000114],
                [84.823752000000113, 19.172916],
                [84.823472, 19.17292],
                [84.823472, 19.172359000000196],
                [84.823196, 19.172362000000131],
                [84.823196, 19.171806000000114],
                [84.822907, 19.171810000000104],
                [84.822907, 19.171530000000182],
                [84.822640000000135, 19.171530000000182],
                [84.822608000000159, 19.170981],
                [84.822364, 19.170974],
                [84.822364, 19.170693000000195],
                [84.821808, 19.170693000000195],
                [84.821808, 19.170415000000101],
                [84.821519000000123, 19.170420000000203],
                [84.821519000000123, 19.170142000000109],
                [84.821252, 19.170142000000109],
                [84.821252, 19.169861000000136],
                [84.820969, 19.169861000000136],
                [84.820969, 19.169581],
                [84.820694, 19.169583],
                [84.820694, 19.169027000000195],
                [84.82042, 19.169032],
                [84.82042, 19.168471],
                [84.820138, 19.168471],
                [84.820138, 19.168193000000141],
                [84.819862000000143, 19.168193000000141],
                [84.819862000000143, 19.167801],
                [84.819862000000143, 19.167639000000118],
                [84.819732, 19.167639000000118],
                [84.819579, 19.167651],
                [84.819579, 19.167471],
                [84.819579, 19.167083000000101],
                [84.81930600000014, 19.167083000000101],
                [84.81930600000014, 19.166805],
                [84.81903, 19.166812000000103],
                [84.81903, 19.166532000000185],
                [84.818750000000122, 19.16652],
                [84.818750000000122, 19.165971000000123],
                [84.818474, 19.165971000000123],
                [84.818474, 19.165695000000191],
                [84.818191, 19.1657],
                [84.818191, 19.165139],
                [84.817918, 19.165139],
                [84.817918, 19.16459],
                [84.81764200000012, 19.16459],
                [84.81764200000012, 19.1643],
                [84.817359000000167, 19.164305000000123],
                [84.817359000000167, 19.163749000000159],
                [84.817086000000117, 19.163749000000159],
                [84.817086000000117, 19.163473],
                [84.816803000000135, 19.163473],
                [84.816803000000135, 19.16319500000014],
                [84.816527, 19.16319500000014],
                [84.816527, 19.162917],
                [84.816147, 19.162917],
                [84.815971, 19.162919],
                [84.815971, 19.162650000000149],
                [84.815698, 19.162639000000123],
                [84.815698, 19.162361],
                [84.815415, 19.162361],
                [84.815415, 19.162083000000159],
                [84.815139000000144, 19.162083000000159],
                [84.815139000000144, 19.161527000000145],
                [84.814857, 19.16152900000014],
                [84.814857, 19.161251],
                [84.814583000000113, 19.161251],
                [84.814583000000113, 19.160971000000128],
                [84.814308000000139, 19.160973000000123],
                [84.814308000000139, 19.160417000000162],
                [84.814025000000157, 19.1604190000001],
                [84.814025000000157, 19.160141],
                [84.813751, 19.160141],
                [84.813751, 19.159861000000141],
                [84.813469000000154, 19.159861000000141],
                [84.813469000000154, 19.159309000000118],
                [84.81292, 19.159309000000118],
                [84.81292, 19.158751000000162],
                [84.812637, 19.158751000000162],
                [84.812637, 19.158461],
                [84.812363000000147, 19.158473],
                [84.812363000000147, 19.158195000000141],
                [84.812081, 19.158195000000141],
                [84.812081, 19.157638],
                [84.811814000000169, 19.157641000000122],
                [84.811814000000169, 19.15736000000015],
                [84.811249, 19.157363],
                [84.811249, 19.157085000000162],
                [84.810973, 19.157085000000162],
                [84.810973, 19.156804000000133],
                [84.810693000000171, 19.156811],
                [84.810693000000171, 19.156531000000136],
                [84.810417, 19.156531000000136],
                [84.810417, 19.156250000000163],
                [84.810144, 19.156250000000163],
                [84.810144, 19.15597],
                [84.809861, 19.155972],
                [84.809861, 19.15569400000015],
                [84.809578, 19.15571],
                [84.809578, 19.1554210000001],
                [84.809289, 19.1554210000001],
                [84.809289, 19.155141],
                [84.809029000000166, 19.155141],
                [84.809029000000166, 19.15486],
                [84.808746, 19.154862],
                [84.808746, 19.154028000000149],
                [84.808471000000139, 19.154031],
                [84.808471000000139, 19.152360000000151],
                [84.808197, 19.152360000000151],
                [84.808197, 19.15153],
                [84.80790800000014, 19.15153],
                [84.807915, 19.151179000000123],
                [84.807915, 19.150972],
                [84.807641, 19.150972],
                [84.807641, 19.150418],
                [84.807358000000121, 19.15042],
                [84.807358000000121, 19.150140000000132],
                [84.806962, 19.150140000000132],
                [84.806809000000143, 19.150140000000132],
                [84.806809000000143, 19.149971],
                [84.806809000000143, 19.149584000000171],
                [84.806543, 19.149589],
                [84.806543, 19.149311000000122],
                [84.806198, 19.149311000000122],
                [84.805968, 19.149311000000122],
                [84.805961000000124, 19.149039000000183],
                [84.805688000000117, 19.149030000000145],
                [84.805688000000117, 19.14875],
                [84.805419, 19.14875],
                [84.805419, 19.14845100000019],
                [84.805419, 19.148196],
                [84.805161, 19.148201000000139],
                [84.805139000000153, 19.147920000000166],
                [84.804863, 19.147916000000176],
                [84.804863, 19.147827000000117],
                [84.804863, 19.146528],
                [84.80458, 19.146528],
                [84.80458, 19.145696000000154],
                [84.804307, 19.145696000000154],
                [84.804307, 19.14514000000019],
                [84.804031000000165, 19.14514000000019],
                [84.804031000000165, 19.144862],
                [84.803748, 19.144862],
                [84.803748, 19.144581000000123],
                [84.80319200000018, 19.144584000000176],
                [84.80319200000018, 19.144027000000104],
                [84.802916, 19.144030000000154],
                [84.802916, 19.143462],
                [84.802636, 19.14347400000019],
                [84.802636, 19.142918000000176],
                [84.802360000000121, 19.142920000000171],
                [84.802360000000121, 19.142081000000186],
                [84.802087, 19.142083000000181],
                [84.802087, 19.141527],
                [84.801795, 19.141532],
                [84.801795, 19.140971000000203],
                [84.801528000000175, 19.140971000000203],
                [84.801528000000175, 19.140417000000181],
                [84.801246, 19.140422],
                [84.801246, 19.140142000000193],
                [84.800972000000144, 19.140142000000193],
                [84.800972000000144, 19.139581000000131],
                [84.80069700000017, 19.139583000000126],
                [84.80069700000017, 19.139305000000199],
                [84.800407000000149, 19.139312],
                [84.800407000000149, 19.138749000000185],
                [84.799858000000185, 19.138749000000185],
                [84.799858000000185, 19.138469],
                [84.799584, 19.138471],
                [84.799584, 19.137639000000199],
                [84.799309, 19.137639000000199],
                [84.799309, 19.136809],
                [84.799026000000111, 19.136809],
                [84.799026000000111, 19.136249000000131],
                [84.798752, 19.136249000000131],
                [84.798752, 19.13569],
                [84.798470000000108, 19.135695000000108],
                [84.798470000000108, 19.135139],
                [84.797921, 19.135139],
                [84.797921, 19.133751000000181],
                [84.797638, 19.133751000000181],
                [84.797638, 19.133471],
                [84.797362000000106, 19.133473],
                [84.797362000000106, 19.133195],
                [84.797082, 19.133195],
                [84.797082, 19.13125100000013],
                [84.796806000000103, 19.13125100000013],
                [84.796806000000103, 19.130421000000176],
                [84.796517000000136, 19.130421000000176],
                [84.796517000000136, 19.129302000000163],
                [84.79625, 19.129304000000158],
                [84.79625, 19.128750000000135],
                [84.795967000000118, 19.128750000000135],
                [84.795967000000118, 19.128481],
                [84.79569200000013, 19.128481],
                [84.79569200000013, 19.128192000000123],
                [84.795135, 19.128194000000118],
                [84.795135, 19.127916],
                [84.79486200000018, 19.127921000000125],
                [84.79486200000018, 19.12764],
                [84.79403000000012, 19.12764],
                [84.79403000000012, 19.127080000000145],
                [84.793747000000138, 19.12708200000014],
                [84.793747000000138, 19.126806],
                [84.793198000000174, 19.126811],
                [84.793198000000174, 19.126531],
                [84.79264, 19.126531],
                [84.79264, 19.12625],
                [84.792077000000162, 19.12625],
                [84.792077000000162, 19.125970000000159],
                [84.79181, 19.125972000000154],
                [84.79181, 19.125694],
                [84.79152800000017, 19.125694],
                [84.79152800000017, 19.12541600000014],
                [84.791038000000171, 19.125421000000184],
                [84.790992, 19.125245],
                [84.790969000000118, 19.125140000000211],
                [84.789857000000126, 19.125140000000211],
                [84.789857000000126, 19.12458],
                [84.789581, 19.124584],
                [84.789581, 19.124028],
                [84.789308, 19.12403],
                [84.789308, 19.12375000000014],
                [84.789016, 19.12375000000014],
                [84.789016, 19.123189],
                [84.788749000000152, 19.123194000000122],
                [84.788749000000152, 19.122918],
                [84.788467, 19.122920000000185],
                [84.788467, 19.122640000000153],
                [84.788177, 19.122640000000153],
                [84.788177, 19.122079],
                [84.787917, 19.12208400000014],
                [84.787917, 19.121806],
                [84.787635000000108, 19.121810000000206],
                [84.787635000000108, 19.121530000000117],
                [84.787086, 19.121530000000117],
                [84.787086, 19.12125],
                [84.786247, 19.12125],
                [84.786247, 19.120969],
                [84.785973, 19.120972000000162],
                [84.785973, 19.120696],
                [84.785698000000124, 19.120701000000103],
                [84.785698000000124, 19.120420000000134],
                [84.785408000000103, 19.120420000000134],
                [84.785408000000103, 19.12014],
                [84.785141, 19.12014],
                [84.785141, 19.119860000000127],
                [84.784859000000139, 19.119862000000122],
                [84.784859000000139, 19.119306000000162],
                [84.784583, 19.119306000000162],
                [84.784583, 19.119028],
                [84.784303000000122, 19.11903],
                [84.784303000000122, 19.118750000000141],
                [84.784027, 19.118750000000141],
                [84.784027, 19.118191],
                [84.783753, 19.118193],
                [84.783753, 19.117915000000149],
                [84.783471, 19.11792],
                [84.783471, 19.117362],
                [84.78319500000012, 19.117362],
                [84.78319500000012, 19.117084000000144],
                [84.782912000000167, 19.117084000000144],
                [84.782912000000167, 19.116805000000163],
                [84.782639000000117, 19.116810000000211],
                [84.782639000000117, 19.116252],
                [84.782372, 19.116252],
                [84.782372, 19.115971],
                [84.782081000000161, 19.115974000000161],
                [84.782081000000161, 19.115417],
                [84.782912000000167, 19.115420000000139],
                [84.782912000000167, 19.115142],
                [84.783204000000154, 19.115142],
                [84.783204000000154, 19.114032],
                [84.782912000000167, 19.114032],
                [84.782912000000167, 19.113751],
                [84.782639000000117, 19.113751],
                [84.782639000000117, 19.113480000000205],
                [84.782372, 19.113480000000205],
                [84.782372, 19.113202000000111],
                [84.780419000000137, 19.113191],
                [84.780419000000137, 19.112917000000145],
                [84.780136000000184, 19.112922],
                [84.780136000000184, 19.112359000000193],
                [84.779861000000139, 19.112361000000188],
                [84.779861000000139, 19.112083],
                [84.779587, 19.112083],
                [84.779587, 19.111805000000171],
                [84.779311, 19.11181],
                [84.779311, 19.111529],
                [84.778748, 19.111529],
                [84.778748, 19.111249000000154],
                [84.778473, 19.111249000000154],
                [84.778473, 19.110691000000198],
                [84.778199000000129, 19.110695000000188],
                [84.77819, 19.110417],
                [84.777917, 19.110417],
                [84.777917, 19.110139000000171],
                [84.777358000000149, 19.110139000000171],
                [84.777358000000149, 19.109859],
                [84.776526, 19.109861],
                [84.776526, 19.109583000000153],
                [84.77597, 19.109583000000153],
                [84.77597, 19.109861],
                [84.775414, 19.109861],
                [84.775414, 19.109583000000153],
                [84.774026000000148, 19.109583000000153],
                [84.774026000000148, 19.109861],
                [84.77375, 19.109861],
                [84.77375, 19.109583000000153],
                [84.772636, 19.109583000000153],
                [84.772636, 19.109307],
                [84.769301, 19.109307],
                [84.769301, 19.109583000000153],
                [84.769028000000134, 19.109583000000153],
                [84.769028000000134, 19.109307],
                [84.768196, 19.109307],
                [84.768196, 19.109583000000153],
                [84.76764, 19.109583000000153],
                [84.76764, 19.109861],
                [84.767371000000182, 19.109859],
                [84.767371000000182, 19.110139000000171],
                [84.767082000000116, 19.110139000000171],
                [84.767082000000116, 19.109859],
                [84.766808000000182, 19.109859],
                [84.766808000000182, 19.110139000000171],
                [84.765694000000153, 19.110139000000171],
                [84.765694000000153, 19.110417],
                [84.76542, 19.110417],
                [84.76542, 19.110695000000188],
                [84.764579000000111, 19.110691000000198],
                [84.764579000000111, 19.111529],
                [84.762642, 19.111529],
                [84.762642, 19.11181],
                [84.762086, 19.111805000000171],
                [84.762086, 19.112083],
                [84.761803, 19.112083],
                [84.761803, 19.112361000000188],
                [84.761527, 19.112359000000193],
                [84.761527, 19.112641],
                [84.760971, 19.112641],
                [84.760971, 19.112922],
                [84.760695, 19.112917000000145],
                [84.760695, 19.113191],
                [84.759857, 19.113202000000111],
                [84.759857, 19.113480000000205],
                [84.759307, 19.113480000000205],
                [84.759307, 19.113751],
                [84.759025000000108, 19.113751],
                [84.759025000000108, 19.113471000000171],
                [84.758751000000174, 19.113480000000205],
                [84.758751000000174, 19.113202000000111],
                [84.758202, 19.113202000000111],
                [84.758202, 19.113480000000205],
                [84.757637, 19.113480000000205],
                [84.757637, 19.113751],
                [84.757363, 19.113751],
                [84.757363, 19.114032],
                [84.757637, 19.114032],
                [84.757637, 19.114861],
                [84.757363, 19.114861],
                [84.757363, 19.115142],
                [84.75708100000017, 19.115142],
                [84.75708100000017, 19.115420000000139],
                [84.756531000000152, 19.115420000000139],
                [84.756531000000152, 19.115142],
                [84.755966000000157, 19.115142],
                [84.755966000000157, 19.114861],
                [84.75569, 19.114861],
                [84.75569, 19.11458100000015],
                [84.755417000000179, 19.114583000000149],
                [84.755417000000179, 19.114305],
                [84.75569, 19.114312],
                [84.75569, 19.113751],
                [84.755966000000157, 19.113751],
                [84.755966000000157, 19.112641],
                [84.75569, 19.112641],
                [84.75569, 19.112079000000104],
                [84.755417000000179, 19.112083],
                [84.755417000000179, 19.111805000000171],
                [84.754861, 19.11181],
                [84.754861, 19.111249000000154],
                [84.754302000000138, 19.111249000000154],
                [84.754302000000138, 19.111529],
                [84.753746000000135, 19.111529],
                [84.753746000000135, 19.111249000000154],
                [84.753471000000133, 19.111249000000154],
                [84.753471000000133, 19.111529],
                [84.753197, 19.111529],
                [84.753197, 19.112922],
                [84.754302000000138, 19.112922],
                [84.754302000000138, 19.113751],
                [84.754029, 19.113751],
                [84.754029, 19.114312],
                [84.753471000000133, 19.114305],
                [84.753471000000133, 19.114583000000149],
                [84.752908, 19.11458100000015],
                [84.752908, 19.115142],
                [84.752639, 19.115139000000166],
                [84.752639, 19.115693000000189],
                [84.752083000000184, 19.115693000000189],
                [84.752083000000184, 19.115974000000161],
                [84.750968000000157, 19.115971],
                [84.750968000000157, 19.116252],
                [84.749863, 19.116252],
                [84.749863, 19.116541000000151],
                [84.74958, 19.116541000000151],
                [84.74958, 19.116810000000211],
                [84.749307, 19.116805000000163],
                [84.749307, 19.117084000000144],
                [84.747643, 19.117081],
                [84.747643, 19.117362],
                [84.747087000000178, 19.117362],
                [84.747094, 19.117640000000161],
                [84.745696, 19.117640000000161],
                [84.745696, 19.117362],
                [84.7454070000001, 19.117362],
                [84.7454070000001, 19.117081],
                [84.74514, 19.117084000000144],
                [84.74514, 19.116805000000163],
                [84.744858000000178, 19.116810000000211],
                [84.744858000000178, 19.116541000000151],
                [84.744308000000146, 19.116541000000151],
                [84.744308000000146, 19.116252],
                [84.744026, 19.116252],
                [84.744026, 19.115971],
                [84.743752000000129, 19.115974000000161],
                [84.743752000000129, 19.115693000000189],
                [84.74347, 19.115693000000189],
                [84.74347, 19.115417],
                [84.742920000000169, 19.115420000000139],
                [84.742920000000169, 19.115142],
                [84.742638000000156, 19.115142],
                [84.742638000000156, 19.114861],
                [84.742082000000124, 19.114861],
                [84.742082000000124, 19.11458100000015],
                [84.74125, 19.114583000000149],
                [84.74125, 19.114305],
                [84.740967000000111, 19.114312],
                [84.740967000000111, 19.114032],
                [84.740691000000169, 19.114032],
                [84.740691000000169, 19.113751],
                [84.740418000000133, 19.113751],
                [84.740418000000133, 19.113202000000111],
                [84.740142, 19.113191],
                [84.740135000000166, 19.112917000000145],
                [84.739860000000178, 19.112922],
                [84.739860000000178, 19.112641],
                [84.739586, 19.112641],
                [84.739586, 19.112359000000193],
                [84.738472, 19.112361000000188],
                [84.738472, 19.111805000000171],
                [84.738198, 19.11181],
                [84.738198, 19.110969000000122],
                [84.737915000000143, 19.110971],
                [84.737915000000143, 19.110695000000188],
                [84.737084000000138, 19.110695000000188],
                [84.737084000000138, 19.110417],
                [84.736808, 19.110417],
                [84.736808, 19.110139000000171],
                [84.736527, 19.110139000000171],
                [84.736527, 19.109309],
                [84.736252, 19.109309],
                [84.736252, 19.108749],
                [84.736527, 19.108749],
                [84.736527, 19.107349],
                [84.736252, 19.107361000000189],
                [84.736252, 19.10680700000017],
                [84.735969000000111, 19.106809000000165],
                [84.735969000000111, 19.106531],
                [84.735686000000143, 19.106531],
                [84.735686000000143, 19.106251000000153],
                [84.735420000000119, 19.106251000000153],
                [84.735420000000119, 19.10597000000018],
                [84.735137000000165, 19.105973],
                [84.735137000000165, 19.105695000000189],
                [84.734864000000115, 19.105695000000189],
                [84.734864000000115, 19.103473000000175],
                [84.734581000000134, 19.103473000000175],
                [84.734581000000134, 19.103194000000197],
                [84.734864000000115, 19.103201],
                [84.734864000000115, 19.10236],
                [84.735137000000165, 19.102363000000192],
                [84.735137000000165, 19.101250000000103],
                [84.734864000000115, 19.101250000000103],
                [84.734864000000115, 19.10097200000018],
                [84.734581000000134, 19.10097200000018],
                [84.734581000000134, 19.100694],
                [84.733749, 19.100694],
                [84.733749, 19.10014000000012],
                [84.733467000000175, 19.10014000000012],
                [84.733467000000175, 19.099860000000199],
                [84.733193, 19.099860000000199],
                [84.733193, 19.099580000000113],
                [84.732917000000143, 19.099582000000105],
                [84.732917000000143, 19.099028],
                [84.73264400000015, 19.099031000000192],
                [84.73264400000015, 19.098180000000124],
                [84.732361000000182, 19.098194000000198],
                [84.732361000000182, 19.097918],
                [84.732085, 19.097921000000152],
                [84.732085, 19.09764000000018],
                [84.731529, 19.09764000000018],
                [84.731529, 19.09736],
                [84.731247, 19.09736],
                [84.731247, 19.097084],
                [84.730973, 19.097084],
                [84.730973, 19.096806000000125],
                [84.730424000000127, 19.09680800000012],
                [84.730424000000127, 19.096530000000193],
                [84.728751, 19.096530000000193],
                [84.728751, 19.096250000000108],
                [84.72847100000017, 19.096250000000108],
                [84.72847100000017, 19.09597],
                [84.727912000000103, 19.095972000000184],
                [84.727912000000103, 19.095694],
                [84.727363000000167, 19.095694],
                [84.727363000000167, 19.095972000000184],
                [84.726807000000164, 19.09597],
                [84.726807000000164, 19.096250000000108],
                [84.726251000000133, 19.096250000000108],
                [84.726251000000133, 19.096530000000193],
                [84.725419, 19.096530000000193],
                [84.725419, 19.09736],
                [84.725127, 19.09736],
                [84.725127, 19.097921000000152],
                [84.725692, 19.097918],
                [84.725692, 19.098472000000125],
                [84.725975, 19.098472000000125],
                [84.725982000000144, 19.10014000000012],
                [84.725692, 19.10014000000012],
                [84.725692, 19.102641],
                [84.725982000000144, 19.102641],
                [84.725982000000144, 19.103201],
                [84.726251000000133, 19.103201],
                [84.726251000000133, 19.103751],
                [84.726517000000143, 19.103751],
                [84.726517000000143, 19.104031000000184],
                [84.726807000000164, 19.104031000000184],
                [84.726807000000164, 19.104311],
                [84.72708, 19.10430400000018],
                [84.72708, 19.104585000000153],
                [84.72763900000011, 19.104580000000109],
                [84.72763900000011, 19.104861],
                [84.727912000000103, 19.104861],
                [84.727912000000103, 19.105421],
                [84.728195, 19.105417],
                [84.728195, 19.105695000000189],
                [84.729309, 19.10569],
                [84.729309, 19.106531],
                [84.729583000000147, 19.106527],
                [84.729583000000147, 19.107083],
                [84.729859, 19.107085],
                [84.729859, 19.107361000000189],
                [84.730141000000145, 19.107349],
                [84.730141000000145, 19.107641],
                [84.730424000000127, 19.107641],
                [84.730424000000127, 19.107919000000148],
                [84.730697000000177, 19.107917000000153],
                [84.730697000000177, 19.108195],
                [84.730973, 19.108195],
                [84.730973, 19.108473000000171],
                [84.731529, 19.108471000000176],
                [84.731529, 19.109309],
                [84.731803000000156, 19.109307],
                [84.731803000000156, 19.109583000000153],
                [84.732085, 19.109581],
                [84.732085, 19.110139000000171],
                [84.732361000000182, 19.110139000000171],
                [84.732361000000182, 19.110417],
                [84.732635000000116, 19.110417],
                [84.732635000000116, 19.110971],
                [84.732917000000143, 19.110969000000122],
                [84.732917000000143, 19.11181],
                [84.73264400000015, 19.11181],
                [84.73264400000015, 19.112641],
                [84.732917000000143, 19.112641],
                [84.732917000000143, 19.112922],
                [84.7340090000001, 19.112922],
                [84.7340090000001, 19.112641],
                [84.734321000000179, 19.112641],
                [84.734321000000179, 19.112359000000193],
                [84.734581000000134, 19.112361000000188],
                [84.734581000000134, 19.112083],
                [84.735137000000165, 19.112083],
                [84.735137000000165, 19.111805000000171],
                [84.735420000000119, 19.11181],
                [84.735420000000119, 19.111529],
                [84.735686000000143, 19.111529],
                [84.735686000000143, 19.110969000000122],
                [84.736527, 19.110971],
                [84.736527, 19.112083],
                [84.737084000000138, 19.112083],
                [84.737084000000138, 19.112361000000188],
                [84.737922000000182, 19.112359000000193],
                [84.737922000000182, 19.112641],
                [84.738198, 19.112639],
                [84.738198, 19.113191],
                [84.737068, 19.113202000000111],
                [84.737068, 19.113480000000205],
                [84.736808, 19.113471000000171],
                [84.736808, 19.114583000000149],
                [84.736527, 19.114583000000149],
                [84.736527, 19.114305],
                [84.736252, 19.114312],
                [84.736252, 19.114032],
                [84.735969000000111, 19.114027000000188],
                [84.735969000000111, 19.115693000000189],
                [84.735686000000143, 19.115691000000194],
                [84.735686000000143, 19.116252],
                [84.735420000000119, 19.116252],
                [84.735420000000119, 19.116541000000151],
                [84.735137000000165, 19.116541000000151],
                [84.735137000000165, 19.116810000000211],
                [84.734864000000115, 19.116810000000211],
                [84.734864000000115, 19.117362],
                [84.735137000000165, 19.117362],
                [84.735137000000165, 19.11792],
                [84.735420000000119, 19.11792],
                [84.735420000000119, 19.117640000000161],
                [84.735969000000111, 19.117640000000161],
                [84.735969000000111, 19.11792],
                [84.736252, 19.117915000000149],
                [84.736252, 19.119584],
                [84.735969000000111, 19.119584],
                [84.735969000000111, 19.119862000000122],
                [84.735686000000143, 19.119860000000127],
                [84.735686000000143, 19.12014],
                [84.734864000000115, 19.12014],
                [84.734864000000115, 19.120420000000134],
                [84.734321000000179, 19.120420000000134],
                [84.734321000000179, 19.12014],
                [84.733749, 19.12014],
                [84.733749, 19.120701000000103],
                [84.733476, 19.120696],
                [84.733476, 19.12208400000014],
                [84.733749, 19.12208400000014],
                [84.733749, 19.12236],
                [84.735420000000119, 19.12236],
                [84.735420000000119, 19.12208400000014],
                [84.735696, 19.12208400000014],
                [84.735696, 19.121806],
                [84.737084000000138, 19.121806],
                [84.737084000000138, 19.12208400000014],
                [84.737357, 19.122079],
                [84.737357, 19.122920000000185],
                [84.737084000000138, 19.122918],
                [84.737084000000138, 19.123194000000122],
                [84.736808, 19.123194000000122],
                [84.736808, 19.123472],
                [84.735969000000111, 19.12347],
                [84.735969000000111, 19.12375000000014],
                [84.735686000000143, 19.12375000000014],
                [84.735686000000143, 19.12403],
                [84.735420000000119, 19.12403],
                [84.735420000000119, 19.124860000000123],
                [84.735969000000111, 19.124860000000123],
                [84.735969000000111, 19.12458],
                [84.738472, 19.124584],
                [84.738472, 19.124028],
                [84.738747, 19.12403],
                [84.738747, 19.12375000000014],
                [84.739297000000121, 19.12375000000014],
                [84.739297000000121, 19.12347],
                [84.740135000000166, 19.123472],
                [84.740135000000166, 19.123194000000122],
                [84.740974000000151, 19.123194000000122],
                [84.740974000000151, 19.122918],
                [84.741532000000106, 19.122920000000185],
                [84.741532000000106, 19.122640000000153],
                [84.741806, 19.122640000000153],
                [84.741806, 19.122351000000204],
                [84.742362, 19.122351000000204],
                [84.742362, 19.122640000000153],
                [84.74347, 19.122640000000153],
                [84.74347, 19.122351000000204],
                [84.743752000000129, 19.12236],
                [84.743752000000129, 19.12208400000014],
                [84.744026, 19.12208400000014],
                [84.744026, 19.121528000000122],
                [84.744584, 19.121530000000117],
                [84.744584, 19.120969],
                [84.745414000000139, 19.120972000000162],
                [84.745414000000139, 19.120696],
                [84.745696, 19.120696],
                [84.745696, 19.120972000000162],
                [84.745972000000137, 19.120969],
                [84.745972000000137, 19.12125],
                [84.746262000000158, 19.12125],
                [84.746262000000158, 19.121530000000117],
                [84.746528, 19.121528000000122],
                [84.746528, 19.123194000000122],
                [84.746246, 19.123194000000122],
                [84.746262000000158, 19.12375000000014],
                [84.745972000000137, 19.12375000000014],
                [84.745972000000137, 19.124311000000201],
                [84.7454070000001, 19.124311000000201],
                [84.7454070000001, 19.124860000000123],
                [84.74514, 19.124860000000123],
                [84.74514, 19.125140000000211],
                [84.744308000000146, 19.125140000000211],
                [84.744308000000146, 19.12625],
                [84.744026, 19.12625],
                [84.744026, 19.12708200000014],
                [84.744308000000146, 19.127080000000145],
                [84.744308000000146, 19.127921000000125],
                [84.744584, 19.127916],
                [84.744584, 19.128194000000118],
                [84.744858000000178, 19.128192000000123],
                [84.744858000000178, 19.128481],
                [84.745696, 19.128481],
                [84.745696, 19.128750000000135],
                [84.746262000000158, 19.128750000000135],
                [84.746262000000158, 19.129031000000108],
                [84.746528, 19.129028],
                [84.746528, 19.129304000000158],
                [84.746804, 19.129304000000158],
                [84.746804, 19.129582],
                [84.746528, 19.129582],
                [84.746528, 19.129863],
                [84.746262000000158, 19.129860000000114],
                [84.746262000000158, 19.130701],
                [84.746528, 19.130695000000113],
                [84.746528, 19.130973000000207],
                [84.746804, 19.130970000000158],
                [84.746804, 19.131811],
                [84.745414000000139, 19.131804],
                [84.745414000000139, 19.132085000000181],
                [84.744858000000178, 19.132080000000141],
                [84.744858000000178, 19.132361000000113],
                [84.744584, 19.132361000000113],
                [84.744584, 19.132921],
                [84.744858000000178, 19.132917000000131],
                [84.744858000000178, 19.133195],
                [84.74514, 19.133195],
                [84.74514, 19.133473],
                [84.7454070000001, 19.133471],
                [84.7454070000001, 19.134029000000108],
                [84.747094, 19.134029000000108],
                [84.747094, 19.134309000000194],
                [84.747643, 19.134307000000202],
                [84.747643, 19.134583000000131],
                [84.747916, 19.13458],
                [84.747916, 19.134861],
                [84.748192000000117, 19.134861],
                [84.748192000000117, 19.135139],
                [84.748475, 19.135139],
                [84.748475, 19.135695000000108],
                [84.74874800000012, 19.135695000000108],
                [84.74874800000012, 19.135973000000199],
                [84.750419000000164, 19.135971000000207],
                [84.750419000000164, 19.136529],
                [84.750138, 19.136529],
                [84.750138, 19.137083000000185],
                [84.749863, 19.13708100000019],
                [84.749863, 19.140422],
                [84.74958, 19.140422],
                [84.74958, 19.141251],
                [84.749297000000112, 19.141251],
                [84.749297000000112, 19.141810000000131],
                [84.749031000000102, 19.141805],
                [84.749031000000102, 19.142083000000181],
                [84.74874800000012, 19.142081000000186],
                [84.74874800000012, 19.142361000000104],
                [84.748192000000117, 19.142361000000104],
                [84.748192000000117, 19.142642],
                [84.74736, 19.142639000000198],
                [84.74736, 19.143193],
                [84.747087000000178, 19.143193],
                [84.747087000000178, 19.14347400000019],
                [84.74514, 19.143462],
                [84.74514, 19.143752],
                [84.744858000000178, 19.143752],
                [84.744858000000178, 19.144030000000154],
                [84.744584, 19.144027000000104],
                [84.744584, 19.144584000000176],
                [84.743752000000129, 19.144584000000176],
                [84.743752000000129, 19.144306],
                [84.74347, 19.14431],
                [84.74347, 19.144030000000154],
                [84.740142, 19.144030000000154],
                [84.740142, 19.143752],
                [84.739860000000178, 19.143752],
                [84.739860000000178, 19.143462],
                [84.739586, 19.14347400000019],
                [84.739586, 19.142918000000176],
                [84.739297000000121, 19.142920000000171],
                [84.739297000000121, 19.142361000000104],
                [84.738198, 19.142361000000104],
                [84.738198, 19.142642],
                [84.737922000000182, 19.142642],
                [84.737922000000182, 19.142920000000171],
                [84.737640000000141, 19.142918000000176],
                [84.737640000000141, 19.143193],
                [84.737084000000138, 19.143193],
                [84.737084000000138, 19.14347400000019],
                [84.736808, 19.143462],
                [84.736808, 19.143752],
                [84.735420000000119, 19.143752],
                [84.735420000000119, 19.143462],
                [84.734581000000134, 19.14347400000019],
                [84.734581000000134, 19.143193],
                [84.734305, 19.143193],
                [84.734305, 19.142918000000176],
                [84.733467000000175, 19.142920000000171],
                [84.733467000000175, 19.142642],
                [84.732917000000143, 19.142642],
                [84.732917000000143, 19.142081000000186],
                [84.732361000000182, 19.142083000000181],
                [84.732361000000182, 19.141805],
                [84.730973, 19.141810000000131],
                [84.730973, 19.141532],
                [84.729859, 19.141532],
                [84.729859, 19.141251],
                [84.729576000000108, 19.141251],
                [84.729576000000108, 19.140971000000203],
                [84.729027, 19.140971000000203],
                [84.729027, 19.140693000000109],
                [84.728751, 19.140693000000109],
                [84.728751, 19.140417000000181],
                [84.72847100000017, 19.140422],
                [84.72847100000017, 19.140142000000193],
                [84.72820200000011, 19.140142000000193],
                [84.72820200000011, 19.139861],
                [84.727363000000167, 19.139861],
                [84.727363000000167, 19.139583000000126],
                [84.726807000000164, 19.139583000000126],
                [84.726807000000164, 19.139861],
                [84.726251000000133, 19.139861],
                [84.726251000000133, 19.140142000000193],
                [84.724861, 19.140142000000193],
                [84.724861, 19.140422],
                [84.723748, 19.140422],
                [84.723748, 19.140142000000193],
                [84.723473000000155, 19.140142000000193],
                [84.723473000000155, 19.139861],
                [84.722641, 19.139861],
                [84.722641, 19.139583000000126],
                [84.722358000000142, 19.139583000000126],
                [84.722358000000142, 19.139305000000199],
                [84.722069, 19.139312],
                [84.722069, 19.138469],
                [84.72180200000011, 19.138471],
                [84.72180200000011, 19.138195],
                [84.721526, 19.1382],
                [84.721526, 19.137919],
                [84.721253000000146, 19.137919],
                [84.721253000000146, 19.137639000000199],
                [84.720970000000179, 19.137639000000199],
                [84.720970000000179, 19.137359000000114],
                [84.720697, 19.137361000000105],
                [84.720697, 19.136807],
                [84.720970000000179, 19.1368],
                [84.720970000000179, 19.136529],
                [84.721253000000146, 19.136529],
                [84.721253000000146, 19.135971000000207],
                [84.721526, 19.135973000000199],
                [84.721526, 19.135139],
                [84.721253000000146, 19.135139],
                [84.721253000000146, 19.13458],
                [84.721526, 19.134583000000131],
                [84.721526, 19.134027000000113],
                [84.72180200000011, 19.134029000000108],
                [84.72180200000011, 19.133471],
                [84.721253000000146, 19.133473],
                [84.721253000000146, 19.133195],
                [84.720970000000179, 19.133195],
                [84.720970000000179, 19.132917000000131],
                [84.720414, 19.132921],
                [84.720414, 19.132641000000202],
                [84.720138000000119, 19.132641000000202],
                [84.720138000000119, 19.132361000000113],
                [84.719856, 19.132361000000113],
                [84.719856, 19.131811],
                [84.719582, 19.131811],
                [84.719582, 19.13125100000013],
                [84.719856, 19.13125100000013],
                [84.719856, 19.130970000000158],
                [84.719582, 19.130973000000207],
                [84.719582, 19.130695000000113],
                [84.719322, 19.130701],
                [84.719322, 19.130141],
                [84.719033000000167, 19.130141],
                [84.719033000000167, 19.129860000000114],
                [84.717918, 19.129863],
                [84.717918, 19.129582],
                [84.717362, 19.129582],
                [84.717362, 19.129304000000158],
                [84.717086, 19.129304000000158],
                [84.717086, 19.129028],
                [84.716797, 19.129031000000108],
                [84.716797, 19.128750000000135],
                [84.716248000000107, 19.128750000000135],
                [84.716248000000107, 19.128472],
                [84.715698, 19.128481],
                [84.715692000000146, 19.128192000000123],
                [84.715416, 19.128194000000118],
                [84.715416, 19.127916],
                [84.714028000000141, 19.127921000000125],
                [84.714028000000141, 19.12764],
                [84.713752, 19.12764],
                [84.713752, 19.12736],
                [84.713469, 19.127362],
                [84.713469, 19.12708200000014],
                [84.713196, 19.12708200000014],
                [84.713196, 19.126528000000118],
                [84.71289700000014, 19.126531],
                [84.71289700000014, 19.12625],
                [84.712640000000178, 19.12625],
                [84.712640000000178, 19.125970000000159],
                [84.712364, 19.125972000000154],
                [84.712364, 19.12541600000014],
                [84.712081, 19.125421000000184],
                [84.712081, 19.124860000000123],
                [84.711808000000119, 19.124860000000123],
                [84.711808000000119, 19.12458],
                [84.711525000000137, 19.124584],
                [84.711525000000137, 19.123472],
                [84.710976000000173, 19.123472],
                [84.710976000000173, 19.123194000000122],
                [84.710693, 19.123194000000122],
                [84.710693, 19.122918],
                [84.710418, 19.122920000000185],
                [84.710418, 19.122351000000204],
                [84.708474000000109, 19.12236],
                [84.708474000000109, 19.12208400000014],
                [84.706803, 19.12208400000014],
                [84.706803, 19.121806],
                [84.70652700000015, 19.121810000000206],
                [84.70652700000015, 19.121530000000117],
                [84.705695, 19.121530000000117],
                [84.705695, 19.120969],
                [84.705413000000178, 19.120972000000162],
                [84.705413000000178, 19.120416000000141],
                [84.704025, 19.120416000000141],
                [84.704025, 19.120972000000162],
                [84.703475, 19.120972000000162],
                [84.703475, 19.120696],
                [84.703186000000102, 19.120701000000103],
                [84.703186000000102, 19.119860000000127],
                [84.702919, 19.119862000000122],
                [84.702919, 19.118750000000141],
                [84.703186000000102, 19.118750000000141],
                [84.703186000000102, 19.117640000000161],
                [84.703475, 19.117640000000161],
                [84.703475, 19.116810000000211],
                [84.703751, 19.116810000000211],
                [84.703751, 19.116252],
                [84.704034, 19.116252],
                [84.704034, 19.115971],
                [84.704307000000128, 19.115974000000161],
                [84.704307000000128, 19.114583000000149],
                [84.704863000000131, 19.114583000000149],
                [84.704863000000131, 19.114305],
                [84.705406000000139, 19.114312],
                [84.705406000000139, 19.114032],
                [84.705695, 19.114032],
                [84.705695, 19.113751],
                [84.70652700000015, 19.113751],
                [84.70652700000015, 19.113202000000111],
                [84.705971000000133, 19.113191],
                [84.705971000000133, 19.111249000000154],
                [84.706254000000101, 19.111249000000154],
                [84.706254000000101, 19.110969000000122],
                [84.70652700000015, 19.110971],
                [84.70652700000015, 19.110695000000188],
                [84.706803, 19.110695000000188],
                [84.706803, 19.110139000000171],
                [84.707092000000145, 19.110139000000171],
                [84.707092000000145, 19.109029000000188],
                [84.706803, 19.109029000000188],
                [84.706803, 19.108749],
                [84.70652700000015, 19.108749],
                [84.70652700000015, 19.108471000000176],
                [84.706803, 19.108473000000171],
                [84.706803, 19.108195],
                [84.707086, 19.108195],
                [84.707086, 19.107917000000153],
                [84.707915, 19.107917000000153],
                [84.707915, 19.108195],
                [84.710137, 19.108195],
                [84.710137, 19.108473000000171],
                [84.710418, 19.108473000000171],
                [84.710418, 19.108195],
                [84.710976000000173, 19.108195],
                [84.710976000000173, 19.107639],
                [84.71125, 19.107641],
                [84.71125, 19.107349],
                [84.711525000000137, 19.107361000000189],
                [84.711525000000137, 19.107085],
                [84.71125, 19.107085],
                [84.71125, 19.106527],
                [84.711532, 19.106531],
                [84.711532, 19.106251000000153],
                [84.711808000000119, 19.106251000000153],
                [84.711808000000119, 19.10514100000017],
                [84.712081, 19.10514100000017],
                [84.712081, 19.104861],
                [84.712357, 19.104861],
                [84.712357, 19.104580000000109],
                [84.712913, 19.104585000000153],
                [84.712913, 19.103751],
                [84.713189000000156, 19.103751],
                [84.713189000000156, 19.103201],
                [84.713469, 19.103201],
                [84.713469, 19.102921000000148],
                [84.713752, 19.102921000000148],
                [84.713752, 19.100421],
                [84.714028000000141, 19.100421],
                [84.714028000000141, 19.099580000000113],
                [84.71430100000012, 19.099582000000105],
                [84.71430100000012, 19.09930600000018],
                [84.714577, 19.099311],
                [84.714577, 19.099031000000192],
                [84.71626400000018, 19.099031000000192],
                [84.71626400000018, 19.09875],
                [84.71653, 19.09875],
                [84.71653, 19.097921000000152],
                [84.716797, 19.097921000000152],
                [84.716797, 19.09764000000018],
                [84.717086, 19.09764000000018],
                [84.717086, 19.09736],
                [84.717636, 19.09736],
                [84.717636, 19.09708],
                [84.71875, 19.097084],
                [84.71875, 19.096806000000125],
                [84.719033000000167, 19.09680800000012],
                [84.719033000000167, 19.096530000000193],
                [84.71875, 19.096530000000193],
                [84.71875, 19.096250000000108],
                [84.719033000000167, 19.096250000000108],
                [84.719033000000167, 19.09584400000011],
                [84.711854000000173, 19.100031000000111],
                [84.697547, 19.108819000000207],
                [84.698327, 19.11031],
                [84.697768000000153, 19.115632000000115],
                [84.693816000000183, 19.11952],
                [84.693917, 19.121551],
                [84.697319000000135, 19.125129000000182],
                [84.70648200000015, 19.143560000000203],
                [84.705224000000143, 19.14901],
                [84.702087000000105, 19.15115],
                [84.697563000000102, 19.150291000000205],
                [84.692139, 19.151701000000166],
                [84.681411000000182, 19.149750000000207],
                [84.678070000000147, 19.153470000000194],
                [84.673332000000158, 19.156891],
                [84.669295000000133, 19.155681000000126],
                [84.665017, 19.156731000000146],
                [84.663269000000113, 19.14748000000014],
                [84.665414000000155, 19.144702000000162],
                [84.665902, 19.135271],
                [84.664514, 19.128151000000109],
                [84.661170000000183, 19.121861000000134],
                [84.657318000000132, 19.121389000000189],
                [84.653428000000176, 19.122909],
                [84.647292000000135, 19.12037],
                [84.641709, 19.124789000000131],
                [84.640373, 19.122239000000146],
                [84.629319, 19.120701000000103],
                [84.625550000000118, 19.118271000000103],
                [84.609397000000158, 19.11745],
                [84.594642, 19.123549000000192],
                [84.591843, 19.123841000000194],
                [84.591682, 19.121120000000126],
                [84.595773000000165, 19.115210000000154],
                [84.602936, 19.096571000000207],
                [84.605559, 19.09263100000015],
                [84.609627, 19.090892000000164],
                [84.614411, 19.092318000000201],
                [84.616784, 19.090001000000139],
                [84.616570000000166, 19.085201000000207],
                [84.619827, 19.076510000000152],
                [84.624444, 19.07442],
                [84.631448, 19.072620000000196],
                [84.633606, 19.074639000000101],
                [84.634744, 19.078689000000164],
                [84.644608000000105, 19.084451000000168],
                [84.648712, 19.084200000000177],
                [84.654166000000131, 19.081012000000154],
                [84.65962300000011, 19.070931],
                [84.66458900000012, 19.066291000000202],
                [84.663201000000171, 19.064451000000187],
                [84.659012000000175, 19.063649000000108],
                [84.6545330000001, 19.052310000000141],
                [84.647728000000185, 19.05608900000021],
                [84.636834000000121, 19.057149000000148],
                [84.634377, 19.05554],
                [84.630058000000105, 19.049591],
                [84.626083, 19.050291],
                [84.625413, 19.052780000000148],
                [84.623291, 19.05566100000015],
                [84.61271600000012, 19.054831000000203],
                [84.611526000000126, 19.05373],
                [84.612358000000185, 19.049740000000153],
                [84.614188000000112, 19.04672],
                [84.609466, 19.04674000000011],
                [84.607567000000103, 19.045409000000117],
                [84.600486, 19.032931],
                [84.596978, 19.019742],
                [84.590118000000174, 19.013381],
                [84.587693000000101, 19.01299100000011],
                [84.578132, 19.018901],
                [84.575317000000126, 19.027192],
                [84.573647, 19.03511],
                [84.575096, 19.037539000000148],
                [84.578118000000117, 19.062129],
                [84.576446000000132, 19.064561],
                [84.570602000000108, 19.060411],
                [84.5685280000001, 19.060641],
                [84.567969, 19.063471000000103],
                [84.566139000000177, 19.06503900000018],
                [84.559724000000173, 19.059560000000143],
                [84.553597000000181, 19.04741000000012],
                [84.547722, 19.046091],
                [84.534813000000142, 19.045361],
                [84.531471000000153, 19.044149000000115],
                [84.527152, 19.038720000000179],
                [84.50991800000017, 19.037460000000177],
                [84.507110000000168, 19.035449],
                [84.503089, 19.029262],
                [84.497779000000122, 19.024879000000166],
                [84.489387000000107, 19.020950000000134],
                [84.482064000000122, 19.009909],
                [84.477830000000139, 19.007890000000142],
                [84.475516000000169, 18.996032],
                [84.475692000000137, 18.99174],
                [84.473062000000127, 18.982642000000109],
                [84.471658000000133, 18.98122],
                [84.462831, 18.983289000000177],
                [84.452187, 18.988331],
                [84.448151, 18.99174],
                [84.444062, 18.994559],
                [84.437393000000142, 18.997459],
                [84.432976, 19.001860000000189],
                [84.429801, 19.00118],
                [84.42218700000015, 19.008531],
                [84.420022000000102, 19.012519000000164],
                [84.415131, 19.013861000000187],
                [84.41465, 19.012360000000111],
                [84.415413, 19.008132],
                [84.418036, 19.004989],
                [84.420035, 19.000841],
                [84.42526100000012, 18.995341000000106],
                [84.425521753221275, 18.994242946046537],
                [84.426109000000324, 18.991770000000194],
                [84.425553000000136, 18.989151],
                [84.426408, 18.983971000000103],
                [84.427964000000287, 18.982642000000279],
                [84.434722000000278, 18.976830000000231],
                [84.440643000000279, 18.966930000000215],
                [84.437728000000305, 18.965710000000339],
                [84.434547000000393, 18.963160000000354],
                [84.4203040000003, 18.949360000000237],
                [84.41559600000032, 18.938039000000341],
                [84.411405836450143, 18.935782183805483],
                [84.408193564092159, 18.93613910295624],
                [84.407836644941398, 18.940779051917612],
                [84.401412100225656, 18.941135971068601],
                [84.401769019376587, 18.945419000879038],
                [84.395701393811734, 18.951129707293088],
                [84.397485989565922, 18.953985060499971],
                [84.406052049187025, 18.958268090310579],
                [84.406765887488788, 18.961480362668393],
                [84.411048917299226, 18.963978796724458],
                [84.403196695980043, 18.972544856345561],
                [84.39677215126423, 18.967904907384192],
                [84.389276849095992, 18.968261826534953],
                [84.384993819285484, 18.966120311629819],
                [84.383923061832874, 18.960409605215713],
                [84.371430891552265, 18.960409605215713],
                [84.355369529762896, 18.977541724457744],
                [84.366006488710497, 18.995322571782193],
                [84.366218, 18.999731],
                [84.367040042753374, 19.007381107758015],
                [84.368412187806811, 19.02015058656621],
                [84.355920017526202, 19.011822473045804],
                [84.356514882777645, 19.018960856063298],
                [84.36127380478932, 19.03085816109245],
                [84.354508000000166, 19.034100000000191],
                [84.354281111474933, 19.037715379008599],
                [84.354141000000183, 19.039948000000148],
                [84.351060000000174, 19.04429],
                [84.35505700000013, 19.047399],
                [84.358275, 19.057881000000176],
                [84.361622064074851, 19.064249183144167],
                [84.362494250355411, 19.065908620144963],
                [84.35889434378349, 19.075473054951768],
                [84.35889434378349, 19.086180629478005],
                [84.372016, 19.092822000000179],
                [84.370196783561184, 19.10938037428485],
                [84.364842996298066, 19.101647126015902],
                [84.35056623026307, 19.097483069255698],
                [84.349376499760169, 19.087965225232377],
                [84.341048386239763, 19.076067920203226],
                [84.332720272719357, 19.080231976963429],
                [84.342238116742678, 19.102836856518817],
                [84.339858655736833, 19.106406048027562],
                [84.345807308251423, 19.117708487805256],
                [84.343427847245579, 19.133174984343153],
                [84.354135421771815, 19.143287693617928],
                [84.361868670040764, 19.13139038858878],
                [84.370391, 19.13183],
                [84.374857421002147, 19.131921961714905],
                [84.383553000000106, 19.132101],
                [84.377930031830132, 19.142692828366474],
                [84.385663280099067, 19.142097963115017],
                [84.388637606356369, 19.149236346132504],
                [84.37495570557283, 19.152210672389796],
                [84.374360840321387, 19.159943920658741],
                [84.362375671658512, 19.167922416294456],
                [84.374360840321387, 19.176005282448099],
                [84.370791648812627, 19.181359069711217],
                [84.361512, 19.18634],
                [84.356514882777645, 19.188497452728708],
                [84.388077000000166, 19.198932000000124],
                [84.394749609409331, 19.199129030625667],
                [84.399805964046763, 19.198236732748509],
                [84.4117032690759, 19.213108364034944],
                [84.423898006730766, 19.239282435099081],
                [84.425682602485139, 19.249990009625318],
                [84.420626247847778, 19.278543541695282],
                [84.41968752799481, 19.286894771639648],
                [84.421189000000183, 19.289910000000187],
                [84.414016000000146, 19.296281],
                [84.411949, 19.30039],
                [84.41233, 19.313180000000152],
                [84.408981000000139, 19.325109],
                [84.410867874472601, 19.329969704052413],
                [84.412774000000113, 19.33488],
                [84.41684, 19.342340000000203],
                [84.423766, 19.348580000000137],
                [84.433639000000184, 19.354392000000129],
                [84.4118581150681, 19.357016631186294],
                [84.395181124122388, 19.348516205370796],
                [84.383283819093251, 19.346731609616423],
                [84.373171109818458, 19.356249453639744],
                [84.369007053058255, 19.362792971405778],
                [84.376740301327203, 19.361008375651405],
                [84.377917386302826, 19.370512808073325],
                [84.375428, 19.37286000000017],
                [84.3753600000001, 19.375989],
                [84.379934264715004, 19.380293867645886],
                [84.357109748029117, 19.390156772972826],
                [84.354730287023273, 19.402054078001978],
                [84.366032726800981, 19.406218134762181],
                [84.370196783561184, 19.403838673756347],
                [84.376740301327203, 19.413951383031129],
                [84.386696000000128, 19.418502],
                [84.393928, 19.41955],
                [84.402914372391351, 19.41871030504279],
                [84.410647620660299, 19.426443553311739],
                [84.410052755408827, 19.428823014317565],
                [84.397870443074083, 19.428555167127964],
                [84.392801663116572, 19.428228149066111],
                [84.383878684344694, 19.429417879569026],
                [84.38090435808742, 19.439530588843805],
                [84.373765975069929, 19.448453567615669],
                [84.366032726800981, 19.444884376106923],
                [84.360084074286391, 19.45559195063316],
                [84.364248131046608, 19.468084120913769],
                [84.370072, 19.472150000000163],
                [84.367638000000156, 19.475510000000153],
                [84.369666, 19.480360000000186],
                [84.37394, 19.486500000000145],
                [84.37046, 19.49137],
                [84.369290243824906, 19.494521803831841],
                [84.369046184634655, 19.495179399583769],
                [84.367973000000163, 19.498071],
                [84.373765975069929, 19.500206844492478],
                [84.369751000000164, 19.51294],
                [84.369041124825728, 19.514579263538504],
                [84.373033154550939, 19.517074282116877],
                [84.375550570824302, 19.518647667287659],
                [84.377930031830132, 19.532329568071187],
                [84.373171109818458, 19.53649362483139],
                [84.377335166578675, 19.543037142597424],
                [84.369007053058255, 19.552554986620745],
                [84.35889434378349, 19.560883100141151],
                [84.348186769257254, 19.576349596679048],
                [84.342832981994135, 19.563857426398439],
                [84.330340811713512, 19.565642022152812],
                [84.322607563444578, 19.57337527042176],
                [84.319038371935818, 19.570400944164469],
                [84.326176754953323, 19.562667695895524],
                [84.322607563444578, 19.556124178129487],
                [84.305356471152308, 19.557313908632405],
                [84.296433492380444, 19.554339582375118],
                [84.289889974614397, 19.554339582375118],
                [84.281561861094005, 19.546606334106169],
                [84.277992669585259, 19.546606334106169],
                [84.269664556064853, 19.528165511310984],
                [84.258956981538617, 19.524596319802235],
                [84.256577520532772, 19.532329568071187],
                [84.260146712041518, 19.550175525614915],
                [84.253008329024041, 19.56028823488969],
                [84.250034002766753, 19.555529312878033],
                [84.251223733269669, 19.547796064609081],
                [84.251223733269669, 19.531139837568269],
                [84.24598, 19.529119],
                [84.245562208524106, 19.533358025461037],
                [84.24511616944163, 19.537883658788129],
                [84.239866526771536, 19.545459580024268],
                [84.23344198205578, 19.546887256627709],
                [84.229158952245299, 19.55295488219269],
                [84.231300467150433, 19.558665588606566],
                [84.237152662417685, 19.566561252687499],
                [84.233871000000121, 19.567721000000116],
                [84.232197082975034, 19.573417123638645],
                [84.227462000000102, 19.589530000000192],
                [84.228668, 19.6015],
                [84.222008, 19.608552000000195],
                [84.22003200000016, 19.618329],
                [84.221336, 19.62018],
                [84.229126000000107, 19.61971],
                [84.229974000000126, 19.620490000000128],
                [84.229821, 19.62696],
                [84.230728000000155, 19.628861000000139],
                [84.23729, 19.632221000000179],
                [84.239867000000103, 19.63447],
                [84.233689000000183, 19.653091000000128],
                [84.232064, 19.655650000000147],
                [84.220276, 19.658950000000171],
                [84.215173, 19.666941000000175],
                [84.211731, 19.66514],
                [84.205352000000147, 19.67330000000015],
                [84.193687000000111, 19.676190000000183],
                [84.194809, 19.682840000000109],
                [84.182556, 19.695681000000146],
                [84.19624200000014, 19.723222000000188],
                [84.18457800000013, 19.727550000000175],
                [84.177558, 19.728701000000168],
                [84.168029, 19.726449000000169],
                [84.161057000000184, 19.723491],
                [84.151239, 19.715740000000149],
                [84.149484, 19.717871000000113],
                [84.152734, 19.721059],
                [84.154824000000119, 19.727021],
                [84.149146, 19.738292],
                [84.14276, 19.748880000000209],
                [84.126344, 19.76918100000017],
                [84.125655, 19.772820000000191],
                [84.159621, 19.778851000000198],
                [84.165351, 19.782851],
                [84.167197000000129, 19.785221],
                [84.161399, 19.79666],
                [84.167359, 19.804309],
                [84.166962000000112, 19.812642],
                [84.178786000000159, 19.81426],
                [84.184152, 19.817211000000153],
                [84.194968, 19.827691],
                [84.178116000000145, 19.852791],
                [84.179627000000139, 19.853780000000196],
                [84.188149, 19.85291200000017],
                [84.206856000000101, 19.857420000000101],
                [84.227676, 19.860720000000125],
                [84.246101, 19.864720000000144],
                [84.271028, 19.87125],
                [84.283371, 19.886579],
                [84.300843, 19.898661],
                [84.310272, 19.879680000000175],
                [84.31424000000014, 19.869791000000131],
                [84.329880000000102, 19.857980000000108],
                [84.337403, 19.853812000000168],
                [84.342178000000132, 19.853579],
                [84.349097000000114, 19.855950000000171],
                [84.355668, 19.846630000000115],
                [84.365913, 19.839631000000107],
                [84.376121000000168, 19.834521000000105],
                [84.417252, 19.827780000000125],
                [84.426408, 19.830091000000206],
                [84.43447100000013, 19.82303],
                [84.438843000000176, 19.82320100000015],
                [84.444023000000158, 19.82788],
                [84.438439000000173, 19.833432],
                [84.438957, 19.83626],
                [84.446747000000101, 19.84031],
                [84.453627, 19.845801000000101],
                [84.455827000000141, 19.851811000000165],
                [84.454979, 19.859332],
                [84.450836, 19.863560000000117],
                [84.455535000000154, 19.87021000000021],
                [84.454797, 19.878641000000183],
                [84.451111, 19.897341],
                [84.452057000000181, 19.900810000000202],
                [84.456458000000154, 19.906991],
                [84.455207, 19.92065],
                [84.463029000000105, 19.932150000000146],
                [84.45861, 19.945449],
                [84.450273, 19.943450000000208],
                [84.446473000000182, 19.943332],
                [84.426857, 19.951341000000124],
                [84.414841, 19.947701],
                [84.40866, 19.951530000000158],
                [84.404808000000159, 19.949791000000172],
                [84.399101000000115, 19.952979000000134],
                [84.394333000000174, 19.953561000000143],
                [84.39125000000017, 19.948820000000122],
                [84.386176, 19.948191000000119],
                [84.381577, 19.952011000000137],
                [84.374970000000175, 19.95537],
                [84.370232, 19.95901200000014],
                [84.365616000000145, 19.966021000000122],
                [84.352432000000178, 19.98089],
                [84.348733, 19.982280000000113],
                [84.344758000000112, 19.981131000000115],
                [84.339028, 19.974371000000129],
                [84.333123, 19.971411],
                [84.329499, 19.970611],
                [84.324722000000165, 19.972641000000177],
                [84.317543, 19.981029000000198],
                [84.32375300000011, 19.992709000000101],
                [84.324959, 19.993842000000196],
                [84.323906000000179, 19.999481000000113],
                [84.326272000000174, 20.003841000000133],
                [84.330497, 20.006521000000188],
                [84.334037000000123, 20.005301000000141],
                [84.334153000000157, 20.008000000000148],
                [84.339721, 20.018302],
                [84.349243000000101, 20.0296610000002],
                [84.355636, 20.023541000000129],
                [84.364433000000176, 20.026532000000142],
                [84.391854, 20.040831000000193],
                [84.398055, 20.04143],
                [84.404578000000171, 20.043969000000114],
                [84.408546, 20.047051],
                [84.404975000000121, 20.051269000000154],
                [84.404182, 20.058679],
                [84.394958, 20.06586000000021],
                [84.394067000000163, 20.069990000000182],
                [84.396232, 20.080659],
                [84.403541000000175, 20.083959000000103],
                [84.404961, 20.087040000000112],
                [84.404343, 20.092501],
                [84.408058000000125, 20.097590000000135],
                [84.408211, 20.113319],
                [84.410752, 20.11612000000013],
                [84.419197, 20.118080000000131],
                [84.422157000000183, 20.12432],
                [84.420616, 20.131960000000156],
                [84.42099, 20.138451000000195],
                [84.425637000000151, 20.137731000000141],
                [84.433838000000137, 20.14401],
                [84.428748, 20.149320000000156],
                [84.429756, 20.158790000000121],
                [84.426194, 20.162420000000107],
                [84.4254, 20.170240000000202],
                [84.42231, 20.178990000000109],
                [84.424607, 20.184079],
                [84.428758000000116, 20.189002],
                [84.428657, 20.195949000000152],
                [84.430626000000117, 20.199441],
                [84.43939200000014, 20.200300000000134],
                [84.446776, 20.192510000000194],
                [84.451417000000134, 20.18518000000017],
                [84.45182, 20.181741],
                [84.444732, 20.175291000000126],
                [84.446197, 20.170641000000156],
                [84.445762000000158, 20.166910000000197],
                [84.446380000000133, 20.163170000000147],
                [84.47197, 20.139821],
                [84.479218, 20.13621],
                [84.490189, 20.137801],
                [84.495744000000158, 20.13593000000014],
                [84.499267000000117, 20.133849000000108],
                [84.501252, 20.13624],
                [84.501672, 20.142221],
                [84.503677000000124, 20.146391000000104],
                [84.511039, 20.148411],
                [84.515084, 20.14821900000015],
                [84.518020000000121, 20.143141000000121],
                [84.518952000000155, 20.139410000000161],
                [84.523232, 20.136801000000101],
                [84.537048000000127, 20.135850000000111],
                [84.545326, 20.136600000000151],
                [84.557572, 20.1341000000001],
                [84.557634, 20.13939],
                [84.555771, 20.144399000000131],
                [84.552642, 20.149179],
                [84.5522, 20.15446200000013],
                [84.56891500000016, 20.163200000000181],
                [84.580329, 20.167261000000103],
                [84.578697, 20.177030000000109],
                [84.577911000000185, 20.184312],
                [84.583283, 20.17669],
                [84.58764700000016, 20.173219000000127],
                [84.593689, 20.17099],
                [84.600381, 20.172560000000143],
                [84.626992, 20.187131000000129],
                [84.634071000000105, 20.192890000000197],
                [84.641374, 20.200179],
                [84.643409, 20.21694],
                [84.645683, 20.223871000000141],
                [84.649268, 20.229131000000102],
                [84.656746, 20.236419],
                [84.660714000000127, 20.242530000000155],
                [84.660737, 20.25207],
                [84.662902000000116, 20.260259000000129],
                [84.6669, 20.266951000000116],
                [84.681609, 20.271101000000151],
                [84.690003, 20.274941],
                [84.701187000000104, 20.272510000000175],
                [84.708603000000124, 20.266531000000207],
                [84.724906, 20.245629],
                [84.737213000000153, 20.238421000000184],
                [84.745872, 20.23629],
                [84.753402, 20.23635100000012],
                [84.757637, 20.239941000000155],
                [84.762840000000139, 20.240882],
                [84.77089, 20.236280000000129],
                [84.774170000000183, 20.228452],
                [84.785606000000129, 20.222560000000207],
                [84.813767000000126, 20.216609],
                [84.82225, 20.215789000000193],
                [84.828185, 20.21018],
                [84.828614, 20.20156],
                [84.819916000000134, 20.176761000000109],
                [84.81955, 20.163391000000153],
                [84.821122, 20.155050000000127],
                [84.819153, 20.135151000000175],
                [84.815484, 20.115881],
                [84.813767000000126, 20.110500000000169],
                [84.808067000000136, 20.108592000000208],
                [84.802932000000155, 20.108802000000189],
                [84.797118000000168, 20.107530000000107],
                [84.798470000000108, 20.103332],
                [84.802032000000139, 20.098591000000166],
                [84.799796, 20.093839000000113],
                [84.793907, 20.090669000000158],
                [84.792558000000142, 20.087530000000125],
                [84.804329, 20.062510000000142],
                [84.8107, 20.055741000000175],
                [84.821227000000121, 20.051980000000182],
                [84.833037, 20.043712000000195],
                [84.85022, 20.023149],
                [84.853203000000107, 20.011861],
                [84.853866, 20.001199000000152],
                [84.856346, 19.993151],
                [84.863662, 19.991622],
                [84.881608, 19.992281],
                [84.884484000000143, 19.989259000000111],
                [84.888024000000129, 19.987381000000134],
                [84.895477, 19.985772],
                [84.900559, 19.974319],
                [84.903718000000126, 19.962761],
                [84.908149000000122, 19.951320000000177],
                [84.91190200000014, 19.942502],
                [84.91745, 19.933990000000158],
                [84.911294, 19.920591000000169],
                [84.899568000000144, 19.90684100000021],
                [84.900117, 19.903761000000138],
                [84.904969, 19.897861],
                [84.91999800000012, 19.896910000000101],
                [84.925393000000128, 19.897409000000145],
                [84.927872, 19.894100000000144],
                [84.933762000000158, 19.889631000000175],
                [84.934906, 19.88528],
                [84.934418, 19.880671000000117],
                [84.933534000000108, 19.876052],
                [84.931054000000117, 19.870862000000155],
                [84.929588000000109, 19.864971000000132],
                [84.93293, 19.862730000000166],
                [84.939521, 19.86216],
                [84.94477, 19.860841],
                [84.949378000000124, 19.85479],
                [84.965736000000149, 19.845251],
                [84.97219, 19.83203],
                [84.974487000000153, 19.821430000000188],
                [84.977676, 19.816641],
                [84.983727000000144, 19.81493],
                [84.99334, 19.809221000000203],
                [85.003036000000151, 19.794930000000132],
                [85.008453, 19.797351],
                [85.019029, 19.79999],
                [85.024597000000114, 19.796359],
                [85.031388000000135, 19.79906],
                [85.037567000000166, 19.798602000000184],
                [85.047158, 19.793702000000103],
                [85.058679, 19.789369],
                [85.07071, 19.783701],
                [85.07235800000015, 19.777201],
                [85.081238, 19.758872],
                [85.095963, 19.75177],
                [85.109337, 19.747490000000138],
                [85.122032, 19.741081],
                [85.139877000000112, 19.720380000000201],
                [85.139923000000167, 19.715370000000117],
                [85.142852, 19.70960000000019],
                [85.1557770000001, 19.692130000000127],
                [85.155458000000152, 19.688260000000177],
                [85.164383, 19.682489000000196],
                [85.169137, 19.674350000000171],
                [85.177811000000105, 19.669099],
                [85.177909, 19.667449],
                [85.176772000000128, 19.666950000000206],
                [85.175133, 19.666150000000126],
                [85.166336000000157, 19.6617700000001],
                [85.164016, 19.660261000000101],
                [85.161971, 19.657619000000178],
                [85.160262, 19.650201000000145],
                [85.16192421485367, 19.631541341843725],
                [85.163153184138409, 19.61774520309887],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Jagatsinghapur",
          Dist_Code: "380",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [86.386948000000217, 19.962777000000184],
                [86.386948000000217, 19.96223],
                [86.385826, 19.961111],
                [86.38556, 19.961111],
                [86.384721000000283, 19.960279000000348],
                [86.384452000000167, 19.960279000000348],
                [86.384240000000119, 19.960074000000301],
                [86.384162, 19.959999000000604],
                [86.383889000000323, 19.959721000000396],
                [86.383613000000182, 19.95972300000016],
                [86.383331, 19.959443000000185],
                [86.382774000000239, 19.959443000000185],
                [86.382499, 19.959167000000203],
                [86.38166900000013, 19.959167000000203],
                [86.381377000000185, 19.958937000000102],
                [86.380837000000199, 19.958891],
                [86.380545000000239, 19.95861100000047],
                [86.379996000000219, 19.95861100000047],
                [86.379723000000283, 19.958891],
                [86.379447000000113, 19.958889000000223],
                [86.37889100000011, 19.959443000000185],
                [86.379167000000209, 19.95972300000016],
                [86.379723000000283, 19.959721000000396],
                [86.379996000000219, 19.960001000000371],
                [86.380545000000239, 19.960001000000371],
                [86.381111, 19.960560000000211],
                [86.381386000000219, 19.960555000000337],
                [86.38166900000013, 19.960833000000545],
                [86.381943000000192, 19.960831],
                [86.382499, 19.961389000000278],
                [86.382768, 19.961389000000278],
                [86.383057000000107, 19.961670000000133],
                [86.383331, 19.961665],
                [86.383613000000182, 19.961945000000689],
                [86.383889000000323, 19.961945000000689],
                [86.384445000000127, 19.962499000000204],
                [86.385001000000187, 19.962499000000204],
                [86.385277, 19.96278],
                [86.38556, 19.962777000000184],
                [86.385901, 19.963126],
                [86.386109, 19.963333000000141],
                [86.386391, 19.963333000000141],
                [86.386948000000217, 19.962777000000184],
              ],
            ],
            [
              [
                [86.392486000000176, 19.966109000000184],
                [86.392219000000111, 19.965829000000209],
                [86.391946000000175, 19.965834],
                [86.391045000000176, 19.965512],
                [86.390473000000256, 19.965510000000215],
                [86.390473000000256, 19.966189000000206],
                [86.390617, 19.966460000000776],
                [86.391946000000175, 19.967222000000213],
                [86.392219000000111, 19.967222000000213],
                [86.392648000000108, 19.967652000000491],
                [86.394074000000188, 19.968801000000433],
                [86.395706000000104, 19.97008],
                [86.39621, 19.970631000000591],
                [86.397240000000224, 19.971452000000223],
                [86.398377, 19.972259000000118],
                [86.398774, 19.972388000000134],
                [86.399054000000305, 19.97252500000058],
                [86.399269000000217, 19.972388000000134],
                [86.399353000000275, 19.972320000000305],
                [86.399132000000151, 19.97150900000042],
                [86.398362, 19.970741000000537],
                [86.397780000000211, 19.970283000000105],
                [86.396499000000105, 19.969004000000265],
                [86.394997000000146, 19.968056000000157],
                [86.393327000000156, 19.96639],
                [86.393058, 19.96639],
                [86.392778000000121, 19.966109000000184],
                [86.392486000000176, 19.966109000000184],
              ],
            ],
            [
              [
                [86.368607000000253, 19.973890000000431],
                [86.368888, 19.97361],
                [86.37046, 19.973612000000227],
                [86.372329000000121, 19.973519000000344],
                [86.372527, 19.973510000000257],
                [86.372810000000214, 19.973368000000615],
                [86.373024, 19.972967000000146],
                [86.373015000000166, 19.972701000000139],
                [86.372810000000214, 19.972432],
                [86.372527, 19.972161000000138],
                [86.371390000000275, 19.971942000000578],
                [86.371390000000275, 19.971666000000138],
                [86.372222000000221, 19.970832000000193],
                [86.372222000000221, 19.969166000000538],
                [86.371696000000313, 19.968642000000269],
                [86.370889000000247, 19.968202],
                [86.370665, 19.968060000000147],
                [86.36972, 19.968056000000157],
                [86.369583, 19.968195000000147],
                [86.369446000000195, 19.968334000000365],
                [86.369163000000327, 19.968056000000157],
                [86.368058000000218, 19.968056000000157],
                [86.367776000000205, 19.968334000000365],
                [86.367233000000326, 19.968329000000264],
                [86.366944, 19.968610000000119],
                [86.364997, 19.968610000000119],
                [86.36486700000026, 19.968740000000246],
                [86.364165, 19.969444],
                [86.364441000000213, 19.969722000000271],
                [86.364441000000213, 19.97],
                [86.365280000000141, 19.970832000000193],
                [86.365280000000141, 19.971101000000314],
                [86.364997, 19.971390000000152],
                [86.364997, 19.971944000000345],
                [86.365556000000296, 19.9725],
                [86.365838, 19.972780000000508],
                [86.366112, 19.972778000000286],
                [86.366388000000185, 19.973054],
                [86.366668000000161, 19.973054],
                [86.366944, 19.973334],
                [86.367226000000272, 19.973334],
                [86.367500000000106, 19.973612000000227],
                [86.368081000000345, 19.973637000000728],
                [86.368316000000206, 19.973890000000431],
                [86.368607000000253, 19.973890000000431],
              ],
            ],
            [
              [
                [86.335571000000343, 19.990829],
                [86.335564, 19.989816999999899],
                [86.335571000000343, 19.989550000000232],
                [86.335282, 19.988889000000196],
                [86.335282, 19.988611000000216],
                [86.334999000000138, 19.98833100000024],
                [86.334717000000168, 19.98833100000024],
                [86.333894, 19.98917],
                [86.333611000000175, 19.989165000000181],
                [86.333053, 19.989721000000593],
                [86.33277900000023, 19.989719000000147],
                [86.332497, 19.989999000000122],
                [86.332207, 19.989999000000122],
                [86.331405000000274, 19.990815000000563],
                [86.330284, 19.992383000000242],
                [86.329933, 19.99394000000029],
                [86.329276000000149, 19.995702000000389],
                [86.328002, 19.99698700000021],
                [86.327216000000121, 19.998610000000323],
                [86.327216000000121, 20.000000000000679],
                [86.326943000000185, 20.000278000000204],
                [86.326943000000185, 20.001110000000377],
                [86.326728, 20.001329000000165],
                [86.326699000000232, 20.001404000000544],
                [86.326553000000132, 20.001792000000247],
                [86.326386000000213, 20.002298000000106],
                [86.326234, 20.002840000000557],
                [86.326202000000293, 20.003378000000108],
                [86.3264, 20.003811000000265],
                [86.326621, 20.004192],
                [86.327439000000226, 20.005741000000391],
                [86.327797, 20.00682200000028],
                [86.328048000000294, 20.007979000000198],
                [86.328164000000271, 20.008510000000111],
                [86.328369000000222, 20.009051],
                [86.328889, 20.010001],
                [86.329438, 20.010562000000387],
                [86.330514000000207, 20.009750000000164],
                [86.330651000000245, 20.009269000000579],
                [86.3309560000001, 20.008950000000137],
                [86.331291, 20.008599000000451],
                [86.333335, 20.007209],
                [86.333335, 20.006945],
                [86.334557000000288, 20.00572300000044],
                [86.334723, 20.005557],
                [86.334723, 20.005131000000343],
                [86.334723, 20.004998000000111],
                [86.334999000000138, 20.004720000000358],
                [86.334999000000138, 20.004444],
                [86.335282, 20.004166000000392],
                [86.335282, 20.003891000000518],
                [86.335571000000343, 20.003610000000659],
                [86.335555000000213, 20.003335000000103],
                [86.335831, 20.003056000000466],
                [86.335571000000343, 20.002781000000134],
                [86.335617, 20.00243],
                [86.335831, 20.002081],
                [86.336036, 20.001730000000176],
                [86.336137, 20.00132],
                [86.336257000000131, 20.00096],
                [86.336348, 20.000625000000351],
                [86.336456, 20.000319],
                [86.336670000000296, 20.000000000000679],
                [86.336572000000203, 19.99972],
                [86.336861000000269, 19.997760000000422],
                [86.336777000000197, 19.996139],
                [86.336426000000102, 19.994170000000391],
                [86.336371, 19.994011000000452],
                [86.335555000000213, 19.991668000000566],
                [86.335571000000343, 19.990829],
              ],
            ],
            [
              [
                [86.410851000000136, 20.018329000000673],
                [86.410279, 20.017777000000248],
                [86.409996, 20.017779999999899],
                [86.409721000000147, 20.017499],
                [86.409447, 20.017499],
                [86.408898000000278, 20.018051000000465],
                [86.408889000000201, 20.01889000000028],
                [86.409165, 20.019168],
                [86.409158000000303, 20.019719000000347],
                [86.409447, 20.020000000000202],
                [86.409447, 20.020556000000621],
                [86.409721000000147, 20.020829000000273],
                [86.409721000000147, 20.021668],
                [86.410042, 20.02203900000017],
                [86.410270000000182, 20.022409000000373],
                [86.41050000000034, 20.022730000000362],
                [86.41083500000029, 20.023056000000221],
                [86.410851000000136, 20.023612000000409],
                [86.411111000000147, 20.023890000000161],
                [86.411111000000147, 20.024166000000601],
                [86.411391000000123, 20.024444000000127],
                [86.411391000000123, 20.024722000000335],
                [86.411667000000222, 20.025000000000539],
                [86.411667000000222, 20.025278],
                [86.412223, 20.025834000000483],
                [86.412499000000167, 20.025834000000483],
                [86.412934000000277, 20.025401000000326],
                [86.413055, 20.025278],
                [86.412782, 20.025000000000539],
                [86.412782, 20.024722000000335],
                [86.412499000000167, 20.024444000000127],
                [86.412499000000167, 20.023890000000161],
                [86.412216, 20.023612000000409],
                [86.412216, 20.023332000000433],
                [86.411667000000222, 20.022778],
                [86.411667000000222, 20.021670000000533],
                [86.412216, 20.02111],
                [86.412216, 20.020560000000156],
                [86.411986000000169, 20.020111000000266],
                [86.411788000000215, 20.019639000000549],
                [86.411583000000221, 20.019086],
                [86.411186000000129, 20.018632000000704],
                [86.410851000000136, 20.018329000000673],
              ],
            ],
            [
              [
                [86.320274, 20.029444],
                [86.320556, 20.029166000000256],
                [86.320985, 20.029173000000124],
                [86.321304000000211, 20.029137000000215],
                [86.321602, 20.028979000000156],
                [86.321960000000146, 20.028900000000473],
                [86.32235700000021, 20.028829000000307],
                [86.322715000000329, 20.028617000000164],
                [86.323059, 20.028339000000638],
                [86.324173, 20.027220000000163],
                [86.324164000000266, 20.026944000000181],
                [86.32444700000012, 20.026671],
                [86.32444700000012, 20.026390000000216],
                [86.325545, 20.025280000000514],
                [86.325837000000178, 20.025280000000514],
                [86.326667, 20.024442000000359],
                [86.326667, 20.024166000000601],
                [86.3264, 20.023890000000161],
                [86.326386000000213, 20.023612000000409],
                [86.325837000000178, 20.023056000000221],
                [86.325279, 20.023060000000211],
                [86.324173, 20.021939],
                [86.323341000000127, 20.021939],
                [86.322220000000172, 20.023056000000221],
                [86.322136000000157, 20.023300000000283],
                [86.321908000000278, 20.023612000000409],
                [86.32158, 20.023901],
                [86.321258, 20.024191000000425],
                [86.320953000000117, 20.024499000000556],
                [86.320702000000139, 20.024829000000175],
                [86.320556, 20.025246000000376],
                [86.320426000000268, 20.025659000000129],
                [86.320313, 20.026080000000317],
                [86.320267, 20.026507000000716],
                [86.320221, 20.026956],
                [86.320212000000225, 20.027430000000319],
                [86.320189000000127, 20.027901000000604],
                [86.32, 20.028334000000537],
                [86.319734, 20.028610000000519],
                [86.319724, 20.029166000000256],
                [86.32, 20.029444],
                [86.320274, 20.029444],
              ],
            ],
            [
              [
                [86.315002, 20.031669],
                [86.315551000000283, 20.031110000000123],
                [86.315827000000169, 20.031110000000123],
                [86.31611, 20.030830000000144],
                [86.315551000000283, 20.030276000000182],
                [86.315551000000283, 20.030000000000197],
                [86.315827000000169, 20.029720000000221],
                [86.315834000000194, 20.028610000000519],
                [86.31611, 20.028339000000638],
                [86.31611, 20.028061000000431],
                [86.316673000000137, 20.027500000000142],
                [86.316666, 20.027222],
                [86.316948000000124, 20.026944000000181],
                [86.316948000000124, 20.026110000000241],
                [86.317222000000157, 20.025834000000483],
                [86.317222000000157, 20.025554],
                [86.31778, 20.025000000000539],
                [86.31778, 20.024722000000335],
                [86.318336, 20.024166000000601],
                [86.318336, 20.023890000000161],
                [86.318612000000243, 20.023612000000409],
                [86.318756000000278, 20.023391000000395],
                [86.319023, 20.023241000000546],
                [86.319266000000113, 20.023010000000337],
                [86.319734, 20.022780000000235],
                [86.319734, 20.022502],
                [86.32, 20.02221000000031],
                [86.320274, 20.022222],
                [86.320556, 20.021944],
                [86.320832000000152, 20.021944],
                [86.321388000000226, 20.021390000000558],
                [86.321664, 20.021390000000558],
                [86.321953000000107, 20.02111],
                [86.322220000000172, 20.02111],
                [86.323059, 20.020280000000181],
                [86.323341000000127, 20.020280000000181],
                [86.323891, 20.019719000000347],
                [86.323891, 20.018887000000174],
                [86.32444700000012, 20.018329000000673],
                [86.32444700000012, 20.018055],
                [86.324723, 20.017779999999899],
                [86.324723, 20.017219000000292],
                [86.324996000000155, 20.01694600000064],
                [86.324996000000155, 20.016667000000549],
                [86.325279, 20.016399000000316],
                [86.324996000000155, 20.016109000000366],
                [86.324996000000155, 20.015555000000401],
                [86.324784000000164, 20.015040000000223],
                [86.324433, 20.014717000000243],
                [86.324014, 20.01442],
                [86.323631000000304, 20.014001000000459],
                [86.323326000000165, 20.013486],
                [86.323059, 20.012782],
                [86.322776000000246, 20.01250100000015],
                [86.322776000000246, 20.011941000000199],
                [86.322220000000172, 20.011389],
                [86.322220000000172, 20.011111000000479],
                [86.322136000000157, 20.011024000000358],
                [86.32, 20.012492],
                [86.32, 20.013060000000216],
                [86.319724, 20.013335],
                [86.319734, 20.013611],
                [86.319442000000123, 20.013892000000393],
                [86.319442000000123, 20.014165],
                [86.318886, 20.01472100000046],
                [86.318886, 20.014999000000437],
                [86.318612000000243, 20.015280000000299],
                [86.318612000000243, 20.015560000000274],
                [86.31778, 20.016386999999888],
                [86.31778, 20.01694600000064],
                [86.317498000000327, 20.017219000000292],
                [86.317498000000327, 20.017499],
                [86.317222000000157, 20.017777000000248],
                [86.317222000000157, 20.018334],
                [86.316948000000124, 20.018609],
                [86.316948000000124, 20.019170000000255],
                [86.316727000000284, 20.019541000000341],
                [86.316620000000157, 20.01996100000019],
                [86.316436, 20.020371000000289],
                [86.316383000000243, 20.020781000000166],
                [86.316390000000268, 20.02111],
                [86.31611, 20.021390000000558],
                [86.315827000000169, 20.021670000000533],
                [86.31527800000012, 20.02111],
                [86.314720000000236, 20.02111],
                [86.314147, 20.020560000000156],
                [86.313614000000243, 20.020556000000621],
                [86.313332000000273, 20.020834000000146],
                [86.313058000000169, 20.020829000000273],
                [86.312766000000209, 20.02111],
                [86.3125, 20.02111],
                [86.312233, 20.021390000000558],
                [86.311944, 20.021390000000558],
                [86.311112, 20.022222],
                [86.310280000000134, 20.021390000000558],
                [86.308333000000104, 20.023332000000433],
                [86.307504000000151, 20.023332000000433],
                [86.30722100000024, 20.023612000000409],
                [86.306945000000141, 20.023612000000409],
                [86.306656, 20.023890000000161],
                [86.306389, 20.023890000000161],
                [86.306107, 20.024170000000137],
                [86.305557000000121, 20.024166000000601],
                [86.305275000000151, 20.024444000000127],
                [86.3047320000002, 20.024442000000359],
                [86.304169, 20.025000000000539],
                [86.303611, 20.025000000000539],
                [86.303337000000212, 20.025280000000514],
                [86.30223, 20.025280000000514],
                [86.301109, 20.026390000000216],
                [86.301109, 20.026671],
                [86.30194, 20.027500000000142],
                [86.30223, 20.027500000000142],
                [86.302499, 20.027781],
                [86.303337000000212, 20.02777800000035],
                [86.303773, 20.02792200000021],
                [86.304199, 20.028063000000195],
                [86.3066630000001, 20.02777800000035],
                [86.306945000000141, 20.027781],
                [86.30722100000024, 20.027500000000142],
                [86.307777, 20.027500000000142],
                [86.308053000000186, 20.027781],
                [86.308053000000186, 20.028061000000431],
                [86.308327, 20.028339000000638],
                [86.30860900000026, 20.028339000000638],
                [86.308892000000114, 20.028610000000519],
                [86.309448000000188, 20.028610000000519],
                [86.310280000000134, 20.029444],
                [86.309997000000223, 20.029720000000221],
                [86.309997000000223, 20.030000000000197],
                [86.310280000000134, 20.030281],
                [86.310280000000134, 20.030557],
                [86.310556, 20.030835000000703],
                [86.311385000000243, 20.030835000000703],
                [86.311668000000154, 20.030557],
                [86.311944, 20.030559000000263],
                [86.312766000000209, 20.029720000000221],
                [86.314720000000236, 20.031669],
                [86.315002, 20.031669],
              ],
            ],
            [
              [
                [86.309997000000223, 20.040833000000472],
                [86.310280000000134, 20.040555000000261],
                [86.310836000000208, 20.040571000000678],
                [86.311112, 20.040279000000279],
                [86.3125, 20.040279000000279],
                [86.312766000000209, 20.040001],
                [86.313332000000273, 20.040001],
                [86.313607000000189, 20.038611000000397],
                [86.313332000000273, 20.038331],
                [86.310836000000208, 20.038331],
                [86.310546000000301, 20.038611000000397],
                [86.310280000000134, 20.038611000000397],
                [86.309997000000223, 20.038891000000373],
                [86.309165, 20.038891000000373],
                [86.308892000000114, 20.039167000000131],
                [86.308892000000114, 20.039721000000323],
                [86.309448000000188, 20.040279000000279],
                [86.309448000000188, 20.040555000000261],
                [86.309724000000344, 20.040833000000472],
                [86.309997000000223, 20.040833000000472],
              ],
            ],
            [
              [
                [86.300552000000124, 20.042499],
                [86.300826000000185, 20.042221000000378],
                [86.301109, 20.042223000000142],
                [86.303055000000171, 20.040277000000511],
                [86.303337000000212, 20.040279000000279],
                [86.303887000000117, 20.039721000000323],
                [86.303337000000212, 20.039167000000131],
                [86.303337000000212, 20.038891000000373],
                [86.303048000000132, 20.038611000000397],
                [86.302499, 20.038611000000397],
                [86.30223, 20.038891000000373],
                [86.301391, 20.038891000000373],
                [86.301109, 20.039172000000228],
                [86.300835000000262, 20.039167000000131],
                [86.300552000000124, 20.039443000000116],
                [86.30027700000015, 20.039443000000116],
                [86.300003, 20.039723],
                [86.299721, 20.039721000000323],
                [86.299171000000143, 20.040279000000279],
                [86.299164000000104, 20.040555000000261],
                [86.298889000000131, 20.040831000000701],
                [86.298889000000131, 20.041111000000452],
                [86.298606, 20.041389000000205],
                [86.298615, 20.041665],
                [86.298911000000132, 20.041968],
                [86.299164000000104, 20.042223000000142],
                [86.299461, 20.042221000000378],
                [86.299721, 20.042499],
                [86.300552000000124, 20.042499],
              ],
            ],
            [
              [
                [86.426393000000232, 20.038611000000397],
                [86.42611, 20.038331],
                [86.425552, 20.03833300000019],
                [86.42472, 20.037501000000471],
                [86.42472, 20.037221],
                [86.425002000000319, 20.036945000000284],
                [86.425002000000319, 20.036391],
                [86.424446000000245, 20.03583000000048],
                [86.424446000000245, 20.035555000000379],
                [86.423058, 20.034167000000473],
                [86.422792, 20.034171000000466],
                [86.422792, 20.033889000000269],
                [86.421668000000167, 20.032779000000343],
                [86.421668000000167, 20.032501000000362],
                [86.421388000000249, 20.0322200000005],
                [86.421112, 20.032223000000155],
                [86.420829000000239, 20.031945000000398],
                [86.420563, 20.0322200000005],
                [86.420563, 20.032501000000362],
                [86.420280000000204, 20.032779000000343],
                [86.420556, 20.03305700000055],
                [86.420556, 20.033333000000535],
                [86.420829000000239, 20.033608000000406],
                [86.420829000000239, 20.034167000000473],
                [86.421112, 20.034445],
                [86.421112, 20.034721],
                [86.421388000000249, 20.035001],
                [86.421388000000249, 20.035555000000379],
                [86.421668000000167, 20.035833000000135],
                [86.421668000000167, 20.036111000000343],
                [86.421388000000249, 20.036391],
                [86.421388000000249, 20.037510000000108],
                [86.421668000000167, 20.037777000000453],
                [86.421668000000167, 20.038331],
                [86.423607, 20.040279000000279],
                [86.423607, 20.040571000000678],
                [86.424157000000193, 20.041111000000452],
                [86.424157000000193, 20.041389000000205],
                [86.424446000000245, 20.041665],
                [86.424446000000245, 20.04194500000062],
                [86.42472, 20.042221000000378],
                [86.42472, 20.042499],
                [86.425834, 20.043611],
                [86.426393000000232, 20.043611],
                [86.427222, 20.042777000000111],
                [86.427222, 20.042499],
                [86.427498, 20.042221000000378],
                [86.427498, 20.041665],
                [86.427222, 20.041389000000205],
                [86.427222, 20.041111000000452],
                [86.426942, 20.040831000000701],
                [86.426942, 20.040277000000511],
                [86.426666000000154, 20.040001],
                [86.426666000000154, 20.039441000000348],
                [86.426393000000232, 20.039167000000131],
                [86.426393000000232, 20.038611000000397],
              ],
            ],
            [
              [
                [86.294998, 20.049722000000195],
                [86.295554000000138, 20.049166000000461],
                [86.29583, 20.049166000000461],
                [86.296386, 20.049722000000195],
                [86.296945, 20.049722000000195],
                [86.298333, 20.048334],
                [86.298333, 20.048056],
                [86.298606, 20.04778],
                [86.298606, 20.047500000000124],
                [86.298889000000131, 20.047219000000265],
                [86.298889000000131, 20.046944],
                [86.299164000000104, 20.046668000000633],
                [86.299171000000143, 20.046381000000331],
                [86.299447, 20.046112000000214],
                [86.299447, 20.045834],
                [86.299721, 20.045556000000481],
                [86.299721, 20.04528],
                [86.30027700000015, 20.04471900000021],
                [86.30027700000015, 20.044446000000104],
                [86.299721, 20.043889000000259],
                [86.298889000000131, 20.043889000000259],
                [86.298333, 20.04445],
                [86.298057000000185, 20.04445],
                [86.297501000000111, 20.044999000000185],
                [86.297225000000296, 20.044999000000185],
                [86.296935000000119, 20.04528],
                [86.296386, 20.04528],
                [86.296113000000148, 20.045560000000474],
                [86.29583, 20.045556000000481],
                [86.295554000000138, 20.045834],
                [86.295281000000202, 20.045834],
                [86.294998, 20.046112000000214],
                [86.294725000000128, 20.046112000000214],
                [86.294442000000274, 20.046390000000425],
                [86.294166000000118, 20.046381000000331],
                [86.293893000000168, 20.0466700000004],
                [86.293334000000158, 20.046668000000633],
                [86.293052, 20.046944],
                [86.292222, 20.046944],
                [86.291946000000209, 20.047222],
                [86.2916570000002, 20.047219000000265],
                [86.291108, 20.04778],
                [86.291108, 20.04861],
                [86.290832, 20.048892000000247],
                [86.291114, 20.049166000000461],
                [86.291108, 20.049722000000195],
                [86.2916570000002, 20.050280000000381],
                [86.292502, 20.050280000000381],
                [86.292778, 20.050556000000139],
                [86.292778, 20.050831999999897],
                [86.293893000000168, 20.050831999999897],
                [86.294998, 20.049722000000195],
              ],
            ],
            [
              [
                [86.270279000000286, 20.058057000000414],
                [86.269996000000148, 20.057781],
                [86.269996000000148, 20.057220000000367],
                [86.270279000000286, 20.056944000000382],
                [86.270279000000286, 20.056388000000194],
                [86.269157000000163, 20.055281000000374],
                [86.268891, 20.055281000000374],
                [86.26832500000026, 20.05472],
                [86.268059, 20.054722000000535],
                [86.267776000000239, 20.054444000000323],
                [86.267503, 20.054451000000647],
                [86.267220000000165, 20.054171000000217],
                [86.267220000000165, 20.053330000000411],
                [86.267503, 20.053054000000426],
                [86.267776000000239, 20.053054000000426],
                [86.268059, 20.053334000000401],
                [86.268335000000192, 20.053334000000401],
                [86.268608000000128, 20.05361200000015],
                [86.269164000000202, 20.053054000000426],
                [86.269723000000212, 20.052778000000213],
                [86.270545000000183, 20.051942000000274],
                [86.270835, 20.051942000000274],
                [86.271667, 20.052778000000213],
                [86.271667, 20.053054000000426],
                [86.271942000000223, 20.053330000000411],
                [86.271942000000223, 20.053890000000361],
                [86.272232000000187, 20.054171000000217],
                [86.272232000000187, 20.054451000000647],
                [86.272781, 20.055],
                [86.273057, 20.055],
                [86.27333, 20.055281000000374],
                [86.273613000000154, 20.055],
                [86.273887000000215, 20.055],
                [86.275001000000131, 20.053890000000361],
                [86.275001000000131, 20.053610000000386],
                [86.274445, 20.053054000000426],
                [86.274445, 20.052778000000213],
                [86.274718000000263, 20.052511000000319],
                [86.274803, 20.052468000000314],
                [86.275047000000129, 20.052340999999835],
                [86.27539100000017, 20.052213000000162],
                [86.27578, 20.052049000000348],
                [86.276207, 20.051851000000394],
                [86.276795, 20.05198500000051],
                [86.277191000000215, 20.051857000000147],
                [86.277497, 20.051650000000105],
                [86.277770000000132, 20.05139],
                [86.278007, 20.051151000000342],
                [86.278283000000144, 20.05101900000022],
                [86.278550000000195, 20.05087000000071],
                [86.278923, 20.05078800000069],
                [86.279297000000184, 20.050561000000236],
                [86.279732000000351, 20.050303000000437],
                [86.280166, 20.050016000000138],
                [86.280587000000111, 20.049731000000289],
                [86.280961, 20.049464],
                [86.28128, 20.049230000000303],
                [86.281640000000124, 20.049129000000214],
                [86.281930000000315, 20.04894000000035],
                [86.282326, 20.048863000000207],
                [86.282761, 20.04875100000049],
                [86.283204000000111, 20.048578000000358],
                [86.283630000000159, 20.048341],
                [86.284104, 20.048099],
                [86.284653, 20.047930000000175],
                [86.285141000000152, 20.0476500000002],
                [86.285638000000105, 20.047406000000361],
                [86.286057000000127, 20.04710300000033],
                [86.286308000000119, 20.046599000000235],
                [86.286750000000239, 20.0464900000004],
                [86.287231000000119, 20.046381000000331],
                [86.287498000000127, 20.046112000000214],
                [86.287498000000127, 20.045277000000389],
                [86.287231000000119, 20.044999000000185],
                [86.287498000000127, 20.044721000000433],
                [86.28778000000014, 20.044721000000433],
                [86.288056, 20.044446000000104],
                [86.28917, 20.04445],
                [86.289437, 20.044170000000115],
                [86.289720000000145, 20.044170000000115],
                [86.29, 20.043889000000259],
                [86.29, 20.043320000000445],
                [86.290558000000189, 20.042777000000111],
                [86.290832, 20.04306000000042],
                [86.291114, 20.043058],
                [86.291390000000135, 20.043320000000445],
                [86.291390000000135, 20.04445],
                [86.292502, 20.045560000000474],
                [86.292778, 20.045560000000474],
                [86.293038000000166, 20.04528],
                [86.293328, 20.04528],
                [86.29361, 20.044999000000185],
                [86.293893000000168, 20.044999000000185],
                [86.294442000000274, 20.04445],
                [86.294716, 20.04445],
                [86.296113000000148, 20.04306000000042],
                [86.296386, 20.04306000000042],
                [86.296669000000222, 20.042780000000445],
                [86.296669000000222, 20.042499],
                [86.297501000000111, 20.041670000000519],
                [86.297501000000111, 20.041111000000452],
                [86.297225000000296, 20.040831000000701],
                [86.297225000000296, 20.040555000000261],
                [86.296935000000119, 20.040279000000279],
                [86.296935000000119, 20.040001],
                [86.296669000000222, 20.039721000000323],
                [86.297776, 20.038611000000397],
                [86.298889000000131, 20.038611000000397],
                [86.299171000000143, 20.038331],
                [86.300003, 20.03833300000019],
                [86.30027700000015, 20.038055000000664],
                [86.300826000000185, 20.038062000000306],
                [86.301109, 20.037781],
                [86.30194, 20.037781],
                [86.30223, 20.037510000000108],
                [86.302499, 20.037510000000108],
                [86.303048000000132, 20.036952000000607],
                [86.303337000000212, 20.036952000000607],
                [86.303611, 20.036671],
                [86.303887000000117, 20.036671],
                [86.304169, 20.036391],
                [86.305001000000331, 20.036391],
                [86.305268000000112, 20.036111000000343],
                [86.305557000000121, 20.036111000000343],
                [86.306112999999897, 20.035555000000379],
                [86.306389, 20.035555000000379],
                [86.3066630000001, 20.035279],
                [86.30722100000024, 20.035281000000392],
                [86.307777, 20.034721],
                [86.308053000000186, 20.034721],
                [86.308053000000186, 20.034445],
                [86.30722100000024, 20.033611],
                [86.306945000000141, 20.033611],
                [86.306763000000259, 20.033428000000182],
                [86.306389, 20.03305700000055],
                [86.305831000000154, 20.033059000000318],
                [86.305268000000112, 20.032501000000362],
                [86.304443000000191, 20.032501000000362],
                [86.303887000000117, 20.033059000000318],
                [86.303611, 20.032779000000343],
                [86.303337000000212, 20.032779000000343],
                [86.303048000000132, 20.032501000000362],
                [86.302779, 20.032501000000362],
                [86.301667000000165, 20.031379000000239],
                [86.301109, 20.031945000000398],
                [86.300552000000124, 20.031945000000398],
                [86.299447, 20.030835000000703],
                [86.299164000000104, 20.030835000000703],
                [86.298057000000185, 20.029722],
                [86.298057000000185, 20.029444],
                [86.297776, 20.029166000000256],
                [86.297225000000296, 20.029166000000256],
                [86.296669000000222, 20.029720000000221],
                [86.296669000000222, 20.030000000000197],
                [86.296386, 20.030281],
                [86.29583, 20.030281],
                [86.295281000000202, 20.029720000000221],
                [86.294998, 20.029722],
                [86.294907, 20.02962900000011],
                [86.294725000000128, 20.029444],
                [86.291664000000168, 20.029444],
                [86.291390000000135, 20.029166000000256],
                [86.290558000000189, 20.029171000000126],
                [86.290292, 20.028890000000494],
                [86.29, 20.028890000000494],
                [86.289720000000145, 20.028610000000519],
                [86.28917, 20.028610000000519],
                [86.288888000000185, 20.028890000000494],
                [86.288612, 20.028610000000519],
                [86.288147, 20.028610000000519],
                [86.282791000000245, 20.031651],
                [86.277617000000234, 20.036621000000419],
                [86.271553, 20.035671000000317],
                [86.267968, 20.036391],
                [86.275199, 20.041991000000277],
                [86.276817, 20.047429],
                [86.273399, 20.049289],
                [86.270545000000183, 20.049829],
                [86.26425300000021, 20.045419000000717],
                [86.260307, 20.045781],
                [86.253869, 20.046369],
                [86.254165, 20.046668000000633],
                [86.254158000000274, 20.047219000000265],
                [86.254448000000181, 20.047500000000124],
                [86.254448000000181, 20.04861],
                [86.254724, 20.04889000000048],
                [86.254851000000116, 20.049300000000578],
                [86.255020000000101, 20.049660000000127],
                [86.255257000000242, 20.049991000000311],
                [86.255501000000194, 20.050342000000452],
                [86.255751, 20.05072900000027],
                [86.256102, 20.051121000000645],
                [86.256538, 20.051531000000516],
                [86.257041000000171, 20.05196],
                [86.257545, 20.05238600000029],
                [86.258072000000183, 20.05276200000025],
                [86.258621000000261, 20.053052000000203],
                [86.25915400000018, 20.053318000000214],
                [86.259719, 20.053610000000386],
                [86.259719, 20.053890000000361],
                [86.260002, 20.054171000000217],
                [86.260291000000251, 20.054171000000217],
                [86.260558000000273, 20.054451000000647],
                [86.260827, 20.054451000000647],
                [86.261481000000259, 20.055096],
                [86.261673000000116, 20.055281000000374],
                [86.261948, 20.055281000000374],
                [86.262498, 20.05472],
                [86.262780000000291, 20.054722000000535],
                [86.263054, 20.054444000000323],
                [86.26335200000014, 20.054451000000647],
                [86.263610000000185, 20.054171000000217],
                [86.263892000000155, 20.054171000000217],
                [86.264442, 20.053610000000386],
                [86.265, 20.054166000000119],
                [86.265556000000274, 20.05472],
                [86.265556000000274, 20.055],
                [86.265, 20.05555000000049],
                [86.265, 20.056110000000441],
                [86.265267, 20.056391000000296],
                [86.265267, 20.056671000000275],
                [86.266388000000219, 20.057781],
                [86.266671, 20.057781],
                [86.266937, 20.058059000000181],
                [86.268335000000192, 20.058057000000414],
                [86.268608000000128, 20.058332000000515],
                [86.269996000000148, 20.058332000000515],
                [86.270279000000286, 20.058057000000414],
              ],
            ],
            [
              [
                [86.26335200000014, 20.058059000000181],
                [86.261673000000116, 20.056391000000296],
                [86.261390000000205, 20.056391000000296],
                [86.260291000000251, 20.055281000000374],
                [86.260002, 20.055281000000374],
                [86.259719, 20.055],
                [86.259163, 20.055],
                [86.258605000000145, 20.054451000000647],
                [86.258331, 20.054451000000647],
                [86.25805600000011, 20.054171000000217],
                [86.257766000000203, 20.054171000000217],
                [86.2575, 20.053890000000361],
                [86.257217000000125, 20.053890000000361],
                [86.256927000000218, 20.053610000000386],
                [86.256668, 20.05361200000015],
                [86.256385000000236, 20.053334000000401],
                [86.256112, 20.053334000000401],
                [86.255904000000129, 20.053125000000133],
                [86.255280000000127, 20.0525],
                [86.254448000000181, 20.052511000000319],
                [86.254158000000274, 20.052220000000485],
                [86.253892000000107, 20.052511000000319],
                [86.253326, 20.052511000000319],
                [86.253076000000291, 20.0522470000003],
                [86.252777000000307, 20.052222000000249],
                [86.252501000000152, 20.051944],
                [86.252221000000233, 20.051944],
                [86.251945, 20.051666],
                [86.251663000000107, 20.05167],
                [86.251389, 20.05139],
                [86.250831000000147, 20.05139],
                [86.250557000000114, 20.051666],
                [86.250557000000114, 20.052220000000485],
                [86.250268, 20.052511000000319],
                [86.250557000000114, 20.052778000000213],
                [86.250557000000114, 20.053052000000203],
                [86.251952000000102, 20.054451000000647],
                [86.252221000000233, 20.054444000000323],
                [86.253333, 20.055556],
                [86.253609, 20.055556],
                [86.253892000000107, 20.055834],
                [86.254158000000274, 20.05583],
                [86.254448000000181, 20.056110000000441],
                [86.254724, 20.056110000000441],
                [86.254997000000216, 20.056391000000296],
                [86.255280000000127, 20.056388000000194],
                [86.255836000000201, 20.056944000000382],
                [86.256112, 20.056944000000382],
                [86.256385000000236, 20.057222000000131],
                [86.256700000000293, 20.057252],
                [86.256927000000218, 20.057500000000342],
                [86.257217000000125, 20.057500000000342],
                [86.2575, 20.057781],
                [86.258331, 20.057781],
                [86.258605000000145, 20.058059000000181],
                [86.259163, 20.058057000000414],
                [86.259446000000125, 20.058332000000515],
                [86.261107, 20.058332000000515],
                [86.261666, 20.058888000000248],
                [86.262498, 20.058888000000248],
                [86.26335200000014, 20.058059000000181],
              ],
            ],
            [
              [
                [86.437225, 20.059445000000547],
                [86.438057000000157, 20.058610000000723],
                [86.437768000000148, 20.058321000000653],
                [86.437501, 20.058332000000515],
                [86.436943000000255, 20.057779000000203],
                [86.436669000000151, 20.057781],
                [86.436387000000181, 20.057500000000342],
                [86.436111, 20.057500000000342],
                [86.435279000000136, 20.056671000000275],
                [86.435279000000136, 20.056110000000441],
                [86.434449, 20.055281000000374],
                [86.434449, 20.055],
                [86.433608000000206, 20.054171000000217],
                [86.433608000000206, 20.052780000000435],
                [86.434167000000215, 20.052220000000485],
                [86.434449, 20.052222000000249],
                [86.434723, 20.051944],
                [86.434723, 20.051666],
                [86.434167000000215, 20.051112000000554],
                [86.433608000000206, 20.051112000000554],
                [86.433326000000235, 20.050831999999897],
                [86.433052000000131, 20.051112000000554],
                [86.43222, 20.051112000000554],
                [86.43222, 20.052220000000485],
                [86.431947000000307, 20.052511000000319],
                [86.431947000000307, 20.054444000000323],
                [86.431655, 20.05472],
                [86.431664000000168, 20.055276],
                [86.43222, 20.05583],
                [86.43222, 20.056110000000441],
                [86.432503, 20.056388000000194],
                [86.432503, 20.056944000000382],
                [86.433891000000116, 20.058332000000515],
                [86.434167000000215, 20.058321000000653],
                [86.434449, 20.058610000000723],
                [86.435279000000136, 20.058610000000723],
                [86.435548, 20.058888000000248],
                [86.436111, 20.058888000000248],
                [86.436387000000181, 20.059169000000104],
                [86.436669000000151, 20.05916700000034],
                [86.436943000000255, 20.059445000000547],
                [86.437225, 20.059445000000547],
              ],
            ],
            [
              [
                [86.491111, 20.14972300000067],
                [86.491386999999889, 20.149445000000465],
                [86.491669000000201, 20.149445000000465],
                [86.491669000000201, 20.14805500000011],
                [86.492232000000271, 20.14750100000014],
                [86.492768000000169, 20.14750100000014],
                [86.493331000000282, 20.14806],
                [86.493331000000282, 20.148611000000525],
                [86.493607000000139, 20.148901000000475],
                [86.494721000000283, 20.148901000000475],
                [86.494721000000283, 20.14806],
                [86.493607000000139, 20.146941000000194],
                [86.493613, 20.146667000000203],
                [86.492768000000169, 20.145831000000264],
                [86.492501000000104, 20.145833],
                [86.492225, 20.145555],
                [86.491111, 20.145555],
                [86.490837000000255, 20.145833],
                [86.490279000000143, 20.145831000000264],
                [86.489999000000168, 20.146111000000239],
                [86.489723000000353, 20.146111000000239],
                [86.489167, 20.146667000000203],
                [86.489167, 20.146945000000184],
                [86.489440000000158, 20.147221000000169],
                [86.489440000000158, 20.14805500000011],
                [86.489167, 20.148330999999864],
                [86.489167, 20.148611000000525],
                [86.489999000000168, 20.149445000000465],
                [86.490555000000242, 20.149445000000465],
                [86.490837000000255, 20.14972300000067],
                [86.491111, 20.14972300000067],
              ],
            ],
            [
              [
                [86.501663000000107, 20.175840000000104],
                [86.501953, 20.175560000000129],
                [86.502502, 20.175560000000129],
                [86.502777999999893, 20.17527900000027],
                [86.503610000000137, 20.17527900000027],
                [86.504173000000179, 20.174721],
                [86.504448000000181, 20.174723000000537],
                [86.504722, 20.174445000000329],
                [86.5049980000001, 20.174445000000329],
                [86.505280000000113, 20.174165000000354],
                [86.505836000000187, 20.174169000000344],
                [86.506112, 20.173891000000364],
                [86.507234000000139, 20.173891000000364],
                [86.50805600000011, 20.17306],
                [86.50805600000011, 20.172501],
                [86.506942000000194, 20.171391],
                [86.506668, 20.171391],
                [86.505547000000178, 20.170281000000383],
                [86.5049980000001, 20.170281000000383],
                [86.5049980000001, 20.170001000000408],
                [86.503883, 20.168891],
                [86.502777999999893, 20.168891],
                [86.502502, 20.168611],
                [86.502365, 20.16875],
                [86.502219000000181, 20.168891],
                [86.501663000000107, 20.168330000000189],
                [86.500275, 20.168333000000299],
                [86.500000000000142, 20.168057],
                [86.500000000000142, 20.167781000000101],
                [86.49994700000012, 20.167220000000267],
                [86.499785000000188, 20.166767],
                [86.499512000000252, 20.16635000000019],
                [86.499222, 20.165898000000421],
                [86.498963000000202, 20.165390000000112],
                [86.498618, 20.164900000000667],
                [86.498261000000284, 20.164426000000272],
                [86.497932000000205, 20.163909000000327],
                [86.49773400000025, 20.163230000000336],
                [86.497467000000185, 20.162550000000234],
                [86.497107, 20.161958000000364],
                [86.496567000000283, 20.161700000000106],
                [86.49595, 20.161700000000106],
                [86.495667000000168, 20.161700000000106],
                [86.495355, 20.161836999999874],
                [86.494887000000105, 20.161974],
                [86.494407000000109, 20.162213000000285],
                [86.493958000000219, 20.162450000000259],
                [86.493636000000137, 20.162771000000472],
                [86.493470000000102, 20.163120000000159],
                [86.493584, 20.163485000000261],
                [86.493714000000281, 20.16384],
                [86.493889000000109, 20.164191],
                [86.494056, 20.164551000000294],
                [86.494231000000113, 20.164891000000573],
                [86.494468, 20.165199000000477],
                [86.494630000000228, 20.165465000000491],
                [86.4944, 20.16570200000023],
                [86.493942000000104, 20.165867000000159],
                [86.493873, 20.165894000000431],
                [86.493522000000198, 20.165942000000538],
                [86.493119000000235, 20.16580000000021],
                [86.492722000000171, 20.165570000000109],
                [86.492287, 20.16531],
                [86.491858, 20.164891000000573],
                [86.491569000000297, 20.164893000000344],
                [86.491355, 20.165251000000122],
                [86.491120000000123, 20.165728000000168],
                [86.490913000000134, 20.16628100000025],
                [86.49086, 20.166856],
                [86.490890000000249, 20.167394000000282],
                [86.490792000000141, 20.1678810000003],
                [86.490548000000246, 20.168342000000386],
                [86.490256, 20.168832],
                [86.489937, 20.169360000000321],
                [86.489609000000129, 20.169901000000202],
                [86.489639000000267, 20.170388000000226],
                [86.490081000000188, 20.170730000000272],
                [86.490662000000142, 20.170981000000204],
                [86.491172000000276, 20.171289000000108],
                [86.491669000000201, 20.171521000000205],
                [86.492225, 20.171667],
                [86.492501000000104, 20.17194300000028],
                [86.492775000000208, 20.17194300000028],
                [86.493057000000178, 20.172223000000255],
                [86.493331000000282, 20.172221],
                [86.493889000000109, 20.172781],
                [86.493889000000109, 20.173055],
                [86.494163000000171, 20.173333000000181],
                [86.494445000000184, 20.173333000000181],
                [86.495004000000193, 20.172777000000448],
                [86.495277000000129, 20.172781],
                [86.495553000000228, 20.17306],
                [86.495833000000204, 20.173055],
                [86.496109, 20.173452000000221],
                [86.49645300000013, 20.173821],
                [86.496759, 20.174169000000344],
                [86.497009000000205, 20.174511000000386],
                [86.497178000000176, 20.174842000000123],
                [86.49732200000021, 20.175200000000579],
                [86.497483, 20.17556699999977],
                [86.497673000000276, 20.175972000000453],
                [86.497985000000185, 20.176326000000241],
                [86.49835900000015, 20.176651],
                [86.498839, 20.176811000000264],
                [86.499443000000198, 20.176610000000206],
                [86.500045000000213, 20.176371000000469],
                [86.500617000000133, 20.17613],
                [86.501189000000281, 20.175890000000429],
                [86.501663000000107, 20.175840000000104],
              ],
            ],
            [
              [
                [86.552971000000156, 20.205271000000263],
                [86.552613, 20.205271000000263],
                [86.552689000000143, 20.205811000000264],
                [86.553329000000289, 20.206417000000325],
                [86.554038, 20.2068200000001],
                [86.555038000000224, 20.207360000000101],
                [86.555328000000131, 20.20708900000022],
                [86.555396, 20.206754000000494],
                [86.555114000000103, 20.206282000000325],
                [86.554330000000135, 20.206146000000437],
                [86.55368, 20.205690000000224],
                [86.552971000000156, 20.205271000000263],
              ],
            ],
            [
              [
                [86.415860087540324, 20.343823439786089],
                [86.418472268270804, 20.341805359720862],
                [86.420747836871939, 20.337395869519916],
                [86.42391385250788, 20.335888243026144],
                [86.426476817546515, 20.335586717727658],
                [86.428889019935625, 20.335586717727658],
                [86.430999697026365, 20.335586717727658],
                [86.432723982964077, 20.337768690362047],
                [86.434768763259655, 20.339808071908688],
                [86.4346180006102, 20.33784815746753],
                [86.434014950012838, 20.335134429779597],
                [86.433411899415475, 20.333325277987562],
                [86.43365350504601, 20.332117249835843],
                [86.440453000000375, 20.332282000000529],
                [86.445528794228423, 20.328517017477449],
                [86.44609100000018, 20.3281],
                [86.451882000000111, 20.326179000000131],
                [86.456046000000114, 20.32619],
                [86.46138, 20.32831],
                [86.463677000000217, 20.331368000000335],
                [86.46930600000023, 20.333431000000243],
                [86.472611000000128, 20.332879],
                [86.492348000000263, 20.325652000000442],
                [86.497002000000165, 20.32536],
                [86.50216, 20.326220000000372],
                [86.506568, 20.328189],
                [86.514267, 20.333989000000422],
                [86.524193000000238, 20.336111000000294],
                [86.532386, 20.332389000000372],
                [86.542701000000108, 20.322211000000376],
                [86.546416000000235, 20.319870000000257],
                [86.556832, 20.320121000000196],
                [86.57462300000013, 20.331409000000114],
                [86.577659000000139, 20.332430000000155],
                [86.579628000000113, 20.330819000000243],
                [86.592742000000143, 20.337301000000249],
                [86.60736700000011, 20.336590000000108],
                [86.611556, 20.334169000000195],
                [86.621430000000132, 20.330281000000692],
                [86.626792000000108, 20.329340000000222],
                [86.631836, 20.328640000000401],
                [86.648178000000186, 20.328510000000275],
                [86.654395000000179, 20.327031000000257],
                [86.661018, 20.323571000000126],
                [86.668731000000136, 20.319050000000281],
                [86.673255, 20.31541],
                [86.6791920000001, 20.313712000000116],
                [86.688058000000325, 20.297309000000265],
                [86.690437, 20.294831000000379],
                [86.694038000000191, 20.292949000000128],
                [86.70684, 20.293291000000178],
                [86.708192, 20.293751000000377],
                [86.708534, 20.293890000000598],
                [86.708611, 20.292500000000242],
                [86.709443000000235, 20.292500000000242],
                [86.709717, 20.292780000000214],
                [86.709999, 20.292780000000214],
                [86.710282000000149, 20.292500000000242],
                [86.712219000000218, 20.292500000000242],
                [86.712502000000129, 20.292780000000214],
                [86.712775, 20.292500000000242],
                [86.713058000000203, 20.292500000000242],
                [86.713333000000176, 20.292780000000214],
                [86.713607, 20.292780000000214],
                [86.714156000000273, 20.292222000000486],
                [86.714448000000218, 20.292224000000257],
                [86.714721000000154, 20.291944000000282],
                [86.715553, 20.291942],
                [86.716392, 20.292780000000214],
                [86.717217000000204, 20.292780000000214],
                [86.718063000000186, 20.291942],
                [86.718056000000189, 20.291666000000301],
                [86.718482, 20.291242000000235],
                [86.718612000000221, 20.291112000000108],
                [86.718888, 20.291112000000108],
                [86.718888, 20.290291000000245],
                [86.718612000000221, 20.290002000000406],
                [86.718612000000221, 20.289722000000431],
                [86.718329, 20.289444000000227],
                [86.718329, 20.288890000000261],
                [86.718063000000186, 20.288609000000402],
                [86.718056000000189, 20.287778000000113],
                [86.717217000000204, 20.28695],
                [86.716941000000105, 20.28695],
                [86.716392, 20.286390000000662],
                [86.715843000000277, 20.286390000000662],
                [86.715278000000112, 20.285829000000373],
                [86.714721000000154, 20.285833000000359],
                [86.714448000000218, 20.285555000000155],
                [86.714165, 20.285555000000155],
                [86.713607, 20.284999000000422],
                [86.713058000000203, 20.284999000000422],
                [86.712775, 20.284719000000447],
                [86.712502000000129, 20.284721000000214],
                [86.712219000000218, 20.284445000000453],
                [86.711945000000171, 20.284445000000453],
                [86.711806, 20.284306000000239],
                [86.711670000000183, 20.284167000000249],
                [86.711387, 20.284170000000351],
                [86.711114, 20.283889],
                [86.710831, 20.283889],
                [86.710282000000149, 20.28333100000054],
                [86.70972300000021, 20.283333000000308],
                [86.709443000000235, 20.2830550000001],
                [86.7088940000002, 20.283060000000656],
                [86.708618, 20.282779000000112],
                [86.708046000000181, 20.282779000000112],
                [86.707779000000116, 20.282501],
                [86.70722100000026, 20.282501],
                [86.707084000000222, 20.28236000000015],
                [86.706947000000156, 20.28222100000016],
                [86.706665000000186, 20.282223],
                [86.706391, 20.281945000000174],
                [86.706109000000112, 20.281945000000174],
                [86.705833, 20.281665000000199],
                [86.705277000000166, 20.281669000000417],
                [86.705001, 20.281391000000205],
                [86.704721, 20.281391000000205],
                [86.704438000000252, 20.281102000000143],
                [86.70388900000016, 20.281111000000234],
                [86.703613, 20.280835000000472],
                [86.70333000000015, 20.280835000000472],
                [86.702774, 20.280277000000293],
                [86.701942, 20.280281000000279],
                [86.701669000000237, 20.280001000000304],
                [86.701386, 20.280001000000304],
                [86.70111, 20.279723000000327],
                [86.700837, 20.279723000000327],
                [86.70073700000016, 20.279624999999889],
                [86.700554000000167, 20.279443000000352],
                [86.70027900000018, 20.279443000000352],
                [86.699996, 20.279167000000367],
                [86.699172999999888, 20.279172000000464],
                [86.698891000000216, 20.278891],
                [86.698059, 20.278891],
                [86.697776000000133, 20.278611000000179],
                [86.69722, 20.278611000000179],
                [86.696953, 20.278331000000204],
                [86.696388000000113, 20.278333],
                [86.696115000000162, 20.278055000000219],
                [86.695832000000323, 20.278062],
                [86.695556000000153, 20.277781000000225],
                [86.695267000000158, 20.277781000000225],
                [86.695, 20.277501000000253],
                [86.694724000000278, 20.277501000000253],
                [86.694442, 20.277221000000278],
                [86.693886000000163, 20.277221000000278],
                [86.693336, 20.276667000000312],
                [86.693047000000249, 20.276671000000299],
                [86.692780000000184, 20.276391000000324],
                [86.692498000000214, 20.276391000000324],
                [86.692222, 20.276111000000579],
                [86.691948000000224, 20.275833000000372],
                [86.691666000000254, 20.275833000000372],
                [86.691390000000112, 20.275555000000161],
                [86.69111000000018, 20.275555000000161],
                [86.690278, 20.274723000000442],
                [86.690002000000135, 20.274723000000442],
                [86.688613999999845, 20.273332000000206],
                [86.688058000000325, 20.273332000000206],
                [86.687775000000187, 20.273057000000332],
                [86.687493000000174, 20.273059],
                [86.687233000000148, 20.272779000000124],
                [86.686668, 20.272779000000124],
                [86.685546000000187, 20.271669000000198],
                [86.68528, 20.2719440000003],
                [86.68472400000023, 20.2719440000003],
                [86.683892, 20.271110000000359],
                [86.683326000000235, 20.271110000000359],
                [86.683053, 20.27083000000038],
                [86.6827770000002, 20.27083400000037],
                [86.682504000000264, 20.270556000000166],
                [86.682221000000126, 20.270561000000264],
                [86.681945, 20.270281000000292],
                [86.681656, 20.270281000000292],
                [86.681389000000181, 20.270000000000433],
                [86.68110700000021, 20.270000000000433],
                [86.680268, 20.269162000000499],
                [86.68027500000025, 20.268888000000285],
                [86.680001, 20.26861],
                [86.680001, 20.268054000000344],
                [86.680268, 20.267780000000354],
                [86.680268, 20.266942000000196],
                [86.680001, 20.266666000000438],
                [86.680001, 20.266101000000383],
                [86.68027500000025, 20.265834],
                [86.68027500000025, 20.265278000000304],
                [86.680557000000292, 20.265],
                [86.680557000000292, 20.264681000000333],
                [86.680557000000292, 20.263890000000398],
                [86.680001, 20.263332000000215],
                [86.679732, 20.263332000000215],
                [86.678887, 20.264166000000152],
                [86.678887, 20.264441000000254],
                [86.678055, 20.265278000000304],
                [86.678048, 20.266101000000383],
                [86.677499000000267, 20.266666000000438],
                [86.677499000000267, 20.266944000000414],
                [86.677223000000126, 20.266944000000414],
                [86.677079, 20.266803000000206],
                [86.67694, 20.266666000000438],
                [86.676667, 20.266670000000428],
                [86.676108, 20.266101000000383],
                [86.675552000000238, 20.266670000000428],
                [86.675279, 20.266670000000428],
                [86.674164, 20.267778000000582],
                [86.674164, 20.268334000000319],
                [86.673888000000133, 20.268612000000527],
                [86.673888000000133, 20.269166],
                [86.673606000000163, 20.269440000000483],
                [86.673606000000163, 20.271391000000218],
                [86.673332, 20.271669000000198],
                [86.673332, 20.2725],
                [86.673057, 20.272779000000124],
                [86.673057, 20.273059],
                [86.674164, 20.274167],
                [86.674155000000184, 20.274440000000361],
                [86.67472, 20.275001000000199],
                [86.67472, 20.275279000000179],
                [86.675003, 20.275555000000161],
                [86.675003, 20.27583],
                [86.675835000000149, 20.276667000000312],
                [86.675828000000109, 20.277221000000278],
                [86.676108, 20.277501000000253],
                [86.676108, 20.277781000000225],
                [86.676391000000223, 20.278062],
                [86.676391000000223, 20.278611000000179],
                [86.675828000000109, 20.279172000000464],
                [86.675552000000238, 20.279172000000464],
                [86.675003, 20.278611000000179],
                [86.675003, 20.278331000000204],
                [86.674447000000143, 20.277778999999775],
                [86.674447000000143, 20.277221000000278],
                [86.674164, 20.276945000000516],
                [86.674155000000184, 20.276671000000299],
                [86.673888000000133, 20.276391000000324],
                [86.673888000000133, 20.276111000000579],
                [86.673615000000197, 20.275833000000372],
                [86.673615000000197, 20.275555000000161],
                [86.673057, 20.275001000000199],
                [86.673057, 20.27472000000034],
                [86.672776000000255, 20.274445000000238],
                [86.672776000000255, 20.274167],
                [86.672507000000152, 20.273888000000163],
                [86.672500000000113, 20.273332000000206],
                [86.672227000000177, 20.273330000000438],
                [86.671935000000232, 20.27361],
                [86.671113, 20.27361],
                [86.670563, 20.274168999999794],
                [86.670281, 20.274168999999794],
                [86.669289, 20.275160000000135],
                [86.669572000000173, 20.275632],
                [86.669998000000177, 20.277221000000278],
                [86.670281, 20.277501000000253],
                [86.670281, 20.277781000000225],
                [86.670554000000251, 20.278055000000219],
                [86.670554000000251, 20.278333],
                [86.671935000000232, 20.27972100000056],
                [86.671935000000232, 20.280001000000304],
                [86.672227000000177, 20.280277000000293],
                [86.672227000000177, 20.281102000000143],
                [86.671944, 20.281389000000441],
                [86.671944, 20.281945000000174],
                [86.671669000000108, 20.282223],
                [86.671113, 20.282223],
                [86.670830000000123, 20.281945000000174],
                [86.670830000000123, 20.281665000000199],
                [86.670563, 20.281391000000205],
                [86.670563, 20.281102000000143],
                [86.670281, 20.280835000000472],
                [86.670281, 20.280277000000293],
                [86.669998000000177, 20.280001000000304],
                [86.669998000000177, 20.279440000000697],
                [86.669725000000298, 20.279167000000367],
                [86.669715, 20.278611000000179],
                [86.669449000000128, 20.278331000000204],
                [86.669442000000103, 20.278055000000219],
                [86.669166, 20.277781000000225],
                [86.667778000000268, 20.276111000000579],
                [86.666664000000353, 20.275001000000199],
                [86.666657, 20.274440000000361],
                [86.66639, 20.274167],
                [86.666381, 20.273330000000438],
                [86.666946, 20.272779000000124],
                [86.666946, 20.2725],
                [86.667222000000194, 20.272229000000145],
                [86.667502000000169, 20.272229000000145],
                [86.668327, 20.271391000000218],
                [86.668327, 20.271110000000359],
                [86.668610000000214, 20.27083000000038],
                [86.668610000000214, 20.270556000000166],
                [86.668893, 20.270281000000292],
                [86.668893, 20.270000000000433],
                [86.669166, 20.26972],
                [86.669442000000103, 20.269722000000225],
                [86.669725000000298, 20.269444],
                [86.670554000000251, 20.269444],
                [86.670830000000123, 20.269166],
                [86.671113, 20.269166],
                [86.672500000000113, 20.267778000000582],
                [86.672507000000152, 20.267500000000378],
                [86.672776000000255, 20.267222000000171],
                [86.672776000000255, 20.266666000000438],
                [86.673606000000163, 20.26583200000027],
                [86.673615000000197, 20.265556],
                [86.673332, 20.26528],
                [86.673332, 20.265],
                [86.673057, 20.264721999999885],
                [86.673057, 20.264444000000363],
                [86.672776000000255, 20.264166000000152],
                [86.672783, 20.2625],
                [86.673615000000197, 20.261668000000324],
                [86.673888000000133, 20.26167],
                [86.674447000000143, 20.261109000000257],
                [86.67472, 20.261109000000257],
                [86.675003, 20.260829000000509],
                [86.675552000000238, 20.260834000000383],
                [86.675835000000149, 20.260556000000172],
                [86.676108, 20.260560000000392],
                [86.676391000000223, 20.260291000000272],
                [86.676667, 20.260291000000272],
                [86.67694, 20.259998999999876],
                [86.677781, 20.259998999999876],
                [86.678048, 20.259719000000128],
                [86.679725, 20.259721000000351],
                [86.68027500000025, 20.259168000000265],
                [86.680557000000292, 20.25917],
                [86.680557000000292, 20.258889000000174],
                [86.679732, 20.258051],
                [86.678337, 20.258055000000237],
                [86.678055, 20.258333000000444],
                [86.67694, 20.258329000000224],
                [86.67591, 20.258342000000304],
                [86.675400000000295, 20.258349000000173],
                [86.67405, 20.257882000000105],
                [86.671837000000139, 20.257611000000221],
                [86.669326000000169, 20.256531000000219],
                [86.668266000000116, 20.256302999999882],
                [86.667122, 20.256054000000169],
                [86.663888, 20.254723000000464],
                [86.662042, 20.254069000000296],
                [86.660683000000105, 20.25393],
                [86.658607000000231, 20.253055],
                [86.656196, 20.252599000000142],
                [86.653335000000112, 20.251389000000238],
                [86.651658000000154, 20.250562000000624],
                [86.649772999999897, 20.250021],
                [86.647339000000201, 20.249080000000273],
                [86.644622000000339, 20.248189000000135],
                [86.643195000000134, 20.247453000000171],
                [86.640953000000223, 20.246938000000451],
                [86.63881, 20.246060000000167],
                [86.636308000000128, 20.245522000000385],
                [86.63481, 20.244171],
                [86.632103000000114, 20.24289000000044],
                [86.629532, 20.242215000000435],
                [86.626175, 20.240729],
                [86.623337000000319, 20.239720000000258],
                [86.62220000000022, 20.2387740000006],
                [86.619775000000104, 20.237899000000194],
                [86.617767000000157, 20.237222],
                [86.616669, 20.236112],
                [86.61638600000019, 20.236121000000136],
                [86.615837000000155, 20.235560000000529],
                [86.615547, 20.235560000000529],
                [86.615271000000106, 20.235280000000554],
                [86.614722, 20.235280000000554],
                [86.614442, 20.234999999999893],
                [86.613893000000346, 20.234999999999893],
                [86.61361, 20.234719000000265],
                [86.613334, 20.234722000000371],
                [86.613052, 20.234443000000276],
                [86.612778000000262, 20.234443000000276],
                [86.612220000000121, 20.233890000000198],
                [86.611946, 20.233890000000198],
                [86.611657, 20.233609000000339],
                [86.611114000000143, 20.233612000000441],
                [86.610558, 20.23305500000037],
                [86.610276, 20.23305500000037],
                [86.61000000000017, 20.232777000000166],
                [86.609726000000123, 20.232780000000268],
                [86.609437000000113, 20.232499],
                [86.609168000000267, 20.232499],
                [86.606941, 20.231670000000573],
                [86.606392000000241, 20.231109000000284],
                [86.606109000000103, 20.231111000000507],
                [86.605553, 20.230558000000425],
                [86.605277000000157, 20.230560000000192],
                [86.605004000000264, 20.230279000000333],
                [86.604721, 20.230279000000333],
                [86.604446000000152, 20.229990000000264],
                [86.604165, 20.229999000000358],
                [86.60388900000018, 20.2297230000006],
                [86.603616000000258, 20.2297230000006],
                [86.603333000000106, 20.229445000000389],
                [86.602775, 20.229445000000389],
                [86.602271, 20.228942000000412],
                [86.601943, 20.228611000000452],
                [86.60167, 20.228611000000452],
                [86.601113000000154, 20.228060000000593],
                [86.600831000000184, 20.228060000000593],
                [86.599999, 20.227221000000551],
                [86.599723000000139, 20.227223000000315],
                [86.599441, 20.226943000000343],
                [86.599167, 20.226950000000212],
                [86.598611000000275, 20.226391000000145],
                [86.598342000000144, 20.226391000000145],
                [86.597779, 20.225831000000195],
                [86.59750300000016, 20.225833000000645],
                [86.597221, 20.225555000000437],
                [86.596108000000172, 20.225555000000437],
                [86.595833000000169, 20.225833000000645],
                [86.595559000000137, 20.225831000000195],
                [86.595277, 20.22611100000017],
                [86.595001, 20.22611100000017],
                [86.5947180000001, 20.226391000000145],
                [86.594169, 20.225831000000195],
                [86.593886000000197, 20.225833000000645],
                [86.593613000000261, 20.225557000000205],
                [86.593330000000122, 20.225277000000229],
                [86.593064000000226, 20.225281000000216],
                [86.592781, 20.225001000000471],
                [86.592216000000207, 20.225001000000471],
                [86.591995, 20.224778],
                [86.591942000000103, 20.224721000000496],
                [86.59083500000024, 20.224723000000264],
                [86.589638000000136, 20.223529],
                [86.589164, 20.223055000000151],
                [86.588890000000248, 20.223055000000151],
                [86.587502, 20.221667000000245],
                [86.587220000000272, 20.221671000000235],
                [86.586937000000134, 20.221391000000491],
                [86.586671, 20.221391000000491],
                [86.585556000000153, 20.220279000000343],
                [86.585289, 20.220279000000343],
                [86.585, 20.220001000000135],
                [86.584717000000168, 20.220001000000135],
                [86.58448700000028, 20.219768000000155],
                [86.584168000000133, 20.219723000000382],
                [86.583983, 20.219540000000503],
                [86.58361, 20.21916600000031],
                [86.583336000000173, 20.219169000000417],
                [86.58304699999988, 20.218891000000209],
                [86.58304699999988, 20.21861000000035],
                [86.58278, 20.218330000000375],
                [86.582497, 20.218335000000476],
                [86.582222000000257, 20.218056],
                [86.581948000000224, 20.218050000000396],
                [86.58139, 20.21861000000035],
                [86.580827, 20.21861000000035],
                [86.580558000000138, 20.218891000000209],
                [86.580558000000138, 20.219169000000417],
                [86.580278000000177, 20.21916600000031],
                [86.580002, 20.219444000000287],
                [86.579719000000168, 20.219444000000287],
                [86.579560000000171, 20.219285000000351],
                [86.579170000000133, 20.218888],
                [86.578614, 20.218891000000209],
                [86.57833100000019, 20.21861000000035],
                [86.577217000000275, 20.21861000000035],
                [86.576943000000171, 20.218330000000375],
                [86.57555300000017, 20.218335000000476],
                [86.575279000000336, 20.218056],
                [86.574997, 20.218056],
                [86.574723000000262, 20.217776000000409],
                [86.574174000000184, 20.21778100000051],
                [86.573609, 20.21722],
                [86.573333000000204, 20.217221999999758],
                [86.57306, 20.216944000000236],
                [86.57277700000013, 20.216944000000236],
                [86.57264, 20.216805000000246],
                [86.572501, 20.216666],
                [86.572221, 20.21667100000013],
                [86.572114000000155, 20.216561000000407],
                [86.57194500000017, 20.216388000000503],
                [86.571662, 20.216390000000271],
                [86.570701, 20.215426000000203],
                [86.569725000000275, 20.214444000000181],
                [86.569443000000305, 20.214451000000274],
                [86.569169, 20.21417100000053],
                [86.568055000000271, 20.214166000000429],
                [86.567496, 20.214722000000162],
                [86.566947000000226, 20.214722000000162],
                [86.566667, 20.214444000000181],
                [86.566391000000152, 20.214451000000274],
                [86.566108, 20.21417100000053],
                [86.565826000000271, 20.21417100000053],
                [86.565354000000212, 20.213690000000266],
                [86.565276, 20.21361],
                [86.565003000000146, 20.213611999999777],
                [86.564720000000278, 20.213334000000255],
                [86.564444000000137, 20.213334000000255],
                [86.564164000000204, 20.21305400000028],
                [86.563888, 20.21305400000028],
                [86.563332, 20.212500000000311],
                [86.563056000000117, 20.212500000000311],
                [86.561944000000238, 20.211390000000389],
                [86.561944000000238, 20.211112000000181],
                [86.561119000000119, 20.21028],
                [86.561119000000119, 20.210001999999797],
                [86.560280000000134, 20.209170000000309],
                [86.559998000000164, 20.209170000000309],
                [86.559722, 20.208890000000331],
                [86.558892000000114, 20.208890000000331],
                [86.558610000000144, 20.208609],
                [86.558327000000233, 20.208609],
                [86.558061000000109, 20.208329],
                [86.557778, 20.208334000000601],
                [86.557502, 20.208056000000393],
                [86.55722, 20.208060000000383],
                [86.556946000000309, 20.207780000000408],
                [86.556390000000235, 20.207780000000408],
                [86.556107, 20.208060000000383],
                [86.555275000000151, 20.208056000000393],
                [86.554733, 20.208609],
                [86.554726, 20.209168000000542],
                [86.554444, 20.2094440000003],
                [86.554444, 20.209722],
                [86.554168000000217, 20.210001999999797],
                [86.553612000000143, 20.210001999999797],
                [86.553475000000148, 20.209861],
                [86.553338, 20.209722],
                [86.553056, 20.209722],
                [86.552497, 20.209168000000542],
                [86.552224000000166, 20.209170000000309],
                [86.551109, 20.208060000000383],
                [86.551109, 20.207780000000408],
                [86.549445000000205, 20.206109000000421],
                [86.549163000000235, 20.206112],
                [86.547775000000215, 20.204721000000283],
                [86.547775000000215, 20.204445000000529],
                [86.547501000000153, 20.204167000000322],
                [86.547501000000153, 20.20388900000011],
                [86.545831000000177, 20.202221000000229],
                [86.545831000000177, 20.201945000000247],
                [86.546111, 20.201665000000272],
                [86.545831000000177, 20.201391000000282],
                [86.546143000000299, 20.200550000000472],
                [86.545646, 20.199671000000304],
                [86.545562, 20.198331000000277],
                [86.545555000000306, 20.198055000000291],
                [86.544716, 20.197221000000347],
                [86.543891000000187, 20.197221000000347],
                [86.543609000000146, 20.197501000000322],
                [86.542779000000266, 20.197501000000322],
                [86.542220999999898, 20.198055000000291],
                [86.542220999999898, 20.198331000000277],
                [86.541947, 20.198611000000248],
                [86.541947, 20.198891000000224],
                [86.541658, 20.199172000000541],
                [86.541658, 20.200282000000239],
                [86.541648000000109, 20.2011980000002],
                [86.541008, 20.201872000000318],
                [86.538886000000133, 20.201111000000303],
                [86.538613000000211, 20.201111000000303],
                [86.53833, 20.200831000000328],
                [86.537781000000308, 20.200835000000549],
                [86.53749800000017, 20.200554999999891],
                [86.537216000000157, 20.20056],
                [86.536666000000224, 20.20001],
                [86.53611000000015, 20.20001],
                [86.534722000000144, 20.198611000000248],
                [86.534722000000144, 20.198331000000277],
                [86.533058, 20.196667000000385],
                [86.532776, 20.196671],
                [86.532776, 20.196391000000627],
                [86.532502000000221, 20.196111],
                [86.532502000000221, 20.195555000000237],
                [86.53167, 20.194723000000518],
                [86.53082900000031, 20.194723000000518],
                [86.529724000000201, 20.19361],
                [86.529441, 20.19361],
                [86.529168000000126, 20.193879000000145],
                [86.529168000000126, 20.194167000000331],
                [86.528892000000255, 20.194445000000311],
                [86.528892000000255, 20.194720000000412],
                [86.52861, 20.195001000000268],
                [86.528053, 20.195001000000268],
                [86.527497000000196, 20.194440000000437],
                [86.527497000000196, 20.194167000000331],
                [86.526656000000216, 20.19333],
                [86.526665, 20.193057000000405],
                [86.525834, 20.192220000000127],
                [86.525834, 20.191388],
                [86.525275000000221, 20.190821000000362],
                [86.524719000000147, 20.190834000000446],
                [86.524446000000211, 20.190556000000463],
                [86.524436, 20.190281000000361],
                [86.523887, 20.18972],
                [86.523055, 20.189722000000295],
                [86.522782000000106, 20.189444000000314],
                [86.522499000000238, 20.189444000000314],
                [86.521385000000322, 20.188334000000388],
                [86.520553000000106, 20.188334000000388],
                [86.518105, 20.187284000000311],
                [86.517218000000113, 20.186388000000303],
                [86.516938000000138, 20.18611000000055],
                [86.516945000000177, 20.185834000000334],
                [86.516113, 20.185000000000169],
                [86.515824000000222, 20.185000000000169],
                [86.514999, 20.184170000000446],
                [86.514999, 20.183890000000471],
                [86.514442, 20.183332000000288],
                [86.514442, 20.183056000000526],
                [86.514167000000128, 20.182782000000312],
                [86.514167000000128, 20.182502000000333],
                [86.513611, 20.181939000000281],
                [86.513337, 20.181944000000382],
                [86.51305400000011, 20.181668],
                [86.512779000000108, 20.18167000000016],
                [86.512359000000217, 20.181251000000199],
                [86.511947000000177, 20.180829000000578],
                [86.511666, 20.180834],
                [86.5114820000002, 20.180649000000127],
                [86.511391000000103, 20.180556000000248],
                [86.511391000000103, 20.18028],
                [86.511108, 20.179999000000176],
                [86.511108, 20.178609000000275],
                [86.511391000000103, 20.178333000000517],
                [86.510835, 20.177777000000102],
                [86.5105590000002, 20.178055000000306],
                [86.50972, 20.177221000000369],
                [86.509453000000164, 20.177219000000598],
                [86.509164000000141, 20.177499000000573],
                [86.508888000000283, 20.177219000000598],
                [86.50805600000011, 20.177221000000369],
                [86.50777400000014, 20.176945],
                [86.507234000000139, 20.177499000000573],
                [86.506942000000194, 20.177499000000573],
                [86.505554000000174, 20.178887000000479],
                [86.504722, 20.178887000000479],
                [86.503890000000339, 20.179721000000423],
                [86.503610000000137, 20.179446000000546],
                [86.503327000000226, 20.179450000000539],
                [86.502976000000146, 20.179088],
                [86.502777999999893, 20.178887000000479],
                [86.501953, 20.178880000000156],
                [86.501663000000107, 20.179170000000109],
                [86.501388000000105, 20.179170000000109],
                [86.501107, 20.179450000000539],
                [86.500558000000211, 20.179446000000546],
                [86.500275, 20.179721000000423],
                [86.498612000000122, 20.179719000000198],
                [86.498336000000251, 20.179999000000176],
                [86.498046, 20.179999000000176],
                [86.497497, 20.180560000000465],
                [86.495553000000228, 20.180556000000248],
                [86.495277000000129, 20.180834],
                [86.495004000000193, 20.180829000000578],
                [86.494721000000283, 20.181109000000554],
                [86.494445000000184, 20.181109000000554],
                [86.494156, 20.181390000000189],
                [86.493889000000109, 20.181390000000189],
                [86.493607000000139, 20.18167000000016],
                [86.493607000000139, 20.182782000000312],
                [86.495826000000164, 20.185000000000169],
                [86.496109, 20.185000000000169],
                [86.496665000000107, 20.185561],
                [86.496948, 20.18555600000013],
                [86.497224000000116, 20.185834000000334],
                [86.497497, 20.18583200000057],
                [86.499168000000196, 20.187500000000451],
                [86.499168000000196, 20.188054000000413],
                [86.499443000000198, 20.188334000000388],
                [86.499443000000198, 20.188612],
                [86.499733, 20.18861000000015],
                [86.500275, 20.18916600000011],
                [86.500000000000142, 20.189444000000314],
                [86.499726, 20.189444000000314],
                [86.499443000000198, 20.189722000000295],
                [86.499168000000196, 20.18972],
                [86.498885, 20.190000000000506],
                [86.498612000000122, 20.190000000000506],
                [86.498336000000251, 20.190281000000361],
                [86.497497, 20.190281000000361],
                [86.497224000000116, 20.190000000000506],
                [86.497224000000116, 20.18972],
                [86.49778, 20.18916600000011],
                [86.498046, 20.189171000000666],
                [86.498336000000251, 20.188890000000121],
                [86.497224000000116, 20.187780000000426],
                [86.496948, 20.187780000000426],
                [86.496109, 20.186951000000359],
                [86.495826000000164, 20.186951000000359],
                [86.495553000000228, 20.186671000000381],
                [86.495277000000129, 20.186671000000381],
                [86.494172, 20.185554000000362],
                [86.493057000000178, 20.184442000000214],
                [86.492775000000208, 20.184444000000433],
                [86.492775000000208, 20.183890000000471],
                [86.492232000000271, 20.183332000000288],
                [86.491943, 20.183332000000288],
                [86.491943, 20.183056000000526],
                [86.492232000000271, 20.182782000000312],
                [86.492232000000271, 20.182219000000256],
                [86.492501000000104, 20.181944000000382],
                [86.492501000000104, 20.180556000000248],
                [86.492768000000169, 20.18028],
                [86.492768000000169, 20.179999000000176],
                [86.493331000000282, 20.179450000000539],
                [86.493607000000139, 20.179450000000539],
                [86.493889000000109, 20.179170000000109],
                [86.494156, 20.179170000000109],
                [86.494445000000184, 20.178880000000156],
                [86.494721000000283, 20.178887000000479],
                [86.495277000000129, 20.178333000000517],
                [86.495277000000129, 20.177777000000102],
                [86.495004000000193, 20.177499000000573],
                [86.495277000000129, 20.177219000000598],
                [86.495004000000193, 20.176945],
                [86.494721000000283, 20.176945],
                [86.493889000000109, 20.176111],
                [86.493889000000109, 20.175560000000129],
                [86.494156, 20.17527900000027],
                [86.493889000000109, 20.175001],
                [86.493889000000109, 20.174721],
                [86.492501000000104, 20.173333000000181],
                [86.492225, 20.173333000000181],
                [86.491943, 20.173055],
                [86.491669000000201, 20.17306],
                [86.491386999999889, 20.172781],
                [86.490548000000246, 20.172781],
                [86.490279000000143, 20.172501],
                [86.489723000000353, 20.172501],
                [86.489440000000158, 20.172221],
                [86.488335, 20.172223000000255],
                [86.488052000000195, 20.17194300000028],
                [86.487779, 20.17194300000028],
                [86.48750300000016, 20.171667],
                [86.486389, 20.171667],
                [86.485832000000229, 20.172223000000255],
                [86.484169, 20.172223000000255],
                [86.483886000000126, 20.17194300000028],
                [86.483613, 20.17194300000028],
                [86.483476000000152, 20.171808000000279],
                [86.48333, 20.171667],
                [86.483063000000286, 20.171672],
                [86.482895000000198, 20.171510000000346],
                [86.482781, 20.171389000000314],
                [86.482498000000106, 20.171391],
                [86.480552, 20.169452000000312],
                [86.480552, 20.168611],
                [86.479722000000123, 20.167779000000333],
                [86.479706, 20.167498],
                [86.479446, 20.167220000000267],
                [86.479446, 20.166945000000393],
                [86.478614, 20.166109999999886],
                [86.478332, 20.166109999999886],
                [86.478058000000246, 20.165830000000135],
                [86.477776, 20.165832000000361],
                [86.477500000000106, 20.165557000000486],
                [86.47667, 20.165557000000486],
                [86.475280000000211, 20.166940000000519],
                [86.475280000000211, 20.168891],
                [86.474997, 20.169171],
                [86.474441000000283, 20.169171],
                [86.474168, 20.168891],
                [86.474168, 20.167781000000101],
                [86.473899, 20.167498],
                [86.473892, 20.166388],
                [86.474168, 20.166109999999886],
                [86.474168, 20.165830000000135],
                [86.474724000000137, 20.165279000000275],
                [86.475829, 20.16417100000012],
                [86.475280000000211, 20.163610000000286],
                [86.474997, 20.163610000000286],
                [86.474717, 20.163330000000538],
                [86.474441000000283, 20.163334],
                [86.474168, 20.163056000000321],
                [86.473899, 20.163061000000422],
                [86.473625000000183, 20.162787000000204],
                [86.472778, 20.161946000000622],
                [86.472778, 20.161671],
                [86.472495000000123, 20.161390000000207],
                [86.472495000000123, 20.161110000000228],
                [86.472221, 20.160834000000474],
                [86.472221, 20.160552],
                [86.471946, 20.160278],
                [86.471946, 20.15889],
                [86.471656000000209, 20.158610000000177],
                [86.471946, 20.158332000000424],
                [86.471946, 20.158056000000666],
                [86.472221, 20.157771000000135],
                [86.472504000000228, 20.157777999999777],
                [86.472778, 20.157500000000248],
                [86.472778, 20.157222],
                [86.473053000000263, 20.156944000000518],
                [86.473053000000263, 20.15666600000031],
                [86.473343000000142, 20.156392],
                [86.473343000000142, 20.155000000000197],
                [86.473609, 20.15472200000044],
                [86.473609, 20.15305600000033],
                [86.473343000000142, 20.152780000000345],
                [86.473343000000142, 20.152219],
                [86.472778, 20.151668000000193],
                [86.472778, 20.151389000000332],
                [86.472495000000123, 20.151109000000357],
                [86.472504000000228, 20.150555000000164],
                [86.471665, 20.14972300000067],
                [86.471390000000312, 20.14972300000067],
                [86.470833, 20.149165],
                [86.470840000000109, 20.148901000000475],
                [86.470558, 20.148901000000475],
                [86.469436000000229, 20.147779000000352],
                [86.46917, 20.147779000000352],
                [86.468887000000194, 20.14750100000014],
                [86.468614000000258, 20.14750100000014],
                [86.468475000000225, 20.147362000000609],
                [86.46833100000012, 20.147221000000169],
                [86.465842000000109, 20.147221000000169],
                [86.465553, 20.14750100000014],
                [86.465279, 20.14750100000014],
                [86.464997, 20.147779000000352],
                [86.464721000000154, 20.147777000000584],
                [86.463768, 20.148552000000105],
                [86.463059, 20.151109000000357],
                [86.463059, 20.151389000000332],
                [86.462777, 20.15167],
                [86.462777, 20.151946000000404],
                [86.462501000000245, 20.152219],
                [86.461938000000131, 20.153890000000267],
                [86.461945000000171, 20.154168000000478],
                [86.461669, 20.154439000000362],
                [86.461669, 20.155000000000197],
                [86.460457, 20.157320000000478],
                [86.460381, 20.158129000000596],
                [86.460534, 20.15907000000038],
                [86.46083, 20.160841000000115],
                [86.46083, 20.161946000000622],
                [86.460557000000151, 20.16222200000038],
                [86.459998000000141, 20.16222200000038],
                [86.459725000000205, 20.161946000000622],
                [86.459716000000171, 20.161671],
                [86.459442, 20.161390000000207],
                [86.459442, 20.160841000000115],
                [86.459167, 20.160552],
                [86.459167, 20.157777999999777],
                [86.459442, 20.157500000000248],
                [86.459442, 20.156392],
                [86.459716000000171, 20.156112000000341],
                [86.459716000000171, 20.15528],
                [86.459998000000141, 20.155000000000197],
                [86.459998000000141, 20.153890000000267],
                [86.460557000000151, 20.153329000000436],
                [86.460557000000151, 20.15305600000033],
                [86.461113000000225, 20.152499],
                [86.461113000000225, 20.152219],
                [86.461389, 20.151946000000404],
                [86.461389, 20.151109000000357],
                [86.461669, 20.150833000000372],
                [86.461669, 20.149999000000431],
                [86.462777, 20.148330999999864],
                [86.464721000000154, 20.14638900000045],
                [86.464997, 20.146391000000214],
                [86.466040000000348, 20.145990000000435],
                [86.467613000000128, 20.14604000000076],
                [86.468614000000258, 20.146111000000239],
                [86.468887000000194, 20.146111000000239],
                [86.46917, 20.146391000000214],
                [86.469443000000268, 20.14638900000045],
                [86.470275000000214, 20.147223],
                [86.470558, 20.147221000000169],
                [86.471107000000103, 20.147779000000352],
                [86.471390000000312, 20.147779000000352],
                [86.472221, 20.148611000000525],
                [86.472495000000123, 20.148611000000525],
                [86.473053000000263, 20.149165],
                [86.473053000000263, 20.149441000000245],
                [86.473892, 20.150277000000184],
                [86.473892, 20.150555000000164],
                [86.474168, 20.150831000000149],
                [86.474168, 20.151389000000332],
                [86.474441000000283, 20.15167],
                [86.474441000000283, 20.151946000000404],
                [86.474717, 20.152219],
                [86.474724000000137, 20.152780000000345],
                [86.475280000000211, 20.153329000000436],
                [86.475280000000211, 20.153609000000412],
                [86.474997, 20.153890000000267],
                [86.474997, 20.154168000000478],
                [86.474724000000137, 20.154444000000236],
                [86.474717, 20.155832000000366],
                [86.474441000000283, 20.156112000000341],
                [86.474441000000283, 20.157771000000135],
                [86.474168, 20.158056000000666],
                [86.474168, 20.161110000000228],
                [86.474441000000283, 20.161390000000207],
                [86.474441000000283, 20.161671],
                [86.475280000000211, 20.1625],
                [86.475563000000122, 20.1625],
                [86.475829, 20.162781000000447],
                [86.477500000000106, 20.162781000000447],
                [86.477783, 20.163061000000422],
                [86.478058000000246, 20.163056000000321],
                [86.478332, 20.163334],
                [86.478608000000222, 20.163330000000538],
                [86.480278000000197, 20.165000000000187],
                [86.480278000000197, 20.165279000000275],
                [86.480827, 20.165830000000135],
                [86.480834000000272, 20.166109999999886],
                [86.484444, 20.16972099999975],
                [86.484727000000106, 20.169709],
                [86.48500100000021, 20.170001000000408],
                [86.485283, 20.170001000000408],
                [86.485557000000284, 20.16972099999975],
                [86.488335, 20.166945000000393],
                [86.488335, 20.166388],
                [86.488608000000269, 20.166109999999886],
                [86.488608000000269, 20.165830000000135],
                [86.488891000000109, 20.165557000000486],
                [86.488877, 20.165000000000187],
                [86.489167, 20.164720000000209],
                [86.489167, 20.163610000000286],
                [86.489440000000158, 20.163330000000538],
                [86.489440000000158, 20.162776000000346],
                [86.489723000000353, 20.1625],
                [86.489723000000353, 20.162220000000158],
                [86.489167, 20.161666000000647],
                [86.489167, 20.161110000000228],
                [86.489440000000158, 20.160834000000474],
                [86.489440000000158, 20.160280000000281],
                [86.489723000000353, 20.160000000000306],
                [86.489723000000353, 20.159720000000558],
                [86.490837000000255, 20.158612000000399],
                [86.490837000000255, 20.158056000000666],
                [86.491111, 20.157771000000135],
                [86.491111, 20.157500000000248],
                [86.490837000000255, 20.157222],
                [86.490837000000255, 20.15666600000031],
                [86.490548000000246, 20.156392],
                [86.490548000000246, 20.156112000000341],
                [86.489723000000353, 20.15528],
                [86.489723000000353, 20.155000000000197],
                [86.489440000000158, 20.154710000000243],
                [86.489440000000158, 20.152780000000345],
                [86.489723000000353, 20.152499],
                [86.489723000000353, 20.152219],
                [86.489440000000158, 20.151946000000404],
                [86.489440000000158, 20.15167],
                [86.489167, 20.151389000000332],
                [86.489167, 20.151109000000357],
                [86.488052000000195, 20.149999000000431],
                [86.487779, 20.149999000000431],
                [86.48750300000016, 20.14972100000022],
                [86.48722, 20.14972300000067],
                [86.48611500000014, 20.148611000000525],
                [86.486106, 20.147221000000169],
                [86.485832000000229, 20.146945000000184],
                [86.485832000000229, 20.146667000000203],
                [86.485557000000284, 20.146391000000214],
                [86.485557000000284, 20.145562000000151],
                [86.484435000000161, 20.144440000000255],
                [86.483613, 20.144443000000358],
                [86.48333, 20.144723000000333],
                [86.482498000000106, 20.144723000000333],
                [86.482407, 20.14463],
                [86.482225000000184, 20.144443000000358],
                [86.481942000000316, 20.144443000000358],
                [86.481803000000227, 20.144306000000139],
                [86.481666000000175, 20.144167000000603],
                [86.481393000000281, 20.144171000000135],
                [86.481110000000101, 20.14389100000016],
                [86.480827, 20.14389100000016],
                [86.480600000000308, 20.143659000000294],
                [86.479722000000123, 20.143611000000188],
                [86.479446, 20.143333000000432],
                [86.47889, 20.143333000000432],
                [86.478614, 20.143055000000452],
                [86.478058000000246, 20.143062],
                [86.47798100000027, 20.142979000000192],
                [86.477776, 20.14277900000047],
                [86.476944000000103, 20.14277900000047],
                [86.47667, 20.142501000000259],
                [86.476112000000157, 20.142501000000259],
                [86.475387000000111, 20.1418900000001],
                [86.474601000000163, 20.141418000000154],
                [86.474457, 20.140750000000477],
                [86.474822, 20.139531000000485],
                [86.475533000000198, 20.138382000000771],
                [86.476173, 20.137911],
                [86.47667, 20.138057000000341],
                [86.47667, 20.138330000000671],
                [86.475829, 20.13916600000038],
                [86.475829, 20.139440000000373],
                [86.475563000000122, 20.139729000000436],
                [86.475563000000122, 20.14055900000039],
                [86.476388000000256, 20.141391000000564],
                [86.477220000000202, 20.141391000000564],
                [86.477500000000106, 20.141671000000539],
                [86.478058000000246, 20.141667000000322],
                [86.478332, 20.141945],
                [86.479446, 20.141945],
                [86.479722000000123, 20.142221000000283],
                [86.481666000000175, 20.142221000000283],
                [86.481942000000316, 20.142501000000259],
                [86.482215000000267, 20.142501000000259],
                [86.482498000000106, 20.142221000000283],
                [86.48333, 20.142221000000283],
                [86.483613, 20.141945],
                [86.483886000000126, 20.141945],
                [86.484169, 20.141667000000322],
                [86.484169, 20.140830000000275],
                [86.484444, 20.140557],
                [86.484435000000161, 20.140279000000415],
                [86.484169, 20.139997999999874],
                [86.483886000000126, 20.139997999999874],
                [86.483613, 20.139729000000436],
                [86.48333, 20.139729000000436],
                [86.482215000000267, 20.13861],
                [86.481666000000175, 20.13861],
                [86.481110000000101, 20.138059000000105],
                [86.480552, 20.138059000000105],
                [86.480002, 20.1375],
                [86.480002, 20.137220000000294],
                [86.47889, 20.136110000000368],
                [86.47889, 20.13583],
                [86.478614, 20.135556000000399],
                [86.478608000000222, 20.135281000000298],
                [86.478332, 20.135000000000442],
                [86.478332, 20.132780000000363],
                [86.47889, 20.13222200000018],
                [86.479164000000281, 20.13222400000063],
                [86.480002, 20.13139],
                [86.480002, 20.129722000000125],
                [86.480278000000197, 20.129444000000369],
                [86.480278000000197, 20.126390000000352],
                [86.480002, 20.12610900000049],
                [86.480002, 20.125834000000388],
                [86.47889, 20.12472100000036],
                [86.47667, 20.12473],
                [86.476388000000256, 20.12445],
                [86.474717, 20.12445],
                [86.474441000000283, 20.12473],
                [86.474168, 20.12473],
                [86.473609, 20.12417],
                [86.473343000000142, 20.12417],
                [86.473008000000149, 20.123835000000323],
                [86.472504000000228, 20.123332999999768],
                [86.472221, 20.123332999999768],
                [86.471946, 20.123058000000352],
                [86.471656000000209, 20.12306000000012],
                [86.471656000000209, 20.122779000000484],
                [86.471107000000103, 20.122221000000305],
                [86.471107000000103, 20.121945000000316],
                [86.470833, 20.121945000000316],
                [86.470833, 20.121665000000572],
                [86.470002, 20.120833000000172],
                [86.46971900000014, 20.120833000000172],
                [86.469443000000268, 20.120555000000191],
                [86.46917, 20.12056],
                [86.468887000000194, 20.12028200000054],
                [86.468614000000258, 20.12028200000054],
                [86.46833100000012, 20.120001],
                [86.468055, 20.120001],
                [86.467499000000174, 20.119443],
                [86.467223, 20.119443],
                [86.466943000000114, 20.119167],
                [86.466391000000144, 20.119167],
                [86.465835, 20.119723000000473],
                [86.465553, 20.119723000000473],
                [86.465279, 20.119443],
                [86.465279, 20.118889000000529],
                [86.464997, 20.118602000000234],
                [86.464997, 20.117777000000384],
                [86.464707000000118, 20.117501000000399],
                [86.464707000000118, 20.117221000000423],
                [86.463333000000134, 20.115833],
                [86.463059, 20.115833],
                [86.462777, 20.11555500000031],
                [86.462777, 20.115281000000319],
                [86.462218, 20.11472],
                [86.462218, 20.114445000000611],
                [86.462501000000245, 20.114167000000403],
                [86.462501000000245, 20.113611],
                [86.462777, 20.113330000000126],
                [86.462777, 20.111944],
                [86.463059, 20.111666000000238],
                [86.463059, 20.11111],
                [86.462777, 20.11083],
                [86.462777, 20.11000000000012],
                [86.462501000000245, 20.109720000000145],
                [86.462501000000245, 20.109166000000183],
                [86.462777, 20.108890000000198],
                [86.462777, 20.10861000000045],
                [86.463333000000134, 20.108054],
                [86.464707000000118, 20.106661],
                [86.464721000000154, 20.106388000000376],
                [86.465842000000109, 20.105280000000217],
                [86.465842000000109, 20.105000000000469],
                [86.466111000000211, 20.104722000000258],
                [86.466111000000211, 20.104444],
                [86.466943000000114, 20.103612000000336],
                [86.467216, 20.103621000000427],
                [86.467499000000174, 20.103332],
                [86.46833100000012, 20.103332],
                [86.468614000000258, 20.103056],
                [86.46917, 20.103060000000138],
                [86.469436000000229, 20.102780000000159],
                [86.46971900000014, 20.102780000000159],
                [86.470002, 20.102502000000637],
                [86.470275000000214, 20.102502000000637],
                [86.470840000000109, 20.101939000000353],
                [86.470833, 20.100834],
                [86.470558, 20.100556000000321],
                [86.470558, 20.100280000000108],
                [86.470002, 20.099719000000274],
                [86.470002, 20.099446],
                [86.469436000000229, 20.098890000000203],
                [86.46971900000014, 20.098609000000348],
                [86.46971900000014, 20.098333],
                [86.469443000000268, 20.098055000000382],
                [86.469443000000268, 20.097777000000175],
                [86.46971900000014, 20.097499],
                [86.471390000000312, 20.097499],
                [86.471946, 20.098055000000382],
                [86.472221, 20.098051000000392],
                [86.473336000000103, 20.099168000000414],
                [86.472504000000228, 20.099721],
                [86.472221, 20.099446],
                [86.471390000000312, 20.099446],
                [86.471390000000312, 20.099719000000274],
                [86.471656000000209, 20.100000000000133],
                [86.471656000000209, 20.100280000000108],
                [86.471946, 20.100556000000321],
                [86.471946, 20.100829],
                [86.472221, 20.10110900000063],
                [86.472221, 20.101390000000489],
                [86.472504000000228, 20.101668000000469],
                [86.472504000000228, 20.101944000000451],
                [86.472221, 20.102219000000328],
                [86.472221, 20.102778000000395],
                [86.471665, 20.103332],
                [86.471390000000312, 20.103332],
                [86.471107000000103, 20.103621000000427],
                [86.470833, 20.103612000000336],
                [86.469833, 20.104610000000317],
                [86.46971900000014, 20.104722000000258],
                [86.469443000000268, 20.104444],
                [86.468614000000258, 20.104444],
                [86.468064, 20.105000000000469],
                [86.467499000000174, 20.105000000000469],
                [86.467216, 20.105280000000217],
                [86.467223, 20.105556000000202],
                [86.466943000000114, 20.10583400000041],
                [86.466943000000114, 20.106110000000164],
                [86.465553, 20.1075],
                [86.465553, 20.107778],
                [86.464997, 20.108334000000465],
                [86.464997, 20.10861000000045],
                [86.464707000000118, 20.108890000000198],
                [86.464707000000118, 20.11000000000012],
                [86.465279, 20.110556000000539],
                [86.464997, 20.11083],
                [86.464997, 20.11111],
                [86.464447, 20.111669000000571],
                [86.464447, 20.112501],
                [86.464165, 20.11277900000027],
                [86.464158, 20.113330000000126],
                [86.46389100000026, 20.113611],
                [86.46389100000026, 20.11472],
                [86.464997, 20.115833],
                [86.465279, 20.115830000000411],
                [86.466111000000211, 20.116667],
                [86.466111000000211, 20.117221000000423],
                [86.466943000000114, 20.118062000000233],
                [86.467782, 20.118055000000592],
                [86.468055, 20.118333000000117],
                [86.468887000000194, 20.118333000000117],
                [86.46917, 20.118611000000325],
                [86.46971900000014, 20.118602000000234],
                [86.470002, 20.1188910000003],
                [86.470275000000214, 20.1188910000003],
                [86.470558, 20.119172000000159],
                [86.470840000000109, 20.119172000000159],
                [86.474441000000283, 20.122779000000484],
                [86.475563000000122, 20.122779000000484],
                [86.475829, 20.122499000000509],
                [86.47667, 20.122499000000509],
                [86.476937, 20.122779000000484],
                [86.478058000000246, 20.122779000000484],
                [86.478332, 20.12306000000012],
                [86.47889, 20.12306000000012],
                [86.481393000000281, 20.125555000000297],
                [86.481393000000281, 20.125834000000388],
                [86.481666000000175, 20.12610900000049],
                [86.481666000000175, 20.13139],
                [86.481393000000281, 20.131666000000443],
                [86.481393000000281, 20.131944],
                [86.481110000000101, 20.13222200000018],
                [86.481110000000101, 20.1325],
                [86.480834000000272, 20.132778],
                [86.480834000000272, 20.133334000000325],
                [86.484727000000106, 20.137222],
                [86.48500100000021, 20.137222],
                [86.485183, 20.137407000000387],
                [86.485557000000284, 20.137781000000583],
                [86.485839000000254, 20.137781000000583],
                [86.486655, 20.13861],
                [86.486664000000175, 20.138888000000176],
                [86.48722, 20.139440000000373],
                [86.48722, 20.140279000000415],
                [86.48750300000016, 20.14055900000039],
                [86.487779, 20.14055900000039],
                [86.488328, 20.139997999999874],
                [86.488328, 20.139729000000436],
                [86.488877, 20.139169],
                [86.488877, 20.138330000000671],
                [86.489167, 20.138057000000341],
                [86.489167, 20.136671000000199],
                [86.489440000000158, 20.136390000000343],
                [86.489440000000158, 20.135561000000273],
                [86.489723000000353, 20.135281000000298],
                [86.489723000000353, 20.13472],
                [86.489440000000158, 20.134444000000254],
                [86.489440000000158, 20.13389],
                [86.489999000000168, 20.133330000000335],
                [86.490279000000143, 20.133334000000325],
                [86.490555000000242, 20.133612],
                [86.490837000000255, 20.133612],
                [86.491111, 20.133334000000325],
                [86.491111, 20.13305400000035],
                [86.490279000000143, 20.13222400000063],
                [86.489999000000168, 20.13222400000063],
                [86.488891000000109, 20.131112000000481],
                [86.488877, 20.130832000000506],
                [86.488052000000195, 20.130000000000333],
                [86.488052000000195, 20.129722000000125],
                [86.487779, 20.129444000000369],
                [86.487779, 20.12861],
                [86.48750300000016, 20.128329000000114],
                [86.48750300000016, 20.1275],
                [86.48722, 20.127219000000192],
                [86.48722, 20.126943000000434],
                [86.48750300000016, 20.126668000000333],
                [86.48750300000016, 20.125560000000402],
                [86.487779, 20.12528],
                [86.487779, 20.123331],
                [86.488052000000195, 20.123058000000352],
                [86.487779, 20.122779000000484],
                [86.487779, 20.122221000000305],
                [86.48750300000016, 20.121945000000316],
                [86.48750300000016, 20.121665000000572],
                [86.488335, 20.120833000000172],
                [86.488608000000269, 20.120831000000404],
                [86.489167, 20.121389000000129],
                [86.489167, 20.121945000000316],
                [86.489440000000158, 20.122221000000305],
                [86.489440000000158, 20.124999000000109],
                [86.489167, 20.12528],
                [86.489167, 20.125555000000297],
                [86.488877, 20.125829000000518],
                [86.488877, 20.126390000000352],
                [86.488608000000269, 20.126668000000333],
                [86.488608000000269, 20.126943000000434],
                [86.488328, 20.127219000000192],
                [86.488328, 20.1275],
                [86.488608000000269, 20.127791000000339],
                [86.488877, 20.127791000000339],
                [86.488891000000109, 20.128055999999784],
                [86.488608000000269, 20.128329000000114],
                [86.488608000000269, 20.12861],
                [86.488877, 20.128890000000407],
                [86.488891000000109, 20.129168],
                [86.490555000000242, 20.130832000000506],
                [86.491111, 20.130832000000506],
                [86.491669000000201, 20.13139],
                [86.491669000000201, 20.131666000000443],
                [86.491943, 20.131944],
                [86.491943, 20.13222400000063],
                [86.492225, 20.1325],
                [86.492225, 20.133334000000325],
                [86.491943, 20.133601000000223],
                [86.491943, 20.13389],
                [86.491669000000201, 20.134171000000602],
                [86.491669000000201, 20.134444000000254],
                [86.491386999999889, 20.13472],
                [86.491386999999889, 20.135000000000442],
                [86.491111, 20.135281000000298],
                [86.491111, 20.136110000000368],
                [86.491386999999889, 20.136390000000343],
                [86.491386999999889, 20.136666000000101],
                [86.491669000000201, 20.136944000000305],
                [86.491669000000201, 20.137220000000294],
                [86.491943, 20.1375],
                [86.491943, 20.138057000000341],
                [86.492232000000271, 20.138330000000671],
                [86.492225, 20.13916600000038],
                [86.492501000000104, 20.139440000000373],
                [86.492225, 20.139723],
                [86.492232000000271, 20.139997999999874],
                [86.491943, 20.140279000000415],
                [86.491943, 20.140557],
                [86.492225, 20.140833000000377],
                [86.492232000000271, 20.141111],
                [86.491943, 20.141391000000564],
                [86.491943, 20.141671000000539],
                [86.491111, 20.142501000000259],
                [86.489999000000168, 20.142501000000259],
                [86.489723000000353, 20.142221000000283],
                [86.488891000000109, 20.143055000000452],
                [86.489167, 20.143333000000432],
                [86.489440000000158, 20.143333000000432],
                [86.489723000000353, 20.143611000000188],
                [86.489999000000168, 20.143611000000188],
                [86.490279000000143, 20.14389100000016],
                [86.491943, 20.14389100000016],
                [86.492232000000271, 20.144171000000135],
                [86.492768000000169, 20.144171000000135],
                [86.495004000000193, 20.146391000000214],
                [86.495004000000193, 20.146667000000203],
                [86.495277000000129, 20.146941000000194],
                [86.495277000000129, 20.14750100000014],
                [86.495826000000164, 20.14806],
                [86.495826000000164, 20.148611000000525],
                [86.495553000000228, 20.148889],
                [86.495553000000228, 20.14972100000022],
                [86.495277000000129, 20.149999000000431],
                [86.495277000000129, 20.150277000000184],
                [86.495004000000193, 20.150555000000164],
                [86.495004000000193, 20.150833000000372],
                [86.494721000000283, 20.151111000000121],
                [86.494721000000283, 20.152219],
                [86.494445000000184, 20.152499],
                [86.494721000000283, 20.152780000000345],
                [86.494721000000283, 20.153329000000436],
                [86.495004000000193, 20.153609000000412],
                [86.495004000000193, 20.153890000000267],
                [86.496109, 20.155000000000197],
                [86.496665000000107, 20.155000000000197],
                [86.496948, 20.15528],
                [86.497497, 20.15528],
                [86.49778, 20.15556],
                [86.498046, 20.15556],
                [86.498612000000122, 20.156112000000341],
                [86.498885, 20.156112000000341],
                [86.499168000000196, 20.156392],
                [86.499443000000198, 20.156390000000325],
                [86.500000000000142, 20.156944000000518],
                [86.500275, 20.156944000000518],
                [86.501114, 20.157777999999777],
                [86.501388000000105, 20.157777999999777],
                [86.502219000000181, 20.158610000000177],
                [86.502219000000181, 20.15889],
                [86.502502, 20.159166000000365],
                [86.502502, 20.159444000000118],
                [86.502777999999893, 20.159720000000558],
                [86.502777999999893, 20.160280000000281],
                [86.503334000000265, 20.160834000000474],
                [86.503327000000226, 20.161110000000228],
                [86.503610000000137, 20.161388000000439],
                [86.503610000000137, 20.162220000000158],
                [86.503883, 20.1625],
                [86.503883, 20.163061000000422],
                [86.503327000000226, 20.163610000000286],
                [86.503890000000339, 20.164166000000247],
                [86.503883, 20.164440000000234],
                [86.505547000000178, 20.166109999999886],
                [86.505554000000174, 20.166388],
                [86.5075, 20.168333000000299],
                [86.507767, 20.168330000000189],
                [86.508606, 20.169171],
                [86.508888000000283, 20.169167000000467],
                [86.509444000000116, 20.16972099999975],
                [86.510010000000122, 20.169709],
                [86.510276, 20.170001000000408],
                [86.5105590000002, 20.170001000000408],
                [86.510825, 20.170281000000383],
                [86.511108, 20.170279000000612],
                [86.513045, 20.172221],
                [86.513045, 20.172501],
                [86.514167000000128, 20.173611000000388],
                [86.514167000000128, 20.173891000000364],
                [86.514442, 20.174169000000344],
                [86.515274, 20.174165000000354],
                [86.515557000000143, 20.174445000000329],
                [86.516113, 20.174445000000329],
                [86.516389000000103, 20.174723000000537],
                [86.516669, 20.174721],
                [86.516893, 20.174944],
                [86.517777000000123, 20.175840000000104],
                [86.518059, 20.175840000000104],
                [86.518326000000158, 20.176111],
                [86.518609, 20.176111],
                [86.518882000000232, 20.176389000000196],
                [86.519165, 20.176389000000196],
                [86.519356, 20.176576000000289],
                [86.519447000000113, 20.17667],
                [86.51972100000016, 20.176667000000176],
                [86.519997, 20.176945],
                [86.520279, 20.176940999999712],
                [86.520835000000119, 20.177499000000573],
                [86.521111, 20.177499000000573],
                [86.521394000000129, 20.177780000000208],
                [86.522223, 20.177777000000102],
                [86.522782000000106, 20.178333000000517],
                [86.523055, 20.178333000000517],
                [86.523614000000322, 20.178887000000479],
                [86.523887, 20.178880000000156],
                [86.524170000000112, 20.179170000000109],
                [86.524170000000112, 20.179446000000546],
                [86.524436, 20.179719000000198],
                [86.524446000000211, 20.179999000000176],
                [86.525275000000221, 20.180834],
                [86.525558000000132, 20.180834],
                [86.526948000000147, 20.182219000000256],
                [86.526948000000147, 20.182502000000333],
                [86.527497000000196, 20.183056000000526],
                [86.527497000000196, 20.183332000000288],
                [86.527778, 20.183612000000263],
                [86.527778, 20.183890000000471],
                [86.52861, 20.184722000000189],
                [86.52861, 20.185000000000169],
                [86.528892000000255, 20.185280000000141],
                [86.528892000000255, 20.18555600000013],
                [86.529168000000126, 20.185834000000334],
                [86.530280000000204, 20.185834000000334],
                [86.530556, 20.186112000000314],
                [86.530823000000154, 20.18611000000055],
                [86.531112000000164, 20.18639],
                [86.53167, 20.18639],
                [86.532220000000208, 20.186951000000359],
                [86.532502000000221, 20.186944],
                [86.532776, 20.18722200000024],
                [86.533058, 20.187220000000476],
                [86.533332000000129, 20.187500000000451],
                [86.533608, 20.187500000000451],
                [86.534157000000263, 20.188070000000376],
                [86.534722000000144, 20.188054000000413],
                [86.535005000000282, 20.188334000000388],
                [86.535005000000282, 20.188612],
                [86.535554, 20.188612],
                [86.53611000000015, 20.188054000000413],
                [86.536666000000224, 20.188054000000413],
                [86.53682800000017, 20.188218000000454],
                [86.536942, 20.188334000000388],
                [86.537225000000234, 20.188054000000413],
                [86.537940000000319, 20.188647000000397],
                [86.538811000000166, 20.189444000000314],
                [86.539025000000251, 20.189722000000295],
                [86.539321, 20.190411000000491],
                [86.540817, 20.191730000000685],
                [86.540596, 20.192200000000405],
                [86.539597000000171, 20.192261000000592],
                [86.539169, 20.193082000000224],
                [86.539390000000125, 20.193626000000446],
                [86.539597000000171, 20.193702],
                [86.53965700000019, 20.193832000000604],
                [86.539864000000179, 20.193829000000271],
                [86.540001000000217, 20.193889000000123],
                [86.540557, 20.193889000000123],
                [86.540833000000163, 20.19361],
                [86.54161, 20.193339000000144],
                [86.54168, 20.193305000000233],
                [86.542015, 20.193116000000366],
                [86.542503000000167, 20.193332000000275],
                [86.542779000000266, 20.19333],
                [86.543052, 20.19361],
                [86.543609000000146, 20.19361],
                [86.543891000000187, 20.19333],
                [86.544167, 20.19361],
                [86.544440000000222, 20.19361],
                [86.544723, 20.193889000000123],
                [86.544999000000232, 20.193889000000123],
                [86.545281, 20.19361],
                [86.546943, 20.19361],
                [86.54722600000018, 20.193889000000123],
                [86.547784, 20.193879000000145],
                [86.548057000000227, 20.194169],
                [86.548333, 20.194167000000331],
                [86.5486140000002, 20.194445000000311],
                [86.549163000000235, 20.194445000000311],
                [86.549445000000205, 20.194723000000518],
                [86.550004, 20.194723000000518],
                [86.551109, 20.195833000000441],
                [86.55139200000022, 20.195830000000107],
                [86.553046000000151, 20.197501000000322],
                [86.553056, 20.197779],
                [86.553612000000143, 20.198331000000277],
                [86.553612000000143, 20.198611000000248],
                [86.554726, 20.199723000000397],
                [86.55499300000011, 20.199721000000633],
                [86.555266, 20.20001],
                [86.555558, 20.20001],
                [86.55722, 20.201668999999807],
                [86.557778, 20.201668999999807],
                [86.558892000000114, 20.20056],
                [86.558892000000114, 20.200282000000239],
                [86.558061000000109, 20.199441],
                [86.557778, 20.199443000000421],
                [86.557502, 20.19916700000044],
                [86.55722, 20.199172000000541],
                [86.554444, 20.196391000000627],
                [86.554168000000217, 20.196391000000627],
                [86.553612000000143, 20.195830000000107],
                [86.553338, 20.195833000000441],
                [86.55278, 20.195279000000479],
                [86.552497, 20.195281000000243],
                [86.551109, 20.193879000000145],
                [86.550836000000146, 20.193889000000123],
                [86.550277000000136, 20.193332000000275],
                [86.550004, 20.193332000000275],
                [86.54991300000016, 20.193241000000395],
                [86.549721, 20.193057000000405],
                [86.549156, 20.193059000000169],
                [86.548889000000131, 20.192779000000193],
                [86.54860700000016, 20.192779000000193],
                [86.547784, 20.191940000000383],
                [86.547501000000153, 20.191944000000369],
                [86.546111, 20.190556000000463],
                [86.545831000000177, 20.190559000000118],
                [86.544716, 20.189440000000101],
                [86.543891000000187, 20.189444000000314],
                [86.542220999999898, 20.187778000000659],
                [86.541106, 20.187780000000426],
                [86.540557, 20.187220000000476],
                [86.540276000000219, 20.18722200000024],
                [86.539445000000143, 20.186388000000303],
                [86.539169, 20.18639],
                [86.538613000000211, 20.18583200000057],
                [86.53833, 20.185834000000334],
                [86.536942, 20.184444000000433],
                [86.536666000000224, 20.184444000000433],
                [86.534446, 20.182222000000589],
                [86.534164, 20.182222000000589],
                [86.533890000000198, 20.181944000000382],
                [86.533608, 20.181944000000382],
                [86.531388, 20.179721000000423],
                [86.531112000000164, 20.179721000000423],
                [86.527222000000265, 20.175833000000235],
                [86.526948000000147, 20.175840000000104],
                [86.52639, 20.17527900000027],
                [86.526107000000167, 20.17527900000027],
                [86.525558000000132, 20.174721],
                [86.525558000000132, 20.174445000000329],
                [86.522499000000238, 20.171389000000314],
                [86.522499000000238, 20.171111000000106],
                [86.520553000000106, 20.169167000000467],
                [86.520546, 20.168891],
                [86.519997, 20.168330000000189],
                [86.519997, 20.168057],
                [86.519172000000111, 20.167220000000267],
                [86.519165, 20.166945000000393],
                [86.518333000000197, 20.166109999999886],
                [86.518326000000158, 20.165830000000135],
                [86.518059, 20.165557000000486],
                [86.518059, 20.165279000000275],
                [86.517777000000123, 20.165000000000187],
                [86.517777000000123, 20.164720000000209],
                [86.516669, 20.163610000000286],
                [86.516669, 20.163330000000538],
                [86.515557000000143, 20.16222200000038],
                [86.515557000000143, 20.161946000000622],
                [86.515267, 20.161671],
                [86.515267, 20.161390000000207],
                [86.514999, 20.161110000000228],
                [86.514999, 20.160834000000474],
                [86.514442, 20.160280000000281],
                [86.514442, 20.160000000000306],
                [86.513893, 20.159442000000347],
                [86.513886000000284, 20.15889],
                [86.513611, 20.158612000000399],
                [86.513611, 20.158332000000424],
                [86.512496000000269, 20.157222],
                [86.512496000000269, 20.15666600000031],
                [86.512223, 20.156392],
                [86.512223, 20.156112000000341],
                [86.511391000000103, 20.15528],
                [86.511391000000103, 20.155000000000197],
                [86.511108, 20.154710000000243],
                [86.511108, 20.154444000000236],
                [86.509164000000141, 20.152499],
                [86.509164000000141, 20.151959000000712],
                [86.508888000000283, 20.15167],
                [86.508888000000283, 20.151389000000332],
                [86.508606, 20.151109000000357],
                [86.50861500000012, 20.150555000000164],
                [86.508332000000266, 20.150277000000184],
                [86.508332000000266, 20.14972100000022],
                [86.50805600000011, 20.149445000000465],
                [86.50805600000011, 20.149165],
                [86.507767, 20.148901000000475],
                [86.507767, 20.148611000000525],
                [86.507234000000139, 20.14806],
                [86.507234000000139, 20.147779000000352],
                [86.506668, 20.147221000000169],
                [86.506668, 20.146945000000184],
                [86.50638600000012, 20.146667000000203],
                [86.50638600000012, 20.146111000000239],
                [86.506112, 20.145831000000264],
                [86.506112, 20.145555],
                [86.505836000000187, 20.145281000000519],
                [86.505836000000187, 20.145001000000544],
                [86.505547000000178, 20.144720999999883],
                [86.505554000000174, 20.144167000000603],
                [86.504722, 20.143330000000329],
                [86.504448000000181, 20.143333000000432],
                [86.504166000000211, 20.143055000000452],
                [86.503883, 20.143062],
                [86.503610000000137, 20.142770000000379],
                [86.503610000000137, 20.142221000000283],
                [86.504166000000211, 20.141667000000322],
                [86.503610000000137, 20.141111],
                [86.502502, 20.141111],
                [86.502258000000126, 20.140869],
                [86.500831000000161, 20.139445000000471],
                [86.500558000000211, 20.139445000000471],
                [86.50048, 20.139369000000212],
                [86.500275, 20.13916600000038],
                [86.500000000000142, 20.139169],
                [86.499892, 20.139059000000312],
                [86.499726, 20.138888000000176],
                [86.499733, 20.13861],
                [86.500558000000211, 20.137776000000478],
                [86.499733, 20.136940000000319],
                [86.499726, 20.136387999999894],
                [86.499443000000198, 20.136110000000368],
                [86.499443000000198, 20.13583],
                [86.49778, 20.134166],
                [86.49778, 20.13389],
                [86.497497, 20.133601000000223],
                [86.497497, 20.13305400000035],
                [86.497224000000116, 20.132778],
                [86.497224000000116, 20.1325],
                [86.496948, 20.13222200000018],
                [86.496948, 20.13139],
                [86.496665000000107, 20.131112000000481],
                [86.496665000000107, 20.129722000000125],
                [86.496392000000213, 20.129444000000369],
                [86.496392000000213, 20.129168],
                [86.496665000000107, 20.128890000000407],
                [86.496665000000107, 20.12861],
                [86.496392000000213, 20.128329000000114],
                [86.496109, 20.128334000000674],
                [86.495833000000204, 20.128055999999784],
                [86.495826000000164, 20.127791000000339],
                [86.495277000000129, 20.127219000000192],
                [86.495277000000129, 20.126390000000352],
                [86.494721000000283, 20.125829000000518],
                [86.494721000000283, 20.125555000000297],
                [86.494156, 20.124999000000109],
                [86.494156, 20.12473],
                [86.493889000000109, 20.12445],
                [86.493889000000109, 20.123609000000211],
                [86.492775000000208, 20.122499000000509],
                [86.492501000000104, 20.122499000000509],
                [86.492232000000271, 20.122221000000305],
                [86.491943, 20.122223],
                [86.490837000000255, 20.121111000000379],
                [86.490837000000255, 20.120831000000404],
                [86.490555000000242, 20.120555000000191],
                [86.490279000000143, 20.12028200000054],
                [86.490279000000143, 20.120001],
                [86.489999000000168, 20.119721],
                [86.489723000000353, 20.119723000000473],
                [86.489440000000158, 20.119443],
                [86.489167, 20.119443],
                [86.488335, 20.118611000000325],
                [86.487779, 20.118611000000325],
                [86.487779, 20.117777000000384],
                [86.48722, 20.117221000000423],
                [86.486947, 20.117223000000191],
                [86.486762000000269, 20.117037999999862],
                [86.486389, 20.116667],
                [86.486389, 20.116391000000696],
                [86.486655, 20.116111],
                [86.486664000000175, 20.115833],
                [86.486389, 20.11555500000031],
                [86.486031000000111, 20.115222000000355],
                [86.4857480000002, 20.114750000000409],
                [86.485322000000153, 20.114210000000408],
                [86.48500100000021, 20.113889000000192],
                [86.48333, 20.11555500000031],
                [86.48333, 20.116111],
                [86.483886000000126, 20.116667],
                [86.483886000000126, 20.117221000000423],
                [86.484169, 20.117501000000399],
                [86.484169, 20.117777000000384],
                [86.484727000000106, 20.118331000000346],
                [86.484169, 20.1188910000003],
                [86.483886000000126, 20.1188910000003],
                [86.48333, 20.118331000000346],
                [86.48333, 20.118055000000592],
                [86.482781, 20.117501000000399],
                [86.482781, 20.117221000000423],
                [86.482498000000106, 20.116945000000211],
                [86.482498000000106, 20.116671],
                [86.481110000000101, 20.115281000000319],
                [86.481110000000101, 20.115001000000344],
                [86.480827, 20.11472],
                [86.480834000000272, 20.114167000000403],
                [86.481110000000101, 20.113889000000192],
                [86.481110000000101, 20.113611],
                [86.482215000000267, 20.112501],
                [86.483063000000286, 20.112501],
                [86.48333, 20.112220000000431],
                [86.48333, 20.111944],
                [86.483613, 20.111666000000238],
                [86.483613, 20.11111],
                [86.483886000000126, 20.11083],
                [86.483886000000126, 20.110275999999882],
                [86.48333, 20.109720000000145],
                [86.482781, 20.110281000000438],
                [86.482498000000106, 20.110281000000438],
                [86.481393000000281, 20.109171000000735],
                [86.481393000000281, 20.108890000000198],
                [86.479706, 20.10722],
                [86.479446, 20.10722],
                [86.479157000000242, 20.1075],
                [86.47889, 20.1075],
                [86.47889, 20.107781000000383],
                [86.479164000000281, 20.108054],
                [86.479164000000281, 20.108334000000465],
                [86.479446, 20.10861000000045],
                [86.479446, 20.108890000000198],
                [86.479722000000123, 20.109166000000183],
                [86.479722000000123, 20.109444000000391],
                [86.480002, 20.109720000000145],
                [86.480002, 20.11000000000012],
                [86.480278000000197, 20.110281000000438],
                [86.480552, 20.110281000000438],
                [86.480827, 20.110559000000187],
                [86.481393000000281, 20.110559000000187],
                [86.481942000000316, 20.11111],
                [86.481393000000281, 20.111666000000238],
                [86.480834000000272, 20.112223],
                [86.480552, 20.112223],
                [86.480002, 20.111666000000238],
                [86.479706, 20.111669000000571],
                [86.479157000000242, 20.11111],
                [86.478608000000222, 20.11111],
                [86.478332, 20.11083],
                [86.477776, 20.11083500000063],
                [86.477220000000202, 20.110275999999882],
                [86.477220000000202, 20.11000000000012],
                [86.476937, 20.109720000000145],
                [86.476944000000103, 20.109444000000391],
                [86.47667, 20.109166000000183],
                [86.47667, 20.1075],
                [86.476388000000256, 20.10722],
                [86.476388000000256, 20.106388000000376],
                [86.476112000000157, 20.106110000000164],
                [86.476112000000157, 20.10583400000041],
                [86.475829, 20.105556000000202],
                [86.475829, 20.105280000000217],
                [86.475280000000211, 20.104722000000258],
                [86.475280000000211, 20.104444],
                [86.474997, 20.104166000000301],
                [86.474997, 20.10389],
                [86.475563000000122, 20.103332],
                [86.475829, 20.103332],
                [86.476112000000157, 20.103056],
                [86.476388000000256, 20.103060000000138],
                [86.47667, 20.102780000000159],
                [86.47667, 20.102219000000328],
                [86.476388000000256, 20.101944000000451],
                [86.476388000000256, 20.101668000000469],
                [86.476112000000157, 20.101390000000489],
                [86.476112000000157, 20.10110900000063],
                [86.475829, 20.100829],
                [86.475829, 20.100556000000321],
                [86.474717, 20.099450000000157],
                [86.471656000000209, 20.096389000000269],
                [86.471390000000312, 20.096389000000269],
                [86.471390000000312, 20.096109000000293],
                [86.471107000000103, 20.095833000000308],
                [86.471107000000103, 20.095555000000324],
                [86.470558, 20.095001000000131],
                [86.470275000000214, 20.095001000000131],
                [86.470275000000214, 20.094721000000156],
                [86.462501000000245, 20.086945],
                [86.462501000000245, 20.086667000000258],
                [86.461389, 20.085559000000327],
                [86.46083, 20.085559000000327],
                [86.459998000000141, 20.084720000000285],
                [86.459725000000205, 20.084722000000735],
                [86.459167, 20.084166000000316],
                [86.458610000000107, 20.084169],
                [86.457779000000102, 20.083330000000608],
                [86.457779000000102, 20.08305600000039],
                [86.457496, 20.082781],
                [86.457496, 20.082491000000111],
                [86.456947000000156, 20.081944000000242],
                [86.456947000000156, 20.081112],
                [86.455003, 20.079166000000434],
                [86.454720000000208, 20.079171],
                [86.454437, 20.078890000000225],
                [86.454171000000173, 20.078890000000225],
                [86.453888, 20.07861000000025],
                [86.453888, 20.078056],
                [86.453332000000188, 20.077500000000324],
                [86.452217000000104, 20.077500000000324],
                [86.451668, 20.076942000000141],
                [86.451217000000142, 20.076670000000373],
                [86.450729, 20.076369000000106],
                [86.450219000000146, 20.07605500000022],
                [86.449708000000186, 20.075640000000242],
                [86.449387, 20.074961000000254],
                [86.449081000000248, 20.074330000000138],
                [86.448639, 20.073890000000343],
                [86.448197000000206, 20.07355],
                [86.447837, 20.07327],
                [86.447541, 20.072992000000109],
                [86.447281, 20.072707],
                [86.447005, 20.072428999999826],
                [86.446732000000154, 20.072153],
                [86.446426, 20.071818000000345],
                [86.44609100000018, 20.07144],
                [86.445649000000273, 20.071130000000263],
                [86.444398, 20.070624000000173],
                [86.443687, 20.069949000000172],
                [86.442887, 20.068671000000219],
                [86.442490000000291, 20.068379],
                [86.442071000000212, 20.068060000000283],
                [86.441642000000201, 20.067729],
                [86.441246, 20.067360000000232],
                [86.440826000000101, 20.066950000000357],
                [86.440407, 20.066530000000505],
                [86.439903000000157, 20.066102000000452],
                [86.439377000000249, 20.065658000000436],
                [86.438987000000154, 20.065081000000188],
                [86.438698000000144, 20.064431000000237],
                [86.438493000000207, 20.063850000000453],
                [86.438187000000184, 20.063390000000251],
                [86.437859000000202, 20.063011],
                [86.437547, 20.062560000000296],
                [86.437301, 20.061963000000329],
                [86.437079000000139, 20.061400000000727],
                [86.436783, 20.060968999999883],
                [86.436416000000165, 20.06067100000018],
                [86.436013000000216, 20.060495],
                [86.435593, 20.060329000000358],
                [86.435126, 20.060181],
                [86.43467, 20.059998000000174],
                [86.434121, 20.059850000000544],
                [86.433442, 20.059834000000134],
                [86.432731000000203, 20.059893999999755],
                [86.432243, 20.05978000000027],
                [86.431794000000167, 20.059552],
                [86.431297, 20.059192000000159],
                [86.430787000000109, 20.058790000000496],
                [86.430329000000128, 20.058273],
                [86.430000000000277, 20.057687000000438],
                [86.429734000000138, 20.057111000000528],
                [86.429513, 20.056564000000431],
                [86.429451000000228, 20.056024000000431],
                [86.429444000000203, 20.055520000000111],
                [86.429422000000258, 20.055071000000222],
                [86.429351, 20.054679000000529],
                [86.429191, 20.054383000000136],
                [86.428337, 20.05361200000015],
                [86.428054000000174, 20.05361200000015],
                [86.426942, 20.05472],
                [86.426942, 20.055],
                [86.425834, 20.056110000000441],
                [86.425552, 20.056110000000441],
                [86.42472, 20.056944000000382],
                [86.424446000000245, 20.056944000000382],
                [86.424164000000232, 20.057222000000131],
                [86.423890000000171, 20.057220000000367],
                [86.423607, 20.057500000000342],
                [86.421937, 20.057500000000342],
                [86.421668000000167, 20.057781],
                [86.419717, 20.057781],
                [86.419441000000219, 20.057500000000342],
                [86.418892000000184, 20.057500000000342],
                [86.418609, 20.057220000000367],
                [86.418053, 20.057222000000131],
                [86.4177770000001, 20.056944000000382],
                [86.417221, 20.056944000000382],
                [86.417085000000142, 20.056805000000391],
                [86.416946, 20.056666000000174],
                [86.416389, 20.056671000000275],
                [86.416107, 20.056391000000296],
                [86.415001000000117, 20.056391000000296],
                [86.414719, 20.056110000000441],
                [86.413887000000187, 20.056110000000441],
                [86.413620000000122, 20.05583],
                [86.411765, 20.05554],
                [86.411765, 20.055139000000278],
                [86.413117000000327, 20.055],
                [86.416107, 20.055],
                [86.416389, 20.055281000000374],
                [86.417221, 20.055276],
                [86.417335000000179, 20.055390000000209],
                [86.41750400000015, 20.055556],
                [86.41916500000012, 20.055556],
                [86.419441000000219, 20.055834],
                [86.420280000000204, 20.055834],
                [86.420556, 20.056110000000441],
                [86.421668000000167, 20.056110000000441],
                [86.421937, 20.056391000000296],
                [86.422500000000113, 20.056391000000296],
                [86.422792, 20.056110000000441],
                [86.423890000000171, 20.056110000000441],
                [86.425561, 20.054451000000647],
                [86.425561, 20.053330000000411],
                [86.425834, 20.053054000000426],
                [86.42611, 20.053054000000426],
                [86.426393000000232, 20.052778000000213],
                [86.426393000000232, 20.052511000000319],
                [86.427222, 20.05167],
                [86.426942, 20.05139],
                [86.426942, 20.050280000000381],
                [86.427222, 20.05000200000017],
                [86.427222, 20.049722000000195],
                [86.426942, 20.049444000000445],
                [86.426942, 20.048892000000247],
                [86.426393000000232, 20.048329000000191],
                [86.426393000000232, 20.047500000000124],
                [86.42611, 20.047219000000265],
                [86.425561, 20.047219000000265],
                [86.425278000000148, 20.047500000000124],
                [86.425278000000148, 20.04778],
                [86.425002000000319, 20.048056],
                [86.425002000000319, 20.048329000000191],
                [86.423890000000171, 20.049451000000314],
                [86.423607, 20.049451000000314],
                [86.423607, 20.04917],
                [86.421668000000167, 20.047219000000265],
                [86.421388000000249, 20.047222],
                [86.421112, 20.046944],
                [86.420563, 20.046939000000513],
                [86.419717, 20.04778],
                [86.41972400000013, 20.048056],
                [86.419441000000219, 20.048329000000191],
                [86.419441000000219, 20.04861],
                [86.41916500000012, 20.048892000000247],
                [86.418983, 20.048705000000151],
                [86.418609, 20.048334],
                [86.418609, 20.046112000000214],
                [86.41833600000011, 20.045834],
                [86.41833600000011, 20.045556000000481],
                [86.418053, 20.04528],
                [86.417183000000236, 20.044881000000483],
                [86.416604, 20.04447800000025],
                [86.41574000000017, 20.0434610000002],
                [86.415359000000237, 20.042244000000434],
                [86.415115, 20.041898000000398],
                [86.414888000000346, 20.041520999999872],
                [86.414719, 20.041111000000452],
                [86.414436000000237, 20.040831000000701],
                [86.414443000000276, 20.040555000000261],
                [86.414719, 20.040279000000279],
                [86.414719, 20.038331],
                [86.414443000000276, 20.038055000000664],
                [86.414436000000237, 20.037221],
                [86.414719, 20.036945000000284],
                [86.414719, 20.036671],
                [86.415001000000117, 20.036391],
                [86.415284000000256, 20.036391],
                [86.416107, 20.035549999999827],
                [86.416114000000135, 20.035001],
                [86.416389, 20.034721],
                [86.416389, 20.034167000000473],
                [86.416107, 20.033889000000269],
                [86.416107, 20.033059000000318],
                [86.415833000000291, 20.032779000000343],
                [86.415833000000291, 20.0322200000005],
                [86.415558, 20.031945000000398],
                [86.415833000000291, 20.031666000000307],
                [86.415833000000291, 20.031110000000123],
                [86.415001000000117, 20.030281],
                [86.413613, 20.031666000000307],
                [86.413613, 20.031945000000398],
                [86.413331000000113, 20.0322200000005],
                [86.413331000000113, 20.033889000000269],
                [86.413613, 20.034167000000473],
                [86.413613, 20.034445],
                [86.413055, 20.035001],
                [86.413055, 20.035555000000379],
                [86.412782, 20.035833000000135],
                [86.412782, 20.036111000000343],
                [86.412499000000167, 20.036391],
                [86.412499000000167, 20.036671],
                [86.412216, 20.036952000000607],
                [86.411667000000222, 20.036391],
                [86.411667000000222, 20.035549999999827],
                [86.411567, 20.034921000000164],
                [86.411530000000184, 20.034358000000108],
                [86.411606, 20.033809],
                [86.411583000000221, 20.033292000000298],
                [86.411437, 20.032770000000479],
                [86.411339000000268, 20.032218],
                [86.411147000000184, 20.031692000000241],
                [86.411018, 20.031179000000517],
                [86.410865, 20.030700000000703],
                [86.410783000000194, 20.030249000000364],
                [86.410653000000181, 20.02982],
                [86.41066000000022, 20.029385],
                [86.41077400000016, 20.028909000000336],
                [86.410783000000194, 20.028380000000194],
                [86.410689, 20.02779],
                [86.41059100000011, 20.027153999999879],
                [86.410546, 20.026447000000413],
                [86.410461, 20.025729000000407],
                [86.410195, 20.02513700000031],
                [86.409837, 20.024722000000335],
                [86.4095, 20.024360000000339],
                [86.409233000000228, 20.023990000000133],
                [86.409028, 20.023587000000131],
                [86.408882000000162, 20.023179000000479],
                [86.408729, 20.022792000000656],
                [86.408577, 20.022409000000373],
                [86.408410000000146, 20.02203],
                [86.40827100000034, 20.021588000000516],
                [86.408066, 20.021160000000233],
                [86.407829000000135, 20.020731000000293],
                [86.407501000000181, 20.020280000000181],
                [86.407501000000181, 20.020000000000202],
                [86.407218, 20.019719000000347],
                [86.407218, 20.018612],
                [86.407777, 20.018055],
                [86.407777, 20.017499],
                [86.408059, 20.017219000000292],
                [86.408059, 20.01694600000064],
                [86.408333000000127, 20.016667000000549],
                [86.4086080000001, 20.0166700000002],
                [86.409158000000303, 20.016109000000366],
                [86.409721000000147, 20.016111000000134],
                [86.410279, 20.015555000000401],
                [86.410279, 20.015280000000299],
                [86.410851000000136, 20.01472100000046],
                [86.41083500000029, 20.014445],
                [86.411391000000123, 20.013889],
                [86.411111000000147, 20.013611],
                [86.411111000000147, 20.013060000000216],
                [86.411391000000123, 20.012782],
                [86.411941, 20.012782],
                [86.412216, 20.013060000000216],
                [86.412499000000167, 20.012782],
                [86.412499000000167, 20.01250100000015],
                [86.412782, 20.012221000000174],
                [86.412782, 20.010833000000268],
                [86.412499000000167, 20.010555],
                [86.412499000000167, 20.010001],
                [86.412216, 20.009721000000123],
                [86.412223, 20.009167],
                [86.411941, 20.008611000000194],
                [86.411941, 20.008055],
                [86.411667000000222, 20.007779000000475],
                [86.411667000000222, 20.007501000000499],
                [86.411941, 20.007209],
                [86.411941, 20.006945],
                [86.411667000000222, 20.006667000000331],
                [86.411941, 20.00638900000035],
                [86.411941, 20.0055590000004],
                [86.411667000000222, 20.005279000000424],
                [86.411667000000222, 20.003610000000659],
                [86.411391000000123, 20.00333],
                [86.411391000000123, 20.002222],
                [86.411111000000147, 20.001944000000318],
                [86.411111000000147, 20.000000000000679],
                [86.409996, 19.999451000000128],
                [86.408333000000127, 19.997780000000372],
                [86.408333000000127, 19.997500000000397],
                [86.408059, 19.997222000000185],
                [86.408059, 19.995832],
                [86.407501000000181, 19.995278000000546],
                [86.407218, 19.995278000000546],
                [86.406386, 19.994444000000609],
                [86.406113000000218, 19.994444000000609],
                [86.40583, 19.994168000000169],
                [86.405564000000112, 19.994170000000391],
                [86.405372, 19.993983000000291],
                [86.405281, 19.99389],
                [86.404998000000134, 19.99389],
                [86.404426000000214, 19.993329000000127],
                [86.404166000000188, 19.993334000000228],
                [86.403610000000114, 19.992778000000268],
                [86.403344000000203, 19.99278],
                [86.401108000000164, 19.99055100000032],
                [86.400832, 19.990555000000537],
                [86.399171000000123, 19.988889000000196],
                [86.399171000000123, 19.988611000000216],
                [86.397500000000235, 19.986941000000339],
                [86.397500000000235, 19.986664999999896],
                [86.397217, 19.98667],
                [86.396942000000124, 19.986391000000364],
                [86.396668, 19.986391000000364],
                [86.396019000000123, 19.98574],
                [86.394722000000215, 19.984441000000281],
                [86.394448000000111, 19.984167],
                [86.394172000000239, 19.984172000000168],
                [86.393981, 19.983981999999735],
                [86.39389, 19.983891000000309],
                [86.393607000000131, 19.983891000000309],
                [86.393058, 19.983331000000359],
                [86.393058, 19.982779000000161],
                [86.392219000000111, 19.981952000000543],
                [86.39167, 19.981952000000543],
                [86.39167, 19.98167100000023],
                [86.390555000000276, 19.980561000000304],
                [86.390555000000276, 19.980290000000416],
                [86.389999000000202, 19.97972],
                [86.389999000000202, 19.978889000000205],
                [86.389717000000161, 19.978610000000113],
                [86.389701000000102, 19.978321000000275],
                [86.389167, 19.977779000000503],
                [86.389167, 19.977501000000299],
                [86.388894, 19.977229000000531],
                [86.388611000000182, 19.977229000000531],
                [86.388336000000194, 19.97694],
                [86.388053, 19.976944],
                [86.387497, 19.976388000000266],
                [86.387223000000148, 19.976391000000373],
                [86.386948000000217, 19.97611000000051],
                [86.386405000000295, 19.97611000000051],
                [86.383606000000199, 19.97611000000051],
                [86.383331, 19.976391000000373],
                [86.382232, 19.976391000000373],
                [86.381943000000192, 19.976671000000348],
                [86.381386000000219, 19.976671000000348],
                [86.380837000000199, 19.977229000000531],
                [86.380545000000239, 19.977229000000531],
                [86.380279, 19.977501000000299],
                [86.379723000000283, 19.977501000000299],
                [86.379173, 19.978059000000254],
                [86.37889100000011, 19.978059000000254],
                [86.378326000000229, 19.978610000000113],
                [86.378052000000125, 19.978610000000113],
                [86.377776000000253, 19.978889000000205],
                [86.377776000000253, 19.979445],
                [86.378052000000125, 19.97972],
                [86.378052000000125, 19.979998000000247],
                [86.378335, 19.980279000000102],
                [86.378335, 19.980833],
                [86.378608, 19.981111000000279],
                [86.378608, 19.981391000000254],
                [86.37889100000011, 19.981667],
                [86.37889100000011, 19.982221],
                [86.379173, 19.982501000000632],
                [86.379167000000209, 19.982779000000161],
                [86.379723000000283, 19.983333000000126],
                [86.379723000000283, 19.983613000000101],
                [86.380837000000199, 19.98472100000026],
                [86.380837000000199, 19.986111],
                [86.381111, 19.986391000000364],
                [86.380837000000199, 19.98667],
                [86.380837000000199, 19.98750100000029],
                [86.380545000000239, 19.987779],
                [86.380555000000228, 19.989165000000181],
                [86.380837000000199, 19.989441],
                [86.380837000000199, 19.989999000000122],
                [86.381386000000219, 19.990555000000537],
                [86.38166900000013, 19.990555000000537],
                [86.382836, 19.990833],
                [86.383331, 19.990833],
                [86.383606000000199, 19.991109],
                [86.383843000000113, 19.991157000000609],
                [86.385001000000187, 19.991390000000361],
                [86.385826, 19.991390000000361],
                [86.386109, 19.991670000000337],
                [86.386391, 19.991670000000337],
                [86.386681000000152, 19.991950000000312],
                [86.386948000000217, 19.991946000000777],
                [86.387223000000148, 19.992210000000338],
                [86.387223000000148, 19.9925],
                [86.386948000000217, 19.99278],
                [86.385810000000248, 19.9925],
                [86.384247000000158, 19.992299000000454],
                [86.382768, 19.9925],
                [86.382499, 19.993056000000472],
                [86.382430000000213, 19.995269000000459],
                [86.382232, 19.995560000000292],
                [86.38166900000013, 19.995560000000292],
                [86.381386000000219, 19.995269000000459],
                [86.381386000000219, 19.995000000000342],
                [86.381111, 19.994719],
                [86.381111, 19.993334000000228],
                [86.380555000000228, 19.992778000000268],
                [86.380545000000239, 19.9925],
                [86.379821, 19.991770000000312],
                [86.378952, 19.991159000000376],
                [86.378533, 19.990485000000259],
                [86.378387000000117, 19.988928000000211],
                [86.378533, 19.988051000000262],
                [86.37889100000011, 19.986900000000102],
                [86.37889100000011, 19.985001000000235],
                [86.378326000000229, 19.984441000000281],
                [86.378052000000125, 19.984443],
                [86.377776000000253, 19.984167],
                [86.377776000000253, 19.983891000000309],
                [86.377487, 19.983611000000334],
                [86.377503, 19.983333000000126],
                [86.376664000000105, 19.982501000000632],
                [86.376664000000105, 19.982221],
                [86.376115000000354, 19.981667],
                [86.376106000000249, 19.981391000000254],
                [86.375267000000335, 19.980561000000304],
                [86.37500000000027, 19.980561000000304],
                [86.374741000000128, 19.980290000000416],
                [86.374168, 19.980290000000416],
                [86.373847000000112, 19.979998000000247],
                [86.372498, 19.979998000000247],
                [86.372222000000221, 19.97972],
                [86.371666000000147, 19.97972],
                [86.371390000000275, 19.979998000000247],
                [86.370278000000127, 19.979998000000247],
                [86.370002, 19.980290000000416],
                [86.369157, 19.980290000000416],
                [86.369157, 19.979998000000247],
                [86.368888, 19.97972],
                [86.368614, 19.979723000000146],
                [86.368332, 19.979445],
                [86.367776000000205, 19.979445],
                [86.367500000000106, 19.979723000000146],
                [86.367233000000326, 19.97972],
                [86.366944, 19.979998000000247],
                [86.363609000000267, 19.979998000000247],
                [86.363327, 19.980290000000416],
                [86.362221, 19.980290000000416],
                [86.361945000000148, 19.980561000000304],
                [86.361656000000139, 19.980290000000416],
                [86.360557000000114, 19.980290000000416],
                [86.360284, 19.979998000000247],
                [86.359726000000109, 19.979998000000247],
                [86.359452, 19.980290000000416],
                [86.358887000000124, 19.980290000000416],
                [86.358611000000266, 19.980561000000304],
                [86.358331, 19.980557],
                [86.358055000000192, 19.980833],
                [86.355279000000195, 19.980833],
                [86.355003, 19.980557],
                [86.354447, 19.981111000000279],
                [86.353606, 19.981111000000279],
                [86.353317000000274, 19.981391000000254],
                [86.352569000000102, 19.981391000000254],
                [86.352218, 19.981391000000254],
                [86.351936, 19.98167100000023],
                [86.351669, 19.98167100000023],
                [86.351386, 19.981952000000543],
                [86.351113000000154, 19.98194500000022],
                [86.350570000000275, 19.982501000000632],
                [86.350554, 19.982779000000161],
                [86.349998, 19.983333000000126],
                [86.349998, 19.983600000000475],
                [86.349998, 19.984443],
                [86.3497160000001, 19.98472100000026],
                [86.3497160000001, 19.985001000000235],
                [86.349998, 19.985282000000549],
                [86.349998, 19.986111],
                [86.350281000000194, 19.986391000000364],
                [86.350281000000194, 19.986664999999896],
                [86.350121000000101, 19.986827000000172],
                [86.34972500000012, 19.987223000000764],
                [86.34944200000028, 19.986945000000556],
                [86.349166000000181, 19.986664999999896],
                [86.349166000000181, 19.986391000000364],
                [86.348893000000245, 19.986111],
                [86.348893000000245, 19.985831000000637],
                [86.348334000000236, 19.985277],
                [86.34834400000021, 19.98472100000026],
                [86.348610000000107, 19.984443],
                [86.348610000000107, 19.983889000000538],
                [86.348893000000245, 19.983611000000334],
                [86.348893000000245, 19.982779000000161],
                [86.34944200000028, 19.982221],
                [86.34944200000028, 19.981667],
                [86.349166000000181, 19.981391000000254],
                [86.348610000000107, 19.981952000000543],
                [86.348052000000195, 19.98194500000022],
                [86.347778000000162, 19.982221],
                [86.347512, 19.982221],
                [86.347222, 19.982501000000632],
                [86.347222, 19.982781],
                [86.345832, 19.984172000000168],
                [86.345558000000182, 19.984167],
                [86.345000000000113, 19.984723000000482],
                [86.344720000000137, 19.984723000000482],
                [86.344558, 19.984883000000305],
                [86.343329000000182, 19.986111],
                [86.343063, 19.986111],
                [86.342780000000161, 19.986391000000364],
                [86.342217, 19.986391000000364],
                [86.341271, 19.987469000000143],
                [86.340271000000229, 19.988889000000196],
                [86.339997000000125, 19.989165000000181],
                [86.339997000000125, 19.989445000000153],
                [86.339722000000151, 19.989719000000147],
                [86.339722000000151, 19.989999000000122],
                [86.339448000000104, 19.990277000000326],
                [86.339448000000104, 19.991109],
                [86.339471000000216, 19.99309900000048],
                [86.339615000000293, 19.994724000000357],
                [86.33996500000022, 19.995672000000688],
                [86.34018, 19.99682300000017],
                [86.340111, 19.997632000000291],
                [86.339943000000275, 19.998300000000423],
                [86.339156000000145, 20.000000000000679],
                [86.33889, 20.000360000000221],
                [86.338837, 20.000718000000685],
                [86.338662000000141, 20.00106],
                [86.338630000000236, 20.001450000000201],
                [86.338607, 20.001842000000572],
                [86.338607, 20.002186000000389],
                [86.338577, 20.002519000000344],
                [86.338441, 20.002831000000462],
                [86.338318, 20.003180000000153],
                [86.338126, 20.003540000000378],
                [86.337707000000236, 20.004868000000666],
                [86.337281000000161, 20.006081000000215],
                [86.336921000000288, 20.007770000000388],
                [86.336563000000169, 20.00898500000039],
                [86.336212, 20.010669000000227],
                [86.335282, 20.01250100000015],
                [86.334999000000138, 20.012782],
                [86.334999000000138, 20.013060000000216],
                [86.334443, 20.013611],
                [86.334443, 20.014445],
                [86.333894, 20.014999000000437],
                [86.333894, 20.015280000000299],
                [86.333611000000175, 20.015555000000401],
                [86.333611000000175, 20.015831000000155],
                [86.33277900000023, 20.0166700000002],
                [86.332412, 20.017037000000524],
                [86.332077, 20.01736],
                [86.331681000000145, 20.017682000000143],
                [86.331298000000103, 20.018024000000192],
                [86.330901, 20.018322000000349],
                [86.330482, 20.018571000000517],
                [86.330069000000137, 20.018819000000118],
                [86.329812, 20.019181000000113],
                [86.329568, 20.019580000000357],
                [86.329292, 20.01998800000046],
                [86.329003000000213, 20.02043],
                [86.328880000000225, 20.021021000000243],
                [86.328743000000188, 20.021602],
                [86.328492000000253, 20.022080000000411],
                [86.328324000000151, 20.02257],
                [86.328324000000151, 20.023122000000281],
                [86.328340000000239, 20.023701000000294],
                [86.32833, 20.024166000000601],
                [86.328612999999891, 20.024442000000359],
                [86.328612999999891, 20.025000000000539],
                [86.328889, 20.025278],
                [86.328889, 20.025834000000483],
                [86.328612999999891, 20.026110000000241],
                [86.328612999999891, 20.026951],
                [86.328538, 20.028170000000497],
                [86.328187000000113, 20.02952],
                [86.327401000000165, 20.030671000000208],
                [86.3264, 20.031808000000179],
                [86.32575300000012, 20.032751000000413],
                [86.324830000000119, 20.033699000000521],
                [86.324189000000146, 20.034370000000305],
                [86.322906000000245, 20.034691],
                [86.322425000000166, 20.035001],
                [86.321953000000107, 20.035249000000245],
                [86.321479, 20.035409],
                [86.321112000000127, 20.035696000000364],
                [86.320764, 20.036042],
                [86.320342000000252, 20.036371000000369],
                [86.319861000000159, 20.036665000000308],
                [86.319405000000216, 20.036929000000324],
                [86.318977000000103, 20.037152000000326],
                [86.318635, 20.037412000000355],
                [86.318382, 20.037724000000477],
                [86.318109000000149, 20.038009000000326],
                [86.317872000000222, 20.038322000000328],
                [86.317596000000123, 20.038602000000303],
                [86.31726100000013, 20.038859000000226],
                [86.316955000000107, 20.039172000000228],
                [86.316673000000137, 20.039550000000414],
                [86.316383000000243, 20.039931],
                [86.316003000000109, 20.040170000000213],
                [86.315567000000129, 20.040320000000516],
                [86.31517100000022, 20.040500000000517],
                [86.314751, 20.040612000000234],
                [86.314378000000247, 20.040790000000236],
                [86.31392, 20.040928999999771],
                [86.313439000000173, 20.041091],
                [86.312928000000142, 20.04124100000012],
                [86.312386000000146, 20.041376000000124],
                [86.311836000000184, 20.04151],
                [86.311362000000116, 20.041711000000301],
                [86.310959000000167, 20.041957000000362],
                [86.310592, 20.042221000000378],
                [86.310218000000347, 20.042481000000404],
                [86.309838000000212, 20.042650000000318],
                [86.309409, 20.042789000000532],
                [86.308983000000168, 20.042950000000243],
                [86.30857, 20.043115000000167],
                [86.30819700000022, 20.043320000000445],
                [86.30784600000014, 20.043541],
                [86.307495, 20.043728],
                [86.30716, 20.043903000000451],
                [86.306815000000114, 20.044081000000453],
                [86.306412000000165, 20.044211000000356],
                [86.306006000000295, 20.044357000000215],
                [86.305528000000137, 20.044473000000146],
                [86.305038000000238, 20.044680000000191],
                [86.304520000000181, 20.044911000000408],
                [86.304001, 20.045102],
                [86.303565, 20.04539600000043],
                [86.3031, 20.045619000000439],
                [86.302651000000125, 20.045850000000424],
                [86.302239, 20.046112000000214],
                [86.301833000000187, 20.046390000000425],
                [86.301453000000123, 20.0466700000004],
                [86.301086000000197, 20.047001000000584],
                [86.300812000000164, 20.047390000000174],
                [86.300536, 20.04778],
                [86.30027700000015, 20.048179000000342],
                [86.300026000000159, 20.048621000000363],
                [86.299857, 20.049106000000162],
                [86.299607000000137, 20.049514000000269],
                [86.299308000000138, 20.049754000000345],
                [86.299057, 20.049991000000311],
                [86.29884300000019, 20.050221000000413],
                [86.298615, 20.050556000000139],
                [86.296945, 20.052222000000249],
                [86.296669000000222, 20.052220000000485],
                [86.296113000000148, 20.052780000000435],
                [86.295648000000128, 20.053088000000567],
                [86.295288000000241, 20.053282000000305],
                [86.294839, 20.053368000000543],
                [86.294456, 20.053610000000386],
                [86.294091000000122, 20.053915000000181],
                [86.29374, 20.054339000000251],
                [86.293396, 20.05490000000054],
                [86.293052, 20.055399000000303],
                [86.292710000000142, 20.055894000000304],
                [86.292443000000134, 20.056391000000296],
                [86.292138000000293, 20.056778000000115],
                [86.291894, 20.057140000000114],
                [86.291648, 20.05743],
                [86.291472, 20.057678000000344],
                [86.291397000000174, 20.057979],
                [86.291381000000328, 20.058300000000138],
                [86.291336000000214, 20.058610000000723],
                [86.291228000000189, 20.058920000000391],
                [86.291130000000109, 20.059260000000219],
                [86.291062000000153, 20.059650000000143],
                [86.290994000000225, 20.06008],
                [86.290871000000195, 20.060431000000104],
                [86.290672000000114, 20.060721],
                [86.290467000000135, 20.060981],
                [86.290077, 20.061131],
                [86.28987, 20.060810000000398],
                [86.289788, 20.060349],
                [86.289834, 20.05991600000015],
                [86.289918, 20.059520000000244],
                [86.289909, 20.059203],
                [86.289818000000224, 20.058952],
                [86.289711, 20.058722],
                [86.289512000000215, 20.058597],
                [86.289223000000206, 20.058560000000167],
                [86.288803, 20.058544000000431],
                [86.288261000000247, 20.058522000000263],
                [86.287498000000127, 20.058610000000723],
                [86.287498000000127, 20.057500000000342],
                [86.28778000000014, 20.057220000000367],
                [86.289444000000259, 20.057222000000131],
                [86.291946000000209, 20.054722000000535],
                [86.291946000000209, 20.054166000000119],
                [86.292222, 20.053890000000361],
                [86.2916570000002, 20.053330000000411],
                [86.291390000000135, 20.053334000000401],
                [86.290832, 20.052778000000213],
                [86.291108, 20.052511000000319],
                [86.290558000000189, 20.051942000000274],
                [86.290276000000219, 20.051944],
                [86.29, 20.051666],
                [86.29, 20.05139],
                [86.289720000000145, 20.051112000000554],
                [86.28917, 20.051112000000554],
                [86.288612, 20.050561000000236],
                [86.288329000000175, 20.050561000000236],
                [86.288063, 20.050280000000381],
                [86.28778000000014, 20.050280000000381],
                [86.287689, 20.050186999999816],
                [86.287224, 20.049722000000195],
                [86.286110000000164, 20.049722000000195],
                [86.285843, 20.05000200000017],
                [86.285278, 20.05000200000017],
                [86.284995, 20.050280000000381],
                [86.284172, 20.050280000000381],
                [86.283334000000124, 20.051112000000554],
                [86.283334000000124, 20.051666],
                [86.283890000000198, 20.052220000000485],
                [86.283890000000198, 20.0525],
                [86.283058, 20.053334000000401],
                [86.282219, 20.053330000000411],
                [86.28167000000029, 20.053890000000361],
                [86.281387000000151, 20.053890000000361],
                [86.281098000000142, 20.054171000000217],
                [86.280831, 20.054171000000217],
                [86.280555000000206, 20.053888000000594],
                [86.278891, 20.055556],
                [86.278611000000112, 20.05555000000049],
                [86.276658, 20.057500000000342],
                [86.276665, 20.057779000000203],
                [86.276307000000187, 20.05930300000022],
                [86.27581, 20.060110000000574],
                [86.274452, 20.061601000000334],
                [86.273811000000109, 20.061799000000288],
                [86.271942000000223, 20.061952000000471],
                [86.270835, 20.061945000000147],
                [86.27055400000026, 20.062221],
                [86.269996000000148, 20.062221],
                [86.269723000000212, 20.062501000000335],
                [86.269447000000113, 20.062501000000335],
                [86.269157000000163, 20.06278100000031],
                [86.268059, 20.06278100000031],
                [86.267776000000239, 20.062501000000335],
                [86.267220000000165, 20.062501000000335],
                [86.266937, 20.06278100000031],
                [86.26609900000021, 20.06278100000031],
                [86.265832000000145, 20.062501000000335],
                [86.264442, 20.062501000000335],
                [86.264168, 20.062221],
                [86.263610000000185, 20.062221],
                [86.263336, 20.061945000000147],
                [86.262498, 20.061952000000471],
                [86.262222000000151, 20.061671],
                [86.261948, 20.061671],
                [86.261673000000116, 20.061391],
                [86.261390000000205, 20.061391],
                [86.261107, 20.061111000000203],
                [86.260772, 20.061133000000378],
                [86.26043, 20.060962000000696],
                [86.260064000000256, 20.060637000000263],
                [86.259599, 20.060311000000176],
                [86.259056, 20.059998000000174],
                [86.258507, 20.05972],
                [86.257974, 20.059440000000446],
                [86.257470000000168, 20.059169000000104],
                [86.256996, 20.05893000000037],
                [86.256492000000136, 20.058800000000467],
                [86.256027000000117, 20.058599000000182],
                [86.255624000000154, 20.058376000000404],
                [86.255286, 20.058111000000277],
                [86.254997000000216, 20.05784000000039],
                [86.254692, 20.057610000000288],
                [86.254357000000127, 20.057412000000337],
                [86.253999000000235, 20.057199999999735],
                [86.253586, 20.056985000000161],
                [86.253099000000105, 20.056830000000215],
                [86.252595, 20.05665700000031],
                [86.252114000000333, 20.05647],
                [86.25161, 20.05634],
                [86.251214000000147, 20.056119],
                [86.250831000000147, 20.055926],
                [86.250473, 20.055741000000122],
                [86.250168000000173, 20.055536],
                [86.24989400000014, 20.055281000000374],
                [86.249618, 20.055],
                [86.24932200000022, 20.054715000000211],
                [86.249001000000277, 20.054399000000554],
                [86.248702000000293, 20.053988000000111],
                [86.248299, 20.053592000000204],
                [86.247856, 20.053188],
                [86.247521, 20.052641000000445],
                [86.247268, 20.052072000000404],
                [86.24717, 20.051511000000115],
                [86.246986, 20.05101900000022],
                [86.246879000000192, 20.050469000000241],
                [86.246772000000291, 20.049861000000185],
                [86.246895000000265, 20.049289],
                [86.246856, 20.04873],
                [86.246696000000142, 20.048231000000435],
                [86.246667000000144, 20.047730000000453],
                [86.24669, 20.047251000000639],
                [86.246758, 20.046798],
                [86.24669, 20.04636],
                [86.246667000000144, 20.045900000000298],
                [86.246667000000144, 20.045446000000304],
                [86.246644, 20.044999000000185],
                [86.246505000000226, 20.044569000000362],
                [86.24636800000016, 20.044099],
                [86.246323000000118, 20.04360000000019],
                [86.246231000000122, 20.043188],
                [86.246108000000135, 20.042841000000632],
                [86.245988000000111, 20.042540000000365],
                [86.245858, 20.042290000000317],
                [86.245826000000164, 20.042000000000364],
                [86.245803, 20.041731000000251],
                [86.245682, 20.04151],
                [86.245552, 20.041389000000205],
                [86.245552, 20.040831000000701],
                [86.24500300000031, 20.040277000000511],
                [86.244719999999887, 20.040279000000279],
                [86.244447000000235, 20.040001],
                [86.243889000000124, 20.040001],
                [86.243332000000152, 20.039441000000348],
                [86.243057000000178, 20.039443000000116],
                [86.242774, 20.039167000000131],
                [86.242501000000104, 20.039172000000228],
                [86.241928, 20.038611000000397],
                [86.240837, 20.038611000000397],
                [86.240547, 20.038331],
                [86.240281000000195, 20.03833300000019],
                [86.239166000000111, 20.037223000000491],
                [86.239166000000111, 20.036945000000284],
                [86.239722000000185, 20.036391],
                [86.240281000000195, 20.036391],
                [86.241113, 20.035549999999827],
                [86.241386, 20.035555000000379],
                [86.241944000000132, 20.035001],
                [86.242501000000104, 20.035001],
                [86.242767, 20.034721],
                [86.243332000000152, 20.034721],
                [86.243332000000152, 20.034445],
                [86.243615, 20.034167000000473],
                [86.243606000000213, 20.033608000000406],
                [86.243057000000178, 20.03305700000055],
                [86.243057000000178, 20.032779000000343],
                [86.242501000000104, 20.0322200000005],
                [86.242501000000104, 20.031945000000398],
                [86.242225000000232, 20.031666000000307],
                [86.242218000000236, 20.031379000000239],
                [86.241928, 20.031081],
                [86.228753000000125, 20.035049000000523],
                [86.225373, 20.034322000000426],
                [86.222870000000214, 20.03045200000042],
                [86.220849000000129, 20.030331000000384],
                [86.220124, 20.030290000000143],
                [86.212776000000176, 20.032941000000157],
                [86.210878, 20.034721],
                [86.209266, 20.035311000000316],
                [86.208047000000292, 20.035747999999778],
                [86.204277000000147, 20.031860000000275],
                [86.202019000000163, 20.034281000000188],
                [86.202392, 20.036820000000258],
                [86.204742000000167, 20.037861000000245],
                [86.200751000000238, 20.041070000000211],
                [86.200111, 20.044600999999826],
                [86.194511, 20.045722],
                [86.193497000000306, 20.0440010000002],
                [86.190728, 20.043721000000229],
                [86.183938, 20.045651],
                [86.165299000000147, 20.065892000000755],
                [86.165147000000204, 20.069240000000256],
                [86.162697000000136, 20.076230000000116],
                [86.157418000000277, 20.081151],
                [86.153320000000221, 20.083391000000116],
                [86.151916, 20.086309000000476],
                [86.156905000000251, 20.097709000000343],
                [86.161537, 20.104220000000389],
                [86.159638000000243, 20.110171000000484],
                [86.156067000000206, 20.113761000000519],
                [86.153541000000288, 20.118021],
                [86.154975000000249, 20.122531000000205],
                [86.15496800000021, 20.127219000000192],
                [86.1530920000001, 20.129451000000238],
                [86.141296, 20.138442000000389],
                [86.141578000000138, 20.14195200000017],
                [86.147233000000185, 20.15407],
                [86.141633000000155, 20.155310000000551],
                [86.142472, 20.15884900000037],
                [86.139832, 20.160410000000407],
                [86.147301000000112, 20.169919000000387],
                [86.148163000000224, 20.17453],
                [86.147141000000232, 20.18198],
                [86.145371000000111, 20.184271000000304],
                [86.142663000000283, 20.186060000000221],
                [86.137437000000233, 20.187509000000539],
                [86.136726000000209, 20.189832000000472],
                [86.139443000000128, 20.192542000000223],
                [86.146079000000128, 20.195792000000207],
                [86.150193, 20.203661000000235],
                [86.147538000000324, 20.210451000000372],
                [86.145927000000185, 20.214599],
                [86.134376, 20.213359],
                [86.123947000000257, 20.214749000000431],
                [86.121262000000328, 20.21861000000035],
                [86.095398, 20.228370000000261],
                [86.089386, 20.234332000000219],
                [86.080857000000123, 20.235850000000248],
                [86.073724000000126, 20.238202000000225],
                [86.072112000000104, 20.241160000000484],
                [86.070929, 20.243339000000329],
                [86.069398000000177, 20.252150000000253],
                [86.066674, 20.25955],
                [86.063896000000213, 20.264271000000232],
                [86.059434000000167, 20.26617100000021],
                [86.053597000000167, 20.265490000000451],
                [86.049813000000299, 20.267878000000106],
                [86.04728800000025, 20.267361000000161],
                [86.045326000000259, 20.26978100000019],
                [86.042586, 20.276990000000293],
                [86.042007000000112, 20.276901],
                [86.041351000000176, 20.276789999999885],
                [86.039017, 20.280771000000406],
                [86.037018000000202, 20.286132000000404],
                [86.027154, 20.289592000000308],
                [86.025146000000106, 20.29280099999982],
                [86.027291, 20.29754100000013],
                [86.028946000000118, 20.304319],
                [86.02552, 20.31808100000034],
                [86.025162000000179, 20.32536],
                [86.03025100000022, 20.332861000000541],
                [86.02844200000014, 20.33568000000059],
                [86.02127200000028, 20.342301000000127],
                [86.01471453334527, 20.355363803596216],
                [86.006338830604975, 20.363549149456045],
                [86.011859180138543, 20.376874131089149],
                [86.015285603986712, 20.380110198056851],
                [86.018521670954769, 20.383536621905019],
                [86.021757737922456, 20.389056971438542],
                [86.022899879205383, 20.383346265024553],
                [86.026135946173355, 20.382013766861739],
                [86.030514154424253, 20.38296555126362],
                [86.036795931479546, 20.380871625578262],
                [86.044981277339588, 20.376303060447068],
                [86.056593047047926, 20.370401997153063],
                [86.063636251625368, 20.367165930184907],
                [86.065920534190909, 20.366214145783026],
                [86.066110891071432, 20.362787721934179],
                [86.068966244278414, 20.358599870564142],
                [86.07258302500712, 20.358409513683448],
                [86.075248021333636, 20.357267372400649],
                [86.078864802062341, 20.354031305432951],
                [86.082503250102249, 20.350141929942076],
                [86.098956405580026, 20.345754421814714],
                [86.132863724913165, 20.345159556562972],
                [86.140054793491274, 20.346793890331121],
                [86.143202148917311, 20.347509198382337],
                [86.145950760445345, 20.348133882820544],
                [86.150129212617784, 20.358550151726142],
                [86.151033788513516, 20.363223793855692],
                [86.154953617396274, 20.364279132400721],
                [86.15932573422667, 20.36563599624446],
                [86.162190224563943, 20.367143622738233],
                [86.169426831731627, 20.366842097439299],
                [86.174854287107777, 20.367143622738233],
                [86.182241656924631, 20.366239046841876],
                [86.184201571366117, 20.363525319154174],
                [86.185128292896238, 20.361964524997799],
                [86.187066061703405, 20.358700914375955],
                [86.189779789391238, 20.355987186687567],
                [86.194151906221848, 20.355836424038213],
                [86.196577999999846, 20.35601000000042],
                [86.201339000000232, 20.356190000000193],
                [86.203559000000425, 20.355990000000471],
                [86.207411033630976, 20.355651359681129],
                [86.219655676577119, 20.354574907554245],
                [86.223579000000186, 20.354230000000591],
                [86.231016491403622, 20.352892804831978],
                [86.2464085002171, 20.35640184761905],
                [86.253597640657375, 20.358575602324432],
                [86.262026660445741, 20.361124254917055],
                [86.263594984652158, 20.361598463503011],
                [86.264366430301479, 20.361882680321511],
                [86.264499174975455, 20.361931586254055],
                [86.270877905897095, 20.36428164501444],
                [86.273132928917818, 20.368025053014428],
                [86.275545131307211, 20.369080391559233],
                [86.276751232501894, 20.367874290364622],
                [86.276802035814725, 20.367032756469591],
                [86.280502635339957, 20.368833198430362],
                [86.279972077493412, 20.366506906334276],
                [86.278778554204436, 20.361273765758821],
                [86.276600469852426, 20.359130056703858],
                [86.275243606008516, 20.356717854314407],
                [86.274791318060679, 20.354757939873245],
                [86.276921107473001, 20.35312957624387],
                [86.279446987123137, 20.352655482977745],
                [86.282075097787398, 20.353380948909258],
                [86.283384789072201, 20.355059465172186],
                [86.286098516760305, 20.356265566366343],
                [86.28835995650023, 20.357622430210078],
                [86.291676734785341, 20.357622430210078],
                [86.29416061022259, 20.356717044173813],
                [86.295503602333824, 20.356227516282384],
                [86.296764640464545, 20.355580830061623],
                [86.300687063273273, 20.353569331185319],
                [86.302075907964863, 20.352857103138145],
                [86.303515564357028, 20.35211881780878],
                [86.305177000000285, 20.350700000000185],
                [86.308863676809025, 20.349481247146734],
                [86.309314366113298, 20.350733161880949],
                [86.310220540652935, 20.353250313380155],
                [86.311275879198135, 20.355210227820859],
                [86.31353731893806, 20.354305651924953],
                [86.314441894834061, 20.354456414574312],
                [86.315462639440952, 20.351847845023705],
                [86.315798758677985, 20.350988873639832],
                [86.317457147820832, 20.348275145952123],
                [86.320472400807304, 20.348124383302771],
                [86.326502906780533, 20.350687348341577],
                [86.328161295923138, 20.354004126626702],
                [86.327859770624443, 20.35596404106786],
                [86.328035841849029, 20.358051139567575],
                [86.329192951949139, 20.358903747009887],
                [86.32861358387099, 20.361391496443499],
                [86.328915109169685, 20.362899122937044],
                [86.331025786260383, 20.363954461482074],
                [86.333380684331118, 20.364396004870738],
                [86.335850191038944, 20.36485903737843],
                [86.339363372707098, 20.365582339486075],
                [86.339921317746345, 20.365324826391085],
                [86.341841542899857, 20.362065207768406],
                [86.3429103632091, 20.360250865019449],
                [86.344164048273669, 20.358122710840686],
                [86.347760440335932, 20.354908702522376],
                [86.34942953123651, 20.351779157083907],
                [86.350172642725312, 20.350385823042412],
                [86.352283319815768, 20.347370570055766],
                [86.352735607763904, 20.345561418264193],
                [86.354846284854361, 20.345109130316125],
                [86.358163063139756, 20.345561418264193],
                [86.361027553477044, 20.34691828210816],
                [86.361781366723605, 20.350385823042412],
                [86.36298746791833, 20.352194974834671],
                [86.367208822099457, 20.350988873639832],
                [86.369168736540729, 20.350988873639832],
                [86.370525600384653, 20.353702601327761],
                [86.371430176280654, 20.354154889275829],
                [86.374445429267425, 20.352948788081218],
                [86.37806373285126, 20.351290398938314],
                [86.380626697889838, 20.352194974834671],
                [86.38258661233111, 20.350235060393285],
                [86.386807966512237, 20.348576671250378],
                [86.392084659238705, 20.34978277244522],
                [86.393290760433374, 20.352798025431863],
                [86.393139997784175, 20.357170142262472],
                [86.393441523082828, 20.359280819352986],
                [86.397210589315847, 20.360637683196948],
                [86.399924317003951, 20.358979294054731],
                [86.402336519393359, 20.356416329015921],
                [86.403542620587785, 20.354004126626702],
                [86.405653297678484, 20.353401076029282],
                [86.41013300000013, 20.355012000000436],
                [86.410218106352531, 20.354555441687122],
                [86.41120795321919, 20.349245346683116],
                [86.411606, 20.34711000000015],
                [86.415860087540324, 20.343823439786089],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Jajapur",
          Dist_Code: "382",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [86.077421284965666, 20.594665701428536],
              [86.077294842786316, 20.592641867714402],
              [86.077231000009903, 20.591619999985308],
              [86.075399720218087, 20.591128295604612],
              [86.074218000000229, 20.590811],
              [86.073596231521194, 20.591132075050719],
              [86.069398000000177, 20.593300000000333],
              [86.061318000000298, 20.587650000000387],
              [86.058245205977855, 20.586415163553792],
              [86.054262041468334, 20.584814484603665],
              [86.049838201222229, 20.577852170233651],
              [86.043056737355684, 20.568572272310686],
              [86.038416788394429, 20.571070706366974],
              [86.035204516036501, 20.581064442591295],
              [86.029850728773383, 20.58677514900517],
              [86.00950633717369, 20.603550349096615],
              [85.983451239159862, 20.631746962015988],
              [85.978097451896744, 20.634602315222814],
              [85.975876000000184, 20.657962000000449],
              [85.972024000000289, 20.660311000000142],
              [85.966477000000154, 20.660991000000244],
              [85.96279100000018, 20.65977100000077],
              [85.961296000000331, 20.660441000000215],
              [85.952399273033777, 20.666011200499835],
              [85.941334779356609, 20.669937311158996],
              [85.930270285679612, 20.679217209081962],
              [85.921704226058509, 20.682429481439605],
              [85.906342000000151, 20.691490000000435],
              [85.904610000000204, 20.694861000000284],
              [85.901786000000101, 20.697719000000344],
              [85.901412000000263, 20.700951],
              [85.902932000000291, 20.705921000000384],
              [85.904929025967448, 20.709198417755541],
              [85.910996651532102, 20.709912256057063],
              [85.918266000000514, 20.706979],
              [85.935013000000225, 20.711631000000345],
              [85.941292, 20.712100000000241],
              [85.950539, 20.714719],
              [85.955696000000259, 20.714160000000671],
              [85.960984, 20.721032000000147],
              [85.964836000000261, 20.723721],
              [85.974969000000243, 20.727872000000669],
              [85.979974000000297, 20.728811000000174],
              [85.984336000000255, 20.726901000000279],
              [85.988846000000393, 20.723831000000242],
              [85.993881000000258, 20.72392],
              [85.999077, 20.719899000000165],
              [86.004021000000236, 20.717502000000472],
              [86.007895000000332, 20.718051000000568],
              [86.01339700000031, 20.721871000000299],
              [86.020401000000192, 20.719690000000465],
              [86.021568, 20.726821000000761],
              [86.023927, 20.727742000000539],
              [86.02654300000016, 20.733159],
              [86.026092000000332, 20.73473000000018],
              [86.02160700000033, 20.737262000000435],
              [86.020892326017744, 20.744287733288555],
              [86.020538000000144, 20.747771],
              [86.023069264906823, 20.754527149916377],
              [86.023069264906823, 20.758810179726705],
              [86.018072396794452, 20.763450128688241],
              [86.018429315945554, 20.769874673403869],
              [86.024637371269066, 20.783225870142811],
              [86.026554708969044, 20.786543950355334],
              [86.027466000000501, 20.788121000000494],
              [86.027715847990962, 20.792829849758444],
              [86.027764016153952, 20.793737668320141],
              [86.02823, 20.802520000000126],
              [86.015198000000254, 20.802420000000772],
              [86.010788000000247, 20.807031000000332],
              [85.994011000000327, 20.812070000000343],
              [85.974517000000134, 20.812549000000214],
              [85.97104, 20.815270000000449],
              [85.965102000000101, 20.816890000000395],
              [85.96550800000027, 20.824781000000307],
              [85.96209600000023, 20.827550000000425],
              [85.953584, 20.831092000000577],
              [85.949128000000172, 20.827990000000224],
              [85.937958000000179, 20.833031000000457],
              [85.919745000000304, 20.83266000000031],
              [85.910522000000341, 20.83627000000018],
              [85.895782, 20.8404500000002],
              [85.89404300000021, 20.850111000000535],
              [85.900101000000163, 20.858022000000169],
              [85.90508400000013, 20.874051000000346],
              [85.916472, 20.892049000000551],
              [85.914337000000302, 20.914150000000117],
              [85.914405000000244, 20.921311000000394],
              [85.903267000000284, 20.92307100000016],
              [85.891509000000312, 20.923741000000511],
              [85.864296000000238, 20.921391000000423],
              [85.856246000000155, 20.92285],
              [85.849532000000266, 20.924910000000462],
              [85.837302000000349, 20.926090000000382],
              [85.83544200000027, 20.922471000000424],
              [85.828322000000213, 20.919979999999665],
              [85.822137, 20.920142000000446],
              [85.817519000000217, 20.927041000000195],
              [85.819108, 20.933901],
              [85.815087000000261, 20.940112000000223],
              [85.808578000000281, 20.944761000000479],
              [85.805428000000262, 20.950331],
              [85.798737000000173, 20.956661000000448],
              [85.798156000000219, 20.960531000000397],
              [85.789543000000236, 20.964870000000239],
              [85.78521, 20.963689000000212],
              [85.781213000000236, 20.964350000000191],
              [85.774781000000274, 20.971081000000421],
              [85.77378, 20.975771000000346],
              [85.7584760000003, 20.983089],
              [85.752213, 20.98491000000012],
              [85.736922000000192, 20.986050000000485],
              [85.732804000000201, 20.985100000000383],
              [85.718598000000199, 20.977401000000892],
              [85.717727, 20.983181],
              [85.714988, 20.988042000000284],
              [85.718117, 20.995080000000137],
              [85.719391, 21.003271000000375],
              [85.723297000000159, 21.008561000000547],
              [85.724715, 21.017600000000236],
              [85.728950000000154, 21.024770000000498],
              [85.728348, 21.033139000000169],
              [85.723876000000118, 21.046609000000213],
              [85.724708000000405, 21.057371000000209],
              [85.721688, 21.06115],
              [85.718696000000349, 21.061799000000285],
              [85.711517000000342, 21.060961000000244],
              [85.709235, 21.062032],
              [85.702667000000289, 21.067609000000679],
              [85.700157, 21.068331000000168],
              [85.698548, 21.072001000000451],
              [85.695481000000285, 21.074401000000414],
              [85.6943270000002, 21.078319],
              [85.690437, 21.081961000000142],
              [85.681076000000161, 21.100390000000115],
              [85.679169000000272, 21.112280000000165],
              [85.680108000000345, 21.114482000000287],
              [85.683898, 21.118110000000449],
              [85.68242600000012, 21.125089000000397],
              [85.694785000000238, 21.133519000000316],
              [85.702079000000126, 21.135762],
              [85.709443000000164, 21.134992000000519],
              [85.722687000000334, 21.137770000000327],
              [85.730896, 21.133070000000309],
              [85.735603000000353, 21.133011000000405],
              [85.74234000000034, 21.138280000000403],
              [85.746032000000284, 21.14236000000016],
              [85.752151000000282, 21.143360000000307],
              [85.758050000000225, 21.140591000000139],
              [85.760085000000203, 21.13748000000032],
              [85.761268000000243, 21.125419000000701],
              [85.763442000000154, 21.122151000000482],
              [85.764076, 21.119730000000338],
              [85.763383000000232, 21.116211000000355],
              [85.764069000000333, 21.110671],
              [85.76892800000023, 21.106621000000185],
              [85.768853000000249, 21.100549000000338],
              [85.769997, 21.098199],
              [85.773887, 21.098521000000229],
              [85.776107000000181, 21.096009000000205],
              [85.778314000000179, 21.094931000000539],
              [85.782081000000105, 21.094970000000551],
              [85.787528000000322, 21.098441000000317],
              [85.792182000000295, 21.097789000000599],
              [85.803436000000119, 21.098851000000533],
              [85.809884000000324, 21.088860000000402],
              [85.817161000000254, 21.084960000000475],
              [85.82405100000031, 21.084691000000586],
              [85.830307000000147, 21.086731000000267],
              [85.833444000000142, 21.090350000000221],
              [85.838088000000184, 21.089252000000325],
              [85.844162, 21.089499999999866],
              [85.853835000000331, 21.085889999999775],
              [85.858933000000235, 21.083080000000503],
              [85.870650000000339, 21.080001000000486],
              [85.876800000000273, 21.081430000000235],
              [85.881944000000118, 21.080390000000527],
              [85.898558, 21.084370000000312],
              [85.904662000000229, 21.084210000000205],
              [85.91317, 21.088351000000213],
              [85.91645, 21.091832000000117],
              [85.917396, 21.096410000000159],
              [85.926209000000128, 21.115781000000478],
              [85.926248000000299, 21.125761],
              [85.927620000000317, 21.129],
              [85.929299000000341, 21.130431],
              [85.931549000000345, 21.130451000000502],
              [85.935471000000163, 21.128022000000609],
              [85.934747000000115, 21.123001000000492],
              [85.937402000000219, 21.122281000000211],
              [85.9393460000001, 21.126399000000443],
              [85.940918000000153, 21.127801000000428],
              [85.943236000000113, 21.123461000000184],
              [85.954696000000268, 21.123461000000184],
              [85.956672000000168, 21.128049000000143],
              [85.958748000000327, 21.126791000000189],
              [85.960282000000277, 21.127420000000537],
              [85.958192000000324, 21.132081000000536],
              [85.959664, 21.133460000000237],
              [85.961296000000331, 21.133200000000212],
              [85.963028000000108, 21.131240000000215],
              [85.96713300000026, 21.131951000000239],
              [85.970107000000127, 21.134068000000294],
              [85.973250000000107, 21.138381000000262],
              [85.978408000000201, 21.133551000000292],
              [85.981307000000285, 21.132400000000299],
              [85.983696, 21.13330900000016],
              [85.988694, 21.131322000000235],
              [85.989617, 21.135839],
              [85.994309000000314, 21.135550000000475],
              [85.999672000000132, 21.135140000000142],
              [86.00395300000028, 21.136890000000502],
              [86.009637, 21.135090000000272],
              [86.016137000000327, 21.135231],
              [86.016374000000255, 21.132320000000213],
              [86.018211000000164, 21.131589000000528],
              [86.027191000000116, 21.13578000000069],
              [86.026062000000337, 21.138269000000601],
              [86.024307000000235, 21.139529000000373],
              [86.024727000000183, 21.141291000000358],
              [86.029442000000216, 21.143092000000134],
              [86.03321, 21.150882000000419],
              [86.040437000000267, 21.148650000000654],
              [86.050492000000332, 21.154711000000127],
              [86.054802000000251, 21.153250000000408],
              [86.0580590000001, 21.153231000000225],
              [86.058949856221247, 21.154022942051366],
              [86.066910104237905, 21.154771336428777],
              [86.073477095290372, 21.153202850498467],
              [86.071846000000264, 21.150540000000372],
              [86.071675186874273, 21.148482192387345],
              [86.071167000000202, 21.14236000000016],
              [86.072083000000177, 21.133510000000111],
              [86.06797100000027, 21.122160000000175],
              [86.06037300000024, 21.115840000000382],
              [86.055894000000237, 21.114320000000586],
              [86.050431000000259, 21.110821],
              [86.046212, 21.102951],
              [86.042846, 21.092941000000561],
              [86.031854, 21.087330000000115],
              [86.029686000000183, 21.084340000000331],
              [86.027038000000104, 21.074159000000115],
              [86.023079, 21.067231000000326],
              [86.023346000000146, 21.064559000000365],
              [86.026031, 21.063071000000374],
              [86.028077, 21.05942],
              [86.027993000000237, 21.056680000000366],
              [86.032417000000336, 21.053180000000506],
              [86.029953000000248, 21.047382],
              [86.030053000000336, 21.040920000000423],
              [86.032127000000145, 21.036859000000327],
              [86.03264700000021, 21.033201000000187],
              [86.03788, 21.027501000000534],
              [86.039047, 21.02312],
              [86.042716, 21.018101000000449],
              [86.047416000000212, 21.015250000000659],
              [86.054351000000267, 21.015920000000101],
              [86.065505000000186, 21.010920000000162],
              [86.07673, 21.008142000000301],
              [86.079643, 21.010510000000348],
              [86.084091000000157, 21.012251000000159],
              [86.086418000000123, 21.017750000000202],
              [86.08429000000028, 21.020991000000315],
              [86.08583700000024, 21.025092000000537],
              [86.088212, 21.03870000000023],
              [86.090279000000223, 21.044849000000447],
              [86.104683, 21.052010000000333],
              [86.111489000000262, 21.05850100000043],
              [86.115013000000175, 21.060699000000394],
              [86.118019, 21.060899],
              [86.123862000000116, 21.059231000000235],
              [86.126846000000313, 21.061891000000227],
              [86.129433000000105, 21.06827],
              [86.136115000000174, 21.067930000000214],
              [86.143379, 21.065100000000363],
              [86.15705800000022, 21.057681],
              [86.172859000000173, 21.055411],
              [86.186890000000275, 21.050550000000321],
              [86.192369, 21.04969],
              [86.203179000000119, 21.050260000000485],
              [86.208421, 21.048521000000498],
              [86.21304300000017, 21.04664100000036],
              [86.218551000000318, 21.042921000000259],
              [86.221603000000229, 21.03927900000053],
              [86.230690000000124, 21.033310000000476],
              [86.242432, 21.031870000000364],
              [86.256576000000209, 21.033189],
              [86.261224000000226, 21.03055900000026],
              [86.273561000000115, 21.020201000000323],
              [86.275543000000113, 21.017541000000499],
              [86.284630000000263, 21.012470000000288],
              [86.286187000000126, 21.008620000000285],
              [86.285531, 20.995841000000208],
              [86.283386000000334, 20.985530000000431],
              [86.282258, 20.983650000000292],
              [86.281617, 20.972070000000368],
              [86.286080000000339, 20.962971000000145],
              [86.286048000000136, 20.9561],
              [86.284013000000158, 20.937990000000351],
              [86.276366, 20.922360000000477],
              [86.274598000000282, 20.91634],
              [86.27607, 20.907310000000276],
              [86.277734, 20.903570000000283],
              [86.277023000000199, 20.900250000000195],
              [86.28311200000023, 20.895892000000224],
              [86.286698, 20.895001000000374],
              [86.294244, 20.89638],
              [86.307618000000375, 20.88972],
              [86.309288000000123, 20.879642000000214],
              [86.317078000000237, 20.872590000000283],
              [86.322662, 20.87223900000037],
              [86.329858, 20.872882000000622],
              [86.331932000000194, 20.870229000000162],
              [86.330689, 20.867941000000709],
              [86.324761000000336, 20.862721000000302],
              [86.324356, 20.859212],
              [86.329682, 20.856319000000322],
              [86.333267000000191, 20.855262],
              [86.335776000000109, 20.852711],
              [86.34304, 20.849081000000403],
              [86.349806999999814, 20.846799000000427],
              [86.353287000000179, 20.846761000000463],
              [86.3602980000001, 20.849081000000403],
              [86.362527000000327, 20.851850000000521],
              [86.36569900000022, 20.853331000000363],
              [86.38835200000031, 20.858911000000543],
              [86.396470000000178, 20.85755000000017],
              [86.401650000000345, 20.853391000000155],
              [86.410218000000128, 20.851111000000166],
              [86.415261000000143, 20.85105],
              [86.418297000000152, 20.850161],
              [86.421059000000213, 20.847330000000277],
              [86.422431, 20.84464099999985],
              [86.425018000000236, 20.842799],
              [86.436318000000114, 20.84235],
              [86.440265110895467, 20.840577948712614],
              [86.442978000000124, 20.839360000000223],
              [86.447381, 20.838380000000367],
              [86.457439871521089, 20.850895320652338],
              [86.462436739633446, 20.858033703669825],
              [86.469932041801698, 20.857676784519068],
              [86.480282697177003, 20.857319865368307],
              [86.488848756798092, 20.863030571782353],
              [86.502411684531168, 20.868027439894714],
              [86.512284000000278, 20.864950000000356],
              [86.521628156888525, 20.862470468710338],
              [86.538502910140011, 20.857992645917246],
              [86.544388000000225, 20.85643100000015],
              [86.565117, 20.859439000000176],
              [86.575738000000328, 20.85507900000038],
              [86.57904900000014, 20.852632000000423],
              [86.591842000000312, 20.850749000000231],
              [86.595092000000122, 20.84328],
              [86.597389, 20.840001000000367],
              [86.597480000000346, 20.828689000000164],
              [86.599060000000165, 20.82409000000035],
              [86.606668, 20.822522000000273],
              [86.608619000000232, 20.81393],
              [86.610718000000162, 20.809731000000109],
              [86.613097000000195, 20.807300000000222],
              [86.615563, 20.808282000000471],
              [86.615540000000323, 20.806889000000517],
              [86.619957000000255, 20.803441000000127],
              [86.620689, 20.800939000000252],
              [86.619584000000117, 20.798881000000161],
              [86.61206, 20.799769],
              [86.609749000000292, 20.79457100000041],
              [86.611732, 20.791111000000281],
              [86.614154476509938, 20.790609797963608],
              [86.617097000000214, 20.79000100000064],
              [86.620750000000299, 20.790261000000154],
              [86.619595625430676, 20.787744982221106],
              [86.618072770386988, 20.784699272133587],
              [86.616740272223666, 20.780321063882916],
              [86.616549915343143, 20.775181428110269],
              [86.613313848375341, 20.771564647381521],
              [86.609316353885418, 20.770803219859598],
              [86.609506710765899, 20.769661078576856],
              [86.610496870393817, 20.766120193722593],
              [86.607222428200345, 20.765853940967471],
              [86.604176718112839, 20.765663584086944],
              [86.601321364905942, 20.76376001528234],
              [86.59846601169896, 20.76376001528234],
              [86.593897446567766, 20.765663584086944],
              [86.588757810795116, 20.768138223533011],
              [86.57962068053277, 20.770232149218309],
              [86.573529260357731, 20.769090007935453],
              [86.565724628258735, 20.767567152891782],
              [86.560394635605661, 20.762998587760588],
              [86.557671853233657, 20.756445211030606],
              [86.556525078517524, 20.755616984846593],
              [86.554521880558951, 20.75417023076545],
              [86.552290229518093, 20.751702752909974],
              [86.55146088878459, 20.750785772675663],
              [86.550336653933954, 20.749542735772586],
              [86.549004155770746, 20.745735598163144],
              [86.54344861966176, 20.745309035121348],
              [86.542341664954265, 20.743451315597547],
              [86.539867025508201, 20.74135738991242],
              [86.537773099823127, 20.738121322944433],
              [86.537392386062294, 20.731649189008632],
              [86.537788000000191, 20.727591000000128],
              [86.53853452734505, 20.725748125714286],
              [86.539486311747424, 20.724415627550904],
              [86.542722378715254, 20.72289277250723],
              [86.546529516324682, 20.724225270670441],
              [86.552430579619042, 20.728793835801575],
              [86.554143791543183, 20.728222765160346],
              [86.554334148423706, 20.724796341311837],
              [86.554334148423706, 20.722117234563878],
              [86.554334148423706, 20.72041813306117],
              [86.552620936499494, 20.719275991778257],
              [86.548052371368371, 20.718133850495569],
              [86.544183000000132, 20.713251000000234],
              [86.545787761048956, 20.710565151267694],
              [86.547029745923027, 20.708486472014439],
              [86.549384869531522, 20.705570296384732],
              [86.552620936499494, 20.702334229416916],
              [86.556618430989246, 20.697765664285548],
              [86.552049865858095, 20.697575307405252],
              [86.547290943846448, 20.696813879883329],
              [86.543674163117629, 20.693197099154414],
              [86.540818809910633, 20.688057463381934],
              [86.536060172898019, 20.687517143325856],
              [86.530296, 20.688780000000232],
              [86.527709000000286, 20.68832000000037],
              [86.526698032246131, 20.685299726659078],
              [86.525948000000241, 20.683059000000238],
              [86.521423, 20.686740000000377],
              [86.517777000000237, 20.690870000000469],
              [86.514358000000115, 20.693090000000492],
              [86.51243700000019, 20.690891000000242],
              [86.512542000000323, 20.685699000000394],
              [86.511329000000146, 20.682319000000515],
              [86.509171000000308, 20.680010000000603],
              [86.501868000000201, 20.67990100000025],
              [86.496437, 20.678989000000453],
              [86.490616000000202, 20.674401000000493],
              [86.485466, 20.673152000000524],
              [86.482086000000137, 20.672822000000217],
              [86.47908800000026, 20.674590000000304],
              [86.47268600000011, 20.678360000000104],
              [86.471253, 20.679540000000422],
              [86.4694360000003, 20.681040000000163],
              [86.465539, 20.681129000000279],
              [86.46357989201617, 20.676695503855107],
              [86.463564336023396, 20.676660300367356],
              [86.463160065701089, 20.675745429451972],
              [86.462159, 20.673480000000318],
              [86.461742329500836, 20.670375924380263],
              [86.456562095694139, 20.670249577214289],
              [86.453897099367595, 20.667394224007293],
              [86.453326028726323, 20.664348513919773],
              [86.453706742487071, 20.662064231354176],
              [86.454658526889517, 20.657686023103505],
              [86.453516385606775, 20.653498171733244],
              [86.456562095694139, 20.650262104765254],
              [86.457120168039452, 20.646551173160045],
              [86.451531000000315, 20.643569],
              [86.448800239317137, 20.642504374636584],
              [86.447486000000296, 20.641992000000183],
              [86.432503000000153, 20.63912],
              [86.424888000000166, 20.636649],
              [86.419892000000317, 20.629561000000304],
              [86.418603000000218, 20.629080000000155],
              [86.417107000000243, 20.628522],
              [86.417328000000253, 20.623850000000456],
              [86.419051000000181, 20.621901000000488],
              [86.421196000000222, 20.619490000000663],
              [86.4179230000003, 20.619050000000353],
              [86.411056000000173, 20.621520000000597],
              [86.405411000000271, 20.621021000000322],
              [86.400962, 20.61951],
              [86.39685700000021, 20.615921000000235],
              [86.38992400000015, 20.607440000000217],
              [86.390998352124967, 20.606587763590763],
              [86.39286, 20.605111000000417],
              [86.391007000000101, 20.600780000000153],
              [86.389686237738758, 20.599717960933159],
              [86.388871251121358, 20.599062621473301],
              [86.38759582508014, 20.598037037746046],
              [86.386130078011178, 20.596858414843833],
              [86.382659148499016, 20.597155929761577],
              [86.381750283184076, 20.593419483466274],
              [86.378086606554277, 20.592117364515666],
              [86.375569014561592, 20.589801179882439],
              [86.373759862769518, 20.58859507868771],
              [86.37164918567899, 20.588745841337179],
              [86.36712630619914, 20.589951942531737],
              [86.3629049520179, 20.591007281076994],
              [86.358834360486, 20.594173296712992],
              [86.352502329214062, 20.599600752088744],
              [86.34617029794228, 20.602314479776847],
              [86.34315504495558, 20.60532973276332],
              [86.339838266670526, 20.60532973276332],
              [86.335315387190505, 20.604726682165957],
              [86.330641745061399, 20.604877444815425],
              [86.327023441477522, 20.607289647204531],
              [86.324912764386823, 20.611360238736491],
              [86.323127296272659, 20.619723639535092],
              [86.321876735849429, 20.622637179244801],
              [86.321664232457152, 20.623132266935151],
              [86.32106, 20.624540000000358],
              [86.317901000000262, 20.623230000000145],
              [86.316226828144565, 20.619294822131103],
              [86.313208000000117, 20.612199000000651],
              [86.315162000000129, 20.609170000000173],
              [86.315886, 20.604580000000336],
              [86.313881, 20.590490000000383],
              [86.314781000000238, 20.587119000000136],
              [86.317559, 20.583940000000208],
              [86.317680000000138, 20.579730000000549],
              [86.317659159974752, 20.579710987692405],
              [86.315407646868124, 20.577656937385651],
              [86.31459000000028, 20.57691100000056],
              [86.313310675405532, 20.576384600682101],
              [86.311433000000335, 20.575612000000373],
              [86.311694644884753, 20.574544205986964],
              [86.304467319760064, 20.57194357822743],
              [86.296929187293742, 20.570737477033216],
              [86.295120035501824, 20.572094340877069],
              [86.292104782515352, 20.575109593863427],
              [86.288637241580759, 20.5749588312143],
              [86.285277417121605, 20.574478856291531],
              [86.283360548828895, 20.574205017927618],
              [86.282082677769765, 20.573376348395922],
              [86.280890480408658, 20.572603236275253],
              [86.277782330829027, 20.569380613189534],
              [86.277055692084261, 20.571652108291058],
              [86.273189067949815, 20.573436704045431],
              [86.269768592753934, 20.573436704045431],
              [86.266050684932324, 20.573734136671359],
              [86.263225074987915, 20.574329001922816],
              [86.261589195546364, 20.576857179241525],
              [86.260250748730613, 20.580277654437392],
              [86.258614869289076, 20.582062250191765],
              [86.256830273534689, 20.583995562259016],
              [86.256235408283246, 20.587713470080413],
              [86.25474824515463, 20.592026243153665],
              [86.251179053645885, 20.59723131410373],
              [86.242016000463181, 20.603378636879537],
              [86.239875000231152, 20.604169000099372],
              [86.237517653502294, 20.604189581821341],
              [86.235754168122668, 20.604204978630825],
              [86.235407220599356, 20.604208007827985],
              [86.231743000058344, 20.604239999945769],
              [86.225219999990244, 20.603470000012972],
              [86.221287074760113, 20.603328682931355],
              [86.21786659956426, 20.603626115557116],
              [86.214297408055515, 20.605410711311489],
              [86.207605173976603, 20.611805512764644],
              [86.204928280345058, 20.614928555334807],
              [86.20507699665788, 20.618200314217795],
              [86.204482131406436, 20.623405385167867],
              [86.201782457720043, 20.626112470367271],
              [86.200297321097864, 20.625923370174686],
              [86.197770243258603, 20.625957309512096],
              [86.196303317719838, 20.625977010718596],
              [86.193237206633597, 20.626018189410157],
              [86.191986245364802, 20.626034990173078],
              [86.190354081684333, 20.623554101480917],
              [86.18752847173991, 20.620728491536504],
              [86.184851578108322, 20.620877207849382],
              [86.183364414979707, 20.621769505726544],
              [86.181840435845899, 20.626934337528095],
              [86.179961258881619, 20.628653656490989],
              [86.179398000028897, 20.629169000012091],
              [86.17712879923242, 20.629456631841773],
              [86.173903075110246, 20.629865507593873],
              [86.170690202115949, 20.631186243473959],
              [86.163882577994499, 20.632774512878537],
              [86.162097982240113, 20.634261676007153],
              [86.163436429055864, 20.635005257571486],
              [86.167946140639032, 20.634293197680446],
              [86.169087648944739, 20.634112959694271],
              [86.173549138330628, 20.63455910863291],
              [86.178676478346318, 20.636165386614429],
              [86.18143110291247, 20.637384718577316],
              [86.184851578108322, 20.63693856963874],
              [86.189135768879723, 20.637131007231172],
              [86.189015634868539, 20.639466746957218],
              [86.18856948592996, 20.643035938465967],
              [86.188866918555718, 20.648241009416431],
              [86.188272053304246, 20.65181020092518],
              [86.186338741237009, 20.652999931428095],
              [86.183513131292599, 20.652405066176634],
              [86.179795223470961, 20.649579456232171],
              [86.177861911403724, 20.649579456232171],
              [86.174441436207843, 20.648538442042135],
              [86.172508124140606, 20.645266683159146],
              [86.172210691514906, 20.641548775337519],
              [86.170426095760533, 20.639912895896025],
              [86.166343540845773, 20.638528928180275],
              [86.164180010620186, 20.639466746957218],
              [86.163287712743042, 20.641548775337519],
              [86.161800549614355, 20.644374385281932],
              [86.158826223357082, 20.644969250533386],
              [86.15503212856764, 20.643031446525633],
              [86.153656036487675, 20.641044253375178],
              [86.152970607584038, 20.640054436014104],
              [86.148118648830845, 20.637830867515898],
              [86.146470841062055, 20.637055428565869],
              [86.143062294193484, 20.635451406510068],
              [86.140279409297236, 20.632733239850829],
              [86.136667492740258, 20.629205321369788],
              [86.134436748047307, 20.628313023492574],
              [86.131164989164319, 20.625784846173698],
              [86.127000932404115, 20.621323356787965],
              [86.122836875643927, 20.619241328407664],
              [86.119118967822303, 20.61730801634064],
              [86.115995925252122, 20.613143959580437],
              [86.114954911062085, 20.608979902820234],
              [86.113913896872063, 20.604667129747153],
              [86.112426733743391, 20.604815846060031],
              [86.109154974860402, 20.606154292875594],
              [86.104693485474428, 20.608385037568773],
              [86.103503754971527, 20.606897874440104],
              [86.101570442904261, 20.604369697121225],
              [86.098447400334166, 20.604518413434274],
              [86.0956217903897, 20.606451725501525],
              [86.094559065788957, 20.606838170810871],
              [86.092350031506712, 20.607641456004441],
              [86.091027913970521, 20.607641456007283],
              [86.088483407372195, 20.607641456004441],
              [86.086252662679243, 20.607046590752983],
              [86.082683471170498, 20.606154292875594],
              [86.080601442790439, 20.603774831869764],
              [86.078221981784608, 20.599610775109561],
              [86.078078534156745, 20.595292477191773],
              [86.077421284965666, 20.594665701428536],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Jharsuguda",
          Dist_Code: "371",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [84.201164577407695, 21.740563273432308],
              [84.197952305049725, 21.739849435130388],
              [84.195810790144421, 21.740206354281323],
              [84.189916308862649, 21.738783548454759],
              [84.185460134768945, 21.737707920225258],
              [84.178321751751454, 21.730926456358524],
              [84.167257258074443, 21.728071103151475],
              [84.135491453646509, 21.740206354281323],
              [84.135491453646509, 21.746630898997122],
              [84.131565342987003, 21.76590453314429],
              [84.132851584809188, 21.776876217273859],
              [84.128651075852673, 21.780303370291957],
              [84.124511, 21.781961],
              [84.118963998717035, 21.782542909244281],
              [84.118547118154297, 21.782586642180483],
              [84.116635465916517, 21.782787184428908],
              [84.114807, 21.782979000000122],
              [84.108277000000129, 21.785671],
              [84.094841, 21.779991000000159],
              [84.0832, 21.772621000000182],
              [84.076554, 21.770510000000169],
              [84.067834000000161, 21.76977],
              [84.061919000000131, 21.770980000000119],
              [84.056556000000157, 21.770879000000143],
              [84.042321, 21.762469],
              [84.037163000000106, 21.758189000000183],
              [84.031723000000156, 21.755821000000136],
              [84.028313000000111, 21.75878],
              [84.026253, 21.7629],
              [84.023819, 21.76799],
              [84.022796000000127, 21.773049],
              [84.02072200000012, 21.777822000000125],
              [84.015954000000178, 21.778170000000152],
              [84.012307, 21.78119],
              [84.008011, 21.782891000000117],
              [83.998498, 21.768630000000194],
              [83.993766, 21.765332000000168],
              [83.991660000000167, 21.76169],
              [83.988342, 21.752799],
              [83.983948000000154, 21.74858],
              [83.980392, 21.748672000000166],
              [83.977311, 21.753838],
              [83.970382000000185, 21.756911000000109],
              [83.965478000000175, 21.762971],
              [83.962966000000151, 21.76252],
              [83.961877000000101, 21.752211],
              [83.959686, 21.74858],
              [83.955468, 21.744820000000111],
              [83.94870800000011, 21.742281],
              [83.946397, 21.739482],
              [83.94567900000014, 21.73210000000017],
              [83.937187, 21.724371000000186],
              [83.941902, 21.717001000000206],
              [83.954194, 21.71012200000018],
              [83.966209, 21.7053790000001],
              [83.966186, 21.699832000000182],
              [83.961548, 21.687812],
              [83.970581000000138, 21.625591],
              [83.97432800000017, 21.59181900000015],
              [83.96672, 21.573999000000125],
              [83.957161000000127, 21.567569],
              [83.934112000000184, 21.573169000000171],
              [83.924332, 21.573552],
              [83.909181, 21.572661],
              [83.894202000000107, 21.570101000000189],
              [83.887176000000153, 21.570222],
              [83.878898, 21.57151],
              [83.872047000000165, 21.574119000000106],
              [83.866531000000109, 21.57694100000014],
              [83.860672000000122, 21.581091000000178],
              [83.853011, 21.583660000000119],
              [83.839248, 21.582229000000208],
              [83.82911, 21.585451000000141],
              [83.816429000000127, 21.590821000000172],
              [83.80754, 21.587721],
              [83.803650000000104, 21.577301],
              [83.799659000000105, 21.571002000000131],
              [83.793136, 21.563020000000101],
              [83.786217, 21.570591000000199],
              [83.744133, 21.606201000000166],
              [83.720124, 21.62754],
              [83.716423, 21.641792000000116],
              [83.704437, 21.663432],
              [83.698342, 21.685542000000162],
              [83.687852, 21.69856],
              [83.677062, 21.70496],
              [83.659729000000183, 21.709771],
              [83.649307000000121, 21.71703],
              [83.616706, 21.724121],
              [83.591590000000153, 21.732059000000159],
              [83.574836000000147, 21.735081],
              [83.552804000000137, 21.740159000000112],
              [83.537461, 21.722972],
              [83.535202000000169, 21.709010000000141],
              [83.530486, 21.688949000000147],
              [83.519966, 21.66969],
              [83.502968000000166, 21.65331],
              [83.483078, 21.639601000000194],
              [83.474777000000117, 21.641219000000145],
              [83.466217000000128, 21.644121],
              [83.440773, 21.655170000000162],
              [83.435355000000115, 21.663120000000156],
              [83.428650000000104, 21.66889],
              [83.419745000000134, 21.675021],
              [83.421113000000148, 21.686549000000177],
              [83.42488, 21.689011000000104],
              [83.427964, 21.692329000000196],
              [83.431832, 21.693911000000178],
              [83.44079600000012, 21.693389000000135],
              [83.449707, 21.690959000000184],
              [83.456337000000119, 21.694321000000169],
              [83.457627000000102, 21.69967],
              [83.461609, 21.70628],
              [83.466926000000157, 21.710569000000188],
              [83.478021000000169, 21.727991000000195],
              [83.479867000000112, 21.734140000000192],
              [83.484131000000147, 21.741552000000123],
              [83.477332000000146, 21.745889000000144],
              [83.473907, 21.749611],
              [83.475418, 21.753410000000141],
              [83.479026, 21.758700000000143],
              [83.477891, 21.764591000000163],
              [83.475922000000182, 21.773790000000126],
              [83.467179000000129, 21.78274],
              [83.474297, 21.786150000000131],
              [83.484047000000132, 21.794341000000198],
              [83.485457, 21.803220000000117],
              [83.491333, 21.808661000000196],
              [83.490914, 21.814541000000183],
              [83.497719000000174, 21.806181000000148],
              [83.506141000000113, 21.800399000000137],
              [83.514122, 21.797801000000103],
              [83.522186, 21.794111000000154],
              [83.536567000000133, 21.79393100000021],
              [83.535767000000163, 21.798961000000187],
              [83.538666, 21.800620000000144],
              [83.534783000000161, 21.806819000000186],
              [83.536401, 21.818349000000122],
              [83.527656, 21.82299],
              [83.531243000000174, 21.831899000000188],
              [83.540948, 21.834659],
              [83.548537, 21.835231000000185],
              [83.557458, 21.834410000000101],
              [83.564537000000129, 21.830369],
              [83.5735320000001, 21.829661],
              [83.57769, 21.826570000000171],
              [83.585769, 21.822800000000139],
              [83.593133, 21.828471],
              [83.60134, 21.82962],
              [83.605399000000119, 21.832519000000154],
              [83.606186, 21.836329],
              [83.605912000000146, 21.843030000000109],
              [83.612549, 21.84344],
              [83.622513, 21.845542000000133],
              [83.622399, 21.840701000000131],
              [83.624282, 21.834971000000163],
              [83.636102000000136, 21.813800000000125],
              [83.640717, 21.81249],
              [83.644477000000151, 21.809971],
              [83.650383000000133, 21.809351000000103],
              [83.661767, 21.805780000000194],
              [83.66893700000017, 21.805780000000194],
              [83.675622000000118, 21.80353000000019],
              [83.679863, 21.8007290000001],
              [83.68376100000016, 21.795781000000144],
              [83.684303, 21.79046],
              [83.688661000000181, 21.78829],
              [83.707687, 21.785641000000105],
              [83.712806, 21.78358100000019],
              [83.714821000000185, 21.78344],
              [83.717927000000131, 21.786941],
              [83.724671, 21.792021],
              [83.72693600000018, 21.801411000000193],
              [83.738777, 21.81718],
              [83.753798000000174, 21.833221000000144],
              [83.761741000000129, 21.83632],
              [83.775512, 21.853400000000185],
              [83.781510000000182, 21.85514100000017],
              [83.793587, 21.86599],
              [83.807328000000126, 21.852302],
              [83.804252000000162, 21.85833],
              [83.808037000000155, 21.867531000000149],
              [83.80951600000013, 21.880271],
              [83.81536000000014, 21.88248000000015],
              [83.822899, 21.875129000000182],
              [83.827882, 21.893039],
              [83.833472, 21.892009],
              [83.841607, 21.899270000000108],
              [83.848480000000137, 21.9003],
              [83.854240000000104, 21.905731000000166],
              [83.858010000000121, 21.907771],
              [83.847366000000179, 21.91982100000018],
              [83.873681, 21.921061000000115],
              [83.888137, 21.937961],
              [83.889740000000174, 21.943431000000199],
              [83.901878000000167, 21.940892],
              [83.911599000000109, 21.941379],
              [83.920768, 21.93926],
              [83.930108000000175, 21.941760000000155],
              [83.950431, 21.93979100000012],
              [83.954278, 21.93841],
              [83.959907, 21.923009000000143],
              [83.965706000000168, 21.910192000000162],
              [83.971412000000129, 21.904141],
              [83.974022, 21.903302000000107],
              [83.99373700000011, 21.915901000000183],
              [84.000207, 21.92061],
              [84.009139000000104, 21.932411],
              [84.013123, 21.940402],
              [84.022317000000129, 21.949860000000111],
              [84.03071600000014, 21.946742],
              [84.04234400000017, 21.945450000000104],
              [84.044808000000131, 21.940741],
              [84.049104000000156, 21.935809000000173],
              [84.053017, 21.934619000000108],
              [84.056183, 21.935720000000114],
              [84.060258, 21.93239],
              [84.07177, 21.93415],
              [84.072953, 21.939841000000168],
              [84.072937000000181, 21.947291],
              [84.07489, 21.953452000000134],
              [84.081962000000132, 21.957951],
              [84.08252, 21.964082000000186],
              [84.080779000000106, 21.968572000000101],
              [84.079147, 21.977649],
              [84.066689, 21.979311000000106],
              [84.065949000000145, 21.98673],
              [84.067772, 21.988211000000202],
              [84.08348, 21.987591],
              [84.086707000000132, 21.996072000000137],
              [84.087952000000129, 21.996131],
              [84.091309, 21.994570000000177],
              [84.095001000000167, 21.99369],
              [84.098410000000158, 21.994440000000104],
              [84.103188, 21.990351000000143],
              [84.10517, 21.995399],
              [84.106018, 21.99733],
              [84.106217, 22.000491000000178],
              [84.109298, 22.006150000000158],
              [84.114403, 22.008140000000136],
              [84.114921, 22.008140000000136],
              [84.117621, 22.003231],
              [84.12117, 22.000999],
              [84.125343000000129, 22.000110000000113],
              [84.138619000000105, 21.997300000000102],
              [84.140000000000143, 21.995769000000106],
              [84.142159, 21.99529],
              [84.147339, 21.996161000000196],
              [84.149438, 21.995089000000117],
              [84.152816, 21.99508],
              [84.158042000000123, 21.99625],
              [84.164902, 21.996049000000195],
              [84.171448000000154, 21.99214],
              [84.192306, 21.98378],
              [84.196411, 21.981011],
              [84.200493000000151, 21.974479000000141],
              [84.215538, 21.973761],
              [84.220107000000141, 21.972209000000131],
              [84.226341, 21.971870000000131],
              [84.235444, 21.97638],
              [84.240013000000118, 21.979669],
              [84.247491000000124, 21.9893],
              [84.2491, 21.994062],
              [84.251922000000121, 21.997241000000198],
              [84.255418000000176, 22.003251],
              [84.258408000000117, 22.004261000000149],
              [84.262428, 22.004391000000108],
              [84.262773, 22.011000000000191],
              [84.267823, 22.010651],
              [84.282929, 22.013822],
              [84.285133, 22.016269000000189],
              [84.289452000000139, 22.028499000000117],
              [84.292716, 22.030651000000198],
              [84.30764, 22.034072],
              [84.315437, 22.034040000000115],
              [84.331108, 22.02754],
              [84.338898000000185, 22.031891000000137],
              [84.343438000000148, 22.029641000000133],
              [84.350822, 22.033429000000179],
              [84.362578000000141, 22.024360000000168],
              [84.369842, 22.024219],
              [84.375466905481389, 22.023055681559349],
              [84.378792, 22.022368000000196],
              [84.382432, 22.020942000000154],
              [84.387654570351202, 22.018194622356695],
              [84.386226893747775, 22.015339269149869],
              [84.383234474122645, 22.013843059337255],
              [84.379088510730284, 22.011770077641124],
              [84.376233157523288, 22.007130128679702],
              [84.374805480919662, 22.000348664812972],
              [84.374448561768915, 21.991782605192039],
              [84.371236289410916, 21.987856494532362],
              [84.371236289410916, 21.982502707269244],
              [84.368380936204048, 21.980004273213179],
              [84.373139970263352, 21.976755720158671],
              [84.370686476676696, 21.97378554257784],
              [84.36878200000011, 21.971480000000209],
              [84.368959473284505, 21.969285755353038],
              [84.364811744695288, 21.97322280934662],
              [84.356959523375949, 21.97643508170443],
              [84.356602604225188, 21.97322280934662],
              [84.360171795733933, 21.970367456139563],
              [84.360171795733933, 21.967155183781809],
              [84.361956391488306, 21.956447609255573],
              [84.363238744755776, 21.943403319426462],
              [84.358291000000165, 21.93804],
              [84.358382, 21.929270000000198],
              [84.35677045756016, 21.928250357627345],
              [84.347832, 21.910730000000108],
              [84.344619000000122, 21.901912000000202],
              [84.342359553219495, 21.896897474916496],
              [84.341591277810707, 21.895192395451144],
              [84.340621, 21.893039],
              [84.327361, 21.87150100000019],
              [84.323243, 21.862619000000162],
              [84.320344000000134, 21.853179000000178],
              [84.323035, 21.838091],
              [84.321073787912027, 21.83436277070302],
              [84.319648253495458, 21.831652855131264],
              [84.319268000000292, 21.830930000000304],
              [84.312791, 21.826930000000115],
              [84.308647000000278, 21.822960000000247],
              [84.305672924035591, 21.819271047256102],
              [84.303266399461094, 21.810570535333053],
              [84.302579624728011, 21.808087580528646],
              [84.292823834604164, 21.803328658516985],
              [84.286637235988934, 21.794048760594187],
              [84.280450637373832, 21.785006808772035],
              [84.281878313977288, 21.778344317955767],
              [84.270456901149288, 21.771443881038799],
              [84.264032356433546, 21.769778258334835],
              [84.257845757818458, 21.770254150535887],
              [84.254752458510879, 21.775013072547548],
              [84.248803805996303, 21.769064420032969],
              [84.243806937883988, 21.770016204435361],
              [84.241903369079338, 21.767398797329005],
              [84.242628742197539, 21.764207155609025],
              [84.243093099582254, 21.762163983116174],
              [84.244272809583578, 21.760149331190853],
              [84.231680901419082, 21.751254789417711],
              [84.228825548212043, 21.751254789417711],
              [84.224899437552352, 21.751254789417711],
              [84.219188731138487, 21.748042517059723],
              [84.209908833215636, 21.747685597908962],
              [84.20045073910579, 21.747701656449575],
              [84.199736900803913, 21.74627397984619],
              [84.201164577407695, 21.740563273432308],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Kalahandi",
          Dist_Code: "395",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [83.142632000000205, 19.462199000000336],
              [83.142466890323675, 19.463704274236811],
              [83.141156235089028, 19.464490667377614],
              [83.14029151732818, 19.465009498034469],
              [83.138925490396034, 19.465829114193578],
              [83.139222923021791, 19.467911142573481],
              [83.143689653038535, 19.468750084470965],
              [83.143135265726684, 19.473195743042705],
              [83.143089547156222, 19.473562362462523],
              [83.140710086150406, 19.479213582351175],
              [83.127386647766727, 19.49266126441864],
              [83.120529022415084, 19.499582838475639],
              [83.115130880337716, 19.505685086041236],
              [83.113048851957657, 19.509551710175511],
              [83.111020550345444, 19.512472464497129],
              [83.110784431264719, 19.512812475973529],
              [83.105613036314409, 19.520259284701748],
              [83.105315603688709, 19.528884830848082],
              [83.104720738437237, 19.53661807911703],
              [83.09758235541976, 19.53929497274839],
              [83.081818426256092, 19.543459029508593],
              [83.078546667373104, 19.546433355765878],
              [83.07586977374153, 19.556546065040656],
              [83.073192880109985, 19.557140930292118],
              [83.062821, 19.555851000000128],
              [83.058243000000104, 19.55522000000013],
              [83.045169295803404, 19.552459683662839],
              [83.04467830008501, 19.552356017289405],
              [83.04452931974707, 19.552324562328117],
              [83.042419, 19.551879],
              [83.039116000000135, 19.550792],
              [83.039047591284245, 19.550724251759444],
              [83.027388255747766, 19.546730788391809],
              [83.028785683543092, 19.538342667619073],
              [83.028352000000311, 19.534692000000231],
              [83.027221499755996, 19.533290215136216],
              [83.02251797085647, 19.527457986746921],
              [83.021972, 19.526781],
              [83.019796160597863, 19.522702492273648],
              [83.018547000000169, 19.520361000000143],
              [83.018547000000169, 19.518613935581865],
              [83.024413929490478, 19.515202930064554],
              [83.023521631613264, 19.507469681795609],
              [83.01931, 19.505920000000113],
              [83.015388, 19.502399],
              [83.005689546003879, 19.49792178864038],
              [83.004336650595789, 19.497297235625062],
              [83.002294626976763, 19.496354552250121],
              [82.991993773286012, 19.485757100117205],
              [82.989614312280167, 19.48010588022856],
              [82.991993773286012, 19.462259922684833],
              [82.990529924353822, 19.460691513114451],
              [82.989307712887907, 19.459382000829347],
              [82.986792707239587, 19.456687351920547],
              [82.983665659765592, 19.453336943912969],
              [82.969686326356367, 19.444413965141102],
              [82.948837000000125, 19.438811000000211],
              [82.946777, 19.440611],
              [82.941890724569575, 19.441010858873362],
              [82.940667, 19.441111],
              [82.938812395788531, 19.440657761623463],
              [82.938568801182186, 19.440598230633892],
              [82.938020068099519, 19.440464128225411],
              [82.935012, 19.43972900000011],
              [82.931671000000208, 19.443269000000264],
              [82.931614950263096, 19.445306263018093],
              [82.928045758754351, 19.444711397766635],
              [82.920312510485402, 19.440249908380899],
              [82.919089719810799, 19.432264660130553],
              [82.923286836742676, 19.425973142345921],
              [82.929235489257266, 19.421214220334257],
              [82.930722652385882, 19.412886106813851],
              [82.934886709146085, 19.400691369158775],
              [82.939645631157731, 19.395932447147111],
              [82.947676312052451, 19.389091496755551],
              [82.949163475181066, 19.380465950609217],
              [82.947587425078936, 19.378783437770149],
              [82.944142732030443, 19.375106054498811],
              [82.941947000000127, 19.372762],
              [82.941597911243989, 19.371980520497626],
              [82.940403008057828, 19.369305578005022],
              [82.940099191840119, 19.368625446827703],
              [82.939529, 19.367349000000157],
              [82.939575991960254, 19.366227571956237],
              [82.939711971440005, 19.362982523198692],
              [82.939724934466412, 19.362673170250272],
              [82.943214822666476, 19.35994309943413],
              [82.943512255292234, 19.354886744796541],
              [82.942163449418487, 19.352915413134891],
              [82.939645631157731, 19.349235524907893],
              [82.936698224053075, 19.335355623809559],
              [82.936474119945373, 19.334300274907598],
              [82.925895063794243, 19.3132390599045],
              [82.925963730374221, 19.30581036155149],
              [82.924773999871292, 19.297184815405156],
              [82.918562382182515, 19.293351233727488],
              [82.914491911731972, 19.292756051305215],
              [82.913530813912573, 19.292615519999284],
              [82.911528093820536, 19.292322683136828],
              [82.910199801210609, 19.292128460767962],
              [82.906115558151484, 19.290961534179697],
              [82.901871687690218, 19.289748999762132],
              [82.892056411041139, 19.279933723112887],
              [82.890271815286766, 19.273985070598311],
              [82.891140942049148, 19.270074000168332],
              [82.892056411041139, 19.265954389703833],
              [82.893690244482997, 19.264729014622272],
              [82.896815333052785, 19.262385198195087],
              [82.89532816992417, 19.256436545680508],
              [82.89532816992417, 19.252272488920305],
              [82.904846013947491, 19.240375183891157],
              [82.909307503333409, 19.22996504199045],
              [82.902763985567375, 19.221339495844514],
              [82.891164113163981, 19.208847325563905],
              [82.887428, 19.21060100000016],
              [82.880456538637731, 19.213606247575566],
              [82.878077077631914, 19.21003705606682],
              [82.884323162772191, 19.202898673049329],
              [82.885325457213455, 19.196559474395649],
              [82.881348836514903, 19.193380829026008],
              [82.864892, 19.187051000000107],
              [82.865289, 19.190800000000134],
              [82.864973734787867, 19.191713941202519],
              [82.864688880975152, 19.192539720977717],
              [82.864616000000169, 19.192751],
              [82.855653000000174, 19.19923],
              [82.848770000000158, 19.196662],
              [82.848321000000141, 19.198750000000128],
              [82.844528000000167, 19.1979110000002],
              [82.842506, 19.199119000000103],
              [82.840439000000103, 19.201840000000171],
              [82.840699000000129, 19.20692],
              [82.838791000000157, 19.21709],
              [82.835259000000107, 19.223079000000151],
              [82.831193000000141, 19.228162000000108],
              [82.827735000000175, 19.229219000000167],
              [82.823029000000176, 19.228691000000133],
              [82.820832000000152, 19.229201],
              [82.818261, 19.23134100000021],
              [82.8161920000001, 19.227929000000184],
              [82.814118000000107, 19.22624],
              [82.810334000000168, 19.22424200000011],
              [82.805512000000178, 19.222981],
              [82.802391, 19.223560000000184],
              [82.797705000000107, 19.230092],
              [82.80947, 19.245041],
              [82.810416, 19.249289000000196],
              [82.817848000000168, 19.249],
              [82.819236, 19.249841],
              [82.818931, 19.251819000000122],
              [82.822418, 19.261870000000211],
              [82.823410000000123, 19.267520000000157],
              [82.821609000000123, 19.275142],
              [82.824752000000146, 19.280621],
              [82.825447, 19.28437],
              [82.830131, 19.28715],
              [82.830887, 19.29084],
              [82.83262, 19.293001000000114],
              [82.836341000000104, 19.295581],
              [82.833579, 19.300319],
              [82.844268000000156, 19.302512000000146],
              [82.838853000000128, 19.30986],
              [82.838723, 19.311890000000169],
              [82.84226900000013, 19.314299000000172],
              [82.841499, 19.316749],
              [82.836091, 19.316708000000173],
              [82.833046000000181, 19.31545],
              [82.830017, 19.318349],
              [82.826562000000109, 19.315309],
              [82.823546000000178, 19.317292000000176],
              [82.818580000000154, 19.315211000000144],
              [82.805717, 19.321980000000107],
              [82.800058, 19.323500000000134],
              [82.79229, 19.322290000000176],
              [82.783386000000149, 19.326901000000131],
              [82.781373, 19.330010000000183],
              [82.77947200000014, 19.335621000000113],
              [82.773376, 19.337312],
              [82.771842000000149, 19.33486],
              [82.76577700000017, 19.334771],
              [82.762848000000119, 19.33073],
              [82.765289, 19.327432000000211],
              [82.758026000000129, 19.323031],
              [82.749465, 19.321492],
              [82.746728000000161, 19.331331],
              [82.743011000000124, 19.332450000000101],
              [82.739838000000177, 19.337681000000199],
              [82.735223, 19.342702000000141],
              [82.727599, 19.339931000000202],
              [82.719727, 19.339821000000139],
              [82.718642, 19.34399900000016],
              [82.718772, 19.347588],
              [82.713302000000155, 19.346679],
              [82.707231, 19.352031000000178],
              [82.706458000000154, 19.362401],
              [82.709779000000125, 19.36475],
              [82.709031, 19.36726],
              [82.706383000000159, 19.371312000000156],
              [82.702187, 19.374061],
              [82.700813, 19.376992],
              [82.700097000000184, 19.382049],
              [82.704560000000171, 19.3857],
              [82.704491000000118, 19.389821000000207],
              [82.701629000000125, 19.393290000000142],
              [82.703903000000111, 19.395211000000124],
              [82.708001000000124, 19.396850000000196],
              [82.707335, 19.40126],
              [82.705369000000104, 19.40652],
              [82.703019, 19.406629000000176],
              [82.700562, 19.408831000000131],
              [82.701660000000146, 19.412330000000107],
              [82.691726000000173, 19.408631000000124],
              [82.685830000000109, 19.410721000000187],
              [82.682381000000163, 19.414328],
              [82.68177, 19.418859000000104],
              [82.674347000000168, 19.43002],
              [82.671760000000148, 19.427541000000129],
              [82.668189000000126, 19.42674100000016],
              [82.666626, 19.434241],
              [82.657548, 19.436359000000149],
              [82.655114, 19.439360000000132],
              [82.654106000000169, 19.442681000000103],
              [82.653999, 19.448939000000106],
              [82.648743000000167, 19.44981],
              [82.644652000000107, 19.451690000000148],
              [82.642907000000122, 19.454681],
              [82.641373, 19.470860000000179],
              [82.634408000000164, 19.47628],
              [82.629195000000124, 19.474381],
              [82.626289, 19.476289000000119],
              [82.627570000000148, 19.483680000000103],
              [82.629929, 19.484831],
              [82.637642, 19.501150000000106],
              [82.635009000000181, 19.504571],
              [82.627089000000154, 19.506891000000163],
              [82.619942000000137, 19.506921000000144],
              [82.615226, 19.511552000000162],
              [82.610894, 19.513090000000197],
              [82.607842000000161, 19.51154],
              [82.600585000000123, 19.514300000000159],
              [82.601723000000135, 19.518681],
              [82.606171000000103, 19.519330000000132],
              [82.608047, 19.522991000000157],
              [82.609656000000115, 19.527301],
              [82.609237000000107, 19.532449],
              [82.603692000000109, 19.531601],
              [82.600243, 19.53324200000014],
              [82.594199, 19.53464200000013],
              [82.589493, 19.533060000000198],
              [82.585846, 19.534131000000169],
              [82.581322, 19.533650000000129],
              [82.577338, 19.540050000000175],
              [82.570077, 19.535802],
              [82.561332, 19.537101],
              [82.560539000000105, 19.541231000000149],
              [82.560356000000112, 19.551701000000147],
              [82.561302, 19.55886],
              [82.559518000000182, 19.562481000000158],
              [82.556457, 19.56538],
              [82.551392, 19.566591],
              [82.551484000000158, 19.57353100000017],
              [82.541558000000109, 19.573581],
              [82.540229, 19.570771],
              [82.537034, 19.56997100000012],
              [82.528877000000179, 19.570561000000104],
              [82.524246000000161, 19.57581],
              [82.523482, 19.578481],
              [82.525276000000105, 19.580760000000165],
              [82.529397, 19.583281],
              [82.531022, 19.588101],
              [82.534759000000108, 19.588600000000152],
              [82.54220500000018, 19.604062000000166],
              [82.540307000000126, 19.605840000000168],
              [82.533752000000135, 19.60743],
              [82.533706, 19.610719],
              [82.530404, 19.613219000000182],
              [82.525962, 19.619182],
              [82.519822, 19.62161100000014],
              [82.520362000000134, 19.62433],
              [82.527892, 19.62763],
              [82.540596, 19.635692000000113],
              [82.549736000000152, 19.6385],
              [82.550271000000166, 19.640569],
              [82.564468000000133, 19.667110000000147],
              [82.567841000000129, 19.670271000000181],
              [82.570708, 19.674382000000147],
              [82.560753, 19.677669000000144],
              [82.559859000000159, 19.683759000000116],
              [82.560256000000138, 19.690510000000181],
              [82.562690000000131, 19.696791000000125],
              [82.561728000000116, 19.702119],
              [82.565888, 19.704811],
              [82.566619000000102, 19.70751],
              [82.56153, 19.708900000000195],
              [82.560334, 19.714299000000146],
              [82.557022000000117, 19.714951],
              [82.556397000000104, 19.720979],
              [82.561097000000117, 19.728822],
              [82.563889000000174, 19.727819],
              [82.566230000000118, 19.728061000000135],
              [82.574273000000161, 19.73176900000021],
              [82.579879000000147, 19.73748],
              [82.585716000000147, 19.74019],
              [82.595544000000103, 19.740910000000152],
              [82.593506, 19.746971000000137],
              [82.593201, 19.751891000000107],
              [82.590539, 19.755939000000179],
              [82.590926000000124, 19.762238000000192],
              [82.58506, 19.771050000000113],
              [82.595138, 19.773069000000188],
              [82.598281, 19.77515],
              [82.599006, 19.781272000000168],
              [82.603279, 19.783551],
              [82.608132000000168, 19.785130000000148],
              [82.618866000000111, 19.786101000000198],
              [82.622962, 19.789310000000167],
              [82.627342, 19.796150000000178],
              [82.628906000000185, 19.80376],
              [82.63629300000018, 19.807992000000123],
              [82.641799, 19.813720000000156],
              [82.645737000000139, 19.825371000000128],
              [82.654106000000169, 19.825530000000121],
              [82.660018000000122, 19.82372],
              [82.669137, 19.825202000000154],
              [82.683318, 19.82372],
              [82.690536, 19.825760000000166],
              [82.69844, 19.826861000000118],
              [82.702713000000116, 19.831039000000143],
              [82.705886, 19.838090000000186],
              [82.704712000000114, 19.8446],
              [82.711007000000151, 19.848561],
              [82.713861, 19.862092000000125],
              [82.717507, 19.870810000000112],
              [82.709350000000171, 19.870121],
              [82.7063670000001, 19.878520000000144],
              [82.702691, 19.885841000000138],
              [82.700530000000114, 19.893289000000149],
              [82.701478, 19.900730000000177],
              [82.700409, 19.906610000000111],
              [82.705879, 19.91123],
              [82.704261, 19.918332000000131],
              [82.706321, 19.926851000000109],
              [82.706497000000169, 19.933531000000183],
              [82.710617000000155, 19.939471000000136],
              [82.711563000000112, 19.944480000000166],
              [82.709451000000158, 19.946671],
              [82.710930000000161, 19.983262000000192],
              [82.707488000000112, 19.990220000000189],
              [82.70063, 19.992871000000147],
              [82.698021, 19.992732],
              [82.699333000000181, 19.995410000000103],
              [82.715461, 20.016399000000145],
              [82.72322100000018, 20.016492],
              [82.731086, 20.019149000000137],
              [82.740693000000164, 20.03671],
              [82.73252, 20.043810000000118],
              [82.73172, 20.047001000000186],
              [82.748864000000168, 20.050481000000158],
              [82.761292000000125, 20.070070000000211],
              [82.774087, 20.081931000000164],
              [82.78279800000017, 20.096549000000145],
              [82.795905, 20.094562],
              [82.803971, 20.09424],
              [82.807793, 20.0966400000002],
              [82.810569, 20.103500000000107],
              [82.813714, 20.10794],
              [82.80983, 20.123620000000184],
              [82.813896, 20.150631],
              [82.817466000000181, 20.16052000000013],
              [82.823936000000103, 20.162131],
              [82.83212300000018, 20.162090000000145],
              [82.845809000000131, 20.157060000000165],
              [82.853882, 20.157819],
              [82.861519, 20.154320000000148],
              [82.869751, 20.153320000000175],
              [82.876892000000154, 20.153459000000108],
              [82.893883000000159, 20.143752],
              [82.901702000000157, 20.142740000000167],
              [82.903792000000109, 20.143369000000174],
              [82.904342000000128, 20.156720000000117],
              [82.906837000000152, 20.161479],
              [82.915589, 20.16725],
              [82.91927200000012, 20.172531],
              [82.924911, 20.17421],
              [82.938896, 20.16839],
              [82.947967000000105, 20.171341000000151],
              [82.952507, 20.170860000000172],
              [82.961564000000166, 20.173960000000129],
              [82.965867, 20.17285000000015],
              [82.97017700000012, 20.172879],
              [82.973213000000143, 20.16983],
              [82.976228, 20.168519],
              [82.983102, 20.16877],
              [82.985572, 20.169812000000142],
              [82.988984000000116, 20.167849],
              [82.992309, 20.169231000000192],
              [83.005966000000143, 20.165279],
              [83.010171, 20.165871000000202],
              [83.016999000000155, 20.169219000000108],
              [83.02272, 20.173251000000104],
              [83.026656000000159, 20.17979],
              [83.031433000000149, 20.176171000000121],
              [83.034576000000158, 20.175630000000123],
              [83.039230000000131, 20.179241000000101],
              [83.043556000000123, 20.181422000000108],
              [83.047517000000127, 20.181251000000138],
              [83.051795, 20.179680000000186],
              [83.061333, 20.18443000000013],
              [83.06874, 20.185472000000171],
              [83.073144, 20.18631],
              [83.076501000000164, 20.184840000000118],
              [83.0789580000001, 20.188751],
              [83.079666, 20.191710000000111],
              [83.083541, 20.193460000000123],
              [83.08747, 20.1914200000001],
              [83.094223000000142, 20.186180000000146],
              [83.114081, 20.189590000000173],
              [83.12085, 20.188699000000206],
              [83.128647000000157, 20.175359],
              [83.132392, 20.17324],
              [83.138108000000145, 20.164930000000137],
              [83.150901000000133, 20.166892000000129],
              [83.16616, 20.165712000000148],
              [83.17627, 20.167451000000195],
              [83.182572, 20.170949],
              [83.18837, 20.175861],
              [83.196794000000168, 20.188731000000185],
              [83.202134, 20.192220000000187],
              [83.214591, 20.195760000000174],
              [83.219008, 20.199641],
              [83.224426, 20.213649],
              [83.232986000000139, 20.225001000000184],
              [83.228287000000179, 20.240811],
              [83.228852, 20.246860000000137],
              [83.231719, 20.25143],
              [83.235733, 20.255131],
              [83.241729000000177, 20.257930000000151],
              [83.255242, 20.261422],
              [83.262412, 20.26464],
              [83.277976, 20.275671],
              [83.283059, 20.282091000000147],
              [83.292975000000169, 20.29828],
              [83.297417000000138, 20.300340000000173],
              [83.307373, 20.300069000000118],
              [83.317519, 20.302811000000183],
              [83.336486000000136, 20.311531000000109],
              [83.34210900000015, 20.311310000000102],
              [83.347848000000155, 20.309810000000194],
              [83.353028000000151, 20.309771000000122],
              [83.355927000000165, 20.313329000000177],
              [83.358726000000132, 20.332180000000101],
              [83.3631290000001, 20.337472000000101],
              [83.378295000000136, 20.339799],
              [83.384056, 20.34564],
              [83.388282000000103, 20.351801000000133],
              [83.397690000000111, 20.357642000000109],
              [83.404931, 20.367322],
              [83.407219, 20.3731580000001],
              [83.410980000000137, 20.389131000000127],
              [83.416238000000163, 20.398202000000133],
              [83.421883, 20.402509000000173],
              [83.44284900000018, 20.414012000000181],
              [83.444839, 20.416350000000133],
              [83.451608000000164, 20.42425],
              [83.465103000000155, 20.434661000000172],
              [83.480491, 20.448910000000179],
              [83.482697000000115, 20.447652000000168],
              [83.484528000000111, 20.448131],
              [83.487686, 20.442191],
              [83.489327000000159, 20.43469100000015],
              [83.489311, 20.428810000000105],
              [83.486656000000139, 20.424371000000175],
              [83.483582000000155, 20.41052],
              [83.483497, 20.40464],
              [83.484687000000108, 20.4009],
              [83.487329, 20.39982],
              [83.489549, 20.402202000000155],
              [83.492867000000146, 20.40877],
              [83.495185, 20.410561],
              [83.501022, 20.410222],
              [83.508012, 20.408141],
              [83.511848, 20.407731],
              [83.513229, 20.402919000000164],
              [83.516167000000152, 20.40044],
              [83.523034, 20.398580000000148],
              [83.532706, 20.39407],
              [83.537347000000153, 20.393071000000127],
              [83.542703000000159, 20.396561],
              [83.549599000000157, 20.394881000000165],
              [83.551377, 20.39161],
              [83.558618000000124, 20.38924],
              [83.56086, 20.38398],
              [83.563971, 20.382909],
              [83.56453, 20.372450000000125],
              [83.568001, 20.362159],
              [83.569915000000137, 20.359712000000112],
              [83.574563000000168, 20.35983],
              [83.579919000000103, 20.35761],
              [83.586113000000111, 20.357510000000154],
              [83.601051, 20.350192],
              [83.617912, 20.345221000000148],
              [83.619851, 20.347190000000179],
              [83.62045300000014, 20.358360000000172],
              [83.622855000000115, 20.363149],
              [83.629807000000127, 20.364240000000102],
              [83.634347, 20.360831000000129],
              [83.638862, 20.363242000000181],
              [83.644065000000168, 20.359721000000146],
              [83.64811, 20.362239],
              [83.649222000000165, 20.36478],
              [83.646125, 20.367791000000121],
              [83.645218000000156, 20.370481000000151],
              [83.645569, 20.374309000000149],
              [83.641601, 20.380661],
              [83.642868, 20.382861],
              [83.645364000000185, 20.384000000000121],
              [83.646882000000161, 20.381799000000107],
              [83.650672, 20.379381],
              [83.656983000000167, 20.3781110000001],
              [83.679597, 20.36992],
              [83.684196, 20.367638000000106],
              [83.694023000000115, 20.367420000000148],
              [83.698486000000102, 20.36484],
              [83.698456000000121, 20.3606],
              [83.696617000000145, 20.352819000000178],
              [83.696952000000167, 20.344480000000139],
              [83.697598750234675, 20.341680182073667],
              [83.700225, 20.330311],
              [83.702182095758062, 20.326829176100937],
              [83.702714278609491, 20.325882381871278],
              [83.703475, 20.324529000000151],
              [83.704918, 20.319442],
              [83.704803576494371, 20.316819707176133],
              [83.704482, 20.30945],
              [83.714005395756857, 20.296433113141511],
              [83.71971610217075, 20.287867053520412],
              [83.719954048271447, 20.27953894],
              [83.716146910662005, 20.273828233586126],
              [83.711975958112063, 20.269311405388063],
              [83.711941529514704, 20.264316414652566],
              [83.714005395756857, 20.259551467551145],
              [83.71189226183229, 20.257168530779317],
              [83.708770581543973, 20.252651030634176],
              [83.709484419845737, 20.246940324220301],
              [83.713961664408174, 20.240411009233636],
              [83.715195126259786, 20.238612210699895],
              [83.716059381910085, 20.235772513562885],
              [83.716860748963697, 20.233139450386314],
              [83.721411058665396, 20.226029591477747],
              [83.724475024182411, 20.221242145357163],
              [83.726616539087715, 20.215055546742057],
              [83.722809401478258, 20.206013594919963],
              [83.723999131981188, 20.20506181051757],
              [83.726696890178673, 20.204854290656154],
              [83.727103772253699, 20.206826103788327],
              [83.732880000000122, 20.205601000000108],
              [83.736462590598165, 20.205417654352509],
              [83.745796000000126, 20.204940000000128],
              [83.748258699145907, 20.204604497150111],
              [83.764000000000166, 20.202460000000137],
              [83.771112459896784, 20.201968511209994],
              [83.776109328008985, 20.203158241712909],
              [83.780301697136039, 20.202617290857798],
              [83.781591759913312, 20.198633619442486],
              [83.782567926015048, 20.195619250634589],
              [83.784361572629038, 20.190080528898015],
              [83.784569000000118, 20.18944],
              [83.784521960115256, 20.189209959557669],
              [83.783256, 20.183019],
              [83.783951000000144, 20.178101000000137],
              [83.783546, 20.174801000000112],
              [83.775277000000116, 20.169541],
              [83.770767, 20.1675390000002],
              [83.768692, 20.158051000000111],
              [83.766678, 20.15556],
              [83.760392, 20.158902000000179],
              [83.755752, 20.159480000000197],
              [83.745461000000134, 20.155362000000192],
              [83.736618000000178, 20.14819000000011],
              [83.732766761559077, 20.146287466899928],
              [83.726859, 20.143369000000174],
              [83.722253000000165, 20.13732],
              [83.72404482726111, 20.132136499709581],
              [83.72421300000012, 20.13165],
              [83.723898775857577, 20.130353550740491],
              [83.723069000000166, 20.126930000000126],
              [83.720329000000149, 20.12208000000015],
              [83.717576528850969, 20.114544208397145],
              [83.714717961273308, 20.112073450380986],
              [83.711227418387281, 20.109056454426987],
              [83.711165387222735, 20.108966437200927],
              [83.710140155410599, 20.107478660460565],
              [83.708603000000139, 20.105248000000127],
              [83.708256692885456, 20.103797198596506],
              [83.707772695084643, 20.101769562839248],
              [83.707589, 20.101000000000163],
              [83.705339750421317, 20.098371261646257],
              [83.703311205698739, 20.094756307464191],
              [83.701243093004322, 20.093324537137384],
              [83.695577957429791, 20.089402520201073],
              [83.676244836757391, 20.091484548581203],
              [83.668511588488428, 20.091781981206903],
              [83.667024425359813, 20.093864009587033],
              [83.666726992734056, 20.100407527353067],
              [83.654829687704918, 20.098325498972933],
              [83.646204141558812, 20.092971711709819],
              [83.639958056418479, 20.088212789698154],
              [83.637578595412648, 20.086428193943785],
              [83.636686297535491, 20.081966704557882],
              [83.631927375523816, 20.080479541429209],
              [83.627643322972162, 20.084341027463431],
              [83.627465886137855, 20.089402520201073],
              [83.623004396751966, 20.090592250703988],
              [83.616758311611619, 20.092674279084118],
              [83.611404524348515, 20.09654090321856],
              [83.605753304459682, 20.101002392604524],
              [83.595938027810604, 20.105761314616181],
              [83.591709963857994, 20.107120335172336],
              [83.587609914290212, 20.108438208247716],
              [83.580225070085788, 20.108084378206396],
              [83.577027914290028, 20.107118767916003],
              [83.571548552500857, 20.105463881990428],
              [83.571259160746067, 20.105102142296968],
              [83.566789630489183, 20.099515229475852],
              [83.562328141103293, 20.093269144335572],
              [83.557271786465861, 20.084941030815166],
              [83.554892325460045, 20.069771966902973],
              [83.55013340344837, 20.056982363996664],
              [83.54647255303091, 20.043688869492197],
              [83.544906000000168, 20.041419000000186],
              [83.544476282398918, 20.039446881037119],
              [83.544420086487349, 20.039188979051115],
              [83.543518000000105, 20.035049000000178],
              [83.544424783312166, 20.033285737637922],
              [83.544906000000168, 20.032350000000118],
              [83.543083000000109, 20.02826100000021],
              [83.54033, 20.024991000000167],
              [83.537002, 20.015961000000171],
              [83.532143000000161, 20.012921000000173],
              [83.520638, 20.010831000000106],
              [83.515296, 20.007619],
              [83.504593, 19.998181],
              [83.502692, 19.994672000000143],
              [83.498909000000182, 19.99077],
              [83.495789000000158, 19.98592],
              [83.495392, 19.981952000000202],
              [83.496741, 19.977211000000118],
              [83.496208000000166, 19.9675820000001],
              [83.492913, 19.959969000000111],
              [83.488746, 19.95351],
              [83.486312, 19.953351000000161],
              [83.477784, 19.955049000000141],
              [83.474023, 19.957492000000169],
              [83.467101, 19.95774],
              [83.464287000000112, 19.959302000000143],
              [83.455726000000183, 19.961941000000191],
              [83.448722000000132, 19.965820000000171],
              [83.444871, 19.966520000000166],
              [83.441422, 19.962841],
              [83.439781, 19.956719000000131],
              [83.439248000000177, 19.950322000000192],
              [83.440078, 19.945472],
              [83.439027000000166, 19.942641],
              [83.436791, 19.94046],
              [83.436928, 19.934630000000194],
              [83.435501, 19.927141000000116],
              [83.424971000000127, 19.92457],
              [83.419258000000113, 19.921349000000188],
              [83.414253, 19.927941],
              [83.410392, 19.92617],
              [83.401145, 19.917311000000208],
              [83.399880000000138, 19.914359],
              [83.402267, 19.912800000000171],
              [83.401581000000178, 19.906861000000102],
              [83.406166000000312, 19.903039000000259],
              [83.406148229591665, 19.898088325745501],
              [83.409981114128399, 19.893901065241486],
              [83.413788251737842, 19.891045712034494],
              [83.416643604944838, 19.884954291859454],
              [83.418547173749502, 19.879624299206505],
              [83.420641099434562, 19.87505573407514],
              [83.42254466823924, 19.87258109462908],
              [83.42115443067182, 19.869359039844536],
              [83.417214675586123, 19.861921109323074],
              [83.414549679259522, 19.853926120343427],
              [83.417214675586123, 19.848976841451243],
              [83.419158607825111, 19.847947700854146],
              [83.42045074255411, 19.847263629527102],
              [83.421783240717318, 19.847644343288092],
              [83.423306095761163, 19.850880410256075],
              [83.425590378326703, 19.849547912092699],
              [83.427684304011819, 19.848786484570773],
              [83.429968586577431, 19.848215413929545],
              [83.431681798501572, 19.844598633200572],
              [83.434727508589091, 19.844408276320102],
              [83.441580356285883, 19.83584221669917],
              [83.45128855718967, 19.826514729556315],
              [83.454714981038109, 19.820994380022736],
              [83.455857122320865, 19.813760818565012],
              [83.453001769113811, 19.812809034162793],
              [83.44919463150454, 19.812047606640871],
              [83.44919463150454, 19.808811539672881],
              [83.452621055352822, 19.796247985562211],
              [83.45189700000013, 19.790399000000203],
              [83.452134000000143, 19.787799000000174],
              [83.451212828253432, 19.78709340424501],
              [83.452430698472526, 19.786159070897437],
              [83.459093189288851, 19.783494074570903],
              [83.464803895702715, 19.780258007602921],
              [83.463852111300497, 19.777593011276334],
              [83.462709970017599, 19.773595516786596],
              [83.462329256256652, 19.769788379177381],
              [83.463281040659055, 19.768075167253013],
              [83.462138899376143, 19.765790884687469],
              [83.462900326898051, 19.762745174600123],
              [83.462709970017599, 19.758176609468929],
              [83.460806401212992, 19.745232341597156],
              [83.459263762595384, 19.738722625444549],
              [83.459160528800211, 19.738286993472055],
              [83.456333014522031, 19.726355284284292],
              [83.455381230119642, 19.724451715479457],
              [83.450622308107981, 19.721120470071405],
              [83.446339278297543, 19.719216901266797],
              [83.44586338609632, 19.713506194852751],
              [83.443008032889267, 19.707795488438645],
              [83.434441973268392, 19.702560674225989],
              [83.42825537465329, 19.694946399007275],
              [83.425400021446237, 19.687808015989781],
              [83.414930393020512, 19.678290171966289],
              [83.407593, 19.67722000000014],
              [83.399423342443896, 19.675888315892788],
              [83.396127000000121, 19.675351],
              [83.392806000000164, 19.673329],
              [83.386162000000169, 19.66625],
              [83.378707000000119, 19.660512],
              [83.371407, 19.644991000000172],
              [83.371407, 19.634201000000186],
              [83.367576, 19.623359],
              [83.36720200000012, 19.61943000000019],
              [83.365402, 19.617390000000167],
              [83.366708000000116, 19.617500000000174],
              [83.365889, 19.613582000000175],
              [83.367813, 19.607171000000157],
              [83.368157, 19.596709000000143],
              [83.36579800000014, 19.591529000000204],
              [83.363533000000118, 19.591180000000119],
              [83.36023, 19.593040000000137],
              [83.359047, 19.59616],
              [83.355118, 19.5993600000001],
              [83.34768600000011, 19.598731],
              [83.33367800000012, 19.59242],
              [83.325576000000169, 19.589551000000139],
              [83.29545500000016, 19.58489000000014],
              [83.283898000000178, 19.590000000000142],
              [83.282067, 19.589542000000105],
              [83.281388000000149, 19.587812000000149],
              [83.279282000000109, 19.586200000000186],
              [83.276351, 19.589150000000185],
              [83.265288, 19.595930000000177],
              [83.262961000000104, 19.595930000000177],
              [83.259955, 19.594380000000168],
              [83.259278, 19.592131000000105],
              [83.262177, 19.579310000000131],
              [83.262253000000129, 19.572790000000104],
              [83.259499, 19.570720000000104],
              [83.250412, 19.568822],
              [83.248436000000183, 19.5652],
              [83.24907, 19.56041],
              [83.256477000000103, 19.55669000000011],
              [83.257599000000184, 19.551731000000128],
              [83.25611, 19.545310000000139],
              [83.252678000000145, 19.54144900000011],
              [83.245057, 19.537322],
              [83.243714000000111, 19.53466],
              [83.247757000000135, 19.527959000000177],
              [83.248756, 19.522581000000169],
              [83.243607000000139, 19.512140000000155],
              [83.241622, 19.509902],
              [83.24051, 19.501530000000113],
              [83.237611000000157, 19.499169000000162],
              [83.231888, 19.500049000000157],
              [83.227311, 19.499821000000107],
              [83.223815000000158, 19.49862],
              [83.220886000000107, 19.496610000000199],
              [83.201958, 19.46939],
              [83.197648000000115, 19.456750000000163],
              [83.19851, 19.448682000000129],
              [83.200096, 19.444509000000206],
              [83.204857000000104, 19.438551000000185],
              [83.207200000000157, 19.43688],
              [83.210503, 19.437170000000147],
              [83.211419, 19.432890000000206],
              [83.210509, 19.428619000000136],
              [83.208458000000149, 19.427062],
              [83.207510625637184, 19.42822962284276],
              [83.203089940507411, 19.427992660633429],
              [83.201088909173365, 19.429839766480196],
              [83.199164891118627, 19.432613458943301],
              [83.195953, 19.442439000000146],
              [83.194511044109703, 19.446225889840829],
              [83.193489, 19.448910000000179],
              [83.189026, 19.454751],
              [83.18706675942876, 19.455828194089801],
              [83.183540384255338, 19.45244464603558],
              [83.181458355875279, 19.449172887152766],
              [83.181458355875279, 19.444711397766635],
              [83.182945519003894, 19.418239894076972],
              [83.181755788500965, 19.414373269942299],
              [83.178781462243691, 19.414075837316769],
              [83.174039262386529, 19.418264898105345],
              [83.169517000000297, 19.421280000000248],
              [83.165287816793452, 19.422380893323744],
              [83.164788, 19.422511000000149],
              [83.160491000000249, 19.425350000000375],
              [83.148740767045098, 19.439357610503517],
              [83.143981845033451, 19.446495993521008],
              [83.144834775195122, 19.456836903888469],
              [83.142632000000205, 19.462199000000336],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Kandhamal",
          Dist_Code: "390",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [83.748258699145907, 20.204604497150111],
              [83.745796000000126, 20.204940000000128],
              [83.736462590598165, 20.205417654352509],
              [83.732880000000122, 20.205601000000108],
              [83.727103772253514, 20.206826103788327],
              [83.726696890178673, 20.204854290656154],
              [83.723999131981188, 20.20506181051757],
              [83.722809401478258, 20.206013594919963],
              [83.726616539087715, 20.215055546742057],
              [83.724475024182411, 20.221242145357163],
              [83.721411058665396, 20.226029591477747],
              [83.716860748963697, 20.233139450386314],
              [83.716059381910085, 20.235772513562885],
              [83.715195126259786, 20.238612210699895],
              [83.713961664408174, 20.240411009233636],
              [83.709484419845737, 20.246940324220301],
              [83.708770581543973, 20.252651030634176],
              [83.71189226183229, 20.257168530779317],
              [83.714005395756857, 20.259551467551145],
              [83.711941529514704, 20.264316414652566],
              [83.711975958112063, 20.269311405388063],
              [83.716146910662005, 20.273828233586126],
              [83.719954048271447, 20.27953894],
              [83.71971610217075, 20.287867053520412],
              [83.714005395756857, 20.296433113141511],
              [83.704482, 20.30945],
              [83.7048035764942, 20.316819707176133],
              [83.704918, 20.319442],
              [83.703475, 20.324529000000151],
              [83.702714278609491, 20.325882381871278],
              [83.700225, 20.330311],
              [83.696952000000167, 20.344480000000139],
              [83.696617000000145, 20.352819000000178],
              [83.698456000000121, 20.3606],
              [83.698486000000102, 20.36484],
              [83.694023000000115, 20.367420000000148],
              [83.684196, 20.367638000000106],
              [83.679597, 20.36992],
              [83.670733715815047, 20.373130363525316],
              [83.663052457226371, 20.375912586444763],
              [83.656983000000167, 20.3781110000001],
              [83.650672, 20.379381],
              [83.646882000000161, 20.381799000000107],
              [83.645364000000185, 20.384000000000121],
              [83.647071, 20.385021],
              [83.65322, 20.398250000000186],
              [83.653922, 20.402441],
              [83.651078, 20.407751000000129],
              [83.652518, 20.411291],
              [83.656051000000133, 20.41251],
              [83.658371, 20.414889],
              [83.659080000000102, 20.417552000000111],
              [83.662669775870299, 20.420499663844904],
              [83.666552082123275, 20.423687532444372],
              [83.674549464070921, 20.411300706883363],
              [83.678713520831124, 20.408623813251833],
              [83.683144204118406, 20.409972348936545],
              [83.684507022474847, 20.409669500412857],
              [83.692295329190159, 20.414662004717563],
              [83.702094140323865, 20.420943293905729],
              [83.703925462591187, 20.422117218436139],
              [83.707267052901074, 20.429741529678545],
              [83.71159790671156, 20.429104983161373],
              [83.725692259158151, 20.427033402970775],
              [83.746178750045701, 20.422491486287122],
              [83.746834851425817, 20.422885147115146],
              [83.753523773483693, 20.421473322202921],
              [83.761716679588844, 20.419744052696668],
              [83.767348443298303, 20.416654494146481],
              [83.769133039052676, 20.418736522526611],
              [83.762886953912343, 20.425874905544102],
              [83.762589521286628, 20.431526125432917],
              [83.767645875923989, 20.436285047444581],
              [83.773891961064322, 20.432418423310132],
              [83.776728549191191, 20.432493070366316],
              [83.78519440084203, 20.432715855935836],
              [83.790845620730849, 20.428254366549929],
              [83.793035618929125, 20.429946637884878],
              [83.797389138496868, 20.433310721187294],
              [83.806906982520204, 20.435392749567423],
              [83.809606631023698, 20.438327150114667],
              [83.813747932911994, 20.442828565210615],
              [83.818001657886199, 20.449584231651837],
              [83.819995583965891, 20.449364132610409],
              [83.830701592578492, 20.448182352473729],
              [83.820916267961451, 20.453039390062422],
              [83.81713847608691, 20.455073585687327],
              [83.806192955459991, 20.464115537509254],
              [83.806005742199247, 20.470480788372011],
              [83.801850627882843, 20.476141019292239],
              [83.797091705871182, 20.480602508678196],
              [83.80036346475417, 20.487146026444233],
              [83.804360954993427, 20.492142889243322],
              [83.799219458164643, 20.497554991168325],
              [83.795723327034281, 20.501235129200147],
              [83.789060836217942, 20.509325296620027],
              [83.787573861847861, 20.509750905999617],
              [83.786978996596403, 20.513022664882605],
              [83.791737918608064, 20.513617530134066],
              [83.793225081736679, 20.518971317397181],
              [83.797389138496868, 20.524622537286056],
              [83.796794273245425, 20.527596863543348],
              [83.794712244865352, 20.53384294868362],
              [83.798281436374097, 20.539494168572499],
              [83.811665904531864, 20.535032679186539],
              [83.811368471906164, 20.540683899075411],
              [83.813536638258398, 20.540603596617924],
              [83.819399152800798, 20.540386466449654],
              [83.82432592844502, 20.545313242093862],
              [83.825645237941131, 20.54663255158999],
              [83.828322131572676, 20.551094040975894],
              [83.830106727327049, 20.560017019747757],
              [83.831593890455721, 20.563586211256503],
              [83.849142415373677, 20.57042716164829],
              [83.85538850051401, 20.571022026899751],
              [83.860312437684883, 20.571268223758345],
              [83.867285805543176, 20.571616892151209],
              [83.873829323309195, 20.572806622654124],
              [83.888700954595635, 20.57042716164829],
              [83.888331218000843, 20.574792688420185],
              [83.888403521969892, 20.583811629806057],
              [83.889890685098564, 20.592734608577924],
              [83.894054741858753, 20.598683261092496],
              [83.899705961747586, 20.600467856846869],
              [83.903870018507789, 20.598683261092496],
              [83.909223805770907, 20.60106272209833],
              [83.913192000000123, 20.600771000000119],
              [83.912516386612126, 20.601912780060498],
              [83.915767323536926, 20.601360154724084],
              [83.916274708604405, 20.601115210208715],
              [83.924392869683103, 20.597196097963881],
              [83.919039082419985, 20.588570551817721],
              [83.908331507893749, 20.584703927683272],
              [83.909818671022364, 20.58113473617453],
              [83.92469030230879, 20.575780948911412],
              [83.936146118106294, 20.577238961831025],
              [83.941049096723916, 20.577862977291481],
              [83.948187479741406, 20.5790527077944],
              [83.954496319753204, 20.578388619372099],
              [83.9594899195191, 20.577862977291481],
              [83.961879406343698, 20.57731155725514],
              [83.963356543653546, 20.576970679414327],
              [83.967818033039492, 20.578755275168696],
              [83.969602628793865, 20.571914324776909],
              [83.977335877062814, 20.564478509133718],
              [83.988043451589064, 20.561206750250669],
              [84.008499685041997, 20.567326641317489],
              [84.014633739570655, 20.567860037363396],
              [84.015700053042664, 20.568355111475395],
              [84.018381579413401, 20.574591218408493],
              [84.022696828728087, 20.575862675795857],
              [84.030843656957344, 20.578263080542111],
              [84.051694033495025, 20.584406495057518],
              [84.056452955506685, 20.585001360308976],
              [84.060914444892589, 20.582324466677445],
              [84.065375934278549, 20.581729601425987],
              [84.066863097407165, 20.576375814162866],
              [84.06805282791008, 20.570724594273994],
              [84.075191210927557, 20.564775941759418],
              [84.090062842213996, 20.564478509133718],
              [84.099165498510132, 20.561372385860974],
              [84.102894919248371, 20.562933538728252],
              [84.106130986216357, 20.568644245142135],
              [84.108415268781968, 20.574164594675715],
              [84.114697045837303, 20.574926022197637],
              [84.120407752251353, 20.576448877241315],
              [84.121491813441523, 20.580284786067576],
              [84.12545732467575, 20.580284786067576],
              [84.128454959637878, 20.5802847860678],
              [84.131638757541026, 20.578294912378109],
              [84.136563376582643, 20.575217025477052],
              [84.138671000000144, 20.578502],
              [84.140579000000102, 20.57906000000019],
              [84.143115096218111, 20.58122796800728],
              [84.146111, 20.583789000000134],
              [84.147720000000149, 20.587869],
              [84.152779, 20.591750000000157],
              [84.159814891087748, 20.595109493767943],
              [84.161682, 20.596001000000165],
              [84.165485820994178, 20.597231936401151],
              [84.171355621504048, 20.589319274159827],
              [84.179863669550556, 20.58796383318133],
              [84.181893000000201, 20.585291000000261],
              [84.184728781906045, 20.585890876941782],
              [84.18756100000023, 20.586490000000307],
              [84.191254959222974, 20.586130501585497],
              [84.203087, 20.5849790000002],
              [84.214576, 20.581611],
              [84.223312000000121, 20.58459200000015],
              [84.22901900000015, 20.58962200000013],
              [84.242837000000151, 20.59583],
              [84.249175, 20.599650000000107],
              [84.250572, 20.605801],
              [84.254807, 20.606911000000135],
              [84.257394, 20.611041],
              [84.258668000000142, 20.618619000000187],
              [84.267853, 20.634951],
              [84.275818, 20.637301000000143],
              [84.276147, 20.639660000000159],
              [84.273537000000118, 20.644351000000135],
              [84.27487300000017, 20.651701],
              [84.271499000000105, 20.669040000000106],
              [84.276803, 20.674681000000184],
              [84.286216, 20.68249],
              [84.296677, 20.687360000000119],
              [84.31218, 20.689001000000182],
              [84.320100000000181, 20.687150000000194],
              [84.327286, 20.683652000000105],
              [84.332817, 20.6774],
              [84.335846000000103, 20.669161000000141],
              [84.349061000000148, 20.667390000000175],
              [84.352142000000157, 20.670640000000159],
              [84.353851000000176, 20.668270000000174],
              [84.353211000000144, 20.663450000000122],
              [84.367852, 20.639140000000108],
              [84.36431, 20.632490000000182],
              [84.378854, 20.596580000000127],
              [84.378327000000112, 20.594061],
              [84.373368000000127, 20.589492],
              [84.377155150446157, 20.580317131094368],
              [84.3777690000001, 20.578830000000149],
              [84.377442224388219, 20.577433868902514],
              [84.380201152500291, 20.575973068179277],
              [84.382342667405609, 20.57882842138633],
              [84.387101589417256, 20.575973068179277],
              [84.389005158221934, 20.57335566107292],
              [84.387101589417256, 20.568596739061256],
              [84.386863643316573, 20.56526549365304],
              [84.38353239790851, 20.56526549365304],
              [84.380439098601002, 20.565503439753737],
              [84.378306299124603, 20.564906255900606],
              [84.379020000000239, 20.563279],
              [84.377806599360198, 20.558627630880714],
              [84.376686, 20.554332],
              [84.37721300000014, 20.550651],
              [84.383637000000164, 20.538991],
              [84.384551, 20.530941000000148],
              [84.38633800000018, 20.525569000000129],
              [84.391029000000159, 20.521580000000139],
              [84.400132, 20.518071],
              [84.416038000000171, 20.514570000000102],
              [84.423759, 20.509070000000118],
              [84.428436000000133, 20.502711000000144],
              [84.429070000000166, 20.496601000000108],
              [84.426453, 20.491051000000137],
              [84.420562000000174, 20.482290000000141],
              [84.422362, 20.47757],
              [84.433029, 20.47123],
              [84.443367, 20.461341],
              [84.448577, 20.46196],
              [84.458655, 20.435671],
              [84.451157000000109, 20.423589000000103],
              [84.454049000000154, 20.415229000000121],
              [84.453842, 20.396271],
              [84.456062, 20.39074],
              [84.462281, 20.385981],
              [84.480592, 20.380541000000104],
              [84.482598, 20.385931000000195],
              [84.490768, 20.39105],
              [84.497323, 20.39278],
              [84.506073000000157, 20.392392],
              [84.505624000000168, 20.38808],
              [84.508666, 20.378991],
              [84.512703, 20.377240000000196],
              [84.514077, 20.375280000000199],
              [84.512978, 20.366280000000181],
              [84.497018, 20.358631],
              [84.484993, 20.348831],
              [84.47860700000011, 20.344731000000134],
              [84.480697000000177, 20.3361],
              [84.482559, 20.33248],
              [84.499351000000146, 20.328581000000209],
              [84.503242, 20.333392],
              [84.506180000000128, 20.333812000000133],
              [84.505988, 20.326131000000196],
              [84.504805, 20.321889],
              [84.509628000000106, 20.314510000000208],
              [84.515449, 20.321871000000154],
              [84.519599000000184, 20.3226],
              [84.526047, 20.318081],
              [84.53241, 20.318901],
              [84.537208, 20.320481],
              [84.539674000000133, 20.315480000000147],
              [84.54663000000015, 20.28115],
              [84.545158, 20.276961],
              [84.538986, 20.268450000000193],
              [84.540337000000108, 20.26224],
              [84.540994, 20.252189000000151],
              [84.538689, 20.24611],
              [84.540627000000129, 20.238001],
              [84.546967000000137, 20.227171000000165],
              [84.569733000000141, 20.199292000000177],
              [84.577911000000185, 20.184312],
              [84.578697, 20.177030000000109],
              [84.580329, 20.167261000000103],
              [84.56891500000016, 20.163200000000181],
              [84.5522, 20.15446200000013],
              [84.552642, 20.149179],
              [84.555771, 20.144399000000131],
              [84.557634, 20.13939],
              [84.557572, 20.1341000000001],
              [84.545326, 20.136600000000151],
              [84.537048000000127, 20.135850000000111],
              [84.523232, 20.136801000000101],
              [84.518952000000155, 20.139410000000161],
              [84.518020000000121, 20.143141000000121],
              [84.515084, 20.14821900000015],
              [84.511039, 20.148411],
              [84.503677000000124, 20.146391000000104],
              [84.501672, 20.142221],
              [84.501252, 20.13624],
              [84.499267000000117, 20.133849000000108],
              [84.495744000000158, 20.13593000000014],
              [84.490189, 20.137801],
              [84.479218, 20.13621],
              [84.47197, 20.139821],
              [84.446380000000133, 20.163170000000147],
              [84.445762000000158, 20.166910000000197],
              [84.446197, 20.170641000000156],
              [84.444732, 20.175291000000126],
              [84.45182, 20.181741],
              [84.451417000000134, 20.18518000000017],
              [84.446776, 20.192510000000194],
              [84.43939200000014, 20.200300000000134],
              [84.430626000000117, 20.199441],
              [84.428657, 20.195949000000152],
              [84.428758000000116, 20.189002],
              [84.424607, 20.184079],
              [84.42231, 20.178990000000109],
              [84.4254, 20.170240000000202],
              [84.426194, 20.162420000000107],
              [84.429756, 20.158790000000121],
              [84.428748, 20.149320000000156],
              [84.433838000000137, 20.14401],
              [84.425637000000151, 20.137731000000141],
              [84.42099, 20.138451000000195],
              [84.420616, 20.131960000000156],
              [84.422157000000183, 20.12432],
              [84.419197, 20.118080000000131],
              [84.410752, 20.11612000000013],
              [84.408211, 20.113319],
              [84.408058000000125, 20.097590000000135],
              [84.404343, 20.092501],
              [84.404961, 20.087040000000112],
              [84.403541000000175, 20.083959000000103],
              [84.396232, 20.080659],
              [84.394067000000163, 20.069990000000182],
              [84.394958, 20.06586000000021],
              [84.404182, 20.058679],
              [84.404975000000121, 20.051269000000154],
              [84.408546, 20.047051],
              [84.404578000000171, 20.043969000000114],
              [84.398055, 20.04143],
              [84.391854, 20.040831000000193],
              [84.364433000000176, 20.026532000000142],
              [84.355636, 20.023541000000129],
              [84.349243000000101, 20.0296610000002],
              [84.339721, 20.018302],
              [84.334153000000157, 20.008000000000148],
              [84.334037000000123, 20.005301000000141],
              [84.330497, 20.006521000000188],
              [84.326272000000174, 20.003841000000133],
              [84.323906000000179, 19.999481000000113],
              [84.324959, 19.993842000000196],
              [84.32375300000011, 19.992709000000101],
              [84.317543, 19.981029000000198],
              [84.324722000000165, 19.972641000000177],
              [84.329499, 19.970611],
              [84.333123, 19.971411],
              [84.339028, 19.974371000000129],
              [84.344758000000112, 19.981131000000115],
              [84.348733, 19.982280000000113],
              [84.352432000000178, 19.98089],
              [84.365616000000145, 19.966021000000122],
              [84.370232, 19.95901200000014],
              [84.374970000000175, 19.95537],
              [84.381577, 19.952011000000137],
              [84.386176, 19.948191000000119],
              [84.39125000000017, 19.948820000000122],
              [84.394333000000174, 19.953561000000143],
              [84.399101000000115, 19.952979000000134],
              [84.404808000000159, 19.949791000000172],
              [84.40866, 19.951530000000158],
              [84.414841, 19.947701],
              [84.426857, 19.951341000000124],
              [84.446473000000182, 19.943332],
              [84.450273, 19.943450000000208],
              [84.45861, 19.945449],
              [84.463029000000105, 19.932150000000146],
              [84.455207, 19.92065],
              [84.456458000000154, 19.906991],
              [84.452057000000181, 19.900810000000202],
              [84.451111, 19.897341],
              [84.454797, 19.878641000000183],
              [84.455535000000154, 19.87021000000021],
              [84.450836, 19.863560000000117],
              [84.454979, 19.859332],
              [84.455827000000141, 19.851811000000165],
              [84.453627, 19.845801000000101],
              [84.446747000000101, 19.84031],
              [84.438957, 19.83626],
              [84.438439000000173, 19.833432],
              [84.444023000000158, 19.82788],
              [84.438843000000176, 19.82320100000015],
              [84.43447100000013, 19.82303],
              [84.426408, 19.830091000000206],
              [84.417252, 19.827780000000125],
              [84.376121000000168, 19.834521000000105],
              [84.365913, 19.839631000000107],
              [84.355668, 19.846630000000115],
              [84.349097000000114, 19.855950000000171],
              [84.342178000000132, 19.853579],
              [84.337403, 19.853812000000168],
              [84.329880000000102, 19.857980000000108],
              [84.31424000000014, 19.869791000000131],
              [84.310272, 19.879680000000175],
              [84.300843, 19.898661],
              [84.283371, 19.886579],
              [84.271028, 19.87125],
              [84.246101, 19.864720000000144],
              [84.227676, 19.860720000000125],
              [84.206856000000101, 19.857420000000101],
              [84.188149, 19.85291200000017],
              [84.179627000000139, 19.853780000000196],
              [84.178116000000145, 19.852791],
              [84.194968, 19.827691],
              [84.184152, 19.817211000000153],
              [84.178786000000159, 19.81426],
              [84.166962000000112, 19.812642],
              [84.167359, 19.804309],
              [84.161399, 19.79666],
              [84.167197000000129, 19.785221],
              [84.165351, 19.782851],
              [84.159621, 19.778851000000198],
              [84.125655, 19.772820000000191],
              [84.126344, 19.76918100000017],
              [84.14276, 19.748880000000209],
              [84.149146, 19.738292],
              [84.154824000000119, 19.727021],
              [84.152734, 19.721059],
              [84.149484, 19.717871000000113],
              [84.151239, 19.715740000000149],
              [84.161057000000184, 19.723491],
              [84.168029, 19.726449000000169],
              [84.177558, 19.728701000000168],
              [84.18457800000013, 19.727550000000175],
              [84.19624200000014, 19.723222000000188],
              [84.182556, 19.695681000000146],
              [84.194809, 19.682840000000109],
              [84.193687000000111, 19.676190000000183],
              [84.205352000000147, 19.67330000000015],
              [84.211731, 19.66514],
              [84.215173, 19.666941000000175],
              [84.220276, 19.658950000000171],
              [84.232064, 19.655650000000147],
              [84.233689000000183, 19.653091000000128],
              [84.239867000000103, 19.63447],
              [84.23729, 19.632221000000179],
              [84.230728000000155, 19.628861000000139],
              [84.229821, 19.62696],
              [84.229974000000126, 19.620490000000128],
              [84.229126000000107, 19.61971],
              [84.221336, 19.62018],
              [84.22003200000016, 19.618329],
              [84.222008, 19.608552000000195],
              [84.228668, 19.6015],
              [84.227462000000102, 19.589530000000192],
              [84.233871000000121, 19.567721000000116],
              [84.231628, 19.564220000000144],
              [84.227647000000147, 19.564052000000114],
              [84.220520000000164, 19.5659],
              [84.215209, 19.568719],
              [84.208588, 19.573811],
              [84.201692, 19.581321],
              [84.197808, 19.58303],
              [84.193307, 19.583561000000142],
              [84.175338000000167, 19.579112],
              [84.162848, 19.580261000000117],
              [84.1598970000001, 19.578581000000209],
              [84.157317, 19.573339],
              [84.154801000000163, 19.57213100000012],
              [84.150559, 19.57397],
              [84.148506000000154, 19.576621],
              [84.143731000000159, 19.579281000000204],
              [84.13923, 19.586020000000186],
              [84.135009, 19.596219000000129],
              [84.131820000000161, 19.609092000000139],
              [84.127700000000161, 19.620460000000143],
              [84.124267000000131, 19.623742],
              [84.120393, 19.625591000000149],
              [84.112281000000152, 19.622801000000202],
              [84.10672700000012, 19.619569000000119],
              [84.085472, 19.621641000000178],
              [84.084159000000156, 19.620321],
              [84.0844740000001, 19.617951],
              [84.087464, 19.610111],
              [84.083359, 19.609251000000139],
              [84.078172, 19.609769000000192],
              [84.071799000000141, 19.6173490000001],
              [84.068611000000118, 19.61609100000015],
              [84.061516, 19.622129000000196],
              [84.053885000000122, 19.62289],
              [84.04058, 19.617880000000177],
              [84.035262, 19.619350000000107],
              [84.031853000000112, 19.62258],
              [84.026572000000144, 19.624731],
              [84.021569, 19.625192000000133],
              [84.015502, 19.6176910000002],
              [84.01191, 19.6176910000002],
              [84.007339, 19.616141000000191],
              [84.004998000000157, 19.613500000000155],
              [84.003922, 19.610341],
              [83.996811, 19.619501000000181],
              [83.992203000000174, 19.61866],
              [83.977341, 19.614161000000134],
              [83.968826, 19.61334],
              [83.960701000000128, 19.616511],
              [83.95327700000017, 19.623941],
              [83.948380000000128, 19.626391],
              [83.94304, 19.626830000000147],
              [83.93586, 19.627902],
              [83.932533, 19.635961000000176],
              [83.928139000000129, 19.649032000000201],
              [83.92080700000011, 19.652760000000111],
              [83.919188000000105, 19.65583],
              [83.923013, 19.658460000000101],
              [83.930778, 19.66159],
              [83.929887000000164, 19.66396],
              [83.925376000000171, 19.66976],
              [83.91848000000013, 19.6694],
              [83.913224, 19.672140000000123],
              [83.908912, 19.670711000000207],
              [83.905265, 19.667050000000124],
              [83.89727, 19.665300000000112],
              [83.873421000000164, 19.66543],
              [83.866645000000162, 19.667071],
              [83.85682, 19.673199000000178],
              [83.851097000000138, 19.677571],
              [83.847649000000132, 19.681382],
              [83.841844000000137, 19.69094],
              [83.838311, 19.699439000000208],
              [83.836189000000147, 19.702689000000188],
              [83.829826000000168, 19.70214000000021],
              [83.823456000000178, 19.70258],
              [83.813781, 19.705859],
              [83.806672, 19.71011],
              [83.801391, 19.709962000000125],
              [83.785278, 19.70474],
              [83.773750000000106, 19.704959],
              [83.765388000000115, 19.707371000000133],
              [83.761712, 19.706119000000108],
              [83.760292000000149, 19.701499000000123],
              [83.758728, 19.687312],
              [83.759102000000141, 19.685060000000131],
              [83.756385000000165, 19.672600000000156],
              [83.753792, 19.667761000000151],
              [83.743401, 19.659440000000185],
              [83.736869000000169, 19.65110100000015],
              [83.733115, 19.647591000000201],
              [83.727012, 19.647559],
              [83.72432000000012, 19.649259000000193],
              [83.721528, 19.651741000000179],
              [83.716605000000158, 19.661519000000105],
              [83.712510000000108, 19.665480000000109],
              [83.702958, 19.670882000000116],
              [83.693527000000103, 19.679399000000153],
              [83.68727, 19.681450000000208],
              [83.682106, 19.680670000000127],
              [83.6677770000001, 19.6734],
              [83.663964000000121, 19.66971900000015],
              [83.662193000000102, 19.66563],
              [83.655823, 19.657230000000133],
              [83.650542000000129, 19.655579000000156],
              [83.647766000000146, 19.652482],
              [83.641831, 19.65111000000018],
              [83.633606, 19.659691000000173],
              [83.630050000000139, 19.665589],
              [83.630287, 19.671711000000126],
              [83.635858, 19.68346],
              [83.6381, 19.69148000000018],
              [83.637421, 19.696912],
              [83.626969000000116, 19.7114820000001],
              [83.625556000000103, 19.72432],
              [83.620856000000103, 19.735880000000172],
              [83.618156000000141, 19.73774],
              [83.611571000000126, 19.73949],
              [83.606072, 19.74194000000011],
              [83.603387, 19.745131000000182],
              [83.60257800000015, 19.748240000000177],
              [83.602708, 19.751310000000156],
              [83.605278, 19.755280000000194],
              [83.611077000000122, 19.760331000000175],
              [83.613572000000119, 19.764709000000202],
              [83.614928, 19.77135],
              [83.611512, 19.788102000000205],
              [83.611603000000102, 19.792141],
              [83.614158000000131, 19.799119000000129],
              [83.61213, 19.80853],
              [83.609146, 19.81057],
              [83.600807, 19.811630000000203],
              [83.598457, 19.820819],
              [83.597001, 19.824582000000188],
              [83.595031000000105, 19.826490000000142],
              [83.590683, 19.821831000000142],
              [83.58158, 19.81627],
              [83.572609, 19.821899],
              [83.56014900000018, 19.826619000000161],
              [83.551484000000173, 19.831449000000131],
              [83.541009000000116, 19.83472],
              [83.537827, 19.83646100000021],
              [83.534867000000176, 19.840741000000143],
              [83.531571000000142, 19.850972],
              [83.529534000000169, 19.851499],
              [83.523856000000166, 19.849260000000125],
              [83.521607000000103, 19.85135],
              [83.522423000000103, 19.856540000000106],
              [83.520577000000159, 19.868091],
              [83.521187000000154, 19.87075],
              [83.526589, 19.878121000000128],
              [83.534308, 19.892459],
              [83.537376, 19.895112000000207],
              [83.544991, 19.899351],
              [83.549522000000181, 19.905571000000119],
              [83.552086, 19.91074900000012],
              [83.555024000000159, 19.918471],
              [83.55516, 19.922459000000167],
              [83.550454, 19.923460000000201],
              [83.546447000000143, 19.92630000000019],
              [83.542969000000127, 19.930411000000159],
              [83.536567000000133, 19.935861],
              [83.522988000000154, 19.943412],
              [83.504014, 19.949770000000168],
              [83.498353, 19.950541000000211],
              [83.488746, 19.95351],
              [83.492913, 19.959969000000111],
              [83.496208000000166, 19.9675820000001],
              [83.496741, 19.977211000000118],
              [83.495392, 19.981952000000202],
              [83.495789000000158, 19.98592],
              [83.498909000000182, 19.99077],
              [83.502692, 19.994672000000143],
              [83.504593, 19.998181],
              [83.515296, 20.007619],
              [83.520638, 20.010831000000106],
              [83.532143000000161, 20.012921000000173],
              [83.537002, 20.015961000000171],
              [83.54033, 20.024991000000167],
              [83.543083000000109, 20.02826100000021],
              [83.544906000000168, 20.032350000000118],
              [83.543518000000105, 20.035049000000178],
              [83.544420086487349, 20.039188979051115],
              [83.544476282398918, 20.039446881037119],
              [83.544906000000168, 20.041419000000186],
              [83.54647255303091, 20.043688869492197],
              [83.55013340344837, 20.056982363996664],
              [83.554892325460045, 20.069771966902973],
              [83.557271786465861, 20.084941030815166],
              [83.562328141103293, 20.093269144335572],
              [83.566789630489183, 20.099515229475852],
              [83.571548552500857, 20.105463881990428],
              [83.577027914290028, 20.107118767916003],
              [83.580225070085788, 20.108084378206396],
              [83.587609914290212, 20.108438208247716],
              [83.595938027810604, 20.105761314616181],
              [83.605753304459682, 20.101002392604524],
              [83.611404524348515, 20.09654090321856],
              [83.616758311611619, 20.092674279084118],
              [83.623004396751966, 20.090592250703988],
              [83.627465886137855, 20.089402520201073],
              [83.627643322972162, 20.084341027463431],
              [83.631927375523816, 20.080479541429209],
              [83.636686297535491, 20.081966704557882],
              [83.637578595412648, 20.086428193943785],
              [83.639958056418479, 20.088212789698154],
              [83.646204141558812, 20.092971711709819],
              [83.654829687704918, 20.098325498972933],
              [83.666726992734056, 20.100407527353067],
              [83.667024425359813, 20.093864009587033],
              [83.668511588488428, 20.091781981206903],
              [83.676244836757391, 20.091484548581203],
              [83.695577957429791, 20.089402520201073],
              [83.701243093004322, 20.093324537137384],
              [83.703311205698739, 20.094756307464191],
              [83.705339750421317, 20.098371261646257],
              [83.707589, 20.101000000000163],
              [83.707772695084643, 20.101769562839248],
              [83.708256692885456, 20.103797198596506],
              [83.708603000000139, 20.105248000000127],
              [83.710140155410599, 20.107478660460565],
              [83.711165387222735, 20.108966437200927],
              [83.711227418387281, 20.109056454426987],
              [83.714717961273308, 20.112073450380986],
              [83.717576528850969, 20.114544208397145],
              [83.720329000000149, 20.12208000000015],
              [83.723069000000166, 20.126930000000126],
              [83.723898775857577, 20.130353550740491],
              [83.72421300000012, 20.13165],
              [83.722253000000165, 20.13732],
              [83.726859, 20.143369000000174],
              [83.736618000000178, 20.14819000000011],
              [83.745461000000134, 20.155362000000192],
              [83.755752, 20.159480000000197],
              [83.760392, 20.158902000000179],
              [83.766678, 20.15556],
              [83.768692, 20.158051000000111],
              [83.770767, 20.1675390000002],
              [83.775277000000116, 20.169541],
              [83.783546, 20.174801000000112],
              [83.783951000000144, 20.178101000000137],
              [83.783256, 20.183019],
              [83.784569000000118, 20.18944],
              [83.782567926015048, 20.195619250634589],
              [83.781591759913312, 20.198633619442486],
              [83.780301697136039, 20.202617290857969],
              [83.776109328008985, 20.203158241712909],
              [83.771112459896784, 20.201968511209994],
              [83.764000000000166, 20.202460000000137],
              [83.748258699145907, 20.204604497150111],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Kendrapara",
          Dist_Code: "379",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [86.791665000000123, 20.373612000000374],
                [86.791945, 20.373334000000106],
                [86.79222100000031, 20.373334000000106],
                [86.792504000000108, 20.373056000000357],
                [86.793609000000217, 20.373056000000357],
                [86.7938010000003, 20.373241000000231],
                [86.793892000000355, 20.373334000000106],
                [86.794168000000269, 20.373334000000106],
                [86.794441000000106, 20.373056000000357],
                [86.794717, 20.373060000000518],
                [86.795562000000345, 20.372222000000473],
                [86.795829000000239, 20.372222000000473],
                [86.795829000000239, 20.371666000000115],
                [86.79528, 20.371112],
                [86.79528, 20.370002000000451],
                [86.795006000000313, 20.369660000000405],
                [86.794838000000283, 20.369257000000111],
                [86.794662000000272, 20.368771000000375],
                [86.794441000000106, 20.368320000000377],
                [86.794243000000264, 20.367910000000219],
                [86.794112999999783, 20.367486000000319],
                [86.793899000000209, 20.367130000000142],
                [86.793609000000217, 20.36667000000045],
                [86.792328, 20.365387000000162],
                [86.79222100000031, 20.36527700000067],
                [86.791665000000123, 20.36527700000067],
                [86.791116000000201, 20.36583300000029],
                [86.791116000000201, 20.366111000000554],
                [86.791061, 20.366250000000544],
                [86.790832999999836, 20.366819999999727],
                [86.790619000000262, 20.367358000000703],
                [86.790466, 20.367921],
                [86.790382000000179, 20.368580000000403],
                [86.790382000000179, 20.369295000000243],
                [86.790375000000296, 20.369975000000519],
                [86.790428000000276, 20.370670000000128],
                [86.790528, 20.371360000000376],
                [86.790557000000135, 20.372051000000166],
                [86.790626000000117, 20.372700000000403],
                [86.791032000000357, 20.373220000000455],
                [86.791665000000123, 20.373612000000374],
              ],
            ],
            [
              [
                [86.793908000000243, 20.379930000000336],
                [86.794357, 20.379670000000313],
                [86.794694, 20.379369000000107],
                [86.794906000000239, 20.379071000000348],
                [86.795036000000124, 20.378745000000144],
                [86.795211000000265, 20.378423000000165],
                [86.795348, 20.378043000000726],
                [86.795546000000257, 20.377701],
                [86.795745, 20.377411000000276],
                [86.795838000000273, 20.377220000000641],
                [86.796768000000313, 20.376611000000189],
                [86.797119, 20.376071000000245],
                [86.796982, 20.375059000000189],
                [86.796387, 20.374720000000192],
                [86.796387, 20.374444000000491],
                [86.795838000000273, 20.374451000000132],
                [86.795556, 20.374166000000393],
                [86.794997000000293, 20.374720000000192],
                [86.794168000000269, 20.375561000000168],
                [86.793892000000355, 20.375561000000168],
                [86.793892000000355, 20.375000000000281],
                [86.793609000000217, 20.374720000000192],
                [86.792777000000271, 20.374720000000192],
                [86.792504000000108, 20.375000000000281],
                [86.79222100000031, 20.375000000000281],
                [86.791665000000123, 20.375556000000635],
                [86.791656, 20.375830000000231],
                [86.791107000000338, 20.37639],
                [86.791107000000338, 20.377781000000191],
                [86.790832999999836, 20.378056000000349],
                [86.790832999999836, 20.378330000000286],
                [86.791107000000338, 20.378610000000204],
                [86.791116000000201, 20.378888000000469],
                [86.791945, 20.379722000000349],
                [86.79222100000031, 20.379720000000187],
                [86.792504000000108, 20.38],
                [86.793327000000133, 20.38],
                [86.793908000000243, 20.379930000000336],
              ],
            ],
            [
              [
                [86.793053000000185, 20.384171000000428],
                [86.792777000000271, 20.383891000000514],
                [86.791107000000338, 20.385562000000387],
                [86.791656, 20.386111000000533],
                [86.791945, 20.386111000000533],
                [86.793327000000133, 20.387501000000437],
                [86.793892000000355, 20.387501000000437],
                [86.794441000000106, 20.386940000000205],
                [86.794441000000106, 20.386667000000497],
                [86.794168000000269, 20.386391],
                [86.793892000000355, 20.386391],
                [86.793892000000355, 20.384452],
                [86.793892000000355, 20.384171000000428],
                [86.793053000000185, 20.384171000000428],
              ],
            ],
            [
              [
                [86.802780000000368, 20.420833000000354],
                [86.803612000000243, 20.419999000000466],
                [86.803886, 20.419999000000466],
                [86.804168000000274, 20.419719000000548],
                [86.804444000000188, 20.419721000000205],
                [86.804725000000332, 20.419445000000277],
                [86.805556000000337, 20.419445000000277],
                [86.805832000000109, 20.419721000000205],
                [86.807220000000171, 20.419721000000205],
                [86.807776, 20.419167],
                [86.808052, 20.419170000000403],
                [86.808326000000221, 20.419450000000317],
                [86.808608, 20.419450000000317],
                [86.808891, 20.419170000000403],
                [86.808891, 20.418889],
                [86.809449000000242, 20.418331000000304],
                [86.809449000000242, 20.41805700000037],
                [86.809723000000176, 20.417779000000106],
                [86.809998000000149, 20.417779000000106],
                [86.812232000000265, 20.415560000000365],
                [86.812232000000265, 20.415279],
                [86.813057000000327, 20.41444],
                [86.813057000000327, 20.414167000000358],
                [86.813331000000105, 20.4138910000006],
                [86.813057000000327, 20.41362],
                [86.813057000000327, 20.413331],
                [86.813331000000105, 20.413055000000206],
                [86.813331000000105, 20.412501000000358],
                [86.813606, 20.412221000000269],
                [86.813613000000117, 20.4116670000003],
                [86.813880000000182, 20.411391000000375],
                [86.813880000000182, 20.411111000000457],
                [86.814162000000266, 20.410833000000189],
                [86.814162000000266, 20.410555],
                [86.814454, 20.410281000000733],
                [86.814454, 20.408061000000369],
                [86.814721000000162, 20.407779000000115],
                [86.814721000000162, 20.40722],
                [86.8148640000001, 20.406691000000304],
                [86.814682000000332, 20.406247],
                [86.814461000000151, 20.405850000000722],
                [86.814347000000311, 20.405452000000476],
                [86.814461000000151, 20.405041000000203],
                [86.814637000000147, 20.404622000000753],
                [86.814659000000148, 20.404141000000546],
                [86.814507000000205, 20.403677999999896],
                [86.814393000000209, 20.403170000000326],
                [86.814201000000125, 20.40268],
                [86.814048, 20.402188],
                [86.813912000000158, 20.401721000000688],
                [86.813775, 20.401301000000213],
                [86.813736000000219, 20.400768000000536],
                [86.813606, 20.400280000000119],
                [86.813606, 20.4],
                [86.812768, 20.399170000000137],
                [86.812768, 20.398621000000155],
                [86.812501000000324, 20.398332000000259],
                [86.812501000000324, 20.397778],
                [86.812232000000265, 20.397502000000312],
                [86.812232000000265, 20.397222000000223],
                [86.811943000000142, 20.396944000000129],
                [86.811943000000142, 20.396390000000164],
                [86.811669, 20.396109000000362],
                [86.811416000000108, 20.39572000000032],
                [86.811179000000195, 20.395341000000368],
                [86.810958000000355, 20.394917000000639],
                [86.810792000000319, 20.394450000000568],
                [86.810548000000196, 20.394029],
                [86.810318, 20.393632000000192],
                [86.810158, 20.393222000000371],
                [86.810103000000339, 20.392766000000162],
                [86.810112, 20.392271],
                [86.809928000000227, 20.391902000000407],
                [86.809670000000196, 20.391560000000364],
                [86.809502000000151, 20.391171000000664],
                [86.809449000000242, 20.390833000000264],
                [86.809449000000242, 20.39027700000042],
                [86.809167000000159, 20.389999000000152],
                [86.809167000000159, 20.389432000000507],
                [86.808608, 20.388889000000344],
                [86.808608, 20.388611],
                [86.808326000000221, 20.388331000000157],
                [86.808335000000255, 20.387223000000173],
                [86.808052, 20.386943000000251],
                [86.808052, 20.386389000000232],
                [86.807776, 20.386111000000533],
                [86.807776, 20.385281],
                [86.80750300000031, 20.385001000000155],
                [86.80750300000031, 20.383891000000514],
                [86.807776, 20.383622000000283],
                [86.807776, 20.38194000000021],
                [86.80750300000031, 20.38166700000016],
                [86.80750300000031, 20.381110000000255],
                [86.807776, 20.380830000000397],
                [86.807776, 20.380557000000177],
                [86.80750300000031, 20.380279000000595],
                [86.80750300000031, 20.378330000000286],
                [86.807220000000171, 20.378056000000349],
                [86.807220000000171, 20.375000000000281],
                [86.806947000000122, 20.374720000000192],
                [86.806947000000122, 20.374444000000491],
                [86.806655000000291, 20.374170000000326],
                [86.806655000000291, 20.373890000000294],
                [86.804444000000188, 20.371670000000275],
                [86.804168000000274, 20.371670000000275],
                [86.803886, 20.371390000000186],
                [86.803612000000243, 20.371666000000115],
                [86.803612000000243, 20.371944000000209],
                [86.803337000000269, 20.372222000000473],
                [86.803337000000269, 20.372500000000226],
                [86.803612000000243, 20.37278],
                [86.803612000000243, 20.373888000000132],
                [86.804444000000188, 20.374722000000524],
                [86.803047, 20.37611],
                [86.803047, 20.376671000000496],
                [86.804444000000188, 20.378059000000459],
                [86.804444000000188, 20.378610000000204],
                [86.804734, 20.378891000000177],
                [86.804725000000332, 20.379169000000271],
                [86.805000000000149, 20.379444],
                [86.805000000000149, 20.379720000000187],
                [86.805267, 20.38],
                [86.805276, 20.380279000000595],
                [86.805556000000337, 20.380550000000646],
                [86.805556000000337, 20.381110000000255],
                [86.805657000000366, 20.381211000000459],
                [86.805832000000109, 20.381391],
                [86.805832000000109, 20.38166700000016],
                [86.806115, 20.381945000000254],
                [86.806106000000213, 20.382220000000299],
                [86.805832000000109, 20.382501],
                [86.805832000000109, 20.38333300000016],
                [86.805809000000338, 20.383900000000548],
                [86.805787000000109, 20.384440000000264],
                [86.805634000000197, 20.384955000000442],
                [86.805709000000178, 20.385429000000212],
                [86.805809000000338, 20.385890000000526],
                [86.805832000000109, 20.386362000000528],
                [86.805878000000163, 20.386852000000708],
                [86.806060000000329, 20.387351000000248],
                [86.806053000000233, 20.387861000000381],
                [86.805894000000222, 20.388340000000195],
                [86.805871000000124, 20.388850000000328],
                [86.805894000000222, 20.389311],
                [86.805702000000139, 20.389621000000485],
                [86.805436000000199, 20.389751000000441],
                [86.805085000000119, 20.389502000000274],
                [86.804741, 20.389008000000612],
                [86.804665000000156, 20.388875000000436],
                [86.804405000000131, 20.388436000000521],
                [86.804048000000293, 20.387920000000456],
                [86.803703000000297, 20.387481000000545],
                [86.802696000000125, 20.386498000000412],
                [86.802199, 20.386095],
                [86.801698000000371, 20.386102000000502],
                [86.801552000000171, 20.386569],
                [86.801522, 20.38713000000029],
                [86.801452, 20.387661000000147],
                [86.801247000000316, 20.388121],
                [86.801055000000233, 20.388638000000352],
                [86.800736, 20.389213000000151],
                [86.800492000000233, 20.38958700000034],
                [86.800308000000243, 20.389871000000593],
                [86.800415, 20.390450000000378],
                [86.800574, 20.391052000000453],
                [86.800834000000108, 20.39155100000016],
                [86.80111, 20.391941],
                [86.801942000000267, 20.392780000000236],
                [86.801942000000267, 20.393055],
                [86.80222400000018, 20.393333000000322],
                [86.80222400000018, 20.394719000000631],
                [86.801942000000267, 20.394999000000492],
                [86.801942000000267, 20.395556000000223],
                [86.801666000000324, 20.395829000000269],
                [86.801666000000324, 20.396109000000362],
                [86.80111, 20.396670000000594],
                [86.800987000000291, 20.396921000000528],
                [86.80069, 20.397126000000295],
                [86.800330000000301, 20.397349],
                [86.800002000000319, 20.397705],
                [86.799774000000113, 20.398224000000365],
                [86.799736, 20.398840000000511],
                [86.799897000000186, 20.399378000000123],
                [86.800551000000311, 20.399642000000252],
                [86.800973000000212, 20.40002],
                [86.80122400000019, 20.40039000000035],
                [86.801392, 20.400832000000317],
                [86.80222400000018, 20.401680000000507],
                [86.80222400000018, 20.401951000000334],
                [86.80111, 20.403056],
                [86.80111, 20.40333],
                [86.801392, 20.403610000000125],
                [86.801392, 20.404166000000483],
                [86.801666000000324, 20.404431000000383],
                [86.801666000000324, 20.406110000000236],
                [86.801392, 20.40639100000072],
                [86.801392, 20.406666],
                [86.80111, 20.406940000000127],
                [86.80111, 20.407501000000362],
                [86.800827, 20.407779000000115],
                [86.80111, 20.408061000000369],
                [86.80111, 20.408891000000263],
                [86.801392, 20.409167000000533],
                [86.801392, 20.409720000000103],
                [86.800834000000108, 20.41027900000017],
                [86.80047600000033, 20.41052000000024],
                [86.800469, 20.410921000000194],
                [86.800590000000327, 20.411359000000228],
                [86.800866, 20.411776000000422],
                [86.801392, 20.412223],
                [86.801666000000324, 20.412221000000269],
                [86.801942000000267, 20.412501000000358],
                [86.80222400000018, 20.412501000000358],
                [86.802498000000284, 20.412781000000276],
                [86.802780000000368, 20.412781000000276],
                [86.803337000000269, 20.412221000000269],
                [86.803612000000243, 20.412223],
                [86.803886, 20.411945000000394],
                [86.804168000000274, 20.411952000000262],
                [86.804734, 20.411391000000375],
                [86.805000000000149, 20.411391000000375],
                [86.805556000000337, 20.410830000000139],
                [86.805556000000337, 20.410555],
                [86.805832000000109, 20.410281000000733],
                [86.806388000000226, 20.41027900000017],
                [86.806947000000122, 20.410830000000139],
                [86.806115, 20.4116670000003],
                [86.806106000000213, 20.412221000000269],
                [86.806388000000226, 20.412501000000358],
                [86.806388000000226, 20.412777000000457],
                [86.806947000000122, 20.413333000000474],
                [86.805832000000109, 20.414445],
                [86.805000000000149, 20.41444],
                [86.804168000000274, 20.415277000000398],
                [86.804168000000274, 20.415831000000193],
                [86.803612000000243, 20.416389000000542],
                [86.803337000000269, 20.416389000000542],
                [86.803047, 20.41666000000043],
                [86.803054, 20.417777000000449],
                [86.80222400000018, 20.418609],
                [86.80222400000018, 20.418889],
                [86.801666000000324, 20.419450000000317],
                [86.801666000000324, 20.419999000000466],
                [86.802498000000284, 20.420833000000354],
                [86.802780000000368, 20.420833000000354],
              ],
            ],
            [
              [
                [86.789726, 20.38761],
                [86.789397000000207, 20.387540000000282],
                [86.788978000000199, 20.387770000000497],
                [86.789046000000127, 20.388151000000388],
                [86.78919200000017, 20.388691000000275],
                [86.78919200000017, 20.389231000000386],
                [86.789046000000127, 20.389972000000395],
                [86.789117000000118, 20.390592000000193],
                [86.789163000000244, 20.391031000000105],
                [86.789108, 20.391446000000141],
                [86.788978000000199, 20.39182000000039],
                [86.788903000000218, 20.392178000000506],
                [86.788887000000145, 20.39252200000038],
                [86.788887000000145, 20.392859000000549],
                [86.788942000000233, 20.393178000000312],
                [86.789101, 20.39346100000062],
                [86.789176, 20.393792000000126],
                [86.789277000000226, 20.394133000000291],
                [86.789420000000334, 20.394480000000382],
                [86.789514000000324, 20.394860000000385],
                [86.789673000000306, 20.395209000000133],
                [86.789719, 20.39558500000032],
                [86.789726, 20.395970000000371],
                [86.789726, 20.396385000000233],
                [86.789726, 20.396830000000644],
                [86.789726, 20.397320000000715],
                [86.789726, 20.397830000000106],
                [86.789726, 20.398361],
                [86.789726, 20.398890000000218],
                [86.790001000000288, 20.400180000000542],
                [86.789794, 20.400989000000543],
                [86.78929, 20.402001000000606],
                [86.788796, 20.403015000000263],
                [86.788581, 20.403893],
                [86.787795000000159, 20.405080000000787],
                [86.787889000000149, 20.405627000000376],
                [86.788064000000233, 20.406110000000236],
                [86.788331000000298, 20.40639100000072],
                [86.788331000000298, 20.406666],
                [86.788613, 20.406940000000127],
                [86.788613, 20.407779000000115],
                [86.789436, 20.408610000000458],
                [86.789436, 20.408891000000263],
                [86.789719, 20.409167000000533],
                [86.789719, 20.409445000000282],
                [86.790001000000288, 20.409720000000103],
                [86.790001000000288, 20.410555],
                [86.790284000000241, 20.410830000000139],
                [86.790284000000241, 20.411671000000233],
                [86.790557000000135, 20.411952000000262],
                [86.790557000000135, 20.412781000000276],
                [86.790284000000241, 20.413062],
                [86.790284000000241, 20.4138910000006],
                [86.790001000000288, 20.414172000000232],
                [86.790001000000288, 20.415279],
                [86.789712000000165, 20.415560000000365],
                [86.789719, 20.416111000000281],
                [86.790275, 20.416665000000304],
                [86.790001000000288, 20.416941],
                [86.790001000000288, 20.417499000000188],
                [86.789719, 20.417777000000449],
                [86.789712000000165, 20.419719000000548],
                [86.790001000000288, 20.419999000000466],
                [86.790001000000288, 20.421109000000111],
                [86.790284000000241, 20.421390000000422],
                [86.790275, 20.421668000000178],
                [86.790001000000288, 20.421939],
                [86.790001000000288, 20.424166],
                [86.790284000000241, 20.424441000000623],
                [86.790284000000241, 20.425002000000173],
                [86.790001000000288, 20.425278000000272],
                [86.790001000000288, 20.425834000000631],
                [86.790275, 20.426112000000153],
                [86.790284000000241, 20.426390000000421],
                [86.790414000000155, 20.426800000000238],
                [86.790573000000208, 20.427281000000445],
                [86.790832999999836, 20.427778000000327],
                [86.790557000000135, 20.428054000000252],
                [86.790557000000135, 20.428601000000409],
                [86.790832999999836, 20.428886000000372],
                [86.791107000000338, 20.429171000000331],
                [86.791389, 20.429171000000331],
                [86.791512, 20.42904700000053],
                [86.791945, 20.428612000000264],
                [86.791945, 20.428334000000174],
                [86.79222100000031, 20.428054000000252],
                [86.79222100000031, 20.427778000000327],
                [86.792504000000108, 20.4275],
                [86.792504000000108, 20.427220000000371],
                [86.792777000000271, 20.426944000000272],
                [86.792777000000271, 20.426666000000179],
                [86.793053000000185, 20.426390000000421],
                [86.793053000000185, 20.426112000000153],
                [86.793327000000133, 20.425832],
                [86.793327000000133, 20.425346],
                [86.793327000000133, 20.424940000000156],
                [86.793359, 20.424503],
                [86.793457000000259, 20.42404500000071],
                [86.793586, 20.423562000000228],
                [86.793609000000217, 20.423058000000591],
                [86.793609000000217, 20.422559000000369],
                [86.793618, 20.422101000000275],
                [86.793664000000305, 20.421681000000373],
                [86.7938010000003, 20.421289000000623],
                [86.79383, 20.420881000000229],
                [86.793664000000305, 20.420430000000234],
                [86.79358000000029, 20.419967],
                [86.793443000000181, 20.41953000000057],
                [86.793349000000191, 20.419099000000237],
                [86.793327000000133, 20.418680000000215],
                [86.793336000000323, 20.418299000000101],
                [86.793327000000133, 20.417930000000521],
                [86.793381000000167, 20.417570000000403],
                [86.793541000000275, 20.417262000000104],
                [86.793664000000305, 20.416927],
                [86.793869000000228, 20.416619000000587],
                [86.794022, 20.416250000000215],
                [86.794136000000293, 20.415847],
                [86.794168000000269, 20.415369999999875],
                [86.794168000000269, 20.414842000000416],
                [86.794220000000308, 20.414290000000218],
                [86.794402000000261, 20.41380200000037],
                [86.794441000000106, 20.413310000000362],
                [86.794457, 20.412861000000298],
                [86.794541000000251, 20.412430000000196],
                [86.794678, 20.412020000000716],
                [86.794678, 20.411560000000289],
                [86.794617000000116, 20.411070000000102],
                [86.794769, 20.410482000000282],
                [86.79454800000029, 20.410049000000523],
                [86.794158000000365, 20.40966099999968],
                [86.793899000000209, 20.409171000000352],
                [86.793700000000271, 20.408647000000538],
                [86.793443000000181, 20.408130000000366],
                [86.793297000000308, 20.407521000000425],
                [86.793099000000126, 20.406912000000652],
                [86.793053000000185, 20.406261],
                [86.793021000000209, 20.4056110000007],
                [86.792894000000203, 20.404962000000289],
                [86.7928390000001, 20.404319000000548],
                [86.792976000000209, 20.403672000000139],
                [86.793053000000185, 20.4030400000002],
                [86.793053000000185, 20.402455000000483],
                [86.79306, 20.401933],
                [86.793106000000165, 20.401477000000394],
                [86.793281000000235, 20.40108],
                [86.793327000000133, 20.400659000000239],
                [86.793327000000133, 20.40023900000028],
                [86.793327000000133, 20.399840000000321],
                [86.793381000000167, 20.39947100000051],
                [86.793541000000275, 20.399138000000502],
                [86.793541000000275, 20.398742],
                [86.79358000000029, 20.398357000000541],
                [86.793586, 20.398170000000501],
                [86.793602000000178, 20.397969000000383],
                [86.793609000000217, 20.3976],
                [86.793618, 20.397240000000117],
                [86.793687, 20.396909000000274],
                [86.793846000000116, 20.396590000000341],
                [86.793960000000283, 20.396230000000397],
                [86.79412000000022, 20.395875],
                [86.794190000000171, 20.395494],
                [86.79436600000011, 20.395113000000716],
                [86.79473100000034, 20.394733000000535],
                [86.795189, 20.394318000000109],
                [86.795357, 20.393819000000402],
                [86.795341000000334, 20.393352000000331],
                [86.794708000000171, 20.392921],
                [86.794288000000265, 20.392531000000414],
                [86.79412000000022, 20.392112],
                [86.793953000000243, 20.39169],
                [86.793839, 20.391209000000114],
                [86.793609000000217, 20.390769000000258],
                [86.793343, 20.390332000000168],
                [86.793083, 20.389901000000229],
                [86.792816000000329, 20.389520000000513],
                [86.792511000000147, 20.389270000000405],
                [86.792205, 20.389049],
                [86.791932000000187, 20.388862],
                [86.791688000000221, 20.38865],
                [86.791419000000161, 20.388490000000385],
                [86.791168000000226, 20.38829700000019],
                [86.79087, 20.388050000000185],
                [86.790414000000155, 20.387797],
                [86.789726, 20.38761],
              ],
            ],
            [
              [
                [86.802726000000149, 20.459472000000286],
                [86.802598000000202, 20.459472000000286],
                [86.802024000000117, 20.459538000000403],
                [86.801522, 20.459672000000463],
                [86.801308000000205, 20.459943000000344],
                [86.801240000000277, 20.460479000000301],
                [86.801240000000277, 20.461155999999786],
                [86.801377000000102, 20.461831000000579],
                [86.801452, 20.46225],
                [86.801949000000135, 20.462507000000411],
                [86.802452, 20.462642000000351],
                [86.802810000000164, 20.462642000000351],
                [86.803307, 20.462507000000411],
                [86.803596000000354, 20.46197200000034],
                [86.803596000000354, 20.461491000000358],
                [86.803239000000104, 20.460819000000352],
                [86.802878000000121, 20.460278000000525],
                [86.802726000000149, 20.459472000000286],
              ],
            ],
            [
              [
                [86.805276, 20.491945000000207],
                [86.806388000000226, 20.490833],
                [86.806388000000226, 20.490554000000706],
                [86.806947000000122, 20.490001000000625],
                [86.806947000000122, 20.489720000000826],
                [86.807220000000171, 20.48944500000027],
                [86.807220000000171, 20.489167000000343],
                [86.80750300000031, 20.488879000000502],
                [86.80750300000031, 20.488610000000271],
                [86.807776, 20.488329999999674],
                [86.807776, 20.487779],
                [86.808052, 20.487500000000459],
                [86.807776, 20.48722000000037],
                [86.807776, 20.486944000000104],
                [86.808052, 20.486666],
                [86.808052, 20.48639100000053],
                [86.808326000000221, 20.48611],
                [86.808326000000221, 20.485559000000247],
                [86.808608, 20.48528100000021],
                [86.808608, 20.48444],
                [86.809449000000242, 20.483612000000274],
                [86.809167000000159, 20.483334],
                [86.809167000000159, 20.483056000000484],
                [86.808608, 20.482500000000122],
                [86.808891, 20.48222],
                [86.808891, 20.481666000000242],
                [86.808608, 20.481390000000484],
                [86.809449000000242, 20.48056000000053],
                [86.809449000000242, 20.48],
                [86.809167000000159, 20.47971],
                [86.809167000000159, 20.479444000000392],
                [86.808891, 20.479166000000131],
                [86.808891, 20.478060000000479],
                [86.809167000000159, 20.477780000000386],
                [86.809167000000159, 20.477222000000204],
                [86.809449000000242, 20.476943000000226],
                [86.809449000000242, 20.476668000000242],
                [86.808608, 20.475829000000257],
                [86.808335000000255, 20.474446000000224],
                [86.808326000000221, 20.474170000000466],
                [86.808052, 20.473901000000236],
                [86.807776, 20.473901000000236],
                [86.807152000000244, 20.473263000000596],
                [86.806947000000122, 20.473055000000606],
                [86.806947000000122, 20.472777000000512],
                [86.806655000000291, 20.472499000000251],
                [86.806655000000291, 20.471941],
                [86.805832000000109, 20.471111000000345],
                [86.805832000000109, 20.469165000000594],
                [86.806030000000121, 20.468380999999845],
                [86.806030000000121, 20.467572000000242],
                [86.805946000000105, 20.466890000000141],
                [86.805732, 20.466690000000476],
                [86.805588000000142, 20.466487000000367],
                [86.80552, 20.46601000000032],
                [86.805306000000243, 20.465678000000192],
                [86.805237, 20.465211000000291],
                [86.804877000000303, 20.464600000000186],
                [86.804786000000249, 20.464452],
                [86.804444000000188, 20.463889000000503],
                [86.804168000000274, 20.463611000000409],
                [86.803612000000243, 20.463611000000409],
                [86.802498000000284, 20.464709000000308],
                [86.802780000000368, 20.465001000000537],
                [86.802780000000368, 20.465555],
                [86.803047, 20.465830000000548],
                [86.803054, 20.46666700000014],
                [86.802780000000368, 20.466943],
                [86.802780000000368, 20.467770000000311],
                [86.802498000000284, 20.46805500000027],
                [86.802498000000284, 20.469721000000444],
                [86.80222400000018, 20.470001000000302],
                [86.80222400000018, 20.470560000000368],
                [86.801942000000267, 20.470833],
                [86.801942000000267, 20.472221000000498],
                [86.80111, 20.473055000000606],
                [86.80111, 20.473333000000135],
                [86.800827, 20.473609000000234],
                [86.800827, 20.473901000000236],
                [86.80111, 20.474170000000466],
                [86.80111, 20.474446000000224],
                [86.801392, 20.474719000000274],
                [86.801392, 20.475277],
                [86.801536, 20.475426000000649],
                [86.801666000000324, 20.475556],
                [86.801666000000324, 20.475829000000257],
                [86.801942000000267, 20.476109000000175],
                [86.801942000000267, 20.476390000000148],
                [86.803886, 20.478331000000306],
                [86.805267, 20.47971],
                [86.805276, 20.480278000000279],
                [86.805832000000109, 20.480834000000467],
                [86.805832000000109, 20.481109999999713],
                [86.804168000000274, 20.48278],
                [86.803886, 20.482778000000391],
                [86.803337000000269, 20.48333],
                [86.803886, 20.483890000000368],
                [86.803886, 20.484166000000467],
                [86.803612000000243, 20.48444],
                [86.803612000000243, 20.485000000000408],
                [86.804168000000274, 20.485559000000247],
                [86.804168000000274, 20.485839000000166],
                [86.803886, 20.48611],
                [86.803886, 20.48639100000053],
                [86.804168000000274, 20.486669000000116],
                [86.804444000000188, 20.486666],
                [86.804725000000332, 20.486944000000104],
                [86.804734, 20.48722000000037],
                [86.805000000000149, 20.487498000000297],
                [86.805000000000149, 20.488332000000177],
                [86.804444000000188, 20.488879000000502],
                [86.804444000000188, 20.489167000000343],
                [86.804168000000274, 20.48944500000027],
                [86.804168000000274, 20.489720000000826],
                [86.804444000000188, 20.490001000000625],
                [86.804444000000188, 20.490833],
                [86.804168000000274, 20.49111100000027],
                [86.804168000000274, 20.491391000000359],
                [86.804444000000188, 20.491671000000277],
                [86.805000000000149, 20.491667000000113],
                [86.805276, 20.491945000000207],
              ],
            ],
            [
              [
                [86.874161, 20.673609999999879],
                [86.873887000000295, 20.673330000000131],
                [86.873611000000196, 20.673334000000121],
                [86.873199000000199, 20.673143000000486],
                [86.872413000000194, 20.672673000000142],
                [86.872062000000113, 20.672671000000317],
                [86.87198, 20.673090000000506],
                [86.872223000000105, 20.673890000000476],
                [86.872223000000105, 20.674169000000454],
                [86.873338000000146, 20.675278],
                [86.873338000000146, 20.67555000000015],
                [86.875558000000169, 20.677781000000376],
                [86.875831, 20.677781000000376],
                [86.876114, 20.678059000000243],
                [86.876953000000114, 20.678891000000529],
                [86.87721900000011, 20.678891000000529],
                [86.877778000000191, 20.67945200000042],
                [86.878327000000112, 20.67945200000042],
                [86.878890000000339, 20.678891000000529],
                [86.878890000000339, 20.6786110000001],
                [86.878334000000152, 20.678054000000369],
                [86.878334000000152, 20.677779000000381],
                [86.876387000000179, 20.675830000000243],
                [86.876387000000179, 20.675556000000139],
                [86.874443, 20.673609999999879],
                [86.874161, 20.673609999999879],
              ],
            ],
            [
              [
                [86.798058, 20.691943],
                [86.797844000000154, 20.690305000000645],
                [86.797630000000353, 20.689822],
                [86.797630000000353, 20.689227000000237],
                [86.797279000000273, 20.688621],
                [86.79657, 20.687811000000348],
                [86.795777, 20.685582000000633],
                [86.79528, 20.684167000000112],
                [86.79528, 20.683889000000185],
                [86.794997000000293, 20.683611000000436],
                [86.794997000000293, 20.683331],
                [86.794724, 20.683055000000646],
                [86.794717, 20.682781000000542],
                [86.794441000000106, 20.682501000000112],
                [86.794441000000106, 20.682221000000702],
                [86.794168000000269, 20.681945000000265],
                [86.794168000000269, 20.681667],
                [86.793892000000355, 20.681391000000243],
                [86.793892000000355, 20.680830000000579],
                [86.793609000000217, 20.680555000000361],
                [86.793609000000217, 20.680281000000431],
                [86.793327000000133, 20.680001000000342],
                [86.793327000000133, 20.679720000000536],
                [86.793053000000185, 20.679445000000722],
                [86.793053000000185, 20.679171000000107],
                [86.792504000000108, 20.6786110000001],
                [86.792504000000108, 20.67833200000063],
                [86.79222100000031, 20.678054000000369],
                [86.79222100000031, 20.677779000000381],
                [86.791107000000338, 20.676671000000336],
                [86.791107000000338, 20.676391000000475],
                [86.790832999999836, 20.676110000000101],
                [86.790557000000135, 20.675830000000243],
                [86.79016800000025, 20.67534000000051],
                [86.789673000000306, 20.674930000000526],
                [86.789245000000264, 20.675139000000453],
                [86.789245000000264, 20.676892000000517],
                [86.789315000000187, 20.678241],
                [86.789315000000187, 20.679253000000124],
                [86.789436, 20.680830000000579],
                [86.789712000000165, 20.681111000000378],
                [86.789712000000165, 20.682781000000542],
                [86.790001000000288, 20.683055000000646],
                [86.790001000000288, 20.683333000000172],
                [86.790275, 20.683611000000436],
                [86.790284000000241, 20.683889000000185],
                [86.790557000000135, 20.68416899999988],
                [86.790557000000135, 20.684999000000342],
                [86.790832999999836, 20.685279000000261],
                [86.790832999999836, 20.685557000000522],
                [86.791116000000201, 20.685833000000454],
                [86.791107000000338, 20.686109000000211],
                [86.791389, 20.686389000000243],
                [86.791389, 20.686945000000602],
                [86.791665000000123, 20.68722100000036],
                [86.791656, 20.68749],
                [86.791945, 20.687779999999741],
                [86.791945, 20.68805500000024],
                [86.79222100000031, 20.688333000000508],
                [86.79222100000031, 20.688609000000266],
                [86.792777000000271, 20.689167000000449],
                [86.792777000000271, 20.689719000000302],
                [86.793053000000185, 20.69000200000027],
                [86.793053000000185, 20.690555000000696],
                [86.793327000000133, 20.690831000000454],
                [86.793327000000133, 20.691112000000256],
                [86.793609000000217, 20.691392000000171],
                [86.793892000000355, 20.691390000000521],
                [86.793892000000355, 20.691943],
                [86.794168000000269, 20.692222],
                [86.794168000000269, 20.692778000000427],
                [86.794717, 20.693331000000338],
                [86.794717, 20.69389],
                [86.794997000000293, 20.694166000000504],
                [86.794997000000293, 20.694444],
                [86.79528, 20.694724000000512],
                [86.79528, 20.695829000000284],
                [86.795829000000239, 20.696388000000351],
                [86.795838000000273, 20.69722],
                [86.796387, 20.697780000000417],
                [86.796387, 20.698061000000386],
                [86.796937000000213, 20.698610000000311],
                [86.796944000000252, 20.698888000000572],
                [86.797500000000284, 20.699444000000423],
                [86.797500000000284, 20.699720000000859],
                [86.798332000000173, 20.700559000000105],
                [86.798607000000217, 20.700559000000105],
                [86.799157, 20.7],
                [86.799157, 20.699720000000859],
                [86.798890000000355, 20.699444000000423],
                [86.7985460000003, 20.69907700000044],
                [86.798477, 20.698610000000311],
                [86.798477, 20.696850000000548],
                [86.7985460000003, 20.696176000000374],
                [86.798409000000149, 20.694959000000207],
                [86.798332000000173, 20.694166000000504],
                [86.798332000000173, 20.692222],
                [86.798058, 20.691943],
              ],
            ],
            [
              [
                [87.003021000000246, 20.710790000000195],
                [87.002305, 20.710332000000161],
                [87.002166000000258, 20.710600000000277],
                [87.002166000000258, 20.710872],
                [87.002380000000343, 20.711141000000275],
                [87.002517000000338, 20.711410000000338],
                [87.00266300000014, 20.711815000000449],
                [87.002952000000263, 20.712150000000118],
                [87.003089000000188, 20.71249000000034],
                [87.003235, 20.712896000000224],
                [87.003303000000344, 20.713433000000574],
                [87.004021, 20.714240000000181],
                [87.004304000000204, 20.714719],
                [87.004593000000142, 20.715259000000113],
                [87.00502, 20.715729000000291],
                [87.005263000000156, 20.716116000000163],
                [87.005867, 20.717080000000177],
                [87.006385, 20.71762],
                [87.006866000000102, 20.718701000000515],
                [87.007866, 20.719710000000358],
                [87.008302000000214, 20.720049999999897],
                [87.008728000000104, 20.720250000000245],
                [87.009017000000227, 20.720250000000245],
                [87.0091630000001, 20.719979000000418],
                [87.009086000000295, 20.719710000000358],
                [87.008796, 20.719371000000532],
                [87.008805000000308, 20.718833000000469],
                [87.008659000000122, 20.718495000000352],
                [87.00851300000032, 20.718090000000242],
                [87.008302000000214, 20.717679000000199],
                [87.008156, 20.717078000000352],
                [87.007659000000146, 20.716672000000525],
                [87.007378000000344, 20.716403000000462],
                [87.006943, 20.715594000000344],
                [87.006875000000136, 20.715188000000293],
                [87.006303, 20.714309000000235],
                [87.00602, 20.71336500000012],
                [87.005592, 20.712891000000123],
                [87.005234000000243, 20.712422000000227],
                [87.005042000000145, 20.712239000000345],
                [87.004876000000124, 20.712084000000512],
                [87.004379000000171, 20.711747000000511],
                [87.003953000000124, 20.711480000000275],
                [87.003586000000126, 20.71128200000026],
                [87.003381000000203, 20.711141000000275],
                [87.003021000000246, 20.710790000000195],
              ],
            ],
            [
              [
                [87.00851300000032, 20.708123000000338],
                [87.007659000000146, 20.707989000000278],
                [87.00522700000019, 20.707991000000103],
                [87.004447000000113, 20.708062000000265],
                [87.003661000000108, 20.708330000000441],
                [87.002433000000323, 20.708666000000672],
                [87.002433000000323, 20.709003000000163],
                [87.002861000000209, 20.709538000000514],
                [87.003287000000256, 20.709948999999877],
                [87.003784000000152, 20.710420000000163],
                [87.004434000000103, 20.710892000000108],
                [87.004639000000196, 20.711084000000366],
                [87.005081000000345, 20.711501],
                [87.005858, 20.712380000000163],
                [87.006287000000142, 20.713051000000231],
                [87.006569000000226, 20.713591000000175],
                [87.007141, 20.714270000000223],
                [87.007347000000252, 20.714810000000281],
                [87.007645, 20.715480000000124],
                [87.008140000000182, 20.716223000000124],
                [87.008721, 20.716962000000528],
                [87.009286000000287, 20.717707000000694],
                [87.009927, 20.718309],
                [87.010642000000217, 20.719056000000247],
                [87.011071000000229, 20.71938],
                [87.011497000000119, 20.71986500000019],
                [87.011994000000158, 20.720405000000309],
                [87.01265, 20.720811000000136],
                [87.013284000000326, 20.721148000000138],
                [87.01391500000031, 20.721549],
                [87.014419000000302, 20.721889000000143],
                [87.015137, 20.722160000000766],
                [87.015504000000178, 20.722231000000242],
                [87.015725, 20.722223999999809],
                [87.015832000000145, 20.722222000000212],
                [87.016114000000172, 20.721944000000118],
                [87.016427000000164, 20.72154],
                [87.016579000000306, 20.721201],
                [87.016862000000103, 20.720797000000569],
                [87.017067000000367, 20.720330000000665],
                [87.017213000000169, 20.719922000000334],
                [87.017434, 20.719450000000332],
                [87.017502000000135, 20.718981000000433],
                [87.017571000000288, 20.718571000000619],
                [87.017571000000288, 20.717689],
                [87.017639000000244, 20.717424000000388],
                [87.017785, 20.717221000000102],
                [87.017785, 20.716684000000267],
                [87.017502000000135, 20.716109000000468],
                [87.017486, 20.71602],
                [87.017434, 20.71561000000025],
                [87.017434, 20.715006000000351],
                [87.017220000000208, 20.714331000000467],
                [87.016937, 20.713930000000282],
                [87.016579000000306, 20.713251000000465],
                [87.016151, 20.712440000000122],
                [87.015868000000282, 20.712105000000285],
                [87.015510000000162, 20.71183300000018],
                [87.0148700000003, 20.7110930000004],
                [87.014152000000237, 20.710416000000517],
                [87.013733, 20.710081000000169],
                [87.013154000000256, 20.709810000000285],
                [87.012582000000151, 20.709352000000415],
                [87.011802, 20.709001000000509],
                [87.011155000000244, 20.708798000000396],
                [87.010727, 20.708531000000729],
                [87.0098720000003, 20.708330000000441],
                [87.0091630000001, 20.708191000000451],
                [87.00851300000032, 20.708123000000338],
              ],
            ],
            [
              [
                [87.057510000000306, 20.744359000000767],
                [87.057611000000335, 20.74394900000021],
                [87.057426000000291, 20.743680000000488],
                [87.057130000000129, 20.743869000000355],
                [87.056717, 20.74406],
                [87.056282000000166, 20.744081000000499],
                [87.056084000000268, 20.74400800000063],
                [87.055892000000171, 20.743935],
                [87.055473000000163, 20.743821000000473],
                [87.055108000000331, 20.743575000000529],
                [87.054771000000173, 20.743352000000751],
                [87.054215000000212, 20.743511000000233],
                [87.053695000000147, 20.743593000000256],
                [87.053178000000159, 20.743582000000398],
                [87.052612000000224, 20.743463],
                [87.051956000000345, 20.743315000000504],
                [87.05164400000011, 20.743292000000388],
                [87.051322, 20.743144],
                [87.050873, 20.74299200000041],
                [87.050477000000157, 20.742731999999869],
                [87.050133000000116, 20.74259],
                [87.04981100000029, 20.742731999999869],
                [87.049531, 20.743076000000254],
                [87.049278, 20.743472000000164],
                [87.049027000000123, 20.743842000000424],
                [87.049119, 20.74421800000027],
                [87.049531, 20.744523000000122],
                [87.049957000000106, 20.74474],
                [87.050361000000336, 20.744988000000372],
                [87.050750000000207, 20.745170000000364],
                [87.051163, 20.745259000000257],
                [87.051589, 20.745291],
                [87.052018000000132, 20.745371],
                [87.052467000000135, 20.745517],
                [87.052934, 20.745599000000478],
                [87.053360000000154, 20.745781],
                [87.053786000000201, 20.745982000000193],
                [87.054306000000267, 20.746080000000116],
                [87.054885000000212, 20.745911000000714],
                [87.055466000000123, 20.745683000000319],
                [87.05599200000033, 20.745405],
                [87.056480000000178, 20.745180000000456],
                [87.05692200000037, 20.744981000000163],
                [87.057289000000338, 20.74480100000039],
                [87.057426000000291, 20.744610000000698],
                [87.057510000000306, 20.744359000000767],
              ],
            ],
            [
              [
                [87.07055600000011, 20.736213000000131],
                [87.07039, 20.735516],
                [87.07, 20.73527700000033],
                [87.069444000000246, 20.735835000000517],
                [87.069168000000147, 20.735835000000517],
                [87.068245000000189, 20.736744],
                [87.068047000000135, 20.736940000000285],
                [87.068047000000135, 20.737779000000213],
                [87.068336000000244, 20.738057000000474],
                [87.068336000000244, 20.7386110000005],
                [87.069168000000147, 20.739445],
                [87.069489, 20.739445],
                [87.069724000000164, 20.739445],
                [87.07, 20.739721000000138],
                [87.069779000000239, 20.740008],
                [87.069656000000208, 20.740161000000164],
                [87.069558000000114, 20.740610000000167],
                [87.069679000000335, 20.740867000000488],
                [87.069717000000125, 20.741191000000295],
                [87.069733, 20.741569000000133],
                [87.069724000000164, 20.742018000000478],
                [87.069724000000164, 20.742522000000285],
                [87.069763000000179, 20.74304900000072],
                [87.069909000000209, 20.743529],
                [87.070030000000244, 20.744010000000451],
                [87.070237000000162, 20.744462000000389],
                [87.070267000000328, 20.745029000000212],
                [87.070283000000217, 20.745610000000507],
                [87.070312000000143, 20.746147999999888],
                [87.070481, 20.746611000000534],
                [87.070565000000144, 20.747046000000463],
                [87.07068600000018, 20.747481],
                [87.070877000000365, 20.74799000000024],
                [87.071167, 20.748461],
                [87.071495000000112, 20.748783],
                [87.071794000000224, 20.748812],
                [87.071930000000108, 20.748673000000103],
                [87.072060000000334, 20.748539],
                [87.072060000000334, 20.748190000000132],
                [87.072120000000197, 20.747760000000252],
                [87.072006000000144, 20.747240000000197],
                [87.071953000000207, 20.746713000000451],
                [87.071944000000173, 20.746219000000107],
                [87.071953000000207, 20.745770000000274],
                [87.071944000000173, 20.745362],
                [87.071944000000173, 20.744958],
                [87.071937000000318, 20.744550000000398],
                [87.071876000000231, 20.744111000000483],
                [87.071746000000118, 20.7437],
                [87.071709000000268, 20.743231000000144],
                [87.071746000000118, 20.742731999999869],
                [87.071618000000214, 20.742290000000246],
                [87.071443, 20.741875000000388],
                [87.071388000000326, 20.741401],
                [87.071326000000212, 20.740947000000684],
                [87.071137000000348, 20.740580000000186],
                [87.071044000000299, 20.740371000000259],
                [87.070975000000118, 20.740222000000408],
                [87.070846000000287, 20.739817000000464],
                [87.070718000000312, 20.739370000000232],
                [87.070572000000183, 20.738994000000385],
                [87.070435000000188, 20.738618000000198],
                [87.070312000000143, 20.738221000000404],
                [87.070289, 20.737759000000374],
                [87.070319000000183, 20.737271000000472],
                [87.070458000000286, 20.736790000000489],
                [87.07055600000011, 20.736213000000131],
              ],
            ],
            [
              [
                [87.090836000000124, 20.757521000000672],
                [87.091109000000117, 20.757186000000328],
                [87.091401000000346, 20.756881000000131],
                [87.091720000000223, 20.756623000000271],
                [87.092103000000151, 20.756386000000187],
                [87.0925000000003, 20.75613100000043],
                [87.092903000000234, 20.755846000000467],
                [87.093338000000344, 20.755570000000542],
                [87.093796, 20.755370000000365],
                [87.094223, 20.755171000000583],
                [87.094407000000146, 20.754848000000489],
                [87.094421000000267, 20.754490000000541],
                [87.094323000000131, 20.754168],
                [87.094147000000163, 20.753861000000363],
                [87.093933000000206, 20.753521000000141],
                [87.09368, 20.753141000000646],
                [87.093345000000198, 20.752801000000424],
                [87.092880000000136, 20.752525000000325],
                [87.092324000000275, 20.752341000000566],
                [87.092055000000215, 20.752229000000163],
                [87.091766000000163, 20.752220000000133],
                [87.091369000000142, 20.752240000000537],
                [87.090888000000319, 20.752318000000223],
                [87.090592000000171, 20.752402],
                [87.090371000000147, 20.752461000000547],
                [87.089835000000264, 20.7525],
                [87.089309, 20.75255900000047],
                [87.088828000000248, 20.752723000000341],
                [87.088372000000305, 20.752769000000281],
                [87.08792800000019, 20.75278],
                [87.087501000000245, 20.75278],
                [87.087066000000263, 20.75279],
                [87.086647000000241, 20.752840000000443],
                [87.086243000000223, 20.752942000000697],
                [87.085838000000109, 20.752810000000462],
                [87.085418000000161, 20.752692],
                [87.084937000000181, 20.752680000000336],
                [87.084397000000237, 20.752901000000517],
                [87.083930000000166, 20.753077000000182],
                [87.083497, 20.753252000000423],
                [87.083030000000264, 20.753323],
                [87.082688000000232, 20.753327000000233],
                [87.082574, 20.753330000000513],
                [87.082383, 20.753305000000349],
                [87.08213, 20.753270000000153],
                [87.081733, 20.753136],
                [87.081291000000107, 20.75309000000032],
                [87.080887000000118, 20.753040000000109],
                [87.08048200000033, 20.753141000000646],
                [87.080040000000153, 20.753245000000216],
                [87.07985700000016, 20.753186000000479],
                [87.079591000000306, 20.753104000000455],
                [87.079087000000385, 20.753031],
                [87.078606000000178, 20.752904000000221],
                [87.078164, 20.752764],
                [87.077797, 20.75260500000018],
                [87.077523, 20.752480000000158],
                [87.077316, 20.752379000000467],
                [87.076903000000172, 20.752450000000177],
                [87.07653, 20.752484000000148],
                [87.076393, 20.752467999999674],
                [87.076179000000295, 20.752445000000247],
                [87.0758280000002, 20.752270000000344],
                [87.075431000000179, 20.752170000000259],
                [87.075028000000245, 20.752078000000264],
                [87.07459900000012, 20.752240000000537],
                [87.074189000000146, 20.752480000000158],
                [87.073829, 20.752680000000336],
                [87.073455000000124, 20.752810000000462],
                [87.073113, 20.752999000000266],
                [87.072724000000207, 20.753321000000479],
                [87.072480000000311, 20.754099999999873],
                [87.072518, 20.754558000000142],
                [87.072646000000347, 20.75503],
                [87.072853, 20.755550000000138],
                [87.073348000000152, 20.755871000000404],
                [87.073959, 20.756122000000225],
                [87.074576, 20.756379000000145],
                [87.075203, 20.756580000000266],
                [87.075782000000103, 20.756742000000539],
                [87.076286000000252, 20.756928000000126],
                [87.076767000000274, 20.757058000000193],
                [87.077218000000272, 20.757232000000212],
                [87.077667000000105, 20.75746],
                [87.07818700000017, 20.757669000000302],
                [87.078613000000217, 20.757991000000512],
                [87.079019, 20.758301],
                [87.079429, 20.758471],
                [87.079955000000254, 20.758310000000218],
                [87.080445, 20.757943000000232],
                [87.080796000000177, 20.757633000000332],
                [87.081099, 20.75741800000031],
                [87.081428000000287, 20.757300000000491],
                [87.081801, 20.75726100000065],
                [87.0822, 20.757279000000207],
                [87.082574, 20.757359],
                [87.082916, 20.757480000000495],
                [87.083251000000118, 20.757660000000264],
                [87.083527000000217, 20.757899000000517],
                [87.083741000000131, 20.758230000000189],
                [87.083839000000111, 20.758661000000355],
                [87.083839000000111, 20.759171000000432],
                [87.083764000000116, 20.75970000000012],
                [87.08362500000031, 20.760201],
                [87.083426000000188, 20.760671000000166],
                [87.083183000000176, 20.761090000000419],
                [87.08287, 20.76151200000049],
                [87.082496000000148, 20.762002000000159],
                [87.082161000000127, 20.762640000000594],
                [87.082009000000184, 20.763032000000347],
                [87.082168000000237, 20.763251000000132],
                [87.08250300000023, 20.763365000000359],
                [87.082832000000266, 20.763554000000163],
                [87.083176000000137, 20.763753999999828],
                [87.083497, 20.764021000000238],
                [87.083946000000225, 20.764240000000594],
                [87.084527000000179, 20.76439],
                [87.084694000000113, 20.764370000000206],
                [87.08534300000035, 20.764290000000297],
                [87.086152000000354, 20.764110000000525],
                [87.086426000000117, 20.763871000000272],
                [87.086670000000396, 20.763590000000473],
                [87.086907000000252, 20.763255000000296],
                [87.08714400000018, 20.762870000000241],
                [87.087372, 20.762501000000437],
                [87.087593000000354, 20.762141000000494],
                [87.087807000000154, 20.761768999999898],
                [87.088058000000146, 20.761371000000391],
                [87.088333000000134, 20.760922000000161],
                [87.088623000000297, 20.760450000000215],
                [87.088935000000191, 20.760035000000354],
                [87.089295000000305, 20.759725000000454],
                [87.089623000000287, 20.759440000000151],
                [87.089913000000124, 20.759121],
                [87.09014100000033, 20.758729000000464],
                [87.090348, 20.758285000000281],
                [87.090576, 20.757881000000278],
                [87.090836000000124, 20.757521000000672],
              ],
            ],
            [
              [
                [86.870651000000208, 20.771779000000375],
                [86.871856000000292, 20.771640000000385],
                [86.872780000000191, 20.77167000000042],
                [86.874161, 20.77167000000042],
                [86.874443, 20.771392000000159],
                [86.876084, 20.77072000000032],
                [86.877290000000286, 20.770316],
                [86.878434000000297, 20.769979],
                [86.881073000000328, 20.769035],
                [86.882995000000193, 20.768561000000371],
                [86.884850000000171, 20.768224000000199],
                [86.88713800000032, 20.767889000000363],
                [86.88906200000018, 20.767549000000141],
                [86.890564, 20.767349000000475],
                [86.893059000000321, 20.767219000000178],
                [86.895553, 20.76722100000034],
                [86.895835000000289, 20.766945000000241],
                [86.896943000000121, 20.766945000000241],
                [86.897226000000316, 20.76722100000034],
                [86.899170000000169, 20.76722100000034],
                [86.899445, 20.766945000000241],
                [86.899719000000317, 20.766945000000241],
                [86.900002000000299, 20.76722100000034],
                [86.903053000000156, 20.76722100000034],
                [86.903336000000124, 20.767499000000608],
                [86.904168000000169, 20.767499000000608],
                [86.904441000000219, 20.767779000000527],
                [86.9050000000003, 20.767779000000527],
                [86.905280000000204, 20.768060000000329],
                [86.907220000000152, 20.768055000000285],
                [86.907502000000179, 20.768333000000545],
                [86.910050000000325, 20.768329000000215],
                [86.911406, 20.768470000000317],
                [86.913407000000277, 20.768671000000264],
                [86.914542, 20.768671000000264],
                [86.915543, 20.768739000000377],
                [86.917968000000172, 20.768609000000247],
                [86.918832000000265, 20.768538],
                [86.919990000000311, 20.768493000000255],
                [86.920539000000119, 20.768468000000492],
                [86.921897, 20.768329000000215],
                [86.923256, 20.768199000000262],
                [86.925248000000337, 20.767930000000199],
                [86.926697000000317, 20.767814000000381],
                [86.926964, 20.767793000000434],
                [86.927116000000325, 20.767841000000484],
                [86.927818000000158, 20.768060000000329],
                [86.928338, 20.768055000000285],
                [86.9286120000003, 20.768333000000545],
                [86.928887, 20.768055000000285],
                [86.930321000000319, 20.768055000000285],
                [86.930558000000232, 20.768060000000329],
                [86.930831, 20.767779000000527],
                [86.93139700000016, 20.767779000000527],
                [86.931656000000288, 20.768060000000329],
                [86.932219000000174, 20.767499000000608],
                [86.932502000000312, 20.767779000000527],
                [86.932778, 20.767779000000527],
                [86.933051, 20.767499000000608],
                [86.933892, 20.767499000000608],
                [86.935096000000186, 20.767299],
                [86.9366, 20.766891000000378],
                [86.938384, 20.766556000000204],
                [86.93952900000032, 20.766572],
                [86.94110100000016, 20.766492],
                [86.942099000000141, 20.766572],
                [86.943611, 20.766670000000428],
                [86.946113000000295, 20.766667000000322],
                [86.946252, 20.766806000000312],
                [86.946389, 20.766945000000241],
                [86.946662000000217, 20.766945000000241],
                [86.947221000000269, 20.76638700000046],
                [86.947777000000301, 20.766389],
                [86.948059000000313, 20.766670000000428],
                [86.948609, 20.766667000000322],
                [86.948745, 20.766804000000146],
                [86.948891000000273, 20.766945000000241],
                [86.949723000000148, 20.766945000000241],
                [86.949997000000323, 20.766667000000322],
                [86.951667000000242, 20.766667000000322],
                [86.951943000000341, 20.766945000000241],
                [86.952210000000235, 20.766941000000251],
                [86.952499000000202, 20.76722100000034],
                [86.953055000000163, 20.76722100000034],
                [86.953331, 20.766945000000241],
                [86.957222000000144, 20.766945000000241],
                [86.957497000000188, 20.766667000000322],
                [86.960900000000194, 20.766670000000428],
                [86.962967000000148, 20.766740000000365],
                [86.964966000000373, 20.767139000000324],
                [86.966393000000309, 20.767540000000277],
                [86.968467000000118, 20.768285000000272],
                [86.970176000000308, 20.769204000000624],
                [86.971671000000228, 20.769744],
                [86.973030000000207, 20.770282000000115],
                [86.974534000000105, 20.77102],
                [86.975389000000149, 20.771301],
                [86.977310000000145, 20.771301],
                [86.978057000000135, 20.771668000000425],
                [86.978333, 20.771943],
                [86.980553000000185, 20.771943],
                [86.982497000000293, 20.772221000000677],
                [86.982780000000261, 20.772221000000677],
                [86.983056, 20.771943],
                [86.983176000000327, 20.771943],
                [86.983329000000239, 20.771943],
                [86.984473, 20.771743],
                [86.986686000000162, 20.771809000000356],
                [86.987700000000231, 20.771809000000356],
                [86.988045000000142, 20.771809000000356],
                [86.989166000000168, 20.771668000000425],
                [86.990547, 20.77167000000042],
                [86.990836000000144, 20.771392000000159],
                [86.991112000000243, 20.771392000000159],
                [86.99138600000019, 20.77111200000024],
                [86.991944000000188, 20.77111200000024],
                [86.992234000000209, 20.770831000000264],
                [86.992500000000149, 20.770833],
                [86.992776, 20.770555000000339],
                [86.993056000000337, 20.770562000000208],
                [86.994155, 20.769439000000201],
                [86.994164000000168, 20.769167000000433],
                [86.994720000000171, 20.768609000000247],
                [86.994720000000171, 20.768333000000545],
                [86.995003000000153, 20.768055000000285],
                [86.995003000000153, 20.767779000000527],
                [86.995279000000252, 20.767499000000608],
                [86.995279000000252, 20.766670000000428],
                [86.995552000000117, 20.766389],
                [86.995552000000117, 20.765831000000439],
                [86.995835000000255, 20.765557000000509],
                [86.995828, 20.765279000000241],
                [86.996391, 20.764721000000289],
                [86.996391, 20.764445000000361],
                [86.996667000000315, 20.764167],
                [86.996667000000315, 20.76361100000025],
                [86.996949000000242, 20.76333099999982],
                [86.996949000000242, 20.763055000000627],
                [86.997223000000346, 20.762770000000156],
                [86.997223000000346, 20.762501000000437],
                [86.997489000000115, 20.762221000000348],
                [86.997498000000164, 20.761945000000249],
                [86.997779000000136, 20.761667],
                [86.997779000000136, 20.761111000000366],
                [86.998337000000319, 20.760561000000333],
                [86.998337000000319, 20.760000999999814],
                [86.998611, 20.759730000000499],
                [86.998611, 20.7586100000002],
                [86.998886000000283, 20.758332000000618],
                [86.998886000000283, 20.755832000000389],
                [86.999169, 20.755556],
                [86.999169, 20.755000000000102],
                [86.999443, 20.754720000000187],
                [86.999443, 20.754444000000483],
                [86.999725000000225, 20.753056000000182],
                [87.000001000000324, 20.753334000000446],
                [87.000274, 20.753056000000182],
                [87.000550000000132, 20.75305899999989],
                [87.000550000000132, 20.75278],
                [87.000831000000275, 20.7525],
                [87.000831000000275, 20.751671],
                [87.001389, 20.751110000000146],
                [87.001389, 20.750278000000371],
                [87.001954000000268, 20.750000000000451],
                [87.001945000000248, 20.749722000000183],
                [87.003053000000222, 20.748612000000371],
                [87.003609000000253, 20.74833400000011],
                [87.003891000000337, 20.748056000000183],
                [87.003891000000337, 20.747500000000226],
                [87.003326000000115, 20.74694100000016],
                [87.003609000000253, 20.746666000000285],
                [87.003609000000253, 20.746390000000584],
                [87.004447000000113, 20.74611200000032],
                [87.004447000000113, 20.745831000000518],
                [87.004997000000316, 20.745556000000303],
                [87.004723000000212, 20.745282000000365],
                [87.004997000000316, 20.74500200000028],
                [87.005835, 20.744731],
                [87.005835, 20.744172],
                [87.006943, 20.743060000000579],
                [87.006943, 20.741389000000307],
                [87.007233, 20.741109000000218],
                [87.006943, 20.740833000000343],
                [87.006943, 20.739445],
                [87.006385, 20.739167000000119],
                [87.006683, 20.738889],
                [87.006385, 20.7386110000005],
                [87.006385, 20.737777000000616],
                [87.006111000000132, 20.737501000000119],
                [87.006111000000132, 20.736111000000218],
                [87.005835, 20.735831000000523],
                [87.005835, 20.734723000000312],
                [87.005555000000172, 20.73444300000028],
                [87.005555000000172, 20.732779000000445],
                [87.005279, 20.732501000000518],
                [87.005279, 20.731391000000141],
                [87.004997000000316, 20.731110000000168],
                [87.004997000000316, 20.729444000000509],
                [87.004723000000212, 20.729166000000241],
                [87.004723000000212, 20.728330000000533],
                [87.0041650000001, 20.727778000000335],
                [87.004174000000134, 20.726390000000261],
                [87.003891000000337, 20.72611000000034],
                [87.003891000000337, 20.725000000000701],
                [87.003723, 20.724836],
                [87.003609000000253, 20.724722000000437],
                [87.003609000000253, 20.723056000000266],
                [87.003333000000154, 20.722778000000172],
                [87.003326000000115, 20.721670000000355],
                [87.002777, 20.721110000000746],
                [87.002777, 20.720000000000365],
                [87.002221000000347, 20.719441000000298],
                [87.002221000000347, 20.718334000000194],
                [87.00166200000028, 20.717777000000293],
                [87.00166200000028, 20.716941000000244],
                [87.001389, 20.716668000000535],
                [87.001389, 20.71582900000038],
                [87.001113000000132, 20.715555000000446],
                [87.001106000000263, 20.715280000000455],
                [87.000831000000275, 20.714999000000144],
                [87.000831000000275, 20.714719],
                [87.000557000000171, 20.714445000000122],
                [87.000550000000132, 20.71417],
                [87.000001000000324, 20.713889000000101],
                [86.999732000000265, 20.713408000000125],
                [86.999429, 20.71280900000027],
                [86.998994000000309, 20.712239000000345],
                [86.99855800000033, 20.711740000000301],
                [86.998116000000138, 20.711375000000142],
                [86.997733, 20.711059000000258],
                [86.997405000000114, 20.710760000000384],
                [86.997002000000151, 20.710532000000509],
                [86.996589000000284, 20.710279000000178],
                [86.996131, 20.710042000000495],
                [86.995591000000132, 20.709810000000285],
                [86.995003000000153, 20.709513000000239],
                [86.994294000000124, 20.709461000000196],
                [86.993560000000329, 20.709520000000619],
                [86.992851, 20.709687],
                [86.992142000000214, 20.709721000000226],
                [86.991463000000167, 20.709759000000187],
                [86.990882, 20.709948999999877],
                [86.990401, 20.710146999999775],
                [86.989982, 20.710279000000178],
                [86.989572, 20.710420000000163],
                [86.98912000000027, 20.710580000000444],
                [86.98861, 20.71081],
                [86.988083000000287, 20.711011000000379],
                [86.987541, 20.711200000000186],
                [86.987014000000144, 20.711355000000246],
                [86.986420000000336, 20.711389],
                [86.985818000000251, 20.711451000000174],
                [86.985832, 20.711679],
                [86.985558000000282, 20.711667000000315],
                [86.985275000000101, 20.711945000000576],
                [86.985, 20.711945000000576],
                [86.984726000000336, 20.712223000000446],
                [86.984437, 20.712221000000277],
                [86.984170000000148, 20.712499000000371],
                [86.983062000000174, 20.712499000000371],
                [86.982780000000261, 20.712779000000463],
                [86.98222400000013, 20.712777000000639],
                [86.981941000000162, 20.713055000000221],
                [86.981668000000269, 20.713055000000221],
                [86.98139200000017, 20.713333000000482],
                [86.980836000000394, 20.713333000000482],
                [86.980553000000185, 20.713611000000181],
                [86.980072000000206, 20.713650000000595],
                [86.979630000000256, 20.713746000000178],
                [86.97921100000022, 20.713860000000405],
                [86.978737, 20.713901000000586],
                [86.978249, 20.713937000000151],
                [86.977807000000197, 20.714099000000427],
                [86.97734900000016, 20.714160000000671],
                [86.976884, 20.71417],
                [86.976419000000121, 20.714190000000311],
                [86.975983, 20.714309000000235],
                [86.975532, 20.714420000000693],
                [86.975067000000337, 20.714450000000674],
                [86.974609, 20.714509000000412],
                [86.974167000000278, 20.714710000000704],
                [86.973702000000216, 20.714888000000705],
                [86.973182000000151, 20.714986000000462],
                [86.972779000000216, 20.714995000000155],
                [86.972610000000245, 20.714999000000144],
                [86.971977000000138, 20.714951000000607],
                [86.97130700000028, 20.714771000000262],
                [86.970595000000316, 20.7147800000003],
                [86.969857000000204, 20.714951000000607],
                [86.969100000000125, 20.71494],
                [86.967667, 20.715141000000298],
                [86.966393000000309, 20.714999000000144],
                [86.96577500000015, 20.714999000000144],
                [86.965317, 20.71500100000031],
                [86.964866000000228, 20.714999000000144],
                [86.9644100000002, 20.71500100000031],
                [86.963943, 20.714995000000155],
                [86.963455, 20.714933000000538],
                [86.962928000000289, 20.714760000000407],
                [86.962327000000329, 20.714719],
                [86.961716000000237, 20.714682000000547],
                [86.961160000000206, 20.714525000000318],
                [86.960601000000153, 20.714491000000177],
                [86.960091, 20.7144700000004],
                [86.959626000000284, 20.714450000000674],
                [86.959213, 20.714450000000674],
                [86.958808000000118, 20.714429000000216],
                [86.95838800000017, 20.714443000000294],
                [86.957933000000168, 20.714443000000294],
                [86.957420000000226, 20.714461000000362],
                [86.95690200000017, 20.714571],
                [86.95636, 20.714660000000144],
                [86.955804, 20.714714000000182],
                [86.955232000000166, 20.714721000000388],
                [86.954667, 20.714742000000168],
                [86.954193000000188, 20.714860000000495],
                [86.953750000000113, 20.714981000000414],
                [86.953331, 20.714999000000144],
                [86.952950000000186, 20.714999000000144],
                [86.952554000000276, 20.714999000000144],
                [86.952148000000108, 20.714999000000144],
                [86.951745000000173, 20.715043000000374],
                [86.951394, 20.715223000000375],
                [86.951255000000273, 20.71520900000024],
                [86.951043000000183, 20.715186000000127],
                [86.950653000000187, 20.715031000000288],
                [86.950241000000219, 20.714999000000144],
                [86.949805000000239, 20.715038000000156],
                [86.949340000000106, 20.715152000000153],
                [86.948859000000283, 20.715300000000351],
                [86.948388000000236, 20.715501000000636],
                [86.947868000000355, 20.715571000000178],
                [86.947387000000376, 20.715681000000409],
                [86.946984, 20.715840000000238],
                [86.946587, 20.716027000000445],
                [86.946145, 20.716102],
                [86.945632, 20.716150000000308],
                [86.945092000000201, 20.716351000000255],
                [86.944442, 20.716388999999648],
                [86.943688000000165, 20.716401000000126],
                [86.942886000000257, 20.716460000000549],
                [86.942115000000214, 20.716631000000344],
                [86.941306, 20.716645000000252],
                [86.940780000000288, 20.71656500000017],
                [86.940522000000243, 20.716529000000257],
                [86.939788, 20.71641000000033],
                [86.939118, 20.716388999999648],
                [86.938508000000226, 20.716401000000126],
                [86.937972000000272, 20.716490000000583],
                [86.937461, 20.716640000000375],
                [86.936944000000139, 20.716672000000525],
                [86.93641800000033, 20.716672000000525],
                [86.93615800000029, 20.716665000000145],
                [86.935898000000265, 20.716658000000614],
                [86.935394000000286, 20.716601000000303],
                [86.93492000000019, 20.71643100000011],
                [86.93441, 20.716351000000255],
                [86.933938000000282, 20.716159000000342],
                [86.933441000000386, 20.716091000000226],
                [86.932921000000348, 20.715977],
                [86.932395000000142, 20.715852],
                [86.931878, 20.715740000000146],
                [86.93141300000029, 20.715567000000245],
                [86.93096800000022, 20.715409000000641],
                [86.930542000000145, 20.715252000000245],
                [86.930152000000405, 20.715031000000288],
                [86.92970300000016, 20.714881000000329],
                [86.929200000000137, 20.714742000000168],
                [86.928712000000232, 20.714651000000284],
                [86.928254, 20.7144700000004],
                [86.927773000000158, 20.714300000000545],
                [86.927331, 20.714145000000137],
                [86.926902000000254, 20.713910000000617],
                [86.926430000000252, 20.71366100000045],
                [86.925927000000215, 20.713408000000125],
                [86.925475000000262, 20.713119000000685],
                [86.925004000000214, 20.712909000000362],
                [86.924507000000148, 20.71272],
                [86.924071000000282, 20.71249000000034],
                [86.923638000000196, 20.712230000000314],
                [86.923148000000296, 20.712027000000599],
                [86.922608000000224, 20.711861000000734],
                [86.922127000000202, 20.71157100000033],
                [86.92167600000019, 20.71122000000025],
                [86.921227, 20.710849000000103],
                [86.920776000000316, 20.71055],
                [86.920372000000143, 20.710276999999842],
                [86.919983, 20.710031000000637],
                [86.919518, 20.709912000000198],
                [86.919098, 20.709709000000483],
                [86.918716000000217, 20.709461000000196],
                [86.918289000000271, 20.709269000000457],
                [86.917802, 20.709142000000266],
                [86.917366000000271, 20.70890900000034],
                [86.916892000000104, 20.7087],
                [86.916382000000198, 20.708574000000734],
                [86.91600800000019, 20.708335000000485],
                [86.915680000000208, 20.708098],
                [86.915459, 20.708014000000386],
                [86.915290000000127, 20.707950000000434],
                [86.914880000000309, 20.707770000000433],
                [86.914413000000181, 20.707551000000247],
                [86.91390900000026, 20.707321],
                [86.913437000000243, 20.707040000000283],
                [86.913034000000295, 20.706753000000671],
                [86.912612000000237, 20.706514000000418],
                [86.912163000000334, 20.706323000000104],
                [86.911735000000292, 20.706101000000213],
                [86.911315, 20.705839000000534],
                [86.910866000000141, 20.705600000000285],
                [86.910392, 20.705370000000638],
                [86.909943000000212, 20.705078000000295],
                [86.909462000000346, 20.704821000000145],
                [86.909011000000348, 20.70455800000024],
                [86.908624000000302, 20.704251],
                [86.90822700000011, 20.703920000000373],
                [86.907805000000209, 20.703635],
                [86.907379000000134, 20.703341000000641],
                [86.906930000000315, 20.703057],
                [86.90647900000026, 20.702781000000297],
                [86.90603, 20.702489000000465],
                [86.905601, 20.70222200000023],
                [86.905166000000335, 20.701944000000307],
                [86.904708000000284, 20.701669000000489],
                [86.904191000000111, 20.701432],
                [86.903609000000287, 20.701240000000489],
                [86.903024000000215, 20.701067000000418],
                [86.902511000000217, 20.700830000000504],
                [86.90203, 20.700549000000187],
                [86.901574000000139, 20.700278000000306],
                [86.9011, 20.700032000000242],
                [86.900580000000318, 20.699859000000284],
                [86.900115000000227, 20.699652000000238],
                [86.899780000000234, 20.699323000000327],
                [86.899498000000307, 20.698963000000216],
                [86.899192000000227, 20.698646000000107],
                [86.898826000000128, 20.698391000000182],
                [86.898324, 20.698290999999866],
                [86.897918000000161, 20.69804],
                [86.897522000000251, 20.697778000000252],
                [86.897118000000233, 20.697541000000335],
                [86.896667000000249, 20.697360999999823],
                [86.896232, 20.697183000000557],
                [86.895851000000206, 20.696928000000238],
                [86.895500000000297, 20.696650000000144],
                [86.895202000000126, 20.696340000000468],
                [86.894821000000235, 20.696151000000437],
                [86.894379000000114, 20.69603],
                [86.893921, 20.695811000000383],
                [86.893417, 20.695499000000151],
                [86.892891000000233, 20.695121000000309],
                [86.892319, 20.694681000000511],
                [86.891753000000264, 20.694198],
                [86.89116800000015, 20.693778],
                [86.890678000000293, 20.693350000000517],
                [86.890222, 20.692992000000171],
                [86.889816000000209, 20.692591000000217],
                [86.889404000000226, 20.692260000000712],
                [86.888977, 20.6919500000003],
                [86.888542000000115, 20.691661000000401],
                [86.88813900000018, 20.691369000000172],
                [86.887779, 20.691061000000499],
                [86.887437, 20.690779000000241],
                [86.887047000000265, 20.690540000000507],
                [86.886673, 20.690282000000302],
                [86.88627, 20.69000200000027],
                [86.885857000000186, 20.689719000000302],
                [86.885467, 20.689439000000213],
                [86.885139000000137, 20.689131000000309],
                [86.884873000000297, 20.688773000000364],
                [86.884560000000334, 20.68844700000022],
                [86.8842, 20.688101],
                [86.883751000000217, 20.687741],
                [86.883316, 20.687315000000119],
                [86.882867000000232, 20.686861000000242],
                [86.882477000000151, 20.686344000000471],
                [86.882012000000174, 20.685901000000396],
                [86.881486000000208, 20.685528000000428],
                [86.88098200000023, 20.685140000000327],
                [86.880570000000233, 20.684691000000438],
                [86.880203000000265, 20.684249000000133],
                [86.87976100000013, 20.683921000000336],
                [86.879380000000239, 20.6836],
                [86.879081000000141, 20.683269000000386],
                [86.878739, 20.683032000000306],
                [86.878434000000297, 20.682761000000479],
                [86.87812, 20.682430000000632],
                [86.877823000000191, 20.681979000000236],
                [86.877463, 20.681526000000414],
                [86.877083000000241, 20.681188000000354],
                [86.876738000000245, 20.680892000000533],
                [86.876442000000154, 20.680607],
                [86.876153000000187, 20.680320000000446],
                [86.875838, 20.680033000000147],
                [86.87551900000031, 20.679691000000101],
                [86.875175, 20.67934000000059],
                [86.874824, 20.678989000000453],
                [86.874482000000327, 20.678649000000231],
                [86.874122000000213, 20.678351],
                [86.873741, 20.678061],
                [86.873352, 20.677788000000415],
                [86.873017, 20.677460000000107],
                [86.872757000000249, 20.677070000000523],
                [86.872451000000339, 20.676710000000408],
                [86.872100000000188, 20.676400000000111],
                [86.871727000000121, 20.676110000000101],
                [86.871353000000198, 20.675830000000243],
                [86.87097900000019, 20.67555000000015],
                [86.870628, 20.675251000000113],
                [86.870323000000255, 20.674909],
                [86.870086, 20.674545000000471],
                [86.869887000000276, 20.674200000000209],
                [86.869666000000265, 20.673920000000287],
                [86.869438, 20.67369],
                [86.869185000000101, 20.673451000000391],
                [86.868973000000295, 20.673145000000311],
                [86.868684, 20.672831000000425],
                [86.868431, 20.672366],
                [86.868278000000188, 20.671712000000404],
                [86.867943000000182, 20.671165],
                [86.867501, 20.670720000000355],
                [86.867050000000376, 20.670310000000196],
                [86.866637000000125, 20.669948000000428],
                [86.866357000000193, 20.66954],
                [86.866088000000133, 20.669211000000413],
                [86.865837000000198, 20.668920000000121],
                [86.865600000000299, 20.668621],
                [86.865327, 20.66831300000069],
                [86.865021000000326, 20.667983000000387],
                [86.8647, 20.667609000000532],
                [86.864333000000258, 20.667235000000343],
                [86.863930000000309, 20.666859000000493],
                [86.863517000000101, 20.666451000000105],
                [86.863029, 20.666137000000273],
                [86.862526000000145, 20.665850000000145],
                [86.861992, 20.665503],
                [86.861388000000289, 20.665002000000467],
                [86.861106000000277, 20.665002000000467],
                [86.860832000000102, 20.664774],
                [86.859178000000242, 20.664721000000149],
                [86.858886, 20.665002000000467],
                [86.858330000000237, 20.665002000000467],
                [86.857224, 20.666112000000336],
                [86.85721500000021, 20.667222000000315],
                [86.857498000000348, 20.667500000000242],
                [86.857498000000348, 20.668334000000463],
                [86.857781000000145, 20.668610000000221],
                [86.857781000000145, 20.669166000000583],
                [86.858330000000237, 20.66972],
                [86.858330000000237, 20.67],
                [86.860276000000141, 20.671944000000391],
                [86.86028300000018, 20.672220000000145],
                [86.860832000000102, 20.672781000000548],
                [86.860832000000102, 20.673059000000301],
                [86.861388000000289, 20.673609999999879],
                [86.86444, 20.676666000000289],
                [86.86444, 20.67694],
                [86.864989000000193, 20.677501000000454],
                [86.864999000000111, 20.677779000000381],
                [86.865281000000195, 20.678050000000205],
                [86.865281000000195, 20.678891000000529],
                [86.864989000000193, 20.679171000000107],
                [86.864999000000111, 20.679445000000722],
                [86.864723000000168, 20.679720000000536],
                [86.864723000000168, 20.680001000000342],
                [86.86444, 20.680281000000431],
                [86.86444, 20.680561000000349],
                [86.863328000000223, 20.681671000000161],
                [86.862779000000145, 20.681667],
                [86.862503, 20.681945000000265],
                [86.862220000000249, 20.681945000000265],
                [86.861947, 20.68222300000053],
                [86.860557000000284, 20.68222300000053],
                [86.86028300000018, 20.682501000000112],
                [86.858330000000237, 20.682501000000112],
                [86.858063000000158, 20.682781000000542],
                [86.857781000000145, 20.682781000000542],
                [86.857498000000348, 20.683059000000238],
                [86.857224, 20.683055000000646],
                [86.856942000000316, 20.683331],
                [86.856942000000316, 20.68416899999988],
                [86.858063000000158, 20.685279000000261],
                [86.858063000000158, 20.685560000000233],
                [86.859444000000195, 20.686945000000602],
                [86.859444000000195, 20.68722100000036],
                [86.859727000000348, 20.68749],
                [86.859727000000348, 20.687779999999741],
                [86.860276000000141, 20.688333000000508],
                [86.860276000000141, 20.688611000000261],
                [86.862503, 20.6908340000005],
                [86.863052000000124, 20.690831000000454],
                [86.863328000000223, 20.691112000000256],
                [86.863608000000156, 20.691112000000256],
                [86.863891000000294, 20.691392000000171],
                [86.866943000000191, 20.691392000000171],
                [86.867234000000323, 20.691670000000439],
                [86.868057000000334, 20.691668000000611],
                [86.868148, 20.691759000000157],
                [86.868333000000277, 20.691943],
                [86.86888900000028, 20.691943],
                [86.869163, 20.692222],
                [86.869445, 20.692222],
                [86.870004000000151, 20.69278],
                [86.870277, 20.69278],
                [86.871109000000303, 20.693612000000307],
                [86.871109000000303, 20.69389],
                [86.871665000000263, 20.694444],
                [86.871665000000263, 20.69472200000018],
                [86.871948000000245, 20.694999999999702],
                [86.871948000000245, 20.695280000000306],
                [86.874161, 20.697500000000499],
                [86.874161, 20.697780000000417],
                [86.874999, 20.698610000000311],
                [86.875266000000153, 20.698610000000311],
                [86.875558000000169, 20.6988900000004],
                [86.875824000000335, 20.69894300000038],
                [86.8759000000002, 20.698956000000347],
                [86.876387000000179, 20.699444000000423],
                [86.876663000000278, 20.699444000000423],
                [86.876946000000231, 20.699721999999777],
                [86.87721900000011, 20.699720000000859],
                [86.877778000000191, 20.700281000000409],
                [86.87805100000017, 20.700281000000409],
                [86.878327000000112, 20.700559000000105],
                [86.87861, 20.700559000000105],
                [86.879448000000338, 20.701391000000395],
                [86.8797220000001, 20.701391000000395],
                [86.879998, 20.701669000000489],
                [86.880554000000345, 20.701666000000436],
                [86.880836, 20.701944000000307],
                [86.881112, 20.701944000000307],
                [86.883888000000169, 20.704720000000517],
                [86.883888000000169, 20.705001000000316],
                [86.884164, 20.705281000000181],
                [86.884164, 20.705554000000397],
                [86.884444, 20.705833000000379],
                [86.884453, 20.706111000000302],
                [86.884720000000101, 20.70639100000022],
                [86.884720000000101, 20.70666700000049],
                [86.885276000000246, 20.707221000000683],
                [86.885276000000246, 20.708054999999884],
                [86.885003, 20.708330000000441],
                [86.885003, 20.708620000000447],
                [86.884720000000101, 20.708891000000271],
                [86.884720000000101, 20.709167000000768],
                [86.884444, 20.709445000000297],
                [86.884453, 20.709721000000226],
                [86.884164, 20.71000100000014],
                [86.884164, 20.710276999999842],
                [86.883605, 20.710831000000606],
                [86.883605, 20.711111000000297],
                [86.881942, 20.712779000000463],
                [86.881668000000317, 20.712777000000639],
                [86.88138600000029, 20.713055000000221],
                [86.881112, 20.713055000000221],
                [86.880554000000345, 20.713611000000181],
                [86.880287, 20.713609000000243],
                [86.879998, 20.713889000000101],
                [86.8797220000001, 20.713889000000101],
                [86.879448000000338, 20.71417],
                [86.879173000000137, 20.71417],
                [86.878890000000339, 20.714450000000674],
                [86.87861, 20.714445000000122],
                [86.878334000000152, 20.714721000000388],
                [86.87805100000017, 20.714719],
                [86.87805100000017, 20.714999000000144],
                [86.877778000000191, 20.715280000000455],
                [86.877778000000191, 20.715555000000446],
                [86.877502000000263, 20.71582900000038],
                [86.877502000000263, 20.716109000000468],
                [86.87721900000011, 20.716388999999648],
                [86.87721900000011, 20.719444000000347],
                [86.877502000000263, 20.719724000000266],
                [86.877502000000263, 20.720834000000249],
                [86.877778000000191, 20.721110000000746],
                [86.877778000000191, 20.721390000000603],
                [86.87805100000017, 20.721666000000365],
                [86.87805100000017, 20.721944000000118],
                [86.878327000000112, 20.722220000000384],
                [86.878334000000152, 20.722778000000172],
                [86.87861, 20.723051000000218],
                [86.87861, 20.72389000000015],
                [86.878890000000339, 20.724166000000476],
                [86.878890000000339, 20.724722000000437],
                [86.879166, 20.725000000000701],
                [86.879173000000137, 20.725830000000311],
                [86.879448000000338, 20.72611000000034],
                [86.879448000000338, 20.726944000000284],
                [86.8797220000001, 20.727220000000209],
                [86.8797220000001, 20.727500000000241],
                [86.879448000000338, 20.727778000000335],
                [86.879448000000338, 20.728059000000709],
                [86.878890000000339, 20.728610000000621],
                [86.878890000000339, 20.732501000000518],
                [86.878327000000112, 20.733061000000127],
                [86.87805100000017, 20.732790000000247],
                [86.87805100000017, 20.732501000000518],
                [86.877778000000191, 20.732220000000545],
                [86.877778000000191, 20.730279000000333],
                [86.877502000000263, 20.730000000000352],
                [86.877502000000263, 20.729440000000345],
                [86.877778000000191, 20.729166000000241],
                [86.877778000000191, 20.728330000000533],
                [86.87805100000017, 20.728056000000429],
                [86.87805100000017, 20.72611000000034],
                [86.877778000000191, 20.725830000000311],
                [86.877778000000191, 20.725276000000459],
                [86.877502000000263, 20.725000000000701],
                [86.877502000000263, 20.724720000000609],
                [86.87721900000011, 20.724446000000338],
                [86.87721900000011, 20.724170000000239],
                [86.876953000000114, 20.72389000000015],
                [86.876953000000114, 20.723619000000323],
                [86.876663000000278, 20.723329000000486],
                [86.876663000000278, 20.722778000000172],
                [86.876387000000179, 20.722500000000249],
                [86.876387000000179, 20.721941000000182],
                [86.876114, 20.721666000000365],
                [86.876107000000317, 20.72028000000028],
                [86.875831, 20.72000200000053],
                [86.875831, 20.71889200000015],
                [86.875558000000169, 20.718612000000117],
                [86.875558000000169, 20.718331000000312],
                [86.875831, 20.718056000000441],
                [86.875831, 20.717221000000102],
                [86.876114, 20.716943000000406],
                [86.876114, 20.716109000000468],
                [86.876387000000179, 20.71582900000038],
                [86.876387000000179, 20.715280000000455],
                [86.877502000000263, 20.71417],
                [86.877502000000263, 20.713889000000101],
                [86.87805100000017, 20.713331000000146],
                [86.878334000000152, 20.713333000000482],
                [86.87861, 20.713055000000221],
                [86.878890000000339, 20.713055000000221],
                [86.879166, 20.712777000000639],
                [86.879448000000338, 20.712779000000463],
                [86.879998, 20.712221000000277],
                [86.88028, 20.712223000000446],
                [86.880836, 20.711667000000315],
                [86.881112, 20.711679],
                [86.882233000000198, 20.710559],
                [86.882500000000263, 20.710559],
                [86.883332000000138, 20.709721000000226],
                [86.883332000000138, 20.709167000000768],
                [86.883888000000169, 20.708620000000447],
                [86.883888000000169, 20.707221000000683],
                [86.883615000000347, 20.706942000000478],
                [86.883615000000347, 20.70666700000049],
                [86.883056, 20.706111000000302],
                [86.883056, 20.705833000000379],
                [86.882774, 20.705833000000379],
                [86.880554000000345, 20.703610000000705],
                [86.88028, 20.703610000000705],
                [86.8797220000001, 20.703057],
                [86.879448000000338, 20.703061],
                [86.87861, 20.702220000000406],
                [86.878334000000152, 20.70222200000023],
                [86.877778000000191, 20.701666000000436],
                [86.877502000000263, 20.701669000000489],
                [86.876663000000278, 20.700830000000504],
                [86.876387000000179, 20.700834000000661],
                [86.876114, 20.700556],
                [86.875831, 20.700559000000105],
                [86.875266000000153, 20.7],
                [86.874999, 20.7],
                [86.874733000000319, 20.699720000000859],
                [86.874443, 20.699721999999777],
                [86.874024, 20.699305000000258],
                [86.873611000000196, 20.698888000000572],
                [86.873338000000146, 20.6988900000004],
                [86.8713920000001, 20.696951000000407],
                [86.8713920000001, 20.696680000000523],
                [86.871116, 20.696390000000854],
                [86.871116, 20.69611],
                [86.870835000000199, 20.695834000000325],
                [86.870835000000199, 20.69555400000041],
                [86.870553000000115, 20.695278000000705],
                [86.870553000000115, 20.694999999999702],
                [86.870277, 20.69472200000018],
                [86.870277, 20.694444],
                [86.869163, 20.693334000000274],
                [86.86888900000028, 20.693334000000274],
                [86.868613000000181, 20.693056000000517],
                [86.868333000000277, 20.693060000000109],
                [86.868057000000334, 20.69278],
                [86.867501, 20.69278],
                [86.867234000000323, 20.693060000000109],
                [86.866943000000191, 20.693060000000109],
                [86.866669, 20.69278],
                [86.863891000000294, 20.69278],
                [86.863328000000223, 20.692222],
                [86.862779000000145, 20.692222],
                [86.862503, 20.691943],
                [86.862220000000249, 20.691943],
                [86.862061000000196, 20.691784000000606],
                [86.861664, 20.691390000000521],
                [86.861388000000289, 20.691392000000171],
                [86.858330000000237, 20.688329000000575],
                [86.858330000000237, 20.68805500000024],
                [86.856393000000168, 20.686109000000211],
                [86.856393000000168, 20.685833000000454],
                [86.85611, 20.685557000000522],
                [86.856117, 20.685279000000261],
                [86.855827, 20.684999000000342],
                [86.855827, 20.684721000000305],
                [86.855552000000259, 20.684445000000373],
                [86.855552000000259, 20.683059000000238],
                [86.856942000000316, 20.681671000000161],
                [86.85721500000021, 20.681671000000161],
                [86.857498000000348, 20.681391000000243],
                [86.857781000000145, 20.681391000000243],
                [86.858063000000158, 20.681111000000378],
                [86.858330000000237, 20.681111000000378],
                [86.858612000000306, 20.680830000000579],
                [86.859444000000195, 20.680833000000117],
                [86.859727000000348, 20.680555000000361],
                [86.860000000000227, 20.680561000000349],
                [86.86028300000018, 20.680281000000431],
                [86.860832000000102, 20.680281000000431],
                [86.861106000000277, 20.680001000000342],
                [86.861947, 20.680001000000342],
                [86.862220000000249, 20.679720000000536],
                [86.862779000000145, 20.679723000000305],
                [86.863608000000156, 20.67888900000036],
                [86.863608000000156, 20.678319000000268],
                [86.861664, 20.676391000000475],
                [86.861388000000289, 20.676391000000475],
                [86.86028300000018, 20.675281],
                [86.860000000000227, 20.675281],
                [86.860000000000227, 20.675000000000288],
                [86.858612000000306, 20.673609999999879],
                [86.858612000000306, 20.673330000000131],
                [86.858330000000237, 20.673056000000368],
                [86.858330000000237, 20.672781000000548],
                [86.858063000000158, 20.672509000000272],
                [86.858063000000158, 20.672220000000145],
                [86.856666, 20.670834],
                [86.856666, 20.670556000000314],
                [86.856393000000168, 20.670280000000552],
                [86.856393000000168, 20.669451000000546],
                [86.856117, 20.669170000000172],
                [86.856117, 20.668332000000468],
                [86.855834000000115, 20.668056000000202],
                [86.855827, 20.66778000000027],
                [86.855552000000259, 20.667500000000242],
                [86.855552000000259, 20.666381000000566],
                [86.855834000000115, 20.666112000000336],
                [86.855827, 20.665560000000138],
                [86.856942000000316, 20.664441],
                [86.857224, 20.664443000000567],
                [86.857781000000145, 20.663890000000315],
                [86.858063000000158, 20.663892000000825],
                [86.858330000000237, 20.663612000000395],
                [86.858886, 20.663612000000395],
                [86.859727000000348, 20.66278],
                [86.859178000000242, 20.662219000000274],
                [86.859169000000222, 20.66194500000017],
                [86.858720000000375, 20.661631000000281],
                [86.858323000000198, 20.661280000000712],
                [86.857917, 20.660977000000507],
                [86.857528000000158, 20.660671000000427],
                [86.85721500000021, 20.660336000000253],
                [86.856926, 20.660031000000224],
                [86.856652000000324, 20.65977100000077],
                [86.856377, 20.65955],
                [86.856117, 20.659340000000434],
                [86.855827, 20.659090000000329],
                [86.855552000000259, 20.658782000000251],
                [86.855232, 20.65845200000069],
                [86.85484300000023, 20.658151000000309],
                [86.85449200000015, 20.657818000000471],
                [86.854157000000129, 20.657472],
                [86.853858000000258, 20.657061000000336],
                [86.853523000000266, 20.65672400000016],
                [86.853127, 20.656441000000704],
                [86.85276, 20.656153999999894],
                [86.852379, 20.655858],
                [86.851951, 20.655559],
                [86.851508000000123, 20.655268000000486],
                [86.851066000000316, 20.654969000000445],
                [86.850585000000351, 20.654712000000469],
                [86.850120000000217, 20.65444000000036],
                [86.849649000000142, 20.65416700000014],
                [86.849152, 20.653882],
                [86.848655000000164, 20.653615000000507],
                [86.84816, 20.653369000000392],
                [86.847657000000353, 20.653159000000237],
                [86.847169, 20.653009000000107],
                [86.846688000000299, 20.652811000000206],
                [86.84623700000013, 20.652610000000148],
                [86.845788, 20.652380000000441],
                [86.845321000000339, 20.652179000000327],
                [86.844872000000166, 20.651999],
                [86.844361000000134, 20.651910000000267],
                [86.84383500000034, 20.651887999999865],
                [86.843322000000327, 20.651901000000233],
                [86.84287300000031, 20.651979000000662],
                [86.842453000000177, 20.652111000000385],
                [86.842002000000193, 20.652239000000687],
                [86.841553000000346, 20.652442],
                [86.841157, 20.652772000000365],
                [86.840835000000226, 20.653157000000416],
                [86.840553, 20.653510000000317],
                [86.840302, 20.653811000000527],
                [86.840110000000308, 20.654092000000556],
                [86.839996000000312, 20.65439900000052],
                [86.839882, 20.654700000000382],
                [86.839759000000228, 20.654990000000218],
                [86.839675, 20.655309000000667],
                [86.83955400000012, 20.655637000000123],
                [86.839447000000334, 20.656031000000208],
                [86.839333000000337, 20.65651],
                [86.83921, 20.657039000000108],
                [86.839126, 20.65759],
                [86.839005000000199, 20.658117000000114],
                [86.838921000000354, 20.658611000000175],
                [86.838882000000112, 20.659062000000173],
                [86.838820000000311, 20.659454],
                [86.8386840000001, 20.659792000000714],
                [86.838622000000129, 20.660170000000388],
                [86.83854, 20.660578000000552],
                [86.838387000000225, 20.660963],
                [86.838271, 20.661401],
                [86.838096000000107, 20.661838000000152],
                [86.837952000000115, 20.662301000000291],
                [86.837777000000159, 20.662741],
                [86.837601, 20.663190000000494],
                [86.837448000000151, 20.66365900000039],
                [86.837234000000393, 20.664149],
                [86.8369900000001, 20.664699000000436],
                [86.836740000000333, 20.66533],
                [86.836448000000175, 20.66598],
                [86.83609, 20.666549],
                [86.835700000000301, 20.667071000000245],
                [86.835342000000182, 20.667529000000339],
                [86.835030000000287, 20.667946000000537],
                [86.834748, 20.668341000000506],
                [86.834517000000275, 20.668760000000756],
                [86.83421400000023, 20.669129000000336],
                [86.833877, 20.669512000000278],
                [86.83351900000028, 20.66990200000054],
                [86.833139000000102, 20.670287000000254],
                [86.832749000000177, 20.670670000000481],
                [86.832359, 20.671039000000118],
                [86.831933, 20.671370000000302],
                [86.831498, 20.671671000000568],
                [86.831078000000318, 20.671960000000119],
                [86.830643000000208, 20.67222900000035],
                [86.830224, 20.672509000000272],
                [86.829788000000335, 20.672776000000674],
                [86.829362000000273, 20.673040000000121],
                [86.828927000000164, 20.673312000000404],
                [86.828475, 20.673596000000309],
                [86.828004000000178, 20.67387],
                [86.827454000000316, 20.67413],
                [86.826866000000308, 20.674360000000259],
                [86.82624000000024, 20.674551000000289],
                [86.825638000000339, 20.674752000000574],
                [86.825082000000336, 20.674971000000195],
                [86.824546000000197, 20.675160000000229],
                [86.82404300000033, 20.675319000000226],
                [86.823571000000385, 20.675477000000338],
                [86.823097000000217, 20.675600000000536],
                [86.82267, 20.675757000000196],
                [86.822183, 20.675871000000424],
                [86.821716, 20.676019],
                [86.821244, 20.676131000000449],
                [86.820770000000238, 20.67624],
                [86.820312000000214, 20.676331000000115],
                [86.819856000000286, 20.676402000000277],
                [86.819398000000234, 20.676491],
                [86.818908000000405, 20.676600000000345],
                [86.818390000000349, 20.676680000000541],
                [86.817857000000103, 20.676790000000434],
                [86.817299000000304, 20.676878],
                [86.816726000000102, 20.676995000000311],
                [86.816109000000253, 20.677061000000315],
                [86.815530000000294, 20.677070000000523],
                [86.815056000000183, 20.676999000000304],
                [86.814591000000206, 20.677011],
                [86.814087000000299, 20.677038000000316],
                [86.813506000000331, 20.677049000000174],
                [86.812920000000332, 20.677138],
                [86.812294000000279, 20.677171999999867],
                [86.812026999999802, 20.677111000000192],
                [86.811728000000116, 20.67704200000048],
                [86.811204000000288, 20.676951000000425],
                [86.81069100000029, 20.676910000000245],
                [86.810151, 20.676906000000592],
                [86.809554, 20.676944],
                [86.808852, 20.67694],
                [86.808152000000206, 20.676890000000181],
                [86.807418, 20.676860000000371],
                [86.806655000000291, 20.676790000000434],
                [86.805878000000163, 20.676717],
                [86.805069, 20.676680000000541],
                [86.804269, 20.676621000000122],
                [86.803473000000139, 20.676568000000199],
                [86.802712, 20.676450000000379],
                [86.802078000000151, 20.67624],
                [86.801536, 20.676031000000133],
                [86.801032000000106, 20.675832000000408],
                [86.800515000000345, 20.675668000000478],
                [86.800087000000119, 20.67547000000064],
                [86.799713000000267, 20.675267000000524],
                [86.799323000000115, 20.675073000000108],
                [86.799004000000167, 20.674820000000519],
                [86.798692000000102, 20.674551000000289],
                [86.798341, 20.674289],
                [86.798058, 20.674169000000454],
                [86.798058, 20.673890000000476],
                [86.796670000000148, 20.672509000000272],
                [86.796670000000148, 20.672220000000145],
                [86.796387, 20.671944000000391],
                [86.796387, 20.671666000000297],
                [86.795838000000273, 20.671110000000333],
                [86.795829000000239, 20.670834],
                [86.795556, 20.670556000000314],
                [86.795562000000345, 20.67],
                [86.79528, 20.66972200000037],
                [86.79528, 20.669166000000583],
                [86.794997000000293, 20.66889000000014],
                [86.794997000000293, 20.668610000000221],
                [86.79528, 20.668334000000463],
                [86.79528, 20.667500000000242],
                [86.794997000000293, 20.667222000000315],
                [86.79528, 20.666944],
                [86.79528, 20.666389999999861],
                [86.795410000000203, 20.665622000000266],
                [86.795754000000258, 20.665047000000467],
                [86.79617300000028, 20.664530000000521],
                [86.796661000000114, 20.664149],
                [86.797126, 20.663830000000697],
                [86.797509000000133, 20.663570999999873],
                [86.797889000000154, 20.663459000000156],
                [86.798234000000249, 20.663482000000155],
                [86.798523000000202, 20.663630000000293],
                [86.798767000000154, 20.663892000000825],
                [86.799050000000292, 20.664238000000346],
                [86.799394000000319, 20.664605000000158],
                [86.799813000000356, 20.664940000000339],
                [86.80021600000029, 20.665298000000458],
                [86.800567, 20.665702000000518],
                [86.800880000000163, 20.666139000000609],
                [86.801208000000116, 20.666558],
                [86.801568000000245, 20.666891000000131],
                [86.801971000000179, 20.667169],
                [86.802436, 20.667390000000349],
                [86.803047, 20.667548000000462],
                [86.803749, 20.667573000000225],
                [86.804374, 20.667488],
                [86.804916000000134, 20.667390000000349],
                [86.805449000000223, 20.66732],
                [86.805930000000203, 20.667329000000105],
                [86.806099000000174, 20.66729700000047],
                [86.806427000000127, 20.667231000000182],
                [86.806915000000316, 20.667124000000392],
                [86.807373, 20.666937000000186],
                [86.807847000000194, 20.666732000000643],
                [86.808373000000174, 20.666522000000324],
                [86.808852, 20.666201],
                [86.809319000000102, 20.665841000000452],
                [86.809823, 20.665469],
                [86.810302, 20.665084000000544],
                [86.810792000000319, 20.664710000000291],
                [86.811241000000152, 20.664311000000332],
                [86.811676, 20.663901000000173],
                [86.812134000000327, 20.663518000000632],
                [86.81253700000029, 20.663110000000241],
                [86.812950000000143, 20.662750000000123],
                [86.813353000000106, 20.66239000000035],
                [86.813636000000244, 20.661950000000211],
                [86.813912000000158, 20.661501000000381],
                [86.814185, 20.661061000000355],
                [86.814438, 20.660592000000459],
                [86.814698, 20.660129000000147],
                [86.814942000000286, 20.659712000000294],
                [86.815124000000125, 20.659331000000403],
                [86.815270000000268, 20.659019000000168],
                [86.8154, 20.658759000000142],
                [86.815505000000172, 20.658531000000263],
                [86.815621000000348, 20.65826900000047],
                [86.815735000000217, 20.657998000000244],
                [86.815826000000115, 20.657681000000647],
                [86.815972, 20.65738000000044],
                [86.816109000000253, 20.657080000000516],
                [86.816284000000323, 20.656783000000242],
                [86.816444000000246, 20.656423000000636],
                [86.816642, 20.656052000000155],
                [86.816840000000155, 20.655660000000235],
                [86.816986000000142, 20.655261000000106],
                [86.817178, 20.654889000000193],
                [86.817412, 20.654502000000374],
                [86.817681, 20.65408],
                [86.817939000000123, 20.653647000000145],
                [86.818176, 20.653169000000215],
                [86.818413000000106, 20.652710000000404],
                [86.818627000000205, 20.652300000000249],
                [86.818848, 20.651931000000101],
                [86.819122000000135, 20.651559000000187],
                [86.819457000000156, 20.651131000000127],
                [86.819847000000252, 20.650659000000697],
                [86.820214, 20.65014200000018],
                [86.820526000000299, 20.649650000000172],
                [86.820808000000198, 20.649191000000197],
                [86.821059000000204, 20.64877700000039],
                [86.821296, 20.648362000000358],
                [86.821533000000315, 20.647954000000702],
                [86.821716, 20.647521],
                [86.821861000000283, 20.64707000000038],
                [86.821923, 20.646609],
                [86.821953, 20.646142000000733],
                [86.821946000000239, 20.645713000000224],
                [86.821923, 20.645301000000583],
                [86.821861000000283, 20.644920000000518],
                [86.821761, 20.644551000000146],
                [86.821579000000199, 20.644132000000123],
                [86.821396, 20.643662000000514],
                [86.821159000000293, 20.64320400000042],
                [86.820893000000112, 20.642746],
                [86.820633, 20.642281],
                [86.82039600000023, 20.64183],
                [86.820220000000219, 20.641420000000601],
                [86.82003800000011, 20.641060000000316],
                [86.819847000000252, 20.640690000000284],
                [86.819687, 20.640317000000316],
                [86.819541000000171, 20.639922000000293],
                [86.819359, 20.639560000000582],
                [86.819122000000135, 20.639243000000242],
                [86.818803000000216, 20.638926000000307],
                [86.818429, 20.638580000000101],
                [86.818007, 20.638270000000425],
                [86.817552000000248, 20.638031000000179],
                [86.817071, 20.637880000000273],
                [86.816574000000159, 20.637873000000578],
                [86.816170000000142, 20.637800000000592],
                [86.815819, 20.637759000000411],
                [86.815475000000191, 20.637768000000275],
                [86.815108, 20.637841000000261],
                [86.814728000000201, 20.638031000000179],
                [86.814286, 20.638249000000652],
                [86.813766, 20.638484000000513],
                [86.813249000000184, 20.638780000000502],
                [86.812804000000341, 20.639179000000119],
                [86.812417000000309, 20.639610000000282],
                [86.812050000000312, 20.640038000000512],
                [86.811721, 20.64046],
                [86.811402000000371, 20.640857000000434],
                [86.81109700000016, 20.641251000000519],
                [86.810792000000319, 20.641654000000294],
                [86.810454, 20.642033000000364],
                [86.810112, 20.642370000000536],
                [86.809693, 20.642685000000306],
                [86.809219, 20.643001000000705],
                [86.808746999999855, 20.643355000000152],
                [86.808296, 20.643731000000336],
                [86.807870000000307, 20.64409100000028],
                [86.807457, 20.644435000000154],
                [86.807006, 20.644713000000415],
                [86.806525000000221, 20.644938999999731],
                [86.806106000000213, 20.645000000000714],
                [86.805832000000109, 20.645279999999893],
                [86.805000000000149, 20.645279999999893],
                [86.80371000000018, 20.645000000000714],
                [86.802429000000231, 20.64487],
                [86.800827, 20.645000000000714],
                [86.800278, 20.645556000000337],
                [86.800278, 20.645830000000498],
                [86.800002000000319, 20.646110000000359],
                [86.796112, 20.646110000000359],
                [86.794373000000149, 20.646039000000194],
                [86.794015, 20.64583400000026],
                [86.793053000000185, 20.645830000000498],
                [86.792777000000271, 20.646110000000359],
                [86.792504000000108, 20.646110000000359],
                [86.79222100000031, 20.645830000000498],
                [86.791116000000201, 20.64583400000026],
                [86.790832999999836, 20.645556000000337],
                [86.790557000000135, 20.645570000000472],
                [86.790284000000241, 20.645279999999893],
                [86.789712000000165, 20.645279999999893],
                [86.789436, 20.645000000000714],
                [86.788887000000145, 20.645000000000714],
                [86.788613, 20.644720000000284],
                [86.786940000000342, 20.644722000000453],
                [86.786667000000122, 20.644444000000359],
                [86.785835, 20.644444000000359],
                [86.785630000000296, 20.64424100000047],
                [86.785552, 20.644166],
                [86.784721, 20.644166],
                [86.78444700000027, 20.644444000000359],
                [86.783608000000342, 20.644444000000359],
                [86.783333000000297, 20.644722000000453],
                [86.783059, 20.644720000000284],
                [86.782776, 20.645000000000714],
                [86.782776, 20.645279999999893],
                [86.782501, 20.645570000000472],
                [86.781669000000107, 20.645556000000337],
                [86.78138600000031, 20.64583400000026],
                [86.780563, 20.645830000000498],
                [86.780281000000201, 20.646110000000359],
                [86.779716000000334, 20.646110000000359],
                [86.77944200000023, 20.646390000000448],
                [86.778893000000124, 20.646390000000448],
                [86.778610000000327, 20.646668000000197],
                [86.778054000000324, 20.646668000000197],
                [86.777778, 20.646944000000296],
                [86.777496000000184, 20.646944000000296],
                [86.777222, 20.646668000000197],
                [86.776946000000166, 20.646668000000197],
                [86.776657000000199, 20.646390000000448],
                [86.776023000000166, 20.646395000000489],
                [86.775237000000146, 20.646187999999707],
                [86.774597000000128, 20.646390000000448],
                [86.773797, 20.646388000000112],
                [86.773940000000295, 20.646723000000289],
                [86.774300000000252, 20.647450000000386],
                [86.774170000000112, 20.648059000000327],
                [86.774170000000112, 20.648340999999842],
                [86.774711000000281, 20.648891000000614],
                [86.774720000000158, 20.649166000000427],
                [86.775276000000176, 20.649720000000453],
                [86.775276000000176, 20.650001000000255],
                [86.775558000000203, 20.65027900000052],
                [86.775558000000203, 20.650830000000266],
                [86.776390000000134, 20.651671],
                [86.776390000000134, 20.651950999999766],
                [86.778054000000324, 20.653611000000176],
                [86.778054000000324, 20.653891000000268],
                [86.778334000000228, 20.65416700000014],
                [86.77834400000016, 20.65444000000036],
                [86.778893000000124, 20.655001],
                [86.778893000000124, 20.655281000000169],
                [86.779166000000131, 20.655555000000103],
                [86.779166000000131, 20.655831000000543],
                [86.781113000000104, 20.657779000000399],
                [86.78138600000031, 20.657777],
                [86.781945, 20.658333000000418],
                [86.782501, 20.658331],
                [86.789169000000385, 20.665002000000467],
                [86.789169000000385, 20.665278000000395],
                [86.789712000000165, 20.665831],
                [86.789712000000165, 20.666112000000336],
                [86.790001000000288, 20.666112000000336],
                [86.790001000000288, 20.666389999999861],
                [86.790557000000135, 20.666941000000516],
                [86.790557000000135, 20.667500000000242],
                [86.791945, 20.66889000000014],
                [86.791945, 20.669166000000583],
                [86.792504000000108, 20.66972],
                [86.792504000000108, 20.67],
                [86.792777000000271, 20.670280000000552],
                [86.792777000000271, 20.670556000000314],
                [86.793053000000185, 20.670834],
                [86.793053000000185, 20.671110000000333],
                [86.794997000000293, 20.673056000000368],
                [86.794997000000293, 20.673330000000131],
                [86.795562000000345, 20.673890000000476],
                [86.795556, 20.674166000000238],
                [86.795838000000273, 20.674440000000342],
                [86.795838000000273, 20.675000000000288],
                [86.796112, 20.675278],
                [86.796112, 20.675556000000139],
                [86.797782000000367, 20.677220000000482],
                [86.797500000000284, 20.677501000000454],
                [86.797500000000284, 20.677779000000381],
                [86.797775000000257, 20.678054000000369],
                [86.797782000000367, 20.678319000000268],
                [86.798607000000217, 20.679171000000107],
                [86.798614000000256, 20.679445000000722],
                [86.798881000000321, 20.679720000000536],
                [86.798881000000321, 20.680001000000342],
                [86.799446000000202, 20.680555000000361],
                [86.799446000000202, 20.680830000000579],
                [86.799721999999889, 20.681111000000378],
                [86.800720000000226, 20.682257000000497],
                [86.801506000000273, 20.68340400000039],
                [86.80214700000019, 20.685219999999838],
                [86.802078000000151, 20.686574000000117],
                [86.802514000000187, 20.687989000000297],
                [86.803612000000243, 20.691112000000256],
                [86.803612000000243, 20.693056000000517],
                [86.803886, 20.693334000000274],
                [86.803886, 20.694444],
                [86.804168000000274, 20.69472200000018],
                [86.804168000000274, 20.695278000000705],
                [86.804444000000188, 20.69555400000041],
                [86.804444000000188, 20.698333999999871],
                [86.804734, 20.698610000000311],
                [86.804444000000188, 20.6988900000004],
                [86.804725000000332, 20.699168000000324],
                [86.804734, 20.702489000000465],
                [86.805000000000149, 20.702778000000418],
                [86.805000000000149, 20.703610000000705],
                [86.805276, 20.70388800000023],
                [86.805267, 20.704720000000517],
                [86.805556000000337, 20.705001000000316],
                [86.805556000000337, 20.705279],
                [86.80750300000031, 20.707221000000683],
                [86.80750300000031, 20.70750100000037],
                [86.808326000000221, 20.708330000000441],
                [86.808326000000221, 20.708620000000447],
                [86.808608, 20.708891000000271],
                [86.809167000000159, 20.708891000000271],
                [86.809449000000242, 20.709169000000365],
                [86.809723000000176, 20.709167000000768],
                [86.810279000000307, 20.709723000000391],
                [86.810548000000196, 20.709440000000424],
                [86.811669, 20.71055500000011],
                [86.811669, 20.710831000000606],
                [86.811943000000142, 20.711111000000297],
                [86.811943000000142, 20.711389],
                [86.812774, 20.712223000000446],
                [86.813057000000327, 20.711945000000576],
                [86.814721000000162, 20.713609000000243],
                [86.814721000000162, 20.713889000000101],
                [86.815553000000222, 20.714719],
                [86.815553000000222, 20.714999000000144],
                [86.816674, 20.716109000000468],
                [86.816665, 20.716388999999648],
                [86.817223000000226, 20.716943000000406],
                [86.817223000000226, 20.717221000000102],
                [86.817779000000229, 20.717782000000337],
                [86.817779000000229, 20.718056000000441],
                [86.818046000000294, 20.718331000000312],
                [86.818046000000294, 20.718612000000117],
                [86.81833600000013, 20.71889200000015],
                [86.81833600000013, 20.71916500000037],
                [86.818611000000132, 20.719441000000298],
                [86.818611000000132, 20.72000200000053],
                [86.818885000000236, 20.720278000000459],
                [86.818885000000236, 20.720834000000249],
                [86.819167000000135, 20.721110000000746],
                [86.819167000000135, 20.721390000000603],
                [86.819443, 20.721666000000365],
                [86.819443, 20.722222000000212],
                [86.819726000000216, 20.722500000000249],
                [86.819733000000255, 20.723329000000486],
                [86.819443, 20.723619000000323],
                [86.819443, 20.72389000000015],
                [86.819733000000255, 20.724170000000239],
                [86.819726000000216, 20.724446000000338],
                [86.819999, 20.724722000000437],
                [86.820008000000229, 20.725000000000701],
                [86.820266, 20.725280000000449],
                [86.820275000000137, 20.725556000000378],
                [86.820558000000105, 20.725834],
                [86.820558000000105, 20.726668000000522],
                [86.820831000000325, 20.72694000000029],
                [86.820831000000325, 20.727778000000335],
                [86.821114000000293, 20.728056000000429],
                [86.821114000000293, 20.729444000000509],
                [86.821387000000158, 20.729720000000267],
                [86.821387000000158, 20.730281000000158],
                [86.821662999999873, 20.730561],
                [86.821662999999873, 20.732501000000518],
                [86.821953, 20.732790000000247],
                [86.821953, 20.735281000000494],
                [86.822219, 20.735559],
                [86.822219, 20.736111000000218],
                [86.822502000000199, 20.736391000000133],
                [86.822502000000199, 20.737501000000119],
                [86.822778000000113, 20.737777000000616],
                [86.822778000000113, 20.739445],
                [86.823067, 20.739719000000317],
                [86.82306, 20.740277000000155],
                [86.823327000000106, 20.740551],
                [86.823831, 20.742401000000196],
                [86.82412000000015, 20.743600000000292],
                [86.824448000000118, 20.745282000000365],
                [86.824448000000118, 20.745556000000303],
                [86.824722000000222, 20.745831000000518],
                [86.824722000000222, 20.74611200000032],
                [86.824997, 20.746390000000584],
                [86.824997, 20.746666000000285],
                [86.825280000000177, 20.746944000000376],
                [86.825280000000177, 20.74729],
                [86.825280000000177, 20.747500000000226],
                [86.825547, 20.747789000000346],
                [86.825547, 20.748890000000127],
                [86.825836, 20.74917],
                [86.825836, 20.749446000000315],
                [86.826112000000279, 20.74972000000059],
                [86.826112000000279, 20.75028000000054],
                [86.826385000000172, 20.750556000000298],
                [86.826385000000172, 20.750834000000388],
                [86.826668000000311, 20.751110000000146],
                [86.826668000000311, 20.75166600000011],
                [86.827217, 20.752220000000133],
                [86.827217, 20.7525],
                [86.827773, 20.753056000000182],
                [86.827767000000264, 20.753601000000337],
                [86.828056, 20.753888000000469],
                [86.828056, 20.754444000000483],
                [86.828332000000145, 20.754720000000187],
                [86.828332000000145, 20.755281],
                [86.828612000000405, 20.755561000000505],
                [86.828612000000405, 20.75611],
                [86.829171, 20.756671000000321],
                [86.829171, 20.757501000000268],
                [86.829444000000294, 20.757779000000362],
                [86.829444000000294, 20.75805400000035],
                [86.829720000000208, 20.758332000000618],
                [86.829720000000208, 20.7586100000002],
                [86.830002, 20.758891000000343],
                [86.830002, 20.760000999999814],
                [86.83583, 20.765833000000267],
                [86.836113000000168, 20.765833000000267],
                [86.836227, 20.765949000000258],
                [86.836938, 20.766670000000428],
                [86.837218000000263, 20.766670000000428],
                [86.838050000000209, 20.767499000000608],
                [86.838333, 20.767499000000608],
                [86.838608000000391, 20.767779000000527],
                [86.838891000000146, 20.767779000000527],
                [86.839158000000211, 20.768060000000329],
                [86.839447000000334, 20.768055000000285],
                [86.839721, 20.768333000000545],
                [86.839996000000312, 20.768333000000545],
                [86.840133, 20.768472000000482],
                [86.840553, 20.76890100000065],
                [86.840844000000104, 20.76890100000065],
                [86.841111000000168, 20.769170000000482],
                [86.841394000000307, 20.769167000000433],
                [86.841530000000176, 20.769306000000363],
                [86.841667000000172, 20.769443000000191],
                [86.841943000000271, 20.769439000000201],
                [86.842499, 20.769999000000148],
                [86.842782, 20.769999000000148],
                [86.844176, 20.771392000000159],
                [86.844436000000115, 20.771392000000159],
                [86.84751100000021, 20.773081000000268],
                [86.84951, 20.7742910000004],
                [86.851014000000291, 20.774829000000459],
                [86.854164000000182, 20.775834000000312],
                [86.855278000000155, 20.775834000000312],
                [86.858918000000216, 20.775697000000541],
                [86.861106000000277, 20.775551],
                [86.863013000000109, 20.775084],
                [86.864579000000205, 20.774544000000155],
                [86.866578, 20.773935000000218],
                [86.868080000000106, 20.773131000000145],
                [86.869292000000229, 20.772591000000201],
                [86.870651000000208, 20.771779000000375],
              ],
            ],
            [
              [
                [86.875275, 20.775834000000312],
                [86.875558000000169, 20.775554000000223],
                [86.876114, 20.775554000000223],
                [86.876946000000231, 20.774724000000326],
                [86.87721900000011, 20.774724000000326],
                [86.877778000000191, 20.774166000000143],
                [86.877778000000191, 20.773190000000223],
                [86.877778000000191, 20.773056000000505],
                [86.877502000000263, 20.77278],
                [86.876953000000114, 20.77278],
                [86.876663000000278, 20.773060000000495],
                [86.876114, 20.773056000000505],
                [86.875831, 20.773334000000769],
                [86.875558000000169, 20.773331000000322],
                [86.875266000000153, 20.773612000000124],
                [86.874999, 20.773612000000124],
                [86.874443, 20.774166000000143],
                [86.874443, 20.774441000000358],
                [86.873887000000295, 20.775000000000425],
                [86.873887000000295, 20.775554000000223],
                [86.874168, 20.775834000000312],
                [86.874726000000265, 20.775834000000312],
                [86.874999, 20.775554000000223],
                [86.875161000000205, 20.775718000000321],
                [86.875275, 20.775834000000312],
              ],
            ],
            [
              [
                [86.864989000000193, 20.781110000000407],
                [86.865281000000195, 20.780839000000523],
                [86.86554800000026, 20.780839000000523],
                [86.865837000000198, 20.780559],
                [86.866387, 20.780559],
                [86.866669, 20.780281000000397],
                [86.867234000000323, 20.780281000000397],
                [86.867768, 20.779720000000673],
                [86.868057000000334, 20.779722000000501],
                [86.868333000000277, 20.779444000000236],
                [86.868613000000181, 20.779444000000236],
                [86.871665000000263, 20.776388000000331],
                [86.871665000000263, 20.77611],
                [86.870835000000199, 20.775278000000352],
                [86.870277, 20.775278000000352],
                [86.870004000000151, 20.775554000000223],
                [86.869445, 20.775554000000223],
                [86.869163, 20.775834000000312],
                [86.868613000000181, 20.775834000000312],
                [86.868333000000277, 20.776112000000573],
                [86.868057000000334, 20.77611],
                [86.867501, 20.77667],
                [86.867225000000118, 20.776666],
                [86.866669, 20.777222000000219],
                [86.866387, 20.777222000000219],
                [86.865837000000198, 20.777778000000236],
                [86.86554800000026, 20.777771000000367],
                [86.86444, 20.778890000000214],
                [86.86444, 20.779168000000308],
                [86.864167000000208, 20.77944],
                [86.864167000000208, 20.780559],
                [86.864723000000168, 20.781110000000407],
                [86.864989000000193, 20.781110000000407],
              ],
            ],
            [
              [
                [86.984170000000148, 20.782222],
                [86.984444, 20.781944000000287],
                [86.985, 20.781944000000287],
                [86.986114, 20.780834000000649],
                [86.986657000000235, 20.780839000000523],
                [86.987222000000116, 20.780281000000397],
                [86.987502000000319, 20.780281000000397],
                [86.987502000000319, 20.77944],
                [86.986663, 20.778610000000349],
                [86.985275000000101, 20.778610000000349],
                [86.985, 20.778334000000424],
                [86.983056, 20.778334000000424],
                [86.982780000000261, 20.778056000000156],
                [86.981941000000162, 20.778056000000156],
                [86.981668000000269, 20.778334000000424],
                [86.98139200000017, 20.778330000000434],
                [86.980553000000185, 20.779168000000308],
                [86.980553000000185, 20.779444000000236],
                [86.980277, 20.779720000000673],
                [86.980277, 20.78],
                [86.980553000000185, 20.780281000000397],
                [86.980553000000185, 20.780559],
                [86.981668000000269, 20.781667999999851],
                [86.98222400000013, 20.781666],
                [86.982497000000293, 20.781944000000287],
                [86.982780000000261, 20.781944000000287],
                [86.983056, 20.782222],
                [86.984170000000148, 20.782222],
              ],
            ],
            [
              [
                [86.881942, 20.788611000000227],
                [86.882233000000198, 20.788330000000421],
                [86.886666000000304, 20.788335000000469],
                [86.886947000000106, 20.788055000000377],
                [86.890830000000264, 20.788061000000191],
                [86.891113000000217, 20.787781000000273],
                [86.892777, 20.787781000000273],
                [86.893059000000321, 20.787501000000184],
                [86.894174000000334, 20.787501000000184],
                [86.894447, 20.787223000000321],
                [86.896667000000249, 20.787223000000321],
                [86.896943000000121, 20.786945],
                [86.898331, 20.786945],
                [86.898614000000208, 20.786667000000303],
                [86.900002000000299, 20.786671000000634],
                [86.900277000000102, 20.786391000000545],
                [86.90083300000029, 20.786391000000545],
                [86.9011, 20.786111000000115],
                [86.901932000000301, 20.786113000000277],
                [86.902497000000139, 20.786113000000277],
                [86.902778000000282, 20.785832000000479],
                [86.903053000000156, 20.785832000000479],
                [86.903336000000124, 20.785554000000211],
                [86.904168000000169, 20.785554000000211],
                [86.904441000000219, 20.785278999999655],
                [86.904717000000318, 20.785281000000221],
                [86.9050000000003, 20.785001000000303],
                [86.905563, 20.785001000000303],
                [86.90582900000031, 20.78472000000033],
                [86.906112000000107, 20.78472000000033],
                [86.906388000000206, 20.784444000000573],
                [86.907776000000283, 20.784444000000573],
                [86.908058000000182, 20.784166000000479],
                [86.90889, 20.784171000000178],
                [86.90915700000015, 20.783902000000122],
                [86.909996000000135, 20.783902000000122],
                [86.910285000000258, 20.783610000000518],
                [86.911393000000245, 20.783610000000518],
                [86.91166600000011, 20.783332000000424],
                [86.913056000000196, 20.783332000000424],
                [86.9133300000003, 20.783056000000492],
                [86.913613, 20.78306100000054],
                [86.913886, 20.782781],
                [86.914435, 20.782781],
                [86.914718, 20.782500000000304],
                [86.916947000000263, 20.782500000000304],
                [86.91722, 20.782220000000219],
                [86.917779000000138, 20.782222],
                [86.918052000000202, 20.781944000000287],
                [86.919440000000108, 20.781944000000287],
                [86.919723, 20.781666],
                [86.92193600000023, 20.781667999999851],
                [86.922225000000125, 20.781390000000325],
                [86.924156, 20.781390000000325],
                [86.924445000000134, 20.781110000000407],
                [86.926109000000153, 20.781110000000407],
                [86.926392000000121, 20.780839000000523],
                [86.926941000000255, 20.780839000000523],
                [86.927224, 20.780559],
                [86.92778000000024, 20.780559],
                [86.928046, 20.780839000000523],
                [86.9286120000003, 20.780839000000523],
                [86.928887, 20.780559],
                [86.930558000000232, 20.780559],
                [86.930831, 20.780281000000397],
                [86.932219000000174, 20.780281000000397],
                [86.932502000000312, 20.780559],
                [86.933610000000314, 20.780559],
                [86.933892, 20.780281000000397],
                [86.936386, 20.780281000000397],
                [86.936668, 20.780281000000397],
                [86.936944000000139, 20.78],
                [86.937233000000262, 20.78],
                [86.937500000000327, 20.780281000000397],
                [86.938332000000216, 20.780281000000397],
                [86.93860600000032, 20.78],
                [86.940269000000271, 20.78],
                [86.940552, 20.779720000000673],
                [86.941949000000179, 20.779722000000501],
                [86.942223000000283, 20.779444000000236],
                [86.942498000000327, 20.779444000000236],
                [86.942779000000129, 20.779168000000308],
                [86.943611, 20.779171],
                [86.944816000000273, 20.778409],
                [86.946106000000256, 20.777869000000628],
                [86.947608000000329, 20.777261000000291],
                [86.949441000000135, 20.77667],
                [86.950250000000253, 20.776399000000193],
                [86.950965, 20.775791000000307],
                [86.951531000000188, 20.775180000000539],
                [86.951531000000188, 20.774709999999679],
                [86.950546, 20.773890000000389],
                [86.949997000000323, 20.773331000000322],
                [86.949447, 20.773334000000769],
                [86.949279, 20.773167000000623],
                [86.949165, 20.773056000000505],
                [86.949028, 20.773056000000505],
                [86.948609, 20.773060000000495],
                [86.948326, 20.77278],
                [86.946952000000209, 20.77278],
                [86.946662000000217, 20.772502000000483],
                [86.945557000000107, 20.772502000000483],
                [86.945267000000271, 20.77278],
                [86.942223000000283, 20.77278],
                [86.941949000000179, 20.772502000000483],
                [86.941108000000256, 20.772502000000483],
                [86.940825, 20.772221000000677],
                [86.940552, 20.772221000000677],
                [86.940269000000271, 20.77194100000025],
                [86.939720000000122, 20.772502000000483],
                [86.939453, 20.772502000000483],
                [86.939164000000162, 20.77278],
                [86.93528000000029, 20.77278],
                [86.934998, 20.773060000000495],
                [86.934166000000147, 20.773056000000505],
                [86.933892, 20.773334000000769],
                [86.932219000000174, 20.773331000000322],
                [86.931946000000124, 20.773612000000124],
                [86.931107000000139, 20.773612000000124],
                [86.930831, 20.773890000000389],
                [86.928046, 20.773890000000389],
                [86.92778000000024, 20.774170000000478],
                [86.926665000000341, 20.774170000000478],
                [86.926392000000121, 20.773890000000389],
                [86.925553000000193, 20.773890000000389],
                [86.92527, 20.774170000000478],
                [86.920831000000106, 20.774170000000478],
                [86.920737000000116, 20.774077],
                [86.920555000000192, 20.773890000000389],
                [86.920281, 20.773890000000389],
                [86.919999000000161, 20.774170000000478],
                [86.918328000000301, 20.774170000000478],
                [86.918052000000202, 20.773890000000389],
                [86.917779000000138, 20.773890000000389],
                [86.917503, 20.774170000000478],
                [86.916664000000125, 20.774166000000143],
                [86.916389000000237, 20.774444000000411],
                [86.914444000000259, 20.774444000000411],
                [86.914169000000285, 20.774724000000326],
                [86.913886, 20.774724000000326],
                [86.913613, 20.774444000000411],
                [86.9133300000003, 20.774724000000326],
                [86.911942, 20.774724000000326],
                [86.91166600000011, 20.774444000000411],
                [86.910834000000179, 20.774444000000411],
                [86.910554000000317, 20.774724000000326],
                [86.907776000000283, 20.774724000000326],
                [86.907502000000179, 20.774444000000411],
                [86.906944, 20.774444000000411],
                [86.906388000000206, 20.773890000000389],
                [86.906112000000107, 20.773890000000389],
                [86.90582900000031, 20.773612000000124],
                [86.904717000000318, 20.773612000000124],
                [86.904441000000219, 20.773331000000322],
                [86.903336000000124, 20.773334000000769],
                [86.903138000000226, 20.773138000000522],
                [86.903053000000156, 20.773056000000505],
                [86.902778000000282, 20.773060000000495],
                [86.902497000000139, 20.77278],
                [86.902221, 20.77278],
                [86.901948, 20.772502000000483],
                [86.901390000000191, 20.772502000000483],
                [86.9011, 20.772221000000677],
                [86.900277000000102, 20.772221000000677],
                [86.900002000000299, 20.771943],
                [86.897226000000316, 20.771943],
                [86.896943000000121, 20.771668000000425],
                [86.895279000000102, 20.771668000000425],
                [86.894997000000245, 20.771943],
                [86.890830000000264, 20.771943],
                [86.890557, 20.772221000000677],
                [86.887222000000335, 20.772221000000677],
                [86.886947000000106, 20.772502000000483],
                [86.885003, 20.772502000000483],
                [86.884720000000101, 20.77278],
                [86.883605, 20.77278],
                [86.883332000000138, 20.773060000000495],
                [86.880836, 20.773056000000505],
                [86.880554000000345, 20.773334000000769],
                [86.879998, 20.773334000000769],
                [86.878890000000339, 20.774441000000358],
                [86.879448000000338, 20.775000000000425],
                [86.880287, 20.775000000000425],
                [86.880554000000345, 20.774724000000326],
                [86.881112, 20.774724000000326],
                [86.88138600000029, 20.774444000000411],
                [86.882224000000164, 20.774444000000411],
                [86.882500000000263, 20.774166000000143],
                [86.883615000000347, 20.774166000000143],
                [86.883888000000169, 20.774444000000411],
                [86.884164, 20.774444000000411],
                [86.884453, 20.774709999999679],
                [86.884164, 20.775000000000425],
                [86.883888000000169, 20.775000000000425],
                [86.883605, 20.77528000000029],
                [86.882774, 20.775278000000352],
                [86.882500000000263, 20.775554000000223],
                [86.882224000000164, 20.775554000000223],
                [86.881942, 20.775834000000312],
                [86.881668000000317, 20.775834000000312],
                [86.88138600000029, 20.776112000000573],
                [86.880836, 20.77611],
                [86.880547000000135, 20.7763900000005],
                [86.879998, 20.7763900000005],
                [86.8797220000001, 20.77667],
                [86.879448000000338, 20.77667],
                [86.879173000000137, 20.776951000000391],
                [86.878890000000339, 20.776951000000391],
                [86.87721900000011, 20.778610000000349],
                [86.876702000000122, 20.778610000000349],
                [86.876387000000179, 20.778610000000349],
                [86.876312000000198, 20.778535000000712],
                [86.876114, 20.778334000000424],
                [86.875831, 20.778334000000424],
                [86.875558000000169, 20.778061000000204],
                [86.874443, 20.779171],
                [86.873887000000295, 20.779168000000308],
                [86.873611000000196, 20.779444000000236],
                [86.873055000000349, 20.779444000000236],
                [86.872780000000191, 20.779168000000308],
                [86.872497000000209, 20.779444000000236],
                [86.871948000000245, 20.779444000000236],
                [86.871665000000263, 20.779722000000501],
                [86.870826000000349, 20.779720000000673],
                [86.870553000000115, 20.78],
                [86.870004000000151, 20.78],
                [86.869721000000183, 20.780281000000397],
                [86.869445, 20.780281000000397],
                [86.869156000000189, 20.780559],
                [86.86888900000028, 20.780559],
                [86.868606000000142, 20.780839000000523],
                [86.868333000000277, 20.780839000000523],
                [86.868057000000334, 20.781110000000407],
                [86.867768, 20.781110000000407],
                [86.867501, 20.781390000000325],
                [86.867234000000323, 20.781390000000325],
                [86.866943000000191, 20.781667999999851],
                [86.866669, 20.781666],
                [86.866387, 20.781944000000287],
                [86.866111000000316, 20.781944000000287],
                [86.865837000000198, 20.782222],
                [86.86554800000026, 20.782220000000219],
                [86.865281000000195, 20.782500000000304],
                [86.865281000000195, 20.783056000000492],
                [86.865555000000128, 20.783332000000424],
                [86.865555000000128, 20.783610000000518],
                [86.866387, 20.784444000000573],
                [86.866669, 20.784444000000573],
                [86.867225000000118, 20.785001000000303],
                [86.867501, 20.785001000000303],
                [86.868057000000334, 20.785554000000211],
                [86.868333000000277, 20.785554000000211],
                [86.868613000000181, 20.785832000000479],
                [86.86888900000028, 20.785832000000479],
                [86.869163, 20.786113000000277],
                [86.869721000000183, 20.786111000000115],
                [86.870004000000151, 20.786391000000545],
                [86.870826000000349, 20.786391000000545],
                [86.871116, 20.786671000000634],
                [86.8713920000001, 20.786667000000303],
                [86.871948000000245, 20.787223000000321],
                [86.873046000000315, 20.78722],
                [86.873338000000146, 20.787501000000184],
                [86.874726000000265, 20.787501000000184],
                [86.874908, 20.787685000000344],
                [86.874999, 20.787781000000273],
                [86.875558000000169, 20.787781000000273],
                [86.875831, 20.788061000000191],
                [86.876387000000179, 20.788055000000377],
                [86.876663000000278, 20.788335000000469],
                [86.879065, 20.78833300000047],
                [86.880836, 20.788330000000421],
                [86.881112, 20.788611000000227],
                [86.881942, 20.788611000000227],
              ],
            ],
            [
              [
                [86.556525078517524, 20.755616984846593],
                [86.557671853233657, 20.756445211030606],
                [86.560394635605661, 20.762998587760588],
                [86.565724628258735, 20.767567152891782],
                [86.573529260357731, 20.769090007935453],
                [86.57962068053277, 20.770232149218309],
                [86.588757810795116, 20.768138223533011],
                [86.593897446567766, 20.765663584086944],
                [86.59846601169896, 20.76376001528234],
                [86.601321364905942, 20.76376001528234],
                [86.604176718112839, 20.765663584086944],
                [86.607222428200345, 20.765853940967471],
                [86.610496870393817, 20.766120193722593],
                [86.609506710765899, 20.769661078576856],
                [86.609316353885418, 20.770803219859598],
                [86.613313848375341, 20.771564647381521],
                [86.616549915343143, 20.775181428110269],
                [86.616740272223666, 20.780321063882916],
                [86.618072770386988, 20.784699272133587],
                [86.619595625430676, 20.787744982221106],
                [86.620750000000143, 20.790261000000321],
                [86.624589000000171, 20.79201100000034],
                [86.627146196306029, 20.789210103658259],
                [86.629227, 20.786931000000315],
                [86.630298570158317, 20.78690280078558],
                [86.631127, 20.786881],
                [86.631613493408778, 20.787502340239595],
                [86.634842595071845, 20.791626488202095],
                [86.635597000000217, 20.79259000000047],
                [86.636383, 20.789871000000343],
                [86.635934000000233, 20.787291],
                [86.636887, 20.78454000000016],
                [86.641190000000265, 20.783280000000385],
                [86.641167000000323, 20.786051000000324],
                [86.647179, 20.791852000000514],
                [86.653328000000187, 20.79244000000045],
                [86.655906000000172, 20.7920890000002],
                [86.660316000000179, 20.787469000000211],
                [86.661132, 20.784050000000487],
                [86.670905000000218, 20.784780000000122],
                [86.675026000000145, 20.785080000000615],
                [86.678565000000191, 20.780431000000359],
                [86.687996, 20.777771000000367],
                [86.693573000000114, 20.77318100000053],
                [86.70176, 20.77194100000025],
                [86.705872000000255, 20.770282000000115],
                [86.707390000000245, 20.767700000000211],
                [86.707152000000264, 20.758011000000344],
                [86.70862500000014, 20.756072000000355],
                [86.724900000000261, 20.758020000000382],
                [86.730552, 20.76395],
                [86.741401000000266, 20.765849000000166],
                [86.748421000000207, 20.766189000000388],
                [86.755698000000322, 20.763862000000241],
                [86.758109000000147, 20.762649],
                [86.759636000000157, 20.757881000000278],
                [86.758073000000181, 20.752890000000658],
                [86.753891000000152, 20.747181000000463],
                [86.752343, 20.740931000000266],
                [86.753059000000107, 20.736471],
                [86.754752000000209, 20.733649000000295],
                [86.75779, 20.730871],
                [86.760436000000283, 20.729121000000639],
                [86.764160000000217, 20.728510000000366],
                [86.7697900000001, 20.731769000000149],
                [86.773927000000114, 20.735929000000279],
                [86.777076000000235, 20.737],
                [86.779709000000281, 20.736811000000269],
                [86.781935952514786, 20.735996409253911],
                [86.788395044753642, 20.731807826494556],
                [86.791250397960695, 20.730618095991808],
                [86.793171583343891, 20.731635194135826],
                [86.795295481670607, 20.732759610896942],
                [86.797674942676437, 20.737756479009303],
                [86.802195918587401, 20.740611832215954],
                [86.802783906784185, 20.741043023560277],
                [86.805765110096146, 20.743229239322652],
                [86.810286086007338, 20.745846646429182],
                [86.813561, 20.74621],
                [86.813698, 20.745888000000427],
                [86.814126000000144, 20.744943000000539],
                [86.81463, 20.7437280000002],
                [86.815765000000212, 20.744202000000364],
                [86.816665, 20.744443000000214],
                [86.816941000000142, 20.744441],
                [86.817497000000145, 20.74500200000028],
                [86.817779000000229, 20.74500200000028],
                [86.818611000000132, 20.744172],
                [86.818611000000132, 20.743892000000638],
                [86.81833600000013, 20.743611000000151],
                [86.818611000000132, 20.743329000000411],
                [86.818611000000132, 20.740277000000155],
                [86.81833600000013, 20.739999000000406],
                [86.81833600000013, 20.73860000000013],
                [86.818055000000328, 20.738333000000232],
                [86.81807800000027, 20.737800000000217],
                [86.817786000000282, 20.736241000000341],
                [86.817711000000301, 20.734962],
                [86.817711000000301, 20.733476000000163],
                [86.817428000000163, 20.732669000000552],
                [86.817497000000145, 20.731110000000168],
                [86.817497000000145, 20.730000000000352],
                [86.817223000000226, 20.729720000000267],
                [86.817223000000226, 20.729444000000509],
                [86.816948000000238, 20.729166000000241],
                [86.816941000000142, 20.728891000000427],
                [86.816674, 20.728610000000621],
                [86.816665, 20.728332000000361],
                [86.81639100000011, 20.728056000000429],
                [86.81639100000011, 20.727220000000209],
                [86.816109000000253, 20.726944000000284],
                [86.816109000000253, 20.72611000000034],
                [86.81639100000011, 20.725830000000311],
                [86.816109000000253, 20.725556000000378],
                [86.816109000000253, 20.72442100000023],
                [86.816109000000253, 20.723888000000553],
                [86.815553000000222, 20.723329000000486],
                [86.815553000000222, 20.722778000000172],
                [86.815277000000307, 20.722500000000249],
                [86.815277000000307, 20.722220000000384],
                [86.815003000000203, 20.721944000000118],
                [86.815003000000203, 20.721666000000365],
                [86.814162000000266, 20.720832000000478],
                [86.813889, 20.720834000000249],
                [86.813613000000117, 20.720556],
                [86.813331000000105, 20.720560000000145],
                [86.813057000000327, 20.72028000000028],
                [86.812768, 20.72028000000028],
                [86.806655000000291, 20.71417],
                [86.806655000000291, 20.713889000000101],
                [86.803337000000269, 20.710559],
                [86.802078000000151, 20.709659],
                [86.801361, 20.708855000000533],
                [86.800652000000269, 20.707774000000253],
                [86.800148, 20.706560000000135],
                [86.799721999999889, 20.705281000000181],
                [86.799721999999889, 20.704720000000517],
                [86.799163, 20.704166000000491],
                [86.799157, 20.703891000000279],
                [86.798607000000217, 20.70333],
                [86.798614000000256, 20.703057],
                [86.798058, 20.702489000000465],
                [86.798058, 20.70222200000023],
                [86.79722600000018, 20.701388000000176],
                [86.79722600000018, 20.701110000000423],
                [86.796387, 20.700281000000409],
                [86.796387, 20.7],
                [86.795838000000273, 20.699430000000344],
                [86.795829000000239, 20.699168000000324],
                [86.795562000000345, 20.6988900000004],
                [86.795562000000345, 20.698610000000311],
                [86.794997000000293, 20.698056000000516],
                [86.794997000000293, 20.697780000000417],
                [86.794441000000106, 20.69722],
                [86.794441000000106, 20.696666],
                [86.794168000000269, 20.696390000000854],
                [86.794168000000269, 20.69611],
                [86.793892000000355, 20.695834000000325],
                [86.793892000000355, 20.69555400000041],
                [86.793609000000217, 20.695278000000705],
                [86.793609000000217, 20.694999999999702],
                [86.793327000000133, 20.69472200000018],
                [86.793336000000323, 20.694166000000504],
                [86.793053000000185, 20.69389],
                [86.793053000000185, 20.693331000000338],
                [86.792777000000271, 20.693056000000517],
                [86.792777000000271, 20.69278],
                [86.792504000000108, 20.692502],
                [86.792504000000108, 20.691941000000266],
                [86.79222100000031, 20.691668000000611],
                [86.79222100000031, 20.691392000000171],
                [86.791945, 20.691112000000256],
                [86.791945, 20.690551000000365],
                [86.791665000000123, 20.690277000000428],
                [86.791656, 20.69000200000027],
                [86.791389, 20.689719000000302],
                [86.791389, 20.689443000000548],
                [86.791116000000201, 20.689167000000449],
                [86.791107000000338, 20.688609000000266],
                [86.790832999999836, 20.688333000000508],
                [86.790832999999836, 20.68805500000024],
                [86.790557000000135, 20.687779999999741],
                [86.790557000000135, 20.687219000000191],
                [86.790275, 20.686945000000602],
                [86.790284000000241, 20.68667],
                [86.790001000000288, 20.686389000000243],
                [86.790001000000288, 20.685831000000118],
                [86.789719, 20.685557000000522],
                [86.789712000000165, 20.685279000000261],
                [86.789436, 20.684999000000342],
                [86.789436, 20.684450000000421],
                [86.789169000000385, 20.68416899999988],
                [86.789169000000385, 20.683889000000185],
                [86.788887000000145, 20.683611000000436],
                [86.788887000000145, 20.683059000000238],
                [86.788613, 20.682781000000542],
                [86.788613, 20.682501000000112],
                [86.788331000000298, 20.682221000000702],
                [86.788331000000298, 20.681389000000305],
                [86.788064000000233, 20.681111000000378],
                [86.788055000000199, 20.680833000000117],
                [86.788331000000298, 20.680555000000361],
                [86.788331000000298, 20.680281000000431],
                [86.788613, 20.680001000000342],
                [86.788613, 20.6786110000001],
                [86.788887000000145, 20.67833200000063],
                [86.788887000000145, 20.678054000000369],
                [86.788613, 20.677779000000381],
                [86.788613, 20.677220000000482],
                [86.788331000000298, 20.676944],
                [86.788331000000298, 20.676666000000289],
                [86.788613, 20.676391000000475],
                [86.788613, 20.675281],
                [86.788331000000298, 20.675000000000288],
                [86.788331000000298, 20.674720000000203],
                [86.788055000000199, 20.674444],
                [86.788055000000199, 20.674166000000238],
                [86.787781, 20.673890000000476],
                [86.787781, 20.673609999999879],
                [86.787499, 20.673330000000131],
                [86.787499, 20.672778000000271],
                [86.787216000000257, 20.672509000000272],
                [86.787216000000257, 20.672220000000145],
                [86.786940000000342, 20.671944000000391],
                [86.786940000000342, 20.671666000000297],
                [86.786111, 20.670830000000244],
                [86.786111, 20.670556000000314],
                [86.785552, 20.67],
                [86.785552, 20.669451000000546],
                [86.784996000000234, 20.66889000000014],
                [86.784996000000234, 20.668610000000221],
                [86.78444700000027, 20.668056000000202],
                [86.78444700000027, 20.66778000000027],
                [86.783898000000178, 20.667222000000315],
                [86.78388900000013, 20.666666000000301],
                [86.783608000000342, 20.666381000000566],
                [86.783608000000342, 20.666112000000336],
                [86.782776, 20.665280000000216],
                [86.782776, 20.665002000000467],
                [86.780837, 20.663062000000362],
                [86.780837, 20.66278],
                [86.779716000000334, 20.661670000000296],
                [86.77944200000023, 20.661670000000296],
                [86.778610000000327, 20.660829000000373],
                [86.778334000000228, 20.660833000000704],
                [86.778054000000324, 20.660555000000436],
                [86.777778, 20.660555000000436],
                [86.775002, 20.657777],
                [86.775002, 20.657510000000169],
                [86.774711000000281, 20.657221000000273],
                [86.774720000000158, 20.656945000000512],
                [86.773888000000255, 20.656111000000404],
                [86.773888000000255, 20.655831000000543],
                [86.772782000000205, 20.654723000000324],
                [86.772782000000205, 20.654445],
                [86.772224, 20.653889000000444],
                [86.772217000000168, 20.653611000000176],
                [86.771941, 20.653330000000377],
                [86.771941, 20.653055000000499],
                [86.771668000000233, 20.652781000000395],
                [86.771668000000233, 20.652501000000537],
                [86.770836000000287, 20.651671],
                [86.770836000000287, 20.651379000000414],
                [86.770280000000326, 20.650832],
                [86.770280000000326, 20.650554000000334],
                [86.769997, 20.65027900000052],
                [86.769997, 20.649720000000453],
                [86.768334, 20.648056000000448],
                [86.768327, 20.647778000000521],
                [86.768058000000309, 20.64750000000026],
                [86.768058000000309, 20.647220000000395],
                [86.76777700000018, 20.646944000000296],
                [86.76777700000018, 20.646668000000197],
                [86.767502000000121, 20.646390000000448],
                [86.767502000000121, 20.646110000000359],
                [86.767219000000395, 20.645830000000498],
                [86.767219000000395, 20.645276000000472],
                [86.766936000000186, 20.645000000000714],
                [86.766936000000186, 20.644720000000284],
                [86.766670000000246, 20.644444000000359],
                [86.766670000000246, 20.639444000000534],
                [86.766387000000108, 20.639166000000497],
                [86.766387000000108, 20.636941000000203],
                [86.766189, 20.634874],
                [86.765977000000106, 20.632244000000462],
                [86.765838000000301, 20.630085000000513],
                [86.765412000000225, 20.627991],
                [86.76505400000012, 20.626509],
                [86.764167000000242, 20.62472],
                [86.764167000000242, 20.624445000000147],
                [86.763611, 20.62389100000069],
                [86.763611, 20.623610000000149],
                [86.762497, 20.62250000000051],
                [86.762497, 20.62222],
                [86.761947000000234, 20.621666000000399],
                [86.761947000000234, 20.62111],
                [86.761391000000273, 20.620559000000124],
                [86.761391000000273, 20.620281],
                [86.760559000000313, 20.619440000000449],
                [86.760559000000313, 20.619168000000681],
                [86.759728000000152, 20.61833],
                [86.759445000000355, 20.618334],
                [86.758057000000107, 20.616946000000151],
                [86.757768000000326, 20.616951000000761],
                [86.757499, 20.616670000000219],
                [86.757232, 20.616670000000219],
                [86.756942, 20.616390000000134],
                [86.756386000000234, 20.616390000000134],
                [86.756247, 20.616249000000376],
                [86.756111000000189, 20.616110000000443],
                [86.755837, 20.616112000000268],
                [86.755776000000182, 20.614492000000148],
                [86.755698000000322, 20.613883000000207],
                [86.755698000000322, 20.613345000000262],
                [86.757417000000231, 20.613550000000366],
                [86.758057000000107, 20.61389],
                [86.758330000000313, 20.614170000000165],
                [86.758889000000167, 20.614165999999837],
                [86.759162000000217, 20.614444000000102],
                [86.759721000000113, 20.614444000000102],
                [86.760001000000202, 20.614722000000363],
                [86.760277000000301, 20.614720000000542],
                [86.760559000000313, 20.615],
                [86.760833, 20.615],
                [86.761109000000189, 20.615278000000725],
                [86.761391000000273, 20.615278000000725],
                [86.761665, 20.615554000000426],
                [86.761947000000234, 20.615551000000377],
                [86.762773, 20.616390000000134],
                [86.763046000000244, 20.616390000000134],
                [86.763335, 20.616670000000219],
                [86.763611, 20.616670000000219],
                [86.763893999999866, 20.616951000000761],
                [86.764167000000242, 20.616951000000761],
                [86.765831, 20.618610000000498],
                [86.765831, 20.618889999999734],
                [86.767502000000121, 20.620556],
                [86.767502000000121, 20.620830000000179],
                [86.76777700000018, 20.62111],
                [86.76777700000018, 20.621388000000362],
                [86.768607000000301, 20.62222],
                [86.768607000000301, 20.62250000000051],
                [86.768890000000269, 20.622779000000488],
                [86.768890000000269, 20.623332],
                [86.769172000000125, 20.623610000000149],
                [86.769172000000125, 20.624171000000555],
                [86.769448, 20.624445000000147],
                [86.769448, 20.62472],
                [86.769997, 20.625279],
                [86.769997, 20.625830000000516],
                [86.770836000000287, 20.626671000000268],
                [86.770836000000287, 20.627501000000557],
                [86.77111, 20.627781000000645],
                [86.77111, 20.628055000000241],
                [86.771385000000109, 20.628335],
                [86.771392000000134, 20.629721000000238],
                [86.771668000000233, 20.629999000000506],
                [86.771668000000233, 20.630270000000333],
                [86.771941, 20.63056],
                [86.771941, 20.631667000000327],
                [86.771668000000233, 20.631945000000595],
                [86.771941, 20.632221000000296],
                [86.771941, 20.632777000000313],
                [86.772224, 20.633055000000233],
                [86.772217000000168, 20.63360900000043],
                [86.771941, 20.633889000000462],
                [86.771941, 20.634445000000138],
                [86.771668000000233, 20.634719000000239],
                [86.771668000000233, 20.635280000000474],
                [86.771385000000109, 20.635555],
                [86.771392000000134, 20.635829],
                [86.77111, 20.636109000000481],
                [86.771668000000233, 20.636668000000547],
                [86.771668000000233, 20.637221000000288],
                [86.771392000000134, 20.637502],
                [86.771668000000233, 20.637782000000524],
                [86.771668000000233, 20.638056000000116],
                [86.771392000000134, 20.638331000000672],
                [86.771392000000134, 20.638892000000162],
                [86.771531, 20.640171000000688],
                [86.771385000000109, 20.641666000000551],
                [86.77111, 20.641944000000304],
                [86.77111, 20.642210000000599],
                [86.771941, 20.643056000000453],
                [86.771941, 20.643610000000304],
                [86.772217000000168, 20.643890000000336],
                [86.772217000000168, 20.644171000000139],
                [86.773056000000309, 20.645000000000714],
                [86.773332, 20.645000000000714],
                [86.773612000000341, 20.645279999999893],
                [86.775558000000203, 20.645279999999893],
                [86.775834000000302, 20.645570000000472],
                [86.777222, 20.645570000000472],
                [86.777496000000184, 20.645279999999893],
                [86.779166000000131, 20.645279999999893],
                [86.77944200000023, 20.645000000000714],
                [86.779998, 20.645000000000714],
                [86.780563, 20.644439000000485],
                [86.780830000000122, 20.644444000000359],
                [86.781113000000104, 20.644166],
                [86.78138600000031, 20.644171000000139],
                [86.781938000000352, 20.643610000000304],
                [86.781945, 20.643334000000372],
                [86.782218000000256, 20.643056000000453],
                [86.782501, 20.643061000000326],
                [86.782776, 20.642780000000354],
                [86.783059, 20.642778000000185],
                [86.783241000000189, 20.642962999999888],
                [86.783608000000342, 20.643334000000372],
                [86.784164000000132, 20.642778000000185],
                [86.784721, 20.642780000000354],
                [86.784996000000234, 20.643061000000326],
                [86.785552, 20.643056000000453],
                [86.785835, 20.643334000000372],
                [86.788331000000298, 20.643334000000372],
                [86.788613, 20.643612],
                [86.790557000000135, 20.643610000000304],
                [86.790832999999836, 20.643890000000336],
                [86.791107000000338, 20.643890000000336],
                [86.791389, 20.644171000000139],
                [86.791665000000123, 20.644166],
                [86.791870000000216, 20.644369000000548],
                [86.791945, 20.644444000000359],
                [86.792504000000108, 20.644439000000485],
                [86.793053000000185, 20.645000000000714],
                [86.794168000000269, 20.645000000000714],
                [86.794441000000106, 20.645279999999893],
                [86.794997000000293, 20.645279999999893],
                [86.79528, 20.645000000000714],
                [86.79722600000018, 20.645000000000714],
                [86.797500000000284, 20.644720000000284],
                [86.797775000000257, 20.644722000000453],
                [86.798058, 20.644444000000359],
                [86.798614000000256, 20.644444000000359],
                [86.799163, 20.64388799999983],
                [86.799736, 20.643943000000313],
                [86.799881000000298, 20.643908000000405],
                [86.800171000000134, 20.643838000000123],
                [86.800629000000171, 20.6437400000002],
                [86.801162, 20.643810000000482],
                [86.801721000000143, 20.643851000000318],
                [86.802316000000104, 20.643861000000296],
                [86.802917000000292, 20.643872],
                [86.8035050000003, 20.643874000000263],
                [86.804054, 20.643849000000497],
                [86.804526000000209, 20.643760000000263],
                [86.804978000000332, 20.643630000000368],
                [86.805556000000337, 20.643610000000304],
                [86.805832000000109, 20.643334000000372],
                [86.806947000000122, 20.643334000000372],
                [86.807220000000171, 20.643056000000453],
                [86.80750300000031, 20.643061000000326],
                [86.807776, 20.642780000000354],
                [86.808052, 20.642780000000354],
                [86.808608, 20.642210000000599],
                [86.808891, 20.642222000000398],
                [86.809998000000149, 20.641112000000529],
                [86.809998000000149, 20.640834000000261],
                [86.810279000000307, 20.640556],
                [86.810279000000307, 20.640280000000299],
                [86.810837000000134, 20.639722000000116],
                [86.810837000000134, 20.639444000000534],
                [86.811111000000238, 20.639166000000497],
                [86.811341, 20.63888100000036],
                [86.811721, 20.638564000000425],
                [86.812127000000288, 20.638247],
                [86.812547, 20.637951000000495],
                [86.812973, 20.637650000000114],
                [86.813447, 20.637395000000648],
                [86.813964000000198, 20.63713],
                [86.81459800000026, 20.63687],
                [86.815247000000141, 20.636611000000467],
                [86.815530000000294, 20.636472000000303],
                [86.815872000000326, 20.636401000000312],
                [86.81636000000023, 20.636355000000602],
                [86.816879000000355, 20.63646],
                [86.81731400000028, 20.63668400000028],
                [86.81771800000034, 20.636941000000203],
                [86.81816000000012, 20.637221000000288],
                [86.818611000000132, 20.637541000000503],
                [86.81903800000012, 20.63791],
                [86.819450000000117, 20.63832000000081],
                [86.819856000000286, 20.638748000000358],
                [86.820230000000137, 20.639172000000251],
                [86.820558000000105, 20.639583000000183],
                [86.820831000000325, 20.639972000000164],
                [86.821052000000165, 20.640351000000457],
                [86.821221, 20.640747000000371],
                [86.821426000000173, 20.641126000000433],
                [86.821647000000141, 20.641479000000341],
                [86.821877, 20.641839000000115],
                [86.822112000000274, 20.642179000000166],
                [86.822274000000149, 20.642530000000303],
                [86.822427000000218, 20.642869000000239],
                [86.822547, 20.643229000000183],
                [86.822677, 20.643592000000236],
                [86.8228, 20.643977000000287],
                [86.822907000000129, 20.6443890000001],
                [86.823012, 20.644879000000113],
                [86.823067, 20.645410000000531],
                [86.823067, 20.645976000000299],
                [86.822983, 20.646511000000313],
                [86.822837000000192, 20.647031000000531],
                [86.822648, 20.64750000000026],
                [86.822472, 20.647936000000126],
                [86.822297000000319, 20.648340999999842],
                [86.822167000000178, 20.648742000000365],
                [86.822053, 20.649121],
                [86.821907000000152, 20.649467000000296],
                [86.821777000000253, 20.649779000000358],
                [86.821624, 20.650048000000421],
                [86.821472, 20.650301000000233],
                [86.82131900000023, 20.650566000000133],
                [86.821153000000123, 20.650801000000165],
                [86.820977000000127, 20.651060000000477],
                [86.820838000000194, 20.651332000000245],
                [86.820701, 20.651601000000309],
                [86.820580000000149, 20.651901000000233],
                [86.820473000000206, 20.652200000000331],
                [86.820343, 20.6524920000005],
                [86.820214, 20.652781000000395],
                [86.820068000000248, 20.653050000000459],
                [86.819915000000179, 20.653355000000484],
                [86.819703, 20.653681000000113],
                [86.819427000000175, 20.654069000000217],
                [86.819099, 20.654541000000389],
                [86.818771, 20.655104000000446],
                [86.818481, 20.65571900000014],
                [86.818192, 20.656311000000297],
                [86.817948000000158, 20.656840000000326],
                [86.817727, 20.657329999999881],
                [86.817513, 20.657779000000399],
                [86.817305, 20.658242000000197],
                [86.81710700000022, 20.658714000000309],
                [86.816941000000142, 20.659211000000422],
                [86.816772000000228, 20.659751000000135],
                [86.81656700000029, 20.660277000000175],
                [86.816307, 20.66074],
                [86.816018000000199, 20.66115],
                [86.815742000000256, 20.661510000000415],
                [86.815475000000191, 20.661879],
                [86.81521500000018, 20.662242000000386],
                [86.814956, 20.662611000000705],
                [86.814682000000332, 20.662948000000195],
                [86.814399000000122, 20.663315000000516],
                [86.814087000000299, 20.66365900000039],
                [86.813736000000219, 20.663967000000465],
                [86.813347000000348, 20.66422000000011],
                [86.812996, 20.664512000000283],
                [86.812654000000208, 20.664831000000387],
                [86.812264, 20.665132],
                [86.811858000000228, 20.665401],
                [86.811478000000236, 20.665740000000419],
                [86.811074, 20.666100000000192],
                [86.810607000000275, 20.666435000000373],
                [86.810135000000329, 20.666764000000281],
                [86.809616000000389, 20.66703],
                [86.80912100000026, 20.667270000000194],
                [86.808631, 20.667502],
                [86.808175000000332, 20.667744000000134],
                [86.807717, 20.667981000000559],
                [86.807243000000298, 20.668199000000524],
                [86.806664000000325, 20.668334000000463],
                [86.806388000000226, 20.66861200000039],
                [86.806106000000213, 20.668610000000221],
                [86.805832000000109, 20.66889000000014],
                [86.805000000000149, 20.66889000000014],
                [86.804734, 20.669170000000172],
                [86.803612000000243, 20.669170000000172],
                [86.803337000000269, 20.66889000000014],
                [86.801942000000267, 20.66889000000014],
                [86.801803000000163, 20.668751],
                [86.801666000000324, 20.66861200000039],
                [86.801392, 20.66861200000039],
                [86.800973000000212, 20.668195000000193],
                [86.800551000000311, 20.667778000000506],
                [86.800551000000311, 20.667500000000242],
                [86.799157, 20.666112000000336],
                [86.799157, 20.665831],
                [86.798699000000212, 20.665357000000196],
                [86.79837000000029, 20.665050000000569],
                [86.798026000000263, 20.664840000000421],
                [86.797652, 20.664760000000168],
                [86.797272000000234, 20.664801000000345],
                [86.796960000000325, 20.664938000000173],
                [86.796723000000128, 20.665200000000361],
                [86.796508000000273, 20.665572000000388],
                [86.796303000000179, 20.666050000000318],
                [86.796180000000319, 20.666670000000458],
                [86.79612800000011, 20.667370000000286],
                [86.796134, 20.668101000000373],
                [86.796212000000125, 20.668833],
                [86.796387, 20.669530000000119],
                [86.796615, 20.670185000000171],
                [86.796868, 20.670741000000127],
                [86.797096000000224, 20.671240000000406],
                [86.797333000000123, 20.671680000000201],
                [86.797623000000314, 20.672081000000155],
                [86.797958000000321, 20.672507000000444],
                [86.798318000000251, 20.672872],
                [86.798692000000102, 20.673118],
                [86.799072000000123, 20.673371000000312],
                [86.799462000000261, 20.67369],
                [86.799888000000337, 20.674029],
                [86.80039900000034, 20.674355000000215],
                [86.801003, 20.67466300000029],
                [86.801643000000226, 20.674950000000589],
                [86.802238000000244, 20.675210000000614],
                [86.802856000000219, 20.675381000000179],
                [86.8034600000003, 20.67547000000064],
                [86.803977, 20.67547000000064],
                [86.804444000000188, 20.675518000000519],
                [86.804848000000206, 20.67555000000015],
                [86.80526, 20.675620000000432],
                [86.805686, 20.675741000000521],
                [86.806183, 20.675782],
                [86.806479000000351, 20.675762000000127],
                [86.806655000000291, 20.675750000000328],
                [86.807077000000263, 20.675668000000478],
                [86.807457, 20.675600000000536],
                [86.807824000000252, 20.675629000000125],
                [86.808189, 20.675741000000521],
                [86.808601000000223, 20.675791000000171],
                [86.809059, 20.675800000000201],
                [86.809508000000321, 20.675791000000171],
                [86.809953000000149, 20.675750000000328],
                [86.810402, 20.675670000000306],
                [86.810805000000173, 20.675741000000521],
                [86.811257, 20.675791000000171],
                [86.811715000000319, 20.675803000000649],
                [86.812173, 20.675796000000268],
                [86.812622000000189, 20.675791000000171],
                [86.81305, 20.675782],
                [86.813460000000276, 20.675730000000662],
                [86.813857, 20.67562700000013],
                [86.814270000000349, 20.675611000000398],
                [86.814698, 20.675693000000418],
                [86.815124000000125, 20.675682],
                [86.815537000000333, 20.675611000000398],
                [86.815963, 20.675611000000398],
                [86.816398, 20.675568000000393],
                [86.816856000000243, 20.67554100000012],
                [86.817353000000111, 20.675520000000343],
                [86.817848, 20.675461000000606],
                [86.81830600000032, 20.67534000000051],
                [86.818816, 20.675281],
                [86.819366000000102, 20.675251000000113],
                [86.819938000000136, 20.675190000000551],
                [86.820473000000206, 20.675041000000469],
                [86.821000000000282, 20.674930000000526],
                [86.821504, 20.67477],
                [86.822021, 20.674649],
                [86.822534000000175, 20.674490000000212],
                [86.823083000000153, 20.674380000000152],
                [86.8236, 20.674239000000224],
                [86.824111000000286, 20.674109000000264],
                [86.824578000000187, 20.673941],
                [86.825089, 20.673818000000544],
                [86.825592000000242, 20.673660000000265],
                [86.826119000000162, 20.673536999999836],
                [86.826607, 20.673321],
                [86.827103, 20.673049000000329],
                [86.827584000000215, 20.672781000000548],
                [86.828056, 20.672521000000526],
                [86.828537000000196, 20.67227000000053],
                [86.828972000000121, 20.671981000000411],
                [86.829398, 20.6717],
                [86.82982700000035, 20.671420000000175],
                [86.830246, 20.671140000000143],
                [86.830673, 20.670811000000466],
                [86.831101, 20.670442],
                [86.831536000000185, 20.670043000000128],
                [86.832008, 20.669644000000343],
                [86.832466000000224, 20.669211000000413],
                [86.832915, 20.668737000000412],
                [86.833314, 20.668229000000164],
                [86.833701000000119, 20.667748000000124],
                [86.8340910000002, 20.667379000000491],
                [86.834413, 20.667039000000269],
                [86.834634, 20.666732000000643],
                [86.834748, 20.666451000000105],
                [86.83487800000033, 20.66621],
                [86.835021000000239, 20.6659610000006],
                [86.835190000000168, 20.66571300000032],
                [86.835320000000124, 20.665423000000313],
                [86.835472, 20.665148000000325],
                [86.835602000000151, 20.664849000000455],
                [86.835746000000171, 20.664560000000499],
                [86.835869000000216, 20.66425],
                [86.836006, 20.663956],
                [86.836083, 20.663650000000185],
                [86.836120000000207, 20.663338000000117],
                [86.836158000000168, 20.663030000000212],
                [86.83627200000015, 20.662759000000332],
                [86.836411000000325, 20.662442],
                [86.836594, 20.662057000000512],
                [86.836769, 20.661528000000253],
                [86.8368990000004, 20.660870000000209],
                [86.836997000000139, 20.66016100000035],
                [86.837150000000335, 20.659491000000113],
                [86.837211000000224, 20.658871000000541],
                [86.837234000000393, 20.658329000000261],
                [86.837289000000155, 20.65785],
                [86.837442000000166, 20.657421000000621],
                [86.837540000000146, 20.656959000000423],
                [86.837699000000129, 20.656503000000153],
                [86.83792900000013, 20.656077000000263],
                [86.838173000000253, 20.655639000000289],
                [86.838417000000206, 20.655240000000326],
                [86.838631000000163, 20.654819000000309],
                [86.8388300000003, 20.65439900000052],
                [86.838996000000321, 20.653900000000302],
                [86.839301000000191, 20.653419000000262],
                [86.839698000000155, 20.652943000000501],
                [86.840126, 20.652428000000494],
                [86.840562, 20.651979000000662],
                [86.841004000000197, 20.651626],
                [86.841423000000233, 20.651348000000151],
                [86.84182, 20.651161],
                [86.842171, 20.651001],
                [86.842529000000283, 20.65088900000017],
                [86.842911, 20.650801000000165],
                [86.843322000000327, 20.65075500000011],
                [86.843757, 20.650739000000211],
                [86.844215000000105, 20.650737000000383],
                [86.844657000000311, 20.650762000000153],
                [86.845063000000124, 20.650819000000464],
                [86.845414000000204, 20.650880000000139],
                [86.845726000000113, 20.650921000000377],
                [86.846061000000105, 20.651060000000477],
                [86.846458, 20.65124300000053],
                [86.846923000000203, 20.651443000000196],
                [86.847397000000328, 20.651662],
                [86.847878, 20.651872000000189],
                [86.848359000000158, 20.651979000000662],
                [86.848794, 20.652091000000322],
                [86.849175, 20.652223000000269],
                [86.849555, 20.652410000000426],
                [86.849984000000333, 20.652690000000341],
                [86.850471000000297, 20.653050000000459],
                [86.850998000000217, 20.653437000000505],
                [86.851547, 20.653770000000346],
                [86.852067, 20.654060000000182],
                [86.852539, 20.654390000000483],
                [86.85299, 20.654712000000469],
                [86.8535, 20.655019000000319],
                [86.853997, 20.655391000000744],
                [86.854524000000126, 20.655780000000384],
                [86.855050000000276, 20.656120000000666],
                [86.85553800000018, 20.65647800000044],
                [86.855980000000315, 20.656829000000521],
                [86.856393000000168, 20.657179999999865],
                [86.856819000000286, 20.65749000000033],
                [86.857284, 20.657768000000598],
                [86.857774, 20.658050000000284],
                [86.858223000000109, 20.658372000000266],
                [86.858612000000306, 20.658741],
                [86.858986000000172, 20.659122000000529],
                [86.859428000000307, 20.659429000000156],
                [86.859855000000294, 20.65978500000028],
                [86.860206, 20.660250000000584],
                [86.860604000000123, 20.660689999999697],
                [86.861076, 20.66107500000043],
                [86.86164100000029, 20.661383000000335],
                [86.862266000000119, 20.661661],
                [86.862954, 20.661950000000211],
                [86.863624, 20.662269000000659],
                [86.864151000000319, 20.662741],
                [86.864648, 20.663249000000402],
                [86.865272000000317, 20.66357700000037],
                [86.86586000000031, 20.6638800000004],
                [86.866416000000115, 20.664181],
                [86.866883000000243, 20.664510000000114],
                [86.867241, 20.664899000000158],
                [86.867538000000238, 20.665319000000235],
                [86.867836, 20.665740000000419],
                [86.868217000000286, 20.666089000000337],
                [86.868675000000152, 20.666385000000499],
                [86.869179000000301, 20.666661000000428],
                [86.869698, 20.66694600000039],
                [86.870179000000263, 20.66726000000028],
                [86.870582000000226, 20.66761100000036],
                [86.870986000000229, 20.667901000000366],
                [86.87136, 20.668190000000319],
                [86.871697000000239, 20.668489000000186],
                [86.872078000000201, 20.668760000000756],
                [86.872406000000154, 20.669081000000286],
                [86.872727, 20.669401000000104],
                [86.873046000000315, 20.669711],
                [86.873384000000243, 20.67],
                [86.873712000000225, 20.670276000000396],
                [86.874031, 20.670549000000616],
                [86.874359, 20.670841000000102],
                [86.874687, 20.671160000000206],
                [86.87499300000033, 20.671529000000529],
                [86.875259000000128, 20.671949000000264],
                [86.875487000000348, 20.67240000000049],
                [86.875802000000107, 20.672742000000532],
                [86.876107000000317, 20.673011],
                [86.876397000000154, 20.673241000000242],
                [86.876656000000239, 20.673439],
                [86.876907000000216, 20.673651000000401],
                [86.877167000000256, 20.6739160000003],
                [86.877418000000247, 20.674223000000492],
                [86.877664000000138, 20.674574000000398],
                [86.878006000000241, 20.674823],
                [86.878318, 20.675112000000123],
                [86.878587000000138, 20.675431],
                [86.878837000000246, 20.675775000000495],
                [86.879136000000287, 20.676062],
                [86.879431999999866, 20.676341],
                [86.87970800000015, 20.676650000000219],
                [86.879998, 20.676951000000425],
                [86.88028, 20.677264000000374],
                [86.880547000000135, 20.67758],
                [86.880829, 20.677906000000402],
                [86.881103000000138, 20.678234000000199],
                [86.881356, 20.67857000000026],
                [86.881661000000278, 20.678852000000685],
                [86.881951000000115, 20.679121000000233],
                [86.882233000000198, 20.679381000000202],
                [86.882500000000263, 20.679620000000451],
                [86.882751000000255, 20.679871000000613],
                [86.883056, 20.680281000000431],
                [86.883332000000138, 20.680561000000349],
                [86.883605, 20.680561000000349],
                [86.884164, 20.681111000000378],
                [86.884453, 20.681111000000378],
                [86.886101000000153, 20.682781000000542],
                [86.88639100000033, 20.682781000000542],
                [86.886666000000304, 20.683055000000646],
                [86.88683300000028, 20.683499],
                [86.887122000000247, 20.683812],
                [86.887391000000306, 20.684142000000342],
                [86.887719, 20.68439],
                [86.888045000000247, 20.684648000000429],
                [86.88836, 20.684949],
                [86.888702, 20.685252000000329],
                [86.889098000000303, 20.685489000000754],
                [86.889488000000227, 20.685710000000196],
                [86.889878000000323, 20.685872000000295],
                [86.890167000000289, 20.686157000000431],
                [86.890557, 20.686451000000257],
                [86.890976, 20.686681000000473],
                [86.891350000000301, 20.686936000000564],
                [86.891671, 20.687219000000191],
                [86.891876000000281, 20.687429000000346],
                [86.892501000000138, 20.688060000000515],
                [86.892777, 20.68805500000024],
                [86.894447, 20.689721],
                [86.894723000000141, 20.689719000000302],
                [86.895279000000102, 20.690277000000428],
                [86.895286000000141, 20.690831000000454],
                [86.897782000000262, 20.693334000000274],
                [86.898614000000208, 20.694170000000494],
                [86.898887000000215, 20.694166000000504],
                [86.898887000000215, 20.694444],
                [86.900184, 20.695741000000449],
                [86.90083300000029, 20.696390000000854],
                [86.9011, 20.696390000000854],
                [86.902497000000139, 20.697780000000417],
                [86.903053000000156, 20.697778000000252],
                [86.903609000000287, 20.698333999999871],
                [86.903892, 20.69833000000045],
                [86.904168000000169, 20.698610000000311],
                [86.904441000000219, 20.698610000000311],
                [86.904717000000318, 20.6988900000004],
                [86.9050000000003, 20.6988900000004],
                [86.905280000000204, 20.699171000000199],
                [86.905556000000303, 20.699168000000324],
                [86.90582900000031, 20.699444000000423],
                [86.905991000000228, 20.699444000000423],
                [86.906112000000107, 20.699444000000423],
                [86.906388000000206, 20.699721999999777],
                [86.90667000000029, 20.699720000000859],
                [86.906937000000354, 20.7],
                [86.907220000000152, 20.7],
                [86.9074090000003, 20.700187000000252],
                [86.907502000000179, 20.700281000000409],
                [86.907776000000283, 20.700281000000409],
                [86.908058000000182, 20.700559000000105],
                [86.908608000000228, 20.700556],
                [86.90889, 20.700834000000661],
                [86.90915700000015, 20.700830000000504],
                [86.909722, 20.701391000000395],
                [86.909996000000135, 20.701391000000395],
                [86.910285000000258, 20.701669000000489],
                [86.910834000000179, 20.701666000000436],
                [86.911110000000107, 20.701944000000307],
                [86.91166600000011, 20.701944000000307],
                [86.911942, 20.70222200000023],
                [86.912498000000355, 20.70222200000023],
                [86.912781000000152, 20.702500000000324],
                [86.913063000000236, 20.702489000000465],
                [86.9133300000003, 20.702781000000297],
                [86.915001000000174, 20.702781000000297],
                [86.915283, 20.703061],
                [86.915832000000179, 20.703057],
                [86.916115000000318, 20.703332000000611],
                [86.916389000000237, 20.703332000000611],
                [86.916664000000125, 20.703610000000705],
                [86.916947000000263, 20.703610000000705],
                [86.91722, 20.70388800000023],
                [86.917656000000292, 20.704009000000323],
                [86.918221000000329, 20.704201000000179],
                [86.918738000000275, 20.704515000000239],
                [86.919365000000127, 20.704723],
                [86.919976, 20.704985000000583],
                [86.920562000000231, 20.705231000000303],
                [86.921127, 20.705390000000531],
                [86.921669000000151, 20.705580000000278],
                [86.922189000000216, 20.70588],
                [86.922713, 20.706238000000493],
                [86.923385000000209, 20.706263000000259],
                [86.923912000000129, 20.706450000000469],
                [86.924324000000283, 20.706758000000544],
                [86.924874000000145, 20.706835000000691],
                [86.925355000000295, 20.706981000000379],
                [86.925781, 20.707221000000683],
                [86.926193000000396, 20.70750100000037],
                [86.926642000000228, 20.707781000000292],
                [86.927087, 20.708021000000596],
                [86.927581000000302, 20.708166000000343],
                [86.928001000000208, 20.708335000000485],
                [86.928361000000152, 20.708499000000355],
                [86.928712000000232, 20.708629],
                [86.929008, 20.708802000000556],
                [86.92929800000023, 20.709012000000367],
                [86.92970300000016, 20.70919900000035],
                [86.930145000000294, 20.709374000000818],
                [86.930649000000287, 20.709461000000196],
                [86.931121, 20.709609000000167],
                [86.931572000000273, 20.7097460000005],
                [86.93198500000014, 20.70990300000016],
                [86.932092000000338, 20.709937000000135],
                [86.932395000000142, 20.710031000000637],
                [86.932794000000328, 20.71027],
                [86.933281000000292, 20.710500000000362],
                [86.933938000000282, 20.710710000000173],
                [86.934685000000272, 20.710881000000249],
                [86.93541, 20.711081000000657],
                [86.936126000000314, 20.711191000000149],
                [86.936821000000265, 20.711259],
                [86.937423000000166, 20.711366000000446],
                [86.938027, 20.71140000000042],
                [86.938592000000241, 20.71151],
                [86.939164000000162, 20.71161],
                [86.939798, 20.711469000000243],
                [86.940506000000184, 20.71140000000042],
                [86.941231000000116, 20.711389],
                [86.941963000000243, 20.711389],
                [86.94267400000011, 20.711366000000446],
                [86.943351000000163, 20.711241],
                [86.944023000000158, 20.711120000000502],
                [86.944686000000317, 20.711031000000272],
                [86.945359000000266, 20.710920000000325],
                [86.946015000000131, 20.710838000000244],
                [86.946685000000144, 20.710781000000164],
                [86.947341, 20.710778000000627],
                [86.947982000000181, 20.710781000000164],
                [86.948486000000329, 20.710580000000444],
                [86.948982000000328, 20.710448000000323],
                [86.949441000000135, 20.710279000000178],
                [86.949867, 20.710131],
                [86.950272000000297, 20.710019000000209],
                [86.950699000000128, 20.71000100000014],
                [86.95115700000018, 20.71000100000014],
                [86.951606000000353, 20.709960000000471],
                [86.951989, 20.70975],
                [86.952317, 20.709641000000371],
                [86.952583000000217, 20.709479],
                [86.95288, 20.709573000000599],
                [86.953217000000251, 20.709680000000382],
                [86.953582, 20.709721000000226],
                [86.953981000000255, 20.709721000000226],
                [86.95440700000033, 20.709680000000382],
                [86.954819000000299, 20.709484000000138],
                [86.955255000000278, 20.709428999999879],
                [86.955658000000241, 20.709352000000415],
                [86.956032000000135, 20.709222000000519],
                [86.956428, 20.709181000000108],
                [86.956841000000253, 20.709169000000365],
                [86.957267000000328, 20.709169000000365],
                [86.957702, 20.709169000000365],
                [86.958122, 20.709169000000365],
                [86.958527000000316, 20.709169000000365],
                [86.958892000000134, 20.709169000000365],
                [86.959168, 20.709167000000768],
                [86.959441000000282, 20.709445000000297],
                [86.959724, 20.709445000000297],
                [86.96, 20.709167000000768],
                [86.961944, 20.709167000000768],
                [86.962220000000158, 20.709445000000297],
                [86.963057999999847, 20.709445000000297],
                [86.963334000000131, 20.709167000000768],
                [86.965843000000106, 20.709169000000365],
                [86.966110000000327, 20.708891000000271],
                [86.966689000000287, 20.708891000000271],
                [86.96727, 20.708891000000271],
                [86.967872, 20.708891000000271],
                [86.968437000000151, 20.70888000000047],
                [86.968993000000339, 20.708857000000304],
                [86.96952, 20.708862000000178],
                [86.970010000000272, 20.708832000000196],
                [86.970443, 20.708629],
                [86.970887000000332, 20.708499000000355],
                [86.971336000000221, 20.708406000000643],
                [86.971717000000112, 20.708205000000355],
                [86.972100000000168, 20.708021000000596],
                [86.972458000000273, 20.707790000000497],
                [86.972863, 20.70759900000035],
                [86.973367000000195, 20.707460000000701],
                [86.973877000000115, 20.707221000000683],
                [86.974472000000134, 20.706952000000452],
                [86.976143, 20.706101000000213],
                [86.976731, 20.705662000000299],
                [86.977143000000325, 20.70535400000022],
                [86.978219000000351, 20.704679000000105],
                [86.97972800000035, 20.704219],
                [86.98030900000029, 20.704210000000383],
                [86.980911, 20.704139000000218],
                [86.981506000000408, 20.703961000000216],
                [86.98213900000016, 20.703861000000639],
                [86.98275000000028, 20.703670000000326],
                [86.983352000000338, 20.70359],
                [86.983878000000161, 20.703474000000252],
                [86.984421000000154, 20.703351000000563],
                [86.985016000000172, 20.703310000000211],
                [86.985626000000238, 20.703319000000246],
                [86.986192000000173, 20.703310000000211],
                [86.986702, 20.703180000000255],
                [86.987229000000156, 20.702979000000138],
                [86.987771000000222, 20.702792000000496],
                [86.988236000000171, 20.702637],
                [86.988701, 20.702521000000271],
                [86.98924300000013, 20.702450000000109],
                [86.989845000000216, 20.702261],
                [86.990647000000351, 20.70222200000023],
                [86.991151000000258, 20.702206000000157],
                [86.991662000000289, 20.702195000000298],
                [86.992386000000337, 20.702113000000619],
                [86.993118000000123, 20.702033000000252],
                [86.994278, 20.701963000000482],
                [86.995445000000288, 20.701896000000424],
                [87.000001000000324, 20.700281000000409],
                [87.003053000000222, 20.700281000000409],
                [87.004058, 20.700322000000252],
                [87.004912, 20.700242],
                [87.005195000000228, 20.700244000000335],
                [87.00548400000028, 20.700106999999829],
                [87.005699000000149, 20.699841000000216],
                [87.005699000000149, 20.699369000000271],
                [87.005546000000294, 20.69876000000033],
                [87.005273, 20.698489000000446],
                [87.004548000000142, 20.698220000000216],
                [87.004128000000193, 20.697951000000153],
                [87.003768, 20.697821000000257],
                [87.003274, 20.697482000000257],
                [87.002631000000321, 20.697281000000142],
                [87.002266000000347, 20.697140000000214],
                [87.001770000000349, 20.697140000000214],
                [87.000001000000324, 20.696680000000523],
                [86.999732000000265, 20.696951000000407],
                [86.999732000000265, 20.697170000000195],
                [86.999604, 20.697231000000269],
                [86.999306000000189, 20.697222000000231],
                [86.998971000000196, 20.697215],
                [86.998597000000345, 20.6972290000001],
                [86.998207000000235, 20.697299000000381],
                [86.997804000000301, 20.697429000000334],
                [86.997346, 20.697493000000119],
                [86.996878, 20.697541000000335],
                [86.996436000000216, 20.697701000000102],
                [86.995955, 20.697817],
                [86.995490000000117, 20.697995000000269],
                [86.994980000000197, 20.698124000000288],
                [86.994499000000175, 20.69831100000027],
                [86.994011000000327, 20.698489000000446],
                [86.993462000000179, 20.698642000000117],
                [86.992952000000102, 20.698811],
                [86.992386000000337, 20.698881000000362],
                [86.991867000000212, 20.698897],
                [86.99138600000019, 20.69894300000038],
                [86.9909600000003, 20.699061000000533],
                [86.99053100000036, 20.699109000000245],
                [86.990098000000202, 20.699050000000163],
                [86.989686000000205, 20.698911000000173],
                [86.98924300000013, 20.698820000000119],
                [86.988838000000257, 20.698740000000264],
                [86.98854100000014, 20.698610000000311],
                [86.988288, 20.698555000000564],
                [86.988122000000303, 20.69853900000032],
                [86.987839000000335, 20.6984],
                [86.987213000000267, 20.69820000000032],
                [86.987502000000319, 20.697211000000372],
                [86.988106000000215, 20.697420000000303],
                [86.988320000000186, 20.697500000000499],
                [86.988838000000257, 20.697620999999852],
                [86.989227, 20.697673],
                [86.989959, 20.69766200000026],
                [86.990440000000234, 20.697712000000646],
                [86.990882, 20.697671],
                [86.991279000000219, 20.697541000000335],
                [86.991714000000329, 20.697484],
                [86.992149000000254, 20.697413],
                [86.992539, 20.697252000000216],
                [86.992952000000102, 20.697122000000313],
                [86.993339000000319, 20.696980000000444],
                [86.993758000000327, 20.696887],
                [86.994132000000178, 20.696741000000255],
                [86.99452200000033, 20.696634000000468],
                [86.994912000000269, 20.696499000000468],
                [86.995331000000107, 20.696360000000134],
                [86.995796, 20.696199000000483],
                [86.996338000000122, 20.696069000000588],
                [86.996878, 20.695921000000222],
                [86.997437, 20.695834000000325],
                [86.998039000000162, 20.695766000000386],
                [86.998832, 20.695699000000328],
                [87.000001000000324, 20.695280000000306],
                [87.001168000000263, 20.695499000000151],
                [87.001594000000338, 20.695636000000484],
                [87.002166000000258, 20.695772000000371],
                [87.00293600000019, 20.695971],
                [87.00359300000018, 20.696176000000374],
                [87.00409, 20.696244000000316],
                [87.004798000000207, 20.696322000000233],
                [87.00522700000019, 20.696390000000854],
                [87.005867, 20.696390000000854],
                [87.006446000000125, 20.696452000000129],
                [87.007157000000163, 20.696650000000144],
                [87.007873000000117, 20.6969190000002],
                [87.00859100000018, 20.697256000000376],
                [87.00894200000026, 20.697391000000376],
                [87.009514000000181, 20.697730000000202],
                [87.010300000000186, 20.697928],
                [87.010658000000291, 20.697999000000202],
                [87.011146, 20.698120000000298],
                [87.011513, 20.698339000000484],
                [87.012085000000283, 20.698537000000496],
                [87.012436, 20.698669],
                [87.012871000000118, 20.698808000000376],
                [87.013154000000256, 20.6989400000001],
                [87.013443000000365, 20.699011],
                [87.013580000000317, 20.699301000000158],
                [87.014428000000336, 20.699631000000462],
                [87.015153, 20.699971],
                [87.015716000000324, 20.70030600000052],
                [87.016579000000306, 20.700643000000351],
                [87.017151, 20.700910000000189],
                [87.01772300000026, 20.701119000000112],
                [87.018432000000104, 20.701657000000406],
                [87.018715, 20.701723000000353],
                [87.019004000000209, 20.701723000000353],
                [87.019576000000299, 20.701657000000406],
                [87.019996000000205, 20.701450000000303],
                [87.020431, 20.701049000000349],
                [87.020707000000272, 20.70085],
                [87.021072000000103, 20.700782000000626],
                [87.021363000000164, 20.700711000000464],
                [87.021637, 20.700641000000186],
                [87.022858, 20.700641000000186],
                [87.023141000000223, 20.700711000000464],
                [87.023430000000118, 20.700846000000404],
                [87.024071000000262, 20.701452000000128],
                [87.024285000000333, 20.701723000000353],
                [87.024575000000169, 20.701992],
                [87.024932, 20.702261],
                [87.02514, 20.702330000000295],
                [87.025254000000231, 20.702371000000138],
                [87.025741000000195, 20.702651],
                [87.026528000000297, 20.703041000000322],
                [87.027100000000218, 20.70345100000014],
                [87.027672, 20.703581],
                [87.028312000000298, 20.70385],
                [87.028809000000237, 20.704121000000665],
                [87.029381, 20.704590000000557],
                [87.029671000000164, 20.70493200000066],
                [87.030097, 20.705402000000269],
                [87.030379000000252, 20.705668],
                [87.03067100000024, 20.70588],
                [87.031166000000198, 20.70588],
                [87.03180600000023, 20.705739000000275],
                [87.032599000000275, 20.705600000000285],
                [87.033447000000294, 20.705600000000285],
                [87.03373700000013, 20.705739000000275],
                [87.03423400000041, 20.705940000000393],
                [87.034523000000135, 20.706079000000496],
                [87.034949000000196, 20.70621100000022],
                [87.035309000000296, 20.706416000000495],
                [87.035735, 20.706480000000276],
                [87.036018, 20.706550000000213],
                [87.036376000000331, 20.706685000000217],
                [87.036659000000313, 20.706751000000164],
                [87.036980000000227, 20.707061],
                [87.037338, 20.707460000000701],
                [87.037338, 20.708000000000137],
                [87.038261000000361, 20.708540000000536],
                [87.038758000000243, 20.70888000000047],
                [87.039115000000308, 20.709080000000139],
                [87.039466, 20.709222000000519],
                [87.039902, 20.709418],
                [87.040412000000146, 20.709550000000256],
                [87.040688000000245, 20.709755000000197],
                [87.04090200000033, 20.709819000000319],
                [87.041260000000122, 20.709960000000471],
                [87.041685999999828, 20.710026],
                [87.042190000000161, 20.710090000000374],
                [87.042473000000115, 20.710229000000535],
                [87.042762, 20.710295],
                [87.043259000000347, 20.710361000000258],
                [87.044617, 20.710361000000258],
                [87.044829000000192, 20.710229000000535],
                [87.044891000000163, 20.710154000000156],
                [87.045121000000208, 20.709889000000256],
                [87.045189000000306, 20.709484000000138],
                [87.044617, 20.708877000000367],
                [87.044036000000148, 20.708460000000507],
                [87.043191, 20.708000000000137],
                [87.042343, 20.70759900000035],
                [87.041550000000115, 20.707259],
                [87.04067900000021, 20.706509000000377],
                [87.040321, 20.706241],
                [87.039749000000171, 20.705566000000143],
                [87.038468, 20.7054310000002],
                [87.0376040000003, 20.704688000000367],
                [87.036538, 20.703879000000192],
                [87.035683, 20.703341000000641],
                [87.034974000000304, 20.702801],
                [87.034179, 20.701924000000467],
                [87.033181000000113, 20.701450000000303],
                [87.032472, 20.700839000000535],
                [87.03154, 20.700103000000407],
                [87.030708000000146, 20.699250000000344],
                [87.030425, 20.698981000000284],
                [87.029709, 20.69856],
                [87.029213000000226, 20.698238000000451],
                [87.028846, 20.697701000000102],
                [87.027000000000314, 20.696349000000332],
                [87.026359000000397, 20.696151000000437],
                [87.025787000000136, 20.695811000000383],
                [87.025429, 20.69547200000039],
                [87.02413900000019, 20.694660000000166],
                [87.023642000000265, 20.6944600000005],
                [87.023070000000388, 20.694061000000197],
                [87.022583, 20.693651000000379],
                [87.021363000000164, 20.692771],
                [87.020721, 20.692233],
                [87.020287000000323, 20.691827],
                [87.019501000000318, 20.691419000000444],
                [87.018861000000271, 20.69108700000049],
                [87.018218000000203, 20.69082],
                [87.017357, 20.690338999999877],
                [87.016570000000101, 20.68966000000017],
                [87.01635800000011, 20.689400000000202],
                [87.015358000000148, 20.688440000000352],
                [87.014571000000245, 20.687768],
                [87.013648000000245, 20.68723],
                [87.011360000000124, 20.686010999999887],
                [87.010651000000252, 20.685475000000505],
                [87.009933000000188, 20.684801000000331],
                [87.00921500000014, 20.684190000000395],
                [87.006654000000111, 20.682642000000381],
                [87.005653000000265, 20.681968000000378],
                [87.00465500000027, 20.68142800000032],
                [87.002228, 20.679741000000373],
                [87.00144100000027, 20.679189000000175],
                [87.000869, 20.678661000000314],
                [87.000001000000324, 20.677220000000482],
                [86.998344, 20.676662000000299],
                [86.997223000000346, 20.676110000000101],
                [86.996949000000242, 20.676110000000101],
                [86.996108000000262, 20.675281],
                [86.995828, 20.675281],
                [86.995370000000307, 20.674813],
                [86.995279000000252, 20.674722000000763],
                [86.995003000000153, 20.674722000000763],
                [86.994720000000171, 20.674444],
                [86.994447000000363, 20.674444],
                [86.994164000000168, 20.674166000000238],
                [86.993887999999885, 20.674169000000454],
                [86.993606, 20.673890000000476],
                [86.993332000000279, 20.673890000000476],
                [86.993056000000337, 20.673609999999879],
                [86.992767, 20.673609999999879],
                [86.991944000000188, 20.672781000000548],
                [86.991668, 20.672781000000548],
                [86.991112000000243, 20.672220000000145],
                [86.990554000000131, 20.672222000000481],
                [86.989724000000351, 20.67138800000037],
                [86.989442000000267, 20.671390000000198],
                [86.98861, 20.670561000000358],
                [86.988320000000186, 20.670561000000358],
                [86.987222000000116, 20.669451000000546],
                [86.987222000000116, 20.669170000000172],
                [86.986946000000202, 20.66889000000014],
                [86.986946000000202, 20.668610000000221],
                [86.986663, 20.668334000000463],
                [86.986390000000185, 20.668334000000463],
                [86.986114, 20.668056000000202],
                [86.985832, 20.668060000000192],
                [86.985549000000248, 20.66778000000027],
                [86.985282000000183, 20.66778000000027],
                [86.984772, 20.667274000000358],
                [86.984444, 20.666944],
                [86.983329000000239, 20.666944],
                [86.982780000000261, 20.666389999999861],
                [86.982497000000293, 20.666389999999861],
                [86.981941000000162, 20.665831],
                [86.980836000000394, 20.665831],
                [86.980277, 20.665278000000395],
                [86.980004000000264, 20.665280000000216],
                [86.97972100000031, 20.665002000000467],
                [86.978607000000338, 20.665002000000467],
                [86.978333, 20.664721000000149],
                [86.978057000000135, 20.664721000000149],
                [86.976387000000145, 20.663055000000494],
                [86.976113, 20.663062000000362],
                [86.974716000000271, 20.661670000000296],
                [86.974443, 20.661670000000296],
                [86.974076000000224, 20.661296000000103],
                [86.973891000000179, 20.661111000000229],
                [86.973611000000162, 20.661111000000229],
                [86.973052, 20.660555000000436],
                [86.972779000000216, 20.660555000000436],
                [86.972503000000117, 20.660279000000511],
                [86.972221, 20.660279000000511],
                [86.971947, 20.659999000000422],
                [86.971658, 20.659999000000422],
                [86.971382, 20.65977100000077],
                [86.970833000000127, 20.659721000000498],
                [86.970276000000212, 20.659167000000306],
                [86.970001000000238, 20.659169999999843],
                [86.969169000000292, 20.658331],
                [86.968888000000149, 20.658333000000418],
                [86.96833, 20.657777],
                [86.968063000000299, 20.657779000000399],
                [86.967781, 20.657510000000169],
                [86.967507000000111, 20.657510000000169],
                [86.967216, 20.657221000000273],
                [86.966666000000131, 20.65722299999987],
                [86.966484, 20.657039000000108],
                [86.966110000000327, 20.656665000000423],
                [86.965843000000106, 20.656669000000413],
                [86.965278000000225, 20.656111000000404],
                [86.964996000000184, 20.656111000000404],
                [86.963334000000131, 20.65444000000036],
                [86.962502000000242, 20.654445],
                [86.962220000000158, 20.65416700000014],
                [86.961937, 20.654171000000126],
                [86.961670000000112, 20.653891000000268],
                [86.961112000000156, 20.653891000000268],
                [86.961037000000189, 20.653811000000527],
                [86.960930000000161, 20.653704],
                [86.960556000000324, 20.653333],
                [86.960556000000324, 20.653055000000499],
                [86.96, 20.653061000000314],
                [86.959717, 20.652781000000395],
                [86.959168, 20.652781000000395],
                [86.958336000000131, 20.651950999999766],
                [86.958047, 20.651950999999766],
                [86.957696000000325, 20.651591000000391],
                [86.957497000000188, 20.651389000000332],
                [86.957222000000144, 20.651389000000332],
                [86.956390000000269, 20.650554000000334],
                [86.956390000000269, 20.65027900000052],
                [86.955827000000212, 20.649720000000453],
                [86.954719, 20.649722000000104],
                [86.954446000000161, 20.649444000000184],
                [86.95417, 20.649444000000184],
                [86.953819000000337, 20.649096000000153],
                [86.952775000000301, 20.648056000000448],
                [86.952499000000202, 20.648059000000327],
                [86.952210000000235, 20.647778000000521],
                [86.951394, 20.647778000000521],
                [86.951180000000292, 20.647569000000654],
                [86.951104000000242, 20.64755300000024],
                [86.950835, 20.64750000000026],
                [86.950546, 20.647220000000395],
                [86.950553, 20.646944000000296],
                [86.949447, 20.64583400000026],
                [86.949165, 20.64583400000026],
                [86.948891000000273, 20.645556000000337],
                [86.948326, 20.645570000000472],
                [86.948059000000313, 20.645279999999893],
                [86.947777000000301, 20.645279999999893],
                [86.946662000000217, 20.644171000000139],
                [86.946396, 20.644171000000139],
                [86.946106000000256, 20.643890000000336],
                [86.945830000000313, 20.643890000000336],
                [86.945267000000271, 20.643330000000383],
                [86.945001, 20.643334000000372],
                [86.943054000000288, 20.641388000000287],
                [86.941949000000179, 20.641390000000111],
                [86.941391, 20.640832],
                [86.940835, 20.640834000000261],
                [86.940552, 20.641112000000529],
                [86.940003, 20.641112000000529],
                [86.939720000000122, 20.640834000000261],
                [86.9394470000003, 20.640834000000261],
                [86.939164000000162, 20.640556],
                [86.93860600000032, 20.640560000000331],
                [86.938332000000216, 20.640280000000299],
                [86.938056000000117, 20.640280000000299],
                [86.936386, 20.638612000000474],
                [86.936386, 20.638331000000672],
                [86.935554000000238, 20.637502],
                [86.93528000000029, 20.637502],
                [86.934998, 20.637221000000288],
                [86.934722000000107, 20.637221000000288],
                [86.934540000000354, 20.637039000000524],
                [86.934166000000147, 20.636668000000547],
                [86.933892, 20.636672000000537],
                [86.933610000000314, 20.636401000000312],
                [86.933327000000176, 20.636401000000312],
                [86.933051, 20.636109000000481],
                [86.932778, 20.636109000000481],
                [86.932502000000312, 20.635829],
                [86.932219000000174, 20.635829],
                [86.931946000000124, 20.636109000000481],
                [86.93, 20.63417],
                [86.929733000000326, 20.63417],
                [86.929443000000148, 20.633889000000462],
                [86.929168000000146, 20.633889000000462],
                [86.92778000000024, 20.632499],
                [86.927224, 20.632499],
                [86.926941000000255, 20.632221000000296],
                [86.926665000000341, 20.632223000000121],
                [86.926392000000121, 20.631945000000595],
                [86.926109000000153, 20.631945000000595],
                [86.925836000000317, 20.631667000000327],
                [86.925553000000193, 20.631669],
                [86.925004000000214, 20.631111000000651],
                [86.924721000000233, 20.631111000000651],
                [86.924445000000134, 20.630831000000562],
                [86.923889, 20.630832999999704],
                [86.921669000000151, 20.628611000000426],
                [86.921387, 20.628611000000426],
                [86.920562000000231, 20.627781000000645],
                [86.920562000000231, 20.627211],
                [86.919999000000161, 20.626667000000502],
                [86.919167000000286, 20.626671000000268],
                [86.918891000000187, 20.626391000000236],
                [86.918328000000301, 20.626391000000236],
                [86.918098, 20.626159000000197],
                [86.916947000000263, 20.626113000000142],
                [86.916847000000175, 20.626015000000386],
                [86.916664000000125, 20.625833],
                [86.915001000000174, 20.625833],
                [86.914169000000285, 20.625001000000335],
                [86.914169000000285, 20.624461000000391],
                [86.914435, 20.624171000000555],
                [86.914169000000285, 20.62389100000069],
                [86.914169000000285, 20.62333],
                [86.913886, 20.623057],
                [86.912781000000152, 20.623061000000231],
                [86.912498000000355, 20.622781000000309],
                [86.912215000000216, 20.622781000000309],
                [86.91166600000011, 20.62222],
                [86.911393000000245, 20.622222000000242],
                [86.911110000000107, 20.621944000000493],
                [86.910834000000179, 20.621944000000493],
                [86.910278000000218, 20.621388000000362],
                [86.909722, 20.621402000000266],
                [86.909446000000273, 20.62111],
                [86.908608000000228, 20.62111],
                [86.908058000000182, 20.620559000000124],
                [86.907776000000283, 20.620559000000124],
                [86.907593000000233, 20.620374000000307],
                [86.907220000000152, 20.62],
                [86.906937000000354, 20.62],
                [86.90667000000029, 20.619720000000367],
                [86.906388000000206, 20.619722000000131],
                [86.905556000000303, 20.618888000000592],
                [86.905563, 20.618610000000498],
                [86.905280000000204, 20.618334],
                [86.904168000000169, 20.618334],
                [86.903609000000287, 20.617776],
                [86.903343000000163, 20.61778],
                [86.901390000000191, 20.615829000000637],
                [86.901107, 20.615834000000511],
                [86.900558, 20.615278000000725],
                [86.90083300000029, 20.615],
                [86.90083300000029, 20.614720000000542],
                [86.900277000000102, 20.614165999999837],
                [86.899170000000169, 20.614170000000165],
                [86.898887000000215, 20.61389],
                [86.897216000000327, 20.612210000000513],
                [86.896943000000121, 20.612222000000255],
                [86.896385000000166, 20.611665000000354],
                [86.896111000000232, 20.611669999999883],
                [86.895835000000289, 20.611392000000357],
                [86.895546000000181, 20.611392000000357],
                [86.895156000000256, 20.610995000000511],
                [86.894997000000245, 20.610834000000686],
                [86.894723000000141, 20.610834000000686],
                [86.894447, 20.610556],
                [86.893891000000195, 20.61056],
                [86.893326, 20.610002000000456],
                [86.893059000000321, 20.610002000000456],
                [86.892777, 20.609719000000265],
                [86.892501000000138, 20.610002000000456],
                [86.89222100000022, 20.610002000000456],
                [86.891945000000121, 20.609721],
                [86.891945000000121, 20.609442999999825],
                [86.890274000000232, 20.607780000000101],
                [86.889998000000134, 20.607780000000101],
                [86.889442, 20.60721900000021],
                [86.88888600000017, 20.607221000000546],
                [86.888054, 20.606387],
                [86.887238000000224, 20.606061000000516],
                [86.886628000000229, 20.60611799999986],
                [86.886413, 20.606996000000201],
                [86.886452000000233, 20.608222],
                [86.886666000000304, 20.609168000000519],
                [86.886947000000106, 20.609439000000403],
                [86.886947000000106, 20.610002000000456],
                [86.887222000000335, 20.610282000000321],
                [86.887222000000335, 20.611665000000354],
                [86.886947000000106, 20.611941000000453],
                [86.886947000000106, 20.61250200000017],
                [86.887222000000335, 20.612778000000443],
                [86.887222000000335, 20.613332000000636],
                [86.887496, 20.613612000000327],
                [86.887496, 20.61389],
                [86.887779, 20.614165999999837],
                [86.887779, 20.61722],
                [86.887222000000335, 20.61778],
                [86.886947000000106, 20.61778],
                [86.886101000000153, 20.616951000000761],
                [86.886101000000153, 20.616670000000219],
                [86.885825, 20.616390000000134],
                [86.885003, 20.616390000000134],
                [86.883888000000169, 20.615271000000288],
                [86.884444, 20.614722000000363],
                [86.884444, 20.614444000000102],
                [86.884720000000101, 20.614165999999837],
                [86.884720000000101, 20.613612000000327],
                [86.885825, 20.61250200000017],
                [86.885825, 20.608060000000531],
                [86.8855590000002, 20.607499000000299],
                [86.885071, 20.606310000000683],
                [86.885003, 20.605831000000133],
                [86.885003, 20.605277000000111],
                [86.885276000000246, 20.604999000000529],
                [86.885276000000246, 20.604721000000492],
                [86.885003, 20.604445],
                [86.884720000000101, 20.604445],
                [86.884444, 20.604167000000466],
                [86.884164, 20.604169000000294],
                [86.883888000000169, 20.603889000000205],
                [86.883605, 20.603889000000205],
                [86.883332000000138, 20.603611000000452],
                [86.882500000000263, 20.603611000000452],
                [86.881942, 20.603059000000254],
                [86.881668000000317, 20.603059000000254],
                [86.88138600000029, 20.602779000000393],
                [86.880287, 20.602779000000393],
                [86.879998, 20.602501000000128],
                [86.8797220000001, 20.602501000000128],
                [86.878327000000112, 20.601110999999658],
                [86.877502000000263, 20.601110999999658],
                [86.87721900000011, 20.60083],
                [86.875275, 20.59888900000038],
                [86.874999, 20.598891000000716],
                [86.874443, 20.598330000000313],
                [86.873887000000295, 20.598333000000192],
                [86.873611000000196, 20.598613],
                [86.873338000000146, 20.598333000000192],
                [86.872780000000191, 20.598333000000192],
                [86.872497000000209, 20.598054],
                [86.872223000000105, 20.598054],
                [86.872039000000342, 20.59787000000011],
                [86.871948000000245, 20.597779],
                [86.871948000000245, 20.597501000000474],
                [86.870826000000349, 20.596391],
                [86.870553000000115, 20.596391],
                [86.870004000000151, 20.595830000000259],
                [86.869445, 20.595832],
                [86.86888900000028, 20.595279000000286],
                [86.868606000000142, 20.595281000000107],
                [86.868333000000277, 20.595000000000308],
                [86.868057000000334, 20.595000000000308],
                [86.866943000000191, 20.59389100000055],
                [86.866669, 20.59389100000055],
                [86.86554800000026, 20.592781],
                [86.865281000000195, 20.592781],
                [86.864167000000208, 20.591671000000186],
                [86.863891000000294, 20.591671000000186],
                [86.863608000000156, 20.591390000000384],
                [86.863328000000223, 20.591390000000384],
                [86.863189000000119, 20.591247000000291],
                [86.863052000000124, 20.591101000000489],
                [86.862779000000145, 20.591110000000295],
                [86.862503, 20.590834],
                [86.862220000000249, 20.590834],
                [86.861947, 20.590556000000326],
                [86.861655, 20.590561000000545],
                [86.861388000000289, 20.590279999999829],
                [86.860832000000102, 20.590279999999829],
                [86.860557000000284, 20.590000000000142],
                [86.860276000000141, 20.590000000000142],
                [86.860000000000227, 20.589722],
                [86.859727000000348, 20.589722],
                [86.859727000000348, 20.589446000000688],
                [86.859435000000346, 20.589170000000191],
                [86.859435000000346, 20.588890000000326],
                [86.858886, 20.588332000000147],
                [86.858612000000306, 20.588334000000483],
                [86.857781000000145, 20.587500000000428],
                [86.857498000000348, 20.587500000000428],
                [86.856942000000316, 20.586941000000529],
                [86.856666, 20.586944000000241],
                [86.85611, 20.586390000000215],
                [86.855827, 20.586390000000215],
                [86.855552000000259, 20.58667],
                [86.855278000000155, 20.586666000000314],
                [86.854722000000294, 20.587222000000335],
                [86.854722000000294, 20.587778000000121],
                [86.855002000000226, 20.588040000000316],
                [86.855759000000134, 20.588149],
                [86.856689000000173, 20.588350000000215],
                [86.856757000000115, 20.588621],
                [86.856614, 20.589031],
                [86.856117, 20.589161000000153],
                [86.855050000000276, 20.58909100000022],
                [86.853760000000122, 20.589093],
                [86.853051, 20.588350000000215],
                [86.852769000000166, 20.587949000000428],
                [86.852402, 20.587270000000213],
                [86.852317000000284, 20.586531000000374],
                [86.852317000000284, 20.585790000000312],
                [86.852607000000305, 20.584839999999865],
                [86.853332000000236, 20.584170000000423],
                [86.853332000000236, 20.583892000000329],
                [86.852782, 20.583331],
                [86.852500000000333, 20.583334000000146],
                [86.85194400000033, 20.582777000000416],
                [86.851670000000226, 20.582780000000124],
                [86.850563000000292, 20.581670000000312],
                [86.849990000000318, 20.581670000000312],
                [86.849168000000347, 20.580829],
                [86.848892, 20.580833000000716],
                [86.848053000000263, 20.579999],
                [86.847777000000335, 20.579999],
                [86.846948000000324, 20.579160000000282],
                [86.846107000000345, 20.579167000000318],
                [86.845902000000109, 20.57895800000011],
                [86.845824000000206, 20.578942000000378],
                [86.845558000000239, 20.578889000000455],
                [86.844719, 20.578060000000217],
                [86.844436000000115, 20.578060000000217],
                [86.843727000000271, 20.577339000000272],
                [86.843613, 20.577223],
                [86.843613, 20.576945000000531],
                [86.843055000000263, 20.576389000000169],
                [86.842499, 20.576945000000531],
                [86.841667000000172, 20.576945000000531],
                [86.839165000000293, 20.57444500000042],
                [86.838891000000146, 20.57444500000042],
                [86.838608000000391, 20.574167000000156],
                [86.838333, 20.574171000000316],
                [86.837501, 20.57333],
                [86.837218000000263, 20.573333000000268],
                [86.836389000000267, 20.572501],
                [86.836113000000168, 20.572220000000183],
                [86.83583, 20.572223000000456],
                [86.835281000000265, 20.571667000000613],
                [86.835007000000161, 20.571671000000258],
                [86.834166000000181, 20.570830000000282],
                [86.833610000000405, 20.570832000000102],
                [86.832519000000133, 20.570076000000594],
                [86.831017, 20.569062000000365],
                [86.830383000000182, 20.568658000000195],
                [86.829597000000192, 20.568519000000204],
                [86.829171, 20.568057000000689],
                [86.827500000000185, 20.56639000000046],
                [86.827217, 20.56639000000046],
                [86.824997, 20.564159],
                [86.824722000000222, 20.56416600000011],
                [86.824166, 20.563612],
                [86.823890000000105, 20.563890000000352],
                [86.823327000000106, 20.563890000000352],
                [86.822563, 20.563118],
                [86.821953, 20.562500000000448],
                [86.821662999999873, 20.562500000000448],
                [86.819167000000135, 20.560000000000397],
                [86.818611000000132, 20.560000000000397],
                [86.81833600000013, 20.559722000000303],
                [86.818055000000328, 20.559724000000635],
                [86.817779000000229, 20.55944400000072],
                [86.81639100000011, 20.55944400000072],
                [86.816200000000308, 20.559254000000291],
                [86.81583300000031, 20.558890000000584],
                [86.815553000000222, 20.558890000000584],
                [86.815277000000307, 20.55861200000049],
                [86.815003000000203, 20.55861200000049],
                [86.814721000000162, 20.558331000000688],
                [86.814454, 20.558331000000688],
                [86.814162000000266, 20.55861200000049],
                [86.813880000000182, 20.55861200000049],
                [86.813331000000105, 20.558060000000118],
                [86.813057000000327, 20.558060000000118],
                [86.812768, 20.557782000000199],
                [86.812501000000324, 20.557782000000199],
                [86.812408, 20.55768900000032],
                [86.812232000000265, 20.557502000000106],
                [86.811943000000142, 20.557502000000106],
                [86.811669, 20.557221000000307],
                [86.811669, 20.556943],
                [86.812225000000225, 20.556390000000473],
                [86.811943000000142, 20.556109000000159],
                [86.811943000000142, 20.555829000000237],
                [86.81138600000024, 20.555277000000384],
                [86.811111000000238, 20.55528],
                [86.809998000000149, 20.55417000000028],
                [86.809723000000176, 20.55417000000028],
                [86.808608, 20.55305100000043],
                [86.808335000000255, 20.55305500000042],
                [86.808052, 20.552777000000326],
                [86.807776, 20.552779000000154],
                [86.80750300000031, 20.552499000000232],
                [86.807220000000171, 20.552499000000232],
                [86.806947000000122, 20.552219000000147],
                [86.806388000000226, 20.552221000000312],
                [86.806115, 20.551945000000213],
                [86.805832000000109, 20.551945000000213],
                [86.804168000000274, 20.550277],
                [86.803886, 20.55027900000055],
                [86.803337000000269, 20.549721000000428],
                [86.803054, 20.549723],
                [86.802888, 20.549550000000629],
                [86.802780000000368, 20.549445000000329],
                [86.801942000000267, 20.549445000000329],
                [86.799721999999889, 20.547223000000482],
                [86.799446000000202, 20.547223000000482],
                [86.799163, 20.546943],
                [86.798890000000355, 20.546943],
                [86.798332000000173, 20.546388999999859],
                [86.798058, 20.546391000000423],
                [86.796768000000313, 20.545700000000632],
                [86.796342000000195, 20.545500000000228],
                [86.795312, 20.545160000000688],
                [86.794532000000217, 20.54482100000018],
                [86.793876000000282, 20.54482100000018],
                [86.79345000000022, 20.544750000000526],
                [86.7928780000003, 20.544550000000292],
                [86.792169, 20.544071000000137],
                [86.791665000000123, 20.543332000000245],
                [86.791665000000123, 20.54250100000041],
                [86.791107000000338, 20.541940000000515],
                [86.791116000000201, 20.541666],
                [86.790832999999836, 20.541388000000318],
                [86.790832999999836, 20.54111],
                [86.789436, 20.539720000000553],
                [86.789169000000385, 20.53972200000015],
                [86.786940000000342, 20.53750000000019],
                [86.786391, 20.53750000000019],
                [86.785842000000258, 20.536951],
                [86.785552, 20.536951],
                [86.78444700000027, 20.535830000000541],
                [86.78444700000027, 20.535278000000343],
                [86.78415800000019, 20.535],
                [86.78415800000019, 20.534179000000218],
                [86.782218000000256, 20.532222000000271],
                [86.782218000000256, 20.531944000000177],
                [86.781945, 20.53166600000025],
                [86.781532000000183, 20.530492000000315],
                [86.7805570000003, 20.529168000000531],
                [86.780281000000201, 20.528890000000438],
                [86.780281000000201, 20.528609000000639],
                [86.779998, 20.528329000000209],
                [86.779998, 20.528055000000105],
                [86.77944200000023, 20.527499000000315],
                [86.77944200000023, 20.527219000000397],
                [86.779725000000198, 20.526945000000293],
                [86.779716000000334, 20.526389000000272],
                [86.778893000000124, 20.525551000000402],
                [86.778893000000124, 20.525277000000298],
                [86.778610000000327, 20.525010000000574],
                [86.778610000000327, 20.52472100000011],
                [86.778054000000324, 20.524167000000485],
                [86.778054000000324, 20.523611000000123],
                [86.777771, 20.523331000000208],
                [86.777778, 20.52305500000028],
                [86.776946000000166, 20.522221000000396],
                [86.776946000000166, 20.520835],
                [86.776664000000238, 20.520555],
                [86.776657000000199, 20.520281000000118],
                [86.776108, 20.519721000000111],
                [86.776108, 20.518889000000396],
                [86.775834000000302, 20.518611000000472],
                [86.775834000000302, 20.518055000000508],
                [86.775558000000203, 20.517781000000578],
                [86.775558000000203, 20.517220000000119],
                [86.775276000000176, 20.516945000000131],
                [86.775276000000176, 20.5147220000004],
                [86.775558000000203, 20.514444000000132],
                [86.775558000000203, 20.513891],
                [86.775276000000176, 20.513610000000252],
                [86.775276000000176, 20.513070000000308],
                [86.775002, 20.512781000000182],
                [86.775002, 20.511671000000202],
                [86.774711000000281, 20.511390000000571],
                [86.775002, 20.511110000000706],
                [86.775002, 20.510829999999878],
                [86.774720000000158, 20.510556000000513],
                [86.774711000000281, 20.510280000000247],
                [86.774437000000177, 20.510009000000363],
                [86.774437000000177, 20.509451000000176],
                [86.774711000000281, 20.509170000000204],
                [86.774437000000177, 20.508890000000346],
                [86.774437000000177, 20.50832900000011],
                [86.773888000000255, 20.50777800000014],
                [86.773888000000255, 20.507499999999872],
                [86.772782000000205, 20.506390000000234],
                [86.772782000000205, 20.506112000000481],
                [86.77111, 20.504441000000266],
                [86.768669, 20.504444000000145],
                [86.768058000000309, 20.504444000000145],
                [86.76777700000018, 20.504168000000217],
                [86.766670000000246, 20.50417],
                [86.766114000000215, 20.503612000000427],
                [86.763885000000229, 20.503612000000427],
                [86.763611, 20.503334000000333],
                [86.763335, 20.503331000000113],
                [86.763046000000244, 20.503612000000427],
                [86.762223000000148, 20.503612000000427],
                [86.761391000000273, 20.504444000000145],
                [86.761391000000273, 20.504722000000239],
                [86.760559000000313, 20.505560000000283],
                [86.759452, 20.505560000000283],
                [86.757401000000172, 20.502661000000437],
                [86.756400000000312, 20.501248],
                [86.756179000000117, 20.500642000000532],
                [86.755539000000311, 20.499564000000525],
                [86.755554000000288, 20.499167000000678],
                [86.755279000000286, 20.499170000000216],
                [86.753891000000152, 20.497779],
                [86.753601000000316, 20.497779],
                [86.753325000000217, 20.497499000000513],
                [86.753325000000217, 20.497221000000248],
                [86.753052, 20.496945000000149],
                [86.753335000000206, 20.496665000000117],
                [86.753325000000217, 20.495559000000409],
                [86.752357000000117, 20.494582000000261],
                [86.751947000000115, 20.494167000000342],
                [86.751953, 20.493891000000243],
                [86.751664000000318, 20.493611000000548],
                [86.751388000000219, 20.491550000000185],
                [86.751388000000219, 20.490001000000625],
                [86.751106000000135, 20.489720000000826],
                [86.751115000000354, 20.48944500000027],
                [86.750832000000216, 20.489167000000343],
                [86.750832000000216, 20.488879000000502],
                [86.750556000000273, 20.488610000000271],
                [86.750556000000273, 20.48722000000037],
                [86.750832000000216, 20.486944000000104],
                [86.750832000000216, 20.48611],
                [86.750556000000273, 20.485839000000166],
                [86.750556000000273, 20.485000000000408],
                [86.75026700000015, 20.48472000000049],
                [86.750274, 20.484166000000467],
                [86.75, 20.483890000000368],
                [86.75, 20.48333],
                [86.749724, 20.483056000000484],
                [86.749734000000316, 20.48222],
                [86.749444000000125, 20.481944000000279],
                [86.749444000000125, 20.481670000000342],
                [86.749168, 20.481390000000484],
                [86.749168, 20.480832000000298],
                [86.748886000000297, 20.480556000000373],
                [86.748886000000297, 20.4802800000001],
                [86.748612000000193, 20.48],
                [86.748612000000193, 20.47971],
                [86.748336, 20.479444000000392],
                [86.748336, 20.478612],
                [86.748047, 20.478331000000306],
                [86.748054, 20.477778000000566],
                [86.747787000000329, 20.477502000000293],
                [86.74778000000029, 20.476943000000226],
                [86.747498, 20.476668000000242],
                [86.747498, 20.475829000000257],
                [86.747222000000107, 20.475556],
                [86.747222000000107, 20.475280000000108],
                [86.746666000000332, 20.474719000000274],
                [86.746666000000332, 20.474168000000642],
                [86.746392, 20.473901000000236],
                [86.746392, 20.473051000000449],
                [86.745551000000248, 20.472221000000498],
                [86.745551000000248, 20.471945000000229],
                [86.745278, 20.471667000000135],
                [86.745278, 20.47110900000035],
                [86.745002, 20.470833],
                [86.745002, 20.470278999999884],
                [86.744729000000262, 20.470001000000302],
                [86.744729000000262, 20.469721000000444],
                [86.743614000000179, 20.468611],
                [86.742766000000231, 20.468611],
                [86.7425, 20.46889100000049],
                [86.742226000000286, 20.468889000000328],
                [86.741661, 20.469441000000526],
                [86.741661, 20.470001000000302],
                [86.741387000000131, 20.470278999999884],
                [86.741387000000131, 20.470560000000368],
                [86.741661, 20.470840000000457],
                [86.741668000000331, 20.471667000000135],
                [86.741387000000131, 20.471941],
                [86.741387000000131, 20.472499000000251],
                [86.7411120000003, 20.47278],
                [86.7411120000003, 20.473901000000236],
                [86.740555, 20.474446000000224],
                [86.740546000000208, 20.474719000000274],
                [86.739997000000216, 20.475280000000108],
                [86.739997000000216, 20.475560000000193],
                [86.739165000000341, 20.476392000000313],
                [86.739165000000341, 20.476668000000242],
                [86.738892000000106, 20.476943000000226],
                [86.738892000000106, 20.477222000000204],
                [86.738326, 20.477780000000386],
                [86.738326, 20.478060000000479],
                [86.737777000000264, 20.478612],
                [86.737504, 20.478612],
                [86.737221000000233, 20.478890000000199],
                [86.736656, 20.478890000000199],
                [86.736389000000358, 20.479170000000121],
                [86.736113, 20.479166000000131],
                [86.73583300000017, 20.479444000000392],
                [86.734169000000335, 20.479444000000392],
                [86.733887, 20.479166000000131],
                [86.733887, 20.478612],
                [86.734725000000125, 20.478612],
                [86.735001000000224, 20.478331000000306],
                [86.73583300000017, 20.478331000000306],
                [86.736389000000358, 20.477778000000566],
                [86.736656, 20.477780000000386],
                [86.737777000000264, 20.476672000000175],
                [86.737777000000264, 20.476392000000313],
                [86.738053000000193, 20.476109000000175],
                [86.738053000000193, 20.475829000000257],
                [86.738609000000153, 20.475277],
                [86.738602000000114, 20.474999000000306],
                [86.738326, 20.474719000000274],
                [86.738609000000153, 20.474446000000224],
                [86.738602000000114, 20.472499000000251],
                [86.738326, 20.472219000000333],
                [86.738336000000317, 20.468889000000328],
                [86.738053000000193, 20.468611],
                [86.738037, 20.467481000000358],
                [86.737777000000264, 20.467223000000153],
                [86.737777000000264, 20.466943],
                [86.737504, 20.46666700000014],
                [86.737504, 20.466391000000439],
                [86.737221000000233, 20.46611100000052],
                [86.737221000000233, 20.465830000000548],
                [86.736945000000318, 20.465555],
                [86.736945000000318, 20.465001000000537],
                [86.736656, 20.464709000000308],
                [86.736663, 20.463889000000503],
                [86.736389000000358, 20.463611000000409],
                [86.736389000000358, 20.463054000000167],
                [86.736113, 20.462779000000179],
                [86.736107000000274, 20.461391],
                [86.73583300000017, 20.461110000000243],
                [86.73583300000017, 20.460278000000525],
                [86.735557, 20.460000000000431],
                [86.735557, 20.45972],
                [86.735275000000328, 20.459444],
                [86.735275000000328, 20.458888000000453],
                [86.735001000000224, 20.458610000000188],
                [86.735001000000224, 20.458061],
                [86.734725000000125, 20.457781000000516],
                [86.734725000000125, 20.457500000000206],
                [86.734436, 20.457220000000287],
                [86.734443, 20.456944000000529],
                [86.733887, 20.456388000000736],
                [86.733887, 20.45611],
                [86.733611000000153, 20.455834000000205],
                [86.733611000000153, 20.455278000000355],
                [86.733331000000291, 20.455000000000265],
                [86.733331000000291, 20.454371000000432],
                [86.733331000000291, 20.453888000000457],
                [86.733062000000231, 20.453610000000364],
                [86.733611000000153, 20.453056000000338],
                [86.733611000000153, 20.452499999999809],
                [86.733376, 20.452217000000239],
                [86.733360000000161, 20.452058000000417],
                [86.733331000000291, 20.451666000000667],
                [86.733611000000153, 20.451392000000332],
                [86.733611000000153, 20.44889],
                [86.733331000000291, 20.448609000000314],
                [86.733331000000291, 20.4477800000003],
                [86.733611000000153, 20.447499000000274],
                [86.733611000000153, 20.446961000000211],
                [86.733331000000291, 20.446670000000264],
                [86.733331000000291, 20.446389000000458],
                [86.733062000000231, 20.446109000000373],
                [86.733055000000192, 20.44527700000031],
                [86.732788000000127, 20.44499900000039],
                [86.732781, 20.444445000000766],
                [86.733331000000291, 20.443888999999839],
                [86.733062000000231, 20.443600000000284],
                [86.733055000000192, 20.443055000000466],
                [86.733331000000291, 20.442779000000368],
                [86.733331000000291, 20.441669],
                [86.733062000000231, 20.44139100000012],
                [86.733062000000231, 20.440281000000137],
                [86.732788000000127, 20.440001000000219],
                [86.732781, 20.439723000000637],
                [86.732499000000345, 20.439443],
                [86.732499000000345, 20.439167000000335],
                [86.733062000000231, 20.438611000000485],
                [86.733055000000192, 20.43805500000013],
                [86.732499000000345, 20.437501000000108],
                [86.732499000000345, 20.436391000000292],
                [86.732216000000207, 20.436111000000206],
                [86.732223000000246, 20.435001000000565],
                [86.732499000000345, 20.434732000000334],
                [86.732499000000345, 20.432220000000363],
                [86.732781, 20.431944000000264],
                [86.732781, 20.426666000000179],
                [86.733062000000231, 20.426390000000421],
                [86.733055000000192, 20.426112000000153],
                [86.733331000000291, 20.425834000000631],
                [86.733331000000291, 20.425000000000519],
                [86.733062000000231, 20.424722000000425],
                [86.733055000000192, 20.423612000000102],
                [86.733331000000291, 20.423334000000345],
                [86.733331000000291, 20.423056],
                [86.733611000000153, 20.422791000000185],
                [86.733611000000153, 20.418609],
                [86.733887, 20.418333],
                [86.733887, 20.417777000000449],
                [86.733331000000291, 20.417221000000662],
                [86.733331000000291, 20.416945000000162],
                [86.733055000000192, 20.416665000000304],
                [86.733055000000192, 20.416389000000542],
                [86.733611000000153, 20.415833000000529],
                [86.733055000000192, 20.415277000000398],
                [86.733062000000231, 20.41472100000038],
                [86.733331000000291, 20.414445],
                [86.733331000000291, 20.413889],
                [86.733062000000231, 20.41362],
                [86.733062000000231, 20.413331],
                [86.732781, 20.413055000000206],
                [86.732788000000127, 20.410830000000139],
                [86.733055000000192, 20.410555],
                [86.732499000000345, 20.410001000000644],
                [86.732788000000127, 20.409720000000103],
                [86.732223000000246, 20.409167000000533],
                [86.732216000000207, 20.408891000000263],
                [86.731940000000108, 20.408610000000458],
                [86.731940000000108, 20.408332000000197],
                [86.731667, 20.408057000000376],
                [86.731667, 20.407779000000115],
                [86.731391000000357, 20.407501000000362],
                [86.731056000000351, 20.407070000000257],
                [86.730003, 20.405821000000284],
                [86.72943100000019, 20.404880000000215],
                [86.731072, 20.40366000000034],
                [86.731712000000215, 20.403193000000439],
                [86.732711000000322, 20.402518000000381],
                [86.732781, 20.402778000000403],
                [86.733331000000291, 20.403334000000367],
                [86.733611000000153, 20.40333],
                [86.733887, 20.403610000000125],
                [86.734169000000335, 20.403610000000125],
                [86.73583300000017, 20.40389],
                [86.736107000000274, 20.404171000000357],
                [86.736389000000358, 20.404166000000483],
                [86.736496000000145, 20.404276000000547],
                [86.736663, 20.404444],
                [86.737504, 20.404444],
                [86.737777000000264, 20.40472200000033],
                [86.739441, 20.404720000000502],
                [86.739724, 20.405000000000367],
                [86.740546000000208, 20.405000000000367],
                [86.740838000000196, 20.404720000000502],
                [86.7411120000003, 20.404720000000502],
                [86.741387000000131, 20.405000000000367],
                [86.743058, 20.405000000000367],
                [86.743331, 20.405281000000397],
                [86.743607000000139, 20.405281000000397],
                [86.743890000000277, 20.405559000000434],
                [86.744163000000327, 20.40555600000021],
                [86.744446000000124, 20.405834000000478],
                [86.745002, 20.405834000000478],
                [86.745278, 20.40555600000021],
                [86.745551000000248, 20.405559000000434],
                [86.745827000000347, 20.405281000000397],
                [86.746666000000332, 20.405281000000397],
                [86.746948, 20.405000000000367],
                [86.748336, 20.405000000000367],
                [86.748886000000297, 20.405559000000434],
                [86.749168, 20.405559000000434],
                [86.749734000000316, 20.405000000000367],
                [86.749724, 20.40472200000033],
                [86.750556000000273, 20.403888000000389],
                [86.750556000000273, 20.403610000000125],
                [86.751953, 20.402220000000391],
                [86.751947000000115, 20.401666000000198],
                [86.752220000000122, 20.401390000000497],
                [86.752220000000122, 20.400551000000515],
                [86.751947000000115, 20.400278000000291],
                [86.751953, 20.4],
                [86.750274, 20.398332000000259],
                [86.75, 20.398332000000259],
                [86.749724, 20.398058],
                [86.749444000000125, 20.397778],
                [86.749168, 20.397779999999837],
                [86.748886000000297, 20.397500000000484],
                [86.748612000000193, 20.397222000000223],
                [86.748336, 20.397222000000223],
                [86.748054, 20.396944000000129],
                [86.747222000000107, 20.396944000000129],
                [86.746948, 20.396668000000428],
                [86.746110000000314, 20.396670000000594],
                [86.745827000000347, 20.396392000000329],
                [86.744729000000262, 20.396392000000329],
                [86.744446000000124, 20.396109000000362],
                [86.743890000000277, 20.396109000000362],
                [86.743607000000139, 20.395829000000269],
                [86.742775000000265, 20.395834000000487],
                [86.7425, 20.395556000000223],
                [86.741943000000319, 20.395560000000213],
                [86.741661, 20.395280000000124],
                [86.7411120000003, 20.395280000000124],
                [86.739997000000216, 20.394170000000482],
                [86.74028, 20.39389],
                [86.740546000000208, 20.39389],
                [86.740838000000196, 20.39360900000025],
                [86.7411120000003, 20.39360900000025],
                [86.741248000000198, 20.39374800000018],
                [86.741387000000131, 20.39389],
                [86.741668000000331, 20.39389],
                [86.741921, 20.39414000000016],
                [86.742226000000286, 20.394443000000134],
                [86.7425, 20.394443000000134],
                [86.742775000000265, 20.394721000000395],
                [86.743890000000277, 20.394776000000544],
                [86.744157000000186, 20.394999000000492],
                [86.745827000000347, 20.394999000000492],
                [86.746110000000314, 20.395280000000124],
                [86.746392, 20.395280000000124],
                [86.746666000000332, 20.395560000000213],
                [86.747222000000107, 20.395556000000223],
                [86.747498, 20.395834000000487],
                [86.748336, 20.395834000000487],
                [86.74870300000029, 20.39620500000029],
                [86.748886000000297, 20.396392000000329],
                [86.749444000000125, 20.396390000000164],
                [86.749519000000106, 20.396463000000491],
                [86.749734000000316, 20.396670000000594],
                [86.75, 20.396668000000428],
                [86.750274, 20.396944000000129],
                [86.751388000000219, 20.396944000000129],
                [86.751664000000318, 20.397222000000223],
                [86.751953, 20.397222000000223],
                [86.752220000000122, 20.397502000000312],
                [86.75250300000026, 20.397502000000312],
                [86.752776000000139, 20.397779999999837],
                [86.753325000000217, 20.397779999999837],
                [86.753601000000316, 20.398060000000495],
                [86.75444700000034, 20.398056000000334],
                [86.754723000000283, 20.398332000000259],
                [86.7549980000001, 20.398332000000259],
                [86.755279000000286, 20.398621000000155],
                [86.755548000000118, 20.398621000000155],
                [86.756111000000189, 20.399170000000137],
                [86.756669, 20.399170000000137],
                [86.757499, 20.398332000000259],
                [86.757774000000126, 20.398332000000259],
                [86.758057000000107, 20.398056000000334],
                [86.758330000000313, 20.398060000000495],
                [86.758606, 20.397779999999837],
                [86.758606, 20.395829000000269],
                [86.758330000000313, 20.395556000000223],
                [86.758330000000313, 20.395280000000124],
                [86.758057000000107, 20.394999000000492],
                [86.758057000000107, 20.39360900000025],
                [86.757774000000126, 20.393333000000322],
                [86.757774000000126, 20.392221000000681],
                [86.757499, 20.391945000000415],
                [86.757499, 20.391387],
                [86.757232, 20.391109000000707],
                [86.757225000000162, 20.390833000000264],
                [86.756942, 20.390557000000165],
                [86.756942, 20.390279000000245],
                [86.756669, 20.389999000000152],
                [86.756111000000189, 20.389432000000507],
                [86.756111000000189, 20.389165000000272],
                [86.756669, 20.388611],
                [86.756942, 20.388611],
                [86.757225000000162, 20.388889000000344],
                [86.757774000000126, 20.389445],
                [86.757768000000326, 20.389721],
                [86.758057000000107, 20.389999000000152],
                [86.758057000000107, 20.390279000000245],
                [86.758330000000313, 20.390557000000165],
                [86.758330000000313, 20.391109000000707],
                [86.758613, 20.391387],
                [86.758613, 20.391945000000415],
                [86.758889000000167, 20.392219000000349],
                [86.758889000000167, 20.393055],
                [86.759162000000217, 20.393333000000322],
                [86.759162000000217, 20.394443000000134],
                [86.759445000000355, 20.394721000000395],
                [86.759728000000152, 20.394999000000492],
                [86.759721000000113, 20.395278000000527],
                [86.760277000000301, 20.395829000000269],
                [86.760277000000301, 20.396109000000362],
                [86.761109000000189, 20.396944000000129],
                [86.762497, 20.396944000000129],
                [86.76277900000018, 20.397222000000223],
                [86.763046000000244, 20.397222000000223],
                [86.763335, 20.397502000000312],
                [86.763602, 20.397552000000186],
                [86.763680000000292, 20.39756800000043],
                [86.763893999999866, 20.397779999999837],
                [86.764167000000242, 20.397779999999837],
                [86.764443000000341, 20.397502000000312],
                [86.764999000000202, 20.397502000000312],
                [86.765266, 20.397779999999837],
                [86.765555000000163, 20.397778],
                [86.766114000000215, 20.398332000000259],
                [86.766387000000108, 20.398332000000259],
                [86.766670000000246, 20.398056000000334],
                [86.766936000000186, 20.398060000000495],
                [86.767219000000395, 20.397779999999837],
                [86.768058000000309, 20.397779999999837],
                [86.768327, 20.398060000000495],
                [86.768899000000289, 20.398060000000495],
                [86.769172000000125, 20.397779999999837],
                [86.769997, 20.397779999999837],
                [86.770280000000326, 20.397502000000312],
                [86.770547, 20.397502000000312],
                [86.770836000000287, 20.397222000000223],
                [86.77111, 20.397222000000223],
                [86.771385000000109, 20.396944000000129],
                [86.772500000000122, 20.396944000000129],
                [86.772782000000205, 20.396668000000428],
                [86.773056000000309, 20.396670000000594],
                [86.773888000000255, 20.395829000000269],
                [86.774170000000112, 20.395834000000487],
                [86.774444000000216, 20.395556000000223],
                [86.774711000000281, 20.395560000000213],
                [86.775002, 20.395280000000124],
                [86.775276000000176, 20.395280000000124],
                [86.776108, 20.394439000000713],
                [86.776390000000134, 20.394443000000134],
                [86.776664000000238, 20.394168000000143],
                [86.777222, 20.394170000000482],
                [86.779716000000334, 20.3916700000002],
                [86.779716000000334, 20.391389000000625],
                [86.779998, 20.391109000000707],
                [86.779998, 20.390833000000264],
                [86.780830000000122, 20.389999000000152],
                [86.780830000000122, 20.389723000000227],
                [86.781113000000104, 20.389445],
                [86.781113000000104, 20.388889000000344],
                [86.781669000000107, 20.388331000000157],
                [86.781669000000107, 20.387777000000195],
                [86.781938000000352, 20.387501000000437],
                [86.781938000000352, 20.386681000000461],
                [86.782218000000256, 20.386391],
                [86.782218000000256, 20.385830000000166],
                [86.781945, 20.385555000000345],
                [86.782218000000256, 20.385281],
                [86.782218000000256, 20.383622000000283],
                [86.781938000000352, 20.383330000000111],
                [86.781945, 20.383055],
                [86.781669000000107, 20.382779000000365],
                [86.781669000000107, 20.382220000000299],
                [86.781113000000104, 20.38166700000016],
                [86.781113000000104, 20.381391],
                [86.779716000000334, 20.38],
                [86.779166000000131, 20.38],
                [86.778893000000124, 20.379720000000187],
                [86.778334000000228, 20.379722000000349],
                [86.778054000000324, 20.379444],
                [86.776390000000134, 20.379444],
                [86.776108, 20.379169000000271],
                [86.775558000000203, 20.379169000000271],
                [86.775276000000176, 20.378891000000177],
                [86.774720000000158, 20.378888000000469],
                [86.774444000000216, 20.378610000000204],
                [86.773888000000255, 20.378610000000204],
                [86.773612000000341, 20.378330000000286],
                [86.773332, 20.378334000000443],
                [86.773056000000309, 20.378056000000349],
                [86.772782000000205, 20.378059000000459],
                [86.772224, 20.377498],
                [86.771668000000233, 20.376940000000555],
                [86.771668000000233, 20.376666000000448],
                [86.769722000000144, 20.374720000000192],
                [86.769722000000144, 20.374444000000491],
                [86.769172000000125, 20.373890000000294],
                [86.769172000000125, 20.37361000000055],
                [86.768890000000269, 20.373334000000106],
                [86.768890000000269, 20.373056000000357],
                [86.768607000000301, 20.37278],
                [86.768607000000301, 20.372222000000473],
                [86.767219000000395, 20.370832],
                [86.766946000000161, 20.370832],
                [86.766114000000215, 20.370002000000451],
                [86.766114000000215, 20.369722000000362],
                [86.765831, 20.369444],
                [86.765831, 20.368890000000302],
                [86.765266, 20.368320000000377],
                [86.765275000000301, 20.368056],
                [86.764999000000202, 20.367780000000263],
                [86.764999000000202, 20.367499000000461],
                [86.764717000000118, 20.367219],
                [86.764726000000152, 20.366946000000375],
                [86.764167000000242, 20.366389000000137],
                [86.764167000000242, 20.365829000000129],
                [86.764726000000152, 20.36527700000067],
                [86.765555000000163, 20.366109],
                [86.765555000000163, 20.366389000000137],
                [86.765831, 20.36667000000045],
                [86.765831, 20.366946000000375],
                [86.766114000000215, 20.367219],
                [86.766114000000215, 20.367499000000461],
                [86.766387000000108, 20.367780000000263],
                [86.766387000000108, 20.368060000000352],
                [86.766936000000186, 20.36860900000033],
                [86.766946000000161, 20.368890000000302],
                [86.767502000000121, 20.369444],
                [86.767502000000121, 20.369722000000362],
                [86.767944000000313, 20.369981000000504],
                [86.768386000000291, 20.370332000000413],
                [86.768844000000144, 20.370681000000328],
                [86.769279, 20.371059000000511],
                [86.769731000000178, 20.371390000000186],
                [86.770173000000383, 20.371709000000287],
                [86.770560000000188, 20.372078000000268],
                [86.770911000000339, 20.372441000000318],
                [86.771233000000137, 20.372751000000161],
                [86.771492000000222, 20.373019000000333],
                [86.771720000000116, 20.373291000000101],
                [86.771957, 20.373601000000516],
                [86.772224, 20.373956],
                [86.772529000000233, 20.374392000000451],
                [86.772865000000351, 20.374877],
                [86.773216, 20.375362000000219],
                [86.773797, 20.375604000000173],
                [86.774444000000216, 20.375834000000165],
                [86.774720000000158, 20.375834000000165],
                [86.775002, 20.376112000000429],
                [86.775276000000176, 20.37611],
                [86.775558000000203, 20.37639],
                [86.775834000000302, 20.37611],
                [86.775971000000126, 20.37611],
                [86.776390000000134, 20.376112000000429],
                [86.776664000000238, 20.375834000000165],
                [86.777778, 20.375834000000165],
                [86.778054000000324, 20.375556000000635],
                [86.778610000000327, 20.375556000000635],
                [86.778893000000124, 20.375834000000165],
                [86.77944200000023, 20.375834000000165],
                [86.779556, 20.375944000000395],
                [86.779725000000198, 20.376112000000429],
                [86.780281000000201, 20.37611],
                [86.780563, 20.37639],
                [86.780837, 20.37639],
                [86.78135, 20.376340000000308],
                [86.781883000000263, 20.376529000000115],
                [86.782501, 20.376618000000569],
                [86.783127000000121, 20.37668000000053],
                [86.783761000000183, 20.376901000000537],
                [86.784363000000255, 20.37742000000031],
                [86.784951000000234, 20.377462000000431],
                [86.785523000000339, 20.377202000000405],
                [86.786079000000115, 20.376915000000107],
                [86.78637800000017, 20.376513000000212],
                [86.786232, 20.375962000000463],
                [86.785981, 20.375406000000108],
                [86.785737, 20.3749000000007],
                [86.785530000000193, 20.374474000000298],
                [86.785224000000127, 20.374120000000683],
                [86.784919000000258, 20.373801000000178],
                [86.784645000000168, 20.37348],
                [86.784577000000226, 20.373017000000512],
                [86.784721, 20.372390000000504],
                [86.784652000000207, 20.372071],
                [86.7844630000004, 20.371839000000247],
                [86.784278, 20.371586],
                [86.784103, 20.371271],
                [86.783807000000124, 20.370930000000495],
                [86.783433000000201, 20.370519],
                [86.783014000000193, 20.370020000000345],
                [86.78256900000035, 20.36947500000036],
                [86.7820880000003, 20.368940000000517],
                [86.781669000000107, 20.368379000000115],
                [86.78125900000029, 20.367866000000269],
                [86.780853000000135, 20.367429000000179],
                [86.780563, 20.366991000000208],
                [86.780274000000162, 20.366560000000444],
                [86.780007000000111, 20.366109],
                [86.779716000000334, 20.365551],
                [86.779725000000198, 20.36527700000067],
                [86.77944200000023, 20.364999000000402],
                [86.77944200000023, 20.364719000000317],
                [86.779166000000131, 20.36444500000021],
                [86.779166000000131, 20.364167000000119],
                [86.778893000000124, 20.363889],
                [86.778893000000124, 20.363611000000329],
                [86.778610000000327, 20.36333100000024],
                [86.778610000000327, 20.363055000000141],
                [86.77834400000016, 20.362779],
                [86.77834400000016, 20.36222099999986],
                [86.778054000000324, 20.361945000000155],
                [86.778054000000324, 20.36166500000024],
                [86.777840000000239, 20.361384000000267],
                [86.777778, 20.360835000000119],
                [86.777496000000184, 20.360555000000428],
                [86.777496000000184, 20.359171000000455],
                [86.777222, 20.358891000000593],
                [86.777496000000184, 20.358611],
                [86.777496000000184, 20.35833300000041],
                [86.777573000000174, 20.358260000000424],
                [86.777778, 20.358055000000142],
                [86.777771, 20.355561000000588],
                [86.778610000000327, 20.354720000000263],
                [86.778610000000327, 20.355281000000666],
                [86.778893000000124, 20.355557000000424],
                [86.778893000000124, 20.356111000000222],
                [86.779166000000131, 20.356380000000453],
                [86.779166000000131, 20.35667100000023],
                [86.778893000000124, 20.35695200000054],
                [86.778893000000124, 20.358891000000593],
                [86.779166000000131, 20.359171000000455],
                [86.779166000000131, 20.359443000000223],
                [86.77944200000023, 20.359721000000317],
                [86.77944200000023, 20.360281000000324],
                [86.779716000000334, 20.360559000000361],
                [86.779725000000198, 20.36166500000024],
                [86.779998, 20.361945000000155],
                [86.779998, 20.36222099999986],
                [86.780830000000122, 20.363055000000141],
                [86.780837, 20.363611000000329],
                [86.781113000000104, 20.363889],
                [86.782501, 20.36527700000067],
                [86.782501, 20.365551],
                [86.78388900000013, 20.366946000000375],
                [86.783898000000178, 20.367219],
                [86.78444700000027, 20.367780000000263],
                [86.78444700000027, 20.368060000000352],
                [86.786667000000122, 20.370278000000209],
                [86.786667000000122, 20.370832],
                [86.787499, 20.371670000000275],
                [86.788331000000298, 20.370832],
                [86.788331000000298, 20.370556000000303],
                [86.788613, 20.370282000000195],
                [86.788613, 20.370002000000451],
                [86.788887000000145, 20.369722000000362],
                [86.788613, 20.369444],
                [86.788613, 20.368056],
                [86.789169000000385, 20.367499000000461],
                [86.789169000000385, 20.367219],
                [86.789443000000105, 20.366946000000375],
                [86.789436, 20.36667000000045],
                [86.789169000000385, 20.366389000000137],
                [86.789169000000385, 20.366109],
                [86.788613, 20.365555],
                [86.788841, 20.365325000000549],
                [86.789443000000105, 20.364721000000142],
                [86.789169000000385, 20.36444500000021],
                [86.789169000000385, 20.363611000000329],
                [86.790001000000288, 20.362779],
                [86.790001000000288, 20.361111000000218],
                [86.789436, 20.360559000000361],
                [86.789436, 20.360281000000324],
                [86.789712000000165, 20.360001000000235],
                [86.789436, 20.359721000000317],
                [86.789719, 20.359443000000223],
                [86.789712000000165, 20.359171000000455],
                [86.789169000000385, 20.358611],
                [86.789169000000385, 20.35833300000041],
                [86.788613, 20.357779000000384],
                [86.788331000000298, 20.357501000000124],
                [86.788331000000298, 20.357221000000262],
                [86.788055000000199, 20.356945000000504],
                [86.788064000000233, 20.35667100000023],
                [86.786940000000342, 20.355561000000588],
                [86.786940000000342, 20.355281000000666],
                [86.786667000000122, 20.355000999999898],
                [86.786667000000122, 20.354720000000263],
                [86.78444700000027, 20.352500000000415],
                [86.78444700000027, 20.35222000000055],
                [86.784164000000132, 20.351944000000227],
                [86.784164000000132, 20.351669000000239],
                [86.783898000000178, 20.35139],
                [86.783898000000178, 20.351110000000343],
                [86.783608000000342, 20.350834000000415],
                [86.783608000000342, 20.350556000000147],
                [86.782776, 20.349720000000438],
                [86.782776, 20.349446000000508],
                [86.782218000000256, 20.348890000000491],
                [86.782218000000256, 20.34861],
                [86.781945, 20.34833400000036],
                [86.781945, 20.348054000000271],
                [86.781669000000107, 20.347778000000339],
                [86.781669000000107, 20.347220000000387],
                [86.781113000000104, 20.346666000000194],
                [86.781113000000104, 20.346390000000433],
                [86.780837, 20.346110000000344],
                [86.780830000000122, 20.345834],
                [86.777778, 20.342778000000177],
                [86.777496000000184, 20.342782000000167],
                [86.777222, 20.3425],
                [86.776946000000166, 20.3425],
                [86.776108, 20.343331000000255],
                [86.776108, 20.343612],
                [86.775834000000302, 20.34389200000015],
                [86.776108, 20.344166],
                [86.776108, 20.344722000000612],
                [86.775834000000302, 20.345000000000532],
                [86.775834000000302, 20.345834],
                [86.775558000000203, 20.346110000000344],
                [86.775558000000203, 20.346390000000433],
                [86.775276000000176, 20.346666000000194],
                [86.775276000000176, 20.346944000000459],
                [86.774758000000119, 20.347458999999898],
                [86.774437000000177, 20.347509000000283],
                [86.774193, 20.34724700000049],
                [86.773888000000255, 20.347222000000151],
                [86.773612000000341, 20.346944000000459],
                [86.773612000000341, 20.346666000000194],
                [86.773888000000255, 20.346390000000433],
                [86.773888000000255, 20.346110000000344],
                [86.774720000000158, 20.345278000000288],
                [86.774711000000281, 20.34417],
                [86.774437000000177, 20.34389200000015],
                [86.774437000000177, 20.343060000000428],
                [86.774170000000112, 20.342782000000167],
                [86.774170000000112, 20.34221900000011],
                [86.774720000000158, 20.341668000000364],
                [86.774711000000281, 20.340560000000149],
                [86.775002, 20.340280000000458],
                [86.775002, 20.339718999999825],
                [86.774720000000158, 20.339446000000173],
                [86.774711000000281, 20.33917],
                [86.774437000000177, 20.338889000000105],
                [86.774437000000177, 20.33834],
                [86.774711000000281, 20.33806],
                [86.774398000000346, 20.337779000000292],
                [86.774170000000112, 20.337779000000292],
                [86.772500000000122, 20.336111000000294],
                [86.772500000000122, 20.335831000000379],
                [86.771385000000109, 20.334723000000221],
                [86.771385000000109, 20.334445000000294],
                [86.77111, 20.334167000000544],
                [86.77111, 20.333611],
                [86.770547, 20.333062000000261],
                [86.770547, 20.332501000000374],
                [86.769172000000125, 20.331111000000472],
                [86.768890000000269, 20.331113000000297],
                [86.768607000000301, 20.330833000000375],
                [86.768334, 20.330833000000375],
                [86.768058000000309, 20.330555000000281],
                [86.76777700000018, 20.330561],
                [86.767219000000395, 20.330001],
                [86.766936000000186, 20.330001],
                [86.766670000000246, 20.329720000000513],
                [86.766387000000108, 20.329720000000513],
                [86.766114000000215, 20.329445000000302],
                [86.765831, 20.329445000000302],
                [86.764726000000152, 20.328335000000656],
                [86.764167000000242, 20.327779000000302],
                [86.763893999999866, 20.327781000000464],
                [86.763335, 20.327220000000235],
                [86.763053000000284, 20.327223000000455],
                [86.76277900000018, 20.326944000000477],
                [86.762497, 20.326944000000477],
                [86.762223000000148, 20.326666000000209],
                [86.761947000000234, 20.326669000000319],
                [86.761674, 20.326400000000259],
                [86.761391000000273, 20.326400000000259],
                [86.761109000000189, 20.326110000000423],
                [86.760826, 20.326110000000423],
                [86.760277000000301, 20.32555900000062],
                [86.760001000000202, 20.32555900000062],
                [86.759162000000217, 20.324720000000124],
                [86.758889000000167, 20.324722000000286],
                [86.758798000000269, 20.324629],
                [86.758613, 20.324444],
                [86.758330000000313, 20.324444],
                [86.758194, 20.324308000000137],
                [86.758057000000107, 20.324166],
                [86.757768000000326, 20.324171000000543],
                [86.757499, 20.32389000000023],
                [86.757232, 20.32389000000023],
                [86.756942, 20.323610000000141],
                [86.756386000000234, 20.323610000000141],
                [86.755837, 20.323061],
                [86.755548000000118, 20.323061],
                [86.7549980000001, 20.322500000000499],
                [86.753325000000217, 20.322500000000499],
                [86.752776000000139, 20.321951000000347],
                [86.752220000000122, 20.321951000000347],
                [86.751664000000318, 20.321390000000118],
                [86.751388000000219, 20.321390000000118],
                [86.75, 20.320000000000217],
                [86.749724, 20.320000000000217],
                [86.749168, 20.319443999999688],
                [86.748886000000297, 20.319443999999688],
                [86.748612000000193, 20.319166000000333],
                [86.748336, 20.319170000000323],
                [86.748047, 20.318890000000572],
                [86.74778000000029, 20.318890000000572],
                [86.746948, 20.31805600000035],
                [86.746666000000332, 20.31806],
                [86.746110000000314, 20.317502000000328],
                [86.745827000000347, 20.317502000000328],
                [86.745704000000146, 20.317372000000372],
                [86.745551000000248, 20.317210000000156],
                [86.745278, 20.31722200000041],
                [86.744719000000359, 20.316668000000387],
                [86.744157000000186, 20.316112000000768],
                [86.743890000000277, 20.316112000000768],
                [86.743058, 20.315280000000481],
                [86.743058, 20.315000000000616],
                [86.742233000000326, 20.314170000000157],
                [86.741943000000319, 20.314170000000157],
                [86.741661, 20.313890000000239],
                [86.741661, 20.313609000000262],
                [86.7411120000003, 20.313055000000244],
                [86.7411120000003, 20.312780000000256],
                [86.738053000000193, 20.309721],
                [86.737777000000264, 20.30944500000032],
                [86.737504, 20.30944500000032],
                [86.736945000000318, 20.308889000000359],
                [86.736656, 20.308889000000359],
                [86.736389000000358, 20.308611000000266],
                [86.736107000000274, 20.308611000000266],
                [86.73583300000017, 20.308331000000344],
                [86.735557, 20.308333000000172],
                [86.735001000000224, 20.307777000000154],
                [86.734725000000125, 20.307781000000485],
                [86.734436, 20.307500999999711],
                [86.733611000000153, 20.307500999999711],
                [86.733331000000291, 20.307221000000531],
                [86.732223000000246, 20.307223000000359],
                [86.732057000000211, 20.307054000000388],
                [86.731940000000108, 20.30694300000027],
                [86.72972, 20.30694300000027],
                [86.729584, 20.306804000000337],
                [86.729447000000263, 20.306667000000513],
                [86.727218000000192, 20.306672],
                [86.726935, 20.306391],
                [86.726386000000261, 20.306389000000248],
                [86.7258300000003, 20.30694300000027],
                [86.725556000000196, 20.30694300000027],
                [86.725281000000152, 20.307223000000359],
                [86.724998000000355, 20.307223000000359],
                [86.724725, 20.30694300000027],
                [86.724725, 20.306667000000513],
                [86.724442000000209, 20.306391],
                [86.723893000000245, 20.306391],
                [86.723815, 20.306311000000388],
                [86.723334000000179, 20.305833000000625],
                [86.722496000000135, 20.305831000000122],
                [86.721946, 20.306391],
                [86.72165700000015, 20.306391],
                [86.72139, 20.306111000000154],
                [86.721108, 20.306111000000154],
                [86.720832000000286, 20.305831000000122],
                [86.720558000000182, 20.305833000000625],
                [86.720444000000128, 20.305721],
                [86.720276, 20.305555000000364],
                [86.720002000000349, 20.305562],
                [86.719863000000245, 20.305420000000364],
                [86.71972, 20.30527700000027],
                [86.719444, 20.30527700000027],
                [86.718888000000206, 20.304723000000248],
                [86.718612000000263, 20.304723000000248],
                [86.718329000000139, 20.304445000000552],
                [86.718063000000114, 20.30445200000042],
                [86.717780000000388, 20.304171000000448],
                [86.717500000000115, 20.304171000000448],
                [86.717217000000318, 20.303891000000526],
                [86.716941000000219, 20.303891000000526],
                [86.716759, 20.303704000000319],
                [86.716392, 20.303333000000347],
                [86.716109000000273, 20.303333000000347],
                [86.715836000000294, 20.303055],
                [86.715553000000156, 20.303055],
                [86.715278000000112, 20.302779000000378],
                [86.714997000000295, 20.302781000000149],
                [86.714448000000147, 20.302209000000452],
                [86.714165, 20.302220000000311],
                [86.713607, 20.301667000000176],
                [86.71333300000029, 20.301671000000166],
                [86.713058000000245, 20.301391000000248],
                [86.712775000000107, 20.301391000000248],
                [86.711936000000193, 20.300559000000696],
                [86.711677000000208, 20.300559000000696],
                [86.710564, 20.299449000000319],
                [86.709999000000124, 20.298888],
                [86.709717, 20.298891000000193],
                [86.708335000000304, 20.297500000000579],
                [86.708534, 20.293890000000655],
                [86.708192, 20.293751000000324],
                [86.70684, 20.293291000000288],
                [86.694038000000248, 20.292949000000245],
                [86.690437, 20.294831000000325],
                [86.688058000000325, 20.297309000000379],
                [86.679192000000214, 20.313712],
                [86.673255000000125, 20.315409999999865],
                [86.668731000000136, 20.319050000000342],
                [86.661018000000169, 20.323571000000126],
                [86.654395000000179, 20.327031000000201],
                [86.648178000000229, 20.328510000000385],
                [86.631836, 20.328640000000458],
                [86.626792000000179, 20.329340000000339],
                [86.621430000000245, 20.330281000000749],
                [86.611556, 20.334169000000195],
                [86.607367000000224, 20.336590000000108],
                [86.592742000000186, 20.337301000000359],
                [86.579628000000113, 20.3308190000003],
                [86.577659000000253, 20.332430000000208],
                [86.574623000000244, 20.331409],
                [86.556832, 20.320121000000306],
                [86.546416000000349, 20.319870000000318],
                [86.542701000000108, 20.322211000000376],
                [86.532386, 20.332389000000372],
                [86.524193000000281, 20.336111000000294],
                [86.514267, 20.333989000000368],
                [86.506568, 20.328189000000119],
                [86.50216, 20.326220000000429],
                [86.497002000000279, 20.325360000000153],
                [86.492348000000305, 20.325652000000499],
                [86.472611, 20.332879],
                [86.469306000000159, 20.333431000000243],
                [86.463677000000217, 20.331368000000445],
                [86.46138, 20.328310000000151],
                [86.456046000000114, 20.326190000000107],
                [86.451882000000225, 20.326179000000248],
                [86.44609100000018, 20.3281],
                [86.440453000000147, 20.332282000000188],
                [86.43365350504601, 20.332117249835957],
                [86.433411899415589, 20.333325277987562],
                [86.434014950012951, 20.335134429779711],
                [86.434618000610129, 20.337848157467587],
                [86.434768763259612, 20.339808071908802],
                [86.43272398296412, 20.337768690362164],
                [86.430999697026479, 20.335586717727775],
                [86.428889019935554, 20.335586717727775],
                [86.426476817546629, 20.335586717727775],
                [86.42391385250788, 20.335888243026197],
                [86.420747836871868, 20.337395869520034],
                [86.418472268270619, 20.341805359720919],
                [86.411606, 20.34711000000015],
                [86.411207953219261, 20.349245346683059],
                [86.410815017036313, 20.351353277244751],
                [86.410218106352346, 20.354555441687122],
                [86.410133000000187, 20.355012000000436],
                [86.405653297678597, 20.353401076029339],
                [86.403542620587857, 20.354004126626702],
                [86.402336519393472, 20.356416329015978],
                [86.399924317004022, 20.358979294054787],
                [86.397210589315918, 20.360637683197066],
                [86.393441523082942, 20.359280819353042],
                [86.393139997784175, 20.357170142262472],
                [86.393290760433487, 20.352798025431976],
                [86.392084659238705, 20.349782772445277],
                [86.386807966512237, 20.348576671250378],
                [86.382586612331153, 20.350235060393342],
                [86.380626697889952, 20.352194974834784],
                [86.378063732851359, 20.351290398938257],
                [86.374445429267482, 20.352948788081271],
                [86.371430176280612, 20.354154889275829],
                [86.370525600384653, 20.353702601327761],
                [86.3691687365408, 20.350988873639832],
                [86.36720882209957, 20.350988873639832],
                [86.36298746791833, 20.352194974834784],
                [86.361781366723605, 20.350385823042469],
                [86.361027553477115, 20.346918282108273],
                [86.358163063139756, 20.34556141826425],
                [86.35484628485446, 20.345109130316182],
                [86.352735607763947, 20.34556141826425],
                [86.352283319815882, 20.347370570055826],
                [86.350172642725312, 20.350385823042469],
                [86.349429531236552, 20.35177915708385],
                [86.347760440336046, 20.35490870252249],
                [86.344164048273669, 20.358122710840629],
                [86.3429103632091, 20.360250865019559],
                [86.341841542899857, 20.362065207768516],
                [86.339921317746402, 20.365324826391141],
                [86.339363372707098, 20.365582339486075],
                [86.335850191038986, 20.364859037378491],
                [86.333380684331118, 20.364396004870851],
                [86.331025786260426, 20.363954461482134],
                [86.328915109169685, 20.362899122937044],
                [86.328613583871103, 20.361391496443556],
                [86.329192951949238, 20.358903747009887],
                [86.328035841849072, 20.358051139567632],
                [86.327859770624443, 20.355964041067917],
                [86.328161295923209, 20.354004126626702],
                [86.326502906780576, 20.350687348341634],
                [86.320472400807404, 20.348124383302828],
                [86.317457147820932, 20.348275145952123],
                [86.315798758678099, 20.350988873639832],
                [86.315462639440952, 20.351847845023823],
                [86.314441894834061, 20.354456414574425],
                [86.313537318938103, 20.354305651924953],
                [86.311275879198135, 20.355210227820912],
                [86.310220540653049, 20.353250313380212],
                [86.309314366113341, 20.350733161881063],
                [86.308863676808954, 20.349481247146677],
                [86.305177000000342, 20.350700000000185],
                [86.30351556435707, 20.35211881780884],
                [86.30207590796492, 20.352857103138259],
                [86.300687063273401, 20.353569331185437],
                [86.296764640464787, 20.355580830061733],
                [86.295503602334151, 20.356227516282384],
                [86.294413108339853, 20.356786743971607],
                [86.294160610222704, 20.356717044173813],
                [86.291676734785455, 20.357622430210196],
                [86.288359956500173, 20.357622430210196],
                [86.286098516760347, 20.356265566366343],
                [86.283895573493595, 20.355286480470447],
                [86.283384789072315, 20.355059465172129],
                [86.282075097787441, 20.353380948909258],
                [86.279446987123237, 20.352655482977863],
                [86.276921107473115, 20.353129576243813],
                [86.274791318060679, 20.354757939873362],
                [86.275243606008559, 20.356717854314407],
                [86.276600469852482, 20.359130056703915],
                [86.278778554204436, 20.361273765758764],
                [86.279972077493696, 20.366506906334219],
                [86.280502635340085, 20.368833198430419],
                [86.276802035814612, 20.367032756469591],
                [86.276751232501937, 20.367874290364622],
                [86.275545131307169, 20.369080391559347],
                [86.273132928917889, 20.368025053014428],
                [86.270877905897095, 20.364281645014497],
                [86.264499174975498, 20.361931586254109],
                [86.264366430301422, 20.361882680322019],
                [86.263594984652201, 20.361598463503011],
                [86.26202666044604, 20.361124254917055],
                [86.260996395863785, 20.360812737497152],
                [86.253597640657446, 20.358575602324432],
                [86.249825353701368, 20.357434989397625],
                [86.250461940141278, 20.360207652284142],
                [86.247785046509733, 20.365858872172961],
                [86.25150122283496, 20.368730462969602],
                [86.254328564275937, 20.370915226810546],
                [86.258006195101046, 20.370556962944132],
                [86.25818318641619, 20.36811247633403],
                [86.260896914103881, 20.368414001632964],
                [86.261325066279127, 20.370233648376878],
                [86.261499964701244, 20.370976966671602],
                [86.261650727350727, 20.374595270255266],
                [86.263459879142474, 20.377007472644376],
                [86.266324369479875, 20.378515099137751],
                [86.27129953690779, 20.378515099137751],
                [86.272204112803919, 20.380022725631413],
                [86.2705457236613, 20.381228826825968],
                [86.273108688699693, 20.382585690669824],
                [86.273661684948109, 20.383407397091155],
                [86.273862501946354, 20.385600943656865],
                [86.271751824855684, 20.386203994254057],
                [86.268887334518453, 20.385450181007052],
                [86.267379708025302, 20.387862383396335],
                [86.267444388506746, 20.390540296546927],
                [86.267463111506956, 20.39131546963176],
                [86.267745820088621, 20.395895348655525],
                [86.27099801160918, 20.395551278512126],
                [86.274314789894262, 20.395400515862999],
                [86.274616315193015, 20.398265006200571],
                [86.2737117392969, 20.401581784484957],
                [86.275370128439519, 20.405501613368298],
                [86.27748080553026, 20.409421442250558],
                [86.277028517582366, 20.411532119341128],
                [86.273410213998289, 20.411532119341128],
                [86.270394961011817, 20.41273822053585],
                [86.268849118457737, 20.413768782238318],
                [86.268902762936463, 20.414637822792479],
                [86.271355703597735, 20.418930468949775],
                [86.269188859817049, 20.421783979495498],
                [86.268440733591362, 20.422947731402981],
                [86.267831995973182, 20.423894656586576],
                [86.269038097167908, 20.427211434870966],
                [86.273108688699693, 20.429472874611289],
                [86.273560976647758, 20.431131263754306],
                [86.26798275862248, 20.431583551701859],
                [86.264665980337242, 20.433241940844475],
                [86.264967505636008, 20.435352617934988],
                [86.268435046570545, 20.435051092636566],
                [86.269339622466504, 20.437011007078009],
                [86.271148774258322, 20.437011007078009],
                [86.271751824855684, 20.439724734765715],
                [86.268736571869141, 20.44228769980429],
                [86.26798275862248, 20.445453715440291],
                [86.265872081531981, 20.449072019024296],
                [86.262404540597203, 20.450730408166741],
                [86.260896914103881, 20.452539559958719],
                [86.259992338208278, 20.457363964737507],
                [86.261349202052131, 20.459323879178893],
                [86.263158353843878, 20.46022845507451],
                [86.263007591194565, 20.461886844216789],
                [86.266324369479875, 20.463243708061324],
                [86.268435046570545, 20.464600571905006],
                [86.268667285443854, 20.465013441013351],
                [86.269791910414412, 20.467012774294513],
                [86.269641147765341, 20.470329552579582],
                [86.265831790767805, 20.470284674022704],
                [86.263737865082334, 20.471046101544115],
                [86.262405366919367, 20.473711097870869],
                [86.263357151321742, 20.476376094197231],
                [86.266402861408935, 20.47713752171898],
                [86.268116073333417, 20.476566451077694],
                [86.269616215594482, 20.475034317153806],
                [86.270244198362519, 20.47636005855275],
                [86.268435046570545, 20.480279887435241],
                [86.26722894537582, 20.484350478967311],
                [86.2675304706746, 20.487365731954011],
                [86.26722894537582, 20.490833272888544],
                [86.270394961011817, 20.495205389719096],
                [86.2705457236613, 20.497466829458737],
                [86.270740789847068, 20.499271191679096],
                [86.271154902388318, 20.500118133958775],
                [86.272807163401282, 20.503497335432254],
                [86.271902587505153, 20.506060300470889],
                [86.265872081531981, 20.507115639015975],
                [86.25863547436407, 20.510583179950849],
                [86.254866408130894, 20.513296907638612],
                [86.251851155144251, 20.512693857041025],
                [86.249288190105617, 20.511789281144893],
                [86.246272937119144, 20.515709110027554],
                [86.244765310625809, 20.520684277455242],
                [86.246272937119144, 20.52475486898771],
                [86.251097341897747, 20.52686554607828],
                [86.253660306936339, 20.530936137609835],
                [86.256374034624031, 20.531237662908776],
                [86.259238524961432, 20.534252915895472],
                [86.262355598356038, 20.538067296761536],
                [86.26859035945634, 20.546974098333575],
                [86.26722894537582, 20.547972316984268],
                [86.265118268285491, 20.547369266387072],
                [86.263459879142474, 20.548273842282693],
                [86.260746151454768, 20.549178418179164],
                [86.257278610520061, 20.549178418179164],
                [86.255620221377555, 20.549630706126713],
                [86.257429373169529, 20.551741383217571],
                [86.260746151454768, 20.552645959113359],
                [86.264515217688128, 20.551439857918805],
                [86.270093435713008, 20.552796721763226],
                [86.273108688699878, 20.555058161502867],
                [86.274767077842483, 20.560485616878449],
                [86.277782330829027, 20.569380613189534],
                [86.280890480406725, 20.572603236277242],
                [86.283360548854304, 20.574205017967639],
                [86.288637241580759, 20.5749588312143],
                [86.292104782515352, 20.575109593863427],
                [86.295120035501824, 20.572094340877069],
                [86.296929187293742, 20.570737477033216],
                [86.304467319760064, 20.57194357822743],
                [86.311694644884753, 20.574544205986964],
                [86.311433000000335, 20.575612000000373],
                [86.31459, 20.576910999999821],
                [86.317659159974752, 20.579710987692405],
                [86.317680000000138, 20.579730000000549],
                [86.317559, 20.583940000000208],
                [86.314781000000238, 20.587119000000136],
                [86.313881, 20.590490000000383],
                [86.315886, 20.604580000000336],
                [86.315162000000129, 20.609170000000173],
                [86.313208000000117, 20.612199000000651],
                [86.316226828144565, 20.619294822131103],
                [86.317901000000262, 20.623230000000145],
                [86.32106, 20.624540000000358],
                [86.321491745937678, 20.623534123826342],
                [86.321876735849429, 20.622637179244801],
                [86.323127296272659, 20.619723639535092],
                [86.324912764386823, 20.611360238736491],
                [86.327023441477522, 20.607289647204531],
                [86.330641745061399, 20.604877444815425],
                [86.335315387190505, 20.604726682165957],
                [86.339838266670526, 20.60532973276332],
                [86.34315504495558, 20.60532973276332],
                [86.34617029794228, 20.602314479776847],
                [86.352502329214062, 20.599600752088744],
                [86.358834360486, 20.594173296712992],
                [86.3629049520179, 20.591007281076994],
                [86.36712630619914, 20.589951942531737],
                [86.37164918567899, 20.588745841337179],
                [86.373759862769518, 20.58859507868771],
                [86.375569014561592, 20.589801179882439],
                [86.378086606554277, 20.592117364515666],
                [86.381750283184076, 20.593419483466274],
                [86.382659148499016, 20.597155929761577],
                [86.386130078011178, 20.596858414843833],
                [86.387595825079956, 20.598037037746046],
                [86.388871251121174, 20.599062621473301],
                [86.389686237738758, 20.599717960933159],
                [86.391007000000101, 20.600780000000153],
                [86.39286, 20.605111000000417],
                [86.38992400000015, 20.607440000000217],
                [86.39685700000021, 20.615921000000235],
                [86.400962, 20.61951],
                [86.405411000000271, 20.621021000000322],
                [86.411056000000173, 20.621520000000597],
                [86.4179230000003, 20.619050000000353],
                [86.421196000000222, 20.619490000000663],
                [86.419051000000181, 20.621901000000488],
                [86.417328000000253, 20.623850000000456],
                [86.417107000000243, 20.628522],
                [86.418603000000218, 20.629080000000155],
                [86.419892000000317, 20.629561000000304],
                [86.424888000000166, 20.636649],
                [86.432503000000153, 20.63912],
                [86.447486000000296, 20.641992000000183],
                [86.451531000000315, 20.643569],
                [86.455598137888472, 20.645739074215722],
                [86.457120168039452, 20.646551173160212],
                [86.456562095694139, 20.650262104765254],
                [86.453516385606775, 20.653498171733244],
                [86.454658526889517, 20.657686023103505],
                [86.453706742487071, 20.662064231354176],
                [86.453326028726323, 20.664348513919773],
                [86.453897099367595, 20.667394224007293],
                [86.456562095694139, 20.670249577214289],
                [86.461742329500836, 20.670375924380263],
                [86.462159, 20.673480000000318],
                [86.463160065701089, 20.675745429452146],
                [86.465539, 20.681129000000279],
                [86.4694360000003, 20.681040000000163],
                [86.471253, 20.679540000000422],
                [86.47268600000011, 20.678360000000104],
                [86.47908800000026, 20.674590000000304],
                [86.482086000000137, 20.672822000000217],
                [86.485466, 20.673152000000524],
                [86.490616000000202, 20.674401000000493],
                [86.496437, 20.678989000000453],
                [86.501868000000201, 20.67990100000025],
                [86.509171000000308, 20.680010000000603],
                [86.511329000000146, 20.682319000000515],
                [86.512542000000323, 20.685699000000394],
                [86.51243700000019, 20.690891000000242],
                [86.514358000000115, 20.693090000000492],
                [86.517777000000237, 20.690870000000469],
                [86.521423, 20.686740000000377],
                [86.525948000000241, 20.683059000000238],
                [86.527709000000286, 20.688320000000537],
                [86.530296, 20.688780000000232],
                [86.536060172898019, 20.68751714332603],
                [86.540818809910633, 20.688057463381934],
                [86.543674163117629, 20.693197099154414],
                [86.547290943846448, 20.696813879883329],
                [86.552049865858095, 20.697575307405252],
                [86.556618430989246, 20.697765664285548],
                [86.552620936499494, 20.702334229416916],
                [86.549384869531522, 20.705570296384732],
                [86.547029745923027, 20.708486472014439],
                [86.545787761049183, 20.710565151267694],
                [86.544183000000132, 20.713251000000465],
                [86.548052371368371, 20.718133850495569],
                [86.552620936499494, 20.719275991778257],
                [86.554334148423706, 20.72041813306117],
                [86.554334148423706, 20.722117234563878],
                [86.554334148423706, 20.724796341311837],
                [86.554143791543183, 20.728222765160346],
                [86.552430579619042, 20.728793835801575],
                [86.546529516324682, 20.724225270670441],
                [86.542722378715254, 20.72289277250723],
                [86.539486311747424, 20.724415627550904],
                [86.53853452734505, 20.725748125714286],
                [86.537788000000191, 20.727591000000128],
                [86.537392386062294, 20.731649189008632],
                [86.537773099823127, 20.738121322944433],
                [86.539867025508201, 20.74135738991242],
                [86.542341664954265, 20.743451315597547],
                [86.54344861966176, 20.745309035121348],
                [86.549004155770746, 20.745735598163144],
                [86.550336653933954, 20.749542735772586],
                [86.552290229518093, 20.751702752909974],
                [86.554521880558951, 20.754170230765617],
                [86.556525078517524, 20.755616984846593],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Kendujhar",
          Dist_Code: "375",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [85.277749, 21.95128],
              [85.273407000000162, 21.953181],
              [85.268646, 21.955829000000161],
              [85.266404000000179, 21.957942],
              [85.259361, 21.96851],
              [85.256387, 21.97153],
              [85.246536000000134, 21.97901],
              [85.239312, 21.986121000000132],
              [85.230371, 21.992929000000114],
              [85.227310000000131, 21.996940000000162],
              [85.230943000000181, 22.000270000000164],
              [85.241057000000168, 22.012520000000162],
              [85.24653, 22.025409],
              [85.256095, 22.042459],
              [85.259988000000106, 22.052852000000197],
              [85.265458, 22.060252000000155],
              [85.269950000000151, 22.068961],
              [85.274162000000146, 22.080090000000208],
              [85.280899000000119, 22.087641],
              [85.287422, 22.093179000000127],
              [85.30008, 22.107059000000159],
              [85.309700000000163, 22.113390000000148],
              [85.315369, 22.11584],
              [85.323013000000145, 22.124991],
              [85.338502, 22.12472],
              [85.345367000000167, 22.126992],
              [85.353569, 22.120572000000202],
              [85.358132000000154, 22.119601000000156],
              [85.361382, 22.12144],
              [85.361717, 22.124759],
              [85.358659, 22.132802000000137],
              [85.358071, 22.13795],
              [85.362923, 22.146579000000141],
              [85.362426000000184, 22.150050000000132],
              [85.363196000000102, 22.154570000000145],
              [85.369377, 22.155210000000174],
              [85.372176, 22.152441],
              [85.379319000000109, 22.1516890000002],
              [85.385368000000184, 22.152341000000145],
              [85.390350000000112, 22.155130000000153],
              [85.394439, 22.158599],
              [85.402366, 22.156530000000139],
              [85.410286, 22.156081000000135],
              [85.417816000000158, 22.15335900000013],
              [85.435785000000109, 22.144170000000141],
              [85.457008, 22.135771],
              [85.465179, 22.131202],
              [85.471733000000128, 22.12413900000012],
              [85.479400000000155, 22.12177100000013],
              [85.485802000000135, 22.116490000000166],
              [85.50567600000015, 22.111460000000129],
              [85.514848000000171, 22.108210000000209],
              [85.524169000000128, 22.103050000000103],
              [85.528739, 22.09876],
              [85.533500000000146, 22.0968],
              [85.53604800000015, 22.094410000000206],
              [85.537345000000158, 22.09030000000012],
              [85.539542, 22.086590000000108],
              [85.548622000000108, 22.088550000000108],
              [85.554336, 22.090820000000175],
              [85.560225, 22.084910000000203],
              [85.566231000000116, 22.087039000000168],
              [85.571106, 22.086059],
              [85.582237000000163, 22.08099],
              [85.586768000000106, 22.076819000000107],
              [85.591087, 22.07444],
              [85.596648, 22.07472000000018],
              [85.601760000000112, 22.076341000000181],
              [85.603600000000128, 22.07924],
              [85.607324, 22.081790000000176],
              [85.608598000000129, 22.078950000000184],
              [85.611107, 22.076799],
              [85.619583, 22.077840000000204],
              [85.626236, 22.079629],
              [85.631248000000127, 22.081542],
              [85.636392, 22.085769],
              [85.640052, 22.090232],
              [85.644608000000105, 22.090280000000117],
              [85.648056, 22.086811000000122],
              [85.650338, 22.081300000000105],
              [85.655327, 22.077811000000107],
              [85.657508, 22.074280000000154],
              [85.664726, 22.066570000000123],
              [85.667573, 22.061029000000129],
              [85.672363000000118, 22.059721],
              [85.671951000000121, 22.051471000000159],
              [85.668801, 22.043159],
              [85.670182, 22.038842],
              [85.659493000000154, 22.031601000000133],
              [85.658021, 22.0285790000002],
              [85.660881, 22.018430000000134],
              [85.665863000000144, 22.00909],
              [85.671067000000136, 22.009551],
              [85.675003, 22.005731000000136],
              [85.681473000000125, 22.004151000000146],
              [85.687180000000168, 22.005412000000202],
              [85.692643000000132, 22.005131],
              [85.697906, 22.003251],
              [85.698838, 21.99702],
              [85.698640000000154, 21.994540000000196],
              [85.69574, 21.98814],
              [85.697876, 21.985800000000207],
              [85.699531, 21.981611000000154],
              [85.709550000000135, 21.980640000000101],
              [85.724822, 21.984831000000149],
              [85.727432000000164, 21.98608],
              [85.730087000000111, 21.988601000000124],
              [85.733834000000144, 21.989111],
              [85.74051, 21.98445],
              [85.742050000000162, 21.973821],
              [85.749359, 21.97305],
              [85.75296, 21.970092],
              [85.756591000000157, 21.968572000000101],
              [85.761498, 21.968800000000151],
              [85.763153, 21.962922000000159],
              [85.76764700000011, 21.96129900000016],
              [85.770546000000181, 21.959300000000152],
              [85.771927, 21.955970000000146],
              [85.772164, 21.953199000000151],
              [85.776939000000127, 21.9544110000001],
              [85.781739, 21.957429],
              [85.783020000000178, 21.952631],
              [85.788880000000105, 21.94987100000014],
              [85.789962000000102, 21.947230000000101],
              [85.789627, 21.93211000000019],
              [85.790398000000138, 21.92339],
              [85.788802, 21.918741000000175],
              [85.788207, 21.91230900000016],
              [85.785495192957271, 21.906132012547058],
              [85.784989000000209, 21.904979000000306],
              [85.784791000000183, 21.90179100000034],
              [85.790466939255836, 21.894627835401586],
              [85.799583787889929, 21.888064010044783],
              [85.803152979398675, 21.882412790155904],
              [85.802558114147232, 21.877059002892789],
              [85.801070951018545, 21.870515485126756],
              [85.804045277275847, 21.865161697863638],
              [85.81035512626282, 21.849495439201402],
              [85.807083000000247, 21.843579000000258],
              [85.807029187542113, 21.842478711666043],
              [85.806839000000281, 21.838590000000291],
              [85.806648717317714, 21.837879943896944],
              [85.805616019496924, 21.834026343665123],
              [85.805334391149785, 21.832975423403745],
              [85.805237, 21.832612000000207],
              [85.802238, 21.82644],
              [85.805672000000158, 21.81746],
              [85.805221000000174, 21.807601],
              [85.816979000000146, 21.802961000000202],
              [85.824227000000164, 21.801541],
              [85.830018, 21.804339000000191],
              [85.833619, 21.805139000000107],
              [85.850929, 21.797149000000154],
              [85.855629, 21.79665900000014],
              [85.857507, 21.795150000000145],
              [85.858268000000109, 21.792401],
              [85.864114000000129, 21.791401000000118],
              [85.867072, 21.79329],
              [85.877404000000155, 21.789559000000104],
              [85.881768000000108, 21.783371],
              [85.88310100000011, 21.780071],
              [85.890456, 21.776862000000104],
              [85.897658, 21.76866],
              [85.900680000000108, 21.762861000000207],
              [85.907921, 21.766109000000139],
              [85.913933000000142, 21.758622000000109],
              [85.919488, 21.760040000000171],
              [85.925537000000119, 21.758319],
              [85.935280000000134, 21.75766],
              [85.938432, 21.753451000000151],
              [85.945351000000102, 21.749522000000177],
              [85.949388, 21.743471],
              [85.953376000000148, 21.742830000000133],
              [85.96266800000015, 21.736471000000158],
              [85.96621, 21.734969],
              [85.970237, 21.737239],
              [85.972785, 21.735580000000134],
              [85.974479, 21.735651000000182],
              [85.977052000000114, 21.738030000000204],
              [85.985168, 21.73878],
              [85.990228000000144, 21.740111],
              [85.990357000000159, 21.73615],
              [85.994294000000124, 21.73945],
              [86.000167, 21.740569000000104],
              [86.00271500000018, 21.738491000000117],
              [86.006058, 21.739010000000114],
              [86.00875, 21.741091000000146],
              [86.01252, 21.74026200000014],
              [86.014022000000168, 21.73759],
              [86.014421000000127, 21.731471000000166],
              [86.015923, 21.724492],
              [86.018646, 21.720319],
              [86.022117, 21.718491000000192],
              [86.022393000000179, 21.706079000000152],
              [86.019783, 21.694259],
              [86.022628, 21.687299],
              [86.02823, 21.683871000000121],
              [86.032761, 21.686091],
              [86.034912000000176, 21.691650000000148],
              [86.03473, 21.695611000000152],
              [86.037217000000155, 21.699431],
              [86.040916000000138, 21.700411000000141],
              [86.045745000000167, 21.709391],
              [86.04827, 21.70429],
              [86.052482000000154, 21.689229],
              [86.055459, 21.683491000000114],
              [86.06099000000016, 21.68094],
              [86.065102, 21.68156],
              [86.066932000000108, 21.683101000000132],
              [86.068131, 21.686269],
              [86.072441000000111, 21.68755],
              [86.076600000000141, 21.6848010000001],
              [86.078202, 21.68027],
              [86.075996, 21.67313],
              [86.068498, 21.661021],
              [86.07073100000018, 21.64034],
              [86.075287, 21.630542],
              [86.074998, 21.624071],
              [86.065001, 21.60977],
              [86.062027000000143, 21.600111],
              [86.056473000000139, 21.592002000000203],
              [86.049216000000101, 21.584040000000122],
              [86.04657, 21.575439],
              [86.042641, 21.568561],
              [86.037109, 21.567631],
              [86.032157000000126, 21.564529000000103],
              [86.025543000000184, 21.561871000000103],
              [86.021392, 21.557792000000113],
              [86.013413, 21.553619000000133],
              [86.015588, 21.543960000000137],
              [86.004593000000156, 21.527272000000149],
              [86.029091000000136, 21.51387],
              [86.048599, 21.506099000000116],
              [86.055313, 21.501761],
              [86.071702, 21.496431],
              [86.086403000000175, 21.489019000000209],
              [86.094986000000148, 21.485500000000169],
              [86.115936, 21.472101000000176],
              [86.124177, 21.465901000000198],
              [86.129608, 21.460710000000173],
              [86.132927, 21.45632],
              [86.133583000000144, 21.44886],
              [86.13668, 21.445052000000143],
              [86.14122, 21.441829],
              [86.148033, 21.43369],
              [86.154321, 21.424079000000173],
              [86.156326, 21.41938],
              [86.158218, 21.414851000000109],
              [86.152543, 21.406680000000101],
              [86.145637, 21.402111],
              [86.136758, 21.398001000000185],
              [86.126267, 21.382708000000147],
              [86.124314, 21.37756000000018],
              [86.116241, 21.363881],
              [86.118263000000155, 21.35978],
              [86.11782, 21.35504],
              [86.104043, 21.344440000000187],
              [86.10420300000014, 21.341700000000113],
              [86.105636, 21.338801],
              [86.103669, 21.328451],
              [86.099441000000155, 21.320721],
              [86.093719000000121, 21.315570000000147],
              [86.088622, 21.306011],
              [86.091369, 21.300559000000131],
              [86.096688, 21.298711000000193],
              [86.103234, 21.298191000000138],
              [86.104232, 21.286841000000202],
              [86.107621000000137, 21.281219],
              [86.111671000000101, 21.276371],
              [86.112052000000148, 21.270482],
              [86.115181, 21.266429],
              [86.124893, 21.260909],
              [86.129952, 21.260041],
              [86.133079000000151, 21.260410000000142],
              [86.13408, 21.263861],
              [86.133209000000122, 21.27557100000012],
              [86.138688, 21.27377000000018],
              [86.142326000000182, 21.273980000000101],
              [86.143502000000154, 21.277731000000124],
              [86.14576, 21.281200000000119],
              [86.154487000000117, 21.286771],
              [86.157334, 21.285289],
              [86.156860000000137, 21.278762000000196],
              [86.160149000000146, 21.275461000000117],
              [86.167428, 21.272519],
              [86.184898000000132, 21.26776],
              [86.190529, 21.26887],
              [86.194137000000168, 21.27282],
              [86.199311000000179, 21.276492000000129],
              [86.205093, 21.277349000000179],
              [86.205002000000135, 21.280161000000128],
              [86.206062, 21.28425],
              [86.20983100000015, 21.287860000000133],
              [86.214362, 21.301031000000133],
              [86.215279000000109, 21.306980000000117],
              [86.219406000000149, 21.311511],
              [86.221077, 21.316971],
              [86.224876000000137, 21.322940000000123],
              [86.230202000000105, 21.321951000000176],
              [86.246726, 21.33974000000017],
              [86.24595600000012, 21.343981000000205],
              [86.249871, 21.34601],
              [86.266053, 21.361280000000129],
              [86.266876000000167, 21.365490000000133],
              [86.264656000000144, 21.373799000000187],
              [86.2732, 21.374531],
              [86.28074, 21.36983100000014],
              [86.288537, 21.355922],
              [86.294273, 21.349572],
              [86.314293000000177, 21.3409000000002],
              [86.32444, 21.334539],
              [86.343247, 21.31956],
              [86.353271, 21.314191000000104],
              [86.35565300000016, 21.309140000000124],
              [86.356460000000183, 21.294679000000198],
              [86.352494000000135, 21.28136],
              [86.352173, 21.276109],
              [86.354126000000164, 21.270821],
              [86.359657000000169, 21.262890000000191],
              [86.36033, 21.25899],
              [86.368049000000141, 21.25499],
              [86.370018000000158, 21.24988],
              [86.370018000000158, 21.243570000000201],
              [86.365989, 21.232931000000118],
              [86.349098000000126, 21.230289000000191],
              [86.347892, 21.228999],
              [86.349556, 21.222661000000183],
              [86.350434, 21.215151000000155],
              [86.349602, 21.21158],
              [86.350693000000135, 21.207981],
              [86.350639000000101, 21.204362000000113],
              [86.347632, 21.199851],
              [86.345383, 21.186122000000122],
              [86.339156000000145, 21.184540000000133],
              [86.337951000000132, 21.18355100000019],
              [86.339523000000142, 21.181290000000157],
              [86.335038000000154, 21.17389200000019],
              [86.328399, 21.174231000000184],
              [86.325509, 21.173509000000131],
              [86.323196000000152, 21.1712],
              [86.320816, 21.17031100000019],
              [86.321138, 21.174279],
              [86.317391, 21.175052],
              [86.31527800000012, 21.169311],
              [86.311577000000142, 21.167941000000209],
              [86.309142000000165, 21.16488],
              [86.30562600000016, 21.16403],
              [86.302269, 21.164290000000104],
              [86.301238, 21.168071000000104],
              [86.294082, 21.170211000000105],
              [86.287696, 21.169969000000144],
              [86.287666, 21.165650000000191],
              [86.282050000000126, 21.16315],
              [86.280419, 21.160390000000174],
              [86.280412000000112, 21.155770000000185],
              [86.270523000000111, 21.144780000000193],
              [86.269066000000151, 21.141040000000196],
              [86.268448, 21.136890000000161],
              [86.270217, 21.132361],
              [86.277718000000149, 21.131571],
              [86.281998, 21.127942000000182],
              [86.285859000000173, 21.122381000000129],
              [86.287773, 21.115819],
              [86.28479, 21.1137],
              [86.28492, 21.112401],
              [86.285850000000138, 21.111940000000111],
              [86.289268000000135, 21.11303],
              [86.300133000000116, 21.108540000000168],
              [86.305382000000108, 21.105502000000168],
              [86.301986, 21.100700000000185],
              [86.300370000000129, 21.096652000000116],
              [86.301232, 21.092171],
              [86.304062, 21.090049000000189],
              [86.302262, 21.086710000000149],
              [86.301697, 21.081689000000207],
              [86.311515, 21.075139000000199],
              [86.313569000000115, 21.07237],
              [86.315301000000119, 21.06767],
              [86.316529000000102, 21.06051200000018],
              [86.319909000000138, 21.060252000000158],
              [86.321197000000126, 21.053551000000137],
              [86.316299, 21.046980000000186],
              [86.310127000000108, 21.050641],
              [86.307830000000109, 21.035061],
              [86.299896, 21.017272000000101],
              [86.301482000000178, 21.014890000000147],
              [86.301521, 21.010931000000138],
              [86.299073000000121, 21.009559000000134],
              [86.290305000000146, 21.012921000000173],
              [86.28463, 21.012470000000114],
              [86.275543000000113, 21.017541000000161],
              [86.273561000000115, 21.020201000000153],
              [86.261224, 21.030559],
              [86.256576, 21.033189],
              [86.242432, 21.031870000000193],
              [86.230690000000124, 21.033310000000135],
              [86.221603, 21.039279000000185],
              [86.218551000000147, 21.042921],
              [86.21304300000017, 21.046641000000186],
              [86.208421, 21.048521000000161],
              [86.203179000000119, 21.050260000000147],
              [86.192369, 21.04969],
              [86.18689, 21.050550000000154],
              [86.172859000000173, 21.055411],
              [86.157058, 21.057681],
              [86.143379, 21.065100000000196],
              [86.136115000000174, 21.06793],
              [86.129433000000105, 21.06827],
              [86.126846000000157, 21.061891],
              [86.123862000000116, 21.059231],
              [86.118019, 21.060899],
              [86.115013, 21.060699],
              [86.111489000000105, 21.058501],
              [86.104683, 21.052010000000159],
              [86.090279, 21.044849000000109],
              [86.088212, 21.0387],
              [86.085837, 21.025092000000139],
              [86.08429, 21.020991000000148],
              [86.086418000000123, 21.017750000000202],
              [86.084091000000157, 21.012251000000159],
              [86.079643, 21.010510000000121],
              [86.07673, 21.008142000000131],
              [86.065505, 21.010920000000162],
              [86.054351, 21.015920000000101],
              [86.047416, 21.01525],
              [86.042716, 21.018101000000108],
              [86.039047, 21.02312],
              [86.03788, 21.027501000000196],
              [86.032647, 21.033201000000187],
              [86.032127000000145, 21.03685900000016],
              [86.030053000000152, 21.04092],
              [86.029953, 21.047382],
              [86.032417000000166, 21.053180000000161],
              [86.027993, 21.056680000000195],
              [86.028077, 21.05942],
              [86.026031, 21.0630710000002],
              [86.023346000000146, 21.064559000000198],
              [86.023079, 21.067231000000103],
              [86.027038000000104, 21.074159000000115],
              [86.029686000000183, 21.084340000000164],
              [86.031854, 21.087330000000115],
              [86.042846, 21.092941],
              [86.046212, 21.102951000000129],
              [86.050431000000103, 21.110821],
              [86.055894, 21.114320000000188],
              [86.060373, 21.11584],
              [86.067971, 21.122160000000175],
              [86.072083000000177, 21.133510000000111],
              [86.071167, 21.14236000000016],
              [86.071410484463897, 21.145293288532056],
              [86.071598836142172, 21.147562385334417],
              [86.071675186874273, 21.148482192387345],
              [86.071846, 21.150540000000142],
              [86.073477095290372, 21.1532028504983],
              [86.066910104237749, 21.154771336428094],
              [86.058949856221417, 21.154022942051366],
              [86.0580590000001, 21.153231],
              [86.054802, 21.15325],
              [86.050492000000176, 21.154711000000127],
              [86.040437, 21.14865],
              [86.03321, 21.150882],
              [86.029442, 21.143092000000134],
              [86.024727, 21.141291000000134],
              [86.024307, 21.139529000000206],
              [86.026062000000181, 21.138269],
              [86.027191000000116, 21.135780000000178],
              [86.018211000000164, 21.13158900000013],
              [86.016374, 21.13232],
              [86.016137000000171, 21.135231000000196],
              [86.009637, 21.13509],
              [86.003953000000124, 21.136890000000161],
              [85.999672000000132, 21.135140000000142],
              [85.994309000000143, 21.135550000000134],
              [85.989617, 21.135839],
              [85.988694, 21.131322],
              [85.983696, 21.13330900000016],
              [85.981307000000101, 21.132400000000125],
              [85.978408, 21.133551000000121],
              [85.973250000000107, 21.138381],
              [85.970107000000127, 21.134068],
              [85.967133, 21.131951],
              [85.963028000000108, 21.13124],
              [85.961296000000104, 21.1332],
              [85.959664, 21.13346],
              [85.958192000000139, 21.132081000000195],
              [85.960282, 21.127420000000196],
              [85.95874800000017, 21.126791000000189],
              [85.956672000000168, 21.128049000000143],
              [85.954696000000112, 21.123461000000184],
              [85.943236000000113, 21.123461000000184],
              [85.940918000000153, 21.127801],
              [85.9393460000001, 21.126399],
              [85.937402, 21.122281000000211],
              [85.934747000000115, 21.123001],
              [85.935471000000163, 21.128022],
              [85.931549000000174, 21.130451000000157],
              [85.929299000000171, 21.130431],
              [85.927620000000147, 21.129000000000183],
              [85.926248000000143, 21.125761],
              [85.926209000000128, 21.115781000000133],
              [85.917396, 21.096410000000159],
              [85.91645, 21.091832000000117],
              [85.91317, 21.088351],
              [85.904662, 21.08421],
              [85.898558, 21.084370000000145],
              [85.881944000000118, 21.080390000000186],
              [85.876800000000102, 21.08143],
              [85.870650000000154, 21.080001000000149],
              [85.858933, 21.083080000000162],
              [85.85383500000016, 21.085890000000173],
              [85.844162, 21.0895],
              [85.838088000000184, 21.089252000000151],
              [85.833444000000142, 21.09035],
              [85.830307000000147, 21.086731],
              [85.824051000000154, 21.084691],
              [85.817161, 21.08496000000013],
              [85.809884000000167, 21.08886],
              [85.803436000000119, 21.098851000000135],
              [85.792182000000111, 21.097789000000201],
              [85.787528000000165, 21.098441000000143],
              [85.782081000000105, 21.09497],
              [85.778314000000179, 21.094931000000198],
              [85.776107000000181, 21.096009000000205],
              [85.773887, 21.098521],
              [85.769997, 21.098199],
              [85.768853, 21.100549000000164],
              [85.768928, 21.106621000000185],
              [85.764069000000163, 21.110671],
              [85.763383, 21.116211000000188],
              [85.764076, 21.119730000000171],
              [85.763442000000154, 21.122151000000137],
              [85.761268, 21.125419000000189],
              [85.760085, 21.137480000000146],
              [85.75805, 21.140591000000139],
              [85.752151000000126, 21.14336],
              [85.746032000000113, 21.14236000000016],
              [85.742340000000155, 21.13828],
              [85.735603000000168, 21.133011],
              [85.730896, 21.133070000000142],
              [85.722687000000164, 21.137770000000156],
              [85.717376000000144, 21.155100000000171],
              [85.71367700000016, 21.158002000000121],
              [85.708474000000109, 21.159779],
              [85.703681000000174, 21.16249200000021],
              [85.701087000000129, 21.16558],
              [85.700944, 21.17270000000013],
              [85.70462, 21.176032000000131],
              [85.7003330000001, 21.17765],
              [85.688201, 21.174601],
              [85.681525000000164, 21.17984],
              [85.678551000000112, 21.179911000000114],
              [85.677307, 21.177062],
              [85.673950000000147, 21.1728],
              [85.667342000000119, 21.166350000000186],
              [85.659249, 21.1607],
              [85.645317000000134, 21.159112000000103],
              [85.632141, 21.159991],
              [85.624900000000167, 21.155080000000108],
              [85.62326867658247, 21.15278912998178],
              [85.622899018783173, 21.152270018958117],
              [85.611556, 21.136341],
              [85.605172000000124, 21.13163000000014],
              [85.594070000000144, 21.131821000000169],
              [85.58974447446893, 21.134290267706881],
              [85.584015420791246, 21.137560752907966],
              [85.571088932911351, 21.144939962405825],
              [85.550843207580485, 21.155657357069622],
              [85.544656608965212, 21.155181464868626],
              [85.5312065225298, 21.147141287062421],
              [85.528153, 21.14257],
              [85.520068901240776, 21.134070583203989],
              [85.495491000000158, 21.108230000000102],
              [85.49179, 21.107879000000189],
              [85.489847448096654, 21.108734540033819],
              [85.472488, 21.116380000000103],
              [85.468087, 21.117071000000116],
              [85.45723800000016, 21.12177],
              [85.454681, 21.126871],
              [85.435356, 21.144452],
              [85.420617, 21.156541],
              [85.418007000000145, 21.161359],
              [85.412613, 21.16336],
              [85.410507, 21.16622],
              [85.405853000000121, 21.16736],
              [85.398238000000148, 21.170781000000144],
              [85.388862, 21.179480000000119],
              [85.37719700000018, 21.19352],
              [85.376479000000103, 21.204152000000132],
              [85.377243, 21.210581],
              [85.362923, 21.235558],
              [85.359650000000144, 21.237781],
              [85.34349800000011, 21.245391],
              [85.336517000000157, 21.252280000000209],
              [85.314569000000162, 21.255701],
              [85.307152, 21.25876],
              [85.294136, 21.270801000000173],
              [85.284812, 21.264241],
              [85.284249, 21.261351],
              [85.281143, 21.260371000000131],
              [85.274987000000152, 21.2642],
              [85.267883, 21.27003900000016],
              [85.268883000000173, 21.277921],
              [85.272247000000149, 21.280002000000131],
              [85.272553, 21.282901000000148],
              [85.272247000000149, 21.287812],
              [85.267509000000175, 21.294201],
              [85.268569000000113, 21.296591],
              [85.272667, 21.29591],
              [85.276901000000109, 21.29400900000018],
              [85.279137, 21.294850000000107],
              [85.283768000000165, 21.2995],
              [85.287217, 21.300131],
              [85.290610000000171, 21.30203200000016],
              [85.291176000000107, 21.308981000000127],
              [85.302642, 21.31304],
              [85.306733000000165, 21.31634],
              [85.309730000000158, 21.323909000000182],
              [85.313652, 21.32292],
              [85.316857, 21.317541000000169],
              [85.320618, 21.31448000000017],
              [85.32322, 21.31897],
              [85.3274, 21.33303],
              [85.328743000000117, 21.340861000000181],
              [85.330985, 21.345921000000143],
              [85.335297000000125, 21.34998],
              [85.337638000000183, 21.353889000000201],
              [85.335876, 21.360412000000103],
              [85.333679000000174, 21.365052000000155],
              [85.324966000000103, 21.372671000000132],
              [85.324342000000144, 21.377911],
              [85.309700000000163, 21.387301000000203],
              [85.301078000000174, 21.389990000000118],
              [85.302628000000112, 21.399041],
              [85.299187000000174, 21.409099],
              [85.284074000000118, 21.415161000000175],
              [85.277038, 21.419681],
              [85.269118, 21.42227],
              [85.264457, 21.434461000000109],
              [85.256622000000149, 21.437620000000205],
              [85.254753, 21.440660000000204],
              [85.253121000000178, 21.446360000000194],
              [85.257103000000129, 21.449840000000158],
              [85.262338, 21.45021],
              [85.274392000000134, 21.444851000000192],
              [85.280457000000155, 21.447662],
              [85.28443900000012, 21.442821],
              [85.288452000000149, 21.4434],
              [85.291786000000158, 21.441191],
              [85.293860000000137, 21.441050000000129],
              [85.297334, 21.442091000000111],
              [85.302596000000136, 21.444380000000134],
              [85.306587000000135, 21.455370000000126],
              [85.318992, 21.461920000000131],
              [85.320975000000132, 21.46427],
              [85.324891000000136, 21.472080000000172],
              [85.327218000000101, 21.474840000000139],
              [85.327751000000134, 21.476809000000113],
              [85.326142, 21.479041],
              [85.325340000000139, 21.483720000000172],
              [85.325996, 21.488121000000145],
              [85.324387000000144, 21.49267],
              [85.322967000000105, 21.50531],
              [85.316590000000176, 21.521351000000145],
              [85.317855, 21.52386],
              [85.318238, 21.526871000000195],
              [85.315164000000124, 21.529542],
              [85.311271000000133, 21.531219],
              [85.305748, 21.529391000000139],
              [85.301986000000142, 21.526440000000203],
              [85.298257000000135, 21.52713000000011],
              [85.297142000000107, 21.53231100000016],
              [85.295700000000167, 21.534670000000116],
              [85.29667700000013, 21.549671000000156],
              [85.302353000000139, 21.55097000000017],
              [85.302011, 21.55293000000017],
              [85.302772000000147, 21.554799000000109],
              [85.30764, 21.560119],
              [85.306863, 21.562031],
              [85.304917, 21.562580000000136],
              [85.302362000000173, 21.561331000000159],
              [85.298920000000109, 21.562370000000154],
              [85.28769800000012, 21.572891],
              [85.281747000000138, 21.582509],
              [85.280297, 21.588271],
              [85.283607000000174, 21.592029000000135],
              [85.287301000000113, 21.594342000000207],
              [85.286216, 21.597681],
              [85.28514, 21.599231],
              [85.280113000000128, 21.597351000000113],
              [85.27297900000012, 21.60366200000021],
              [85.273200000000131, 21.608350000000137],
              [85.271431000000106, 21.61185],
              [85.262146000000115, 21.619110000000145],
              [85.259322, 21.623980000000181],
              [85.258887000000172, 21.627269000000179],
              [85.260291000000151, 21.635791],
              [85.25901, 21.639241],
              [85.251327000000103, 21.650290000000151],
              [85.244973000000172, 21.671641000000189],
              [85.241958, 21.672811000000191],
              [85.218492, 21.67173],
              [85.215271, 21.670641],
              [85.204979, 21.67053100000015],
              [85.201524000000163, 21.66144],
              [85.197692000000174, 21.65682],
              [85.191224, 21.65566],
              [85.18794200000012, 21.658862000000109],
              [85.184097000000108, 21.664859000000202],
              [85.182358000000107, 21.67465900000013],
              [85.186814000000169, 21.68249],
              [85.187867000000139, 21.688110000000162],
              [85.180688000000117, 21.70385],
              [85.181153, 21.706291],
              [85.1836, 21.713172],
              [85.195541, 21.72364],
              [85.202401, 21.731229000000209],
              [85.207367, 21.734251000000135],
              [85.209289000000112, 21.736891000000124],
              [85.209662, 21.739621],
              [85.208108000000138, 21.74115],
              [85.203454000000164, 21.741889000000121],
              [85.201790000000116, 21.745971000000164],
              [85.198372000000106, 21.76391000000012],
              [85.201141000000106, 21.767659000000148],
              [85.20440700000016, 21.768521],
              [85.205758000000159, 21.771271],
              [85.20588600000012, 21.77931000000012],
              [85.207787, 21.786560000000115],
              [85.221138000000138, 21.80547000000012],
              [85.223718000000119, 21.81651],
              [85.224664, 21.81808],
              [85.230605, 21.810489],
              [85.234008000000102, 21.80738],
              [85.234229, 21.80268],
              [85.235259, 21.799631000000197],
              [85.23783000000013, 21.799499],
              [85.251266, 21.807881000000119],
              [85.258721, 21.80996],
              [85.268143, 21.814969],
              [85.270301, 21.821599],
              [85.272988000000154, 21.825640000000131],
              [85.275855, 21.829679000000162],
              [85.279427, 21.831881000000116],
              [85.285683000000162, 21.832719000000164],
              [85.288192000000137, 21.829410000000106],
              [85.289544, 21.824111],
              [85.291221, 21.822919],
              [85.297601, 21.821980000000163],
              [85.302947, 21.816802],
              [85.305657, 21.815751],
              [85.311248000000134, 21.814609000000125],
              [85.317039, 21.816499000000189],
              [85.329071, 21.822650000000174],
              [85.333078000000157, 21.820581],
              [85.337547000000129, 21.823199],
              [85.339708, 21.825711000000123],
              [85.342597000000168, 21.829759],
              [85.346442000000124, 21.839771000000152],
              [85.350609000000119, 21.842549000000126],
              [85.35408000000011, 21.847871000000104],
              [85.353043, 21.859661],
              [85.354697000000144, 21.871022000000202],
              [85.354217, 21.874781000000151],
              [85.360778, 21.877942],
              [85.364288, 21.88916],
              [85.362198000000134, 21.893761],
              [85.369826000000131, 21.90314],
              [85.370580474489572, 21.904683900672403],
              [85.371078000000324, 21.905702],
              [85.36976734687866, 21.916071705414989],
              [85.37260220856875, 21.922731606256995],
              [85.375457561775804, 21.928442312670878],
              [85.375457561775804, 21.933677126883701],
              [85.376409346178022, 21.939863725498807],
              [85.376409346178022, 21.946526216315302],
              [85.373078100769973, 21.946526216315302],
              [85.363560256746638, 21.939863725498807],
              [85.350711167315097, 21.943670863108249],
              [85.344222138427853, 21.943670863108249],
              [85.341193323291776, 21.943670863108249],
              [85.332151371469635, 21.944622647510464],
              [85.320729958641692, 21.947478000717521],
              [85.307404977008943, 21.949857461723351],
              [85.296459456382181, 21.945574431912856],
              [85.283122299349344, 21.950268665094935],
              [85.277749, 21.95128],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Khordha",
          Dist_Code: "386",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [85.741432674571143, 20.130325693425956],
              [85.737769722554432, 20.133262167153813],
              [85.733248746643298, 20.135403682058946],
              [85.730869285637468, 20.133976005455501],
              [85.729989106662956, 20.132422748441112],
              [85.726824201927485, 20.126837622438014],
              [85.722779118217531, 20.1192233472193],
              [85.718258142306567, 20.118985401118831],
              [85.712309489791991, 20.123506377029795],
              [85.71064386708791, 20.127313514639237],
              [85.713028000000108, 20.130351],
              [85.714286000000101, 20.132771000000101],
              [85.714211000000134, 20.134631000000176],
              [85.711685032253158, 20.135135024213461],
              [85.701682000000147, 20.137131],
              [85.694024000000169, 20.143832],
              [85.688217, 20.14439],
              [85.683456, 20.141601],
              [85.677856000000162, 20.131989],
              [85.677232000000103, 20.124270000000134],
              [85.671866000000165, 20.115470000000183],
              [85.672074000000165, 20.109280000000123],
              [85.671379, 20.104619000000124],
              [85.6782, 20.09845],
              [85.681220000000152, 20.09053],
              [85.686478000000179, 20.087551000000126],
              [85.676849000000161, 20.084841],
              [85.6716, 20.07933],
              [85.670150000000135, 20.074430000000174],
              [85.671753, 20.071770000000182],
              [85.675591, 20.06989],
              [85.675422, 20.066722000000137],
              [85.674203, 20.063962],
              [85.669854000000143, 20.0615],
              [85.663696000000101, 20.060320000000157],
              [85.658317000000153, 20.057530000000209],
              [85.652642000000114, 20.056760000000107],
              [85.647462000000175, 20.058],
              [85.643997000000169, 20.062480000000161],
              [85.642457000000135, 20.067449],
              [85.644371, 20.083442000000101],
              [85.646409, 20.088841000000109],
              [85.641189, 20.090739],
              [85.627380000000173, 20.09251],
              [85.627289000000118, 20.089732],
              [85.639428000000166, 20.080761000000162],
              [85.640344, 20.07533],
              [85.637338, 20.075631],
              [85.636818, 20.072],
              [85.633454, 20.066241000000101],
              [85.621985, 20.06104],
              [85.618081000000103, 20.058410000000205],
              [85.614487, 20.051201],
              [85.611344000000116, 20.03444],
              [85.614143, 20.028419000000149],
              [85.61612800000016, 20.028521],
              [85.617897000000184, 20.022260000000184],
              [85.625206, 20.016950000000119],
              [85.623261740941061, 20.013939828890212],
              [85.622611061530819, 20.012932423856679],
              [85.61775300000015, 20.005411000000148],
              [85.617897000000184, 20.002099000000211],
              [85.608985000000175, 20.006179],
              [85.611542000000142, 20.010441000000121],
              [85.608552, 20.011740000000142],
              [85.603125, 20.00916],
              [85.599053000000126, 20.004909],
              [85.596787, 19.999690000000211],
              [85.590697, 19.992650000000189],
              [85.588662, 19.987239],
              [85.585038, 19.990020000000182],
              [85.584815000000148, 19.992830000000136],
              [85.58418400000015, 19.995171],
              [85.575812, 20.00083],
              [85.573082000000156, 20.011209000000118],
              [85.571038000000129, 20.01383],
              [85.570001659750787, 20.014419992052236],
              [85.568935542649825, 20.01502693616839],
              [85.566803, 20.016241],
              [85.566444437461584, 20.009821980222107],
              [85.565873366820114, 20.006395556373654],
              [85.565111939298191, 20.002969132525376],
              [85.56663479434188, 19.999161994915934],
              [85.565873366820114, 19.998590924274648],
              [85.563208370493598, 19.998590924274648],
              [85.560417, 19.993031],
              [85.560829333564001, 19.988017073615762],
              [85.56108, 19.984969],
              [85.563491, 19.976550000000138],
              [85.563667, 19.968751],
              [85.558457000000118, 19.972878],
              [85.555291000000153, 19.970529],
              [85.554170000000155, 19.96598],
              [85.55821300000018, 19.96278900000021],
              [85.5635, 19.961032000000156],
              [85.562841226563407, 19.955640966080065],
              [85.549019766409273, 19.94682442326086],
              [85.54872, 19.953640000000117],
              [85.546890000000175, 19.954620000000201],
              [85.54152700000013, 19.94826200000011],
              [85.528267, 19.959240000000189],
              [85.5300060000001, 19.967372000000122],
              [85.525459000000112, 19.96964],
              [85.51944, 19.9675820000001],
              [85.513574000000105, 19.96138000000013],
              [85.509262, 19.946931000000113],
              [85.500993, 19.94252],
              [85.496291, 19.937812],
              [85.49813, 19.93538],
              [85.503548000000109, 19.93819],
              [85.513574000000105, 19.93418100000013],
              [85.51371000000016, 19.929121000000176],
              [85.502823, 19.925340000000169],
              [85.504211, 19.918011000000202],
              [85.516746, 19.92173],
              [85.522636000000134, 19.933402000000164],
              [85.52726, 19.932360000000127],
              [85.530715000000129, 19.92901],
              [85.52999, 19.920080000000151],
              [85.560752, 19.908978000000101],
              [85.560007296718865, 19.906643462398673],
              [85.557556, 19.898959000000158],
              [85.545596729325595, 19.873525496850387],
              [85.538583000000116, 19.870060000000191],
              [85.53765, 19.87055],
              [85.537003000000126, 19.871931000000124],
              [85.536506, 19.872592000000104],
              [85.535378000000136, 19.874019000000199],
              [85.534478, 19.874951],
              [85.529350000000164, 19.878531000000176],
              [85.525102, 19.879609000000183],
              [85.522248000000133, 19.880181],
              [85.518608, 19.879160000000123],
              [85.512414, 19.880090000000159],
              [85.508111, 19.879329],
              [85.506768000000108, 19.879550000000101],
              [85.504539, 19.879931000000166],
              [85.501640000000165, 19.87911],
              [85.497139000000104, 19.880890000000132],
              [85.493729, 19.879969000000123],
              [85.488907, 19.87868200000019],
              [85.484383000000136, 19.87885],
              [85.482436000000163, 19.87803],
              [85.481240000000156, 19.877292000000121],
              [85.479751, 19.87664900000021],
              [85.479232000000124, 19.876330000000106],
              [85.477782, 19.876150000000159],
              [85.473121, 19.877911000000207],
              [85.47290700000012, 19.878812000000149],
              [85.472442000000157, 19.879069],
              [85.472458, 19.87976],
              [85.472039, 19.881362],
              [85.47058000000014, 19.882730000000148],
              [85.469527000000184, 19.883712],
              [85.464723, 19.883199],
              [85.464440000000124, 19.882310000000182],
              [85.461486000000136, 19.880601000000176],
              [85.45884, 19.88058],
              [85.456208, 19.880569000000204],
              [85.455018, 19.88107],
              [85.44345800000012, 19.878550000000129],
              [85.44037961382746, 19.879025985761356],
              [85.411462127112415, 19.862395382619805],
              [85.392902331266995, 19.839552556963717],
              [85.374342535421519, 19.825989629230431],
              [85.348644356558438, 19.813854378100753],
              [85.327943045807828, 19.783159331125482],
              [85.308669411660489, 19.783159331125482],
              [85.288121907231002, 19.785446955106746],
              [85.283996, 19.782760000000163],
              [85.283126, 19.782502000000129],
              [85.282050000000126, 19.782172],
              [85.281731, 19.782172],
              [85.281471, 19.782172],
              [85.278105216614705, 19.782300615322292],
              [85.273437000000143, 19.78247900000019],
              [85.271760000000185, 19.782311000000156],
              [85.271210000000153, 19.78213100000016],
              [85.268448, 19.780750000000122],
              [85.264611936493893, 19.77823007728113],
              [85.250411000000128, 19.763330000000103],
              [85.249046000000163, 19.761949],
              [85.23912, 19.7565],
              [85.249420832615414, 19.752464284150388],
              [85.235828187612441, 19.744635979607999],
              [85.226478, 19.739251000000191],
              [85.220867300545464, 19.733190650003046],
              [85.218556338088518, 19.731419664015672],
              [85.21804477897966, 19.731027635140205],
              [85.204835026169334, 19.720904455919417],
              [85.197159000000156, 19.715022],
              [85.19652097175161, 19.708758720617819],
              [85.195882959984232, 19.702495603027952],
              [85.206590534510482, 19.693215705105153],
              [85.199753, 19.678480000000146],
              [85.199538000000175, 19.676228000000147],
              [85.199256, 19.67534],
              [85.198517, 19.674681],
              [85.195846, 19.67387],
              [85.192659554732572, 19.672409716353737],
              [85.188056000000117, 19.670300000000108],
              [85.18602823998387, 19.669790454229709],
              [85.179496, 19.668149000000135],
              [85.177909, 19.667449],
              [85.177811000000105, 19.669099],
              [85.169137, 19.674350000000171],
              [85.164383, 19.682489000000196],
              [85.155458000000152, 19.688260000000177],
              [85.1557770000001, 19.692130000000127],
              [85.142852, 19.70960000000019],
              [85.139923000000167, 19.715370000000117],
              [85.139877000000112, 19.720380000000201],
              [85.122032, 19.741081],
              [85.109337, 19.747490000000138],
              [85.095963, 19.75177],
              [85.081238, 19.758872],
              [85.07235800000015, 19.777201],
              [85.07071, 19.783701],
              [85.058679, 19.789369],
              [85.047158, 19.793702000000103],
              [85.037567000000166, 19.798602000000184],
              [85.031388000000135, 19.79906],
              [85.024597000000114, 19.796359],
              [85.019029, 19.79999],
              [85.008453, 19.797351],
              [85.003036000000151, 19.794930000000132],
              [84.99334, 19.809221000000203],
              [84.983727000000144, 19.81493],
              [84.977676, 19.816641],
              [84.974487000000153, 19.821430000000188],
              [84.97219, 19.83203],
              [84.965736000000149, 19.845251],
              [84.949378000000124, 19.85479],
              [84.94477, 19.860841],
              [84.939521, 19.86216],
              [84.93293, 19.862730000000166],
              [84.929588000000109, 19.864971000000132],
              [84.931054000000117, 19.870862000000155],
              [84.933534000000108, 19.876052],
              [84.934418, 19.880671000000117],
              [84.934906, 19.88528],
              [84.933762000000158, 19.889631000000175],
              [84.93837, 19.890251000000145],
              [84.943580000000154, 19.89200100000016],
              [84.946053000000163, 19.893592000000179],
              [84.952881, 19.892341],
              [84.968979, 19.897409000000145],
              [84.977867, 19.897861],
              [84.987251, 19.895960000000169],
              [84.993377000000109, 19.895611],
              [85.003562000000144, 19.892199],
              [85.0103, 19.894260000000198],
              [85.01638, 19.897368000000139],
              [85.022331, 19.895800000000119],
              [85.049569, 19.907280000000124],
              [85.069183, 19.913022],
              [85.084458, 19.91647],
              [85.091927, 19.922981],
              [85.121489, 19.925792],
              [85.131791, 19.916041000000114],
              [85.148522, 19.90824200000014],
              [85.16085, 19.896881000000175],
              [85.170272, 19.89924000000013],
              [85.174682, 19.90171],
              [85.179414, 19.899000000000164],
              [85.190467, 19.899620000000137],
              [85.20388, 19.904210000000145],
              [85.218063, 19.90391],
              [85.227768000000182, 19.90166],
              [85.238983000000104, 19.897770000000204],
              [85.251808, 19.901099000000155],
              [85.26148300000014, 19.90478],
              [85.265228, 19.909430000000206],
              [85.271210000000153, 19.904992],
              [85.286766, 19.913090000000178],
              [85.314956, 19.918462000000201],
              [85.325600000000165, 19.918040000000129],
              [85.328232000000156, 19.927442000000152],
              [85.3367930000001, 19.933531000000183],
              [85.343712, 19.934901],
              [85.351096, 19.94578000000012],
              [85.35733, 19.95055],
              [85.369231000000113, 19.944139],
              [85.378243, 19.942381],
              [85.378669, 19.932410000000171],
              [85.38395, 19.931699000000147],
              [85.389001, 19.932100000000101],
              [85.391328, 19.931400000000107],
              [85.392638, 19.92541100000016],
              [85.397538, 19.921881000000152],
              [85.415297000000109, 19.919200000000156],
              [85.416175, 19.92645900000019],
              [85.418716000000174, 19.929910000000117],
              [85.425041, 19.930361000000111],
              [85.430221000000174, 19.932481],
              [85.434745, 19.938240000000118],
              [85.44027, 19.947621000000193],
              [85.4478, 19.956421000000198],
              [85.451027, 19.965471],
              [85.447472, 19.973430000000118],
              [85.441628, 19.980069000000178],
              [85.435463000000126, 19.982911000000112],
              [85.434631000000181, 19.98672200000015],
              [85.426919000000154, 19.985411],
              [85.417549000000108, 19.985781],
              [85.410598000000149, 19.987422000000148],
              [85.410698, 19.99311],
              [85.412002000000129, 19.99626],
              [85.41533600000011, 19.996],
              [85.41909, 19.998929000000143],
              [85.420058, 20.00382900000016],
              [85.422782, 20.006361],
              [85.425752, 20.010901],
              [85.428917, 20.019541],
              [85.424605, 20.02038],
              [85.42012, 20.019649000000125],
              [85.415977, 20.016620000000156],
              [85.411147, 20.019471000000177],
              [85.408927000000105, 20.017579000000122],
              [85.40882, 20.013071000000135],
              [85.407409, 20.014580000000134],
              [85.407067, 20.01845],
              [85.407981000000163, 20.023810000000136],
              [85.405853000000121, 20.0259],
              [85.401267000000104, 20.024259000000196],
              [85.397315000000148, 20.0257],
              [85.393668, 20.025962],
              [85.390717, 20.028920000000195],
              [85.39185400000018, 20.0324300000002],
              [85.389411, 20.033310000000139],
              [85.388069, 20.037241000000162],
              [85.38816, 20.040070000000121],
              [85.386063000000135, 20.04025],
              [85.380837, 20.048530000000195],
              [85.379829, 20.054141000000126],
              [85.374733, 20.064101000000161],
              [85.377259, 20.071702],
              [85.374740000000131, 20.073739],
              [85.374749000000165, 20.076800000000159],
              [85.378998000000166, 20.082439],
              [85.384682, 20.082471],
              [85.390122, 20.081060000000203],
              [85.393646000000146, 20.084501000000152],
              [85.396317000000167, 20.088649000000196],
              [85.3983, 20.105440000000211],
              [85.400421, 20.108498000000107],
              [85.408157000000159, 20.115561],
              [85.408287, 20.120179],
              [85.399726000000129, 20.128420000000169],
              [85.3936, 20.13255],
              [85.390441000000166, 20.129731000000103],
              [85.389290000000173, 20.126741000000148],
              [85.386222000000117, 20.128202],
              [85.383743, 20.131269000000142],
              [85.382378, 20.136119000000175],
              [85.383850000000152, 20.140689000000119],
              [85.381692000000143, 20.143109000000148],
              [85.380691000000112, 20.147330000000178],
              [85.378419, 20.148611000000127],
              [85.377113000000165, 20.145450000000206],
              [85.377038000000184, 20.142681],
              [85.373849000000106, 20.142761000000117],
              [85.369147, 20.138152000000158],
              [85.356338, 20.138549000000118],
              [85.349991000000145, 20.137911000000138],
              [85.351723, 20.14592],
              [85.35575, 20.1496],
              [85.357788000000127, 20.15876900000017],
              [85.361236000000119, 20.16152],
              [85.36405100000016, 20.1655],
              [85.36406, 20.170630000000124],
              [85.362526000000102, 20.173531000000192],
              [85.356812, 20.178461],
              [85.352120000000113, 20.180510000000137],
              [85.345519000000166, 20.181121],
              [85.342613, 20.177440000000157],
              [85.341437, 20.174550000000121],
              [85.327049000000144, 20.173009000000146],
              [85.317771, 20.165951],
              [85.306252000000114, 20.1593],
              [85.308518, 20.15126],
              [85.308547000000118, 20.148732000000162],
              [85.305976, 20.146941000000137],
              [85.295417, 20.146471000000126],
              [85.291497, 20.144411],
              [85.288598000000135, 20.146569],
              [85.284828000000147, 20.143631000000191],
              [85.26477, 20.139221000000131],
              [85.26123, 20.136110000000137],
              [85.252403000000101, 20.125530000000136],
              [85.249686, 20.12548],
              [85.246131, 20.12422],
              [85.24211, 20.121059],
              [85.238473, 20.117041000000139],
              [85.23468700000015, 20.1073],
              [85.22612, 20.111142000000196],
              [85.223137000000165, 20.11485],
              [85.221284000000125, 20.119021000000139],
              [85.211326, 20.120970000000106],
              [85.208076000000105, 20.12502],
              [85.208648, 20.129870000000203],
              [85.208183000000119, 20.1339700000002],
              [85.209526, 20.137610000000102],
              [85.204612, 20.142590000000208],
              [85.200929000000116, 20.144452],
              [85.199447, 20.14746],
              [85.205688, 20.151360000000178],
              [85.208236, 20.157591],
              [85.206818000000155, 20.161409000000102],
              [85.203468, 20.163790000000112],
              [85.197854000000106, 20.16508],
              [85.197585, 20.173401],
              [85.195618000000181, 20.176640000000187],
              [85.195167000000168, 20.18312],
              [85.205466000000143, 20.191730000000174],
              [85.20713, 20.194549000000162],
              [85.207581, 20.202752000000142],
              [85.209838, 20.20650100000017],
              [85.212691, 20.210121000000179],
              [85.220527, 20.216101],
              [85.223839000000154, 20.2132],
              [85.2294, 20.202950000000151],
              [85.233803000000179, 20.200970000000151],
              [85.238152, 20.201011000000161],
              [85.245422000000175, 20.20375000000012],
              [85.250329000000107, 20.207531000000127],
              [85.249520000000103, 20.214120000000147],
              [85.249969000000178, 20.219378000000169],
              [85.26786, 20.219882],
              [85.273651000000129, 20.219378000000169],
              [85.302375, 20.222442],
              [85.307533, 20.225701000000182],
              [85.313188, 20.224000000000157],
              [85.317842, 20.223811000000119],
              [85.320098, 20.235050000000111],
              [85.322769, 20.23822],
              [85.328376000000148, 20.237270000000134],
              [85.334297000000149, 20.238060000000125],
              [85.336806, 20.244039],
              [85.336517000000157, 20.246411],
              [85.332444, 20.247241000000194],
              [85.324257, 20.248029000000198],
              [85.321121, 20.24678],
              [85.321411000000111, 20.252610000000168],
              [85.324982, 20.257682],
              [85.32415, 20.267780000000183],
              [85.325431, 20.27118100000018],
              [85.328797000000151, 20.27341],
              [85.330803, 20.2652],
              [85.337326000000118, 20.266260000000155],
              [85.343552000000145, 20.265230000000198],
              [85.348747000000103, 20.265911],
              [85.355714, 20.267901],
              [85.365067000000167, 20.268840000000122],
              [85.373450000000147, 20.274919],
              [85.376677000000129, 20.278650000000191],
              [85.380158, 20.27493],
              [85.38504, 20.27185100000019],
              [85.389495, 20.270269000000209],
              [85.389992000000163, 20.26368],
              [85.392517000000154, 20.252519000000113],
              [85.397338, 20.250190000000142],
              [85.402099000000163, 20.249080000000102],
              [85.415749, 20.265230000000198],
              [85.424943, 20.26593],
              [85.431420000000102, 20.261390000000116],
              [85.440985000000111, 20.256900000000194],
              [85.444131000000169, 20.256362],
              [85.448502000000161, 20.259509],
              [85.450469, 20.262791],
              [85.449227000000107, 20.268569],
              [85.450433, 20.27457],
              [85.452949, 20.279409],
              [85.455337000000128, 20.287531000000108],
              [85.467018, 20.2884],
              [85.478318000000144, 20.29018],
              [85.487512, 20.289090000000154],
              [85.496047000000118, 20.287021000000205],
              [85.504441000000128, 20.283851],
              [85.513526, 20.287101],
              [85.516876000000124, 20.286319],
              [85.515976, 20.292561],
              [85.519096000000147, 20.29665],
              [85.523757000000131, 20.298070000000106],
              [85.528869000000142, 20.29544],
              [85.544518, 20.295460000000158],
              [85.543939, 20.297202],
              [85.546669000000165, 20.298572],
              [85.543777000000134, 20.300550000000154],
              [85.547027, 20.30612],
              [85.553108, 20.302920000000139],
              [85.561126000000158, 20.293801000000197],
              [85.568009000000117, 20.29260000000016],
              [85.578584, 20.29381],
              [85.590896, 20.291429],
              [85.59671, 20.290930000000166],
              [85.600632, 20.29136],
              [85.60344, 20.28904000000011],
              [85.613067, 20.289610000000206],
              [85.620698000000104, 20.284940000000173],
              [85.628433, 20.290911],
              [85.627373000000134, 20.297370000000111],
              [85.627968000000152, 20.302811000000183],
              [85.634033000000144, 20.31213],
              [85.637994000000148, 20.315900000000109],
              [85.641693000000132, 20.31819],
              [85.645859, 20.31672],
              [85.65274, 20.322281000000142],
              [85.657098, 20.32427100000012],
              [85.663017, 20.32371],
              [85.669503, 20.32015],
              [85.672988000000132, 20.317231],
              [85.675538, 20.328189000000119],
              [85.678321000000139, 20.333130000000207],
              [85.68739400000014, 20.339491000000173],
              [85.695848, 20.354682000000132],
              [85.695877, 20.359290000000207],
              [85.699898000000175, 20.369031],
              [85.702888000000129, 20.380092],
              [85.70873200000014, 20.384499],
              [85.708604, 20.389700000000115],
              [85.709878, 20.392401000000117],
              [85.726769, 20.402051],
              [85.731147, 20.40103],
              [85.736428, 20.397819],
              [85.741043000000147, 20.399460000000143],
              [85.754066000000108, 20.397349],
              [85.761933, 20.405210000000178],
              [85.767745, 20.39621000000016],
              [85.770257, 20.399250000000162],
              [85.78147, 20.402580000000164],
              [85.782760000000152, 20.409629],
              [85.778747000000166, 20.409299],
              [85.776864000000145, 20.414860000000139],
              [85.781486000000129, 20.425911000000209],
              [85.788886, 20.41945000000015],
              [85.790031000000141, 20.419500000000191],
              [85.793007000000145, 20.421971000000209],
              [85.796150000000154, 20.427021],
              [85.801659, 20.426750000000194],
              [85.804863, 20.420489000000138],
              [85.810951, 20.419402000000101],
              [85.815846780295985, 20.405324555886402],
              [85.817437, 20.400752000000121],
              [85.825043000000136, 20.396882000000172],
              [85.839084660238242, 20.407531017930577],
              [85.852409641870835, 20.397537281706029],
              [85.853577907553969, 20.397203491510929],
              [85.862403378095379, 20.394681928499036],
              [85.864734881819501, 20.390934868942676],
              [85.860449179939536, 20.381228971186257],
              [85.859556882062336, 20.377064914426054],
              [85.862531208319609, 20.373793155543009],
              [85.867290130331284, 20.371711127162936],
              [85.871454187091473, 20.369034233531174],
              [85.874065509965178, 20.367238949055771],
              [85.871921222118871, 20.359465905612748],
              [85.875252467526735, 20.355658768003472],
              [85.879838000000106, 20.350410000000174],
              [85.884407000000166, 20.349572],
              [85.887778155332597, 20.34976908781783],
              [85.888649000000129, 20.349820000000189],
              [85.889802000000131, 20.355060000000147],
              [85.893433000000172, 20.360869],
              [85.894691000000165, 20.360471],
              [85.895087, 20.347509000000109],
              [85.896104, 20.34399],
              [85.903869, 20.34172],
              [85.910859000000173, 20.338541],
              [85.913118, 20.33408],
              [85.913826000000114, 20.327421000000179],
              [85.917184000000162, 20.32439],
              [85.92321000000014, 20.321219000000209],
              [85.92495800000016, 20.315891],
              [85.926330000000164, 20.308032000000136],
              [85.926011, 20.30439],
              [85.923499, 20.302959000000154],
              [85.916062, 20.309201],
              [85.915169, 20.316321000000126],
              [85.911912, 20.317160000000108],
              [85.910843, 20.313302],
              [85.908653, 20.309901],
              [85.910446, 20.302560000000195],
              [85.916329000000118, 20.299330000000108],
              [85.9215, 20.284901000000101],
              [85.924974, 20.28153],
              [85.931731, 20.279760000000177],
              [85.933532000000113, 20.27323],
              [85.928306, 20.26536000000015],
              [85.932976, 20.260330000000121],
              [85.936866000000109, 20.263249],
              [85.940057000000181, 20.261342],
              [85.945976000000115, 20.260920000000109],
              [85.948319, 20.253080000000175],
              [85.955177, 20.244791000000188],
              [85.967217000000105, 20.236620000000183],
              [85.970208000000156, 20.23321],
              [85.976708, 20.23187],
              [85.988441, 20.22127],
              [85.994148000000138, 20.218221000000195],
              [86.002097, 20.216721],
              [86.006058, 20.201259],
              [86.009666000000124, 20.201120000000113],
              [86.015961000000161, 20.17888],
              [86.019341, 20.176971],
              [86.022979000000177, 20.178101000000137],
              [86.024727, 20.177481000000167],
              [86.025224, 20.17512],
              [86.020447, 20.168212],
              [86.02214, 20.163291],
              [86.026222, 20.162402000000206],
              [86.029137, 20.162571000000181],
              [86.031899, 20.1648],
              [86.033759, 20.167631000000135],
              [86.033622, 20.16953100000017],
              [86.031747000000152, 20.170379000000136],
              [86.037262, 20.172599000000154],
              [86.040038000000138, 20.169381000000154],
              [86.040756, 20.166621],
              [86.043808, 20.16459900000012],
              [86.043252000000138, 20.161860000000157],
              [86.049187, 20.157591],
              [86.04979, 20.154991],
              [86.043236, 20.149869],
              [86.04525, 20.1387590000001],
              [86.043197000000163, 20.135481000000137],
              [86.03917, 20.134652000000127],
              [86.030616000000151, 20.135761],
              [86.034509, 20.13039],
              [86.034126000000171, 20.127591000000105],
              [86.03826, 20.12657],
              [86.047181000000123, 20.126342000000189],
              [86.053649, 20.117549],
              [86.057717, 20.11914],
              [86.059541000000181, 20.117852],
              [86.061959, 20.117581000000197],
              [86.065011000000126, 20.114880000000195],
              [86.067299, 20.11127],
              [86.067679, 20.107990000000139],
              [86.069047000000111, 20.10593],
              [86.072479, 20.104371],
              [86.077049000000144, 20.098671000000191],
              [86.073867000000163, 20.09886],
              [86.067832000000166, 20.102101000000168],
              [86.057747, 20.10131],
              [86.053414, 20.099890000000183],
              [86.051406000000128, 20.097841000000123],
              [86.047789000000165, 20.09883],
              [86.043053, 20.098340000000174],
              [86.037057, 20.100300000000171],
              [86.030994464456043, 20.099910595870593],
              [86.027093, 20.099660000000139],
              [86.015191, 20.093910000000104],
              [86.012621161197657, 20.095605183508322],
              [86.010541262372755, 20.096977180142343],
              [86.006985906522672, 20.103345997081018],
              [86.003940196435153, 20.105439922766145],
              [85.999561988184482, 20.104868852124692],
              [85.995374136814277, 20.100490643874021],
              [85.989633000000126, 20.099081],
              [85.987886553095549, 20.10027872546851],
              [85.983468, 20.103309],
              [85.974238723819369, 20.105682190883549],
              [85.969800388685471, 20.106823452264219],
              [85.963012, 20.108569],
              [85.954659, 20.112660000000172],
              [85.949388, 20.103999000000151],
              [85.945716000000161, 20.11189],
              [85.94220800000015, 20.111701],
              [85.939720000000165, 20.109590000000193],
              [85.940957000000168, 20.10588000000018],
              [85.936242000000149, 20.105871000000146],
              [85.930526, 20.107840000000174],
              [85.926719, 20.10625100000015],
              [85.921594000000169, 20.106411],
              [85.910362, 20.11315],
              [85.905136000000169, 20.115222],
              [85.898857, 20.120519000000112],
              [85.898399, 20.115680000000108],
              [85.894242000000176, 20.104979],
              [85.885422, 20.104070000000142],
              [85.879753, 20.102440000000112],
              [85.869668, 20.114759000000156],
              [85.873757, 20.121022000000149],
              [85.881759, 20.123488000000119],
              [85.884697000000173, 20.12721],
              [85.892899, 20.132641000000142],
              [85.896432000000161, 20.137220000000124],
              [85.88910700000018, 20.152349000000122],
              [85.883591000000123, 20.168962000000132],
              [85.875459321093885, 20.174177133975999],
              [85.871011, 20.177030000000109],
              [85.864440000000101, 20.179860000000183],
              [85.861878, 20.18294],
              [85.856183389102156, 20.195757869536514],
              [85.849758844386415, 20.190761001424388],
              [85.854943000000134, 20.184031000000115],
              [85.851506167972829, 20.185086559815311],
              [85.850420575574262, 20.185419979576121],
              [85.848931125649969, 20.185877436755955],
              [85.847946000000292, 20.186180000000316],
              [85.846683732192531, 20.186419820828061],
              [85.845097690683559, 20.188226526657953],
              [85.842480283577217, 20.189416257160865],
              [85.837245469364333, 20.188702418859005],
              [85.834628062257806, 20.186085011752649],
              [85.831772709050966, 20.186798850054341],
              [85.828679409743231, 20.183229658545596],
              [85.82939324804515, 20.181088143640459],
              [85.833914223956114, 20.180136359238073],
              [85.833438331754877, 20.183229658545596],
              [85.837516626543035, 20.182461215090253],
              [85.836304359056598, 20.181337599907859],
              [85.845333637664098, 20.178226987520642],
              [85.845335636784043, 20.171332353516441],
              [85.84547304281908, 20.167759796607633],
              [85.845573582884725, 20.165145754901342],
              [85.840338768671913, 20.162766293895508],
              [85.837245469364333, 20.162766293895508],
              [85.834390116157337, 20.162766293895508],
              [85.832962439553896, 20.167525215907173],
              [85.833200385654422, 20.170142623013529],
              [85.832316304148819, 20.17279486753068],
              [85.831534762950284, 20.175139491125883],
              [85.830820924648592, 20.175615383326935],
              [85.82939324804515, 20.176567167729328],
              [85.8262999487374, 20.173949760622971],
              [85.823920487731556, 20.169666730812363],
              [85.821778972826436, 20.163004239996035],
              [85.817733889116525, 20.156817641380936],
              [85.815975586512351, 20.150956632700453],
              [85.815592374211164, 20.149679258363445],
              [85.813926751507253, 20.146348012955222],
              [85.807978098992663, 20.145158282452311],
              [85.801077662075713, 20.146110066854696],
              [85.798331000000118, 20.146501000000111],
              [85.79767010657693, 20.145754258565198],
              [85.795906000000215, 20.143761000000264],
              [85.794158, 20.143011],
              [85.792962050102489, 20.142210949979866],
              [85.789785502490517, 20.140085947096164],
              [85.782755812330748, 20.144206498050092],
              [85.777758944218576, 20.145634174653534],
              [85.773475914408138, 20.147061851256975],
              [85.773475914408138, 20.149679258363445],
              [85.774903591011565, 20.150631042765717],
              [85.776807159816173, 20.153724342073414],
              [85.774903591011565, 20.156817641380936],
              [85.761305471675243, 20.159567903123722],
              [85.759613000000257, 20.15920900000037],
              [85.757771471769544, 20.160386832889678],
              [85.756105849065406, 20.158483264085071],
              [85.754202280260799, 20.153010503771551],
              [85.755867902964923, 20.147061851256975],
              [85.755154064663188, 20.146110066854696],
              [85.752774603657343, 20.14587212075406],
              [85.748015681645697, 20.145158282452311],
              [85.747063897243308, 20.141827037044258],
              [85.746350058941616, 20.138495791636043],
              [85.751584873154442, 20.137068115032601],
              [85.75325049585858, 20.136116330630212],
              [85.750157196550816, 20.134450707926074],
              [85.747063897243308, 20.132547139121467],
              [85.743732651835259, 20.131357408618548],
              [85.742719198083236, 20.129294327883482],
              [85.741432674571143, 20.130325693425956],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Koraput",
          Dist_Code: "398",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [83.330933457948191, 18.991591851729307],
              [83.331208000000203, 18.990070000000227],
              [83.329880470304246, 18.986168031887015],
              [83.327054222820252, 18.985885035910481],
              [83.326019709590284, 18.986558351954269],
              [83.325932682498077, 18.986614993673179],
              [83.325564097165724, 18.986854887796024],
              [83.32422797533637, 18.9877245010594],
              [83.323136372854194, 18.989207884776928],
              [83.322145477190347, 18.990554407291935],
              [83.318872980103706, 18.99182784921771],
              [83.316790481957668, 18.991403369671101],
              [83.316242192901399, 18.990412437388038],
              [83.315302983281967, 18.988714973776947],
              [83.313220485135943, 18.988856469392712],
              [83.310691737386989, 18.989705440532642],
              [83.308340472706249, 18.990916919814701],
              [83.307121740565236, 18.9915448629751],
              [83.304741742684016, 18.991120382698053],
              [83.303254244008286, 18.988856469392712],
              [83.303997993346144, 18.985885035910481],
              [83.305931741624619, 18.981215532046171],
              [83.309503035890629, 18.977660136532048],
              [83.309615000000278, 18.976821000000367],
              [83.309973798596076, 18.975841065835478],
              [83.310363709053235, 18.974776152193211],
              [83.310947082305731, 18.973182855080832],
              [83.313346, 18.966631000000117],
              [83.31981, 18.961330000000139],
              [83.320557, 18.961031],
              [83.325562, 18.95897100000013],
              [83.326919, 18.957341],
              [83.325654, 18.952922],
              [83.326011, 18.950162000000145],
              [83.327042000000162, 18.947901000000108],
              [83.328888000000106, 18.946821000000106],
              [83.331046000000114, 18.945811],
              [83.332459000000185, 18.943370000000183],
              [83.333022000000184, 18.939320000000119],
              [83.33113, 18.937640000000211],
              [83.321198000000138, 18.936029000000129],
              [83.318497000000121, 18.933620000000129],
              [83.318878, 18.928439],
              [83.319915, 18.925818000000103],
              [83.32203, 18.923250000000106],
              [83.329011000000136, 18.916909000000143],
              [83.334542, 18.915822000000102],
              [83.339057, 18.916201],
              [83.341371, 18.9184],
              [83.339577, 18.926201],
              [83.339538, 18.929479000000182],
              [83.339524000000139, 18.931911000000124],
              [83.339730000000131, 18.932752],
              [83.339837, 18.933219000000175],
              [83.343262000000138, 18.935161000000104],
              [83.344803000000113, 18.945250000000151],
              [83.345017, 18.956300000000109],
              [83.345756, 18.9571],
              [83.349038, 18.956090000000184],
              [83.354407, 18.954451000000116],
              [83.358902000000143, 18.954711],
              [83.36023, 18.953900000000139],
              [83.361069, 18.953401],
              [83.360848, 18.948111],
              [83.363900000000157, 18.937932],
              [83.367416, 18.93349],
              [83.380225000000152, 18.923282],
              [83.379662, 18.92152],
              [83.376344000000174, 18.917771],
              [83.373841000000183, 18.916791000000156],
              [83.371002000000132, 18.917089000000143],
              [83.364066, 18.922789000000133],
              [83.362762000000131, 18.930071000000108],
              [83.355239, 18.933032000000136],
              [83.349028, 18.933839000000141],
              [83.347923000000137, 18.932141000000168],
              [83.34661, 18.926871],
              [83.34768600000011, 18.920989],
              [83.350166000000101, 18.915929],
              [83.356499, 18.904809000000167],
              [83.357773000000165, 18.903681000000116],
              [83.360527, 18.901170000000146],
              [83.366311000000138, 18.900461000000117],
              [83.36715700000012, 18.900361000000199],
              [83.376845, 18.902469000000163],
              [83.380996000000124, 18.901821000000204],
              [83.383911000000111, 18.89969],
              [83.383263000000156, 18.89724],
              [83.374443, 18.891941000000198],
              [83.372490000000127, 18.889840000000103],
              [83.373901, 18.885911],
              [83.378906, 18.880279000000197],
              [83.385681, 18.875491000000178],
              [83.385392, 18.873262000000121],
              [83.387810000000101, 18.871030000000186],
              [83.394256, 18.868200000000169],
              [83.401779, 18.867071000000177],
              [83.404327000000166, 18.865980000000146],
              [83.405854, 18.865330000000192],
              [83.411338000000157, 18.859341],
              [83.410736, 18.856761000000116],
              [83.408753000000146, 18.85445],
              [83.406807, 18.853679],
              [83.399858, 18.853652000000121],
              [83.39787300000016, 18.852590000000188],
              [83.396943000000121, 18.849210000000134],
              [83.398711, 18.833529000000105],
              [83.396302, 18.830710000000121],
              [83.386491, 18.8257690000002],
              [83.383133, 18.82607],
              [83.376351, 18.821951000000119],
              [83.372834000000154, 18.821211000000172],
              [83.366106735783745, 18.828148968650279],
              [83.36226600000029, 18.83211000000011],
              [83.360322, 18.832041000000114],
              [83.358879000000158, 18.832000000000104],
              [83.353493000000228, 18.827490000000122],
              [83.350113000000178, 18.821639],
              [83.338903800024838, 18.819921815677159],
              [83.329978807970278, 18.818222124568074],
              [83.323433813796981, 18.810290002845587],
              [83.323021000000139, 18.798280000000201],
              [83.31826, 18.795842000000103],
              [83.314041, 18.795801],
              [83.304223, 18.798871],
              [83.300369000000131, 18.797911],
              [83.299089139502925, 18.797077433147532],
              [83.292107, 18.792530000000166],
              [83.279503000000119, 18.789601000000115],
              [83.275253000000177, 18.785369],
              [83.26992000000017, 18.775288000000153],
              [83.269149000000169, 18.770760000000106],
              [83.271248, 18.767321000000145],
              [83.271713, 18.763179],
              [83.26991300000013, 18.759809000000129],
              [83.266098000000142, 18.757010000000204],
              [83.259369, 18.757600000000135],
              [83.255417000000108, 18.758819000000127],
              [83.2450860000001, 18.758090000000205],
              [83.239564000000129, 18.758781000000166],
              [83.229317000000123, 18.764141000000105],
              [83.226516, 18.7649],
              [83.222716, 18.765930000000136],
              [83.221032000000136, 18.765871],
              [83.219391, 18.765819],
              [83.217080000000166, 18.763562000000146],
              [83.217331000000158, 18.758952000000132],
              [83.221894, 18.752021],
              [83.222687, 18.748620000000184],
              [83.223008, 18.747980000000208],
              [83.2223520000001, 18.745051000000156],
              [83.220337000000185, 18.742049],
              [83.214461000000185, 18.737199],
              [83.213639, 18.736021000000104],
              [83.212547, 18.734480000000186],
              [83.209183, 18.724541],
              [83.206778, 18.717492],
              [83.205062, 18.715860000000188],
              [83.203323000000154, 18.719579],
              [83.203667, 18.723502000000106],
              [83.206414000000137, 18.727420000000105],
              [83.206336, 18.728031000000211],
              [83.206261, 18.728742],
              [83.202423000000167, 18.73255000000017],
              [83.20189, 18.736131000000167],
              [83.203424, 18.740352000000197],
              [83.201705, 18.742230000000117],
              [83.191818, 18.741781000000113],
              [83.185371, 18.744142],
              [83.180801000000116, 18.748251000000206],
              [83.177017, 18.754409000000116],
              [83.173943, 18.75677],
              [83.168548, 18.759070000000118],
              [83.156227, 18.757311],
              [83.150832, 18.758689],
              [83.146867, 18.763179],
              [83.144914000000185, 18.766901],
              [83.13884700000014, 18.771140000000113],
              [83.132957, 18.772449],
              [83.115807, 18.76208100000019],
              [83.11219, 18.758279],
              [83.117523000000105, 18.75048],
              [83.116502000000182, 18.747971000000174],
              [83.106002, 18.738492000000118],
              [83.099212000000122, 18.726891000000187],
              [83.095468000000139, 18.723092000000118],
              [83.092591000000127, 18.721761000000122],
              [83.090798, 18.71926000000013],
              [83.089608, 18.716270000000176],
              [83.088724607858737, 18.714054363196734],
              [83.088065000000242, 18.712400000000226],
              [83.087126461963791, 18.711420163051056],
              [83.083837565884934, 18.69638899435591],
              [83.083481855090994, 18.694823866862176],
              [83.082647835382005, 18.691154180143027],
              [83.090975948902425, 18.693295695048388],
              [83.098410315182704, 18.696835869467574],
              [83.105014768836938, 18.696835869467574],
              [83.106680391541019, 18.691392126243553],
              [83.110249583049765, 18.688060880835504],
              [83.11381877455851, 18.687347042533812],
              [83.11703279864625, 18.688724481428491],
              [83.120481265374821, 18.690202395740638],
              [83.130712947699848, 18.699482293663433],
              [83.137137492415633, 18.702099700769789],
              [83.139992845622643, 18.700909970266874],
              [83.140468737823696, 18.694723371651772],
              [83.142848198829526, 18.690440341841331],
              [83.14475176763429, 18.686157312030893],
              [83.145703552036508, 18.681398390019236],
              [83.144513821533607, 18.674973845303438],
              [83.143799983231915, 18.668073408386473],
              [83.139992845622643, 18.659031456564318],
              [83.137851330717339, 18.658317618262625],
              [83.138089276817865, 18.661648863670674],
              [83.133092408705679, 18.659507348765541],
              [83.128542918756793, 18.656521745986876],
              [83.124905370438938, 18.649246649350967],
              [83.119053588771209, 18.649246649350967],
              [83.117766987421447, 18.649246649350967],
              [83.110070932157996, 18.650565973110353],
              [83.096946703620446, 18.652815840859713],
              [83.095121313904983, 18.653383561807512],
              [83.091641698680206, 18.65446576931458],
              [83.090024164500207, 18.65236896574805],
              [83.090024164500207, 18.650227450842745],
              [83.092403625506037, 18.645230582730559],
              [83.095258978712906, 18.638330145813594],
              [83.091927733304871, 18.636188630908457],
              [83.089548272299041, 18.634285062103626],
              [83.084789350287366, 18.633809169902626],
              [83.085979080790295, 18.629050247890969],
              [83.089786218399496, 18.620960080471033],
              [83.088358541796126, 18.616201158459372],
              [83.086454972991461, 18.609062775441881],
              [83.085979080790295, 18.601448500223224],
              [83.078840697772804, 18.59383422500451],
              [83.070988476453564, 18.589789141294769],
              [83.0640880395366, 18.585744057584801],
              [83.060042955826617, 18.576940051863172],
              [83.060042955826617, 18.565994531236466],
              [83.063374201234907, 18.556000795011922],
              [83.07148000000096, 18.542491000001057],
              [83.076964047515872, 18.541986654998134],
              [83.087051000000926, 18.541059000000867],
              [83.089332000000269, 18.537910000000235],
              [83.088510000000142, 18.532761000000161],
              [83.082306000000159, 18.527170000000122],
              [83.073157, 18.514740000000184],
              [83.068818, 18.502029],
              [83.065116, 18.497560000000131],
              [83.060355, 18.494421],
              [83.055175000000105, 18.488122],
              [83.051795, 18.47749],
              [83.043845, 18.472111000000151],
              [83.042639764621327, 18.470525907190957],
              [83.041474332168747, 18.468993162108116],
              [83.038820808958718, 18.465503320510887],
              [83.037017000000148, 18.4631310000002],
              [83.035270284687712, 18.461692564404469],
              [83.037438076271243, 18.452256295157607],
              [83.040769321679505, 18.442500505033756],
              [83.047907704696996, 18.436789798619706],
              [83.055521979915653, 18.436313906418714],
              [83.057901440921484, 18.434886229815103],
              [83.056235818217417, 18.431792930507523],
              [83.05242868060796, 18.427985792898308],
              [83.048986103991624, 18.425044103605952],
              [83.048561000000888, 18.424860000000873],
              [83.047842525401947, 18.424066913185126],
              [83.045930060773316, 18.421955842752308],
              [83.048621542998688, 18.419181787176679],
              [83.053380465010363, 18.416802326170849],
              [83.057425548720317, 18.414660811265545],
              [83.060522362046612, 18.415632597846521],
              [83.066705446642956, 18.417278218372072],
              [83.073843829660447, 18.419419733277206],
              [83.080268374376189, 18.422513032584728],
              [83.081933997080313, 18.417992056673764],
              [83.082647835382005, 18.413471080762626],
              [83.087644703494377, 18.41037778145505],
              [83.091451841103634, 18.406332697745139],
              [83.092641571606563, 18.402049667934644],
              [83.08931032619833, 18.40062199133126],
              [83.081220158778621, 18.399670206928814],
              [83.076699182867443, 18.39752869202351],
              [83.072938765238959, 18.393147876055416],
              [83.070380680681112, 18.394000570908073],
              [83.065825000000572, 18.39315900000053],
              [83.066498000000522, 18.392259000000532],
              [83.065825, 18.389401000000131],
              [83.063876497943838, 18.386943665060297],
              [83.062078291668541, 18.384675874223259],
              [83.059291965927954, 18.38116192586784],
              [83.059052383562104, 18.380859778833148],
              [83.05804803331749, 18.379593152021354],
              [83.056198, 18.37726],
              [83.05339, 18.3753],
              [83.039520000000124, 18.370081000000138],
              [83.036981000000182, 18.369842],
              [83.031882, 18.37326],
              [83.023757, 18.376449000000147],
              [83.020051, 18.38348000000013],
              [83.017182, 18.384501],
              [83.011611, 18.378211],
              [83.003486000000109, 18.376921],
              [82.997116000000105, 18.374860000000123],
              [82.992866000000149, 18.374821000000107],
              [82.991965, 18.374999],
              [82.987617, 18.369502000000178],
              [82.986108, 18.365901000000115],
              [82.981208000000123, 18.365819],
              [82.97843200000014, 18.360989000000128],
              [82.976449, 18.354911000000126],
              [82.96878, 18.357580000000148],
              [82.959793, 18.3572400000001],
              [82.955971000000133, 18.355811000000127],
              [82.95204900000013, 18.35435],
              [82.948165000000174, 18.352060000000105],
              [82.945503, 18.350469],
              [82.932685, 18.35136900000014],
              [82.92761200000011, 18.360989000000128],
              [82.920059, 18.359740000000155],
              [82.915131, 18.35639900000012],
              [82.911667000000122, 18.357379000000204],
              [82.908387000000161, 18.35943],
              [82.902749000000114, 18.355911000000102],
              [82.898521, 18.359301],
              [82.891861, 18.366881000000198],
              [82.884903, 18.378621],
              [82.890954000000121, 18.392220000000115],
              [82.890779, 18.3986],
              [82.888358, 18.40626],
              [82.884613, 18.412760000000159],
              [82.879356, 18.41464000000013],
              [82.877067, 18.411830000000119],
              [82.870011000000119, 18.406201000000177],
              [82.86296900000012, 18.407921000000151],
              [82.855981000000142, 18.410800000000162],
              [82.848633, 18.415009000000108],
              [82.844909, 18.409772000000199],
              [82.839783000000168, 18.411771000000211],
              [82.836982, 18.414271000000149],
              [82.836341000000104, 18.419540000000151],
              [82.835769, 18.424231000000184],
              [82.830147, 18.426120000000136],
              [82.824173, 18.429920000000148],
              [82.818749000000125, 18.433370000000135],
              [82.818359000000129, 18.43853],
              [82.799171, 18.439401000000199],
              [82.791978000000185, 18.433140000000144],
              [82.78711, 18.426740000000105],
              [82.776222000000175, 18.419691],
              [82.776206000000101, 18.41552],
              [82.7784580000001, 18.409480000000197],
              [82.781608000000162, 18.404252000000209],
              [82.781182, 18.39945],
              [82.787392000000168, 18.399821000000198],
              [82.793298000000149, 18.394969],
              [82.787484, 18.39021],
              [82.786759000000174, 18.384581],
              [82.787613000000107, 18.378160000000147],
              [82.780968000000115, 18.372520000000119],
              [82.777909000000108, 18.37092],
              [82.784218000000109, 18.35415],
              [82.771438000000131, 18.339679000000157],
              [82.767051, 18.33108],
              [82.761848000000143, 18.32781],
              [82.7585, 18.327181],
              [82.754463, 18.32982],
              [82.751038, 18.328332],
              [82.750648000000169, 18.323299],
              [82.74643, 18.319851000000195],
              [82.737817000000106, 18.319901],
              [82.732803, 18.3179],
              [82.73433, 18.313251000000147],
              [82.725311, 18.311571],
              [82.717263, 18.314821],
              [82.710907, 18.31282],
              [82.706704000000101, 18.310632],
              [82.702554, 18.308469000000112],
              [82.70169, 18.30484100000012],
              [82.700500000000133, 18.299790000000197],
              [82.698098000000158, 18.296271000000157],
              [82.69374, 18.297331],
              [82.690322, 18.297069000000132],
              [82.681777000000153, 18.292779],
              [82.6754, 18.292369],
              [82.672576, 18.292201000000201],
              [82.66493900000016, 18.290621000000211],
              [82.65883500000011, 18.286610000000163],
              [82.656486000000129, 18.278801],
              [82.652228, 18.272140000000203],
              [82.649108000000169, 18.263839],
              [82.64486, 18.257079000000143],
              [82.647583, 18.244731],
              [82.645309, 18.24045],
              [82.63717, 18.234930000000187],
              [82.631652, 18.228531],
              [82.62886700000017, 18.228661],
              [82.626877, 18.228740000000126],
              [82.620391, 18.236371],
              [82.616409, 18.238121],
              [82.613419000000121, 18.23942900000014],
              [82.611031, 18.243842000000196],
              [82.611817, 18.246511],
              [82.609481, 18.249250000000185],
              [82.600770000000168, 18.252019000000182],
              [82.598267000000178, 18.254472],
              [82.589203, 18.25673],
              [82.588668000000141, 18.262120000000149],
              [82.58725, 18.265779],
              [82.585472, 18.266120000000168],
              [82.583184, 18.266551000000103],
              [82.580741, 18.270100000000124],
              [82.584283, 18.273220000000205],
              [82.588463, 18.27505],
              [82.588401, 18.278339],
              [82.587227000000141, 18.27944],
              [82.585586, 18.28096],
              [82.587578, 18.284780000000122],
              [82.590318, 18.287781],
              [82.590949, 18.291959],
              [82.587838, 18.302040000000201],
              [82.582703, 18.3008],
              [82.581078, 18.300939000000195],
              [82.579781, 18.301041000000108],
              [82.576438, 18.306810000000151],
              [82.57805600000016, 18.309351],
              [82.583253000000113, 18.311411000000188],
              [82.58596, 18.315901],
              [82.588638000000159, 18.318479000000192],
              [82.589668000000103, 18.319482],
              [82.592294000000138, 18.317921],
              [82.595687, 18.315901],
              [82.602142000000171, 18.31726],
              [82.603829000000104, 18.320371],
              [82.600319000000113, 18.330761000000162],
              [82.597579, 18.333619],
              [82.596513000000158, 18.340869],
              [82.597832, 18.341640000000204],
              [82.599152, 18.342421000000169],
              [82.607879000000182, 18.34167100000013],
              [82.611281000000105, 18.34646],
              [82.608658000000148, 18.351230000000211],
              [82.605668, 18.352810000000201],
              [82.598580000000112, 18.354011],
              [82.597618000000111, 18.356219000000173],
              [82.599311, 18.359971],
              [82.597686, 18.362592],
              [82.600875000000116, 18.366051],
              [82.600510000000142, 18.368709],
              [82.599022, 18.371619000000177],
              [82.593643, 18.370491000000126],
              [82.589171000000178, 18.377139],
              [82.580802000000148, 18.378851000000108],
              [82.577331, 18.377322],
              [82.57556, 18.379870000000206],
              [82.570603, 18.384189000000159],
              [82.565215000000123, 18.383990000000203],
              [82.556031000000175, 18.388510000000107],
              [82.551728000000125, 18.38708100000019],
              [82.549446000000131, 18.383510000000111],
              [82.542342000000104, 18.38905],
              [82.535156000000114, 18.389561],
              [82.532302, 18.393449000000199],
              [82.532601, 18.39682],
              [82.54032000000015, 18.40187],
              [82.540573000000151, 18.403431000000122],
              [82.539689000000166, 18.403621000000211],
              [82.53697900000013, 18.40420000000017],
              [82.535913, 18.408320000000167],
              [82.53763600000012, 18.412229000000135],
              [82.539680000000132, 18.41686900000013],
              [82.545120000000153, 18.41725],
              [82.546059, 18.424142],
              [82.550216, 18.426501],
              [82.551071000000135, 18.433901],
              [82.553772000000123, 18.43765],
              [82.55011800000014, 18.438890000000182],
              [82.54773, 18.441789],
              [82.544213, 18.441299000000182],
              [82.538360000000168, 18.443180000000208],
              [82.539010000000118, 18.43809],
              [82.535607000000127, 18.436652],
              [82.533082000000135, 18.434061],
              [82.530151, 18.434311000000204],
              [82.528793000000164, 18.44034],
              [82.529381000000143, 18.44294],
              [82.526703, 18.447309],
              [82.523163, 18.445771000000203],
              [82.521203000000114, 18.447111],
              [82.52044, 18.450532000000116],
              [82.523193, 18.452779],
              [82.516137000000171, 18.4558810000002],
              [82.516761, 18.457210000000199],
              [82.517746, 18.459289000000123],
              [82.521766000000113, 18.461759000000196],
              [82.527512, 18.46822],
              [82.525727000000117, 18.470541],
              [82.521012, 18.472371000000173],
              [82.527528000000103, 18.47772],
              [82.524483, 18.482850000000152],
              [82.51951600000011, 18.482511],
              [82.51979, 18.48489],
              [82.520057, 18.48726],
              [82.524499000000148, 18.489781],
              [82.523216, 18.493512],
              [82.522026000000139, 18.496990000000206],
              [82.523904000000101, 18.49929],
              [82.523131, 18.503930000000135],
              [82.517518, 18.505639000000141],
              [82.514268, 18.503640000000129],
              [82.507407, 18.508080000000117],
              [82.50418, 18.505491000000173],
              [82.502022, 18.501731],
              [82.499152, 18.501751000000123],
              [82.498811, 18.503271000000151],
              [82.498207, 18.50604],
              [82.481453, 18.515061],
              [82.475739, 18.529408],
              [82.477836000000124, 18.53153],
              [82.481918, 18.532711000000116],
              [82.485320000000101, 18.5337],
              [82.481612, 18.538459000000156],
              [82.474007, 18.536832000000171],
              [82.453422, 18.517021],
              [82.449937000000119, 18.511421000000151],
              [82.440832778911826, 18.501387240141806],
              [82.439930612311898, 18.500392962550162],
              [82.439248293598197, 18.499640979260842],
              [82.437126, 18.497302000000101],
              [82.433882101210699, 18.492364078710974],
              [82.429137000000409, 18.485141000000393],
              [82.42876316985614, 18.483795871667208],
              [82.404869929167631, 18.46530504732527],
              [82.402371495111524, 18.46244969411827],
              [82.395946950395782, 18.466732723928711],
              [82.388808567378291, 18.472086511191829],
              [82.387023971623918, 18.47922489420932],
              [82.381085860016512, 18.491785817290005],
              [82.377387154550291, 18.492073983640861],
              [82.376316397097682, 18.495286255998675],
              [82.377744073701066, 18.502067719865405],
              [82.378706399010454, 18.509036909582274],
              [82.378111533758982, 18.516770157851219],
              [82.381788905820301, 18.520141082240624],
              [82.392020839736048, 18.516344485900383],
              [82.394519273792156, 18.515273728447706],
              [82.396175065391418, 18.519893901682504],
              [82.397047989203983, 18.522329630451733],
              [82.398392853511197, 18.528642988138696],
              [82.402152, 18.546290000000109],
              [82.405854, 18.54992100000015],
              [82.407982400364659, 18.554975580838281],
              [82.395957491302724, 18.567333704225117],
              [82.387629377782318, 18.572687491488235],
              [82.386785397452272, 18.573953461983248],
              [82.380490994765054, 18.583395066014468],
              [82.38411063833442, 18.585154907880675],
              [82.39638318491339, 18.585606630011849],
              [82.40233183742798, 18.587391225766222],
              [82.405008731059567, 18.590662984649036],
              [82.402629270053737, 18.591852715151955],
              [82.399050764627006, 18.594637351396209],
              [82.394864295638101, 18.599443195760667],
              [82.390084324548383, 18.602629843153913],
              [82.388439750922302, 18.603726225571105],
              [82.382372125357492, 18.604796983023785],
              [82.375590661490918, 18.605510821325478],
              [82.369490097333454, 18.609385851944008],
              [82.368195384532484, 18.610208243384474],
              [82.363646000000116, 18.61349],
              [82.357367000000153, 18.615829000000126],
              [82.350731000000152, 18.61483],
              [82.329842, 18.592980000000178],
              [82.322296, 18.59221],
              [82.317947000000103, 18.587709000000185],
              [82.310868, 18.574599],
              [82.306809, 18.570729000000139],
              [82.304657000300409, 18.57064714985216],
              [82.298974, 18.570431000000209],
              [82.29251, 18.571561],
              [82.277974044671936, 18.570383742691714],
              [82.273691014861456, 18.570383742691714],
              [82.275118691465067, 18.575618556904427],
              [82.276504937560603, 18.578391049095099],
              [82.277331369386488, 18.580043912747268],
              [82.277974044671936, 18.581329263318477],
              [82.276546368068509, 18.584660508726696],
              [82.269883877252227, 18.5865640775313],
              [82.265600847441746, 18.586088185330137],
              [82.261317817631124, 18.586088185330137],
              [82.256558895619477, 18.588943538537134],
              [82.253227650211414, 18.591798891744187],
              [82.252751758010206, 18.594178352750017],
              [82.248885, 18.595239],
              [82.246116000000299, 18.594911],
              [82.246808087019801, 18.600638992118771],
              [82.247132534518343, 18.603324250854651],
              [82.247451000000282, 18.605960000000376],
              [82.241356722396603, 18.603162835634063],
              [82.237999099773987, 18.606075657779169],
              [82.238474991975224, 18.611310471991882],
              [82.233802000000182, 18.613791],
              [82.230041000000185, 18.614320000000188],
              [82.226232864120149, 18.616623192624893],
              [82.224717000000211, 18.617540000000126],
              [82.223443293861436, 18.622916174027349],
              [82.217059842922737, 18.62606313022803],
              [82.216108058520362, 18.63082205223969],
              [82.218487519526192, 18.637484543056015],
              [82.216583950721528, 18.645574710475895],
              [82.216108058520362, 18.656520231102657],
              [82.213814137610413, 18.65957879231598],
              [82.210397352106483, 18.664134506321314],
              [82.208017891100653, 18.666989859528368],
              [82.204686645692362, 18.665086290723703],
              [82.198500047077331, 18.659375584309654],
              [82.192313448462059, 18.653664877895775],
              [82.179940251231855, 18.649857740286333],
              [82.172325976013198, 18.643195249470065],
              [82.17042240720852, 18.637484543056015],
              [82.161379338037008, 18.637007368285023],
              [82.152814395765333, 18.640815788464231],
              [82.149941434237789, 18.658053557630236],
              [82.149007258156061, 18.663658614120148],
              [82.146151904949051, 18.666989859528368],
              [82.143296551742012, 18.662706829717873],
              [82.13517, 18.66336],
              [82.131737000000257, 18.666619000000193],
              [82.12725, 18.66884100000021],
              [82.124260863695355, 18.673652350344636],
              [82.125212648097758, 18.678411272356293],
              [82.129971570109419, 18.683170194367957],
              [82.131148726848991, 18.696099657349119],
              [82.130923354511637, 18.703157666816985],
              [82.119179, 18.70038900000014],
              [82.122115000000107, 18.704090000000114],
              [82.12265700000016, 18.70895],
              [82.122108, 18.715851000000153],
              [82.108627000000169, 18.719842000000138],
              [82.102936, 18.719290000000111],
              [82.096527, 18.723431],
              [82.084899000000163, 18.732691],
              [82.086745000000107, 18.746931],
              [82.081414, 18.755870000000183],
              [82.084710000000129, 18.758400000000105],
              [82.091294000000104, 18.75618],
              [82.105728000000155, 18.758450000000149],
              [82.113921000000161, 18.760661000000137],
              [82.129066, 18.75765],
              [82.128166000000178, 18.764321000000102],
              [82.130662000000129, 18.770099000000126],
              [82.138976, 18.76954],
              [82.145478000000125, 18.77328],
              [82.150016, 18.778700000000182],
              [82.151703, 18.78380100000015],
              [82.159217, 18.788111],
              [82.161147000000184, 18.79096],
              [82.158912, 18.795071],
              [82.154296, 18.796302000000136],
              [82.156113, 18.79994],
              [82.16101100000013, 18.803570000000203],
              [82.161843, 18.804960000000101],
              [82.158677000000111, 18.8092],
              [82.158310000000114, 18.811470000000153],
              [82.164940000000158, 18.830209],
              [82.161751, 18.837860000000145],
              [82.162422, 18.84510100000011],
              [82.15802700000016, 18.85197],
              [82.161261, 18.857741],
              [82.162795000000102, 18.865510000000196],
              [82.158203000000171, 18.869460000000171],
              [82.163110000000117, 18.871931000000128],
              [82.17041000000016, 18.877571000000156],
              [82.170768000000109, 18.891590000000118],
              [82.17273, 18.895289000000101],
              [82.177147000000133, 18.896901],
              [82.185386, 18.896981000000149],
              [82.198737, 18.905541000000138],
              [82.213784000000118, 18.912139000000192],
              [82.224861, 18.909249],
              [82.227675, 18.906690000000193],
              [82.231217000000171, 18.90522],
              [82.234292, 18.905270000000137],
              [82.239563, 18.910459000000113],
              [82.226661000000135, 18.993981000000186],
              [82.225068000000121, 19.014591000000163],
              [82.222481000000101, 19.021111000000129],
              [82.194092000000111, 19.060221000000123],
              [82.196830000000134, 19.06787],
              [82.208558, 19.078521000000134],
              [82.211227000000164, 19.085759],
              [82.212113, 19.090550000000118],
              [82.210586, 19.09225],
              [82.199868000000137, 19.092179],
              [82.198532, 19.094169],
              [82.199485, 19.099821000000187],
              [82.1969, 19.101150000000182],
              [82.201500000000166, 19.115762000000185],
              [82.215951266211604, 19.10744160928618],
              [82.222375810927403, 19.113152315700059],
              [82.230941870548335, 19.114579992303671],
              [82.222375810927403, 19.126715243433345],
              [82.225231164134399, 19.137422817959585],
              [82.240935606772808, 19.136708979657836],
              [82.252357019600808, 19.131712111545479],
              [82.254498534506112, 19.131712111545479],
              [82.259495402618285, 19.140992009468331],
              [82.273058330351532, 19.148130392485822],
              [82.276270602709346, 19.144561200977076],
              [82.279482875067316, 19.148130392485822],
              [82.285907419783072, 19.145275039278769],
              [82.290547368744328, 19.145275039278769],
              [82.290904287895245, 19.154198018050629],
              [82.294473479404004, 19.158837967012058],
              [82.298756509214499, 19.164905592576869],
              [82.305894892231976, 19.167047107482173],
              [82.322313173172262, 19.166690188331238],
              [82.328023879586326, 19.15955180531375],
              [82.336946858358019, 19.158124128710305],
              [82.343014483922985, 19.162050239369815],
              [82.347654432884255, 19.171330137292667],
              [82.350152866940476, 19.175970086254036],
              [82.356577411656289, 19.169545541538294],
              [82.363358875522849, 19.169902460689226],
              [82.367998824484218, 19.161693320219054],
              [82.378706399010454, 19.167047107482173],
              [82.384060186273402, 19.160979481917362],
              [82.397980033157623, 19.154198018050629],
              [82.403690739571658, 19.157410290408617],
              [82.406903011929487, 19.161693320219054],
              [82.404757048287181, 19.178247896889612],
              [82.406670000000105, 19.178552000000135],
              [82.410271000000179, 19.173549],
              [82.413879, 19.170930000000109],
              [82.424652, 19.16521],
              [82.428299, 19.164380000000104],
              [82.433648000000105, 19.165711],
              [82.439339, 19.170449],
              [82.447906000000145, 19.169629],
              [82.450545, 19.172230000000177],
              [82.45217000000018, 19.17596],
              [82.454361, 19.176731000000128],
              [82.458107, 19.175721],
              [82.459794, 19.173371],
              [82.462670000000102, 19.17129],
              [82.466736, 19.170570000000161],
              [82.471046, 19.17307100000016],
              [82.476997, 19.172710000000105],
              [82.481858, 19.173770000000101],
              [82.48623, 19.17599],
              [82.493988, 19.18172],
              [82.509133, 19.196042],
              [82.512558000000169, 19.196081000000103],
              [82.515054, 19.195101000000189],
              [82.516617, 19.193100000000182],
              [82.519332000000176, 19.191999],
              [82.522149, 19.196568],
              [82.524392, 19.197731000000196],
              [82.526946, 19.196872000000209],
              [82.532592, 19.191541000000139],
              [82.536264000000116, 19.189952000000112],
              [82.542657000000105, 19.1891700000001],
              [82.545273000000165, 19.19057],
              [82.540918, 19.19923],
              [82.543541, 19.19905000000011],
              [82.551627, 19.195231000000145],
              [82.559730000000144, 19.193202],
              [82.564377, 19.1942],
              [82.565819, 19.19683],
              [82.565712, 19.20499],
              [82.568962, 19.203821000000115],
              [82.569892, 19.194020000000133],
              [82.570779, 19.19134],
              [82.574020000000161, 19.189002],
              [82.577042000000105, 19.18987],
              [82.581771, 19.195030000000198],
              [82.583923000000127, 19.19371],
              [82.585167, 19.18587],
              [82.592437, 19.184031000000171],
              [82.595307, 19.18119100000018],
              [82.598297000000159, 19.175742000000181],
              [82.600982, 19.175220000000134],
              [82.605928, 19.176902000000208],
              [82.608391, 19.176040000000111],
              [82.609529000000109, 19.168711000000197],
              [82.609169000000151, 19.155941000000151],
              [82.610206000000161, 19.151291000000182],
              [82.612815, 19.147701000000151],
              [82.613419820687952, 19.147163989456935],
              [82.616197359367362, 19.144697857617015],
              [82.617569000000259, 19.143480000000292],
              [82.618904126523006, 19.143661557236211],
              [82.618345658387838, 19.151183156774604],
              [82.619107085909761, 19.153467439340201],
              [82.622152795997266, 19.152896368698801],
              [82.623485294160432, 19.153277082459734],
              [82.627673145530679, 19.150421729252681],
              [82.628815286813548, 19.146995305404399],
              [82.628434573052601, 19.145662807241017],
              [82.627983881745919, 19.142314814675895],
              [82.629385859182989, 19.141706867328875],
              [82.629517000000277, 19.141650000000251],
              [82.629651255722735, 19.14167838243031],
              [82.63227, 19.142232],
              [82.634811000000113, 19.144830000000123],
              [82.63536, 19.152629],
              [82.631340000000179, 19.165520000000125],
              [82.631493, 19.168701],
              [82.636810000000125, 19.170951],
              [82.647057000000103, 19.180972000000164],
              [82.65445, 19.179532],
              [82.65915, 19.17757],
              [82.661552, 19.177802],
              [82.671647, 19.18921100000011],
              [82.673730000000134, 19.187892],
              [82.675491000000179, 19.180972000000164],
              [82.678947, 19.180081000000193],
              [82.682258000000132, 19.18087],
              [82.685645, 19.183051],
              [82.688722000000141, 19.183322],
              [82.696298000000112, 19.18154],
              [82.699356000000179, 19.17927],
              [82.700204000000127, 19.171420000000122],
              [82.704787, 19.170630000000127],
              [82.715973000000176, 19.166630000000108],
              [82.718086000000184, 19.16472],
              [82.715522000000121, 19.163161000000166],
              [82.715951000000103, 19.160551],
              [82.718642, 19.157600000000112],
              [82.715752000000165, 19.152909000000133],
              [82.723793, 19.15285],
              [82.728759, 19.150530000000114],
              [82.730549414956428, 19.151418736941761],
              [82.733878000000161, 19.153071000000178],
              [82.736459170358998, 19.158338047946241],
              [82.745382149130862, 19.162799537332198],
              [82.748653908013893, 19.163394402583659],
              [82.75311539739981, 19.160420076326368],
              [82.756684588908556, 19.157743182694784],
              [82.757874319411471, 19.159230345823456],
              [82.758171752037228, 19.162204672080744],
              [82.759703511717561, 19.164502311601492],
              [82.76318237819774, 19.161781751760994],
              [82.766228000000154, 19.159400000000172],
              [82.773216000000147, 19.160499000000183],
              [82.778832000000122, 19.164490000000168],
              [82.780708000000104, 19.16407],
              [82.781731, 19.163842],
              [82.78504300000013, 19.160699000000186],
              [82.787796000000156, 19.156522000000106],
              [82.786957, 19.153700000000182],
              [82.784683000000186, 19.151681000000103],
              [82.784981000000158, 19.149178000000116],
              [82.791433385655282, 19.144414143324976],
              [82.793877000000109, 19.142610000000101],
              [82.802879000000118, 19.15275900000011],
              [82.804283000000424, 19.158742000000466],
              [82.80668359919045, 19.160633585083524],
              [82.808201550574935, 19.161829675712735],
              [82.808140433159664, 19.155958586940411],
              [82.806653270030992, 19.150009934425835],
              [82.807545567908193, 19.144061281911259],
              [82.80962759628828, 19.139004927273898],
              [82.814386518299926, 19.142276686156887],
              [82.81614819606078, 19.145408557731621],
              [82.817063411931514, 19.147035608168544],
              [82.814981383551398, 19.154768856437496],
              [82.814683950925698, 19.161907239454987],
              [82.816468546680071, 19.166071296215186],
              [82.820251000000198, 19.169139000000254],
              [82.820549000000184, 19.171500000000204],
              [82.820793000000123, 19.17336],
              [82.827241000000171, 19.172211],
              [82.829208, 19.175240000000198],
              [82.829536000000175, 19.178762000000116],
              [82.828376000000148, 19.182502000000106],
              [82.82949700000016, 19.183860000000205],
              [82.832779000000116, 19.185581000000123],
              [82.834664, 19.192801000000141],
              [82.834762, 19.193220000000164],
              [82.845529, 19.18742],
              [82.848266, 19.188261],
              [82.848503, 19.18832900000012],
              [82.848770000000158, 19.196662],
              [82.855653000000174, 19.19923],
              [82.864616000000169, 19.192751],
              [82.865289, 19.190800000000134],
              [82.864892, 19.187051000000107],
              [82.867363, 19.184690000000156],
              [82.871002, 19.177111000000131],
              [82.876557000000147, 19.178381],
              [82.879173, 19.174971000000138],
              [82.886726, 19.170691],
              [82.88903700000013, 19.166860000000153],
              [82.891442, 19.167712000000101],
              [82.891806, 19.16056900000012],
              [82.897117, 19.155141],
              [82.896798000000132, 19.151669000000194],
              [82.90219, 19.153119],
              [82.902297, 19.153151],
              [82.903412000000102, 19.153010000000105],
              [82.905983, 19.152711],
              [82.908410000000103, 19.15324900000018],
              [82.911026000000135, 19.155501000000182],
              [82.915801, 19.156690000000136],
              [82.923926, 19.153240000000149],
              [82.926789, 19.154270000000107],
              [82.932480000000155, 19.154751],
              [82.935769000000136, 19.153830000000138],
              [82.939377, 19.152130000000167],
              [82.942704, 19.147729000000137],
              [82.960602000000151, 19.154161000000155],
              [82.964837, 19.15752],
              [82.969208, 19.164859000000146],
              [82.971733, 19.16655],
              [82.974548000000112, 19.164239000000173],
              [82.973023, 19.1544],
              [82.972946, 19.14565900000013],
              [82.976196, 19.12604100000015],
              [82.978676000000107, 19.126859000000135],
              [82.981010000000126, 19.1247],
              [82.982331000000144, 19.122239000000146],
              [82.992127000000139, 19.11774],
              [82.998864000000125, 19.111762000000166],
              [82.999619, 19.110620000000146],
              [83.001633, 19.107561000000199],
              [83.002319, 19.1030510000001],
              [83.002404000000112, 19.09099],
              [83.006782000000129, 19.08707000000015],
              [83.012307, 19.085171],
              [83.017891, 19.08325],
              [83.020783, 19.078689000000164],
              [83.022957000000176, 19.073151],
              [83.022658000000135, 19.071690000000153],
              [83.0224240000001, 19.0705],
              [83.015687000000113, 19.06617000000011],
              [83.013496, 19.062311],
              [83.013574000000105, 19.059950000000121],
              [83.015213000000173, 19.05688],
              [83.020783, 19.051581],
              [83.023942000000119, 19.049790000000197],
              [83.033081, 19.047292000000134],
              [83.036591, 19.047012],
              [83.040306000000129, 19.046711000000183],
              [83.04596, 19.043992000000109],
              [83.05584, 19.036769],
              [83.060989000000163, 19.03924],
              [83.063172000000108, 19.04195],
              [83.065406, 19.050961],
              [83.062393000000142, 19.05735900000013],
              [83.065529, 19.062152],
              [83.068321000000182, 19.073570000000128],
              [83.079033, 19.07934100000011],
              [83.082627000000102, 19.083152000000148],
              [83.08461, 19.085461],
              [83.092553000000166, 19.101440000000192],
              [83.096496000000101, 19.1045],
              [83.10205, 19.102529],
              [83.105475000000112, 19.095359],
              [83.111381000000137, 19.085600000000166],
              [83.113243000000168, 19.08387],
              [83.119086, 19.08374],
              [83.122970000000109, 19.086231000000165],
              [83.125199000000165, 19.090780000000162],
              [83.126480000000115, 19.105449],
              [83.12814400000012, 19.114100000000175],
              [83.12818900000012, 19.122640000000153],
              [83.1297, 19.129391],
              [83.135147000000103, 19.129040000000138],
              [83.140029000000126, 19.127251000000111],
              [83.145363, 19.118811],
              [83.148795000000106, 19.116792000000142],
              [83.153159, 19.115910000000152],
              [83.155616000000151, 19.118219],
              [83.159249, 19.125781000000128],
              [83.163367056173541, 19.131303944606653],
              [83.163639224960804, 19.131668964672595],
              [83.164833000000144, 19.133270000000206],
              [83.168409927113757, 19.135251087415888],
              [83.171045178120693, 19.136710625852341],
              [83.17512715464531, 19.136578420574491],
              [83.179501637939467, 19.139395474287646],
              [83.183250027064432, 19.140902788717703],
              [83.18401400000019, 19.141210000000225],
              [83.184152232561459, 19.141232820622058],
              [83.185833995530487, 19.141510460539159],
              [83.18813300000015, 19.14189],
              [83.190153676787787, 19.141703835795958],
              [83.190293000000153, 19.141691],
              [83.19304, 19.141420000000206],
              [83.196807, 19.14217],
              [83.198127000000142, 19.144661000000152],
              [83.197311000000113, 19.147309],
              [83.191627, 19.15684100000021],
              [83.194389000000143, 19.159669],
              [83.19875400000015, 19.159140000000146],
              [83.213012, 19.154320000000151],
              [83.214997000000139, 19.155362],
              [83.216294000000161, 19.156050000000103],
              [83.219512, 19.16043000000013],
              [83.223877000000172, 19.163530000000147],
              [83.22818, 19.162719000000205],
              [83.237068000000164, 19.157221],
              [83.241927, 19.155309],
              [83.252113000000165, 19.156731000000146],
              [83.251381000000137, 19.153910000000163],
              [83.250602000000171, 19.15089],
              [83.248238000000157, 19.147332000000173],
              [83.244186000000113, 19.141969000000184],
              [83.235940000000127, 19.13443],
              [83.234864, 19.129922000000132],
              [83.237121000000144, 19.121320000000136],
              [83.236321, 19.119],
              [83.226616000000135, 19.11552],
              [83.221062000000103, 19.115231000000104],
              [83.217812000000137, 19.116960000000173],
              [83.216086000000161, 19.121022000000202],
              [83.215829, 19.12800100000015],
              [83.212128, 19.127841],
              [83.199914, 19.122930000000164],
              [83.197792000000149, 19.120060000000187],
              [83.197541000000157, 19.115051000000161],
              [83.190872000000113, 19.11002],
              [83.188399000000103, 19.106059],
              [83.185227, 19.103691],
              [83.178375571967791, 19.095260939913825],
              [83.177749000000389, 19.094490000000345],
              [83.175865892119177, 19.092167053516782],
              [83.173635989352405, 19.089416311064664],
              [83.176269295928009, 19.088418129816429],
              [83.179886076656985, 19.088989200457885],
              [83.181366000000111, 19.085461000000233],
              [83.177411437210921, 19.08004242707602],
              [83.177411437210921, 19.074141363781447],
              [83.179505362895995, 19.072428151857302],
              [83.184545373869057, 19.071234909111293],
              [83.1859661694359, 19.069028129322131],
              [83.185459586859153, 19.066747325854461],
              [83.183224015559844, 19.056682039351696],
              [83.183341878747896, 19.050515840805243],
              [83.183372000000219, 19.04894000000024],
              [83.185440520289305, 19.045110500867846],
              [83.183693214266256, 19.040257839058366],
              [83.183122143624786, 19.032833920720343],
              [83.183794093523019, 19.03054929106656],
              [83.185977496831839, 19.023125719816555],
              [83.189213563799825, 19.020270366609505],
              [83.192639987648107, 19.015130730836912],
              [83.192830344528588, 19.009991095064262],
              [83.19549534085516, 19.001044321682397],
              [83.194175576910808, 18.995618625466697],
              [83.193782128930977, 18.994001117105139],
              [83.193220923932799, 18.99234422615876],
              [83.189784634441068, 18.982198990516221],
              [83.189509031585004, 18.979259226717083],
              [83.189213563799825, 18.976107570341238],
              [83.191688203245889, 18.975726856580419],
              [83.192865151091354, 18.973542769526997],
              [83.195893900501375, 18.972924640397931],
              [83.206662944509262, 18.970726815853361],
              [83.221130067424696, 18.970536458972898],
              [83.224937205033967, 18.972440027777505],
              [83.22588898943637, 18.980244659876686],
              [83.231800603045471, 19.002650785106194],
              [83.235812314738084, 19.017855925447343],
              [83.239785041710363, 19.023455671742621],
              [83.253325721050814, 19.030012211212689],
              [83.255376050824722, 19.034227478185862],
              [83.257160854723892, 19.037896851291517],
              [83.259162, 19.042011000000169],
              [83.261045762739954, 19.047453855181114],
              [83.264150722410108, 19.051247776290662],
              [83.264150722410108, 19.057148839585178],
              [83.261676082964058, 19.060004192792231],
              [83.259962871039733, 19.061527047835906],
              [83.259201443517995, 19.064572757923425],
              [83.257868945354616, 19.066476326728033],
              [83.264531436170927, 19.079420594599636],
              [83.26548322057333, 19.087415583579283],
              [83.272336068270064, 19.102834490897177],
              [83.277557000000215, 19.1168990000001],
              [83.280902127891167, 19.119014825736766],
              [83.282044269173895, 19.115398045007847],
              [83.281092484771463, 19.109306624832978],
              [83.282936562412303, 19.107923566602548],
              [83.284736, 19.10886],
              [83.291603000000336, 19.113941000000349],
              [83.29211452098852, 19.112810753025936],
              [83.294776000000113, 19.106930000000201],
              [83.302819000000156, 19.108591000000157],
              [83.311623000000139, 19.105800000000155],
              [83.316223, 19.102730000000175],
              [83.320801000000117, 19.093371],
              [83.324334, 19.093020000000191],
              [83.329056000000136, 19.09398],
              [83.333314, 19.0938],
              [83.333259, 19.07718],
              [83.337692, 19.071211000000115],
              [83.338371, 19.067740000000182],
              [83.338212, 19.063811000000154],
              [83.335427, 19.053252000000153],
              [83.336135, 19.04994],
              [83.336769000000103, 19.046989000000103],
              [83.338768000000115, 19.04362],
              [83.345414, 19.043720000000175],
              [83.352912000000103, 19.042891000000104],
              [83.355827, 19.041781000000125],
              [83.35649, 19.0384810000001],
              [83.354569, 19.033911000000153],
              [83.345778000000152, 19.026650000000128],
              [83.342797, 19.021271],
              [83.341218000000126, 19.01591],
              [83.340912, 19.009162],
              [83.334975000000142, 19.006719],
              [83.332710000000162, 18.99984],
              [83.330672, 18.998429000000151],
              [83.3301, 18.996959],
              [83.33028863443397, 18.995698853074199],
              [83.330650950471551, 18.993278449589976],
              [83.330757000000219, 18.992570000000338],
              [83.330789228690122, 18.992391349030235],
              [83.330933457948191, 18.991591851729307],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Malkangiri",
          Dist_Code: "399",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [82.001685000000492, 18.023661000000509],
              [81.996694301060685, 18.022760933704312],
              [81.994053578953057, 18.022284682783489],
              [81.991477, 18.02182],
              [81.988861, 18.020341],
              [81.985877000000116, 18.014271000000175],
              [81.980462, 18.011281],
              [81.973053, 18.005670000000119],
              [81.964043000000103, 17.999869000000157],
              [81.957131, 17.997071],
              [81.951768, 17.9921],
              [81.936096, 17.984091],
              [81.924712000000156, 17.98088000000018],
              [81.913697, 17.979891],
              [81.904549, 17.97347],
              [81.899277, 17.96855000000016],
              [81.885078000000163, 17.96584],
              [81.874138, 17.959841000000207],
              [81.846816000000132, 17.950800000000182],
              [81.839698, 17.950070000000206],
              [81.833335000000119, 17.95103],
              [81.81980100000014, 17.945462000000131],
              [81.801042000000137, 17.936081],
              [81.794052000000178, 17.92966100000012],
              [81.789322000000169, 17.921369],
              [81.78601100000013, 17.91361100000017],
              [81.782417, 17.909741],
              [81.77575, 17.904770000000152],
              [81.762221, 17.896590000000113],
              [81.758294, 17.893361000000137],
              [81.726318, 17.8741],
              [81.70317100000014, 17.861129],
              [81.699272000000164, 17.869731],
              [81.697877, 17.875540000000168],
              [81.688286000000105, 17.884800000000208],
              [81.683242, 17.879481000000109],
              [81.67775, 17.87758000000019],
              [81.668052, 17.878430000000204],
              [81.663063, 17.876931000000123],
              [81.656953, 17.872819000000103],
              [81.652702, 17.86819],
              [81.649062000000114, 17.862469],
              [81.646020000000121, 17.85627],
              [81.646140000000102, 17.846871],
              [81.642792, 17.839282],
              [81.636552000000151, 17.836280000000212],
              [81.63144, 17.830441],
              [81.623978000000179, 17.824422000000133],
              [81.6157, 17.82201],
              [81.611153, 17.81536200000016],
              [81.599739, 17.815442000000186],
              [81.593955, 17.819111000000188],
              [81.574867000000125, 17.8273410000001],
              [81.568741, 17.827881000000158],
              [81.564591, 17.825691000000173],
              [81.55394, 17.816369000000176],
              [81.525727000000174, 17.810872],
              [81.511307, 17.806560000000157],
              [81.496324, 17.806471],
              [81.48584, 17.802610000000183],
              [81.481179000000139, 17.802861000000174],
              [81.478706, 17.804709000000113],
              [81.474572000000109, 17.809999000000115],
              [81.472716, 17.81789],
              [81.470123, 17.823182],
              [81.466843, 17.824921],
              [81.459427, 17.824711],
              [81.43757, 17.815291000000112],
              [81.4338750000001, 17.815759000000124],
              [81.42592600000016, 17.821279000000168],
              [81.419419000000161, 17.820599000000179],
              [81.414336, 17.816431000000129],
              [81.414459000000122, 17.810111000000173],
              [81.409256, 17.804839],
              [81.402763000000135, 17.80532],
              [81.394309000000177, 17.808121000000195],
              [81.384972000000161, 17.806592000000133],
              [81.383103000000105, 17.814140000000119],
              [81.38304800000013, 17.816951000000184],
              [81.383003, 17.820579000000116],
              [81.383789, 17.823489],
              [81.384429, 17.825791],
              [81.393341, 17.835822000000118],
              [81.39737000000018, 17.843642],
              [81.398056, 17.84678000000013],
              [81.389877, 17.859431],
              [81.389548, 17.862100000000108],
              [81.390503, 17.874291000000191],
              [81.393829, 17.88514],
              [81.395850000000152, 17.887560000000114],
              [81.399018000000112, 17.888490000000157],
              [81.403763000000126, 17.888591000000186],
              [81.411667, 17.885391],
              [81.423127000000164, 17.877421000000194],
              [81.430206, 17.874679000000182],
              [81.434509000000148, 17.874900000000135],
              [81.435958000000127, 17.875449000000113],
              [81.437255000000135, 17.875939000000127],
              [81.440261000000163, 17.879141],
              [81.442748, 17.885161000000206],
              [81.443703000000184, 17.893231],
              [81.448273000000114, 17.903020000000136],
              [81.448181, 17.90508],
              [81.448067000000137, 17.907141],
              [81.446212000000145, 17.910281000000165],
              [81.445923, 17.91718],
              [81.444457, 17.922101],
              [81.445107, 17.925469],
              [81.44523700000012, 17.926171],
              [81.454795000000146, 17.946560000000201],
              [81.466957, 17.954900000000119],
              [81.473259, 17.96532],
              [81.475677, 17.967082000000172],
              [81.476440000000125, 17.96763100000015],
              [81.477311, 17.97002],
              [81.476883, 17.97265],
              [81.476668000000174, 17.973899],
              [81.473076000000148, 17.98328900000018],
              [81.47451, 17.988702],
              [81.477676, 17.993511],
              [81.478943000000115, 18.003701],
              [81.4775, 18.019992000000112],
              [81.47389200000012, 18.028511000000147],
              [81.477516000000122, 18.038722000000174],
              [81.481498, 18.049922000000148],
              [81.49466, 18.058001000000157],
              [81.494881, 18.062660000000161],
              [81.495164, 18.068690000000114],
              [81.496009000000114, 18.070700000000155],
              [81.49685, 18.072711],
              [81.508658, 18.092411],
              [81.510728, 18.10388000000011],
              [81.511879000000107, 18.129231000000171],
              [81.515801, 18.139931000000157],
              [81.521736, 18.14831],
              [81.522607, 18.157271],
              [81.514878, 18.17217],
              [81.508927000000114, 18.174071000000133],
              [81.505249, 18.177790000000183],
              [81.504777, 18.183812000000156],
              [81.508788000000123, 18.192511000000135],
              [81.511138000000102, 18.201940000000146],
              [81.522873000000104, 18.227371],
              [81.525772000000174, 18.236521000000206],
              [81.523682, 18.24866],
              [81.527963, 18.25908000000015],
              [81.539459000000178, 18.26210900000012],
              [81.548074000000142, 18.26213],
              [81.567597, 18.27321100000017],
              [81.574012, 18.281170000000198],
              [81.581787000000176, 18.288160000000168],
              [81.586242000000183, 18.292159],
              [81.590507000000102, 18.293331],
              [81.592034000000154, 18.29747900000012],
              [81.593406000000172, 18.301281],
              [81.59687, 18.302110000000138],
              [81.606116, 18.299419],
              [81.615882000000141, 18.300841],
              [81.621391000000173, 18.303722000000104],
              [81.627618, 18.30487],
              [81.632142, 18.308011],
              [81.646758, 18.3115],
              [81.658669, 18.311099000000123],
              [81.660378, 18.315760000000122],
              [81.652458, 18.324790000000117],
              [81.649377, 18.330579],
              [81.649169, 18.331001000000125],
              [81.652809, 18.336680000000168],
              [81.658097, 18.339290000000116],
              [81.680785000000171, 18.341031],
              [81.699242000000183, 18.34357],
              [81.717507, 18.343201],
              [81.737076000000101, 18.344222000000169],
              [81.744911000000158, 18.34535],
              [81.746078000000111, 18.351741],
              [81.746757000000144, 18.355501],
              [81.755546, 18.386249],
              [81.760368000000128, 18.39983],
              [81.7621, 18.411310000000125],
              [81.767388, 18.4147700000002],
              [81.797568000000155, 18.439761000000143],
              [81.828927, 18.468950000000113],
              [81.844307, 18.481540000000162],
              [81.849587, 18.489049],
              [81.848961, 18.50060000000013],
              [81.853027000000154, 18.50733],
              [81.85794, 18.51306],
              [81.862961, 18.517272],
              [81.868057000000121, 18.517482000000197],
              [81.870797, 18.517589000000154],
              [81.873619, 18.519939],
              [81.875383, 18.521411],
              [81.878678000000136, 18.526279],
              [81.882598000000115, 18.52918000000016],
              [81.896073, 18.528431000000175],
              [81.896827, 18.528392000000164],
              [81.900291000000138, 18.532519000000203],
              [81.89865, 18.536159000000108],
              [81.897941, 18.537732],
              [81.897636, 18.542712000000162],
              [81.899758000000105, 18.549041000000155],
              [81.900802000000155, 18.55717100000015],
              [81.908599000000137, 18.564229],
              [81.913171, 18.561189],
              [81.916398, 18.559021],
              [81.92019700000013, 18.557300000000165],
              [81.925453000000161, 18.557681],
              [81.929847, 18.55800000000016],
              [81.93624, 18.55770200000017],
              [81.943526, 18.555420000000193],
              [81.946259, 18.558410000000148],
              [81.946906, 18.559151000000153],
              [81.945343, 18.562451000000177],
              [81.943572000000117, 18.566159000000194],
              [81.945762000000101, 18.574911000000153],
              [81.954528000000138, 18.58671],
              [81.948882000000182, 18.589541],
              [81.938476, 18.591791],
              [81.933038000000167, 18.594651],
              [81.929717, 18.59639],
              [81.926232000000127, 18.60323],
              [81.913032, 18.612930000000116],
              [81.899933, 18.61961000000019],
              [81.888367000000173, 18.620991],
              [81.887291000000104, 18.624389000000175],
              [81.887802000000107, 18.63163000000014],
              [81.887996597156118, 18.634392799128815],
              [81.888207, 18.637380000000174],
              [81.889312999999873, 18.641129],
              [81.890008, 18.643470000000317],
              [81.885377000000219, 18.650330000000164],
              [81.89317400000013, 18.65388100000018],
              [81.894837, 18.651960000000198],
              [81.9049, 18.646392],
              [81.909141, 18.64099],
              [81.915527, 18.635821000000128],
              [81.935577000000123, 18.632899000000119],
              [81.947442, 18.628820000000129],
              [81.948326000000165, 18.632790000000167],
              [81.946084000000141, 18.640489],
              [81.945922, 18.646380000000189],
              [81.947387, 18.655711],
              [81.949605217400276, 18.658460942531004],
              [81.951638000000102, 18.660981],
              [81.960631, 18.667720000000198],
              [81.956374076234042, 18.677308425695738],
              [81.955077, 18.680230000000158],
              [81.957160000000144, 18.683410000000205],
              [81.963868, 18.687799],
              [81.967681, 18.690612000000151],
              [81.969923310523242, 18.691829637683437],
              [81.973721176679916, 18.693891985828653],
              [81.974174444010075, 18.694138122737908],
              [81.976036000000178, 18.695149000000182],
              [81.991867000000113, 18.697691000000187],
              [81.997727, 18.700451],
              [82.009986, 18.710600000000166],
              [82.015618000000103, 18.713531],
              [82.033737, 18.7188],
              [82.039496000000142, 18.717041],
              [82.049431, 18.717581000000106],
              [82.051758, 18.711840000000105],
              [82.057992000000169, 18.712512000000114],
              [82.059129, 18.717781000000112],
              [82.061287000000149, 18.718009000000158],
              [82.067391000000143, 18.717109000000104],
              [82.073982000000143, 18.713091],
              [82.078583, 18.712081000000119],
              [82.080482, 18.722741000000205],
              [82.084899000000163, 18.732691],
              [82.096527, 18.723431],
              [82.102936, 18.719290000000111],
              [82.108627000000169, 18.719842000000138],
              [82.11535661049804, 18.717849723796913],
              [82.118307967925475, 18.716975985387812],
              [82.122108, 18.715851000000153],
              [82.12265700000016, 18.70895],
              [82.122115000000107, 18.704090000000114],
              [82.119179, 18.70038900000014],
              [82.130923354511637, 18.703157666816985],
              [82.131148726848991, 18.696099657349119],
              [82.129971570109419, 18.683170194367957],
              [82.125212648097758, 18.678411272356293],
              [82.124260863695355, 18.673652350344636],
              [82.12725, 18.66884100000021],
              [82.131737000000257, 18.666619000000193],
              [82.13517, 18.66336],
              [82.143296551742012, 18.662706829717873],
              [82.146151904949051, 18.666989859528368],
              [82.149007258156061, 18.663658614120148],
              [82.149941434237789, 18.658053557630236],
              [82.152814395765333, 18.640815788464231],
              [82.161379338037008, 18.637007368285023],
              [82.17042240720852, 18.637484543056015],
              [82.172325976013198, 18.643195249470065],
              [82.179940251231855, 18.649857740286333],
              [82.192313448462059, 18.653664877895775],
              [82.198500047077331, 18.659375584309654],
              [82.204686645692362, 18.665086290723703],
              [82.208017891100653, 18.666989859528368],
              [82.210397352106483, 18.664134506321314],
              [82.213814137610413, 18.65957879231598],
              [82.216108058520362, 18.656520231102657],
              [82.216583950721528, 18.645574710475895],
              [82.218487519526192, 18.637484543056015],
              [82.216108058520362, 18.63082205223969],
              [82.217059842922737, 18.62606313022803],
              [82.223443293861436, 18.622916174027349],
              [82.224717000000211, 18.617540000000126],
              [82.226232864120149, 18.616623192624893],
              [82.230041000000185, 18.614320000000188],
              [82.233802000000182, 18.613791],
              [82.238474991975224, 18.611310471991882],
              [82.237999099773987, 18.606075657779169],
              [82.241356722396603, 18.603162835633892],
              [82.247451000000282, 18.605960000000376],
              [82.247132534518343, 18.603324250854651],
              [82.246808087019801, 18.600638992118771],
              [82.246116000000299, 18.594911],
              [82.248885, 18.595239],
              [82.252751758010206, 18.594178352750017],
              [82.253227650211414, 18.591798891744187],
              [82.256558895619477, 18.588943538537134],
              [82.261317817631124, 18.586088185330137],
              [82.265600847441746, 18.586088185330137],
              [82.269883877252227, 18.5865640775313],
              [82.276546368068509, 18.584660508726696],
              [82.277974044671936, 18.581329263318477],
              [82.277331369386488, 18.580043912747268],
              [82.276504937560603, 18.578391049095099],
              [82.275118691465067, 18.575618556904427],
              [82.273691014861456, 18.570383742691714],
              [82.277974044671936, 18.570383742691714],
              [82.29251, 18.571561],
              [82.298974, 18.570431000000209],
              [82.306809, 18.570729000000139],
              [82.310868, 18.574599],
              [82.317947000000103, 18.587709000000185],
              [82.322296, 18.59221],
              [82.329842, 18.592980000000178],
              [82.350731000000152, 18.61483],
              [82.357367000000153, 18.615829000000126],
              [82.363646000000116, 18.61349],
              [82.36523582183996, 18.612343161718282],
              [82.368195384532484, 18.610208243384474],
              [82.369490097333809, 18.609385851944008],
              [82.375590661490918, 18.605510821325478],
              [82.382372125357492, 18.604796983023785],
              [82.388439750922302, 18.603726225571105],
              [82.392692579881711, 18.600891006265041],
              [82.394864295638101, 18.599443195760667],
              [82.399050764627006, 18.594637351396209],
              [82.402629270053737, 18.591852715151955],
              [82.405008731059567, 18.590662984649036],
              [82.40233183742798, 18.587391225766222],
              [82.39638318491339, 18.585606630011849],
              [82.38411063833442, 18.585154907880675],
              [82.380490994765054, 18.583395066014468],
              [82.386785397452272, 18.573953461983248],
              [82.387629377782545, 18.572687491488235],
              [82.388037027906279, 18.572425430694405],
              [82.395957491302724, 18.567333704225117],
              [82.407982400364659, 18.554975580838281],
              [82.405854, 18.54992100000015],
              [82.402152, 18.546290000000109],
              [82.400090303098452, 18.536611529160208],
              [82.397047989203983, 18.522329630451733],
              [82.396175065391418, 18.519893901682504],
              [82.394519273792156, 18.515273728447706],
              [82.392020839736048, 18.516344485900383],
              [82.381788905820116, 18.520141082240624],
              [82.378111533758982, 18.516770157851219],
              [82.378706399010454, 18.509036909582274],
              [82.377744073701066, 18.502067719865405],
              [82.376316397097682, 18.495286255998675],
              [82.377387154550291, 18.492073983640861],
              [82.381085860016512, 18.491785817290005],
              [82.387023971623918, 18.47922489420932],
              [82.388808567378291, 18.472086511191829],
              [82.395946950395782, 18.466732723928711],
              [82.402371495111524, 18.46244969411827],
              [82.398910060525083, 18.452951772380626],
              [82.397378000000103, 18.451601],
              [82.387953228103115, 18.439185405539146],
              [82.384846548711536, 18.435092863898088],
              [82.382271000000159, 18.431700000000145],
              [82.380653, 18.426430000000206],
              [82.377602000000167, 18.42199],
              [82.371742, 18.420169000000154],
              [82.367026000000152, 18.41717],
              [82.365996, 18.41301100000015],
              [82.36129, 18.409911000000186],
              [82.365996, 18.403352000000147],
              [82.372512, 18.398091],
              [82.374908, 18.392811000000162],
              [82.375236000000172, 18.383061000000108],
              [82.37841100000017, 18.378131],
              [82.384437000000148, 18.37241],
              [82.384430000000108, 18.36911],
              [82.381095000000158, 18.36669],
              [82.378800000000155, 18.361659000000138],
              [82.379707, 18.357429],
              [82.376350000000159, 18.35327],
              [82.369476000000176, 18.350362000000125],
              [82.360139000000146, 18.343700000000123],
              [82.356567, 18.333571000000116],
              [82.350220000000135, 18.328911],
              [82.34542, 18.32182],
              [82.336418, 18.32012],
              [82.334442000000124, 18.317132000000125],
              [82.34101, 18.310659],
              [82.342904, 18.307341],
              [82.348748, 18.306151000000167],
              [82.354562, 18.309021000000136],
              [82.357971, 18.308241],
              [82.365249, 18.316430000000135],
              [82.369187, 18.317752],
              [82.375106, 18.318000000000151],
              [82.380494, 18.319311000000138],
              [82.384368, 18.318700000000202],
              [82.388427, 18.311202],
              [82.393013, 18.30644100000017],
              [82.387352, 18.300622],
              [82.385408, 18.289092000000206],
              [82.38224, 18.28429],
              [82.371879, 18.274102000000138],
              [82.367058000000128, 18.270941000000104],
              [82.34365200000012, 18.271650000000133],
              [82.336898000000105, 18.266241],
              [82.333901000000111, 18.252291000000124],
              [82.331802, 18.24679100000014],
              [82.332039, 18.240129000000135],
              [82.331009, 18.233360000000115],
              [82.330223, 18.231341],
              [82.322533000000121, 18.228129],
              [82.321321, 18.222459],
              [82.326736, 18.216230000000163],
              [82.332817000000134, 18.215790000000133],
              [82.319732, 18.20104],
              [82.306098, 18.195659000000202],
              [82.309433000000169, 18.18938],
              [82.308220000000162, 18.181280000000125],
              [82.310303, 18.174602],
              [82.319313000000122, 18.171431000000208],
              [82.324792000000159, 18.166420000000183],
              [82.333024, 18.163420000000141],
              [82.341607000000153, 18.163432],
              [82.34873200000014, 18.161832000000171],
              [82.358979000000133, 18.149139000000158],
              [82.365157, 18.139669000000136],
              [82.364296, 18.134860000000113],
              [82.361764000000136, 18.129199000000195],
              [82.357568000000114, 18.125101000000196],
              [82.344871, 18.134621],
              [82.338257, 18.137960000000131],
              [82.333366, 18.142379000000172],
              [82.335358, 18.127259],
              [82.330307000000104, 18.119],
              [82.332488, 18.10705],
              [82.332160000000144, 18.094121000000197],
              [82.334663000000134, 18.089888],
              [82.340554, 18.08709],
              [82.343162, 18.082479],
              [82.343629000000178, 18.074992000000176],
              [82.341942000000174, 18.0713],
              [82.343177, 18.06782],
              [82.33693, 18.049101],
              [82.336349, 18.047260000000161],
              [82.329774, 18.040411000000116],
              [82.32491200000014, 18.04269],
              [82.32618, 18.04651],
              [82.321824, 18.050181],
              [82.319648000000115, 18.048570000000208],
              [82.317307, 18.048531000000136],
              [82.315728, 18.046681000000202],
              [82.312995000000157, 18.045190000000101],
              [82.316963, 18.036021000000172],
              [82.313209000000114, 18.034758000000121],
              [82.309617000000102, 18.038430000000172],
              [82.305526, 18.037810000000203],
              [82.304414000000165, 18.03962],
              [82.306342000000186, 18.04499],
              [82.301057, 18.044041000000103],
              [82.296485000000175, 18.046140000000204],
              [82.292809000000133, 18.054332000000155],
              [82.296403, 18.057559000000193],
              [82.297898, 18.061960000000166],
              [82.287774, 18.060561],
              [82.285057000000151, 18.05941],
              [82.283027, 18.055770000000106],
              [82.278947000000159, 18.054929000000183],
              [82.266952000000146, 18.04827100000011],
              [82.265106000000159, 18.04306100000019],
              [82.264602000000167, 18.039011000000126],
              [82.262207, 18.036301],
              [82.258157, 18.034870000000122],
              [82.266243, 18.025690000000164],
              [82.268937, 18.01994],
              [82.270813, 18.010670000000115],
              [82.270523000000168, 17.997741],
              [82.268853, 17.991990000000154],
              [82.26725, 17.986441],
              [82.26107800000014, 17.982400000000151],
              [82.253188000000122, 17.980191000000158],
              [82.241706, 17.979761000000103],
              [82.238319000000132, 17.983900000000116],
              [82.236993, 17.992011000000101],
              [82.230798000000149, 17.993709],
              [82.222976, 17.992879000000183],
              [82.218178, 17.994190000000113],
              [82.20775600000016, 18.00071],
              [82.196923000000183, 18.00869],
              [82.191018000000142, 18.008952],
              [82.185090000000102, 18.007352],
              [82.177407000000173, 18.010570000000197],
              [82.174248, 18.015502],
              [82.176942, 18.02089200000017],
              [82.173149000000123, 18.025592],
              [82.16375, 18.041621],
              [82.160347000000101, 18.043599],
              [82.147309000000106, 18.04042000000015],
              [82.142297, 18.04357],
              [82.13237100000012, 18.03562],
              [82.130418000000176, 18.040901000000186],
              [82.129242, 18.048670000000126],
              [82.127084000000167, 18.051000000000155],
              [82.119316000000111, 18.0512],
              [82.113265, 18.057821],
              [82.110587000000152, 18.057662000000157],
              [82.10798, 18.054019000000206],
              [82.092361, 18.052761000000196],
              [82.089156000000102, 18.057411000000169],
              [82.080063, 18.060449],
              [82.072213000000133, 18.065638000000202],
              [82.069893, 18.060431000000101],
              [82.064407000000159, 18.058370000000135],
              [82.058983, 18.05845000000016],
              [82.060989000000163, 18.053981],
              [82.065467000000112, 18.051300000000136],
              [82.065643000000108, 18.048919000000122],
              [82.059724000000102, 18.04511900000011],
              [82.050858000000147, 18.044461000000179],
              [82.045167, 18.045589000000117],
              [82.043426367784591, 18.046439518830365],
              [82.043144794738325, 18.046577102851014],
              [82.038801201404212, 18.048699497167146],
              [82.032873328795276, 18.044456779102966],
              [82.028685477425071, 18.037413574525711],
              [82.025830124218018, 18.029608942426531],
              [82.021261559086824, 18.02485002041487],
              [82.014218354509566, 18.025421091056327],
              [82.006413722410429, 18.028086087382857],
              [82.002052610751591, 18.027584752048195],
              [82.001685000000492, 18.023661000000509],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Mayurbhanj",
          Dist_Code: "376",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [86.259567000000104, 22.441271],
              [86.265182000000124, 22.43954100000013],
              [86.271377000000228, 22.442830000000296],
              [86.279824000000346, 22.445520000000265],
              [86.281428895270523, 22.441154648950253],
              [86.282380679672926, 22.438775187944422],
              [86.28452219457823, 22.433064481530486],
              [86.288567278288028, 22.426877882915271],
              [86.289994954891625, 22.42235690700425],
              [86.293802092500854, 22.420929230400699],
              [86.298085122311335, 22.417835931093119],
              [86.300940475518331, 22.411173440276851],
              [86.303081990423692, 22.402607380655919],
              [86.309982427340501, 22.398324350845311],
              [86.313551618849232, 22.39594488983948],
              [86.316882864257451, 22.391185967827816],
              [86.317358756458688, 22.384285530910965],
              [86.321641786269126, 22.376195363491085],
              [86.32635871344614, 22.370369208224982],
              [86.329609291603887, 22.370934526164998],
              [86.334631988472822, 22.368408085924838],
              [86.339019837420125, 22.366200977185709],
              [86.339318, 22.366051000000191],
              [86.347366000000179, 22.359001000000202],
              [86.352660000000157, 22.35153],
              [86.352738, 22.34542],
              [86.363037, 22.33961],
              [86.375527, 22.33711900000014],
              [86.39061, 22.325281000000185],
              [86.401306000000119, 22.31941],
              [86.41137800000017, 22.315559000000118],
              [86.421693000000104, 22.313890000000182],
              [86.424697000000137, 22.30920900000012],
              [86.424378, 22.306271],
              [86.43335800000014, 22.30154],
              [86.439315000000107, 22.305781000000191],
              [86.440193000000107, 22.311411],
              [86.438812, 22.316459000000116],
              [86.438392000000107, 22.323369],
              [86.441818000000112, 22.325341000000144],
              [86.449546, 22.323062],
              [86.458237, 22.322111],
              [86.460265000000135, 22.326419000000151],
              [86.46396, 22.327000000000108],
              [86.467011, 22.32891],
              [86.468422, 22.332281],
              [86.474578000000108, 22.334220000000123],
              [86.47853, 22.334462],
              [86.481712000000115, 22.342019],
              [86.483720000000162, 22.34441900000018],
              [86.499947, 22.340951000000125],
              [86.501260000000158, 22.331460000000156],
              [86.507988, 22.32402100000018],
              [86.519577000000126, 22.32058],
              [86.523650000000117, 22.318572000000184],
              [86.525093000000183, 22.31237],
              [86.520835000000119, 22.31149],
              [86.523201000000114, 22.307839000000108],
              [86.52455, 22.302850000000145],
              [86.532379000000148, 22.298192000000196],
              [86.539887000000121, 22.303730000000137],
              [86.54573700000013, 22.298930000000148],
              [86.552062000000134, 22.29529],
              [86.561203, 22.297011],
              [86.56771, 22.297002000000184],
              [86.570687000000177, 22.29295],
              [86.574334000000121, 22.293939],
              [86.575218, 22.296330000000179],
              [86.578461, 22.297820000000165],
              [86.581305000000128, 22.2949190000001],
              [86.582176, 22.291019],
              [86.585602, 22.290889],
              [86.585618, 22.286630000000113],
              [86.589927000000145, 22.28214],
              [86.590928000000176, 22.274831000000169],
              [86.598458, 22.274379],
              [86.602631, 22.278432],
              [86.608514, 22.278760000000201],
              [86.616058, 22.276002],
              [86.627153, 22.266831000000135],
              [86.630257000000171, 22.269030000000154],
              [86.634658000000158, 22.269149],
              [86.637290000000164, 22.266202000000131],
              [86.637618000000117, 22.263091],
              [86.641372, 22.264192],
              [86.642272, 22.261842000000168],
              [86.645577000000159, 22.261370000000166],
              [86.645896, 22.257281],
              [86.648339, 22.253231000000195],
              [86.647293, 22.249692],
              [86.648178, 22.235691000000195],
              [86.651145, 22.233200000000121],
              [86.66034600000016, 22.234221],
              [86.662698, 22.23748],
              [86.665146000000135, 22.23856],
              [86.669891000000163, 22.236842000000188],
              [86.669952, 22.23010000000016],
              [86.673996, 22.22497],
              [86.682166, 22.219511000000121],
              [86.691789000000114, 22.217399000000167],
              [86.711471, 22.21772],
              [86.720971, 22.216840000000101],
              [86.722785, 22.215249],
              [86.719963000000163, 22.210190000000175],
              [86.717666000000165, 22.19793],
              [86.716073000000151, 22.19380000000012],
              [86.717217000000161, 22.18557],
              [86.713356, 22.181352000000111],
              [86.712775000000107, 22.178289000000174],
              [86.715348, 22.174410000000186],
              [86.716896, 22.163761000000189],
              [86.715209000000101, 22.158720000000184],
              [86.715446000000142, 22.143491],
              [86.722808, 22.142741],
              [86.732337, 22.144911000000146],
              [86.739532000000153, 22.145082000000112],
              [86.752220000000122, 22.143960000000156],
              [86.756705000000167, 22.145191],
              [86.77153800000012, 22.14678],
              [86.776946000000166, 22.149009000000145],
              [86.782838, 22.150141000000186],
              [86.786813000000151, 22.153722000000183],
              [86.79032, 22.153941000000195],
              [86.800453000000147, 22.145920000000157],
              [86.799264, 22.139090000000117],
              [86.800476000000145, 22.130452],
              [86.799843000000152, 22.12848],
              [86.797096, 22.126131],
              [86.79786, 22.125281],
              [86.803963000000167, 22.126131],
              [86.806632, 22.12536],
              [86.807968, 22.123822000000185],
              [86.804383000000129, 22.117071],
              [86.80621300000017, 22.114161000000191],
              [86.812173, 22.113671000000121],
              [86.814851, 22.11244],
              [86.820831000000155, 22.113620000000193],
              [86.823311, 22.112921],
              [86.825401, 22.108631],
              [86.831329000000139, 22.10069100000015],
              [86.832008, 22.095109000000146],
              [86.841690000000128, 22.0918],
              [86.846032, 22.095150000000153],
              [86.8479, 22.09835],
              [86.90876, 22.086380000000183],
              [86.922257000000144, 22.08576],
              [86.929017, 22.084539],
              [86.932037, 22.085849000000103],
              [86.944267000000124, 22.081979],
              [86.951973000000152, 22.081341000000172],
              [86.957237000000177, 22.083369],
              [86.967056, 22.077751000000145],
              [86.970466000000144, 22.073991],
              [86.971908, 22.066271],
              [86.987548000000103, 22.055072],
              [86.990486, 22.049381],
              [86.995178, 22.0458],
              [87.000931, 22.045000000000126],
              [87.004707000000153, 22.042789000000134],
              [87.009423, 22.041481],
              [87.017616000000132, 22.041281],
              [87.02469500000015, 22.032691],
              [87.026047000000162, 22.028750000000109],
              [87.023506, 22.021021000000125],
              [87.022263, 22.012069000000164],
              [87.02501, 22.003951],
              [87.02797, 21.998422],
              [87.031952, 21.995671000000183],
              [87.034318, 21.989191000000112],
              [87.032242, 21.986101],
              [87.030854000000133, 21.978839000000161],
              [87.02031, 21.968362000000123],
              [87.0149, 21.95326],
              [87.005546000000137, 21.940650000000169],
              [87.004083, 21.935422000000127],
              [87.002517000000168, 21.92236],
              [86.999397, 21.918141000000102],
              [87.000609, 21.914381],
              [86.997931000000136, 21.907502000000189],
              [87.001259000000161, 21.905841],
              [87.004837, 21.895530000000118],
              [87.0147860000001, 21.8896820000001],
              [87.016791, 21.887229],
              [87.019966, 21.885750000000197],
              [87.025117000000122, 21.870350000000197],
              [87.030243, 21.865311000000187],
              [87.053773, 21.860942000000129],
              [87.062103, 21.86019],
              [87.077735, 21.859800000000174],
              [87.094642, 21.86034],
              [87.100937, 21.851789000000107],
              [87.115852000000118, 21.847919000000157],
              [87.125221, 21.832630000000105],
              [87.129014, 21.830331000000111],
              [87.133918, 21.8291],
              [87.161026, 21.814051000000113],
              [87.166366, 21.812941000000134],
              [87.173974, 21.80735],
              [87.175941, 21.803280000000139],
              [87.176376000000147, 21.796189000000133],
              [87.179818, 21.785129000000204],
              [87.174897, 21.785961000000153],
              [87.173126, 21.790359],
              [87.17217400000014, 21.803011],
              [87.169869, 21.805500000000102],
              [87.16462100000011, 21.8008],
              [87.166558000000151, 21.798630000000109],
              [87.165108, 21.793140000000104],
              [87.166863, 21.78775000000018],
              [87.166847000000118, 21.783711000000149],
              [87.165076, 21.780981],
              [87.160493, 21.78271],
              [87.158387000000147, 21.782802],
              [87.157416, 21.780349000000108],
              [87.160422000000125, 21.778631],
              [87.157195000000158, 21.767030000000144],
              [87.155228000000122, 21.763260000000166],
              [87.147087, 21.759990000000126],
              [87.141403000000182, 21.758520000000196],
              [87.133369000000172, 21.761061],
              [87.127029000000135, 21.764379000000186],
              [87.124237, 21.770759000000162],
              [87.12227, 21.7709],
              [87.121627000000146, 21.769359000000115],
              [87.123177, 21.766399000000199],
              [87.121711000000161, 21.765720000000151],
              [87.119667000000135, 21.766451],
              [87.117996, 21.772470000000162],
              [87.113616, 21.777152000000111],
              [87.110619, 21.777651],
              [87.110206000000161, 21.778932000000108],
              [87.113791000000148, 21.779280000000139],
              [87.114739, 21.781170000000198],
              [87.111236000000105, 21.782191000000122],
              [87.108223, 21.781379],
              [87.107086000000137, 21.777651],
              [87.103836000000143, 21.7774],
              [87.101327, 21.778262],
              [87.09941, 21.77396100000021],
              [87.099084000000104, 21.768261],
              [87.102592, 21.762561],
              [87.10994, 21.755769],
              [87.118156000000155, 21.749880000000125],
              [87.117385000000155, 21.74828],
              [87.097268, 21.745991],
              [87.090348, 21.737271],
              [87.090606, 21.73386900000019],
              [87.092880000000136, 21.72969100000017],
              [87.092217000000161, 21.727849000000155],
              [87.090859, 21.72707000000019],
              [87.088479000000163, 21.72826],
              [87.086357, 21.730541000000123],
              [87.083075000000107, 21.732540000000135],
              [87.08184, 21.729611],
              [87.083335000000133, 21.726949000000101],
              [87.085038000000139, 21.725602],
              [87.086243, 21.726619000000195],
              [87.089019, 21.724371000000186],
              [87.089578000000103, 21.72155900000018],
              [87.0867930000001, 21.72338],
              [87.086310749627813, 21.719604721036827],
              [87.086295315559227, 21.719483896008789],
              [87.086285197372916, 21.719404686166392],
              [87.086006000000324, 21.717219000000281],
              [87.085224276812795, 21.716099972260505],
              [87.085295660643041, 21.714957830977589],
              [87.085010125322341, 21.713815689694908],
              [87.084224903190346, 21.712459396921524],
              [87.084082135529954, 21.710317882016167],
              [87.082797226586791, 21.70910435690325],
              [87.081940620624806, 21.710175114355927],
              [87.081155398492839, 21.7119597101103],
              [87.080512944021208, 21.71395845735514],
              [87.078300045285829, 21.714743679487121],
              [87.076526340285312, 21.714949995882016],
              [87.075519403542131, 21.713550357525829],
              [87.075131089787959, 21.713010602840992],
              [87.074599000000305, 21.712271000000325],
              [87.075547110400279, 21.709787289363017],
              [87.076279, 21.707870000000181],
              [87.075203, 21.706501],
              [87.072639000000137, 21.704871000000193],
              [87.068154, 21.706200000000191],
              [87.067420000000126, 21.705571000000187],
              [87.068596, 21.70233],
              [87.067468000000176, 21.701361000000183],
              [87.060539000000105, 21.70055],
              [87.050377, 21.702321],
              [87.044068000000124, 21.705632],
              [87.040061, 21.71254],
              [87.039642, 21.720319],
              [87.039947, 21.728150000000191],
              [87.043548, 21.734270000000144],
              [87.022637, 21.735781],
              [87.021393, 21.73361100000016],
              [87.026092000000105, 21.725192],
              [87.027045, 21.715079000000166],
              [87.032706, 21.714781000000183],
              [87.034104, 21.713550000000104],
              [87.033447000000109, 21.695301],
              [87.03411, 21.690750000000143],
              [87.049606, 21.678239],
              [87.04528, 21.670461],
              [87.043122, 21.669230000000191],
              [87.03891, 21.672120000000174],
              [87.036850000000115, 21.670700000000121],
              [87.034126000000171, 21.664752000000185],
              [87.029472, 21.666370000000139],
              [87.028169, 21.666160000000154],
              [87.027688, 21.656481],
              [87.02671, 21.655241],
              [87.023307, 21.654881],
              [87.02044, 21.656130000000182],
              [87.019401, 21.6603],
              [87.020896, 21.665691],
              [87.019111000000166, 21.666349000000189],
              [87.014747, 21.662611000000137],
              [87.014343, 21.667391],
              [87.010788, 21.669059],
              [87.00728500000011, 21.668941],
              [87.00411200000012, 21.666960000000124],
              [86.99524, 21.669711000000174],
              [86.991646, 21.665930000000166],
              [86.98861, 21.66614],
              [86.984879, 21.661889],
              [86.986686000000162, 21.658359],
              [86.986198, 21.646031],
              [86.989036, 21.64361],
              [86.995247, 21.645201],
              [87.002426, 21.645440000000171],
              [87.003677, 21.643521000000185],
              [87.00772, 21.6427720000002],
              [87.008529, 21.638211000000123],
              [87.006898, 21.629022000000127],
              [87.007171000000127, 21.626542],
              [87.003859000000134, 21.624281],
              [87.001412000000158, 21.620229000000158],
              [86.997391, 21.61988],
              [86.996101, 21.615971000000112],
              [86.995263000000179, 21.615939000000132],
              [86.988266000000166, 21.625740000000174],
              [86.985367, 21.62388],
              [86.983657, 21.62055],
              [86.986556, 21.618980000000185],
              [86.98924300000013, 21.615841],
              [86.986839, 21.611691000000175],
              [86.988747000000131, 21.610782000000135],
              [86.991279, 21.611402],
              [86.995231, 21.610572000000154],
              [86.997567, 21.608060000000133],
              [86.99524, 21.603331000000189],
              [86.997002000000151, 21.60197],
              [86.996407000000133, 21.60001],
              [87.002877, 21.593191000000157],
              [86.99524, 21.589260000000191],
              [86.987343000000152, 21.58646100000021],
              [86.987199000000118, 21.588040000000145],
              [86.98620500000014, 21.588489000000148],
              [86.98121600000016, 21.583890000000107],
              [86.968629, 21.579300000000156],
              [86.966263000000168, 21.583129000000206],
              [86.963371, 21.581071000000115],
              [86.959662, 21.576401],
              [86.956178000000122, 21.576838000000176],
              [86.956169, 21.580111],
              [86.957816000000136, 21.582662000000134],
              [86.95742, 21.588002000000181],
              [86.955804, 21.590251],
              [86.953477000000106, 21.587790000000204],
              [86.952789, 21.578568000000129],
              [86.94947, 21.57708000000013],
              [86.948791000000185, 21.574819000000101],
              [86.949867, 21.571090000000137],
              [86.952447000000163, 21.57169],
              [86.954621, 21.570051000000142],
              [86.95427000000015, 21.567200000000124],
              [86.946984, 21.567551000000204],
              [86.935310000000115, 21.572980000000193],
              [86.923561, 21.581900000000129],
              [86.920119000000142, 21.586821000000153],
              [86.917077000000148, 21.58198],
              [86.914627000000152, 21.575229],
              [86.90775300000017, 21.574172000000196],
              [86.907340000000119, 21.57821000000018],
              [86.908981, 21.583999],
              [86.903830000000127, 21.587391],
              [86.903381000000124, 21.592250000000146],
              [86.897453, 21.6043],
              [86.892478, 21.603821],
              [86.889130000000122, 21.606371000000188],
              [86.885919000000158, 21.617361000000184],
              [86.879241, 21.618209000000199],
              [86.87861, 21.621772000000128],
              [86.876182000000128, 21.624331],
              [86.876588000000112, 21.629420000000149],
              [86.873803000000109, 21.62999],
              [86.870072, 21.6247],
              [86.87342, 21.61343],
              [86.87732, 21.609831],
              [86.883751, 21.60752],
              [86.884079000000128, 21.60576100000014],
              [86.876198, 21.602921000000205],
              [86.87368, 21.600152],
              [86.872672000000108, 21.595520000000132],
              [86.86859, 21.596371000000197],
              [86.862779000000145, 21.587049000000203],
              [86.86078, 21.591712000000197],
              [86.852691000000135, 21.593711000000209],
              [86.850182, 21.59831900000011],
              [86.844514, 21.59981],
              [86.840844000000104, 21.595520000000132],
              [86.836822, 21.594962000000173],
              [86.827422000000155, 21.60087000000015],
              [86.825043000000136, 21.598171],
              [86.817611000000142, 21.600341],
              [86.807906000000102, 21.601510000000129],
              [86.799346, 21.60087000000015],
              [86.793762, 21.597959000000166],
              [86.794113, 21.593711000000209],
              [86.787629000000123, 21.59256],
              [86.783798, 21.594221000000115],
              [86.777642000000171, 21.595520000000132],
              [86.767379, 21.596501000000156],
              [86.759987, 21.596099],
              [86.749519000000106, 21.600231],
              [86.735489000000115, 21.597150000000166],
              [86.73232300000015, 21.593271],
              [86.721413, 21.59243],
              [86.715927000000164, 21.590240000000104],
              [86.71154, 21.590670000000152],
              [86.709160000000139, 21.588150000000152],
              [86.706252, 21.582580000000117],
              [86.70134100000017, 21.579282],
              [86.696327, 21.580761],
              [86.689612, 21.57966],
              [86.684922, 21.582662000000134],
              [86.687408, 21.585581],
              [86.68308300000011, 21.588820000000162],
              [86.672227000000177, 21.579341000000166],
              [86.66002, 21.571672000000142],
              [86.653969000000117, 21.57215],
              [86.647553, 21.573682000000183],
              [86.645112, 21.570329],
              [86.644387, 21.565719000000168],
              [86.646477000000147, 21.559540000000137],
              [86.644203000000147, 21.55324],
              [86.636871000000127, 21.541861000000207],
              [86.635499000000138, 21.52855],
              [86.632401000000115, 21.523880000000126],
              [86.624657, 21.526841],
              [86.615914, 21.51767],
              [86.609168000000153, 21.514472000000122],
              [86.602515, 21.512542000000103],
              [86.593957000000131, 21.511721],
              [86.588708000000139, 21.514299],
              [86.580246, 21.51563],
              [86.575881, 21.509121],
              [86.569076, 21.495412000000155],
              [86.56469700000018, 21.488549000000202],
              [86.552741000000182, 21.459761000000181],
              [86.54780700000012, 21.453359000000198],
              [86.543891000000116, 21.444799000000156],
              [86.536087000000151, 21.433969000000101],
              [86.529717000000161, 21.42242],
              [86.524667000000107, 21.416321000000206],
              [86.511726000000166, 21.402669],
              [86.498833, 21.391830000000137],
              [86.493561000000156, 21.383912000000119],
              [86.484497000000133, 21.374900000000135],
              [86.478348000000125, 21.370540000000172],
              [86.471757000000125, 21.368958],
              [86.458816000000155, 21.363251000000158],
              [86.443108, 21.352430000000137],
              [86.438018, 21.350281000000106],
              [86.434921, 21.346821000000201],
              [86.433449, 21.339341000000154],
              [86.430732000000134, 21.333121000000116],
              [86.425041000000178, 21.33068900000017],
              [86.422623000000144, 21.326241000000202],
              [86.391228, 21.31415],
              [86.385749, 21.308379],
              [86.378342, 21.3033010000002],
              [86.373138, 21.301389],
              [86.36785100000013, 21.301571],
              [86.356460000000183, 21.294679000000198],
              [86.35565300000016, 21.309140000000124],
              [86.353271, 21.314191000000104],
              [86.343247, 21.31956],
              [86.32444, 21.334539],
              [86.314293000000177, 21.3409000000002],
              [86.294273, 21.349572],
              [86.288537, 21.355922],
              [86.28074, 21.36983100000014],
              [86.2732, 21.374531],
              [86.264656000000144, 21.373799000000187],
              [86.266876000000167, 21.365490000000133],
              [86.266053, 21.361280000000129],
              [86.249871, 21.34601],
              [86.24595600000012, 21.343981000000205],
              [86.246726, 21.33974000000017],
              [86.230202000000105, 21.321951000000176],
              [86.224876000000137, 21.322940000000123],
              [86.221077, 21.316971],
              [86.219406000000149, 21.311511],
              [86.215279000000109, 21.306980000000117],
              [86.214362, 21.301031000000133],
              [86.20983100000015, 21.287860000000133],
              [86.206062, 21.28425],
              [86.205002000000135, 21.280161000000128],
              [86.205093, 21.277349000000179],
              [86.199311000000179, 21.276492000000129],
              [86.194137000000168, 21.27282],
              [86.190529, 21.26887],
              [86.184898000000132, 21.26776],
              [86.167428, 21.272519],
              [86.160149000000146, 21.275461000000117],
              [86.156860000000137, 21.278762000000196],
              [86.157334, 21.285289],
              [86.154487000000117, 21.286771],
              [86.14576, 21.281200000000119],
              [86.143502000000154, 21.277731000000124],
              [86.142326000000182, 21.273980000000101],
              [86.138688, 21.27377000000018],
              [86.133209000000122, 21.27557100000012],
              [86.13408, 21.263861],
              [86.133079000000151, 21.260410000000142],
              [86.129952, 21.260041],
              [86.124893, 21.260909],
              [86.115181, 21.266429],
              [86.112052000000148, 21.270482],
              [86.111671000000101, 21.276371],
              [86.107621000000137, 21.281219],
              [86.104232, 21.286841000000202],
              [86.103234, 21.298191000000138],
              [86.096688, 21.298711000000193],
              [86.091369, 21.300559000000131],
              [86.088622, 21.306011],
              [86.093719000000121, 21.315570000000147],
              [86.099441000000155, 21.320721],
              [86.103669, 21.328451],
              [86.105636, 21.338801],
              [86.10420300000014, 21.341700000000113],
              [86.104043, 21.344440000000187],
              [86.11782, 21.35504],
              [86.118263000000155, 21.35978],
              [86.116241, 21.363881],
              [86.124314, 21.37756000000018],
              [86.126267, 21.382708000000147],
              [86.136758, 21.398001000000185],
              [86.145637, 21.402111],
              [86.152543, 21.406680000000101],
              [86.158218, 21.414851000000109],
              [86.156326, 21.41938],
              [86.154321, 21.424079000000173],
              [86.148033, 21.43369],
              [86.14122, 21.441829],
              [86.13668, 21.445052000000143],
              [86.133583000000144, 21.44886],
              [86.132927, 21.45632],
              [86.129608, 21.460710000000173],
              [86.124177, 21.465901000000198],
              [86.115936, 21.472101000000176],
              [86.094986000000148, 21.485500000000169],
              [86.086403000000175, 21.489019000000209],
              [86.071702, 21.496431],
              [86.055313, 21.501761],
              [86.048599, 21.506099000000116],
              [86.029091000000136, 21.51387],
              [86.004593000000156, 21.527272000000149],
              [86.015588, 21.543960000000137],
              [86.013413, 21.553619000000133],
              [86.021392, 21.557792000000113],
              [86.025543000000184, 21.561871000000103],
              [86.032157000000126, 21.564529000000103],
              [86.037109, 21.567631],
              [86.042641, 21.568561],
              [86.04657, 21.575439],
              [86.049216000000101, 21.584040000000122],
              [86.056473000000139, 21.592002000000203],
              [86.062027000000143, 21.600111],
              [86.065001, 21.60977],
              [86.074998, 21.624071],
              [86.075287, 21.630542],
              [86.07073100000018, 21.64034],
              [86.068498, 21.661021],
              [86.075996, 21.67313],
              [86.078202, 21.68027],
              [86.076600000000141, 21.6848010000001],
              [86.072441000000111, 21.68755],
              [86.068131, 21.686269],
              [86.066932000000108, 21.683101000000132],
              [86.065102, 21.68156],
              [86.06099000000016, 21.68094],
              [86.055459, 21.683491000000114],
              [86.052482000000154, 21.689229],
              [86.04827, 21.70429],
              [86.045745000000167, 21.709391],
              [86.040916000000138, 21.700411000000141],
              [86.037217000000155, 21.699431],
              [86.03473, 21.695611000000152],
              [86.034912000000176, 21.691650000000148],
              [86.032761, 21.686091],
              [86.02823, 21.683871000000121],
              [86.022628, 21.687299],
              [86.019783, 21.694259],
              [86.022393000000179, 21.706079000000152],
              [86.022117, 21.718491000000192],
              [86.018646, 21.720319],
              [86.015923, 21.724492],
              [86.014421000000127, 21.731471000000166],
              [86.014022000000168, 21.73759],
              [86.01252, 21.74026200000014],
              [86.00875, 21.741091000000146],
              [86.006058, 21.739010000000114],
              [86.00271500000018, 21.738491000000117],
              [86.000167, 21.740569000000104],
              [85.994294000000124, 21.73945],
              [85.990357000000159, 21.73615],
              [85.990228000000144, 21.740111],
              [85.985168, 21.73878],
              [85.977052000000114, 21.738030000000204],
              [85.974479, 21.735651000000182],
              [85.972785, 21.735580000000134],
              [85.970237, 21.737239],
              [85.96621, 21.734969],
              [85.96266800000015, 21.736471000000158],
              [85.953376000000148, 21.742830000000133],
              [85.949388, 21.743471],
              [85.945351000000102, 21.749522000000177],
              [85.938432, 21.753451000000151],
              [85.935280000000134, 21.75766],
              [85.925537000000119, 21.758319],
              [85.919488, 21.760040000000171],
              [85.913933000000142, 21.758622000000109],
              [85.907921, 21.766109000000139],
              [85.900680000000108, 21.762861000000207],
              [85.897658, 21.76866],
              [85.890456, 21.776862000000104],
              [85.88310100000011, 21.780071],
              [85.881768000000108, 21.783371],
              [85.877404000000155, 21.789559000000104],
              [85.867072, 21.79329],
              [85.864114000000129, 21.791401000000118],
              [85.858268000000109, 21.792401],
              [85.857507, 21.795150000000145],
              [85.855629, 21.79665900000014],
              [85.850929, 21.797149000000154],
              [85.833619, 21.805139000000107],
              [85.830018, 21.804339000000191],
              [85.824227000000164, 21.801541],
              [85.816979000000146, 21.802961000000202],
              [85.805221000000174, 21.807601],
              [85.805672000000158, 21.81746],
              [85.802238, 21.82644],
              [85.805237, 21.832612000000207],
              [85.805616019496924, 21.834026343665123],
              [85.806648717317714, 21.837879943896944],
              [85.806839000000281, 21.838590000000291],
              [85.807029187542113, 21.842478711666043],
              [85.807083000000247, 21.843579000000258],
              [85.81035512626282, 21.849495439201402],
              [85.804045277275847, 21.865161697863638],
              [85.801070951018545, 21.870515485126756],
              [85.802558114147232, 21.877059002892789],
              [85.803152979398675, 21.882412790155904],
              [85.799583787889929, 21.888064010044783],
              [85.790466939255836, 21.894627835401586],
              [85.784791000000183, 21.90179100000034],
              [85.784989000000209, 21.904979000000306],
              [85.785495192957271, 21.906132012547058],
              [85.787901046427322, 21.911612095187188],
              [85.788207, 21.91230900000016],
              [85.788802, 21.918741000000175],
              [85.790398000000138, 21.92339],
              [85.789627, 21.93211000000019],
              [85.789962000000102, 21.947230000000101],
              [85.788880000000105, 21.94987100000014],
              [85.783020000000178, 21.952631],
              [85.781739, 21.957429],
              [85.776939000000127, 21.9544110000001],
              [85.772164, 21.953199000000151],
              [85.771927, 21.955970000000146],
              [85.770546000000181, 21.959300000000152],
              [85.76764700000011, 21.96129900000016],
              [85.763153, 21.962922000000159],
              [85.761498, 21.968800000000151],
              [85.756591000000157, 21.968572000000101],
              [85.75296, 21.970092],
              [85.749359, 21.97305],
              [85.742050000000162, 21.973821],
              [85.74051, 21.98445],
              [85.733834000000144, 21.989111],
              [85.730087000000111, 21.988601000000124],
              [85.727432000000164, 21.98608],
              [85.724822, 21.984831000000149],
              [85.709550000000135, 21.980640000000101],
              [85.699531, 21.981611000000154],
              [85.697876, 21.985800000000207],
              [85.69574, 21.98814],
              [85.698640000000154, 21.994540000000196],
              [85.698838, 21.99702],
              [85.697906, 22.003251],
              [85.692643000000132, 22.005131],
              [85.687180000000168, 22.005412000000202],
              [85.681473000000125, 22.004151000000146],
              [85.675003, 22.005731000000136],
              [85.671067000000136, 22.009551],
              [85.665863000000144, 22.00909],
              [85.660881, 22.018430000000134],
              [85.658021, 22.0285790000002],
              [85.659493000000154, 22.031601000000133],
              [85.670182, 22.038842],
              [85.668801, 22.043159],
              [85.671951000000121, 22.051471000000159],
              [85.681503000000106, 22.04878100000013],
              [85.687882, 22.056079],
              [85.696007000000108, 22.056840000000133],
              [85.704652, 22.054331000000158],
              [85.7078020000001, 22.056289000000156],
              [85.712777000000173, 22.056400000000107],
              [85.717561, 22.057729000000105],
              [85.722352000000157, 22.05813],
              [85.733818, 22.064530000000101],
              [85.746064, 22.069879000000178],
              [85.75044200000012, 22.07439],
              [85.752135, 22.07924],
              [85.75782, 22.084981],
              [85.765022000000144, 22.08821],
              [85.773391000000146, 22.090241],
              [85.779038, 22.093420000000204],
              [85.784255, 22.098988000000126],
              [85.790917, 22.100390000000115],
              [85.793976, 22.10537],
              [85.797180000000125, 22.1063],
              [85.80204800000017, 22.110831000000186],
              [85.814743, 22.102111000000203],
              [85.81521500000018, 22.099020000000102],
              [85.808708, 22.091841],
              [85.815422, 22.092821000000178],
              [85.818962, 22.08963000000011],
              [85.824913, 22.08713],
              [85.828088, 22.08266100000014],
              [85.830756000000164, 22.076972000000122],
              [85.814369, 22.070071],
              [85.802728000000144, 22.071760000000207],
              [85.796761000000103, 22.074501000000161],
              [85.787941, 22.077191000000134],
              [85.785110000000131, 22.07191000000017],
              [85.770332, 22.051282000000125],
              [85.771232, 22.047149],
              [85.773299, 22.043309000000189],
              [85.778938000000139, 22.036260000000137],
              [85.775597, 22.028271],
              [85.772171000000114, 22.0247],
              [85.76184900000014, 22.01794],
              [85.75869700000014, 22.014802000000138],
              [85.756126, 22.00839],
              [85.760520000000142, 21.996940000000162],
              [85.760751, 21.989720000000201],
              [85.771401000000168, 21.983712],
              [85.780501000000115, 21.981041],
              [85.782188000000119, 21.979391000000128],
              [85.784278000000185, 21.9786],
              [85.800980000000138, 21.981661000000194],
              [85.805153, 21.980220000000198],
              [85.812653000000111, 21.9809610000002],
              [85.815391, 21.980131],
              [85.816063, 21.975341],
              [85.815582000000163, 21.971300000000205],
              [85.818328, 21.97001],
              [85.822273, 21.970131000000144],
              [85.828598000000156, 21.972941000000102],
              [85.840415000000164, 21.976480000000148],
              [85.84697, 21.97708],
              [85.871323, 21.974750000000192],
              [85.881752, 21.97483],
              [85.88613, 21.975420000000209],
              [85.891151, 21.97852],
              [85.894173000000123, 21.978290000000179],
              [85.902848, 21.966591000000161],
              [85.905425000000136, 21.966630000000176],
              [85.90599800000011, 21.968091],
              [85.904457000000136, 21.97267],
              [85.909211, 21.975541000000131],
              [85.909667000000113, 21.977581000000153],
              [85.907258, 21.981310000000118],
              [85.909248, 21.990130000000189],
              [85.913063, 21.996651],
              [85.91224, 22.004801],
              [85.91954, 22.00979],
              [85.923401000000112, 22.014079000000201],
              [85.924889000000164, 22.017352000000127],
              [85.928773, 22.019360000000173],
              [85.933090000000149, 22.017441000000186],
              [85.93856, 22.01662],
              [85.942582000000158, 22.019130000000128],
              [85.944709000000131, 22.023269000000134],
              [85.951537, 22.031640000000149],
              [85.953584, 22.0361000000002],
              [85.957978, 22.042511],
              [85.963311, 22.054429],
              [85.967377, 22.05978],
              [85.971229, 22.066821000000115],
              [85.975288, 22.071791000000129],
              [85.977387000000107, 22.076739],
              [85.977319000000179, 22.080040000000164],
              [85.978996, 22.08336],
              [85.989197, 22.093450000000185],
              [85.992600000000124, 22.100251000000178],
              [86.000472, 22.108971000000107],
              [86.002587000000105, 22.11302100000017],
              [85.996087000000131, 22.120652],
              [85.995087, 22.123569000000195],
              [85.994629000000117, 22.131781],
              [85.9991, 22.137109000000176],
              [85.999688, 22.142401000000113],
              [85.999237, 22.144929],
              [86.003852000000137, 22.151051000000162],
              [86.011405000000124, 22.15766],
              [86.013121, 22.163611],
              [86.012572, 22.167859000000131],
              [86.014778, 22.172641],
              [86.02671900000017, 22.185222],
              [86.025566000000126, 22.18921000000017],
              [86.017388000000139, 22.198762],
              [85.992835, 22.215482000000176],
              [85.985131000000123, 22.223842000000158],
              [85.97779, 22.23555],
              [85.971359000000163, 22.238380000000117],
              [85.969788, 22.243401],
              [85.981811, 22.252051],
              [85.985444, 22.257459],
              [85.985191000000128, 22.267209000000147],
              [85.993042, 22.273281000000164],
              [85.997528, 22.275341],
              [86.00073900000011, 22.279332],
              [86.002220000000108, 22.281461000000199],
              [86.000238, 22.284371],
              [86.008499, 22.292672000000206],
              [86.016059, 22.296530000000182],
              [86.019751, 22.297820000000165],
              [86.023391000000146, 22.297670000000206],
              [86.027320000000131, 22.2995],
              [86.029381000000157, 22.30076],
              [86.03032, 22.302989],
              [86.039963000000157, 22.30355000000014],
              [86.043288000000103, 22.306191000000176],
              [86.04226, 22.30824],
              [86.039306, 22.308651000000161],
              [86.034074000000132, 22.307940000000141],
              [86.032303000000155, 22.305232],
              [86.02816800000015, 22.307689000000146],
              [86.024720000000144, 22.304170000000109],
              [86.020408, 22.305540000000114],
              [86.017775000000185, 22.304550000000113],
              [86.011398, 22.309391000000115],
              [86.011177000000117, 22.310570000000148],
              [86.008422, 22.309959],
              [86.008461000000111, 22.313241000000168],
              [86.005897, 22.315910000000198],
              [86.013283, 22.323962000000101],
              [86.019189, 22.327132000000173],
              [86.020431, 22.3294],
              [86.013999000000155, 22.334501],
              [86.004762000000127, 22.335649],
              [85.998428, 22.331080000000149],
              [85.995827000000119, 22.333119000000117],
              [85.992883000000106, 22.338159],
              [86.006127, 22.348752],
              [86.016862, 22.362231000000115],
              [86.015266, 22.366001000000146],
              [86.015968, 22.372970000000119],
              [86.018418, 22.37153000000017],
              [86.018913000000154, 22.374759000000207],
              [86.021249000000168, 22.37504000000018],
              [86.019624000000178, 22.37815100000017],
              [86.021500000000145, 22.381761],
              [86.020508000000163, 22.384202],
              [86.01757, 22.386121],
              [86.019065, 22.39066100000019],
              [86.018022, 22.393241000000156],
              [86.015747, 22.393341],
              [86.014778, 22.397051],
              [86.012269, 22.398991000000191],
              [86.013657000000123, 22.403882],
              [86.012046, 22.414731],
              [86.009614, 22.418890000000143],
              [86.009744, 22.421659],
              [86.008743000000123, 22.424321],
              [86.005997000000136, 22.425361000000173],
              [86.002838, 22.425060000000137],
              [86.000023, 22.422648000000201],
              [85.996858, 22.421641000000186],
              [85.99297400000016, 22.422140000000123],
              [85.982132000000135, 22.428989000000112],
              [85.96698, 22.441221000000208],
              [85.963113000000178, 22.445121000000135],
              [85.961403000000118, 22.452699000000102],
              [85.953506, 22.455972000000195],
              [85.958267000000134, 22.4659],
              [85.95932700000013, 22.470380000000201],
              [85.958137, 22.476181],
              [85.960793, 22.478619000000144],
              [85.96675, 22.482161],
              [85.96701, 22.486011000000129],
              [85.965606, 22.490161000000167],
              [85.966376000000167, 22.493810000000106],
              [85.969246000000155, 22.499781000000148],
              [85.980712, 22.509741000000183],
              [85.984138, 22.510621000000125],
              [85.99297400000016, 22.50892100000015],
              [85.995919000000114, 22.508962],
              [85.999871, 22.514972000000107],
              [86.001792, 22.51486],
              [86.008682, 22.518550000000168],
              [86.015448, 22.524480000000203],
              [86.022026, 22.520549],
              [86.028266, 22.534331000000119],
              [86.01834100000012, 22.543630000000171],
              [86.038491000000178, 22.563590000000197],
              [86.046645, 22.55789000000021],
              [86.05339200000013, 22.554651],
              [86.058137, 22.553421],
              [86.061829000000145, 22.548509],
              [86.069206000000165, 22.543069000000109],
              [86.078346000000153, 22.530411000000122],
              [86.091553000000133, 22.50916],
              [86.093507000000145, 22.508221000000159],
              [86.098138000000162, 22.49563100000011],
              [86.101379000000108, 22.490150000000135],
              [86.10733, 22.484898],
              [86.111924, 22.482932000000112],
              [86.119926, 22.485559],
              [86.146232, 22.479141000000137],
              [86.1451500000001, 22.475139000000123],
              [86.155549, 22.47908],
              [86.166024, 22.47674800000021],
              [86.173707, 22.476431000000101],
              [86.196685000000144, 22.467741000000153],
              [86.202392, 22.470280000000113],
              [86.209136, 22.462841],
              [86.216537000000102, 22.465049000000189],
              [86.217583000000147, 22.468249],
              [86.218207, 22.46821100000016],
              [86.216949, 22.464031000000144],
              [86.211502, 22.459712000000192],
              [86.220384, 22.449091000000177],
              [86.221031000000124, 22.450600000000176],
              [86.2284930000001, 22.449581],
              [86.242576, 22.44453],
              [86.259567000000104, 22.441271],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Nabarangapur",
          Dist_Code: "397",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [82.617569000000259, 19.143480000000292],
              [82.616197359367362, 19.144697857617185],
              [82.614720047599889, 19.146009538931871],
              [82.612815, 19.147701000000151],
              [82.610206000000161, 19.151291000000182],
              [82.609169000000151, 19.155941000000151],
              [82.609529000000109, 19.168711000000197],
              [82.608391, 19.176040000000111],
              [82.605928, 19.176902000000208],
              [82.600982, 19.175220000000134],
              [82.598297000000159, 19.175742000000181],
              [82.595307, 19.18119100000018],
              [82.592437, 19.184031000000171],
              [82.585167, 19.18587],
              [82.583923000000127, 19.19371],
              [82.581771, 19.195030000000198],
              [82.577042000000105, 19.18987],
              [82.574020000000161, 19.189002],
              [82.570779, 19.19134],
              [82.569892, 19.194020000000133],
              [82.568962, 19.203821000000115],
              [82.565712, 19.20499],
              [82.565819, 19.19683],
              [82.564377, 19.1942],
              [82.559730000000144, 19.193202],
              [82.551627, 19.195231000000145],
              [82.543541, 19.19905000000011],
              [82.540918, 19.19923],
              [82.545273000000165, 19.19057],
              [82.542657000000105, 19.1891700000001],
              [82.536264000000116, 19.189952000000112],
              [82.532592, 19.191541000000139],
              [82.526946, 19.196872000000209],
              [82.524392, 19.197731000000196],
              [82.522149, 19.196568],
              [82.519332000000176, 19.191999],
              [82.516617, 19.193100000000182],
              [82.515054, 19.195101000000189],
              [82.512558000000169, 19.196081000000103],
              [82.509133, 19.196042],
              [82.493988, 19.18172],
              [82.48623, 19.17599],
              [82.481858, 19.173770000000101],
              [82.476997, 19.172710000000105],
              [82.471046, 19.17307100000016],
              [82.466736, 19.170570000000161],
              [82.462670000000102, 19.17129],
              [82.459794, 19.173371],
              [82.458107, 19.175721],
              [82.454361, 19.176731000000128],
              [82.45217000000018, 19.17596],
              [82.450545, 19.172230000000177],
              [82.447906000000145, 19.169629],
              [82.439339, 19.170449],
              [82.433648000000105, 19.165711],
              [82.428299, 19.164380000000104],
              [82.424652, 19.16521],
              [82.413879, 19.170930000000109],
              [82.410271000000179, 19.173549],
              [82.406670000000105, 19.178552000000135],
              [82.404757048287181, 19.178247896889783],
              [82.406903011929487, 19.161693320219054],
              [82.403690739571658, 19.157410290408617],
              [82.397980033157623, 19.154198018050629],
              [82.384060186273402, 19.160979481917362],
              [82.378706399010454, 19.167047107482173],
              [82.367998824484218, 19.161693320219054],
              [82.363358875522849, 19.169902460689226],
              [82.356577411656289, 19.169545541538294],
              [82.350152866940476, 19.175970086254036],
              [82.347654432884255, 19.171330137292667],
              [82.343014483922985, 19.162050239369815],
              [82.336946858358019, 19.158124128710305],
              [82.328023879586326, 19.15955180531375],
              [82.322313173172262, 19.166690188331238],
              [82.305894892231976, 19.167047107482173],
              [82.298756509214499, 19.164905592576869],
              [82.294473479404004, 19.158837967012058],
              [82.290904287895245, 19.154198018050629],
              [82.290547368744328, 19.145275039278769],
              [82.285907419783072, 19.145275039278769],
              [82.279482875067316, 19.148130392485822],
              [82.276270602709346, 19.144561200977076],
              [82.273058330351532, 19.148130392485822],
              [82.259495402618285, 19.140992009468331],
              [82.254498534506112, 19.131712111545479],
              [82.252357019600808, 19.131712111545479],
              [82.240935606772808, 19.136708979657836],
              [82.225231164134399, 19.137422817959585],
              [82.222375810927403, 19.126715243433345],
              [82.230941870548335, 19.114579992303671],
              [82.222375810927403, 19.113152315700059],
              [82.215951266211604, 19.10744160928618],
              [82.201500000000166, 19.115762000000185],
              [82.199754000000141, 19.117460000000158],
              [82.191018000000142, 19.116311000000163],
              [82.17624, 19.125061],
              [82.169822000000153, 19.11286],
              [82.164803, 19.114690000000106],
              [82.159782, 19.12648],
              [82.161170000000183, 19.129751000000166],
              [82.166558, 19.132142],
              [82.168138, 19.13384],
              [82.164719000000147, 19.139471],
              [82.165879, 19.143141000000124],
              [82.169906000000182, 19.14364],
              [82.171989, 19.142500000000208],
              [82.17479, 19.145231],
              [82.172386, 19.147649000000108],
              [82.165001, 19.15045],
              [82.164138, 19.154639],
              [82.167602000000144, 19.15688],
              [82.171486000000172, 19.153910000000163],
              [82.174713, 19.15275],
              [82.176842000000121, 19.154979000000136],
              [82.178788, 19.158860000000114],
              [82.178239, 19.161479],
              [82.172981, 19.164761],
              [82.171128, 19.168271000000168],
              [82.175164, 19.169640000000125],
              [82.174599000000157, 19.173581],
              [82.169402, 19.176701],
              [82.173393, 19.184311],
              [82.164787, 19.187320000000167],
              [82.158043, 19.193179000000153],
              [82.155709, 19.196530000000106],
              [82.161179, 19.208390000000175],
              [82.153763000000112, 19.215779000000104],
              [82.151650000000103, 19.223569],
              [82.151963, 19.238901000000109],
              [82.150994000000168, 19.258422],
              [82.151726000000139, 19.265462],
              [82.154878, 19.274779000000191],
              [82.158362000000167, 19.28148],
              [82.168534000000179, 19.29066],
              [82.1700060000001, 19.295722000000175],
              [82.170091, 19.30248000000017],
              [82.173683, 19.316301],
              [82.183166, 19.319701],
              [82.180251, 19.332202000000162],
              [82.177491, 19.332371000000133],
              [82.173202, 19.334080000000139],
              [82.168954, 19.33723000000014],
              [82.163146, 19.337802],
              [82.157227, 19.342841],
              [82.149551, 19.344379000000171],
              [82.142349, 19.348172],
              [82.142258000000169, 19.35511],
              [82.140831, 19.36192],
              [82.1411820000001, 19.365781000000137],
              [82.144562, 19.37012],
              [82.150802, 19.370341000000106],
              [82.166367, 19.365931],
              [82.173981000000182, 19.37693900000016],
              [82.177771, 19.405572000000113],
              [82.183488, 19.412460000000177],
              [82.1830590000001, 19.417610000000135],
              [82.179253000000102, 19.41914],
              [82.170455000000103, 19.429491000000152],
              [82.167228000000122, 19.429849],
              [82.160689000000133, 19.429519000000191],
              [82.134101, 19.424828000000158],
              [82.119309, 19.423901],
              [82.106797000000114, 19.443071],
              [82.107162000000116, 19.452611000000157],
              [82.096894000000177, 19.46108],
              [82.099868, 19.46606],
              [82.101828, 19.473659000000165],
              [82.099030000000184, 19.489570000000182],
              [82.091018000000176, 19.49405900000016],
              [82.092078000000114, 19.50984],
              [82.08822700000016, 19.510442000000122],
              [82.070846, 19.515921000000159],
              [82.067147, 19.511021],
              [82.059792, 19.503641000000183],
              [82.022391, 19.501802],
              [82.03021300000016, 19.514209000000104],
              [82.032463000000163, 19.521291000000186],
              [82.041023000000138, 19.525701],
              [82.042573000000147, 19.531569000000101],
              [82.046126000000172, 19.538621000000202],
              [82.043006, 19.544460000000182],
              [82.040422, 19.552209],
              [82.042619, 19.558001],
              [82.044137, 19.5647990000001],
              [82.043236000000121, 19.567671],
              [82.04222900000012, 19.570921],
              [82.037796000000171, 19.577191000000138],
              [82.034897, 19.583272000000189],
              [82.033958, 19.59069],
              [82.037276000000105, 19.597920000000155],
              [82.04506, 19.601651000000114],
              [82.044716, 19.610790000000119],
              [82.048476, 19.615811],
              [82.051346, 19.624442],
              [82.050826000000171, 19.631621],
              [82.047286, 19.638281000000116],
              [82.046386, 19.644029000000156],
              [82.04831, 19.649371000000198],
              [82.046035000000117, 19.653592],
              [82.047669, 19.662690000000161],
              [82.046776000000122, 19.669371000000176],
              [82.038482, 19.69278],
              [82.037568000000121, 19.703911],
              [82.041602000000111, 19.708289],
              [82.043708000000137, 19.713912000000104],
              [82.042557, 19.723131],
              [82.044257, 19.729129],
              [82.044007000000178, 19.73769000000015],
              [82.046594000000169, 19.743021],
              [82.057198000000184, 19.753411],
              [82.055421, 19.761031000000166],
              [82.058983, 19.775070000000195],
              [82.059386, 19.77904],
              [82.059831, 19.78309900000016],
              [82.05219300000013, 19.791341000000156],
              [82.048278, 19.788410000000109],
              [82.044442000000103, 19.789249],
              [82.041076000000118, 19.79219100000017],
              [82.034943000000141, 19.79266],
              [82.029060000000101, 19.79219100000017],
              [82.024192, 19.79297900000017],
              [82.00818600000018, 19.796569000000201],
              [82.00305100000017, 19.798520000000163],
              [82.002891000000133, 19.798509000000131],
              [81.999322, 19.798310000000182],
              [81.992371, 19.794429000000203],
              [81.987418, 19.791740000000114],
              [81.980148, 19.795781000000197],
              [81.970208, 19.81274],
              [81.961456000000155, 19.824432],
              [81.957413, 19.836010000000211],
              [81.960374000000158, 19.854739000000162],
              [81.939422, 19.864841],
              [81.924477, 19.868722000000155],
              [81.898055, 19.878520000000144],
              [81.869247000000186, 19.892810000000164],
              [81.858405000000161, 19.8995500000002],
              [81.849633, 19.908051000000167],
              [81.845811000000111, 19.91486100000014],
              [81.845672, 19.922952000000116],
              [81.848831, 19.938591000000198],
              [81.846513000000101, 19.941440000000167],
              [81.838951000000108, 19.945499],
              [81.837303000000162, 19.95008],
              [81.840263, 19.95514],
              [81.846893000000122, 19.97036],
              [81.850319000000113, 19.982601],
              [81.851014, 19.989751000000119],
              [81.851616000000135, 19.99606],
              [81.852051, 19.997160000000118],
              [81.855461, 20.003521],
              [81.857621000000151, 20.009080000000147],
              [81.858918000000159, 20.016371000000156],
              [81.860169, 20.023361000000133],
              [81.864586, 20.028640000000106],
              [81.865487000000115, 20.03388],
              [81.866111, 20.035181],
              [81.86654, 20.03604],
              [81.873755000000116, 20.046180000000103],
              [81.876221, 20.044389],
              [81.880866000000182, 20.042419000000105],
              [81.885039000000106, 20.04172],
              [81.889459, 20.04327],
              [81.89418100000016, 20.048249],
              [81.901429000000149, 20.059121],
              [81.910272000000177, 20.067050000000105],
              [81.915429000000174, 20.07383],
              [81.921882000000139, 20.086949],
              [81.925635000000156, 20.090119000000126],
              [81.933929, 20.099309],
              [81.936965, 20.101150000000128],
              [81.941352, 20.102251000000134],
              [81.944206000000165, 20.101602],
              [81.954774, 20.0914800000001],
              [81.962646000000149, 20.085570000000185],
              [81.973572, 20.075611000000205],
              [81.978493, 20.069179],
              [81.9833, 20.057029000000167],
              [81.986602, 20.052072000000177],
              [81.992706, 20.047821000000162],
              [81.995552, 20.047532],
              [82.001029, 20.049261000000111],
              [82.006898, 20.047331],
              [82.009956, 20.044799],
              [82.01270300000013, 20.041031000000199],
              [82.014328000000134, 20.036439],
              [82.014496000000165, 20.030251000000188],
              [82.015518, 20.026830000000128],
              [82.014786, 20.019510000000189],
              [82.024406000000155, 20.010040000000167],
              [82.030701000000164, 20.015040000000166],
              [82.031563000000105, 20.016661000000166],
              [82.031029000000146, 20.022880000000153],
              [82.038758000000186, 20.028920000000195],
              [82.048973, 20.035240000000151],
              [82.057900000000174, 20.04987],
              [82.069802000000138, 20.048040000000181],
              [82.076302, 20.044040000000162],
              [82.083046000000124, 20.03274],
              [82.089439, 20.03455],
              [82.093193, 20.032672000000101],
              [82.095230000000171, 20.026801000000198],
              [82.097733000000161, 20.023370000000167],
              [82.102738, 20.020829],
              [82.10547700000015, 20.017812],
              [82.116096000000184, 20.010400000000111],
              [82.121422000000152, 20.009791000000174],
              [82.12841000000013, 20.012581000000122],
              [82.131699000000125, 20.01269],
              [82.148346000000103, 20.003000000000153],
              [82.15558, 20.002309000000189],
              [82.165833000000177, 19.99815000000012],
              [82.166077, 19.995841],
              [82.175782000000169, 19.98553],
              [82.178467, 19.978082],
              [82.184180000000126, 19.981161],
              [82.193817, 19.981309],
              [82.204292000000109, 19.98034],
              [82.210586, 19.990811],
              [82.214256000000134, 19.993341000000154],
              [82.219452000000146, 19.99345900000014],
              [82.22438, 19.995870000000135],
              [82.230629000000178, 19.998081000000123],
              [82.233353000000122, 19.995870000000135],
              [82.25271600000012, 19.97647900000015],
              [82.258637000000121, 19.971741000000176],
              [82.261696000000114, 19.971559000000177],
              [82.268645, 19.957930000000143],
              [82.269463, 19.945249],
              [82.283332, 19.91807000000011],
              [82.295327, 19.898959000000158],
              [82.298233, 19.883461],
              [82.317947000000103, 19.859159],
              [82.321327000000139, 19.851920000000113],
              [82.325120000000112, 19.840490000000155],
              [82.326752000000141, 19.838332000000147],
              [82.339447000000163, 19.829961],
              [82.356246000000155, 19.846621],
              [82.357361000000168, 19.8495],
              [82.356071, 19.855131],
              [82.358452, 19.85688],
              [82.368050000000139, 19.85448],
              [82.377251, 19.862969],
              [82.377982, 19.868690000000182],
              [82.386178000000129, 19.87684],
              [82.388817000000159, 19.881759],
              [82.397004, 19.884541],
              [82.400407, 19.888810000000145],
              [82.410439, 19.8934],
              [82.413888, 19.896521],
              [82.420905000000161, 19.898330000000154],
              [82.424928000000179, 19.89761],
              [82.432257, 19.899481000000204],
              [82.439491, 19.902920000000162],
              [82.442391000000129, 19.902982000000119],
              [82.45835100000015, 19.894649],
              [82.465560000000124, 19.896580000000139],
              [82.468086, 19.899481000000204],
              [82.475693, 19.900530000000114],
              [82.486923, 19.89653],
              [82.494241, 19.897359000000105],
              [82.497612, 19.895089],
              [82.498482, 19.88517],
              [82.502259000000123, 19.88244],
              [82.51241200000014, 19.88412],
              [82.517960000000159, 19.876311000000154],
              [82.523056, 19.872790000000119],
              [82.5299, 19.88213],
              [82.536362, 19.876890000000113],
              [82.544288, 19.86903],
              [82.547219, 19.873301000000136],
              [82.550873, 19.87455900000014],
              [82.55488600000011, 19.869501000000124],
              [82.566749, 19.871721000000143],
              [82.577584, 19.863439000000195],
              [82.590767, 19.866219],
              [82.593497, 19.864540000000201],
              [82.597381, 19.860469000000133],
              [82.591469000000117, 19.852431000000131],
              [82.589821000000171, 19.848189000000154],
              [82.585732, 19.846370000000146],
              [82.581498, 19.840490000000155],
              [82.58349600000011, 19.838321000000118],
              [82.578940000000145, 19.836629],
              [82.574195, 19.831980000000154],
              [82.571823, 19.827809],
              [82.571267000000134, 19.82238],
              [82.573831, 19.823709],
              [82.571839, 19.807609],
              [82.573035, 19.805560000000177],
              [82.571579, 19.802009000000165],
              [82.579278, 19.797212000000112],
              [82.577796000000134, 19.792330000000103],
              [82.577812, 19.787810000000203],
              [82.579291, 19.784661],
              [82.577912000000126, 19.77959],
              [82.578475000000168, 19.77582],
              [82.58129, 19.772691000000176],
              [82.58506, 19.771050000000113],
              [82.590926000000124, 19.762238000000192],
              [82.590539, 19.755939000000179],
              [82.593201, 19.751891000000107],
              [82.593506, 19.746971000000137],
              [82.595544000000103, 19.740910000000152],
              [82.585716000000147, 19.74019],
              [82.579879000000147, 19.73748],
              [82.574273000000161, 19.73176900000021],
              [82.566230000000118, 19.728061000000135],
              [82.563889000000174, 19.727819],
              [82.561097000000117, 19.728822],
              [82.556397000000104, 19.720979],
              [82.557022000000117, 19.714951],
              [82.560334, 19.714299000000146],
              [82.56153, 19.708900000000195],
              [82.566619000000102, 19.70751],
              [82.565888, 19.704811],
              [82.561728000000116, 19.702119],
              [82.562690000000131, 19.696791000000125],
              [82.560256000000138, 19.690510000000181],
              [82.559859000000159, 19.683759000000116],
              [82.560753, 19.677669000000144],
              [82.570708, 19.674382000000147],
              [82.567841000000129, 19.670271000000181],
              [82.564468000000133, 19.667110000000147],
              [82.550271000000166, 19.640569],
              [82.549736000000152, 19.6385],
              [82.540596, 19.635692000000113],
              [82.527892, 19.62763],
              [82.520362000000134, 19.62433],
              [82.519822, 19.62161100000014],
              [82.525962, 19.619182],
              [82.530404, 19.613219000000182],
              [82.533706, 19.610719],
              [82.533752000000135, 19.60743],
              [82.540307000000126, 19.605840000000168],
              [82.54220500000018, 19.604062000000166],
              [82.534759000000108, 19.588600000000152],
              [82.531022, 19.588101],
              [82.529397, 19.583281],
              [82.525276000000105, 19.580760000000165],
              [82.523482, 19.578481],
              [82.524246000000161, 19.57581],
              [82.528877000000179, 19.570561000000104],
              [82.537034, 19.56997100000012],
              [82.540229, 19.570771],
              [82.541558000000109, 19.573581],
              [82.551484000000158, 19.57353100000017],
              [82.551392, 19.566591],
              [82.556457, 19.56538],
              [82.559518000000182, 19.562481000000158],
              [82.561302, 19.55886],
              [82.560356000000112, 19.551701000000147],
              [82.560539000000105, 19.541231000000149],
              [82.561332, 19.537101],
              [82.570077, 19.535802],
              [82.577338, 19.540050000000175],
              [82.581322, 19.533650000000129],
              [82.585846, 19.534131000000169],
              [82.589493, 19.533060000000198],
              [82.594199, 19.53464200000013],
              [82.600243, 19.53324200000014],
              [82.603692000000109, 19.531601],
              [82.609237000000107, 19.532449],
              [82.609656000000115, 19.527301],
              [82.608047, 19.522991000000157],
              [82.606171000000103, 19.519330000000132],
              [82.601723000000135, 19.518681],
              [82.600585000000123, 19.514300000000159],
              [82.607842000000161, 19.51154],
              [82.610894, 19.513090000000197],
              [82.615226, 19.511552000000162],
              [82.619942000000137, 19.506921000000144],
              [82.627089000000154, 19.506891000000163],
              [82.635009000000181, 19.504571],
              [82.637642, 19.501150000000106],
              [82.629929, 19.484831],
              [82.627570000000148, 19.483680000000103],
              [82.626289, 19.476289000000119],
              [82.629195000000124, 19.474381],
              [82.634408000000164, 19.47628],
              [82.641373, 19.470860000000179],
              [82.642907000000122, 19.454681],
              [82.644652000000107, 19.451690000000148],
              [82.648743000000167, 19.44981],
              [82.653999, 19.448939000000106],
              [82.654106000000169, 19.442681000000103],
              [82.655114, 19.439360000000132],
              [82.657548, 19.436359000000149],
              [82.666626, 19.434241],
              [82.668189000000126, 19.42674100000016],
              [82.671760000000148, 19.427541000000129],
              [82.674347000000168, 19.43002],
              [82.68177, 19.418859000000104],
              [82.682381000000163, 19.414328],
              [82.685830000000109, 19.410721000000187],
              [82.691726000000173, 19.408631000000124],
              [82.701660000000146, 19.412330000000107],
              [82.700562, 19.408831000000131],
              [82.703019, 19.406629000000176],
              [82.705369000000104, 19.40652],
              [82.707335, 19.40126],
              [82.708001000000124, 19.396850000000196],
              [82.703903000000111, 19.395211000000124],
              [82.701629000000125, 19.393290000000142],
              [82.704491000000118, 19.389821000000207],
              [82.704560000000171, 19.3857],
              [82.700097000000184, 19.382049],
              [82.700813, 19.376992],
              [82.702187, 19.374061],
              [82.706383000000159, 19.371312000000156],
              [82.709031, 19.36726],
              [82.709779000000125, 19.36475],
              [82.706458000000154, 19.362401],
              [82.707231, 19.352031000000178],
              [82.713302000000155, 19.346679],
              [82.718772, 19.347588],
              [82.718642, 19.34399900000016],
              [82.719727, 19.339821000000139],
              [82.727599, 19.339931000000202],
              [82.735223, 19.342702000000141],
              [82.739838000000177, 19.337681000000199],
              [82.743011000000124, 19.332450000000101],
              [82.746728000000161, 19.331331],
              [82.749465, 19.321492],
              [82.758026000000129, 19.323031],
              [82.765289, 19.327432000000211],
              [82.762848000000119, 19.33073],
              [82.76577700000017, 19.334771],
              [82.771842000000149, 19.33486],
              [82.773376, 19.337312],
              [82.77947200000014, 19.335621000000113],
              [82.781373, 19.330010000000183],
              [82.783386000000149, 19.326901000000131],
              [82.79229, 19.322290000000176],
              [82.800058, 19.323500000000134],
              [82.805717, 19.321980000000107],
              [82.818580000000154, 19.315211000000144],
              [82.823546000000178, 19.317292000000176],
              [82.826562000000109, 19.315309],
              [82.830017, 19.318349],
              [82.833046000000181, 19.31545],
              [82.836091, 19.316708000000173],
              [82.841499, 19.316749],
              [82.84226900000013, 19.314299000000172],
              [82.838723, 19.311890000000169],
              [82.838853000000128, 19.30986],
              [82.844268000000156, 19.302512000000146],
              [82.833579, 19.300319],
              [82.836341000000104, 19.295581],
              [82.83262, 19.293001000000114],
              [82.830887, 19.29084],
              [82.830131, 19.28715],
              [82.825447, 19.28437],
              [82.824752000000146, 19.280621],
              [82.821609000000123, 19.275142],
              [82.823410000000123, 19.267520000000157],
              [82.822418, 19.261870000000211],
              [82.818931, 19.251819000000122],
              [82.819236, 19.249841],
              [82.817848000000168, 19.249],
              [82.810416, 19.249289000000196],
              [82.80947, 19.245041],
              [82.797705000000107, 19.230092],
              [82.802391, 19.223560000000184],
              [82.805512000000178, 19.222981],
              [82.810334000000168, 19.22424200000011],
              [82.814118000000107, 19.22624],
              [82.8161920000001, 19.227929000000184],
              [82.818261, 19.23134100000021],
              [82.820832000000152, 19.229201],
              [82.823029000000176, 19.228691000000133],
              [82.827735000000175, 19.229219000000167],
              [82.831193000000141, 19.228162000000108],
              [82.835259000000107, 19.223079000000151],
              [82.838791000000157, 19.21709],
              [82.840699000000129, 19.20692],
              [82.840439000000103, 19.201840000000171],
              [82.842506, 19.199119000000103],
              [82.844528000000167, 19.1979110000002],
              [82.848321000000141, 19.198750000000128],
              [82.848770000000158, 19.196662],
              [82.848503, 19.18832900000012],
              [82.848266, 19.188261],
              [82.845529, 19.18742],
              [82.834762, 19.193220000000164],
              [82.834664, 19.192801000000141],
              [82.832779000000116, 19.185581000000123],
              [82.82949700000016, 19.183860000000205],
              [82.828376000000148, 19.182502000000106],
              [82.829536000000175, 19.178762000000116],
              [82.829208, 19.175240000000198],
              [82.827241000000171, 19.172211],
              [82.820793000000123, 19.17336],
              [82.820549000000184, 19.171500000000204],
              [82.820370232811385, 19.170083659957807],
              [82.820251000000198, 19.169139000000254],
              [82.816468546680071, 19.166071296215186],
              [82.814683950925698, 19.161907239454987],
              [82.814981383551398, 19.154768856437496],
              [82.817063411931514, 19.147035608168544],
              [82.81614819606078, 19.145408557731621],
              [82.814386518299926, 19.142276686156887],
              [82.80962759628828, 19.139004927273898],
              [82.807545567908193, 19.144061281911259],
              [82.806653270030992, 19.150009934425835],
              [82.808140433159664, 19.155958586940411],
              [82.808201550574935, 19.161829675712905],
              [82.80668359919045, 19.160633585083524],
              [82.804848599858573, 19.159187672172148],
              [82.804283, 19.158742000000128],
              [82.802879000000118, 19.15275900000011],
              [82.793877000000109, 19.142610000000101],
              [82.784981000000158, 19.149178000000116],
              [82.784683000000186, 19.151681000000103],
              [82.786957, 19.153700000000182],
              [82.787796000000156, 19.156522000000106],
              [82.78504300000013, 19.160699000000186],
              [82.781731, 19.163842],
              [82.780708000000104, 19.16407],
              [82.778832000000122, 19.164490000000168],
              [82.773216000000147, 19.160499000000183],
              [82.769369801894001, 19.159894109943192],
              [82.766228000000339, 19.159400000000343],
              [82.76318237819774, 19.161781751760994],
              [82.759703511717561, 19.164502311601492],
              [82.758171752037228, 19.162204672080744],
              [82.757874319411471, 19.159230345823456],
              [82.756684588908556, 19.157743182694784],
              [82.75311539739981, 19.160420076326368],
              [82.748653908013893, 19.163394402583659],
              [82.745382149130862, 19.162799537332198],
              [82.736459170358998, 19.158338047946241],
              [82.733878000000161, 19.153071000000178],
              [82.730549414956428, 19.151418736941761],
              [82.728759000000238, 19.150530000000284],
              [82.726373889185638, 19.151644268443469],
              [82.723793, 19.15285],
              [82.715752000000165, 19.152909000000133],
              [82.718642, 19.157600000000112],
              [82.715951000000103, 19.160551],
              [82.715522000000121, 19.163161000000166],
              [82.718086000000184, 19.16472],
              [82.715973000000176, 19.166630000000108],
              [82.704787, 19.170630000000127],
              [82.700204000000127, 19.171420000000122],
              [82.699356000000179, 19.17927],
              [82.696298000000112, 19.18154],
              [82.688722000000141, 19.183322],
              [82.685645, 19.183051],
              [82.682258000000132, 19.18087],
              [82.678947, 19.180081000000193],
              [82.675491000000179, 19.180972000000164],
              [82.673730000000134, 19.187892],
              [82.671647, 19.18921100000011],
              [82.661552, 19.177802],
              [82.65915, 19.17757],
              [82.65445, 19.179532],
              [82.647057000000103, 19.180972000000164],
              [82.636810000000125, 19.170951],
              [82.631493, 19.168701],
              [82.631340000000179, 19.165520000000125],
              [82.63536, 19.152629],
              [82.634811000000113, 19.144830000000123],
              [82.63227, 19.142232],
              [82.629700168055621, 19.141688722778266],
              [82.629651255722735, 19.141678382430538],
              [82.629517000000277, 19.141650000000251],
              [82.629385859183145, 19.141706867328875],
              [82.62798388174609, 19.142314814675895],
              [82.628434573052601, 19.145662807241017],
              [82.628815286813548, 19.146995305404399],
              [82.627673145530679, 19.150421729252681],
              [82.623485294160432, 19.153277082459734],
              [82.622152795997266, 19.152896368698801],
              [82.619107085909761, 19.153467439340201],
              [82.618345658387838, 19.151183156774604],
              [82.618904126523006, 19.143661557236211],
              [82.617569000000259, 19.143480000000292],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Nayagarh",
          Dist_Code: "385",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [84.839959, 20.52757],
              [84.845039, 20.52208],
              [84.858163, 20.50765],
              [84.878342, 20.4929],
              [84.887862, 20.490231],
              [84.926261, 20.490880000000114],
              [84.939056, 20.485989],
              [84.993477, 20.4541],
              [85.007767, 20.442962],
              [85.02237, 20.438039],
              [85.03013700000011, 20.43366],
              [85.035133, 20.427801],
              [85.045761, 20.421631],
              [85.066697, 20.41313000000013],
              [85.070068, 20.409192],
              [85.076278000000102, 20.408702],
              [85.087211, 20.405611],
              [85.097419, 20.40418],
              [85.111671, 20.399619],
              [85.115281, 20.39528],
              [85.127372, 20.385249],
              [85.130791, 20.38137],
              [85.142403, 20.37884],
              [85.15409, 20.37157000000013],
              [85.166817, 20.37142],
              [85.179284, 20.368931],
              [85.187812, 20.370861],
              [85.19573200000012, 20.37141],
              [85.201653000000121, 20.36948],
              [85.205758, 20.366921],
              [85.219399, 20.364901],
              [85.228866, 20.362150000000153],
              [85.240342, 20.359898000000154],
              [85.249894, 20.359001],
              [85.264412, 20.35155],
              [85.27189, 20.350989],
              [85.335778, 20.350629],
              [85.342506, 20.35405],
              [85.348327, 20.354271],
              [85.356017, 20.357642],
              [85.36512, 20.359491],
              [85.366569, 20.348861],
              [85.368798000000126, 20.34863],
              [85.367814, 20.343710000000151],
              [85.365852, 20.34159],
              [85.361977, 20.34195],
              [85.35495, 20.338409000000123],
              [85.35276, 20.334721],
              [85.35302, 20.329121],
              [85.34871, 20.328690000000101],
              [85.348396, 20.326320000000116],
              [85.350502000000105, 20.3233],
              [85.347602, 20.32124],
              [85.347008, 20.316909],
              [85.344687, 20.313051],
              [85.346016, 20.309869],
              [85.348412, 20.30772],
              [85.348792, 20.299811],
              [85.3499, 20.294888],
              [85.347397, 20.291561],
              [85.345672, 20.286371],
              [85.343299000000101, 20.28257],
              [85.340378, 20.27976000000012],
              [85.339409, 20.277221],
              [85.329613, 20.275181000000138],
              [85.328797000000108, 20.27341],
              [85.325431, 20.271181000000123],
              [85.32415, 20.267780000000126],
              [85.324982, 20.257682],
              [85.321411, 20.252610000000114],
              [85.321121, 20.24678],
              [85.324257, 20.248029000000141],
              [85.332444, 20.247241000000141],
              [85.336517000000114, 20.246411],
              [85.336806, 20.244039],
              [85.334297, 20.23806],
              [85.328376, 20.23727],
              [85.322769, 20.23822],
              [85.320098, 20.23505],
              [85.317842, 20.223811],
              [85.313188, 20.224],
              [85.307533, 20.225701000000125],
              [85.302374999999898, 20.222442],
              [85.273651, 20.219378000000113],
              [85.26786, 20.219882],
              [85.249969000000107, 20.219378000000113],
              [85.24952, 20.21412],
              [85.250329, 20.207531],
              [85.245422000000104, 20.20375],
              [85.238152, 20.201011000000104],
              [85.233803000000123, 20.20097],
              [85.2294, 20.20295],
              [85.223839, 20.2132],
              [85.220527, 20.216101],
              [85.212691, 20.210121000000122],
              [85.209838, 20.206501000000113],
              [85.207581, 20.202752],
              [85.20713, 20.194549000000105],
              [85.205466000000101, 20.19173],
              [85.195167, 20.18312],
              [85.19561800000011, 20.17664000000013],
              [85.197585, 20.173401],
              [85.197854, 20.16508],
              [85.203468, 20.16379],
              [85.206818, 20.161409],
              [85.208236, 20.157591],
              [85.205688, 20.151360000000121],
              [85.199447, 20.14746],
              [85.200929, 20.144452],
              [85.204612, 20.142590000000151],
              [85.209526, 20.13761],
              [85.208183, 20.13397],
              [85.208648, 20.12987000000015],
              [85.208076, 20.12502],
              [85.211326, 20.12097],
              [85.221284, 20.119021],
              [85.223137, 20.11485],
              [85.22612, 20.11114200000014],
              [85.234687, 20.1073],
              [85.238473, 20.117041],
              [85.24211, 20.121059],
              [85.246131, 20.12422],
              [85.249686, 20.12548],
              [85.252403, 20.12553],
              [85.26123, 20.13611],
              [85.26477, 20.139221],
              [85.284828000000104, 20.143631],
              [85.288598, 20.146569],
              [85.291497, 20.144411],
              [85.295417, 20.146471],
              [85.305976, 20.146941],
              [85.308547, 20.148732000000106],
              [85.308518, 20.15126],
              [85.306252, 20.1593],
              [85.317771, 20.165951],
              [85.327049, 20.173009],
              [85.341437, 20.17455],
              [85.342613, 20.17744],
              [85.345519, 20.181121],
              [85.35212, 20.18051],
              [85.356812, 20.178461],
              [85.362526, 20.173531000000136],
              [85.36406, 20.17063],
              [85.364051, 20.1655],
              [85.361236, 20.16152],
              [85.357788, 20.158769000000117],
              [85.35575, 20.1496],
              [85.351723, 20.14592],
              [85.349991, 20.137911],
              [85.356338, 20.138549],
              [85.369147, 20.138152],
              [85.373849, 20.142761],
              [85.377038000000113, 20.142681],
              [85.377113, 20.14545000000015],
              [85.378419, 20.148611],
              [85.380691, 20.147330000000121],
              [85.381692, 20.143109],
              [85.38385, 20.140689],
              [85.382378, 20.136119000000118],
              [85.383743, 20.131269],
              [85.386222, 20.128202],
              [85.38929, 20.126741],
              [85.390441, 20.129731],
              [85.3936, 20.13255],
              [85.399726, 20.128420000000116],
              [85.408287, 20.120179],
              [85.408157, 20.115561],
              [85.400421, 20.108498],
              [85.3983, 20.105440000000154],
              [85.39631700000011, 20.088649000000139],
              [85.393646, 20.084501],
              [85.390122, 20.081060000000146],
              [85.384682, 20.082471],
              [85.378998000000124, 20.082439],
              [85.374749, 20.076800000000102],
              [85.37474, 20.073739],
              [85.377258999999896, 20.071702],
              [85.374733, 20.064101000000104],
              [85.379829, 20.054141],
              [85.380837, 20.048530000000135],
              [85.386063, 20.04025],
              [85.38816, 20.04007],
              [85.388069, 20.037241000000105],
              [85.389411, 20.03331],
              [85.391854000000109, 20.03243],
              [85.390717, 20.028920000000138],
              [85.393668, 20.025962],
              [85.397315, 20.0257],
              [85.401267, 20.024259000000139],
              [85.405853, 20.0259],
              [85.407981000000106, 20.02381],
              [85.407067, 20.01845],
              [85.407409, 20.01458],
              [85.40882, 20.013071],
              [85.408927, 20.017579],
              [85.411147, 20.019471],
              [85.415977, 20.01662],
              [85.42012, 20.019649],
              [85.424605, 20.02038],
              [85.428917, 20.019541],
              [85.425752, 20.010901],
              [85.422781999999899, 20.006361],
              [85.420058, 20.003829000000106],
              [85.41909, 19.998929],
              [85.415336, 19.996],
              [85.412002, 19.99626],
              [85.410698, 19.99311],
              [85.410598, 19.987422],
              [85.417549, 19.985781],
              [85.426919, 19.985411],
              [85.43463100000011, 19.986722],
              [85.435463, 19.982911],
              [85.441628, 19.980069000000121],
              [85.447472, 19.97343],
              [85.451027, 19.965471],
              [85.4478, 19.956421],
              [85.44027, 19.947621000000137],
              [85.434745, 19.93824],
              [85.430221000000103, 19.932481],
              [85.425041, 19.930361],
              [85.418716000000103, 19.92991],
              [85.416175, 19.926459000000133],
              [85.415297, 19.9192],
              [85.397538, 19.921881],
              [85.392638, 19.925411000000107],
              [85.391328, 19.9314],
              [85.389001, 19.9321],
              [85.38395, 19.931699],
              [85.378669, 19.932410000000115],
              [85.378243, 19.942381],
              [85.369231, 19.944139],
              [85.35733, 19.95055],
              [85.351096, 19.94578],
              [85.343712, 19.934901],
              [85.336793, 19.933531000000126],
              [85.328232, 19.927442],
              [85.3256, 19.91804],
              [85.314956, 19.918462000000144],
              [85.286766, 19.913090000000118],
              [85.27121, 19.904992],
              [85.265228, 19.90943000000015],
              [85.261483, 19.90478],
              [85.251808, 19.901099],
              [85.238983, 19.897770000000147],
              [85.227768000000111, 19.90166],
              [85.218063, 19.90391],
              [85.20388, 19.90421],
              [85.190467, 19.89962],
              [85.179414, 19.899000000000111],
              [85.174682, 19.90171],
              [85.170272, 19.89924],
              [85.16085, 19.896881000000118],
              [85.148522, 19.908242],
              [85.131791, 19.916041],
              [85.121489, 19.925792],
              [85.091927, 19.922981],
              [85.084458, 19.91647],
              [85.069183, 19.913022],
              [85.049569, 19.90728],
              [85.022331, 19.8958],
              [85.01638, 19.897368],
              [85.0103, 19.894260000000141],
              [85.003562, 19.892199],
              [84.993377, 19.895611],
              [84.987251, 19.895960000000112],
              [84.977867, 19.897861],
              [84.968979, 19.897409],
              [84.952881, 19.892341],
              [84.946053000000106, 19.893592000000123],
              [84.94358, 19.892001000000104],
              [84.93837, 19.890251],
              [84.933762, 19.889631000000115],
              [84.927872, 19.8941],
              [84.925393, 19.897409],
              [84.919998, 19.89691],
              [84.904969, 19.897861],
              [84.900117, 19.903761],
              [84.899568, 19.906841000000153],
              [84.911294, 19.920591000000108],
              [84.917449999999889, 19.933990000000104],
              [84.911902, 19.942502],
              [84.908149, 19.95132000000012],
              [84.903718, 19.962761],
              [84.900559, 19.974319],
              [84.895477, 19.985772],
              [84.888024, 19.987381],
              [84.884484, 19.989259],
              [84.881608, 19.992281],
              [84.863662, 19.991622],
              [84.856346, 19.993151],
              [84.853866, 20.001199],
              [84.853203, 20.011861],
              [84.85022, 20.023149],
              [84.833037, 20.043712000000138],
              [84.821227, 20.051980000000125],
              [84.8107, 20.055741000000122],
              [84.804329, 20.06251],
              [84.792558, 20.08753],
              [84.793907, 20.090669],
              [84.799796, 20.093839],
              [84.802032, 20.098591000000106],
              [84.79847, 20.103332],
              [84.797118, 20.10753],
              [84.802932, 20.108802000000136],
              [84.808067, 20.108592000000151],
              [84.813767, 20.110500000000112],
              [84.815484, 20.115881],
              [84.819153, 20.135151000000114],
              [84.821122, 20.15505],
              [84.81955, 20.163391],
              [84.819916, 20.176761],
              [84.828614, 20.20156],
              [84.828185, 20.21018],
              [84.82225, 20.215789000000139],
              [84.813767, 20.216609],
              [84.785606, 20.22256],
              [84.774170000000126, 20.228452],
              [84.77089, 20.23628],
              [84.76284, 20.240882],
              [84.757637, 20.239941],
              [84.753402, 20.236351],
              [84.745872, 20.23629],
              [84.737213, 20.238421],
              [84.724906, 20.245629],
              [84.708603, 20.26653100000015],
              [84.701187, 20.272510000000118],
              [84.690003, 20.274941],
              [84.681609, 20.271101],
              [84.6669, 20.266951],
              [84.662902, 20.260259],
              [84.660737, 20.25207],
              [84.660714, 20.24253],
              [84.656746, 20.236419],
              [84.649268, 20.229131],
              [84.645683, 20.223871],
              [84.643409, 20.21694],
              [84.641374, 20.200179],
              [84.634071, 20.192890000000144],
              [84.626992, 20.187131],
              [84.600381, 20.17256],
              [84.593689, 20.17099],
              [84.587647, 20.173219],
              [84.583283, 20.17669],
              [84.577911000000128, 20.184312],
              [84.569733, 20.199292000000121],
              [84.546967, 20.227171],
              [84.540627, 20.238001],
              [84.538689, 20.24611],
              [84.540994, 20.252189],
              [84.540337, 20.26224],
              [84.538986, 20.26845000000014],
              [84.545158, 20.276961],
              [84.54663, 20.28115],
              [84.539674, 20.31548],
              [84.537208, 20.320481],
              [84.53241, 20.318901],
              [84.526047, 20.318081],
              [84.519599000000127, 20.3226],
              [84.515449, 20.321871],
              [84.509628, 20.314510000000148],
              [84.504805, 20.321889],
              [84.505988, 20.326131000000139],
              [84.50618, 20.333812],
              [84.503242, 20.333392],
              [84.499351, 20.328581000000153],
              [84.482559, 20.33248],
              [84.48069700000012, 20.3361],
              [84.478607, 20.344731],
              [84.484993, 20.348831],
              [84.497018, 20.358631],
              [84.512978, 20.366280000000124],
              [84.514077, 20.375280000000139],
              [84.512703, 20.37724],
              [84.508666, 20.378991],
              [84.505624, 20.38808],
              [84.506073000000114, 20.392392],
              [84.511773000000105, 20.400271],
              [84.514396, 20.399040000000124],
              [84.518189, 20.399722],
              [84.520974, 20.403250000000124],
              [84.524773, 20.40495],
              [84.529008, 20.406131000000126],
              [84.533593, 20.40645],
              [84.536132, 20.409071],
              [84.536713, 20.413041],
              [84.540169, 20.415881],
              [84.545128, 20.416711000000131],
              [84.548462000000129, 20.414329],
              [84.550523, 20.41076200000014],
              [84.554885, 20.40678],
              [84.563156, 20.408389],
              [84.587983, 20.418671000000128],
              [84.594681, 20.415979],
              [84.598906, 20.416191],
              [84.61541, 20.428191],
              [84.627877, 20.42443],
              [84.634087, 20.42077],
              [84.640792, 20.418939],
              [84.657195, 20.41935],
              [84.663825, 20.421301000000138],
              [84.66845, 20.423739],
              [84.67147, 20.428601],
              [84.67701, 20.430862],
              [84.679467, 20.433082],
              [84.685669, 20.43604],
              [84.68576, 20.43865900000014],
              [84.682412, 20.442292],
              [84.683, 20.444299],
              [84.685883, 20.44612],
              [84.686127, 20.45123],
              [84.678093, 20.4568],
              [84.680862, 20.459711],
              [84.687202, 20.46346],
              [84.693153, 20.492749],
              [84.698211, 20.49708],
              [84.705903, 20.501779],
              [84.709764, 20.514962000000132],
              [84.713966, 20.519689],
              [84.723251, 20.523411],
              [84.73008, 20.528021],
              [84.732528, 20.533051],
              [84.737977, 20.534442],
              [84.757568, 20.52615],
              [84.764296, 20.5253],
              [84.770462000000109, 20.529778000000132],
              [84.775291, 20.542371],
              [84.78173, 20.543481],
              [84.784073, 20.5504],
              [84.789672, 20.554261000000107],
              [84.78688, 20.570071000000151],
              [84.787728, 20.57517],
              [84.793998, 20.57323],
              [84.81888600000012, 20.554149000000102],
              [84.839959, 20.52757],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Nuapada",
          Dist_Code: "394",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [82.682411, 20.828359],
              [82.679459, 20.816861],
              [82.683646, 20.78225],
              [82.68425, 20.768981],
              [82.689652, 20.762319],
              [82.691062, 20.753501],
              [82.690292, 20.748662],
              [82.682794, 20.735411],
              [82.682053, 20.73101],
              [82.683448, 20.725549],
              [82.695541, 20.72188],
              [82.694946, 20.715982],
              [82.688264, 20.69734],
              [82.68892, 20.676831],
              [82.697036, 20.676281],
              [82.712951, 20.671671000000114],
              [82.716682, 20.667801],
              [82.720124, 20.662269],
              [82.720101, 20.649989000000115],
              [82.726068, 20.646801],
              [82.724297, 20.63767],
              [82.724021, 20.631469],
              [82.725272, 20.627410000000104],
              [82.734626, 20.624821000000107],
              [82.735801999999893, 20.61895],
              [82.725571, 20.593521],
              [82.722581, 20.583299],
              [82.722863000000117, 20.576991],
              [82.708336, 20.566181000000139],
              [82.706016, 20.562851000000133],
              [82.706009, 20.553461],
              [82.703812, 20.543342],
              [82.703406, 20.537081],
              [82.700279, 20.530870000000103],
              [82.701011, 20.523511000000152],
              [82.702729, 20.516541],
              [82.700042, 20.495951000000101],
              [82.696181000000109, 20.490479],
              [82.694602, 20.481809000000109],
              [82.690529, 20.471941],
              [82.684303, 20.468759],
              [82.682502, 20.464201],
              [82.684159, 20.460479],
              [82.679443, 20.45015],
              [82.679284, 20.44576],
              [82.686593000000101, 20.444701],
              [82.690399, 20.440831],
              [82.694894, 20.432920000000134],
              [82.691231, 20.422871000000153],
              [82.691131, 20.418992],
              [82.698905, 20.413239],
              [82.703301, 20.408622],
              [82.705642, 20.40506],
              [82.708801, 20.39773],
              [82.716568, 20.39105],
              [82.71794, 20.389169],
              [82.718232, 20.386391],
              [82.724778000000114, 20.379791],
              [82.721733, 20.376969],
              [82.721040000000116, 20.37397],
              [82.714212, 20.365931],
              [82.709266, 20.36251],
              [82.709311, 20.357401000000149],
              [82.712165000000127, 20.35297],
              [82.717247, 20.351931],
              [82.722633, 20.352229000000133],
              [82.727622, 20.353339],
              [82.737937, 20.357631],
              [82.7455, 20.356751],
              [82.750931, 20.354789],
              [82.757438, 20.349902000000153],
              [82.763847, 20.350192],
              [82.768897, 20.351810000000111],
              [82.772475, 20.354611],
              [82.777152, 20.36453],
              [82.783408, 20.367709],
              [82.788247, 20.366791],
              [82.790977, 20.369311],
              [82.795303, 20.376390000000125],
              [82.79875800000012, 20.379481],
              [82.804917, 20.378380000000103],
              [82.809899, 20.378549],
              [82.808242, 20.368142000000145],
              [82.807868, 20.359520000000142],
              [82.797829, 20.35284],
              [82.793847, 20.348421],
              [82.787789, 20.34564],
              [82.785713, 20.342069],
              [82.788377, 20.334860000000102],
              [82.784867, 20.321411],
              [82.786925, 20.319521],
              [82.791078, 20.31757],
              [82.797737, 20.316062],
              [82.802590000000109, 20.319191],
              [82.807228, 20.323471000000151],
              [82.805785000000114, 20.331500000000112],
              [82.802239, 20.334949],
              [82.80153, 20.3378],
              [82.803909, 20.33968],
              [82.80581, 20.342511],
              [82.806831, 20.349791],
              [82.810013, 20.353982],
              [82.814209, 20.349371000000129],
              [82.817046, 20.341752000000152],
              [82.819458, 20.33958],
              [82.834352, 20.33212],
              [82.837508, 20.335161000000138],
              [82.842087, 20.337321000000141],
              [82.845643, 20.335822000000118],
              [82.847557, 20.33238],
              [82.848031, 20.323339],
              [82.844788, 20.312009],
              [82.84536700000011, 20.29255],
              [82.845048, 20.290702],
              [82.843277, 20.28845],
              [82.839881, 20.287559],
              [82.835876, 20.28778],
              [82.832702, 20.290189],
              [82.835587, 20.29745],
              [82.83078, 20.3017420000001],
              [82.830017, 20.304641],
              [82.831031, 20.31009],
              [82.829812, 20.315772],
              [82.815772, 20.317080000000143],
              [82.812707, 20.311141],
              [82.814719, 20.305669000000133],
              [82.814927, 20.301851],
              [82.813081, 20.297462],
              [82.806922, 20.29041],
              [82.809304, 20.28610000000014],
              [82.813201, 20.2813],
              [82.817887, 20.27766],
              [82.825203, 20.276140000000108],
              [82.832467, 20.27635],
              [82.834892, 20.277082],
              [82.839240000000117, 20.28293],
              [82.843049, 20.28272],
              [82.848938, 20.277209],
              [82.852646, 20.272020000000104],
              [82.854951000000128, 20.265501],
              [82.853387, 20.25133],
              [82.849084, 20.249980000000104],
              [82.847473, 20.245661000000151],
              [82.847138, 20.23407],
              [82.850937, 20.23309],
              [82.855292, 20.230159],
              [82.850967, 20.213001],
              [82.849549, 20.209131000000124],
              [82.845276, 20.20414],
              [82.841476, 20.19137],
              [82.835457000000119, 20.186862],
              [82.824355, 20.18183],
              [82.819818, 20.181752],
              [82.813728, 20.183612],
              [82.810699, 20.183471000000107],
              [82.80671, 20.1756390000001],
              [82.805473, 20.171191000000128],
              [82.805687, 20.168011],
              [82.810302, 20.164369],
              [82.81746600000011, 20.16052],
              [82.813896, 20.150631],
              [82.80983, 20.123620000000123],
              [82.813714, 20.10794],
              [82.810569, 20.1035],
              [82.807793, 20.096640000000143],
              [82.803971, 20.09424],
              [82.795905, 20.094562],
              [82.782798, 20.096549],
              [82.774087, 20.081931000000107],
              [82.761292, 20.070070000000154],
              [82.748864000000125, 20.050481000000101],
              [82.73172, 20.04700100000013],
              [82.73252, 20.04381],
              [82.740693000000121, 20.03671],
              [82.731086, 20.019149],
              [82.723221, 20.016492],
              [82.715461, 20.016399],
              [82.699333000000124, 19.99541],
              [82.698021, 19.992732],
              [82.692307, 19.99242],
              [82.686447, 19.994631],
              [82.681023, 19.995451],
              [82.650482, 19.999401],
              [82.641899000000123, 19.99791],
              [82.636254, 19.998291],
              [82.631759, 20.000089000000113],
              [82.623582, 19.997641],
              [82.620888, 19.99556],
              [82.618759000000111, 19.99157],
              [82.614388000000119, 19.98697],
              [82.598365, 19.985639],
              [82.582359, 19.98994],
              [82.578719, 19.99564],
              [82.575943, 19.998952],
              [82.543618, 20.01213],
              [82.531983, 20.01223],
              [82.524246, 20.010441],
              [82.502129000000124, 20.013531],
              [82.490065000000101, 20.018571],
              [82.481589, 20.02456],
              [82.475907, 20.030051],
              [82.470773000000108, 20.03202],
              [82.464097, 20.031550000000149],
              [82.458329, 20.03387],
              [82.4515, 20.035261],
              [82.441429, 20.035352],
              [82.431922, 20.038971],
              [82.424782, 20.043541],
              [82.417138, 20.04535],
              [82.406189, 20.04631],
              [82.395766, 20.048999],
              [82.390862, 20.05959],
              [82.390342, 20.064231],
              [82.392601, 20.0733110000001],
              [82.394668, 20.08916],
              [82.392646, 20.108250000000108],
              [82.390738, 20.11905100000012],
              [82.387757000000121, 20.126939],
              [82.386581, 20.13338],
              [82.382285, 20.13817],
              [82.37893, 20.14463],
              [82.387192000000127, 20.148851],
              [82.383302000000114, 20.16046],
              [82.390488, 20.167312000000148],
              [82.405747, 20.17899],
              [82.407631, 20.1941],
              [82.413598, 20.202271],
              [82.413085, 20.207951],
              [82.413651, 20.213279],
              [82.412773, 20.21745],
              [82.408188, 20.220630000000138],
              [82.40728, 20.22764],
              [82.404327, 20.239601],
              [82.40837, 20.241661000000132],
              [82.414077, 20.24155],
              [82.405373, 20.255872],
              [82.405083, 20.26353],
              [82.412322, 20.269902],
              [82.420823, 20.272601],
              [82.428048, 20.278611],
              [82.429231, 20.282962],
              [82.428337, 20.289861],
              [82.423957, 20.296502],
              [82.422439, 20.309660000000115],
              [82.416299, 20.31696],
              [82.4071730000001, 20.322072],
              [82.400459, 20.32467],
              [82.400299000000103, 20.329251],
              [82.398788, 20.331651],
              [82.393777, 20.335521],
              [82.394417, 20.340138],
              [82.397956, 20.3467710000001],
              [82.397941, 20.35586],
              [82.402519, 20.36133],
              [82.403075, 20.365261],
              [82.410407, 20.377202],
              [82.410606, 20.382471],
              [82.412744, 20.388242],
              [82.409897, 20.40268],
              [82.417687, 20.40562900000014],
              [82.424285, 20.410151],
              [82.422959, 20.418331],
              [82.429169, 20.425752],
              [82.42774300000012, 20.432070000000117],
              [82.425653, 20.43632],
              [82.417717, 20.438301],
              [82.419403, 20.44558],
              [82.419387000000128, 20.45728100000013],
              [82.416098, 20.466181],
              [82.410079, 20.473301000000102],
              [82.406403, 20.46614],
              [82.397316, 20.451919],
              [82.388092000000128, 20.452511],
              [82.390068, 20.45939],
              [82.389603000000122, 20.465361],
              [82.385139, 20.470489000000153],
              [82.386132, 20.475521000000121],
              [82.383751, 20.48266],
              [82.381232000000111, 20.5018],
              [82.381317, 20.507771],
              [82.380494, 20.50985],
              [82.369950000000117, 20.513941],
              [82.358514, 20.51624],
              [82.348793, 20.52293],
              [82.342248, 20.537692],
              [82.336089000000101, 20.543239000000138],
              [82.3277590000001, 20.54927],
              [82.324012, 20.55388],
              [82.324463, 20.556649],
              [82.326378, 20.556579],
              [82.327477, 20.557898000000129],
              [82.327827, 20.56196],
              [82.332352, 20.562272],
              [82.337151, 20.565180000000108],
              [82.340636, 20.569732],
              [82.34253000000011, 20.57522],
              [82.337669000000105, 20.584931],
              [82.338371, 20.59083],
              [82.338676, 20.594321],
              [82.345489, 20.5979],
              [82.348, 20.60164],
              [82.355827, 20.60349],
              [82.357857000000124, 20.609211000000126],
              [82.356659, 20.61136],
              [82.358176, 20.615169000000147],
              [82.366333, 20.620251],
              [82.368232, 20.624059],
              [82.367546, 20.629570000000108],
              [82.363799, 20.63956],
              [82.362252, 20.65047],
              [82.365807000000103, 20.66115],
              [82.365226, 20.663762000000126],
              [82.360688, 20.671912],
              [82.354286000000101, 20.675041],
              [82.351319, 20.67807],
              [82.345566000000105, 20.694911],
              [82.343301, 20.698852],
              [82.34426, 20.709511],
              [82.346993, 20.714240000000125],
              [82.339408, 20.72583],
              [82.34586200000011, 20.72872],
              [82.340401, 20.74672],
              [82.33513, 20.758519],
              [82.33693, 20.779300000000141],
              [82.338790000000117, 20.79017],
              [82.33567, 20.797372000000102],
              [82.333106, 20.819691],
              [82.335549, 20.827832],
              [82.334038, 20.840589],
              [82.336876, 20.849252],
              [82.341217, 20.868061000000122],
              [82.346619, 20.883849],
              [82.359177, 20.882709],
              [82.356178, 20.87636],
              [82.355918, 20.869939],
              [82.35904, 20.866541],
              [82.368011, 20.864100000000114],
              [82.376672, 20.86692],
              [82.382798, 20.869939],
              [82.401414, 20.862430000000124],
              [82.402467, 20.85796],
              [82.40226, 20.853281],
              [82.40728, 20.848021],
              [82.407372, 20.843499],
              [82.405633, 20.837209],
              [82.413491, 20.829562],
              [82.415526, 20.826469],
              [82.422943, 20.826],
              [82.436501, 20.82953],
              [82.439391, 20.82719],
              [82.441087, 20.823762],
              [82.444656000000109, 20.82407],
              [82.448371, 20.82218],
              [82.453506, 20.821221],
              [82.459053, 20.823842],
              [82.462463, 20.827579000000121],
              [82.46231, 20.830351],
              [82.45983, 20.83565],
              [82.463386, 20.83967],
              [82.468261, 20.842631],
              [82.477624, 20.84672],
              [82.481927, 20.85531],
              [82.481368, 20.861459],
              [82.484527, 20.872891],
              [82.484673, 20.879551000000102],
              [82.483139, 20.899659],
              [82.485671, 20.903511000000147],
              [82.493637, 20.90935],
              [82.503098, 20.91389],
              [82.513443, 20.91722],
              [82.519241, 20.924691],
              [82.526254, 20.927709],
              [82.535851, 20.929521],
              [82.545738, 20.93494],
              [82.55294, 20.941481000000117],
              [82.566512, 20.967001],
              [82.578134, 20.978941],
              [82.582076, 20.986779],
              [82.595147, 20.99712900000014],
              [82.604446, 21.005872],
              [82.607728, 21.012162],
              [82.608619, 21.018199000000148],
              [82.62230799999989, 21.036569],
              [82.620033, 21.0444],
              [82.609123, 21.0639210000001],
              [82.609383, 21.071198],
              [82.615249000000105, 21.075171000000122],
              [82.621941, 21.075201],
              [82.625877, 21.076821],
              [82.631837, 21.086959],
              [82.635490000000104, 21.084130000000126],
              [82.639786000000115, 21.078291],
              [82.644548, 21.075732],
              [82.654159, 21.07332],
              [82.661315000000101, 21.065571],
              [82.666496, 21.05694],
              [82.67543, 21.032551],
              [82.686418, 21.01843],
              [82.684113, 20.996880000000143],
              [82.682327, 20.96902],
              [82.694023, 20.936889],
              [82.69291800000012, 20.927909],
              [82.689782, 20.916019],
              [82.689561, 20.89836],
              [82.687318, 20.89248],
              [82.678917, 20.880002000000101],
              [82.678192000000124, 20.86921],
              [82.681107, 20.854311],
              [82.680382, 20.845409000000128],
              [82.682411, 20.828359],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Puri",
          Dist_Code: "387",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [86.240554, 19.909446000000113],
                [86.240281, 19.90916500000014],
                [86.239907000000159, 19.90916500000014],
                [86.239722000000185, 19.90916500000014],
                [86.239442, 19.909446000000113],
                [86.238610000000151, 19.909446000000113],
                [86.237778, 19.908611000000114],
                [86.237778, 19.908333],
                [86.23722, 19.907777],
                [86.236946000000131, 19.908055000000157],
                [86.236657, 19.908331],
                [86.236664000000118, 19.908889],
                [86.23722, 19.909446000000113],
                [86.23722, 19.909719000000162],
                [86.237778, 19.910277000000114],
                [86.237778, 19.910555],
                [86.237999, 19.910774],
                [86.238334, 19.911112000000113],
                [86.240219, 19.911112000000113],
                [86.240554, 19.911112000000113],
                [86.241113000000141, 19.910555],
                [86.241113000000141, 19.910277000000114],
                [86.240547, 19.909719000000162],
                [86.240554, 19.909446000000113],
              ],
            ],
            [
              [
                [86.372498, 19.954445000000131],
                [86.371666000000104, 19.953611000000191],
                [86.371506, 19.953759],
                [86.370934000000133, 19.9538930000001],
                [86.370438000000135, 19.9538930000001],
                [86.370201, 19.953804],
                [86.37008, 19.953759],
                [86.369622, 19.953319000000189],
                [86.369088000000119, 19.952970000000104],
                [86.368240000000171, 19.952359000000168],
                [86.367821000000134, 19.952159000000162],
                [86.366599000000107, 19.952223000000114],
                [86.366203, 19.952161000000157],
                [86.365722000000162, 19.95190400000018],
                [86.364480000000114, 19.95166],
                [86.363265000000112, 19.951589],
                [86.362930000000105, 19.95152500000011],
                [86.361114000000128, 19.951110000000195],
                [86.36083300000017, 19.950830000000163],
                [86.360001, 19.950835000000207],
                [86.359726, 19.950557000000114],
                [86.359452, 19.950559000000109],
                [86.359391, 19.950500000000201],
                [86.359169, 19.95029],
                [86.358611000000138, 19.95029],
                [86.358331, 19.95],
                [86.357032, 19.94972000000012],
                [86.356391000000116, 19.949722000000115],
                [86.355407, 19.949588],
                [86.355133000000123, 19.949921],
                [86.355263, 19.95020100000016],
                [86.355477000000164, 19.950331],
                [86.357009, 19.95075700000012],
                [86.357307, 19.950835000000207],
                [86.357408, 19.950860000000144],
                [86.358764, 19.951131000000199],
                [86.360184, 19.951402000000193],
                [86.362891, 19.952280000000197],
                [86.365173, 19.953189000000116],
                [86.367463, 19.953460000000117],
                [86.368462, 19.95421],
                [86.369179, 19.95441100000016],
                [86.369895000000128, 19.954627],
                [86.37008, 19.95479100000011],
                [86.370827000000162, 19.954976000000155],
                [86.371110000000144, 19.955311000000162],
                [86.371253, 19.955787],
                [86.371322, 19.955992000000204],
                [86.371322, 19.956533000000199],
                [86.371390000000162, 19.956940000000142],
                [86.372092, 19.957640000000133],
                [86.372300000000152, 19.957640000000133],
                [86.372657, 19.957230000000148],
                [86.372582, 19.956542],
                [86.372231000000141, 19.956011],
                [86.372222000000107, 19.955281000000181],
                [86.372498, 19.954721],
                [86.372498, 19.954445000000131],
              ],
            ],
            [
              [
                [86.321106, 19.988060000000182],
                [86.320556, 19.988060000000182],
                [86.32, 19.988611000000102],
                [86.32, 19.989165000000121],
                [86.319724000000164, 19.989445],
                [86.319724000000164, 19.990555000000196],
                [86.31887000000016, 19.991832000000151],
                [86.318795000000179, 19.99257700000015],
                [86.31861200000013, 19.993320000000207],
                [86.31861200000013, 19.993609000000102],
                [86.318336, 19.99389],
                [86.318336, 19.994719000000138],
                [86.31861200000013, 19.995000000000111],
                [86.319442, 19.994170000000164],
                [86.319442, 19.993609000000102],
                [86.319734, 19.993329],
                [86.319724000000164, 19.993056000000191],
                [86.320732, 19.99141],
                [86.320946000000149, 19.990735000000196],
                [86.321372, 19.989459000000121],
                [86.321502000000152, 19.989081000000109],
                [86.321450000000127, 19.988395000000192],
                [86.321106, 19.988060000000182],
              ],
            ],
            [
              [
                [86.321388000000155, 19.99889],
                [86.321388000000155, 19.99778],
                [86.321664, 19.997500000000169],
                [86.321664, 19.996670000000105],
                [86.32195300000015, 19.996390000000186],
                [86.321944000000116, 19.995000000000111],
                [86.321664, 19.994722000000191],
                [86.321664, 19.99389],
                [86.321106, 19.993329],
                [86.320832000000152, 19.993329],
                [86.320274, 19.99389],
                [86.32, 19.994439],
                [86.32, 19.995000000000111],
                [86.319734, 19.995269000000174],
                [86.319724000000164, 19.995556],
                [86.319442, 19.995832],
                [86.319442, 19.996112],
                [86.31861200000013, 19.996944000000209],
                [86.31861200000013, 19.997222],
                [86.318336, 19.997500000000169],
                [86.318336, 19.997778],
                [86.31778, 19.998332000000115],
                [86.317498000000143, 19.998332000000115],
                [86.317222, 19.998612000000204],
                [86.31611, 19.998610000000209],
                [86.315834000000152, 19.998888],
                [86.315613000000141, 19.999164],
                [86.316039, 19.999433],
                [86.316673000000137, 20.00000000000011],
                [86.316857, 20.000388000000211],
                [86.317352000000184, 20.000652],
                [86.317498000000143, 20.000834000000161],
                [86.31778, 20.00111],
                [86.318177, 20.001190000000118],
                [86.318268, 20.001728],
                [86.318596, 20.002131000000187],
                [86.31900900000015, 20.002332000000131],
                [86.319442, 20.002261000000139],
                [86.319900000000118, 20.002145],
                [86.320212000000183, 20.001880000000195],
                [86.320328000000174, 20.00148200000012],
                [86.320472, 20.001126000000166],
                [86.320641000000165, 20.000789000000164],
                [86.320953, 20.000435000000206],
                [86.320556, 20.00000000000011],
                [86.321106, 19.999171],
                [86.321388000000155, 19.99889],
              ],
            ],
            [
              [
                [86.321388000000155, 20.010001000000155],
                [86.321112, 20.010001000000155],
                [86.320832000000152, 20.01027],
                [86.320832000000152, 20.010562],
                [86.320274, 20.011111000000138],
                [86.320274, 20.011943],
                [86.32, 20.012223000000169],
                [86.32, 20.012492],
                [86.322136, 20.011024],
                [86.321944000000116, 20.010833],
                [86.321944000000116, 20.010555000000174],
                [86.321388000000155, 20.010001000000155],
              ],
            ],
            [
              [
                [86.310426000000163, 20.016246000000134],
                [86.310556, 20.016111000000134],
                [86.311385000000129, 20.016111000000134],
                [86.311944, 20.015555000000173],
                [86.312500000000156, 20.015555000000173],
                [86.313058000000169, 20.016111000000134],
                [86.313332000000102, 20.016111000000134],
                [86.313614000000115, 20.015833],
                [86.314163000000107, 20.015833],
                [86.314720000000165, 20.015277],
                [86.314720000000165, 20.014999000000156],
                [86.315002, 20.014721],
                [86.315002, 20.013335000000151],
                [86.314720000000165, 20.013060000000106],
                [86.314720000000165, 20.012221000000174],
                [86.314446, 20.011943],
                [86.314446, 20.011389],
                [86.314720000000165, 20.011111000000138],
                [86.314720000000165, 20.010831000000106],
                [86.31527800000012, 20.010279],
                [86.31527800000012, 20.010001000000155],
                [86.31555100000017, 20.009721],
                [86.31555100000017, 20.009167],
                [86.315827000000112, 20.008891000000169],
                [86.315827000000112, 20.008611],
                [86.31527800000012, 20.008055],
                [86.313332000000102, 20.008055],
                [86.313058000000169, 20.008333000000157],
                [86.313058000000169, 20.008611],
                [86.312766000000167, 20.008891000000169],
                [86.313332000000102, 20.009452],
                [86.313332000000102, 20.010001000000155],
                [86.311944, 20.011391],
                [86.311401, 20.011391],
                [86.311112, 20.011111000000138],
                [86.310836000000137, 20.011111000000138],
                [86.310546000000144, 20.011391],
                [86.310280000000134, 20.011391],
                [86.309997000000152, 20.011667000000156],
                [86.310280000000134, 20.011943],
                [86.310280000000134, 20.012221000000174],
                [86.310546000000144, 20.012501],
                [86.310546000000144, 20.012782],
                [86.311112, 20.013340000000195],
                [86.311112, 20.013892],
                [86.310836000000137, 20.014165],
                [86.310836000000137, 20.014441000000144],
                [86.310280000000134, 20.014999000000156],
                [86.310280000000134, 20.015280000000129],
                [86.309997000000152, 20.015555000000173],
                [86.310036, 20.016152000000144],
                [86.310280000000134, 20.016399000000145],
                [86.310426000000163, 20.016246000000134],
              ],
            ],
            [
              [
                [86.253051, 20.025280000000116],
                [86.253326, 20.025000000000201],
                [86.254448000000181, 20.025000000000201],
                [86.254724, 20.024722000000107],
                [86.255280000000127, 20.024722000000107],
                [86.255836, 20.024166000000147],
                [86.256112, 20.02417],
                [86.258331000000155, 20.021939],
                [86.2575, 20.02111],
                [86.257217000000125, 20.021390000000103],
                [86.256927000000104, 20.021390000000103],
                [86.256668, 20.021670000000196],
                [86.256385, 20.021668000000197],
                [86.256112, 20.021944000000129],
                [86.254724, 20.021944000000129],
                [86.254448000000181, 20.022222],
                [86.25415800000016, 20.022210000000136],
                [86.253609, 20.02278],
                [86.25333300000014, 20.022778],
                [86.251663000000164, 20.024444],
                [86.251663000000164, 20.024722000000107],
                [86.251952, 20.024722000000107],
                [86.252501, 20.025280000000116],
                [86.253051, 20.025280000000116],
              ],
            ],
            [
              [
                [86.272499, 20.024444],
                [86.271942000000109, 20.02389],
                [86.271667, 20.02389],
                [86.269723000000141, 20.021939],
                [86.269447, 20.022222],
                [86.268335, 20.02111],
                [86.26805900000015, 20.02111],
                [86.267776000000183, 20.020829],
                [86.266671, 20.020829],
                [86.265832, 20.021670000000196],
                [86.265274000000119, 20.021668000000197],
                [86.264718000000116, 20.022210000000136],
                [86.264718000000116, 20.02278],
                [86.26555600000016, 20.023612000000121],
                [86.265832, 20.023612000000121],
                [86.266099000000139, 20.02389],
                [86.266388000000106, 20.02389],
                [86.266671, 20.02417],
                [86.266944000000109, 20.024166000000147],
                [86.26722, 20.024444],
                [86.26805900000015, 20.024444],
                [86.268335, 20.024722000000107],
                [86.268608000000128, 20.024722000000107],
                [86.269447, 20.025554],
                [86.269447, 20.025834000000142],
                [86.270835, 20.027222],
                [86.271386000000106, 20.027222],
                [86.271942000000109, 20.026666000000201],
                [86.271942000000109, 20.026390000000102],
                [86.272499, 20.025832000000147],
                [86.272499, 20.025278000000121],
                [86.272781, 20.025000000000201],
                [86.272499, 20.024722000000107],
                [86.272499, 20.024444],
              ],
            ],
            [
              [
                [86.265832, 20.033611000000175],
                [86.266112000000163, 20.033333],
                [86.266388000000106, 20.033333],
                [86.266671, 20.033057000000206],
                [86.266937, 20.033059000000144],
                [86.26722, 20.032779000000112],
                [86.267503, 20.032779000000112],
                [86.267776000000183, 20.032501000000192],
                [86.268325000000146, 20.032501000000192],
                [86.268325000000146, 20.031379],
                [86.267776000000183, 20.030835000000192],
                [86.267503, 20.030835000000192],
                [86.26722, 20.030557],
                [86.266944000000109, 20.030557],
                [86.266671, 20.030835000000192],
                [86.266388000000106, 20.030830000000144],
                [86.266099000000139, 20.03111],
                [86.26555600000016, 20.03111],
                [86.265274000000119, 20.031388000000103],
                [86.264168, 20.031379],
                [86.263892000000155, 20.031669],
                [86.263336, 20.031666000000197],
                [86.263054, 20.031945000000174],
                [86.262780000000177, 20.031945000000174],
                [86.262498, 20.03222],
                [86.263336, 20.033057000000206],
                [86.263054, 20.033333],
                [86.263336, 20.033611000000175],
                [86.265832, 20.033611000000175],
              ],
            ],
            [
              [
                [86.276817, 20.047429],
                [86.275199, 20.041991],
                [86.267968, 20.036391000000147],
                [86.271553, 20.035671],
                [86.277617000000177, 20.036621000000189],
                [86.282791000000131, 20.031651],
                [86.288147000000137, 20.028610000000125],
                [86.287498, 20.028610000000125],
                [86.287231000000176, 20.028339],
                [86.28666800000012, 20.028339],
                [86.286392, 20.028610000000125],
                [86.285553, 20.028610000000125],
                [86.285278, 20.028339],
                [86.284722, 20.028339],
                [86.284446000000159, 20.028061000000147],
                [86.284172, 20.028061000000147],
                [86.284026, 20.027917000000169],
                [86.283890000000127, 20.027781000000115],
                [86.283334000000124, 20.027781000000115],
                [86.283058, 20.027500000000142],
                [86.282219, 20.027500000000142],
                [86.28193600000013, 20.02722],
                [86.280555, 20.027222],
                [86.280282, 20.026944000000121],
                [86.279999, 20.026951000000164],
                [86.279717000000161, 20.026671],
                [86.278891, 20.026671],
                [86.278611000000168, 20.026951000000164],
                [86.278335, 20.026944000000121],
                [86.278039, 20.02722],
                [86.278039, 20.028061000000147],
                [86.278351000000143, 20.028339],
                [86.278039, 20.028610000000125],
                [86.278039, 20.02889],
                [86.277779, 20.029166000000139],
                [86.277779, 20.02944],
                [86.277221, 20.030000000000197],
                [86.276109, 20.030000000000197],
                [86.275833, 20.029720000000108],
                [86.274438, 20.029720000000108],
                [86.274169000000114, 20.030000000000197],
                [86.273887000000101, 20.030000000000197],
                [86.273613000000154, 20.030281000000169],
                [86.27333, 20.030281000000169],
                [86.272499, 20.03111],
                [86.272499, 20.031379],
                [86.272225, 20.031666000000197],
                [86.272225, 20.031945000000174],
                [86.271942000000109, 20.03222],
                [86.271942000000109, 20.032501000000192],
                [86.271386000000106, 20.033057000000206],
                [86.271111, 20.033333],
                [86.269996, 20.033330000000202],
                [86.269447, 20.033889],
                [86.269157, 20.033889],
                [86.268891, 20.034171000000182],
                [86.268608000000128, 20.034167000000192],
                [86.26805900000015, 20.034721],
                [86.267776000000183, 20.034721],
                [86.267503, 20.035001],
                [86.26722, 20.035001],
                [86.266937, 20.035281000000161],
                [86.266388000000106, 20.035281000000161],
                [86.266099000000139, 20.035001],
                [86.26555600000016, 20.035001],
                [86.265267, 20.034721],
                [86.264442, 20.034721],
                [86.264168, 20.035001],
                [86.263054, 20.035001],
                [86.262780000000177, 20.034721],
                [86.262498, 20.034721],
                [86.262222, 20.034445000000112],
                [86.260834, 20.034445000000112],
                [86.260086, 20.03369900000018],
                [86.259719, 20.033333],
                [86.259446000000167, 20.033333],
                [86.259163, 20.033057000000206],
                [86.258888, 20.033059000000144],
                [86.258331000000155, 20.032501000000192],
                [86.25805600000011, 20.032501000000192],
                [86.257766, 20.03222],
                [86.2575, 20.032223],
                [86.256943, 20.031666000000197],
                [86.256385, 20.031669],
                [86.25631, 20.031587],
                [86.256112, 20.031379],
                [86.255836, 20.031388000000103],
                [86.25555300000012, 20.03111],
                [86.255280000000127, 20.03111],
                [86.254997000000145, 20.030830000000144],
                [86.254724, 20.030835000000192],
                [86.253892, 20.030000000000197],
                [86.253892, 20.029720000000108],
                [86.252221000000119, 20.029722000000103],
                [86.251952, 20.030000000000197],
                [86.251389, 20.030000000000197],
                [86.251123, 20.029720000000108],
                [86.250831, 20.029720000000108],
                [86.250268, 20.030281000000169],
                [86.249999000000159, 20.030281000000169],
                [86.24965, 20.030269],
                [86.249238, 20.030272000000132],
                [86.248871, 20.030231000000125],
                [86.248543, 20.030041000000207],
                [86.248198000000144, 20.029800000000186],
                [86.247818000000152, 20.029271000000104],
                [86.2474050000001, 20.028859000000121],
                [86.247093, 20.028920000000195],
                [86.246772000000121, 20.029071],
                [86.246375000000157, 20.029071],
                [86.24591, 20.028920000000195],
                [86.245682, 20.02903],
                [86.245461, 20.029171000000186],
                [86.245231000000146, 20.029360000000164],
                [86.244996, 20.029570000000145],
                [86.244766, 20.02982],
                [86.24459, 20.030137000000192],
                [86.24447, 20.030470000000204],
                [86.244477000000117, 20.030800000000109],
                [86.244659000000112, 20.031081000000139],
                [86.24472, 20.031379],
                [86.24472, 20.03171],
                [86.24472, 20.03209],
                [86.24472, 20.032558000000105],
                [86.24472, 20.033102000000149],
                [86.24472, 20.033684],
                [86.244759, 20.034253000000199],
                [86.24488, 20.034732],
                [86.244987, 20.035222],
                [86.245055, 20.035701000000127],
                [86.245247, 20.03617000000019],
                [86.245416, 20.036665],
                [86.245568000000148, 20.03713],
                [86.245789000000144, 20.03751],
                [86.245926, 20.037850000000102],
                [86.246108, 20.038121000000153],
                [86.246293, 20.038392],
                [86.246459000000172, 20.038682],
                [86.24665800000011, 20.038971000000114],
                [86.246842, 20.039261000000121],
                [86.246972000000127, 20.03963],
                [86.24717, 20.039937000000119],
                [86.247421, 20.040241000000204],
                [86.247674000000174, 20.040571000000167],
                [86.247879, 20.04089],
                [86.248071000000124, 20.041221000000117],
                [86.248283000000114, 20.04151],
                [86.248467, 20.041811000000106],
                [86.24865, 20.042109],
                [86.248864000000168, 20.042367],
                [86.249030000000104, 20.042691],
                [86.249199, 20.043069000000109],
                [86.249475000000103, 20.043411000000159],
                [86.249878, 20.043732],
                [86.250291000000161, 20.044072000000135],
                [86.250762, 20.04440500000015],
                [86.251236000000162, 20.04471900000021],
                [86.251701000000125, 20.045027000000115],
                [86.25216, 20.045300000000108],
                [86.252501, 20.045560000000133],
                [86.253051, 20.045556000000143],
                [86.253869, 20.046369],
                [86.260307, 20.045781000000144],
                [86.264253, 20.045419000000205],
                [86.270545000000126, 20.049829],
                [86.273399, 20.049289],
                [86.276817, 20.047429],
              ],
            ],
            [
              [
                [85.739113817578342, 20.13218464833653],
                [85.742719198083236, 20.129294327883482],
                [85.743732651835259, 20.131357408618548],
                [85.747063897243308, 20.132547139121467],
                [85.750157196550816, 20.134450707926074],
                [85.75325049585858, 20.136116330630212],
                [85.751584873154442, 20.137068115032601],
                [85.746350058941616, 20.138495791636043],
                [85.747063897243308, 20.141827037044258],
                [85.748015681645697, 20.145158282452311],
                [85.752774603657343, 20.14587212075406],
                [85.755154064663188, 20.146110066854696],
                [85.755867902964923, 20.147061851256975],
                [85.754202280260799, 20.153010503771551],
                [85.756105849065406, 20.158483264085071],
                [85.757771471769544, 20.160386832889678],
                [85.759613000000257, 20.15920900000037],
                [85.761305471675243, 20.159567903123722],
                [85.774903591011565, 20.156817641380936],
                [85.776807159816173, 20.153724342073414],
                [85.774903591011565, 20.150631042765717],
                [85.773475914408138, 20.149679258363445],
                [85.773475914408138, 20.147061851256975],
                [85.777758944218576, 20.145634174653534],
                [85.782755812330748, 20.144206498050092],
                [85.789785502490517, 20.140085947096164],
                [85.792962050102489, 20.142210949979866],
                [85.794158, 20.143011],
                [85.795906000000215, 20.143761000000264],
                [85.79767010657693, 20.145754258565198],
                [85.798331000000118, 20.146501000000111],
                [85.801077662075713, 20.146110066854696],
                [85.807978098992663, 20.145158282452311],
                [85.813926751507253, 20.146348012955222],
                [85.815592374211164, 20.149679258363445],
                [85.815975586512351, 20.150956632700453],
                [85.817733889116525, 20.156817641380936],
                [85.821778972826436, 20.163004239996035],
                [85.823920487731556, 20.169666730812363],
                [85.8262999487374, 20.173949760622971],
                [85.82939324804515, 20.176567167729328],
                [85.830820924648592, 20.175615383326935],
                [85.831534762950284, 20.175139491125883],
                [85.832316304148819, 20.17279486753068],
                [85.833200385654422, 20.170142623013529],
                [85.832962439553896, 20.167525215907173],
                [85.834390116157337, 20.162766293895508],
                [85.837245469364333, 20.162766293895508],
                [85.840338768671913, 20.162766293895508],
                [85.845573582884725, 20.165145754901342],
                [85.84547304281908, 20.167759796607633],
                [85.845335636784043, 20.171332353516441],
                [85.845333637664098, 20.178226987520642],
                [85.836304359056598, 20.181337599907859],
                [85.837516626543206, 20.182461215090253],
                [85.833438331754877, 20.183229658545596],
                [85.833914223956114, 20.180136359238073],
                [85.82939324804515, 20.181088143640459],
                [85.828679409743231, 20.183229658545596],
                [85.831772709050966, 20.186798850054341],
                [85.834628062257806, 20.186085011752649],
                [85.837245469364333, 20.188702418859005],
                [85.842480283577217, 20.189416257160865],
                [85.845097690683559, 20.188226526657953],
                [85.846683732192531, 20.186419820828061],
                [85.847946000000292, 20.186180000000316],
                [85.848931125649784, 20.185877436755785],
                [85.854943000000134, 20.184031000000115],
                [85.849758844386415, 20.190761001424388],
                [85.856183389102156, 20.195757869536514],
                [85.861878, 20.18294],
                [85.864440000000101, 20.179860000000183],
                [85.871011, 20.177030000000109],
                [85.883591000000123, 20.168962000000132],
                [85.885864887349982, 20.162113542686708],
                [85.88910700000018, 20.152349000000122],
                [85.896432000000161, 20.137220000000124],
                [85.892899, 20.132641000000142],
                [85.884697000000173, 20.12721],
                [85.881759, 20.123488000000119],
                [85.873757, 20.121022000000149],
                [85.869668, 20.114759000000156],
                [85.879753, 20.102440000000112],
                [85.885422, 20.104070000000142],
                [85.894242000000176, 20.104979],
                [85.898399, 20.115680000000108],
                [85.898857, 20.120519000000112],
                [85.905136000000169, 20.115222],
                [85.910362, 20.11315],
                [85.921594000000169, 20.106411],
                [85.926719, 20.10625100000015],
                [85.930526, 20.107840000000174],
                [85.936242000000149, 20.105871000000146],
                [85.940957000000168, 20.10588000000018],
                [85.939720000000165, 20.109590000000193],
                [85.94220800000015, 20.111701],
                [85.945716000000161, 20.11189],
                [85.949388, 20.103999000000151],
                [85.954659, 20.112660000000172],
                [85.963012, 20.108569],
                [85.974238723819369, 20.105682190883549],
                [85.983468, 20.103309],
                [85.986147958978492, 20.101471065440361],
                [85.989633000000126, 20.099081],
                [85.995374136814277, 20.100490643874021],
                [85.999561988184482, 20.104868852124692],
                [86.003940196435153, 20.105439922766145],
                [86.006985906522672, 20.103345997081018],
                [86.010541262372755, 20.096977180142343],
                [86.015191, 20.093910000000104],
                [86.016271775604011, 20.094432135752353],
                [86.027093, 20.099660000000139],
                [86.035122909600005, 20.100175770990173],
                [86.037057, 20.100300000000171],
                [86.043053, 20.098340000000174],
                [86.047789000000165, 20.09883],
                [86.051406000000128, 20.097841000000123],
                [86.053414, 20.099890000000183],
                [86.057747, 20.10131],
                [86.067832000000166, 20.102101000000168],
                [86.073867000000163, 20.09886],
                [86.077049000000144, 20.098671000000191],
                [86.079558000000119, 20.096702],
                [86.086227000000164, 20.083991],
                [86.083802, 20.077922000000111],
                [86.076867, 20.076850000000203],
                [86.071686000000142, 20.074592000000102],
                [86.071686000000142, 20.07053],
                [86.076393, 20.060969],
                [86.080178, 20.059251000000128],
                [86.083428, 20.055112000000172],
                [86.084641, 20.052181000000125],
                [86.091316, 20.057471000000131],
                [86.097940000000136, 20.059741000000198],
                [86.111947, 20.05913],
                [86.119156000000132, 20.054070000000134],
                [86.122803, 20.052411000000173],
                [86.123771, 20.04845000000017],
                [86.116706000000121, 20.043372],
                [86.114577000000153, 20.04089],
                [86.114181, 20.038080000000146],
                [86.116592000000111, 20.034370000000131],
                [86.123254000000117, 20.032421000000166],
                [86.129098, 20.031641],
                [86.142114, 20.037492000000153],
                [86.148133, 20.034629],
                [86.155137, 20.037982000000163],
                [86.165206, 20.033241000000142],
                [86.164597000000114, 20.039842],
                [86.165917, 20.041351],
                [86.171806, 20.043969000000114],
                [86.177452, 20.042921],
                [86.183938, 20.045651000000188],
                [86.190728, 20.043721],
                [86.193497000000121, 20.044001],
                [86.194511, 20.045722],
                [86.200111, 20.044601],
                [86.200751000000125, 20.04107],
                [86.20474200000011, 20.037861000000127],
                [86.202392, 20.036820000000144],
                [86.202019, 20.034281000000188],
                [86.204277, 20.031860000000105],
                [86.208047000000178, 20.035748],
                [86.209266000000156, 20.035311000000142],
                [86.210878000000136, 20.034721],
                [86.212776000000105, 20.032941000000157],
                [86.220124, 20.0302900000002],
                [86.220849, 20.030331],
                [86.2228700000001, 20.030452000000135],
                [86.225373, 20.034322],
                [86.228753000000125, 20.035049000000178],
                [86.241928, 20.031081000000139],
                [86.241944000000132, 20.030835000000192],
                [86.240554, 20.029444],
                [86.239998, 20.030000000000197],
                [86.239442, 20.030000000000197],
                [86.239182, 20.029720000000108],
                [86.238893000000104, 20.029722000000103],
                [86.238610000000151, 20.029444],
                [86.238334, 20.029444],
                [86.238052, 20.029166000000139],
                [86.237778, 20.029171000000186],
                [86.237502000000163, 20.02889],
                [86.236946000000131, 20.02889],
                [86.236657, 20.028610000000125],
                [86.236657, 20.026951000000164],
                [86.239722000000185, 20.026951000000164],
                [86.239998, 20.026671],
                [86.241928, 20.026671],
                [86.242218, 20.026390000000102],
                [86.242546, 20.026372000000205],
                [86.242913, 20.026251000000169],
                [86.243232000000134, 20.026080000000203],
                [86.243522000000127, 20.025832000000147],
                [86.243797, 20.025552],
                [86.244132, 20.025262],
                [86.244499000000161, 20.024957000000196],
                [86.244896000000125, 20.024651000000116],
                [86.245194000000126, 20.024257000000201],
                [86.245498, 20.02389],
                [86.245819000000125, 20.023539000000138],
                [86.246147000000107, 20.023179000000194],
                [86.24656000000013, 20.022878000000158],
                [86.246986, 20.022541000000157],
                [86.247421, 20.022199000000111],
                [86.247802, 20.021770000000114],
                [86.248198000000144, 20.021413],
                [86.248611, 20.021157],
                [86.249076000000159, 20.02114100000011],
                [86.24955, 20.021301],
                [86.250038000000174, 20.021331000000199],
                [86.250587, 20.021160000000119],
                [86.251205, 20.021087],
                [86.251815000000107, 20.020920000000153],
                [86.252335000000173, 20.020601],
                [86.25283, 20.020339000000202],
                [86.25328800000014, 20.020139000000196],
                [86.253693, 20.019913000000138],
                [86.254006, 20.019649000000125],
                [86.254243000000116, 20.019273000000108],
                [86.254555000000124, 20.018931],
                [86.254958, 20.018632000000192],
                [86.255439000000109, 20.018391000000115],
                [86.255982000000117, 20.018336000000197],
                [86.256492, 20.018329000000161],
                [86.256921, 20.018334000000202],
                [86.257324000000139, 20.018334000000202],
                [86.257730000000123, 20.018320000000124],
                [86.258133, 20.018240000000102],
                [86.25853, 20.018131000000146],
                [86.25897900000011, 20.018290000000146],
                [86.259430000000108, 20.018290000000146],
                [86.259927, 20.018101000000112],
                [86.260499, 20.018058000000103],
                [86.261078, 20.01806],
                [86.261627, 20.01806],
                [86.262124, 20.018051],
                [86.262543, 20.017999000000199],
                [86.262871, 20.017812],
                [86.263177000000141, 20.017755],
                [86.263352, 20.01778],
                [86.263610000000128, 20.017499],
                [86.264168, 20.017499],
                [86.264442, 20.017219000000178],
                [86.264724000000101, 20.017221000000173],
                [86.265, 20.016946000000129],
                [86.26555600000016, 20.016946000000129],
                [86.265832, 20.017221000000173],
                [86.266671, 20.017219000000178],
                [86.266937, 20.017499],
                [86.26722, 20.017499],
                [86.267503, 20.01778],
                [86.268891, 20.01778],
                [86.269157, 20.017499],
                [86.269996, 20.017499],
                [86.270279000000173, 20.01778],
                [86.27223200000013, 20.01778],
                [86.27259, 20.01778],
                [86.273034, 20.01778],
                [86.27349, 20.017771000000206],
                [86.273948000000175, 20.017725],
                [86.274354000000159, 20.017550000000195],
                [86.274718000000107, 20.017534000000122],
                [86.275069, 20.017650000000113],
                [86.27542, 20.017761],
                [86.27581, 20.017830000000114],
                [86.276154, 20.018005000000183],
                [86.276596, 20.018053],
                [86.27706100000016, 20.018081],
                [86.277497, 20.018199],
                [86.277909000000179, 20.018349],
                [86.278267000000127, 20.018525],
                [86.278634, 20.018664000000168],
                [86.278946000000161, 20.01886],
                [86.279327, 20.019040000000182],
                [86.27973200000018, 20.019202000000117],
                [86.280113, 20.019421],
                [86.280503, 20.019601],
                [86.280861000000172, 20.019861000000102],
                [86.281257, 20.020130000000162],
                [86.281722000000144, 20.02038],
                [86.282226000000136, 20.020601],
                [86.282684000000174, 20.020902],
                [86.283042000000108, 20.021271],
                [86.283334000000124, 20.021641],
                [86.283616, 20.021937],
                [86.283883, 20.02219],
                [86.284118, 20.022431],
                [86.284364, 20.022609],
                [86.284539, 20.022871000000119],
                [86.284715000000148, 20.023170000000157],
                [86.284943, 20.023519],
                [86.2853, 20.02389],
                [86.285827, 20.02417],
                [86.286369, 20.02435],
                [86.286873, 20.024209000000152],
                [86.287322, 20.024191],
                [86.287744, 20.024339],
                [86.288186000000152, 20.024569],
                [86.288680000000156, 20.024613000000155],
                [86.289207, 20.024515],
                [86.289672000000152, 20.024521],
                [86.290071000000154, 20.02467],
                [86.290497, 20.024722000000107],
                [86.290932000000154, 20.024727000000208],
                [86.291336000000143, 20.02477],
                [86.291718000000159, 20.024950000000153],
                [86.29211500000018, 20.025005],
                [86.292343000000173, 20.02503],
                [86.292525000000168, 20.02505],
                [86.292970000000167, 20.025109000000153],
                [86.293441, 20.024991000000167],
                [86.293929000000148, 20.02479],
                [86.294449, 20.024613000000155],
                [86.294946, 20.024419],
                [86.295326, 20.024079000000192],
                [86.295449000000119, 20.023313],
                [86.295684, 20.022880000000153],
                [86.295762000000124, 20.022735],
                [86.296081, 20.022210000000136],
                [86.296402, 20.02175],
                [86.296707000000126, 20.021351],
                [86.296935000000175, 20.020959000000172],
                [86.296890000000175, 20.02046],
                [86.296997000000133, 20.020084],
                [86.297202, 20.019731000000146],
                [86.2973870000001, 20.019309],
                [86.297669000000141, 20.01876],
                [86.297982, 20.018094],
                [86.298362, 20.017531],
                [86.298843000000119, 20.01703000000014],
                [86.299408000000113, 20.01669],
                [86.299926000000184, 20.016380000000193],
                [86.300370000000129, 20.016059],
                [86.300721, 20.015678000000204],
                [86.301049, 20.015341000000202],
                [86.3014000000001, 20.015052],
                [86.301788, 20.014869],
                [86.302177000000128, 20.014701000000169],
                [86.302558, 20.014511],
                [86.302977, 20.014452000000173],
                [86.303436, 20.014423],
                [86.303962000000169, 20.014354],
                [86.304543000000123, 20.01424],
                [86.305161, 20.014163000000107],
                [86.305405, 20.013889000000169],
                [86.305610000000101, 20.013579000000103],
                [86.305879000000161, 20.013272],
                [86.306129, 20.012891000000192],
                [86.306396000000149, 20.012501],
                [86.306617000000116, 20.012109000000116],
                [86.306656000000132, 20.0116720000002],
                [86.306945, 20.011391],
                [86.306945, 20.010831000000106],
                [86.307221000000169, 20.010555000000174],
                [86.307221000000169, 20.01027],
                [86.308333000000161, 20.009167],
                [86.308327, 20.008891000000169],
                [86.308892, 20.008330000000111],
                [86.308892, 20.008055],
                [86.309165, 20.007779000000138],
                [86.309165, 20.007501],
                [86.309448, 20.007209],
                [86.310556, 20.006111000000143],
                [86.310546000000144, 20.005992],
                [86.310799000000117, 20.005716000000174],
                [86.310982000000166, 20.005390000000201],
                [86.311141000000177, 20.005012000000189],
                [86.311417000000105, 20.004675000000184],
                [86.311784, 20.00438100000019],
                [86.311957000000163, 20.003970000000148],
                [86.311752000000112, 20.003339000000146],
                [86.311706000000157, 20.00285400000018],
                [86.311791000000127, 20.002459000000155],
                [86.311729000000156, 20.001969000000141],
                [86.311713, 20.001427000000202],
                [86.311814, 20.00085],
                [86.312240000000116, 20.000390000000206],
                [86.312500000000156, 20.00000000000011],
                [86.313338, 19.999161000000125],
                [86.313835000000125, 19.998824000000123],
                [86.313995, 19.998546],
                [86.314446, 19.997778],
                [86.314460000000139, 19.997500000000169],
                [86.31527800000012, 19.996666000000111],
                [86.31527800000012, 19.996390000000186],
                [86.315827000000112, 19.995832],
                [86.315834000000152, 19.995278000000205],
                [86.31611, 19.995000000000111],
                [86.31611, 19.994719000000138],
                [86.316390000000169, 19.994444],
                [86.316390000000169, 19.994168000000169],
                [86.31778, 19.99278],
                [86.31778, 19.9925],
                [86.318047000000135, 19.992210000000163],
                [86.318054000000174, 19.991946000000205],
                [86.318336, 19.991670000000106],
                [86.318336, 19.990280000000208],
                [86.31861200000013, 19.989999],
                [86.31861200000013, 19.989441],
                [86.319168000000133, 19.988889000000196],
                [86.319168000000133, 19.988611000000102],
                [86.319734, 19.988060000000182],
                [86.319734, 19.987779],
                [86.32, 19.987501000000115],
                [86.32, 19.987221000000201],
                [86.321664, 19.9855550000002],
                [86.321664, 19.984721000000146],
                [86.321944000000116, 19.984443],
                [86.321944000000116, 19.9838890000002],
                [86.321388000000155, 19.983331],
                [86.321388000000155, 19.983055000000146],
                [86.320137, 19.981810000000163],
                [86.319068, 19.98101],
                [86.317154000000116, 19.980605],
                [86.316468, 19.98070000000012],
                [86.315184, 19.980705],
                [86.314147, 19.981111],
                [86.311814, 19.981810000000163],
                [86.31131, 19.982066000000199],
                [86.309952, 19.9824030000002],
                [86.308876000000154, 19.982941],
                [86.30803000000013, 19.983148000000195],
                [86.3069, 19.983511000000185],
                [86.304871, 19.983882000000161],
                [86.303903, 19.984001],
                [86.303237, 19.984083000000108],
                [86.302665000000133, 19.984083000000108],
                [86.302522, 19.984017000000161],
                [86.302522, 19.98381100000017],
                [86.302665000000133, 19.983543],
                [86.30308500000011, 19.98326],
                [86.303497, 19.983296000000163],
                [86.303887, 19.983333],
                [86.304169, 19.983055000000146],
                [86.304732, 19.983062000000185],
                [86.305001000000161, 19.982781],
                [86.306945, 19.982781],
                [86.307221000000169, 19.982501000000124],
                [86.307777, 19.982501000000124],
                [86.308609, 19.981671],
                [86.309165, 19.981671],
                [86.309448, 19.981391000000141],
                [86.310280000000134, 19.981391000000141],
                [86.310546000000144, 19.981111],
                [86.311385000000129, 19.981111],
                [86.313598, 19.980135000000129],
                [86.315795000000136, 19.9798590000002],
                [86.317115000000101, 19.97972],
                [86.317894, 19.979916000000113],
                [86.318398, 19.97998],
                [86.319077, 19.980231],
                [86.32, 19.980561000000186],
                [86.320976, 19.98104],
                [86.321687, 19.981717000000113],
                [86.32195300000015, 19.982221],
                [86.322776, 19.983055000000146],
                [86.32315, 19.983472000000173],
                [86.323273000000114, 19.983613000000101],
                [86.323891000000103, 19.983613000000101],
                [86.324723, 19.982779],
                [86.324723, 19.982501000000124],
                [86.3264, 19.98083],
                [86.32638600000017, 19.980557000000196],
                [86.326943, 19.97999800000013],
                [86.327216, 19.97999800000013],
                [86.328613, 19.97861],
                [86.328889000000103, 19.97861],
                [86.329169, 19.978330000000138],
                [86.329445000000106, 19.97833200000013],
                [86.329718000000156, 19.978057000000145],
                [86.330559, 19.97805900000014],
                [86.330826000000158, 19.977779],
                [86.331109000000126, 19.977779],
                [86.331391, 19.977501000000128],
                [86.331672000000182, 19.977501000000128],
                [86.33194700000017, 19.97722200000015],
                [86.333046000000181, 19.977229000000186],
                [86.333335000000119, 19.97694],
                [86.334443000000121, 19.976944],
                [86.334723, 19.976666000000133],
                [86.335282000000106, 19.976671],
                [86.335571000000158, 19.976391000000142],
                [86.335831, 19.976391000000142],
                [86.336114000000151, 19.976110000000173],
                [86.336387, 19.976110000000173],
                [86.336670000000183, 19.97583],
                [86.337219000000104, 19.975835000000128],
                [86.337502, 19.97555600000015],
                [86.337775000000107, 19.975561000000194],
                [86.338058, 19.975281000000106],
                [86.338340000000173, 19.975281000000106],
                [86.339179, 19.97454],
                [86.339751, 19.97393100000016],
                [86.340606, 19.97284900000016],
                [86.341025000000101, 19.972379],
                [86.341376000000182, 19.97116],
                [86.341376000000182, 19.970561000000199],
                [86.340278000000112, 19.969442000000182],
                [86.339997000000125, 19.969444000000177],
                [86.339722, 19.969166],
                [86.339448000000161, 19.96917],
                [86.339156000000145, 19.968892000000146],
                [86.33889, 19.968892000000146],
                [86.338340000000173, 19.968329],
                [86.338058, 19.968334000000137],
                [86.337921000000136, 19.968197000000199],
                [86.337775000000107, 19.9680560000001],
                [86.337775000000107, 19.967780000000172],
                [86.335831, 19.965829000000209],
                [86.334723, 19.96388700000011],
                [86.334717, 19.963609000000186],
                [86.333053, 19.961945000000181],
                [86.332779000000116, 19.961945000000181],
                [86.330735000000104, 19.959901000000169],
                [86.329445000000106, 19.958611000000186],
                [86.329438, 19.957781],
                [86.329536000000161, 19.957681000000147],
                [86.329718000000156, 19.957501000000203],
                [86.329032, 19.956813000000121],
                [86.328889000000103, 19.956667],
                [86.328889000000103, 19.956560000000131],
                [86.328889000000103, 19.956389],
                [86.328636000000174, 19.956136],
                [86.328057, 19.955555000000111],
                [86.327768, 19.955562000000153],
                [86.327499, 19.955281000000181],
                [86.326943, 19.955281000000181],
                [86.326667000000128, 19.955001],
                [86.32638600000017, 19.955001],
                [86.325837, 19.954445000000131],
                [86.325555000000165, 19.954445000000131],
                [86.324996, 19.95388900000011],
                [86.324723, 19.953891000000105],
                [86.324631, 19.95379500000012],
                [86.324173, 19.95333],
                [86.323891000000103, 19.953333],
                [86.323608000000135, 19.953057],
                [86.323059, 19.953059000000163],
                [86.322776, 19.952779000000131],
                [86.322503, 19.952779000000131],
                [86.32222, 19.952498000000102],
                [86.321664, 19.952498000000102],
                [86.321388000000155, 19.95222],
                [86.321112, 19.952223000000114],
                [86.320832000000152, 19.951945000000187],
                [86.320274, 19.951945000000187],
                [86.32, 19.951667],
                [86.319442, 19.951669],
                [86.319168000000133, 19.951391],
                [86.318886, 19.951391],
                [86.31861200000013, 19.951110000000195],
                [86.318336, 19.951110000000195],
                [86.31720800000015, 19.95],
                [86.316948000000124, 19.94972000000012],
                [86.317498000000143, 19.949166000000101],
                [86.318336, 19.949166000000101],
                [86.318473, 19.949305],
                [86.31861200000013, 19.949444000000195],
                [86.318886, 19.949444000000195],
                [86.319168000000133, 19.949722000000115],
                [86.319442, 19.94972000000012],
                [86.32, 19.95029],
                [86.320274, 19.950276000000141],
                [86.320832000000152, 19.950835000000207],
                [86.321106, 19.950830000000163],
                [86.321388000000155, 19.951110000000195],
                [86.321664, 19.951110000000195],
                [86.32195300000015, 19.951391],
                [86.32222, 19.951391],
                [86.322503, 19.951669],
                [86.323059, 19.951667],
                [86.323335000000142, 19.951945000000187],
                [86.323891000000103, 19.951945000000187],
                [86.324164000000152, 19.952223000000114],
                [86.32444700000012, 19.95222],
                [86.324996, 19.952779000000131],
                [86.325279, 19.952779000000131],
                [86.325545, 19.953059000000163],
                [86.326111000000125, 19.953059000000163],
                [86.326943, 19.953891000000105],
                [86.327225, 19.95388900000011],
                [86.327499, 19.954167000000204],
                [86.327774, 19.954167000000204],
                [86.328057, 19.954445000000131],
                [86.32833, 19.954445000000131],
                [86.331109000000126, 19.957221000000111],
                [86.334167, 19.960560000000154],
                [86.334443000000121, 19.96055500000011],
                [86.334723, 19.960833000000203],
                [86.334999000000138, 19.960831000000208],
                [86.336670000000183, 19.962499000000204],
                [86.337775000000107, 19.964999],
                [86.337775000000107, 19.965289],
                [86.338058, 19.965556000000159],
                [86.338058, 19.965834],
                [86.338340000000173, 19.966109],
                [86.338340000000173, 19.9663900000001],
                [86.339448000000161, 19.9675],
                [86.339722, 19.9675],
                [86.339997000000125, 19.967780000000172],
                [86.340278000000112, 19.967778000000177],
                [86.341353, 19.968637000000168],
                [86.342438000000115, 19.969503],
                [86.343316000000115, 19.969259000000132],
                [86.343810000000119, 19.969191000000187],
                [86.344674, 19.968651],
                [86.345176, 19.96858],
                [86.345543000000177, 19.968136000000126],
                [86.346322000000143, 19.967591000000137],
                [86.346962000000161, 19.967119000000192],
                [86.347671, 19.966511000000136],
                [86.348068000000168, 19.966109],
                [86.349137, 19.965471],
                [86.350005, 19.964680000000154],
                [86.350869000000145, 19.964209],
                [86.351432000000145, 19.9639400000002],
                [86.351646000000116, 19.96373],
                [86.35165500000015, 19.963395],
                [86.351113, 19.963331],
                [86.35083, 19.963333],
                [86.349, 19.963899000000193],
                [86.34814500000013, 19.964309000000181],
                [86.347145, 19.96485100000012],
                [86.346719000000107, 19.96512000000018],
                [86.346222, 19.965330000000101],
                [86.345939, 19.965330000000101],
                [86.345864, 19.96512000000018],
                [86.345939, 19.96478500000017],
                [86.346504, 19.964377000000123],
                [86.346946000000102, 19.96417],
                [86.347512, 19.963609000000186],
                [86.347778000000162, 19.963611000000178],
                [86.348334000000165, 19.963055000000161],
                [86.348610000000107, 19.963055000000161],
                [86.348893, 19.962777],
                [86.3497160000001, 19.962780000000176],
                [86.349998000000184, 19.962499000000204],
                [86.35083, 19.962499000000204],
                [86.351113, 19.962230000000144],
                [86.352501000000174, 19.962230000000144],
                [86.352783, 19.961941000000191],
                [86.353615000000133, 19.961945000000181],
                [86.353889, 19.961665],
                [86.355003, 19.961670000000133],
                [86.355279000000152, 19.96138900000016],
                [86.355842, 19.96138900000016],
                [86.356109000000103, 19.961111],
                [86.356667, 19.961111],
                [86.356940000000108, 19.960831000000208],
                [86.357499000000175, 19.960833000000203],
                [86.357781, 19.96055500000011],
                [86.358331, 19.960560000000154],
                [86.358611000000138, 19.960279000000181],
                [86.358887, 19.960279000000181],
                [86.359452, 19.959721],
                [86.359726, 19.95972300000016],
                [86.360001, 19.959443000000128],
                [86.360275000000144, 19.959443000000128],
                [86.360557, 19.959167000000203],
                [86.361114000000128, 19.959167000000203],
                [86.361389000000131, 19.958889000000109],
                [86.362221, 19.958891000000104],
                [86.362511, 19.958611000000186],
                [86.362777, 19.958611000000186],
                [86.363053000000122, 19.958331],
                [86.363892000000106, 19.958333],
                [86.364165000000156, 19.958055],
                [86.364724, 19.958062],
                [86.364997, 19.957781],
                [86.365547, 19.957781],
                [86.365838, 19.957501000000203],
                [86.365838, 19.955831],
                [86.36557800000017, 19.955151],
                [86.364227000000128, 19.953729000000177],
                [86.362663, 19.952779000000131],
                [86.360658, 19.952241000000182],
                [86.357886, 19.951562000000134],
                [86.356346000000116, 19.951259000000103],
                [86.355468000000116, 19.951088000000194],
                [86.351701, 19.95055],
                [86.349923, 19.950130000000112],
                [86.34665, 19.949668],
                [86.345009, 19.948722000000142],
                [86.343956000000134, 19.948191000000119],
                [86.342614000000125, 19.948191000000119],
                [86.341317, 19.947651000000171],
                [86.339546, 19.947441],
                [86.336914000000135, 19.946835000000185],
                [86.334138, 19.946361000000191],
                [86.33200000000015, 19.94602100000014],
                [86.331138, 19.945846],
                [86.329718000000156, 19.945554],
                [86.327469, 19.944738000000196],
                [86.324622, 19.944129],
                [86.323982, 19.944061000000143],
                [86.323196000000152, 19.943924000000202],
                [86.322061, 19.943724000000142],
                [86.321495000000127, 19.943507000000118],
                [86.320426000000154, 19.942992000000167],
                [86.319779, 19.942792000000164],
                [86.318574, 19.942181],
                [86.31742900000016, 19.941971],
                [86.315934, 19.9419],
                [86.314437, 19.94123],
                [86.312798000000143, 19.940679],
                [86.311807, 19.940478000000152],
                [86.310592, 19.93989],
                [86.309129000000141, 19.93950100000017],
                [86.307137000000154, 19.9391700000001],
                [86.305359, 19.938562],
                [86.304206000000121, 19.938021000000102],
                [86.301728, 19.93721000000016],
                [86.300302, 19.936590000000187],
                [86.298804000000104, 19.935854],
                [86.297669000000141, 19.935649000000122],
                [86.296113, 19.935510000000189],
                [86.294754000000168, 19.934972],
                [86.293754, 19.934635],
                [86.292619, 19.93368],
                [86.291924000000151, 19.933358000000108],
                [86.29036, 19.93275],
                [86.289567, 19.932271],
                [86.28843700000013, 19.931936],
                [86.287299000000118, 19.931125],
                [86.285661000000104, 19.93085300000012],
                [86.284241, 19.930311],
                [86.283096000000143, 19.929639],
                [86.282173000000157, 19.929231],
                [86.280678000000123, 19.92821900000018],
                [86.278680000000151, 19.927339000000185],
                [86.277045, 19.926589],
                [86.273697000000169, 19.924969000000196],
                [86.272209, 19.92436],
                [86.269996, 19.923070000000102],
                [86.267174000000111, 19.921564],
                [86.265748, 19.920684],
                [86.264756, 19.92021],
                [86.263473000000133, 19.91926200000017],
                [86.261832, 19.918922],
                [86.2593, 19.917787000000143],
                [86.256668, 19.916429],
                [86.254211, 19.915166000000166],
                [86.25258600000015, 19.914341000000146],
                [86.250168, 19.912709000000117],
                [86.248672, 19.911836000000161],
                [86.247392, 19.91123],
                [86.246177, 19.911159000000108],
                [86.245247, 19.911159000000108],
                [86.244447000000122, 19.911946],
                [86.242783000000117, 19.912500000000186],
                [86.241386, 19.91389],
                [86.241386, 19.914168000000185],
                [86.240837, 19.914719000000158],
                [86.240837, 19.915000000000131],
                [86.240281, 19.91556],
                [86.240281, 19.916112000000105],
                [86.241669000000158, 19.917500000000185],
                [86.241928, 19.917500000000185],
                [86.242218, 19.917780000000104],
                [86.242501, 19.917778000000105],
                [86.243332, 19.91861],
                [86.243057, 19.91889],
                [86.243057, 19.919444000000109],
                [86.242783000000117, 19.919720000000208],
                [86.242783000000117, 19.920281],
                [86.242501, 19.920554],
                [86.242501, 19.92083400000018],
                [86.242225000000118, 19.921112000000104],
                [86.241753000000173, 19.922051000000177],
                [86.241600000000105, 19.922051000000177],
                [86.241386, 19.921922000000158],
                [86.241386, 19.920998],
                [86.2417370000001, 19.92005000000017],
                [86.2417370000001, 19.919171],
                [86.241028, 19.91822],
                [86.240105, 19.91727400000013],
                [86.238893000000104, 19.916390000000199],
                [86.238893000000104, 19.915959],
                [86.238893000000104, 19.91583200000019],
                [86.239442, 19.915278],
                [86.239442, 19.915000000000131],
                [86.239722000000185, 19.914719000000158],
                [86.239722000000185, 19.914168000000185],
                [86.239998, 19.91389],
                [86.239998, 19.91361],
                [86.240281, 19.913329],
                [86.239998, 19.913056000000207],
                [86.239998, 19.912780000000108],
                [86.239722000000185, 19.912500000000186],
                [86.238327000000169, 19.91389],
                [86.238052, 19.91389],
                [86.237502000000163, 19.913329],
                [86.237502000000163, 19.912222],
                [86.23722, 19.911946],
                [86.23722, 19.911670000000125],
                [86.236946000000131, 19.911390000000207],
                [86.236946000000131, 19.910829000000145],
                [86.235832000000173, 19.909721000000157],
                [86.235832000000173, 19.90916500000014],
                [86.234437, 19.907780000000113],
                [86.233888, 19.907780000000113],
                [86.233329000000182, 19.907221],
                [86.233056, 19.907223],
                [86.23278, 19.906945000000114],
                [86.232224, 19.906945000000114],
                [86.231941000000106, 19.906665],
                [86.231666000000104, 19.90667000000013],
                [86.231392000000184, 19.906392000000206],
                [86.231109, 19.906392000000206],
                [86.229721, 19.90501],
                [86.229446, 19.90501],
                [86.228333000000177, 19.903891000000211],
                [86.227784, 19.903611000000122],
                [86.22667, 19.903611000000122],
                [86.226387, 19.903891000000211],
                [86.225831000000127, 19.903889],
                [86.224999000000167, 19.904721000000158],
                [86.224999000000167, 19.90501],
                [86.223611000000105, 19.906392000000206],
                [86.223611000000105, 19.906665],
                [86.223335000000162, 19.906945000000114],
                [86.223335000000162, 19.907223],
                [86.222503000000117, 19.908055000000157],
                [86.222497000000132, 19.908331],
                [86.221665, 19.90916500000014],
                [86.221665, 19.909446000000113],
                [86.221389, 19.909721000000157],
                [86.221389, 19.910555],
                [86.221109, 19.910829000000145],
                [86.221109, 19.911387000000158],
                [86.223053000000149, 19.913329],
                [86.223053000000149, 19.91361],
                [86.223891, 19.914444000000113],
                [86.223891, 19.914719000000158],
                [86.225282000000149, 19.916112000000105],
                [86.225562, 19.916112000000105],
                [86.226066, 19.91662],
                [86.226341, 19.917311000000208],
                [86.226569, 19.918551],
                [86.226569, 19.919499000000197],
                [86.226326, 19.920520000000117],
                [86.226066, 19.92088],
                [86.225831000000127, 19.921110000000109],
                [86.225516000000184, 19.921771],
                [86.224808, 19.92251],
                [86.2243110000001, 19.923323],
                [86.223784, 19.924652],
                [86.22354, 19.92498],
                [86.223283000000123, 19.925331000000138],
                [86.222893, 19.925621000000145],
                [86.222526, 19.925621000000145],
                [86.222497000000132, 19.925477000000111],
                [86.222465000000156, 19.925345],
                [86.222747000000169, 19.924802],
                [86.223053000000149, 19.924169],
                [86.22355, 19.92294000000015],
                [86.223976, 19.922131000000199],
                [86.224213000000162, 19.921899],
                [86.225061, 19.920951000000112],
                [86.225562, 19.920340000000177],
                [86.225769000000113, 19.919665000000119],
                [86.225555, 19.918612],
                [86.225282000000149, 19.918334000000126],
                [86.225282000000149, 19.918056000000202],
                [86.224999000000167, 19.917780000000104],
                [86.224999000000167, 19.917500000000185],
                [86.223891, 19.916390000000199],
                [86.223891, 19.916112000000105],
                [86.220817, 19.913060000000193],
                [86.220817, 19.912780000000108],
                [86.220559, 19.912500000000186],
                [86.220559, 19.912219],
                [86.220277, 19.911946],
                [86.220277, 19.911670000000125],
                [86.220001000000181, 19.911390000000207],
                [86.219436, 19.911950000000157],
                [86.21888600000014, 19.911950000000157],
                [86.218681, 19.912149000000106],
                [86.217758, 19.91290100000014],
                [86.217202, 19.91323600000015],
                [86.216897, 19.91332],
                [86.216712, 19.91337],
                [86.216559000000174, 19.913441],
                [86.216279, 19.913311000000188],
                [86.216133, 19.913101000000207],
                [86.216065000000114, 19.912698],
                [86.215561, 19.912420000000164],
                [86.214722, 19.912222],
                [86.214164, 19.912222],
                [86.213891, 19.911946],
                [86.213608, 19.911950000000157],
                [86.212981, 19.911319],
                [86.212776000000105, 19.911109],
                [86.212503000000126, 19.911112000000113],
                [86.212503000000126, 19.910834000000186],
                [86.212220000000144, 19.910555],
                [86.212220000000144, 19.90916500000014],
                [86.212503000000126, 19.908889],
                [86.212220000000144, 19.908331],
                [86.212503000000126, 19.908055000000157],
                [86.212503000000126, 19.906111],
                [86.212220000000144, 19.905831000000145],
                [86.212220000000144, 19.905555],
                [86.211388, 19.904721000000158],
                [86.209442000000166, 19.904721000000158],
                [86.208876, 19.905282],
                [86.208876, 19.90556],
                [86.208480000000165, 19.906000000000116],
                [86.208129, 19.90607],
                [86.207917000000108, 19.90607],
                [86.207917000000108, 19.905530000000109],
                [86.208047000000178, 19.904721000000158],
                [86.209442000000166, 19.903333],
                [86.211112000000114, 19.903331],
                [86.211388, 19.903611000000122],
                [86.211944, 19.903611000000122],
                [86.213059, 19.904721000000158],
                [86.213059, 19.90501],
                [86.213608, 19.905555],
                [86.213608, 19.905831000000145],
                [86.213891, 19.906111],
                [86.213891, 19.906392000000206],
                [86.214164, 19.906665],
                [86.214164, 19.906945000000114],
                [86.213891, 19.907223],
                [86.213891, 19.908333],
                [86.213608, 19.908609000000119],
                [86.213608, 19.908889],
                [86.213891, 19.90916500000014],
                [86.213891, 19.909719000000162],
                [86.214157, 19.909999],
                [86.214164, 19.910277000000114],
                [86.214447, 19.910555],
                [86.214447, 19.910829000000145],
                [86.215012, 19.911390000000207],
                [86.215554000000154, 19.911387000000158],
                [86.215652, 19.911485],
                [86.21584400000016, 19.911670000000125],
                [86.216790000000103, 19.91166800000013],
                [86.217216000000164, 19.911670000000125],
                [86.217498, 19.911390000000207],
                [86.217781, 19.911390000000207],
                [86.218330000000137, 19.910829000000145],
                [86.21888600000014, 19.910834000000186],
                [86.219169000000122, 19.910555],
                [86.219169000000122, 19.910277000000114],
                [86.219718, 19.909719000000162],
                [86.219718, 19.908889],
                [86.220001000000181, 19.908609000000119],
                [86.220001000000181, 19.908055000000157],
                [86.220277, 19.907777],
                [86.220277, 19.907221],
                [86.221109, 19.906389000000157],
                [86.221389, 19.906392000000206],
                [86.221947, 19.905831000000145],
                [86.221947, 19.905277000000122],
                [86.223053000000149, 19.904172000000184],
                [86.223053000000149, 19.903891000000211],
                [86.224716, 19.902221],
                [86.225587000000161, 19.901681000000163],
                [86.226578000000117, 19.901610000000115],
                [86.227356, 19.9017510000001],
                [86.228074, 19.90184000000016],
                [86.228386000000157, 19.90184000000016],
                [86.228675, 19.9015710000001],
                [86.227966, 19.900881000000194],
                [86.227531, 19.900755000000114],
                [86.224746, 19.899540000000108],
                [86.222389, 19.898982],
                [86.219971, 19.898105000000207],
                [86.218376, 19.897437000000192],
                [86.217056, 19.896885000000164],
                [86.216133, 19.896890000000205],
                [86.214408000000134, 19.896211000000157],
                [86.212503000000126, 19.895461000000118],
                [86.20987, 19.894583000000122],
                [86.207108000000105, 19.893943],
                [86.206039000000118, 19.89347100000014],
                [86.204612, 19.892860000000205],
                [86.202262000000118, 19.892049],
                [86.199067, 19.890832],
                [86.196296000000117, 19.890071000000198],
                [86.194732, 19.889667000000141],
                [86.1921, 19.88879],
                [86.190614, 19.887969000000165],
                [86.188050000000132, 19.887226000000165],
                [86.185281, 19.88628],
                [86.183922000000152, 19.885941],
                [86.181716, 19.885259000000129],
                [86.178872000000112, 19.884382],
                [86.17778, 19.883887000000122],
                [86.176392000000106, 19.883767000000141],
                [86.175751, 19.883432000000138],
                [86.174897, 19.882951],
                [86.174400000000148, 19.882885000000154],
                [86.172782, 19.882780000000189],
                [86.170831, 19.882180000000115],
                [86.166961000000114, 19.881011000000168],
                [86.165101, 19.88030000000014],
                [86.162681, 19.879619],
                [86.160766, 19.87888],
                [86.15889, 19.878331000000109],
                [86.158332, 19.878333000000104],
                [86.157776000000112, 19.877777],
                [86.155082000000149, 19.877301000000152],
                [86.153999, 19.876868],
                [86.152488, 19.876150000000159],
                [86.150200000000126, 19.875680000000152],
                [86.149856, 19.875680000000152],
                [86.148858000000118, 19.87529],
                [86.147057000000103, 19.874563000000133],
                [86.145852, 19.874158000000186],
                [86.144081000000128, 19.874019000000199],
                [86.14267, 19.873415000000133],
                [86.141113000000161, 19.872672000000133],
                [86.140174000000158, 19.872467],
                [86.13939700000013, 19.872200000000188],
                [86.137528, 19.87181],
                [86.13668, 19.871407],
                [86.135536000000101, 19.871411],
                [86.134467, 19.870730000000204],
                [86.133407000000133, 19.870532000000193],
                [86.132478, 19.870060000000191],
                [86.131668000000133, 19.869720000000139],
                [86.130554000000174, 19.869723],
                [86.128097, 19.869317000000191],
                [86.126960000000139, 19.868909000000194],
                [86.125396, 19.868442],
                [86.124122000000142, 19.867961],
                [86.122474, 19.867500000000117],
                [86.122224000000173, 19.867500000000117],
                [86.120765, 19.867505],
                [86.120323, 19.867473],
                [86.119774000000106, 19.867437],
                [86.118279, 19.866689000000175],
                [86.116852, 19.86655700000011],
                [86.115503, 19.865812000000115],
                [86.113517, 19.865472],
                [86.111389, 19.864722000000139],
                [86.110557, 19.864444],
                [86.110001000000111, 19.864166000000122],
                [86.109611, 19.864041],
                [86.108460000000136, 19.86348],
                [86.107261, 19.86348],
                [86.10611, 19.863612000000153],
                [86.105844, 19.863332],
                [86.104446, 19.863332],
                [86.104164000000125, 19.863056000000139],
                [86.103058000000118, 19.863061000000183],
                [86.102783, 19.86278000000021],
                [86.10250000000012, 19.86278000000021],
                [86.10222, 19.862502000000116],
                [86.101388000000142, 19.862502000000116],
                [86.101249000000152, 19.862361000000188],
                [86.101112, 19.862222],
                [86.100829, 19.862222],
                [86.100556, 19.861944000000161],
                [86.099998, 19.861944000000161],
                [86.099724000000137, 19.861666],
                [86.099168000000105, 19.86167],
                [86.097709, 19.861299],
                [86.096656, 19.86056],
                [86.095145000000159, 19.859911000000178],
                [86.094651000000155, 19.859847],
                [86.092782, 19.85971],
                [86.091941, 19.85972200000014],
                [86.091667000000115, 19.859444],
                [86.090835, 19.859444],
                [86.090553000000156, 19.859168000000121],
                [86.090279, 19.859170000000116],
                [86.089997, 19.85889],
                [86.089477000000144, 19.85889],
                [86.087777000000173, 19.858470000000121],
                [86.085860000000181, 19.858199],
                [86.084365, 19.857732000000166],
                [86.082970000000131, 19.857411],
                [86.080627, 19.857139000000128],
                [86.079200000000156, 19.856741],
                [86.078612000000163, 19.85667],
                [86.07805600000016, 19.856668],
                [86.077774000000119, 19.856946000000161],
                [86.077224000000101, 19.856946000000161],
                [86.076942, 19.857221000000148],
                [86.076386, 19.857221000000148],
                [86.076110000000114, 19.856946000000161],
                [86.075836, 19.856946000000161],
                [86.07555400000011, 19.856668],
                [86.073334, 19.856668],
                [86.073058000000145, 19.856946000000161],
                [86.072502, 19.856946000000161],
                [86.072219, 19.856668],
                [86.071663, 19.85667],
                [86.071388, 19.856390000000143],
                [86.070549, 19.856390000000143],
                [86.07, 19.855831],
                [86.069726000000159, 19.856112],
                [86.068336, 19.856112],
                [86.06805300000012, 19.855833],
                [86.066109, 19.855833],
                [86.065833, 19.855555000000148],
                [86.065277000000137, 19.85556],
                [86.065001, 19.85528000000016],
                [86.064721000000105, 19.85528000000016],
                [86.064452, 19.854999000000188],
                [86.063331, 19.854999000000188],
                [86.063057000000114, 19.854721],
                [86.062225, 19.854724000000143],
                [86.061387000000124, 19.853889000000148],
                [86.061111, 19.853901000000118],
                [86.060837, 19.854170000000117],
                [86.059996000000169, 19.854170000000117],
                [86.059723000000105, 19.853901000000118],
                [86.059167000000144, 19.853901000000118],
                [86.058891, 19.854170000000117],
                [86.05665500000012, 19.854170000000117],
                [86.054643, 19.853732000000146],
                [86.053496, 19.8533900000001],
                [86.051933, 19.853121000000211],
                [86.050766, 19.852679],
                [86.048653000000101, 19.852221000000149],
                [86.048332000000173, 19.852223000000144],
                [86.048058, 19.851943000000112],
                [86.047776000000141, 19.851943000000112],
                [86.0475, 19.851667000000187],
                [86.04360900000016, 19.851667000000187],
                [86.043336000000153, 19.851943000000112],
                [86.042221, 19.851943000000112],
                [86.041946, 19.852223000000144],
                [86.04139, 19.852221000000149],
                [86.04110700000011, 19.852501],
                [86.040833000000177, 19.852501],
                [86.040284, 19.853060000000138],
                [86.039719, 19.853060000000138],
                [86.03917, 19.853611],
                [86.038887, 19.853611],
                [86.038055, 19.854445000000162],
                [86.037782000000149, 19.854445000000162],
                [86.037499000000167, 19.854724000000143],
                [86.037217000000155, 19.854721],
                [86.036941, 19.854999000000188],
                [86.036667000000108, 19.854999000000188],
                [86.036391, 19.85528000000016],
                [86.03610900000011, 19.85528000000016],
                [86.035842, 19.854999000000188],
                [86.035553, 19.854999000000188],
                [86.035279000000159, 19.85528000000016],
                [86.034997000000118, 19.85528000000016],
                [86.034721, 19.854999000000188],
                [86.034149, 19.854999000000188],
                [86.033921, 19.854751],
                [86.033333000000127, 19.854724000000143],
                [86.033057, 19.854445000000162],
                [86.032501000000181, 19.854445000000162],
                [86.032364, 19.854306],
                [86.032218, 19.854165],
                [86.031936, 19.854170000000117],
                [86.030983, 19.852880000000194],
                [86.030441, 19.852324000000177],
                [86.030441, 19.851984000000126],
                [86.030837000000176, 19.851745],
                [86.030915, 19.851540000000163],
                [86.030906, 19.8512],
                [86.030555, 19.850594],
                [86.030555, 19.850277000000112],
                [86.030281000000159, 19.850001000000187],
                [86.030281000000159, 19.849721],
                [86.029998, 19.84944500000017],
                [86.029998, 19.84917200000012],
                [86.029167, 19.848331000000194],
                [86.028893, 19.848333000000192],
                [86.028054000000154, 19.847501],
                [86.028054000000154, 19.847221],
                [86.027779000000109, 19.846945000000115],
                [86.027779000000109, 19.846667000000188],
                [86.026687, 19.8456],
                [86.026115, 19.845197],
                [86.02526, 19.845131],
                [86.024818, 19.845001000000188],
                [86.023537000000132, 19.844878000000104],
                [86.023537000000132, 19.84454],
                [86.023713000000143, 19.844249000000158],
                [86.024643000000182, 19.844089],
                [86.025276000000105, 19.844169],
                [86.025832000000136, 19.844167],
                [86.026078, 19.844287],
                [86.026947, 19.844723],
                [86.027222, 19.84470900000019],
                [86.027779000000109, 19.845279000000115],
                [86.028054000000154, 19.845279000000115],
                [86.028335000000112, 19.845557000000152],
                [86.028344000000146, 19.845830000000202],
                [86.028893, 19.846389],
                [86.029167, 19.846389],
                [86.030830000000137, 19.848055],
                [86.030830000000137, 19.848333000000192],
                [86.031113, 19.848611000000115],
                [86.031113, 19.848891000000144],
                [86.031669000000122, 19.84944500000017],
                [86.031669000000122, 19.849721],
                [86.031936, 19.850001000000187],
                [86.031936, 19.850562],
                [86.032218, 19.850840000000112],
                [86.032218, 19.85111100000017],
                [86.032501000000181, 19.851389],
                [86.032501000000181, 19.851943000000112],
                [86.032777, 19.852221000000149],
                [86.032777, 19.852501],
                [86.034149, 19.853901000000118],
                [86.036667000000108, 19.853901000000118],
                [86.036941, 19.853611],
                [86.037506, 19.853611],
                [86.037782000000149, 19.853333000000188],
                [86.038055, 19.853333000000188],
                [86.038611000000145, 19.85277700000017],
                [86.038887, 19.852779000000165],
                [86.040574, 19.85111100000017],
                [86.041114000000135, 19.85111100000017],
                [86.043343, 19.848891000000144],
                [86.044166, 19.84805],
                [86.044991000000138, 19.84777900000017],
                [86.045487000000122, 19.847576],
                [86.045631000000157, 19.847371000000173],
                [86.045631000000157, 19.847237000000117],
                [86.045563, 19.847102000000117],
                [86.045059, 19.846911000000144],
                [86.044327000000109, 19.846822000000198],
                [86.044038000000143, 19.846740000000178],
                [86.043021, 19.846571],
                [86.041893000000115, 19.846229000000161],
                [86.041428, 19.846149000000135],
                [86.040298000000149, 19.846017],
                [86.038452000000163, 19.845340000000188],
                [86.037841, 19.84529],
                [86.036202000000159, 19.845080000000163],
                [86.034997000000118, 19.844543],
                [86.03357000000014, 19.844271000000159],
                [86.032143, 19.844069000000157],
                [86.030509, 19.843932],
                [86.029807, 19.843626],
                [86.027528000000103, 19.843291],
                [86.026329, 19.842822000000176],
                [86.024902, 19.842621],
                [86.023482, 19.842491000000162],
                [86.021347000000148, 19.842279000000186],
                [86.020684000000173, 19.842145000000123],
                [86.018477000000175, 19.841607],
                [86.01641, 19.84086],
                [86.014870000000116, 19.840625000000156],
                [86.013947000000115, 19.840490000000155],
                [86.01252, 19.840219000000101],
                [86.01146, 19.840080000000164],
                [86.009995, 19.839982],
                [86.009140000000144, 19.839914],
                [86.008217000000144, 19.839850000000119],
                [86.007369000000125, 19.839371000000138],
                [86.006585000000115, 19.839102],
                [86.005441000000161, 19.839102],
                [86.004798, 19.838833000000189],
                [86.003166, 19.838357],
                [86.001739, 19.838291],
                [86.0, 19.838052],
                [85.99823, 19.837749000000198],
                [85.997498, 19.837780000000119],
                [85.995552000000117, 19.837780000000119],
                [85.995002, 19.837500000000198],
                [85.99472, 19.837500000000198],
                [85.994446, 19.837222000000104],
                [85.994164, 19.837222000000104],
                [85.993888000000112, 19.836944],
                [85.991112, 19.836944],
                [85.990556000000126, 19.83639],
                [85.988892000000121, 19.83639],
                [85.988609000000153, 19.836112000000124],
                [85.985831000000118, 19.836112000000124],
                [85.985558000000125, 19.835832000000206],
                [85.985002000000108, 19.835832000000206],
                [85.98472600000018, 19.835556000000107],
                [85.983611000000138, 19.835561000000148],
                [85.983331, 19.835280000000179],
                [85.982779, 19.835280000000179],
                [85.982499000000104, 19.835000000000147],
                [85.981109, 19.835000000000147],
                [85.980842000000152, 19.83472],
                [85.979156000000131, 19.83472],
                [85.978889, 19.835000000000147],
                [85.978606000000113, 19.835000000000147],
                [85.978378, 19.834767],
                [85.978057000000135, 19.834722],
                [85.977501000000117, 19.834168000000201],
                [85.976386, 19.834170000000196],
                [85.976113, 19.833890000000107],
                [85.97583, 19.833890000000107],
                [85.975564000000119, 19.83361],
                [85.974998000000184, 19.83361],
                [85.9747160000001, 19.833890000000107],
                [85.974442000000153, 19.833890000000107],
                [85.974166, 19.83361],
                [85.97361, 19.83361],
                [85.973344, 19.833329],
                [85.973052, 19.83361],
                [85.972778000000162, 19.83361],
                [85.972496, 19.833329],
                [85.971664, 19.833334000000143],
                [85.971391000000125, 19.833056],
                [85.970559, 19.83306],
                [85.970276000000112, 19.832769],
                [85.968612, 19.832778000000129],
                [85.96833, 19.832500000000206],
                [85.967498, 19.832500000000206],
                [85.967217000000105, 19.832219],
                [85.966942000000103, 19.832222000000112],
                [85.966668000000183, 19.831944],
                [85.964446000000166, 19.831944],
                [85.964166, 19.831668000000143],
                [85.961937, 19.83167],
                [85.961670000000183, 19.83139],
                [85.960282, 19.83139],
                [85.960143000000102, 19.831248000000183],
                [85.959999, 19.831109],
                [85.959168, 19.831112000000129],
                [85.958885000000109, 19.830834000000205],
                [85.958336, 19.830834000000205],
                [85.958053, 19.830556000000112],
                [85.957497, 19.830560000000101],
                [85.957221, 19.83028],
                [85.95527700000018, 19.83028],
                [85.955001, 19.829999000000207],
                [85.953331000000148, 19.829999000000207],
                [85.953057, 19.829731],
                [85.952765, 19.829731],
                [85.952499, 19.829441],
                [85.951387, 19.829446000000129],
                [85.951111000000125, 19.829165000000156],
                [85.949996, 19.8291700000002],
                [85.949723, 19.828890000000111],
                [85.948608000000135, 19.828890000000111],
                [85.948326, 19.828609000000139],
                [85.947776, 19.828611000000134],
                [85.947503, 19.82833300000021],
                [85.946662, 19.82833300000021],
                [85.946571000000162, 19.828242000000156],
                [85.946388000000113, 19.828055000000116],
                [85.945, 19.82806],
                [85.944893, 19.827951],
                [85.944734, 19.827780000000125],
                [85.944442, 19.827780000000125],
                [85.944159000000113, 19.827499000000156],
                [85.942781000000124, 19.827499000000156],
                [85.942498000000143, 19.827221],
                [85.942222, 19.827223],
                [85.941949000000179, 19.826945000000133],
                [85.940834000000137, 19.826945000000133],
                [85.940552, 19.826665],
                [85.938888, 19.826670000000146],
                [85.938605, 19.826392],
                [85.937766, 19.826392],
                [85.937500000000156, 19.826111],
                [85.935836000000137, 19.826111],
                [85.935547, 19.825831000000157],
                [85.935280000000134, 19.825833000000152],
                [85.934997000000152, 19.825555],
                [85.934448, 19.825560000000106],
                [85.933892, 19.82500100000021],
                [85.931107, 19.824441],
                [85.929726000000173, 19.824443],
                [85.929170000000155, 19.823889],
                [85.927499, 19.823891],
                [85.927223000000183, 19.823600000000109],
                [85.926941, 19.823611000000138],
                [85.926667000000151, 19.823333],
                [85.926109, 19.823333],
                [85.925979, 19.823203000000145],
                [85.925835, 19.823055000000178],
                [85.924721, 19.823055000000178],
                [85.924552000000148, 19.823226],
                [85.924447000000129, 19.823333],
                [85.924165000000116, 19.823055000000178],
                [85.923615, 19.823055000000178],
                [85.92333300000017, 19.823333],
                [85.921386, 19.823333],
                [85.92083, 19.822779],
                [85.920281, 19.822781],
                [85.919991, 19.822501000000152],
                [85.919716, 19.822501000000152],
                [85.919442000000103, 19.822221],
                [85.91750300000011, 19.822221],
                [85.917220000000142, 19.822501000000152],
                [85.916947, 19.822221],
                [85.91639, 19.822221],
                [85.916115, 19.822501000000152],
                [85.914168000000174, 19.822501000000152],
                [85.913612, 19.821945000000134],
                [85.91333000000013, 19.821952000000177],
                [85.913063, 19.821671000000205],
                [85.91278, 19.821671000000205],
                [85.912217, 19.821111],
                [85.910836000000174, 19.821111],
                [85.910278, 19.820555],
                [85.909722, 19.821111],
                [85.909722, 19.821391000000116],
                [85.908607000000174, 19.822501000000152],
                [85.908607000000174, 19.823600000000109],
                [85.908334000000124, 19.823889],
                [85.908334000000124, 19.824721000000178],
                [85.908058, 19.82500100000021],
                [85.908051000000142, 19.825831000000157],
                [85.907775, 19.826111],
                [85.907775, 19.826945000000133],
                [85.907502, 19.827221],
                [85.907502, 19.827780000000125],
                [85.907219, 19.828055000000116],
                [85.907219, 19.828609000000139],
                [85.906943000000169, 19.828887],
                [85.906937000000184, 19.829441],
                [85.906670000000119, 19.829731],
                [85.906670000000119, 19.829999000000207],
                [85.906943000000169, 19.830278],
                [85.906387000000151, 19.830834000000205],
                [85.906387000000151, 19.831109],
                [85.905831000000134, 19.831668000000143],
                [85.905831000000134, 19.831944],
                [85.905555, 19.832222000000112],
                [85.904999, 19.832222000000112],
                [85.904603000000165, 19.831827000000143],
                [85.904441, 19.831668000000143],
                [85.904167000000115, 19.83167],
                [85.904167000000115, 19.829731],
                [85.904717000000161, 19.8291700000002],
                [85.904717000000161, 19.828890000000111],
                [85.9050060000001, 19.828609000000139],
                [85.904999, 19.828055000000116],
                [85.905282, 19.827780000000125],
                [85.905282, 19.82500100000021],
                [85.905562, 19.824721000000178],
                [85.905555, 19.823055000000178],
                [85.905831000000134, 19.822781],
                [85.905831000000134, 19.822221],
                [85.906114000000102, 19.821945000000134],
                [85.906114000000102, 19.821111],
                [85.906387000000151, 19.82083300000016],
                [85.906387000000151, 19.820555],
                [85.907775, 19.81916700000016],
                [85.908340000000109, 19.818581000000162],
                [85.908065, 19.817900000000119],
                [85.907219, 19.817779],
                [85.905968000000129, 19.8176810000001],
                [85.903388000000163, 19.816999000000177],
                [85.900840000000173, 19.816049],
                [85.898139000000171, 19.815240000000124],
                [85.895149, 19.814561],
                [85.893013, 19.81402],
                [85.889718000000116, 19.812781],
                [85.88861, 19.812781],
                [85.888337, 19.812500000000107],
                [85.88639, 19.812500000000107],
                [85.886108, 19.812220000000192],
                [85.885558000000145, 19.812222000000187],
                [85.885278, 19.811944],
                [85.885002, 19.811951000000132],
                [85.884720000000101, 19.811662],
                [85.884163, 19.811666000000169],
                [85.883888000000169, 19.811388],
                [85.883605, 19.81139],
                [85.883332, 19.811110000000205],
                [85.8825, 19.811112000000143],
                [85.882226000000159, 19.810832000000111],
                [85.880836, 19.810832000000111],
                [85.88055300000012, 19.810556000000187],
                [85.879448000000181, 19.810561],
                [85.879334000000185, 19.810447],
                [85.879174, 19.81028],
                [85.87889200000015, 19.81028],
                [85.878609, 19.810000000000169],
                [85.876945, 19.810000000000169],
                [85.87666300000015, 19.809722],
                [85.876114, 19.809722],
                [85.875831, 19.809444000000205],
                [85.874726000000109, 19.809444000000205],
                [85.874443000000127, 19.809166000000115],
                [85.874169, 19.80917],
                [85.873887000000124, 19.808890000000186],
                [85.872779000000136, 19.808890000000186],
                [85.872497, 19.808598000000185],
                [85.872223000000119, 19.808612],
                [85.871947, 19.808332000000174],
                [85.871391, 19.808332000000174],
                [85.871109000000146, 19.808056],
                [85.870277, 19.80806],
                [85.870003, 19.807780000000147],
                [85.869721, 19.807780000000147],
                [85.869445000000141, 19.807500000000115],
                [85.868057, 19.807500000000115],
                [85.867783000000117, 19.807219000000142],
                [85.866669, 19.807222000000188],
                [85.866386000000134, 19.806944],
                [85.865554, 19.806944],
                [85.865281, 19.806668000000169],
                [85.864998, 19.806670000000164],
                [85.864722000000128, 19.80639],
                [85.864440000000101, 19.80639],
                [85.864166000000154, 19.80611],
                [85.863610000000151, 19.80611],
                [85.863052, 19.805560000000177],
                [85.861946000000145, 19.805560000000177],
                [85.861657, 19.80528],
                [85.860558, 19.80528],
                [85.859437, 19.804170000000109],
                [85.858888, 19.803890000000191],
                [85.858612000000136, 19.803609],
                [85.857498000000177, 19.803612],
                [85.855629, 19.803406000000102],
                [85.85476, 19.802588000000124],
                [85.853919000000175, 19.802730000000107],
                [85.852784, 19.802730000000107],
                [85.851066000000145, 19.8016520000001],
                [85.849509000000168, 19.8016520000001],
                [85.849083, 19.801111],
                [85.84751, 19.800701000000114],
                [85.846656000000138, 19.801241],
                [85.845521, 19.801241],
                [85.844529, 19.800560000000186],
                [85.843103, 19.800428],
                [85.841393, 19.799480000000184],
                [85.839547000000138, 19.79921100000012],
                [85.837981, 19.798800000000195],
                [85.8375, 19.798055000000197],
                [85.834442000000124, 19.797221000000146],
                [85.833466, 19.797232000000175],
                [85.83191, 19.796845000000125],
                [85.831123000000133, 19.796649],
                [85.829002000000159, 19.795701000000118],
                [85.82685, 19.79556400000018],
                [85.824929000000154, 19.794794],
                [85.822349, 19.794073],
                [85.820067, 19.793125000000142],
                [85.818383000000125, 19.79236],
                [85.816963, 19.79236],
                [85.813216000000153, 19.791459000000142],
                [85.810281, 19.790276000000169],
                [85.809998, 19.790559000000137],
                [85.809166, 19.790559000000137],
                [85.808890000000176, 19.790279],
                [85.808327000000119, 19.790279],
                [85.80722, 19.789171],
                [85.806946, 19.789171],
                [85.806657, 19.788891000000145],
                [85.805283, 19.788891000000145],
                [85.803758000000116, 19.788120000000102],
                [85.801194, 19.78730900000016],
                [85.799348000000109, 19.786899000000172],
                [85.797782, 19.786390000000146],
                [85.797502000000108, 19.78611],
                [85.795243, 19.785367],
                [85.792962000000145, 19.784280000000187],
                [85.791389, 19.783612000000172],
                [85.78901, 19.783555],
                [85.788437, 19.782881],
                [85.787011000000149, 19.782470000000156],
                [85.785279, 19.78278],
                [85.784157000000135, 19.78278],
                [85.783891000000125, 19.782502000000129],
                [85.783332, 19.782502000000129],
                [85.78319500000012, 19.782361000000204],
                [85.783059, 19.782222],
                [85.782500000000184, 19.782222],
                [85.78222, 19.781944000000177],
                [85.781937000000127, 19.781942000000182],
                [85.781388000000149, 19.782502000000129],
                [85.781388000000149, 19.782778],
                [85.78083, 19.783332],
                [85.78083, 19.783612000000172],
                [85.780556, 19.78389],
                [85.78083, 19.784444],
                [85.78083, 19.784722000000151],
                [85.780556, 19.785],
                [85.779929, 19.785041],
                [85.779838, 19.784998],
                [85.779647000000168, 19.784907000000196],
                [85.779647000000168, 19.784032],
                [85.779717000000105, 19.783610000000177],
                [85.779724000000144, 19.783332],
                [85.779998, 19.783056000000155],
                [85.779998, 19.780560000000204],
                [85.779717000000105, 19.780280000000172],
                [85.779717000000105, 19.77971900000011],
                [85.779442000000103, 19.779444],
                [85.779168000000183, 19.779444],
                [85.778892, 19.779168000000134],
                [85.778619, 19.779170000000128],
                [85.778343000000106, 19.77889],
                [85.778054000000154, 19.77889],
                [85.777222, 19.778060000000149],
                [85.776946000000166, 19.778060000000149],
                [85.776390000000134, 19.777500000000142],
                [85.775558, 19.777500000000142],
                [85.775275000000121, 19.777219000000169],
                [85.775002, 19.777222000000105],
                [85.774719, 19.776946000000176],
                [85.774444000000116, 19.777222000000105],
                [85.773887, 19.777222000000105],
                [85.773331, 19.776668],
                [85.773056000000153, 19.77667],
                [85.77249, 19.776109000000186],
                [85.772224, 19.776112],
                [85.771941000000112, 19.775900000000146],
                [85.77028000000017, 19.775834000000142],
                [85.769997, 19.775555000000164],
                [85.769721, 19.77556],
                [85.769448, 19.775280000000173],
                [85.769172000000168, 19.775280000000173],
                [85.768889, 19.774999000000204],
                [85.767219, 19.774999000000204],
                [85.766938, 19.774721000000106],
                [85.766669, 19.774724000000159],
                [85.766387000000108, 19.774446],
                [85.766113000000161, 19.774724000000159],
                [85.764381, 19.774131000000118],
                [85.762818, 19.773591],
                [85.760276, 19.772779000000181],
                [85.760003, 19.77249],
                [85.75972, 19.772499],
                [85.759445000000184, 19.772223000000164],
                [85.758613000000111, 19.772223000000164],
                [85.758332000000152, 19.771943],
                [85.758057000000107, 19.771943],
                [85.757774000000126, 19.7716670000002],
                [85.757491000000172, 19.77167],
                [85.756942, 19.771111000000186],
                [85.755547, 19.771111000000186],
                [85.755281000000124, 19.770831],
                [85.754998000000143, 19.770555000000169],
                [85.754449000000179, 19.770562],
                [85.752587000000148, 19.769821000000203],
                [85.751313, 19.769281],
                [85.748336000000151, 19.768611],
                [85.748053000000183, 19.768333000000208],
                [85.747497000000152, 19.768333000000208],
                [85.74739, 19.768226],
                [85.747224000000102, 19.768055000000114],
                [85.746665, 19.76806200000015],
                [85.746392, 19.767781000000177],
                [85.746109, 19.767781000000177],
                [85.745827000000162, 19.767501],
                [85.745551, 19.767501],
                [85.745277000000144, 19.767221],
                [85.744721000000183, 19.767221],
                [85.744446000000138, 19.766945],
                [85.743058, 19.766945],
                [85.742499000000166, 19.766389000000114],
                [85.741670000000155, 19.766389000000114],
                [85.740838, 19.765559000000163],
                [85.740548, 19.765559000000163],
                [85.740279000000143, 19.765279],
                [85.738609, 19.765279],
                [85.736061, 19.764369],
                [85.73420800000018, 19.763560000000147],
                [85.732644, 19.762751000000204],
                [85.730652000000106, 19.762070000000161],
                [85.728059, 19.761666],
                [85.727783, 19.761391000000113],
                [85.727509000000154, 19.761391000000113],
                [85.727218, 19.761110000000141],
                [85.726388000000128, 19.761110000000141],
                [85.72583000000013, 19.760550000000134],
                [85.725556, 19.760554000000123],
                [85.72528, 19.760278000000191],
                [85.724442, 19.760281],
                [85.720558, 19.758890000000118],
                [85.716111000000112, 19.757491000000179],
                [85.715553000000156, 19.7575],
                [85.715279, 19.757222000000123],
                [85.714997000000125, 19.757222000000123],
                [85.714721, 19.7569440000002],
                [85.714448, 19.7569440000002],
                [85.714165, 19.756666000000106],
                [85.713889000000137, 19.756671000000207],
                [85.713060000000127, 19.755832],
                [85.710694, 19.75563800000014],
                [85.708978, 19.7551],
                [85.707681, 19.75472],
                [85.706398, 19.754451000000184],
                [85.705826, 19.754451000000184],
                [85.705559000000136, 19.75417],
                [85.705276000000183, 19.75417],
                [85.705003000000133, 19.753890000000123],
                [85.704438000000138, 19.753890000000123],
                [85.703132, 19.753311000000163],
                [85.701988, 19.75276],
                [85.700278000000168, 19.752222000000124],
                [85.699998, 19.751944],
                [85.699722000000165, 19.751944],
                [85.69889, 19.751112000000145],
                [85.698608, 19.751112000000145],
                [85.698516, 19.751018000000155],
                [85.698334, 19.750834],
                [85.697220000000101, 19.750834],
                [85.697044, 19.750654],
                [85.696946000000182, 19.750556000000124],
                [85.696105, 19.750560000000117],
                [85.695832, 19.750280000000199],
                [85.695266000000103, 19.750280000000199],
                [85.695, 19.750000000000167],
                [85.694444, 19.750000000000167],
                [85.693885, 19.749450000000135],
                [85.693047000000135, 19.749450000000135],
                [85.69278, 19.74917],
                [85.692497, 19.74917],
                [85.692221000000174, 19.748890000000124],
                [85.691948000000181, 19.748890000000124],
                [85.691672, 19.748609000000151],
                [85.691109, 19.748612],
                [85.690833, 19.748333],
                [85.690277000000137, 19.748333],
                [85.689995, 19.748112],
                [85.689452, 19.74806],
                [85.689263, 19.747875000000189],
                [85.689163000000107, 19.747777],
                [85.688607000000147, 19.747780000000144],
                [85.688331, 19.747499000000172],
                [85.687499000000102, 19.747499000000172],
                [85.687232, 19.747221],
                [85.686943000000127, 19.747224000000127],
                [85.686669, 19.746945000000146],
                [85.686111, 19.746945000000146],
                [85.685838, 19.746665],
                [85.684997, 19.746670000000105],
                [85.684723000000119, 19.746389000000132],
                [85.684447, 19.746389000000132],
                [85.682487, 19.74597000000011],
                [85.680495, 19.745701],
                [85.678886000000134, 19.744721000000133],
                [85.678337, 19.744167000000171],
                [85.678048, 19.744172],
                [85.677781, 19.743891],
                [85.67694, 19.743891],
                [85.675828, 19.742781],
                [85.675278, 19.742781],
                [85.675003, 19.742510000000202],
                [85.673888000000119, 19.742510000000202],
                [85.673608000000101, 19.742221],
                [85.672776000000155, 19.742221],
                [85.6725, 19.741945000000154],
                [85.671937000000156, 19.74195200000019],
                [85.671668000000167, 19.741672000000101],
                [85.671386, 19.741672000000101],
                [85.671112000000136, 19.741391000000128],
                [85.670829000000182, 19.741391000000128],
                [85.670563000000172, 19.741111],
                [85.67028, 19.741111],
                [85.669998000000177, 19.740833000000176],
                [85.669166, 19.740833000000176],
                [85.668892000000113, 19.740555],
                [85.668610000000101, 19.740555],
                [85.668334000000158, 19.740279000000154],
                [85.667778000000155, 19.740281000000149],
                [85.6676870000001, 19.740188],
                [85.667222000000123, 19.739721000000195],
                [85.666663, 19.739721000000195],
                [85.66639, 19.739445],
                [85.664719, 19.739449],
                [85.66443700000012, 19.739169000000171],
                [85.663611000000145, 19.739169000000171],
                [85.663055, 19.738608000000109],
                [85.662782000000135, 19.738333],
                [85.662782000000135, 19.738057000000136],
                [85.662499000000182, 19.737779],
                [85.662499000000182, 19.736669],
                [85.662217, 19.736379],
                [85.662223, 19.735557],
                [85.662499000000182, 19.735281000000153],
                [85.662217, 19.735001],
                [85.662217, 19.73472],
                [85.661941000000169, 19.734444000000163],
                [85.661941000000169, 19.733888000000199],
                [85.661667, 19.733610000000105],
                [85.661667, 19.73333400000018],
                [85.660279000000159, 19.731944000000109],
                [85.659997000000118, 19.731951000000148],
                [85.659721, 19.731671],
                [85.6594470000001, 19.731951000000148],
                [85.658889, 19.731951000000148],
                [85.658057, 19.73111],
                [85.657501000000181, 19.73111],
                [85.656669, 19.731951000000148],
                [85.655555, 19.731944000000109],
                [85.655281000000144, 19.732222000000199],
                [85.654725, 19.732222000000199],
                [85.654443000000114, 19.731951000000148],
                [85.653611000000168, 19.731951000000148],
                [85.653344000000104, 19.731671],
                [85.652779000000109, 19.731671],
                [85.651947000000163, 19.730832000000131],
                [85.651664, 19.730832000000131],
                [85.651108, 19.730278000000109],
                [85.650832000000136, 19.730280000000104],
                [85.650559, 19.73000200000018],
                [85.65, 19.729444],
                [85.649720000000102, 19.729444],
                [85.649444, 19.729722],
                [85.648888, 19.729722],
                [85.648612, 19.729444],
                [85.647498000000141, 19.729444],
                [85.647224, 19.729166000000131],
                [85.646942000000124, 19.72917],
                [85.646668, 19.728890000000202],
                [85.646386000000163, 19.728890000000202],
                [85.64611, 19.728612000000108],
                [85.645547000000178, 19.728612000000108],
                [85.645278000000118, 19.728329000000141],
                [85.644722, 19.728332000000186],
                [85.644446, 19.728056],
                [85.644173000000166, 19.728061000000135],
                [85.643981, 19.727871],
                [85.64389, 19.727778],
                [85.643607, 19.727780000000163],
                [85.643325000000146, 19.727511000000103],
                [85.643058, 19.727511000000103],
                [85.642662, 19.72710300000011],
                [85.642502000000135, 19.726944000000113],
                [85.64222, 19.726944000000113],
                [85.641114, 19.72583400000013],
                [85.640556, 19.72583400000013],
                [85.640273, 19.725556000000207],
                [85.639717, 19.725560000000197],
                [85.639444, 19.725280000000108],
                [85.63916800000014, 19.725280000000108],
                [85.638336, 19.72500000000019],
                [85.63778, 19.72500000000019],
                [85.637221000000167, 19.724439000000128],
                [85.636948000000118, 19.724446],
                [85.636665000000136, 19.724168000000127],
                [85.636392, 19.72417],
                [85.635827, 19.723609],
                [85.635277, 19.723612000000113],
                [85.635001000000145, 19.72333400000019],
                [85.634445000000113, 19.72333400000019],
                [85.6341630000001, 19.723056],
                [85.633889000000153, 19.72333400000019],
                [85.633057, 19.722499000000191],
                [85.631667000000149, 19.722499000000191],
                [85.631387, 19.722219000000159],
                [85.630837, 19.722221],
                [85.629447000000127, 19.720833000000191],
                [85.629165, 19.720833000000191],
                [85.628975000000182, 19.720637000000178],
                [85.628891000000166, 19.720555],
                [85.627777, 19.720560000000201],
                [85.627503, 19.720280000000113],
                [85.627221000000162, 19.720280000000113],
                [85.626954, 19.720002000000189],
                [85.62666200000011, 19.720002000000189],
                [85.626389, 19.719721],
                [85.626113000000117, 19.719723],
                [85.6258330000001, 19.719445000000118],
                [85.625557000000157, 19.719445000000118],
                [85.625274, 19.719165],
                [85.62499200000012, 19.71917000000013],
                [85.624816000000109, 19.718985],
                [85.624734, 19.718892000000206],
                [85.624442, 19.718892000000206],
                [85.624169, 19.718611],
                [85.623886000000127, 19.718611],
                [85.622781000000131, 19.717501000000194],
                [85.622498000000149, 19.717501000000194],
                [85.622222, 19.717221000000162],
                [85.619378000000125, 19.716767],
                [85.618667000000102, 19.716359],
                [85.617812, 19.715819000000121],
                [85.616385000000136, 19.715281],
                [85.615326, 19.714830000000173],
                [85.61434100000011, 19.714420000000185],
                [85.613334, 19.713611],
                [85.613053000000136, 19.713333000000144],
                [85.612504000000158, 19.713333000000144],
                [85.612222000000116, 19.713055],
                [85.611946, 19.713055],
                [85.611114, 19.712223000000161],
                [85.608926, 19.7116170000001],
                [85.607697, 19.710839000000188],
                [85.607499000000104, 19.710559],
                [85.607217, 19.710279],
                [85.606667, 19.710279],
                [85.60639100000013, 19.710001000000144],
                [85.606109, 19.710001000000144],
                [85.605826, 19.709720000000171],
                [85.605003, 19.709723],
                [85.604721000000126, 19.709445000000123],
                [85.604447, 19.709445000000123],
                [85.603889, 19.708888],
                [85.603606, 19.708891000000161],
                [85.603219000000166, 19.70849400000014],
                [85.603057000000121, 19.708335000000144],
                [85.602774000000167, 19.708335000000144],
                [85.602273, 19.707831000000162],
                [85.601945000000157, 19.707500000000145],
                [85.601113, 19.707500000000145],
                [85.600824, 19.70722],
                [85.600555, 19.707222],
                [85.600158, 19.70682800000014],
                [85.599999, 19.706666],
                [85.599442000000153, 19.706671000000139],
                [85.599167000000108, 19.7064],
                [85.598893, 19.7064],
                [85.598647000000113, 19.706151],
                [85.598052, 19.706112],
                [85.597275, 19.705588],
                [85.596495, 19.705069],
                [85.59616, 19.704720000000176],
                [85.596046, 19.704424000000184],
                [85.595413, 19.704417000000145],
                [85.594918000000106, 19.704280000000207],
                [85.594018, 19.704079],
                [85.593612, 19.703610000000189],
                [85.59333, 19.703612000000128],
                [85.593056, 19.703332],
                [85.592780000000147, 19.703341000000133],
                [85.592498, 19.703061],
                [85.591949000000142, 19.703061],
                [85.591759, 19.702869000000131],
                [85.591668000000112, 19.702778],
                [85.591392, 19.70278],
                [85.590843000000106, 19.702222],
                [85.590554000000154, 19.702222],
                [85.590278, 19.701944000000189],
                [85.589995, 19.701944000000189],
                [85.589166, 19.70111],
                [85.588883, 19.70111],
                [85.588699000000176, 19.700925],
                [85.588607000000181, 19.700834000000153],
                [85.588334, 19.700834000000153],
                [85.588195, 19.700695],
                [85.588058, 19.700556],
                [85.587219, 19.70056],
                [85.586937, 19.700269000000159],
                [85.586670000000126, 19.700278000000189],
                [85.586388, 19.7],
                [85.586114000000151, 19.7],
                [85.585822000000164, 19.699719000000123],
                [85.585556000000153, 19.699722000000175],
                [85.585282, 19.699444],
                [85.585, 19.699444],
                [85.584724, 19.699168000000153],
                [85.584441000000112, 19.699170000000148],
                [85.583892000000148, 19.698610000000198],
                [85.583612, 19.698610000000198],
                [85.583336, 19.698329],
                [85.583053, 19.698334],
                [85.58278000000017, 19.698056000000172],
                [85.582497, 19.698060000000165],
                [85.581948, 19.697500000000158],
                [85.581665, 19.697500000000158],
                [85.581184000000107, 19.697283000000134],
                [85.580628, 19.697420000000132],
                [85.579436, 19.697260000000195],
                [85.578301, 19.696711000000104],
                [85.576881, 19.696173000000154],
                [85.575455, 19.69536],
                [85.574600000000117, 19.69536],
                [85.572503, 19.694441000000207],
                [85.57222, 19.694165000000108],
                [85.571954, 19.694170000000152],
                [85.571662, 19.69388900000018],
                [85.571389, 19.69388900000018],
                [85.571106, 19.693611],
                [85.570816, 19.693611],
                [85.570001, 19.69278],
                [85.569169, 19.69278],
                [85.568886, 19.692501000000103],
                [85.56861000000012, 19.692501000000103],
                [85.568337, 19.692221000000181],
                [85.568047, 19.692501000000103],
                [85.566673, 19.691111000000202],
                [85.56639, 19.691111000000202],
                [85.565827, 19.69056],
                [85.565278000000134, 19.690001],
                [85.565002, 19.690001],
                [85.564720000000108, 19.68972100000013],
                [85.564446, 19.68972100000013],
                [85.564164000000162, 19.689443000000207],
                [85.563888, 19.689443000000207],
                [85.563614000000115, 19.689167000000108],
                [85.563332, 19.689172000000148],
                [85.563056000000117, 19.688891000000176],
                [85.562767, 19.688891000000176],
                [85.562523, 19.688634],
                [85.562233, 19.688331],
                [85.561668, 19.688333],
                [85.561112, 19.687779000000202],
                [85.560547, 19.687781000000196],
                [85.560280000000134, 19.687501000000108],
                [85.559724000000102, 19.687501000000108],
                [85.559448, 19.687221000000189],
                [85.558892, 19.687221000000189],
                [85.558334, 19.686667],
                [85.558051, 19.686669],
                [85.557502000000142, 19.686108000000157],
                [85.556946000000138, 19.686111000000206],
                [85.556663000000171, 19.685833000000112],
                [85.556390000000121, 19.685833000000112],
                [85.555831, 19.685279],
                [85.555558, 19.685279],
                [85.555275, 19.684999],
                [85.554999000000166, 19.684999],
                [85.554733000000155, 19.684721000000131],
                [85.553887, 19.684723000000126],
                [85.553611, 19.684445000000206],
                [85.553338, 19.684445000000206],
                [85.552779000000143, 19.683889000000189],
                [85.552497000000116, 19.683889000000189],
                [85.552223000000183, 19.683611],
                [85.551941, 19.683611],
                [85.549714, 19.682501000000112],
                [85.549445000000148, 19.682501000000112],
                [85.548889, 19.68194],
                [85.548615, 19.681945],
                [85.54833300000017, 19.681666000000117],
                [85.548057, 19.681671],
                [85.547784, 19.681391000000126],
                [85.547225000000168, 19.681391000000126],
                [85.546936, 19.681110000000153],
                [85.542526, 19.67982000000017],
                [85.539542, 19.678191000000194],
                [85.536392, 19.67639],
                [85.533623, 19.67557],
                [85.530922, 19.674626],
                [85.528924000000117, 19.67273],
                [85.525368, 19.67151100000012],
                [85.522797000000125, 19.66989000000012],
                [85.518936, 19.668030000000208],
                [85.516379, 19.667230000000128],
                [85.513526, 19.66546],
                [85.511399, 19.664240000000174],
                [85.509262, 19.663160000000168],
                [85.506944, 19.66167200000012],
                [85.502777, 19.659169000000187],
                [85.50138900000016, 19.658889],
                [85.501107000000147, 19.658889],
                [85.500268000000162, 19.658059000000147],
                [85.499443000000142, 19.658059000000147],
                [85.499167, 19.657779],
                [85.498887000000124, 19.657779],
                [85.498595000000122, 19.657501000000192],
                [85.498338000000132, 19.657501000000192],
                [85.498046000000144, 19.65722],
                [85.497779, 19.657223],
                [85.497497, 19.656945000000171],
                [85.497223000000119, 19.656945000000171],
                [85.496947, 19.656667],
                [85.496391000000173, 19.656669],
                [85.496109000000146, 19.656391000000152],
                [85.495826000000179, 19.656391000000152],
                [85.4955590000001, 19.65611100000012],
                [85.495277, 19.65611100000012],
                [85.494721, 19.655559],
                [85.494445000000141, 19.655559],
                [85.493889000000109, 19.655001],
                [85.493606000000156, 19.655001],
                [85.492767000000171, 19.654171000000186],
                [85.492501, 19.654171000000186],
                [85.492394, 19.654059000000128],
                [85.492225000000118, 19.653888],
                [85.491669, 19.653891],
                [85.491386000000134, 19.653610000000125],
                [85.491113000000126, 19.653610000000125],
                [85.490548, 19.653061000000143],
                [85.490281, 19.653061000000143],
                [85.489998, 19.652781],
                [85.489166, 19.652781],
                [85.488891000000123, 19.6525],
                [85.488610000000151, 19.6525],
                [85.488328, 19.652231],
                [85.488052000000138, 19.652231],
                [85.487778, 19.651951000000164],
                [85.486947, 19.651951000000164],
                [85.486657, 19.651671],
                [85.485559000000123, 19.651671],
                [85.485283, 19.651390000000102],
                [85.485, 19.651390000000102],
                [85.484863, 19.651249000000174],
                [85.484727000000177, 19.651112000000175],
                [85.484168, 19.651112000000175],
                [85.483886, 19.650832],
                [85.48333, 19.650832],
                [85.483056000000133, 19.650554],
                [85.48278, 19.650554],
                [85.482498000000177, 19.650278000000124],
                [85.482215, 19.650280000000119],
                [85.481942000000146, 19.650000000000201],
                [85.481666, 19.650000000000201],
                [85.481392000000127, 19.649722000000107],
                [85.48111, 19.649722000000107],
                [85.480554, 19.649166],
                [85.480278000000155, 19.649166],
                [85.480004, 19.64889],
                [85.479722000000123, 19.64889],
                [85.479446, 19.648612000000124],
                [85.47889, 19.648612000000124],
                [85.47860700000011, 19.648332000000206],
                [85.478331000000168, 19.648332000000206],
                [85.478058000000132, 19.648056000000107],
                [85.477782, 19.648061000000151],
                [85.477447, 19.647723],
                [85.47693700000012, 19.64722],
                [85.476387, 19.647222],
                [85.476112, 19.646944000000126],
                [85.474999000000182, 19.646944000000126],
                [85.474441000000155, 19.646390000000107],
                [85.473892, 19.646390000000107],
                [85.47360900000011, 19.646101000000154],
                [85.473336, 19.64611],
                [85.473053, 19.645834],
                [85.472779000000159, 19.645834],
                [85.472504000000157, 19.645556],
                [85.472221, 19.64556],
                [85.471948000000154, 19.64528000000012],
                [85.471389, 19.64528000000012],
                [85.471015, 19.644906],
                [85.470833, 19.644719],
                [85.47027700000011, 19.644722000000112],
                [85.469719, 19.644168],
                [85.46943600000013, 19.64417],
                [85.468887, 19.643609],
                [85.467499, 19.643612000000125],
                [85.467225000000141, 19.643334000000205],
                [85.4669430000001, 19.643334000000205],
                [85.466835, 19.643224000000142],
                [85.466667, 19.643056000000112],
                [85.466393, 19.643060000000101],
                [85.466156000000169, 19.642821],
                [85.465844000000104, 19.642500000000151],
                [85.465552000000102, 19.642500000000151],
                [85.465279000000109, 19.642221000000117],
                [85.464723, 19.642221000000117],
                [85.464447000000163, 19.641946000000129],
                [85.464164, 19.641946000000129],
                [85.463891, 19.641665000000152],
                [85.463608, 19.6416700000002],
                [85.463332000000122, 19.641390000000108],
                [85.462776000000119, 19.641390000000108],
                [85.462487000000152, 19.641109000000139],
                [85.462220000000102, 19.641112],
                [85.46167100000018, 19.640555000000116],
                [85.461113000000154, 19.64056],
                [85.46083, 19.640291000000158],
                [85.459718, 19.640291000000158],
                [85.459426, 19.639999000000156],
                [85.458886000000106, 19.639999000000156],
                [85.458337000000171, 19.63944500000013],
                [85.458054, 19.63944500000013],
                [85.457496, 19.638889000000116],
                [85.457222, 19.638892],
                [85.456946000000173, 19.638611],
                [85.45668, 19.638892],
                [85.455825000000146, 19.638892],
                [85.455002000000135, 19.638060000000102],
                [85.45472, 19.638060000000102],
                [85.454437, 19.637782000000183],
                [85.45417, 19.637782000000183],
                [85.453888000000106, 19.63750100000021],
                [85.453614000000158, 19.63750100000021],
                [85.453332000000145, 19.637221000000121],
                [85.453056, 19.637223000000116],
                [85.452773, 19.636943],
                [85.4525, 19.636943],
                [85.452224000000101, 19.636667000000156],
                [85.451112000000123, 19.636672000000196],
                [85.450836, 19.636391],
                [85.449721000000167, 19.636391],
                [85.449448000000118, 19.636111000000138],
                [85.447966, 19.635621000000121],
                [85.447830000000167, 19.635632],
                [85.446471, 19.634956000000155],
                [85.445763, 19.634753],
                [85.444976, 19.6345500000001],
                [85.443887, 19.633891000000112],
                [85.443611000000132, 19.634167],
                [85.443338000000125, 19.634167],
                [85.441665, 19.632499],
                [85.441391000000166, 19.632499],
                [85.441109, 19.632221000000179],
                [85.440552000000181, 19.632223000000117],
                [85.440277000000137, 19.631945],
                [85.43916200000011, 19.631945],
                [85.438889, 19.63166700000016],
                [85.438606, 19.631669000000155],
                [85.438057000000157, 19.631120000000173],
                [85.437767000000164, 19.631120000000173],
                [85.437501000000154, 19.63083000000017],
                [85.437225, 19.630833],
                [85.432756000000126, 19.629176],
                [85.431037000000146, 19.628232000000136],
                [85.429047000000168, 19.627421000000194],
                [85.425499000000102, 19.625520000000101],
                [85.423789000000156, 19.624572],
                [85.422226000000165, 19.624166000000169],
                [85.419197, 19.62307],
                [85.4177770000001, 19.621987],
                [85.416350000000165, 19.621180000000201],
                [85.414718000000136, 19.620280000000147],
                [85.414436, 19.620280000000147],
                [85.414169, 19.620000000000115],
                [85.41388700000013, 19.620000000000115],
                [85.413613, 19.619720000000196],
                [85.413055, 19.619722000000191],
                [85.410477, 19.618354000000121],
                [85.40919400000017, 19.617677],
                [85.407218, 19.61667],
                [85.404868000000178, 19.61561000000011],
                [85.403441, 19.614667000000107],
                [85.401595, 19.613849],
                [85.400451, 19.613176000000177],
                [85.398888, 19.612502000000173],
                [85.397873000000104, 19.611661],
                [85.397438000000179, 19.611255000000195],
                [85.395738, 19.61071],
                [85.394311000000116, 19.610172000000141],
                [85.39260200000011, 19.609090000000144],
                [85.391036, 19.608552000000195],
                [85.389762000000118, 19.608012000000137],
                [85.388757, 19.607059000000159],
                [85.387191, 19.606380000000112],
                [85.385559000000143, 19.606111],
                [85.38472, 19.605279000000106],
                [85.384461, 19.605279000000106],
                [85.384315000000115, 19.605149000000203],
                [85.384162, 19.604999],
                [85.384148000000124, 19.604721000000151],
                [85.382501, 19.603057000000145],
                [85.381402000000136, 19.603059],
                [85.380837, 19.602501000000128],
                [85.380547, 19.602501000000128],
                [85.379998000000157, 19.60194],
                [85.379449000000179, 19.601945000000107],
                [85.379166, 19.601667],
                [85.378608, 19.601671000000177],
                [85.377778000000134, 19.60083],
                [85.377502, 19.600835000000128],
                [85.377220000000108, 19.600554000000155],
                [85.376664000000147, 19.600561000000194],
                [85.376388, 19.600281000000102],
                [85.376105, 19.600281000000102],
                [85.375634, 19.599800000000126],
                [85.375556000000117, 19.599722000000209],
                [85.375000000000156, 19.599722000000209],
                [85.374726, 19.599444000000116],
                [85.374168, 19.599451],
                [85.373885, 19.599171000000123],
                [85.373612, 19.599171000000123],
                [85.373054, 19.59861],
                [85.372497000000166, 19.598052],
                [85.371948, 19.598054],
                [85.371666000000161, 19.597778000000115],
                [85.371109, 19.597781],
                [85.370827000000162, 19.5975],
                [85.370278, 19.5975],
                [85.367944000000179, 19.59665],
                [85.366722, 19.59577],
                [85.365532000000115, 19.595431000000126],
                [85.364097, 19.594619],
                [85.362679000000114, 19.593389],
                [85.360115, 19.59232],
                [85.358688000000114, 19.591237000000202],
                [85.356391, 19.590000000000142],
                [85.355828000000116, 19.589450000000109],
                [85.355552, 19.589450000000109],
                [85.355279000000152, 19.58917],
                [85.355003, 19.58917],
                [85.354912000000155, 19.589077000000199],
                [85.35472, 19.58888700000011],
                [85.354447, 19.58888700000011],
                [85.354164000000111, 19.588612],
                [85.353888, 19.588612],
                [85.353332000000179, 19.588056],
                [85.353059, 19.588056],
                [85.352776, 19.587777],
                [85.35250000000012, 19.587780000000176],
                [85.351937, 19.58722100000011],
                [85.351668000000174, 19.587224000000155],
                [85.351388, 19.586946],
                [85.351112000000143, 19.586946],
                [85.35083000000013, 19.586665],
                [85.350563, 19.586670000000137],
                [85.35028, 19.586389000000164],
                [85.349998000000184, 19.586389000000164],
                [85.349715, 19.586670000000137],
                [85.349442, 19.586670000000137],
                [85.348892, 19.586111],
                [85.348610000000107, 19.586111],
                [85.347495, 19.585001],
                [85.347495, 19.584721000000169],
                [85.347222, 19.584723000000164],
                [85.346946000000102, 19.584443],
                [85.34666300000012, 19.584443],
                [85.345558, 19.583333],
                [85.345275, 19.583333],
                [85.344719, 19.582777],
                [85.342269, 19.582050000000148],
                [85.340852, 19.581359000000187],
                [85.338607, 19.580281000000181],
                [85.338057, 19.579718000000124],
                [85.337501, 19.579721000000173],
                [85.336669000000128, 19.578889000000114],
                [85.336387, 19.578889000000114],
                [85.335831, 19.57833],
                [85.335555000000141, 19.578333],
                [85.335281, 19.57805900000016],
                [85.334999000000138, 19.577779],
                [85.334716000000157, 19.577779],
                [85.334443000000121, 19.577499],
                [85.332223000000155, 19.575281000000185],
                [85.331674000000177, 19.575281000000185],
                [85.331391, 19.575001],
                [85.331108, 19.575001],
                [85.330826, 19.574720000000124],
                [85.330276000000183, 19.574723000000173],
                [85.330001000000138, 19.574445],
                [85.329720000000151, 19.574445],
                [85.328888, 19.573610000000137],
                [85.328613, 19.573610000000137],
                [85.327500000000143, 19.572500000000101],
                [85.327218000000101, 19.572500000000101],
                [85.326669000000138, 19.57195100000018],
                [85.326393, 19.57195100000018],
                [85.325547000000185, 19.5711100000002],
                [85.324998, 19.571112000000195],
                [85.324722000000165, 19.570832000000106],
                [85.324166000000133, 19.570832000000106],
                [85.323608, 19.570278000000137],
                [85.322776, 19.57028100000019],
                [85.322496, 19.57],
                [85.322220000000101, 19.569722000000123],
                [85.322220000000101, 19.5694440000002],
                [85.320832000000152, 19.568056000000119],
                [85.320556, 19.568070000000201],
                [85.320267000000158, 19.567780000000194],
                [85.32, 19.567780000000194],
                [85.319444, 19.56722],
                [85.318885000000179, 19.567222],
                [85.318612, 19.566944000000145],
                [85.317734, 19.56694200000015],
                [85.316590000000176, 19.566536],
                [85.315551000000184, 19.56528000000014],
                [85.315551000000184, 19.565],
                [85.315277, 19.564719],
                [85.315277, 19.564444000000201],
                [85.315002, 19.564168000000102],
                [85.31388900000016, 19.5641700000001],
                [85.313331, 19.56361000000015],
                [85.313058000000154, 19.563612000000145],
                [85.312775, 19.563334],
                [85.312499000000102, 19.563334],
                [85.311943, 19.562778000000201],
                [85.311667, 19.562780000000195],
                [85.311387000000124, 19.562500000000107],
                [85.309447, 19.562500000000107],
                [85.308891000000173, 19.561941],
                [85.308609000000132, 19.561946000000145],
                [85.307777, 19.5611120000002],
                [85.307777, 19.56083400000011],
                [85.307166, 19.560391],
                [85.306665, 19.559446000000204],
                [85.306113, 19.559446000000204],
                [85.305833000000106, 19.559165],
                [85.305268000000112, 19.559170000000105],
                [85.304465, 19.55901],
                [85.303613, 19.558331000000177],
                [85.30194, 19.556667000000171],
                [85.301391000000123, 19.556672],
                [85.301110000000136, 19.556391],
                [85.300828, 19.556391],
                [85.300552000000138, 19.556111000000154],
                [85.300278, 19.556111000000154],
                [85.299987000000144, 19.55584],
                [85.299437000000111, 19.55584],
                [85.297532, 19.554721],
                [85.295287, 19.553611],
                [85.292443000000148, 19.551596000000128],
                [85.290451000000175, 19.550511],
                [85.289024, 19.549702000000131],
                [85.28778000000014, 19.548889000000141],
                [85.287217, 19.54833],
                [85.286941000000155, 19.548335000000176],
                [85.286668000000176, 19.548057],
                [85.286392, 19.548059],
                [85.286392, 19.54778100000015],
                [85.285277000000164, 19.54667100000017],
                [85.285011, 19.54667100000017],
                [85.284448000000154, 19.546110000000109],
                [85.284165, 19.546113000000158],
                [85.283607000000174, 19.545554],
                [85.283333, 19.545561000000131],
                [85.283057000000127, 19.545281],
                [85.28277700000011, 19.545281],
                [85.281669, 19.544171],
                [85.281113, 19.544171],
                [85.280951000000158, 19.544009000000184],
                [85.280555, 19.543612000000163],
                [85.280281000000144, 19.543612000000163],
                [85.279167, 19.542500000000185],
                [85.278877000000165, 19.542500000000185],
                [85.278611000000168, 19.542222],
                [85.278052000000102, 19.542222],
                [85.276664, 19.54083200000019],
                [85.276391000000132, 19.540841],
                [85.276108000000178, 19.540561000000132],
                [85.274568000000144, 19.539740000000105],
                [85.272225, 19.53777800000011],
                [85.271942000000109, 19.53777800000011],
                [85.27141600000013, 19.537251000000193],
                [85.270554, 19.536388],
                [85.270278000000118, 19.536390000000203],
                [85.269173000000166, 19.535280000000167],
                [85.269173000000166, 19.535000000000135],
                [85.26889, 19.535000000000135],
                [85.268608000000128, 19.53471],
                [85.268334, 19.534721000000101],
                [85.266944000000123, 19.533333000000194],
                [85.26667, 19.533333000000194],
                [85.265, 19.531665000000199],
                [85.264441000000119, 19.53167],
                [85.26416800000014, 19.531392000000206],
                [85.263336, 19.531392000000206],
                [85.263047, 19.531111],
                [85.262780000000177, 19.531111],
                [85.261109000000133, 19.529441],
                [85.260833, 19.529443],
                [85.257775000000123, 19.526389000000105],
                [85.256943, 19.526389000000105],
                [85.256852, 19.526296],
                [85.256667000000149, 19.526111],
                [85.256387, 19.526111],
                [85.256111000000118, 19.525833000000144],
                [85.255835, 19.525833000000144],
                [85.255555000000172, 19.525553],
                [85.255279, 19.525279000000122],
                [85.254997000000159, 19.525279000000122],
                [85.253326000000101, 19.523611000000127],
                [85.253053, 19.523611000000127],
                [85.252221000000176, 19.5227700000002],
                [85.25166200000011, 19.522777],
                [85.251389, 19.522498],
                [85.251106, 19.522501000000144],
                [85.250878, 19.522268],
                [85.250557000000157, 19.522223],
                [85.250001000000154, 19.521667],
                [85.249734, 19.521669000000195],
                [85.24823, 19.52016900000012],
                [85.247222, 19.519171000000139],
                [85.246949, 19.519171000000139],
                [85.246575000000149, 19.518797],
                [85.246391, 19.518613000000126],
                [85.246108, 19.518613000000126],
                [85.245835, 19.518334000000149],
                [85.245552, 19.518334000000149],
                [85.245003000000139, 19.517778000000131],
                [85.24472, 19.517781],
                [85.243606, 19.516671000000198],
                [85.243332000000109, 19.516671000000198],
                [85.243056000000166, 19.51639],
                [85.242783000000117, 19.51639],
                [85.241112, 19.514722],
                [85.239998000000114, 19.514722],
                [85.23972400000018, 19.514444000000136],
                [85.239442, 19.514444000000136],
                [85.239166000000154, 19.514166],
                [85.238892, 19.51417100000014],
                [85.23861, 19.513890000000167],
                [85.238327, 19.513890000000167],
                [85.237778, 19.51333000000016],
                [85.237778, 19.513056],
                [85.237222, 19.5125],
                [85.236946, 19.5125],
                [85.236390000000171, 19.511944],
                [85.236114, 19.511944],
                [85.235558, 19.511388],
                [85.235282000000126, 19.51139],
                [85.234726000000165, 19.510829],
                [85.234443, 19.510834],
                [85.23352, 19.509911],
                [85.233055000000135, 19.509446000000136],
                [85.23278, 19.509450000000125],
                [85.231941000000106, 19.508609000000202],
                [85.231667000000158, 19.508612],
                [85.231392000000184, 19.508334000000158],
                [85.231109, 19.508334000000158],
                [85.2302770000001, 19.507499000000163],
                [85.230004, 19.507499000000163],
                [85.22972100000014, 19.507221],
                [85.229448, 19.507224000000175],
                [85.229165000000123, 19.506946],
                [85.228889, 19.506946],
                [85.228333, 19.50639],
                [85.227768000000182, 19.50639],
                [85.227326, 19.505941],
                [85.227219, 19.505833000000163],
                [85.226945, 19.505833000000163],
                [85.225831000000127, 19.50472300000018],
                [85.225564, 19.50473],
                [85.224709, 19.503892000000175],
                [85.224709, 19.503611000000202],
                [85.224443, 19.503331000000113],
                [85.224167000000108, 19.503333000000108],
                [85.223335, 19.502501000000159],
                [85.222779, 19.502501000000159],
                [85.222220000000149, 19.501941],
                [85.2219470000001, 19.501943000000207],
                [85.220832, 19.500833],
                [85.220832, 19.500555000000126],
                [85.220559, 19.500281000000196],
                [85.220276, 19.500281000000196],
                [85.220001, 19.500001000000108],
                [85.219718, 19.500001000000108],
                [85.219438000000181, 19.499719000000194],
                [85.219169000000122, 19.499721000000189],
                [85.218888000000135, 19.499445],
                [85.218613, 19.499450000000135],
                [85.218063, 19.49888900000013],
                [85.217781, 19.49888900000013],
                [85.216110000000157, 19.497221000000135],
                [85.215837000000107, 19.49722300000013],
                [85.215278, 19.496667000000109],
                [85.214996, 19.496669000000104],
                [85.214157, 19.495830000000122],
                [85.213890000000148, 19.495833],
                [85.213608, 19.495557000000129],
                [85.213334000000131, 19.495559],
                [85.212769000000137, 19.495001000000112],
                [85.212502, 19.495001000000112],
                [85.211937, 19.49444],
                [85.211670000000126, 19.494445],
                [85.211534, 19.494306000000162],
                [85.211388, 19.494167],
                [85.21111200000017, 19.494171000000161],
                [85.210556000000153, 19.4936100000001],
                [85.210282, 19.4936100000001],
                [85.208336000000116, 19.491671000000107],
                [85.208046000000124, 19.491671000000107],
                [85.207780000000156, 19.491391000000185],
                [85.207497, 19.491391000000185],
                [85.206672000000125, 19.490552],
                [85.20639, 19.490554],
                [85.20527700000018, 19.49],
                [85.203598000000156, 19.488332],
                [85.203331, 19.488332],
                [85.20277500000013, 19.487778],
                [85.202499, 19.487780000000207],
                [85.202216, 19.487500000000122],
                [85.201943000000171, 19.487500000000122],
                [85.201394, 19.486939],
                [85.201111, 19.486944000000161],
                [85.200835, 19.486666],
                [85.200555000000108, 19.486666],
                [85.200279000000165, 19.486390000000139],
                [85.199997, 19.486390000000139],
                [85.198326, 19.484720000000149],
                [85.198059000000143, 19.484722000000144],
                [85.19777700000013, 19.484444],
                [85.197221, 19.484444],
                [85.196113, 19.483334],
                [85.1958300000001, 19.483334],
                [85.194725000000162, 19.482222],
                [85.194169, 19.482222],
                [85.193886, 19.481946000000157],
                [85.19361000000012, 19.48195],
                [85.192779000000115, 19.481109000000171],
                [85.192498, 19.481112],
                [85.191108, 19.479724000000139],
                [85.190834, 19.479724000000139],
                [85.189720000000108, 19.478611],
                [85.189446, 19.478611],
                [85.189164000000147, 19.478333000000131],
                [85.188888, 19.478333000000131],
                [85.188615000000183, 19.478055],
                [85.188332, 19.478060000000134],
                [85.187767000000164, 19.477501],
                [85.1875, 19.477501],
                [85.187233, 19.477221000000153],
                [85.186944000000125, 19.477223000000148],
                [85.186386000000127, 19.476667000000131],
                [85.186112, 19.476672],
                [85.185836, 19.476389],
                [85.185563000000101, 19.476392000000139],
                [85.18528000000012, 19.476111000000166],
                [85.184998, 19.476111000000166],
                [85.184448, 19.475562000000192],
                [85.184166000000161, 19.475562000000192],
                [85.183610000000144, 19.47500100000013],
                [85.183022000000136, 19.47435900000016],
                [85.181312, 19.473552000000151],
                [85.177223000000126, 19.470001000000192],
                [85.176941, 19.470001000000192],
                [85.176658000000131, 19.469721000000103],
                [85.176392000000121, 19.469723],
                [85.176109000000153, 19.469445000000174],
                [85.175553, 19.469445000000174],
                [85.175004, 19.468889000000157],
                [85.174721, 19.468891000000148],
                [85.174156, 19.46833],
                [85.173889000000116, 19.468335000000192],
                [85.173333000000156, 19.467776000000125],
                [85.173057, 19.467781000000169],
                [85.171669000000165, 19.466391],
                [85.171387, 19.466391],
                [85.169716, 19.46472],
                [85.16944, 19.464722],
                [85.169167, 19.464444000000121],
                [85.16889100000013, 19.464451000000164],
                [85.168611, 19.464171],
                [85.16832800000013, 19.464171],
                [85.16722, 19.463052],
                [85.166947, 19.463054],
                [85.166612, 19.462719],
                [85.166115000000147, 19.462222000000107],
                [85.16555900000013, 19.462222000000107],
                [85.164994000000135, 19.461718000000129],
                [85.152657, 19.474411000000199],
                [85.150054423481649, 19.478707679565385],
                [85.143547000000154, 19.489451],
                [85.143303, 19.483361000000169],
                [85.127500660386474, 19.510066089004678],
                [85.12535914548117, 19.522201340134295],
                [85.139635911516137, 19.532908914660535],
                [85.153198839249441, 19.547899518997436],
                [85.158909545663491, 19.559320931825365],
                [85.160337222266932, 19.583591434084887],
                [85.161725991710895, 19.593590574081414],
                [85.163906413775678, 19.609289612947798],
                [85.163153184138409, 19.61774520309887],
                [85.16192421485367, 19.631541341843725],
                [85.160262, 19.650201000000145],
                [85.161971, 19.657619000000178],
                [85.164016, 19.660261000000101],
                [85.166336000000157, 19.6617700000001],
                [85.168584826588727, 19.662889684035346],
                [85.175133, 19.666150000000126],
                [85.176772000000128, 19.666950000000206],
                [85.177909, 19.667449],
                [85.179496, 19.668149000000135],
                [85.184692261183542, 19.669454742734498],
                [85.188056000000117, 19.670300000000108],
                [85.192659554732572, 19.672409716353737],
                [85.195846, 19.67387],
                [85.198517, 19.674681],
                [85.199256, 19.67534],
                [85.199538000000175, 19.676228000000147],
                [85.199753, 19.678480000000146],
                [85.206590534510482, 19.693215705105153],
                [85.201943527186103, 19.69724311145313],
                [85.195882959984232, 19.702495603027952],
                [85.196090542126839, 19.704533357557349],
                [85.197159000000156, 19.715022],
                [85.204835026169334, 19.720904455919417],
                [85.21804477897966, 19.73102763514003],
                [85.220867300545464, 19.733190650003046],
                [85.226478, 19.739251000000191],
                [85.235828187612441, 19.744635979607999],
                [85.249420832615414, 19.752464284150388],
                [85.23912, 19.7565],
                [85.249046000000163, 19.761949],
                [85.250411000000128, 19.763330000000103],
                [85.264611936493893, 19.77823007728113],
                [85.268448, 19.780750000000122],
                [85.271210000000153, 19.78213100000016],
                [85.271760000000185, 19.782311000000156],
                [85.273437000000143, 19.78247900000019],
                [85.278105216614705, 19.782300615322292],
                [85.281471, 19.782172],
                [85.281731, 19.782172],
                [85.282050000000126, 19.782172],
                [85.283126, 19.782502000000129],
                [85.283996, 19.782760000000163],
                [85.288121907231002, 19.785446955106746],
                [85.308669411660489, 19.783159331125482],
                [85.327943045807828, 19.783159331125482],
                [85.348644356558438, 19.813854378100753],
                [85.374342535421519, 19.825989629230431],
                [85.392902331266995, 19.839552556963717],
                [85.411462127112415, 19.862395382619805],
                [85.44037961382746, 19.879025985761356],
                [85.44345800000012, 19.878550000000129],
                [85.455018, 19.88107],
                [85.456208, 19.880569000000204],
                [85.45884, 19.88058],
                [85.461486000000136, 19.880601000000176],
                [85.464440000000124, 19.882310000000182],
                [85.464723, 19.883199],
                [85.469527000000184, 19.883712],
                [85.47058000000014, 19.882730000000148],
                [85.472039, 19.881362],
                [85.472458, 19.87976],
                [85.472442000000157, 19.879069],
                [85.47290700000012, 19.878812000000149],
                [85.473121, 19.877911000000207],
                [85.477782, 19.876150000000159],
                [85.479232000000124, 19.876330000000106],
                [85.479751, 19.87664900000021],
                [85.481240000000156, 19.877292000000121],
                [85.482436000000163, 19.87803],
                [85.484383000000136, 19.87885],
                [85.488907, 19.87868200000019],
                [85.493729, 19.879969000000123],
                [85.497139000000104, 19.880890000000132],
                [85.501640000000165, 19.87911],
                [85.504539, 19.879931000000166],
                [85.506768000000108, 19.879550000000101],
                [85.508111, 19.879329],
                [85.512414, 19.880090000000159],
                [85.518608, 19.879160000000123],
                [85.522248000000133, 19.880181],
                [85.525102, 19.879609000000183],
                [85.529350000000164, 19.878531000000176],
                [85.534478, 19.874951],
                [85.535378000000136, 19.874019000000199],
                [85.536506, 19.872592000000104],
                [85.537003000000126, 19.871931000000124],
                [85.53765, 19.87055],
                [85.538583000000116, 19.870060000000191],
                [85.545596729325595, 19.873525496850387],
                [85.557556, 19.898959000000158],
                [85.560007296718865, 19.906643462398673],
                [85.560752, 19.908978000000101],
                [85.551110438707653, 19.912457637652604],
                [85.542075950702468, 19.915718182670439],
                [85.52999, 19.920080000000151],
                [85.530715000000129, 19.92901],
                [85.52726, 19.932360000000127],
                [85.522636000000134, 19.933402000000164],
                [85.516746, 19.92173],
                [85.504211, 19.918011000000202],
                [85.502823, 19.925340000000169],
                [85.51371000000016, 19.929121000000176],
                [85.513574000000105, 19.93418100000013],
                [85.503548000000109, 19.93819],
                [85.49813, 19.93538],
                [85.496291, 19.937812],
                [85.500993, 19.94252],
                [85.509262, 19.946931000000113],
                [85.513574000000105, 19.96138000000013],
                [85.51944, 19.9675820000001],
                [85.525459000000112, 19.96964],
                [85.5300060000001, 19.967372000000122],
                [85.528267, 19.959240000000189],
                [85.54152700000013, 19.94826200000011],
                [85.546890000000175, 19.954620000000201],
                [85.54872, 19.953640000000117],
                [85.549019766409273, 19.94682442326086],
                [85.562841226563407, 19.955640966080065],
                [85.5635, 19.961032000000156],
                [85.561340302785396, 19.961749720447806],
                [85.55821300000018, 19.96278900000021],
                [85.554170000000155, 19.96598],
                [85.555291000000153, 19.970529],
                [85.558457000000118, 19.972878],
                [85.563667, 19.968751],
                [85.563491, 19.976550000000138],
                [85.56108, 19.984969],
                [85.560829333564001, 19.988017073615762],
                [85.560417, 19.993031],
                [85.563208370493598, 19.998590924274648],
                [85.565873366820114, 19.998590924274648],
                [85.56663479434188, 19.999161994915934],
                [85.565111939298191, 20.002969132525376],
                [85.565873366820114, 20.006395556373654],
                [85.566444437461584, 20.009821980222107],
                [85.566803, 20.016241],
                [85.568935542649669, 20.015026936168223],
                [85.571038000000129, 20.01383],
                [85.573082000000156, 20.011209000000118],
                [85.575812, 20.00083],
                [85.58418400000015, 19.995171],
                [85.584815000000148, 19.992830000000136],
                [85.585038, 19.990020000000182],
                [85.588662, 19.987239],
                [85.590697, 19.992650000000189],
                [85.596787, 19.999690000000211],
                [85.599053000000126, 20.004909],
                [85.603125, 20.00916],
                [85.608552, 20.011740000000142],
                [85.611542000000142, 20.010441000000121],
                [85.608985000000175, 20.006179],
                [85.617897000000184, 20.002099000000211],
                [85.61775300000015, 20.005411000000148],
                [85.622611061530819, 20.012932423856679],
                [85.623261740941061, 20.013939828890212],
                [85.625206, 20.016950000000119],
                [85.617897000000184, 20.022260000000184],
                [85.61612800000016, 20.028521],
                [85.614143, 20.028419000000149],
                [85.611344000000116, 20.03444],
                [85.614487, 20.051201],
                [85.618081000000103, 20.058410000000205],
                [85.621985, 20.06104],
                [85.633454, 20.066241000000101],
                [85.636818, 20.072],
                [85.637338, 20.075631],
                [85.640344, 20.07533],
                [85.639428000000166, 20.080761000000162],
                [85.627289000000118, 20.089732],
                [85.627380000000173, 20.09251],
                [85.641189, 20.090739],
                [85.646409, 20.088841000000109],
                [85.644371, 20.083442000000101],
                [85.642457000000135, 20.067449],
                [85.643997000000169, 20.062480000000161],
                [85.647462000000175, 20.058],
                [85.652642000000114, 20.056760000000107],
                [85.658317000000153, 20.057530000000209],
                [85.663696000000101, 20.060320000000157],
                [85.669854000000143, 20.0615],
                [85.674203, 20.063962],
                [85.675422, 20.066722000000137],
                [85.675591, 20.06989],
                [85.671753, 20.071770000000182],
                [85.670150000000135, 20.074430000000174],
                [85.6716, 20.07933],
                [85.676849000000161, 20.084841],
                [85.686478000000179, 20.087551000000126],
                [85.681220000000152, 20.09053],
                [85.6782, 20.09845],
                [85.671379, 20.104619000000124],
                [85.672074000000165, 20.109280000000123],
                [85.671866000000165, 20.115470000000183],
                [85.677232000000103, 20.124270000000134],
                [85.677856000000162, 20.131989],
                [85.683456, 20.141601],
                [85.688217, 20.14439],
                [85.694024000000169, 20.143832],
                [85.701682000000147, 20.137131],
                [85.709304830201887, 20.135609962766289],
                [85.714211000000134, 20.134631000000176],
                [85.714286000000101, 20.132771000000101],
                [85.713028000000108, 20.130351],
                [85.71064386708791, 20.127313514639237],
                [85.712309489791991, 20.123506377029795],
                [85.718258142306567, 20.118985401118831],
                [85.722779118217531, 20.1192233472193],
                [85.726824201927485, 20.126837622438014],
                [85.729989106662956, 20.132422748441112],
                [85.730869285637468, 20.133976005455501],
                [85.733248746643298, 20.135403682058946],
                [85.737769722554432, 20.133262167153813],
                [85.739113817578342, 20.13218464833653],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Rayagada",
          Dist_Code: "396",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [83.927657958074903, 19.399966559231697],
              [83.927575740824324, 19.399783438991673],
              [83.922627391005889, 19.393784203574963],
              [83.926148064220897, 19.391931217672262],
              [83.928765471327253, 19.387410241761298],
              [83.930081800660602, 19.386906939369162],
              [83.936855638747133, 19.384316942453772],
              [83.94637055168964, 19.388017904015836],
              [83.950914339678533, 19.387892468862557],
              [83.953141, 19.387831],
              [83.953584332711074, 19.387676946619472],
              [83.956885, 19.38653],
              [83.959212, 19.380741000000167],
              [83.961724, 19.378129],
              [83.964840917999467, 19.377175228568085],
              [83.967848118347987, 19.381149284989586],
              [83.971714742482433, 19.384421043872802],
              [83.977960827622766, 19.381446717615514],
              [83.981232586505755, 19.379662121861141],
              [83.981530019131512, 19.37668779560385],
              [83.983408803460847, 19.373259786788193],
              [83.989356000000129, 19.375481000000146],
              [83.991982, 19.377491000000184],
              [84.003540033435442, 19.377580093480841],
              [84.007406657569874, 19.375200632475011],
              [84.009918, 19.366341],
              [84.012191000000186, 19.362471000000134],
              [84.012121162638195, 19.361928029582366],
              [84.011690940900138, 19.358583148411917],
              [84.008835587693099, 19.360010825015532],
              [84.007645857190184, 19.358583148411917],
              [84.010977102598403, 19.352634495897341],
              [84.013118617503523, 19.347399681684685],
              [84.015973970710576, 19.342164867471805],
              [84.017163701213505, 19.336692107158452],
              [84.015498078509367, 19.325984532632216],
              [84.012642725302356, 19.317180526910587],
              [84.011582, 19.307321000000112],
              [84.009239, 19.303100000000139],
              [84.007991663795934, 19.298504120211526],
              [84.007562000000163, 19.296921000000104],
              [84.008373918571507, 19.291026061801912],
              [84.008752, 19.288281000000207],
              [84.011115000000174, 19.281022000000174],
              [84.001102861366107, 19.275451511262698],
              [84.002530537969534, 19.269264912647596],
              [84.000706190386822, 19.260143174733965],
              [84.000626969165054, 19.259747068624446],
              [83.995392154952057, 19.259271176423109],
              [83.994390648437872, 19.254406716211175],
              [83.992250744482504, 19.254101015646082],
              [83.981840602581983, 19.248449795757036],
              [83.985112361465028, 19.244583171622761],
              [83.9868969572194, 19.23744478860527],
              [83.985112361465028, 19.232091001342152],
              [83.980650872079053, 19.230306405587775],
              [83.985167196977144, 19.222020384440494],
              [83.983869721807849, 19.219074426326809],
              [83.983613178829202, 19.218491937437644],
              [83.982820000000274, 19.21669100000025],
              [83.982920221692936, 19.215477472275378],
              [83.982986000000139, 19.214681000000208],
              [83.981532209681617, 19.210987158900533],
              [83.980782000000232, 19.209081000000307],
              [83.977595321623753, 19.20600096683955],
              [83.972917623810105, 19.202942604020727],
              [83.970240730178588, 19.199075979886054],
              [83.9672664039213, 19.193127327371482],
              [83.970835595430046, 19.191937596868566],
              [83.976189382693164, 19.189855568488664],
              [83.979461141576152, 19.185988944353991],
              [83.984517496213556, 19.180040291839411],
              [83.985122152298217, 19.178377487606607],
              [83.9868969572194, 19.173496774073381],
              [83.988384120348016, 19.164573795301518],
              [83.986599524593643, 19.161896901670158],
              [83.982086000000123, 19.15925000000021],
              [83.981276394570486, 19.158713052385504],
              [83.984220063587799, 19.154461086026739],
              [83.9868969572194, 19.149702164015078],
              [83.991752000000162, 19.141420000000206],
              [83.999389127499995, 19.139886887366227],
              [84.003850616885913, 19.138697156863309],
              [84.008312106271873, 19.136912561108939],
              [84.01901968079811, 19.136317695857478],
              [84.023778602809756, 19.134830532728639],
              [84.026455496441301, 19.128881880214063],
              [84.024144480850893, 19.124757736568078],
              [84.022291439681098, 19.123230660325415],
              [84.017235085043737, 19.123230660325415],
              [84.014000372929033, 19.122219812789407],
              [84.012476163032062, 19.121743497196569],
              [84.010495716075781, 19.117330720177957],
              [84.015343781441615, 19.116292818294934],
              [84.015153056663607, 19.112523085799179],
              [84.013665893534991, 19.109548759541891],
              [84.012178730406305, 19.102112943898472],
              [84.012773595657777, 19.098543752389723],
              [84.013368460909234, 19.093784830378066],
              [84.013368460909234, 19.088728475740876],
              [84.01574792191505, 19.082184957974839],
              [84.016640219792279, 19.076533738085796],
              [84.01693765241798, 19.073261979202979],
              [84.02620026256497, 19.068692623952522],
              [84.025844120137592, 19.064706106456523],
              [84.026455496441301, 19.057795482665082],
              [84.025563198564129, 19.05273912802749],
              [84.02236366817219, 19.052636832320839],
              [84.014558191412149, 19.052441695401964],
              [84.006230077891729, 19.052441695401964],
              [84.000281425377167, 19.05511858903332],
              [83.992548177108219, 19.061959539425285],
              [83.978878422521277, 19.061653960341452],
              [83.975410000000167, 19.062480000000157],
              [83.969877268326314, 19.06065432640883],
              [83.969352000000228, 19.060481000000316],
              [83.964019, 19.057160000000174],
              [83.963561420311052, 19.056680226194768],
              [83.957772, 19.05061],
              [83.95591, 19.04602],
              [83.95617, 19.042802],
              [83.960220000000149, 19.039502000000194],
              [83.957733, 19.036069],
              [83.958718, 19.034289000000168],
              [83.973343, 19.02193],
              [83.978318000000101, 19.016492],
              [83.980363, 19.011940000000205],
              [83.976440000000125, 19.00299],
              [83.972108, 18.999002000000129],
              [83.966683000000202, 18.995911000000369],
              [83.961020318780967, 18.994739766010575],
              [83.955071666266392, 18.990278276624444],
              [83.947040985371743, 18.990575709250372],
              [83.943769226488683, 18.994739766010575],
              [83.936035978219735, 19.001283283776612],
              [83.927707864699343, 19.007529368916718],
              [83.922354077436225, 19.007529368916718],
              [83.914025963915805, 19.009611397297018],
              [83.909564474529915, 19.012288290928378],
              [83.904805552518241, 19.012585723554306],
              [83.900344063132295, 19.008719099419633],
              [83.89558514112062, 19.000093553273697],
              [83.893344845635141, 18.993818934558757],
              [83.89139466974278, 18.988356882686102],
              [83.890533594258926, 18.988340113170576],
              [83.890540024840377, 18.987908669679992],
              [83.884282701342926, 18.9846270567358],
              [83.881605807711409, 18.9846270567358],
              [83.879681145735091, 18.987672248488416],
              [83.872682828939546, 18.988791113496003],
              [83.870303367933715, 18.988791113496003],
              [83.868612275510287, 18.98644237401896],
              [83.864949580670597, 18.981355297852584],
              [83.855274016737937, 18.978264808473337],
              [83.853052275641431, 18.984329624109872],
              [83.852457410389988, 18.988493680870075],
              [83.85186254513853, 18.993847468133193],
              [83.849483084132686, 18.997119227016409],
              [83.845319027372497, 19.000390985899227],
              [83.837883211729235, 19.003067879530981],
              [83.828461, 18.998161000000206],
              [83.82431700000015, 19.000312000000175],
              [83.820634, 19.00422100000014],
              [83.818367605683065, 19.007591006208596],
              [83.816459000000336, 19.010429000000212],
              [83.815765013604135, 19.012284179972877],
              [83.814476, 19.01573],
              [83.812304005916559, 19.021806134951699],
              [83.811411708039415, 19.024780461208987],
              [83.80665278602774, 19.026862489589288],
              [83.795350346250061, 19.022401000203157],
              [83.794036000000105, 19.019452],
              [83.790764008217124, 19.012802928898843],
              [83.788307000000188, 19.00781000000023],
              [83.787042000000127, 19.008369000000123],
              [83.785973000000169, 19.00879000000014],
              [83.784865000000124, 19.009091000000176],
              [83.783753000000146, 19.009331000000142],
              [83.78263900000016, 19.009572],
              [83.78228316770246, 19.009639703973274],
              [83.781994879736189, 19.009694556331674],
              [83.781488000000124, 19.009791],
              [83.780373, 19.009941000000193],
              [83.778878000000162, 19.010010000000189],
              [83.777741, 19.00988000000012],
              [83.77664900000012, 19.009520000000176],
              [83.775651, 19.008961000000109],
              [83.774741, 19.00825],
              [83.773925000000176, 19.00745900000015],
              [83.773201000000128, 19.00658900000013],
              [83.772599, 19.005661],
              [83.772050000000121, 19.004672000000138],
              [83.771569, 19.003669000000112],
              [83.771117, 19.002639000000155],
              [83.770659000000123, 19.001609000000197],
              [83.77021000000012, 19.000592],
              [83.769417, 18.999772],
              [83.768501000000114, 18.9990810000001],
              [83.76748, 18.998429000000151],
              [83.766404000000122, 18.99796],
              [83.765235, 18.997600000000144],
              [83.764054, 18.997310000000137],
              [83.762885000000139, 18.997051000000166],
              [83.761712, 18.996779],
              [83.760567, 18.996469000000157],
              [83.759469000000124, 18.996059000000166],
              [83.758452000000119, 18.995471000000176],
              [83.757789, 18.994559],
              [83.756957, 18.993910000000195],
              [83.755829, 18.993611000000154],
              [83.754692, 18.99337],
              [83.753548000000123, 18.993169000000133],
              [83.75242600000017, 18.993331],
              [83.751282, 18.993281000000191],
              [83.750619, 18.992419],
              [83.749238, 18.990671],
              [83.741081, 18.983891],
              [83.739563000000132, 18.978441000000142],
              [83.74172100000014, 18.967059],
              [83.745972000000137, 18.963221],
              [83.749001000000121, 18.958440000000106],
              [83.748367, 18.95137],
              [83.750366, 18.944371],
              [83.755202, 18.942030000000155],
              [83.76148100000016, 18.944601],
              [83.76525100000012, 18.936421],
              [83.769866, 18.932970000000175],
              [83.777153, 18.919072],
              [83.780068, 18.90772000000015],
              [83.777397, 18.904399000000176],
              [83.77127, 18.901300000000102],
              [83.770500000000112, 18.901591000000163],
              [83.767503000000119, 18.902362000000206],
              [83.762849000000173, 18.906539000000119],
              [83.75615, 18.916691],
              [83.745826000000179, 18.918172],
              [83.742150000000123, 18.92314],
              [83.741402, 18.930290000000124],
              [83.739921, 18.934062],
              [83.736495, 18.938971000000205],
              [83.730027000000163, 18.96016000000014],
              [83.7274630000001, 18.966079000000146],
              [83.726303, 18.975561],
              [83.716897000000174, 18.982539],
              [83.711402000000106, 18.984951000000187],
              [83.708801, 18.983802000000136],
              [83.70574300000014, 18.98524],
              [83.704849, 18.992009000000103],
              [83.704697, 18.992481],
              [83.704362000000103, 18.99530900000013],
              [83.705002, 18.999469],
              [83.709419000000167, 19.001951],
              [83.71478200000017, 19.002131],
              [83.719848000000113, 19.004289],
              [83.723251, 19.011899000000195],
              [83.721282000000116, 19.013419000000166],
              [83.716828000000163, 19.014449000000123],
              [83.699838, 19.015031000000132],
              [83.697021, 19.016480000000168],
              [83.694153, 19.021141000000167],
              [83.684387, 19.04393],
              [83.676376000000147, 19.052450000000189],
              [83.666733, 19.064461000000104],
              [83.662612000000181, 19.066491000000209],
              [83.659697, 19.069741000000189],
              [83.656853, 19.074940000000137],
              [83.658097000000154, 19.08211],
              [83.657487, 19.08777200000014],
              [83.650269000000122, 19.100099],
              [83.647919, 19.10225100000013],
              [83.647789, 19.105941],
              [83.645881000000131, 19.108731000000201],
              [83.644730000000138, 19.113291],
              [83.646271, 19.114499000000134],
              [83.649749, 19.11482],
              [83.650727000000174, 19.118401],
              [83.649437, 19.121879],
              [83.645562, 19.123100000000189],
              [83.633316, 19.124429000000188],
              [83.629836, 19.126991],
              [83.628441, 19.131501000000178],
              [83.630187000000134, 19.144791],
              [83.62851, 19.149741000000173],
              [83.623284, 19.153632],
              [83.621162000000169, 19.151920000000185],
              [83.620239000000183, 19.148629000000192],
              [83.62271800000012, 19.144688],
              [83.619133, 19.141881000000176],
              [83.61409, 19.133819000000127],
              [83.610603000000111, 19.130938000000121],
              [83.605217, 19.131032000000111],
              [83.600517000000124, 19.127700000000114],
              [83.5943, 19.120331],
              [83.59365, 19.11549],
              [83.5943, 19.110581000000135],
              [83.59678, 19.1052],
              [83.604401000000152, 19.09287],
              [83.604417, 19.088180000000133],
              [83.599861, 19.084802],
              [83.593208, 19.084891000000137],
              [83.587631000000144, 19.08307],
              [83.584449, 19.079731],
              [83.582200000000142, 19.075640000000131],
              [83.581787000000119, 19.062772000000162],
              [83.580780000000104, 19.055150000000136],
              [83.578765, 19.049790000000197],
              [83.567360000000107, 19.0522600000001],
              [83.561050000000122, 19.050389],
              [83.557663, 19.051381],
              [83.556427, 19.055839000000102],
              [83.557107, 19.05998900000014],
              [83.560386, 19.063961000000173],
              [83.5606760000001, 19.066222000000149],
              [83.554978, 19.078131000000205],
              [83.551491, 19.07785],
              [83.546433, 19.07383],
              [83.544854000000129, 19.069402000000192],
              [83.544868, 19.062081000000198],
              [83.551484000000173, 19.050380000000185],
              [83.552300000000145, 19.047189000000113],
              [83.54773, 19.044969],
              [83.542778000000141, 19.036840000000204],
              [83.535790000000176, 19.030349000000164],
              [83.534828000000161, 19.028619000000159],
              [83.533096000000157, 19.019382000000114],
              [83.533112, 19.01246],
              [83.531387000000137, 19.00542],
              [83.515296, 19.004909],
              [83.5046, 19.010099000000132],
              [83.495399, 19.011092000000186],
              [83.492928, 19.01803000000012],
              [83.49263, 19.023981000000102],
              [83.493553, 19.026800000000147],
              [83.499312000000131, 19.02708],
              [83.503930000000167, 19.026201000000121],
              [83.508178, 19.021971],
              [83.513671, 19.024781],
              [83.513229, 19.030321000000125],
              [83.510086, 19.036172000000189],
              [83.509796, 19.040081000000153],
              [83.510749, 19.048001000000166],
              [83.508477000000127, 19.049911000000119],
              [83.506179, 19.054309],
              [83.505386, 19.064771],
              [83.502877, 19.064661000000164],
              [83.500365, 19.062081000000198],
              [83.496331, 19.05551],
              [83.49363, 19.05309],
              [83.49249300000011, 19.05495000000013],
              [83.483373663753099, 19.063672909152778],
              [83.48294145906911, 19.064086325447075],
              [83.480439000000203, 19.06648000000018],
              [83.478180000000165, 19.07022],
              [83.47982069249062, 19.077277146100979],
              [83.480712990367834, 19.081143770235592],
              [83.478333529362018, 19.083225798615555],
              [83.470897713718756, 19.083820663867012],
              [83.465841359081395, 19.083523231241422],
              [83.464949061204194, 19.079061741855352],
              [83.467031089584324, 19.076979713475389],
              [83.472467094394844, 19.074580357165697],
              [83.472022000000251, 19.072741000000228],
              [83.470276, 19.070320000000148],
              [83.467468, 19.069880000000122],
              [83.463828000000134, 19.071401],
              [83.459396, 19.069671],
              [83.45826700000012, 19.067132000000125],
              [83.459138, 19.06349],
              [83.457367, 19.059802000000101],
              [83.456704000000101, 19.056110000000157],
              [83.463272000000174, 19.052600000000208],
              [83.462798000000177, 19.043951000000103],
              [83.465440000000157, 19.03619],
              [83.477355, 19.025519000000195],
              [83.477966, 19.021191000000211],
              [83.475112000000109, 19.01153],
              [83.476639, 19.00407],
              [83.474602, 19.000312000000175],
              [83.471840000000142, 18.998979000000187],
              [83.467507000000111, 18.998919],
              [83.45848200000016, 19.002099],
              [83.453278000000168, 19.002461000000146],
              [83.450172, 19.001889000000116],
              [83.448517, 18.999631000000132],
              [83.448228000000128, 18.99594100000018],
              [83.4490890000001, 18.992611000000178],
              [83.45022700000014, 18.982421],
              [83.457718000000156, 18.982501000000124],
              [83.460296000000113, 18.980780000000202],
              [83.458313, 18.972472],
              [83.458947, 18.970449000000198],
              [83.461472000000114, 18.9679210000001],
              [83.462242, 18.963591000000118],
              [83.462272, 18.959221],
              [83.455482, 18.945579000000173],
              [83.45120200000018, 18.944460000000159],
              [83.446847, 18.94564900000011],
              [83.44267400000011, 18.947741000000175],
              [83.440009, 18.950221],
              [83.436477000000167, 18.957879],
              [83.432923000000116, 18.9614],
              [83.414841, 18.977872000000101],
              [83.408783000000113, 18.979891],
              [83.411422000000172, 18.988720000000111],
              [83.410576000000148, 18.992611000000178],
              [83.408851, 18.996191],
              [83.406898000000112, 18.995081],
              [83.404639, 18.993210000000143],
              [83.402312, 18.995161000000106],
              [83.401421, 18.996381000000152],
              [83.396056, 18.99583100000012],
              [83.392959000000175, 18.999129000000149],
              [83.388756, 19.00002000000017],
              [83.38472, 18.997272000000176],
              [83.377196000000112, 18.994721000000137],
              [83.367478, 18.993620000000185],
              [83.362327, 18.994730000000171],
              [83.358008, 19.006140000000123],
              [83.354982000000149, 19.00939],
              [83.346337, 19.00988900000015],
              [83.340912, 19.009162],
              [83.341218000000126, 19.01591],
              [83.342797, 19.021271],
              [83.345778000000152, 19.026650000000128],
              [83.354569, 19.033911000000153],
              [83.35649, 19.0384810000001],
              [83.355827, 19.041781000000125],
              [83.352912000000103, 19.042891000000104],
              [83.345414, 19.043720000000175],
              [83.338768000000115, 19.04362],
              [83.336769000000103, 19.046989000000103],
              [83.336135, 19.04994],
              [83.335427, 19.053252000000153],
              [83.338212, 19.063811000000154],
              [83.338371, 19.067740000000182],
              [83.337692, 19.071211000000115],
              [83.333259, 19.07718],
              [83.333314, 19.0938],
              [83.329056000000136, 19.09398],
              [83.324334, 19.093020000000191],
              [83.320801000000117, 19.093371],
              [83.316223, 19.102730000000175],
              [83.311623000000139, 19.105800000000155],
              [83.302819000000156, 19.108591000000157],
              [83.294776000000113, 19.106930000000201],
              [83.291603000000109, 19.113941000000178],
              [83.284736, 19.10886],
              [83.282936562412303, 19.107923566602548],
              [83.281092484771463, 19.109306624832978],
              [83.282044269173895, 19.115398045007847],
              [83.280902127891167, 19.119014825736766],
              [83.277557, 19.1168990000001],
              [83.272336068270064, 19.102834490897177],
              [83.26548322057333, 19.087415583579283],
              [83.264531436170927, 19.079420594599636],
              [83.257868945354616, 19.066476326728033],
              [83.259201443517995, 19.064572757923425],
              [83.259962871039733, 19.061527047835906],
              [83.261676082964058, 19.060004192792231],
              [83.264150722410108, 19.057148839585178],
              [83.264150722410108, 19.051247776290662],
              [83.261045762739769, 19.047453855181114],
              [83.259162, 19.042011000000169],
              [83.253325721050814, 19.030012211212689],
              [83.239785041710363, 19.023455671742621],
              [83.235812314738084, 19.017855925447343],
              [83.231800603045471, 19.002650785106194],
              [83.22588898943637, 18.980244659876686],
              [83.224937205033967, 18.972440027777505],
              [83.221130067424696, 18.970536458972898],
              [83.206662944509262, 18.970726815853361],
              [83.195893900501375, 18.972924640397931],
              [83.192865151091354, 18.973542769526997],
              [83.191688203245889, 18.975726856580419],
              [83.189213563799825, 18.976107570341238],
              [83.189784634441068, 18.982198990516221],
              [83.193220923932799, 18.99234422615876],
              [83.193782128930977, 18.994001117105139],
              [83.194175576910808, 18.995618625466697],
              [83.19549534085516, 19.001044321682397],
              [83.192830344528588, 19.009991095064262],
              [83.192639987648107, 19.015130730836912],
              [83.189213563799825, 19.020270366609505],
              [83.185977496831839, 19.023125719816555],
              [83.183794093523019, 19.03054929106656],
              [83.183122143624786, 19.032833920720343],
              [83.183693214266256, 19.040257839058366],
              [83.185440520289305, 19.045110500867846],
              [83.183372, 19.04894],
              [83.183341878747896, 19.050515840805243],
              [83.183321376320905, 19.051588457601547],
              [83.183224015559844, 19.056682039351696],
              [83.184886717532592, 19.0641680773636],
              [83.185459586859494, 19.066747325854461],
              [83.1859661694359, 19.069028129322131],
              [83.184545373868829, 19.071234909111293],
              [83.179505362895995, 19.072428151857302],
              [83.177411437210921, 19.074141363781447],
              [83.177411437210921, 19.08004242707602],
              [83.181366000000111, 19.085461000000233],
              [83.179886076656985, 19.088989200457885],
              [83.176269295928009, 19.088418129816429],
              [83.173635989352405, 19.089416311064664],
              [83.175156200951818, 19.091291599371001],
              [83.177749000000148, 19.094490000000174],
              [83.185227, 19.103691],
              [83.188399000000103, 19.106059],
              [83.190872000000113, 19.11002],
              [83.197541000000157, 19.115051000000161],
              [83.197792000000149, 19.120060000000187],
              [83.199914, 19.122930000000164],
              [83.212128, 19.127841],
              [83.215829, 19.12800100000015],
              [83.216086000000161, 19.121022000000202],
              [83.217812000000137, 19.116960000000173],
              [83.221062000000103, 19.115231000000104],
              [83.226616000000135, 19.11552],
              [83.236321, 19.119],
              [83.237121000000144, 19.121320000000136],
              [83.234864, 19.129922000000132],
              [83.235940000000127, 19.13443],
              [83.244186000000113, 19.141969000000184],
              [83.248238000000157, 19.147332000000173],
              [83.250602000000171, 19.15089],
              [83.251381000000137, 19.153910000000163],
              [83.252113000000165, 19.156731000000146],
              [83.241927, 19.155309],
              [83.237068000000164, 19.157221],
              [83.22818, 19.162719000000205],
              [83.223877000000172, 19.163530000000147],
              [83.219512, 19.16043000000013],
              [83.216294000000161, 19.156050000000103],
              [83.214997000000139, 19.155362],
              [83.213012, 19.154320000000151],
              [83.19875400000015, 19.159140000000146],
              [83.194389000000143, 19.159669],
              [83.191627, 19.15684100000021],
              [83.197311000000113, 19.147309],
              [83.198127000000142, 19.144661000000152],
              [83.196807, 19.14217],
              [83.194356700568022, 19.141682151692741],
              [83.19304, 19.141420000000206],
              [83.190293000000153, 19.141691],
              [83.190153676787787, 19.141703835795958],
              [83.18813300000015, 19.14189],
              [83.187329502478278, 19.141757351708002],
              [83.185388194014237, 19.141436863785081],
              [83.184274600528042, 19.141253022180191],
              [83.184152232561459, 19.141232820622289],
              [83.18401400000019, 19.141210000000225],
              [83.183250027064432, 19.140902788717703],
              [83.179501637939467, 19.139395474287479],
              [83.17512715464531, 19.136578420574491],
              [83.171045178120693, 19.136710625852341],
              [83.168409927113757, 19.135251087415888],
              [83.164833000000144, 19.133270000000206],
              [83.163639224960804, 19.131668964672595],
              [83.160616012133318, 19.127614372827217],
              [83.159249, 19.125781000000128],
              [83.158086494995743, 19.123361274472298],
              [83.155616000000151, 19.118219],
              [83.153159, 19.115910000000152],
              [83.148795000000106, 19.116792000000142],
              [83.145363, 19.118811],
              [83.140029000000126, 19.127251000000111],
              [83.135147000000103, 19.129040000000138],
              [83.1297, 19.129391],
              [83.12818900000012, 19.122640000000153],
              [83.12814400000012, 19.114100000000175],
              [83.126480000000115, 19.105449],
              [83.125199000000165, 19.090780000000162],
              [83.122970000000109, 19.086231000000165],
              [83.119086, 19.08374],
              [83.113243000000168, 19.08387],
              [83.111381000000137, 19.085600000000166],
              [83.105475000000112, 19.095359],
              [83.10205, 19.102529],
              [83.096496000000101, 19.1045],
              [83.092553000000166, 19.101440000000192],
              [83.08461, 19.085461],
              [83.082627000000102, 19.083152000000148],
              [83.079033, 19.07934100000011],
              [83.068321000000182, 19.073570000000128],
              [83.065529, 19.062152],
              [83.062393000000142, 19.05735900000013],
              [83.065406, 19.050961],
              [83.063172000000108, 19.04195],
              [83.060989000000163, 19.03924],
              [83.05584, 19.036769],
              [83.04596, 19.043992000000109],
              [83.040306000000129, 19.046711000000183],
              [83.036591, 19.047012],
              [83.033081, 19.047292000000134],
              [83.023942000000119, 19.049790000000197],
              [83.020783, 19.051581],
              [83.015213000000173, 19.05688],
              [83.013574000000105, 19.059950000000121],
              [83.013496, 19.062311],
              [83.015687000000113, 19.06617000000011],
              [83.0224240000001, 19.0705],
              [83.022658000000135, 19.071690000000153],
              [83.022957000000176, 19.073151],
              [83.020783, 19.078689000000164],
              [83.017891, 19.08325],
              [83.012307, 19.085171],
              [83.006782000000129, 19.08707000000015],
              [83.002404000000112, 19.09099],
              [83.002319, 19.1030510000001],
              [83.001633, 19.107561000000199],
              [82.999619, 19.110620000000146],
              [82.998864000000125, 19.111762000000166],
              [82.992127000000139, 19.11774],
              [82.982331000000144, 19.122239000000146],
              [82.981010000000126, 19.1247],
              [82.978676000000107, 19.126859000000135],
              [82.976196, 19.12604100000015],
              [82.972946, 19.14565900000013],
              [82.973023, 19.1544],
              [82.974548000000112, 19.164239000000173],
              [82.971733, 19.16655],
              [82.969208, 19.164859000000146],
              [82.964837, 19.15752],
              [82.960602000000151, 19.154161000000155],
              [82.942704, 19.147729000000137],
              [82.939377, 19.152130000000167],
              [82.935769000000136, 19.153830000000138],
              [82.932480000000155, 19.154751],
              [82.926789, 19.154270000000107],
              [82.923926, 19.153240000000149],
              [82.915801, 19.156690000000136],
              [82.911026000000135, 19.155501000000182],
              [82.908410000000103, 19.15324900000018],
              [82.905983, 19.152711],
              [82.903412000000102, 19.153010000000105],
              [82.902297, 19.153151],
              [82.90219, 19.153119],
              [82.896798000000132, 19.151669000000194],
              [82.897117, 19.155141],
              [82.891806, 19.16056900000012],
              [82.891442, 19.167712000000101],
              [82.88903700000013, 19.166860000000153],
              [82.886726, 19.170691],
              [82.88158283088049, 19.173605439803165],
              [82.87917300000025, 19.174971000000308],
              [82.876557000000147, 19.178381],
              [82.871002, 19.177111000000131],
              [82.867363000000225, 19.184690000000327],
              [82.864892000000268, 19.187051000000277],
              [82.881348836514903, 19.193380829026008],
              [82.885325457213455, 19.196559474395649],
              [82.884323162772191, 19.202898673049329],
              [82.878077077631914, 19.21003705606682],
              [82.880456538637731, 19.213606247575566],
              [82.887428, 19.21060100000016],
              [82.891164113163981, 19.208847325563905],
              [82.902763985567375, 19.221339495844514],
              [82.909307503333409, 19.22996504199045],
              [82.904846013947491, 19.240375183891157],
              [82.89532816992417, 19.252272488920305],
              [82.89532816992417, 19.256436545680508],
              [82.896815333052785, 19.262385198195087],
              [82.893690244482997, 19.264729014622272],
              [82.892056411041139, 19.265954389703833],
              [82.891140942049148, 19.270074000168332],
              [82.890271815286766, 19.273985070598311],
              [82.892056411041139, 19.279933723112887],
              [82.901871687690218, 19.289748999762132],
              [82.906115558151484, 19.290961534179697],
              [82.910199801210609, 19.292128460767962],
              [82.911528093820536, 19.292322683136828],
              [82.913530813912573, 19.292615519999284],
              [82.918562382182515, 19.293351233727488],
              [82.924773999871292, 19.297184815405156],
              [82.925963730374221, 19.30581036155149],
              [82.925895063794243, 19.3132390599045],
              [82.936474119945188, 19.334300274907431],
              [82.936698224053075, 19.335355623809559],
              [82.939645631157731, 19.349235524907893],
              [82.942163449418487, 19.352915413134891],
              [82.943512255292234, 19.354886744796541],
              [82.943214822666476, 19.35994309943413],
              [82.939724934466412, 19.362673170250272],
              [82.939711971440005, 19.362982523198692],
              [82.939575991960439, 19.366227571956237],
              [82.939529, 19.367349000000157],
              [82.940099191839892, 19.368625446827703],
              [82.940403008057828, 19.369305578005022],
              [82.941947000000127, 19.372762],
              [82.944142732030272, 19.375106054498641],
              [82.947587425078936, 19.378783437770149],
              [82.949163475181066, 19.380465950609217],
              [82.947676312052451, 19.389091496755551],
              [82.939645631157731, 19.395932447147111],
              [82.934886709146085, 19.400691369158775],
              [82.930722652385882, 19.412886106813851],
              [82.929235489257266, 19.421214220334257],
              [82.923286836742676, 19.425973142345921],
              [82.919089719810799, 19.432264660130553],
              [82.920312510485402, 19.440249908380899],
              [82.928045758754351, 19.444711397766635],
              [82.931614950263096, 19.445306263018093],
              [82.931671000000208, 19.443269000000264],
              [82.935012, 19.43972900000011],
              [82.940667, 19.441111],
              [82.941890724569575, 19.441010858873362],
              [82.946777, 19.440611],
              [82.948837000000125, 19.438811000000211],
              [82.969686326356367, 19.444413965141102],
              [82.983665659765592, 19.453336943912969],
              [82.989307712888078, 19.459382000829518],
              [82.990529924353822, 19.460691513114451],
              [82.991993773286012, 19.462259922684833],
              [82.989614312280167, 19.48010588022856],
              [82.991993773286012, 19.485757100117205],
              [83.002294626976763, 19.496354552250121],
              [83.004336650595789, 19.497297235624838],
              [83.015388, 19.502399],
              [83.01931, 19.505920000000113],
              [83.023521631613264, 19.507469681795609],
              [83.024413929490478, 19.515202930064554],
              [83.018547000000169, 19.518613935581865],
              [83.018547000000169, 19.520361000000143],
              [83.019796160597679, 19.522702492273648],
              [83.021972, 19.526781],
              [83.027221499755782, 19.533290215136045],
              [83.028352000000311, 19.534692000000231],
              [83.028785683543092, 19.538342667619073],
              [83.027388255747766, 19.546730788391809],
              [83.039047591284245, 19.55072425175927],
              [83.039116000000135, 19.550792],
              [83.042419, 19.551879],
              [83.04452931974707, 19.55232456232795],
              [83.04467830008501, 19.552356017289405],
              [83.04516929580322, 19.552459683662839],
              [83.058243000000104, 19.55522000000013],
              [83.062821, 19.555851000000128],
              [83.073192880109985, 19.557140930292118],
              [83.07586977374153, 19.556546065040656],
              [83.078546667373104, 19.546433355765878],
              [83.081818426256092, 19.543459029508593],
              [83.09758235541976, 19.53929497274839],
              [83.104720738437237, 19.53661807911703],
              [83.105315603688709, 19.528884830848082],
              [83.105613036314409, 19.520259284701748],
              [83.110784431264719, 19.512812475973529],
              [83.111020550345444, 19.512472464497129],
              [83.113048851957657, 19.509551710175511],
              [83.115130880337716, 19.505685086041236],
              [83.120529022415084, 19.499582838475639],
              [83.127386647766727, 19.49266126441864],
              [83.140710086150406, 19.479213582351175],
              [83.143089547156222, 19.473562362462523],
              [83.143135265726684, 19.473195743042705],
              [83.143689653038535, 19.468750084470965],
              [83.139222923021791, 19.467911142573481],
              [83.138925490396034, 19.465829114193578],
              [83.141156235089028, 19.464490667377781],
              [83.142466890323519, 19.463704274236811],
              [83.142632000000205, 19.462199000000336],
              [83.144834775195122, 19.456836903888295],
              [83.143981845033451, 19.446495993521008],
              [83.148740767045098, 19.439357610503517],
              [83.160491000000249, 19.425350000000375],
              [83.164788, 19.422511000000149],
              [83.165287816793452, 19.422380893323744],
              [83.169517000000297, 19.421280000000248],
              [83.174039262386529, 19.418264898105345],
              [83.178781462243691, 19.414075837316769],
              [83.181755788500965, 19.414373269942299],
              [83.182945519003894, 19.418239894076972],
              [83.181458355875279, 19.444711397766635],
              [83.181458355875279, 19.449172887152766],
              [83.183540384255338, 19.45244464603558],
              [83.18706675942876, 19.455828194089801],
              [83.189026, 19.454751],
              [83.193489, 19.448910000000179],
              [83.194511044109703, 19.446225889840829],
              [83.195953, 19.442439000000146],
              [83.199164891118627, 19.432613458943301],
              [83.201088909173365, 19.429839766480196],
              [83.203089940507411, 19.427992660633429],
              [83.207510625637028, 19.42822962284276],
              [83.208458000000334, 19.427062000000259],
              [83.210184914161502, 19.428372972866722],
              [83.210509, 19.428619000000136],
              [83.211419, 19.432890000000206],
              [83.210503, 19.437170000000147],
              [83.207200000000157, 19.43688],
              [83.204857000000104, 19.438551000000185],
              [83.200096, 19.444509000000206],
              [83.19851, 19.448682000000129],
              [83.197648000000115, 19.456750000000163],
              [83.201958, 19.46939],
              [83.220886000000107, 19.496610000000199],
              [83.223815000000158, 19.49862],
              [83.227311, 19.499821000000107],
              [83.231888, 19.500049000000157],
              [83.237611000000157, 19.499169000000162],
              [83.24051, 19.501530000000113],
              [83.241622, 19.509902],
              [83.243607000000139, 19.512140000000155],
              [83.248756, 19.522581000000169],
              [83.247757000000135, 19.527959000000177],
              [83.243714000000111, 19.53466],
              [83.245057, 19.537322],
              [83.252678000000145, 19.54144900000011],
              [83.25611, 19.545310000000139],
              [83.257599000000184, 19.551731000000128],
              [83.256477000000103, 19.55669000000011],
              [83.24907, 19.56041],
              [83.248436000000183, 19.5652],
              [83.250412, 19.568822],
              [83.259499, 19.570720000000104],
              [83.262253000000129, 19.572790000000104],
              [83.262177, 19.579310000000131],
              [83.259278, 19.592131000000105],
              [83.259955, 19.594380000000168],
              [83.262961000000104, 19.595930000000177],
              [83.265288, 19.595930000000177],
              [83.276351, 19.589150000000185],
              [83.279282000000109, 19.586200000000186],
              [83.281388000000149, 19.587812000000149],
              [83.282067, 19.589542000000105],
              [83.283898000000178, 19.590000000000142],
              [83.29545500000016, 19.58489000000014],
              [83.325576000000169, 19.589551000000139],
              [83.33367800000012, 19.59242],
              [83.34768600000011, 19.598731],
              [83.355118, 19.5993600000001],
              [83.359047, 19.59616],
              [83.36023, 19.593040000000137],
              [83.363533000000118, 19.591180000000119],
              [83.36579800000014, 19.591529000000204],
              [83.368157, 19.596709000000143],
              [83.367813, 19.607171000000157],
              [83.365889, 19.613582000000175],
              [83.366708000000116, 19.617500000000174],
              [83.365402, 19.617390000000167],
              [83.36720200000012, 19.61943000000019],
              [83.367576, 19.623359],
              [83.371407, 19.634201000000186],
              [83.371407, 19.644991000000172],
              [83.378707000000119, 19.660512],
              [83.382647051508442, 19.663544597660003],
              [83.386162000000169, 19.66625],
              [83.392806000000164, 19.673329],
              [83.396127000000305, 19.675351000000202],
              [83.399423342443896, 19.675888315892959],
              [83.407593, 19.67722000000014],
              [83.414930393020512, 19.678290171966289],
              [83.425400021446237, 19.687808015989781],
              [83.42825537465329, 19.694946399007275],
              [83.434441973268392, 19.702560674225989],
              [83.443008032889267, 19.707795488438645],
              [83.44586338609632, 19.713506194852751],
              [83.446102645003037, 19.716377301732617],
              [83.446132183139625, 19.716731759372063],
              [83.446339278297543, 19.719216901266797],
              [83.450622308107981, 19.721120470071405],
              [83.455381230119642, 19.724451715479457],
              [83.456333014522031, 19.726355284284292],
              [83.459160528800211, 19.738286993472055],
              [83.459263762595384, 19.738722625444549],
              [83.460806401212992, 19.745232341597156],
              [83.462709970017599, 19.758176609468929],
              [83.462900326898051, 19.762745174600123],
              [83.462138899376143, 19.765790884687469],
              [83.463281040659055, 19.768075167253013],
              [83.462329256256652, 19.769788379177381],
              [83.462709970017599, 19.773595516786596],
              [83.463852111300497, 19.777593011276334],
              [83.464803895702715, 19.780258007602921],
              [83.459093189288851, 19.783494074570903],
              [83.452430698472526, 19.786159070897437],
              [83.451212828253432, 19.78709340424501],
              [83.452134000000328, 19.787799000000344],
              [83.45189700000013, 19.790399000000203],
              [83.452621055352822, 19.796247985562211],
              [83.44919463150454, 19.808811539672881],
              [83.44919463150454, 19.812047606640871],
              [83.453001769113811, 19.812809034162793],
              [83.455857122320865, 19.813760818565012],
              [83.454714981038109, 19.820994380022736],
              [83.45128855718967, 19.826514729556315],
              [83.441580356285883, 19.83584221669917],
              [83.434727508589091, 19.844408276320102],
              [83.431681798501572, 19.844598633200572],
              [83.429968586577431, 19.848215413929545],
              [83.427684304011819, 19.848786484570773],
              [83.425590378326703, 19.849547912092699],
              [83.423306095761163, 19.850880410256075],
              [83.421783240717318, 19.847644343288092],
              [83.42045074255411, 19.847263629527102],
              [83.419158607825111, 19.847947700854146],
              [83.417214675586123, 19.848976841451243],
              [83.414549679259522, 19.853926120343427],
              [83.417214675586123, 19.861921109323074],
              [83.42115443067182, 19.869359039844536],
              [83.42254466823924, 19.87258109462908],
              [83.420641099434562, 19.87505573407514],
              [83.418547173749502, 19.879624299206505],
              [83.416643604944838, 19.884954291859454],
              [83.413788251737842, 19.891045712034494],
              [83.409981114128399, 19.893901065241486],
              [83.406148229591665, 19.898088325745501],
              [83.406166000000312, 19.903039000000259],
              [83.401581000000178, 19.906861000000102],
              [83.402267, 19.912800000000171],
              [83.399880000000138, 19.914359],
              [83.401145, 19.917311000000208],
              [83.410392, 19.92617],
              [83.414253, 19.927941],
              [83.419258000000113, 19.921349000000188],
              [83.424971000000127, 19.92457],
              [83.435501, 19.927141000000116],
              [83.436928, 19.934630000000194],
              [83.436791, 19.94046],
              [83.439027000000166, 19.942641],
              [83.440078, 19.945472],
              [83.439248000000177, 19.950322000000192],
              [83.439781, 19.956719000000131],
              [83.441422, 19.962841],
              [83.444871, 19.966520000000166],
              [83.448722000000132, 19.965820000000171],
              [83.455726000000183, 19.961941000000191],
              [83.464287000000112, 19.959302000000143],
              [83.467101, 19.95774],
              [83.474023, 19.957492000000169],
              [83.477784, 19.955049000000141],
              [83.486312, 19.953351000000161],
              [83.488746, 19.95351],
              [83.498353, 19.950541000000211],
              [83.504014, 19.949770000000168],
              [83.522988000000154, 19.943412],
              [83.536567000000133, 19.935861],
              [83.542969000000127, 19.930411000000159],
              [83.546447000000143, 19.92630000000019],
              [83.550454, 19.923460000000201],
              [83.55516, 19.922459000000167],
              [83.555024000000159, 19.918471],
              [83.552086, 19.91074900000012],
              [83.549522000000181, 19.905571000000119],
              [83.544991, 19.899351],
              [83.537376, 19.895112000000207],
              [83.534308, 19.892459],
              [83.526589, 19.878121000000128],
              [83.521187000000154, 19.87075],
              [83.520577000000159, 19.868091],
              [83.522423000000103, 19.856540000000106],
              [83.521607000000103, 19.85135],
              [83.523856000000166, 19.849260000000125],
              [83.529534000000169, 19.851499],
              [83.531571000000142, 19.850972],
              [83.534867000000176, 19.840741000000143],
              [83.537827, 19.83646100000021],
              [83.541009000000116, 19.83472],
              [83.551484000000173, 19.831449000000131],
              [83.56014900000018, 19.826619000000161],
              [83.572609, 19.821899],
              [83.58158, 19.81627],
              [83.590683, 19.821831000000142],
              [83.595031000000105, 19.826490000000142],
              [83.597001, 19.824582000000188],
              [83.598457, 19.820819],
              [83.600807, 19.811630000000203],
              [83.609146, 19.81057],
              [83.61213, 19.80853],
              [83.614158000000131, 19.799119000000129],
              [83.611603000000102, 19.792141],
              [83.611512, 19.788102000000205],
              [83.614928, 19.77135],
              [83.613572000000119, 19.764709000000202],
              [83.611077000000122, 19.760331000000175],
              [83.605278, 19.755280000000194],
              [83.602708, 19.751310000000156],
              [83.60257800000015, 19.748240000000177],
              [83.603387, 19.745131000000182],
              [83.606072, 19.74194000000011],
              [83.611571000000126, 19.73949],
              [83.618156000000141, 19.73774],
              [83.620856000000103, 19.735880000000172],
              [83.625556000000103, 19.72432],
              [83.626969000000116, 19.7114820000001],
              [83.637421, 19.696912],
              [83.6381, 19.69148000000018],
              [83.635858, 19.68346],
              [83.630287, 19.671711000000126],
              [83.630050000000139, 19.665589],
              [83.633606, 19.659691000000173],
              [83.641831, 19.65111000000018],
              [83.647766000000146, 19.652482],
              [83.650542000000129, 19.655579000000156],
              [83.655823, 19.657230000000133],
              [83.662193000000102, 19.66563],
              [83.663964000000121, 19.66971900000015],
              [83.6677770000001, 19.6734],
              [83.682106, 19.680670000000127],
              [83.68727, 19.681450000000208],
              [83.693527000000103, 19.679399000000153],
              [83.702958, 19.670882000000116],
              [83.712510000000108, 19.665480000000109],
              [83.716605000000158, 19.661519000000105],
              [83.721528, 19.651741000000179],
              [83.72432000000012, 19.649259000000193],
              [83.727012, 19.647559],
              [83.733115, 19.647591000000201],
              [83.736869000000169, 19.65110100000015],
              [83.743401, 19.659440000000185],
              [83.753792, 19.667761000000151],
              [83.756385000000165, 19.672600000000156],
              [83.759102000000141, 19.685060000000131],
              [83.758728, 19.687312],
              [83.760292000000149, 19.701499000000123],
              [83.761712, 19.706119000000108],
              [83.765388000000115, 19.707371000000133],
              [83.773750000000106, 19.704959],
              [83.785278, 19.70474],
              [83.801391, 19.709962000000125],
              [83.806672, 19.71011],
              [83.813781, 19.705859],
              [83.823456000000178, 19.70258],
              [83.829826000000168, 19.70214000000021],
              [83.836189000000147, 19.702689000000188],
              [83.838311, 19.699439000000208],
              [83.841844000000137, 19.69094],
              [83.847649000000132, 19.681382],
              [83.851097000000138, 19.677571],
              [83.85682, 19.673199000000178],
              [83.866645000000162, 19.667071],
              [83.873421000000164, 19.66543],
              [83.89727, 19.665300000000112],
              [83.905265, 19.667050000000124],
              [83.908912, 19.670711000000207],
              [83.913224, 19.672140000000123],
              [83.91848000000013, 19.6694],
              [83.925376000000171, 19.66976],
              [83.929887000000164, 19.66396],
              [83.930778, 19.66159],
              [83.923013, 19.658460000000101],
              [83.919188000000105, 19.65583],
              [83.92080700000011, 19.652760000000111],
              [83.928139000000129, 19.649032000000201],
              [83.932533, 19.635961000000176],
              [83.93586, 19.627902],
              [83.919868, 19.62315000000012],
              [83.920433000000102, 19.613621],
              [83.923279, 19.601539000000113],
              [83.927810000000122, 19.587249],
              [83.927034252367406, 19.578007424922472],
              [83.926682000000241, 19.573811],
              [83.926859087483578, 19.569505588436066],
              [83.92353065711437, 19.567342108695808],
              [83.924720387617285, 19.56407034981299],
              [83.926504983371643, 19.559906293052787],
              [83.928801038372541, 19.558758265552164],
              [83.931263905383318, 19.557526832046957],
              [83.934833096892064, 19.556337101544042],
              [83.941079182032396, 19.556931966795499],
              [83.944945806166828, 19.551578179532381],
              [83.9455406714183, 19.544142363888962],
              [83.946328348278755, 19.539224328410224],
              [83.950597026055704, 19.540573172380217],
              [83.958330274324652, 19.538193711374387],
              [83.966360955219315, 19.533137356737193],
              [83.971714742482433, 19.526593838971159],
              [83.972904472985348, 19.522727214836486],
              [83.971714742482433, 19.518265725450753],
              [83.971119877230976, 19.511424775058796],
              [83.969335281476603, 19.505773555170144],
              [83.966360955219315, 19.499230037404114],
              [83.968145550973688, 19.494173682766526],
              [83.972309607733877, 19.487332732374959],
              [83.971267, 19.47801],
              [83.96894, 19.472549000000122],
              [83.96373, 19.464490000000179],
              [83.96254, 19.459699],
              [83.962166, 19.452611000000157],
              [83.957512, 19.446501000000179],
              [83.95523700000011, 19.44110100000011],
              [83.945816, 19.427579],
              [83.942828959743196, 19.422500072588598],
              [83.94065560039023, 19.41880466394252],
              [83.939489538007791, 19.416821983533843],
              [83.94328018346269, 19.414774043328347],
              [83.942328399060472, 19.413584312825428],
              [83.939040661566509, 19.412775443638505],
              [83.935767454370577, 19.408747776964386],
              [83.935767454370577, 19.407795992561997],
              [83.94076432248275, 19.405416531556167],
              [83.939098699778626, 19.403988854952726],
              [83.934339777766965, 19.403988854952726],
              [83.932198262861831, 19.401847340047421],
              [83.928443805118533, 19.401716854919638],
              [83.927657958074903, 19.399966559231697],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Sambalpur",
          Dist_Code: "372",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [84.486585712111818, 21.373977083895166],
              [84.483843436467325, 21.363503556244719],
              [84.486222897472871, 21.35493749662373],
              [84.493361280490419, 21.347323221404846],
              [84.500499663507952, 21.34684732920368],
              [84.510969291933449, 21.352082143416734],
              [84.520011243755931, 21.356365173227228],
              [84.529529087779025, 21.358268742031893],
              [84.543791723788999, 21.35520860209089],
              [84.548524, 21.350181000000472],
              [84.549466899907927, 21.347296079669146],
              [84.550590002564988, 21.343859806462884],
              [84.551459000000349, 21.341201000000179],
              [84.552025972759722, 21.339922143950609],
              [84.552955167512181, 21.337826264896417],
              [84.555022859566506, 21.333162406804828],
              [84.55902200000024, 21.324142000000617],
              [84.56363, 21.318929000000249],
              [84.563874, 21.31472],
              [84.562759000000113, 21.307251000000402],
              [84.565057000000124, 21.29671],
              [84.566987, 21.25976100000025],
              [84.563393000000332, 21.256260000000335],
              [84.561440000000161, 21.252652000000349],
              [84.564407000000102, 21.249160000000298],
              [84.569893000000135, 21.2497],
              [84.581122000000306, 21.255770000000435],
              [84.595260000000152, 21.256670000000664],
              [84.599747000000121, 21.259781000000199],
              [84.602438856013379, 21.263897921254735],
              [84.604271, 21.266700000000125],
              [84.609322000000276, 21.269939000000242],
              [84.622821963442206, 21.27129757599436],
              [84.62781883155445, 21.279149797313714],
              [84.639954082684298, 21.284503584576438],
              [84.644594031645653, 21.293069644197654],
              [84.659584635982284, 21.299137269762692],
              [84.654587767869984, 21.305561814478544],
              [84.670435576602515, 21.315265923057716],
              [84.672432462431274, 21.315074423506754],
              [84.685402000000153, 21.318430000000255],
              [84.694291000000177, 21.317660000000153],
              [84.702438000000356, 21.31572],
              [84.703512935318983, 21.315383097195305],
              [84.710823000000104, 21.313092000000321],
              [84.71708, 21.306061],
              [84.729186000000297, 21.297991000000358],
              [84.734773, 21.28821100000027],
              [84.73969300000013, 21.284282],
              [84.756112, 21.274001000000222],
              [84.759873000000283, 21.270231000000418],
              [84.754387, 21.26201900000023],
              [84.751939, 21.255640000000305],
              [84.754647000000134, 21.252189000000268],
              [84.765960000000334, 21.250111000000512],
              [84.762544000000204, 21.242341000000117],
              [84.75789, 21.238421000000468],
              [84.754913, 21.231],
              [84.754776000000192, 21.222280000000406],
              [84.743285000000171, 21.229731000000122],
              [84.737685000000212, 21.229959000000459],
              [84.732003, 21.226200000000514],
              [84.725221000000118, 21.223821000000267],
              [84.721948000000154, 21.221941000000236],
              [84.718101000000132, 21.21521],
              [84.715728000000269, 21.203710000000452],
              [84.720238000000208, 21.202841000000486],
              [84.720099000000104, 21.199101000000379],
              [84.723817, 21.195869000000126],
              [84.728813, 21.193862000000301],
              [84.734902000000119, 21.194520000000463],
              [84.737991, 21.184159000000133],
              [84.742157000000233, 21.178872000000407],
              [84.737792000000169, 21.17107],
              [84.738747000000131, 21.165990000000413],
              [84.727477000000235, 21.159820000000305],
              [84.723502, 21.154720000000676],
              [84.721048000000266, 21.147470000000105],
              [84.719033000000124, 21.144370000000432],
              [84.712195000000108, 21.145719],
              [84.704583000000156, 21.149031000000146],
              [84.695159000000132, 21.15051000000016],
              [84.685669000000175, 21.148650000000309],
              [84.679009, 21.144122000000603],
              [84.676506, 21.136181000000299],
              [84.674508000000273, 21.123621000000181],
              [84.67025, 21.118201000000223],
              [84.668053, 21.111152000000171],
              [84.665710000000189, 21.102359000000426],
              [84.66419200000017, 21.090491000000149],
              [84.664322000000126, 21.08148],
              [84.66674, 21.074212000000212],
              [84.677598, 21.066531000000619],
              [84.676666000000282, 21.059142000000289],
              [84.672242000000125, 21.059080000000215],
              [84.661950000000147, 21.064940000000199],
              [84.658729, 21.069781000000145],
              [84.654251, 21.071661000000173],
              [84.649407, 21.076892],
              [84.645232, 21.079419000000364],
              [84.630981000000176, 21.077890000000249],
              [84.626473000000246, 21.075180000000266],
              [84.624367000000163, 21.077591000000435],
              [84.593063000000171, 21.06156000000032],
              [84.582627000000159, 21.058909000000309],
              [84.573455, 21.059281],
              [84.565162, 21.060860000000499],
              [84.555863000000144, 21.066941000000266],
              [84.549119000000232, 21.066510000000328],
              [84.543396000000186, 21.069460000000383],
              [84.538108, 21.073851000000552],
              [84.528588, 21.083731000000167],
              [84.522332, 21.082692000000176],
              [84.515702, 21.083130000000658],
              [84.507461000000248, 21.084771000000497],
              [84.500359, 21.083419000000273],
              [84.495819000000253, 21.077990000000224],
              [84.490014000000244, 21.07585000000017],
              [84.478415, 21.077680000000324],
              [84.472588000000187, 21.073851000000552],
              [84.464631000000153, 21.066191000000341],
              [84.451606000000282, 21.051290000000332],
              [84.44462500000013, 21.036551000000365],
              [84.438050000000189, 21.035521],
              [84.435417000000129, 21.029661],
              [84.423591000000314, 21.036061000000469],
              [84.414741000000319, 21.032310000000503],
              [84.403892000000198, 21.025860000000414],
              [84.422073000000282, 21.018500000000127],
              [84.428147000000124, 21.014810000000121],
              [84.429168, 21.009299],
              [84.423591000000314, 21.003681000000366],
              [84.415176000000187, 21.000892000000473],
              [84.409706000000185, 20.996621000000225],
              [84.405097999999882, 20.987939000000321],
              [84.400619000000219, 20.974021000000217],
              [84.394867000000247, 20.968941],
              [84.385857000000186, 20.967161],
              [84.378327000000283, 20.963639000000509],
              [84.371512, 20.953632000000418],
              [84.3657690000001, 20.949879999999663],
              [84.361427000000305, 20.95036100000015],
              [84.358490000000231, 20.954099000000266],
              [84.353813000000102, 20.95374100000026],
              [84.346877000000219, 20.950719000000156],
              [84.338340000000173, 20.950370000000245],
              [84.333526000000219, 20.947929000000151],
              [84.325417000000158, 20.94722],
              [84.320123000000279, 20.943241000000395],
              [84.311751000000172, 20.940121],
              [84.306106000000199, 20.931661000000528],
              [84.301871, 20.932661],
              [84.297653000000182, 20.934922000000135],
              [84.293327000000176, 20.930870000000592],
              [84.287957, 20.927451000000243],
              [84.281434, 20.923811000000107],
              [84.276030000000191, 20.922170000000275],
              [84.268386000000106, 20.918891],
              [84.258889000000281, 20.920131000000307],
              [84.234833000000137, 20.921220000000172],
              [84.229103000000279, 20.923950000000552],
              [84.220971, 20.930601],
              [84.213539000000168, 20.938940000000226],
              [84.208183, 20.948900000000314],
              [84.205933000000229, 20.959070000000562],
              [84.187766000000224, 20.971840000000153],
              [84.16735, 20.96912100000031],
              [84.161903, 20.971491000000238],
              [84.154053000000232, 20.970901000000364],
              [84.15239600000011, 20.975272],
              [84.149422000000285, 20.978321000000271],
              [84.149003000000135, 20.980619000000384],
              [84.151704000000194, 20.987549999999821],
              [84.148773, 20.996780000000168],
              [84.14038100000019, 21.008490000000158],
              [84.141404000000122, 21.022899000000503],
              [84.141067000000106, 21.030942000000319],
              [84.128563000000128, 21.03150100000061],
              [84.107308000000145, 21.03414],
              [84.083642000000211, 21.042420000000444],
              [84.074548, 21.044929000000131],
              [84.063736, 21.046351000000406],
              [84.048217000000236, 21.04489000000012],
              [84.041336000000214, 21.039571000000247],
              [84.035051000000223, 21.045369000000161],
              [84.028427000000221, 21.050199000000241],
              [84.020446, 21.051190000000126],
              [84.013230000000291, 21.050730000000378],
              [84.010728, 21.05563],
              [83.993844000000166, 21.066061000000214],
              [83.992141000000103, 21.066629000000145],
              [83.988846, 21.07196],
              [83.986619000000161, 21.07387],
              [83.983964, 21.074800000000316],
              [83.984688000000105, 21.078681000000412],
              [83.986389000000116, 21.082250000000609],
              [83.985466, 21.086090000000237],
              [83.986359000000249, 21.093272],
              [83.987686, 21.097472000000145],
              [83.984711, 21.108620000000421],
              [83.981247000000252, 21.11050900000054],
              [83.978286000000111, 21.113850000000408],
              [83.979843000000116, 21.125401000000235],
              [83.979057000000168, 21.130420000000182],
              [83.967590000000172, 21.134068000000294],
              [83.960732000000107, 21.138652000000317],
              [83.954324, 21.141660000000225],
              [83.944847, 21.143680000000128],
              [83.944077, 21.14796],
              [83.935058000000112, 21.151340000000342],
              [83.927804000000179, 21.155059000000158],
              [83.900276, 21.172611000000181],
              [83.888495, 21.174010000000401],
              [83.905197000000243, 21.222312000000322],
              [83.907241, 21.235410000000225],
              [83.90641800000013, 21.241881000000145],
              [83.896522, 21.255150000000182],
              [83.891228000000112, 21.26729100000011],
              [83.886727000000107, 21.271491000000189],
              [83.884598, 21.276881000000223],
              [83.883926, 21.285490000000205],
              [83.884552000000141, 21.292642000000111],
              [83.877357, 21.288959000000425],
              [83.871322000000163, 21.28977],
              [83.869004000000118, 21.300190000000377],
              [83.864562000000177, 21.306699000000428],
              [83.870925000000156, 21.319419000000146],
              [83.871361000000178, 21.336442000000257],
              [83.875962, 21.345641000000111],
              [83.875313000000162, 21.359568000000305],
              [83.872979, 21.37911900000017],
              [83.873948, 21.38633],
              [83.865829000000232, 21.393170000000275],
              [83.856277, 21.39551],
              [83.844658, 21.400821000000398],
              [83.842536000000152, 21.406500000000502],
              [83.842689, 21.412330000000335],
              [83.848129000000242, 21.418470000000294],
              [83.860229, 21.41829],
              [83.864165000000156, 21.420850000000648],
              [83.876899, 21.423851000000688],
              [83.877350000000135, 21.429330000000615],
              [83.879821, 21.435078000000427],
              [83.870347000000194, 21.450770000000599],
              [83.865615, 21.471900000000229],
              [83.858598000000242, 21.483681000000157],
              [83.857353000000245, 21.490060000000309],
              [83.84520800000017, 21.512002000000162],
              [83.839797, 21.523769000000126],
              [83.826995, 21.526150000000367],
              [83.814027000000223, 21.531472000000115],
              [83.808251000000141, 21.536240000000131],
              [83.793136, 21.563020000000275],
              [83.799659, 21.571002000000355],
              [83.80365, 21.577301],
              [83.80754, 21.587721000000325],
              [83.816429, 21.590821000000453],
              [83.82911, 21.585451000000141],
              [83.839248000000268, 21.582229000000773],
              [83.853011000000194, 21.58366],
              [83.860672000000164, 21.581091000000466],
              [83.866531000000151, 21.576941000000257],
              [83.872047, 21.57411900000033],
              [83.878898, 21.57151],
              [83.887176000000281, 21.570222],
              [83.894202000000149, 21.57010100000047],
              [83.909181, 21.572661000000373],
              [83.924332000000149, 21.573552000000287],
              [83.934112000000127, 21.573169000000231],
              [83.957161, 21.567569000000272],
              [83.966720000000151, 21.573999000000406],
              [83.974328000000114, 21.591819000000207],
              [83.970581000000195, 21.625591000000661],
              [83.961548000000207, 21.687812000000342],
              [83.966186, 21.699832000000239],
              [83.966209, 21.705379000000217],
              [83.954194000000115, 21.71012200000018],
              [83.941902000000184, 21.717001000000433],
              [83.937187000000151, 21.724371000000239],
              [83.945679000000197, 21.732100000000393],
              [83.946397000000189, 21.739482000000176],
              [83.948708, 21.742281000000268],
              [83.955468, 21.744819999999887],
              [83.959686, 21.74858],
              [83.961877000000214, 21.752211000000667],
              [83.962966, 21.76252],
              [83.965478000000104, 21.762971000000558],
              [83.970382000000114, 21.756911000000397],
              [83.977311, 21.753838],
              [83.980392000000151, 21.74867200000039],
              [83.983948000000268, 21.74858],
              [83.988342, 21.752799],
              [83.991660000000351, 21.761690000000268],
              [83.993766000000136, 21.765332000000168],
              [83.998498, 21.768630000000478],
              [84.008011, 21.782891],
              [84.012307000000177, 21.781190000000144],
              [84.015954000000235, 21.778170000000724],
              [84.020722, 21.777822000000462],
              [84.022796000000284, 21.773049000000125],
              [84.023819000000216, 21.767990000000275],
              [84.026253000000153, 21.762900000000393],
              [84.028313, 21.758779999999881],
              [84.031723000000156, 21.755821000000417],
              [84.037163, 21.758189000000126],
              [84.042321, 21.762469],
              [84.056556, 21.770879000000374],
              [84.061919, 21.770979999999778],
              [84.067834000000275, 21.769770000000559],
              [84.076554, 21.77051],
              [84.083200000000119, 21.772621000000296],
              [84.094841000000244, 21.779991000000106],
              [84.108277000000129, 21.785671000000317],
              [84.114807, 21.782978999999838],
              [84.116635465916474, 21.782787184429246],
              [84.118547118154225, 21.7825866421806],
              [84.124511, 21.78196100000013],
              [84.128651075852858, 21.780303370292124],
              [84.132851584809188, 21.776876217273859],
              [84.131565342986889, 21.765904533144518],
              [84.135491453646551, 21.746630898997179],
              [84.135491453646551, 21.740206354281323],
              [84.167257258074329, 21.728071103151475],
              [84.178321751751568, 21.730926456358471],
              [84.185460134769102, 21.737707920225372],
              [84.195810790144535, 21.740206354281323],
              [84.197952305049782, 21.739849435130274],
              [84.201164577407695, 21.740563273432365],
              [84.199736900803913, 21.746273979846588],
              [84.20045073910596, 21.747701656450083],
              [84.209908833215692, 21.747685597909136],
              [84.21918873113853, 21.748042517059723],
              [84.22489943755231, 21.751254789417995],
              [84.2288255482122, 21.751254789417995],
              [84.23168090141921, 21.751254789417995],
              [84.244272809583649, 21.760149331190853],
              [84.243093099582197, 21.762163983116345],
              [84.241903369079225, 21.767398797329175],
              [84.243806937883946, 21.770016204435702],
              [84.248803805996459, 21.769064420033143],
              [84.254752458510822, 21.775013072547832],
              [84.257845757818387, 21.770254150536168],
              [84.264032356433617, 21.769778258335002],
              [84.270456901149402, 21.771443881039197],
              [84.281878313977217, 21.778344317955991],
              [84.280450637373946, 21.785006808772316],
              [84.286637235988891, 21.79404876059402],
              [84.292823834604107, 21.803328658517554],
              [84.302579624728054, 21.808087580529211],
              [84.303266399461208, 21.810570535332996],
              [84.305672924035704, 21.819271047256045],
              [84.308647000000391, 21.822960000000414],
              [84.312791, 21.82693],
              [84.319268000000449, 21.830930000000528],
              [84.319648253495401, 21.83165285513132],
              [84.321073787912184, 21.834362770703134],
              [84.323035000000161, 21.838090999999842],
              [84.32034400000019, 21.853179000000406],
              [84.323243, 21.862619000000219],
              [84.327361000000153, 21.871501000000304],
              [84.340621000000269, 21.893039000000492],
              [84.342359553219381, 21.896897474916834],
              [84.344619000000122, 21.901912000000262],
              [84.347832000000196, 21.910730000000282],
              [84.356770457560316, 21.928250357627345],
              [84.358382000000105, 21.929270000000766],
              [84.358291000000165, 21.938040000000452],
              [84.36323874475589, 21.943403319426348],
              [84.361956391488306, 21.956447609255516],
              [84.360171795733933, 21.967155183781863],
              [84.360171795733933, 21.970367456139453],
              [84.356602604225188, 21.9732228093469],
              [84.356959523376062, 21.976435081704487],
              [84.364811744695359, 21.9732228093469],
              [84.368959473284562, 21.969285755352981],
              [84.368782000000223, 21.971480000000152],
              [84.37068647667688, 21.973785542578064],
              [84.373139970263466, 21.976755720158728],
              [84.368380936204105, 21.980004273213346],
              [84.371236289410874, 21.982502707269298],
              [84.371236289410874, 21.987856494532245],
              [84.374448561769029, 21.991782605192153],
              [84.374805480919619, 22.000348664813142],
              [84.376233157523401, 22.007130128679588],
              [84.37908851073044, 22.011770077641124],
              [84.38323447412283, 22.013843059337429],
              [84.386226893747704, 22.015339269149983],
              [84.387654570351202, 22.018194622356983],
              [84.382432000000151, 22.020942000000101],
              [84.378792, 22.022368000000363],
              [84.375266203811776, 22.023097189804268],
              [84.369842000000162, 22.024219000000127],
              [84.362578000000141, 22.024360000000335],
              [84.350822, 22.03342900000052],
              [84.343438000000148, 22.029641000000307],
              [84.338898000000114, 22.031891000000311],
              [84.331108, 22.027540000000268],
              [84.315437, 22.034040000000456],
              [84.30764, 22.034072000000144],
              [84.292716000000127, 22.030651000000482],
              [84.289452, 22.028499000000689],
              [84.285132999999888, 22.016269000000413],
              [84.282929, 22.013822000000566],
              [84.267823, 22.010651],
              [84.262773, 22.011000000000418],
              [84.26081, 22.039610000000486],
              [84.266747000000336, 22.05483],
              [84.262948000000193, 22.059101],
              [84.259698000000157, 22.073499000000535],
              [84.263075999999884, 22.079009000000266],
              [84.264359000000283, 22.089639],
              [84.261148, 22.10137],
              [84.262818, 22.102801000000451],
              [84.265633000000193, 22.102940000000437],
              [84.27205600000012, 22.104951000000252],
              [84.272377000000105, 22.110612000000621],
              [84.271262000000135, 22.11822200000028],
              [84.292426000000134, 22.11357000000066],
              [84.296342, 22.114680000000131],
              [84.308852000000215, 22.120950000000214],
              [84.319154, 22.121520000000366],
              [84.333512000000198, 22.12824100000034],
              [84.34055300000027, 22.132501000000268],
              [84.359497, 22.14616],
              [84.377311, 22.1443200000001],
              [84.380333000000221, 22.14538000000038],
              [84.398956, 22.159499000000316],
              [84.402946000000199, 22.160671000000313],
              [84.405517, 22.163540000000459],
              [84.41436, 22.169379000000159],
              [84.435761, 22.17606],
              [84.471382, 22.18567100000018],
              [84.476127, 22.16256],
              [84.47873700000018, 22.153781000000201],
              [84.482048, 22.149350000000364],
              [84.484672000000145, 22.140510000000173],
              [84.489806, 22.132560000000236],
              [84.494340000000236, 22.109940000000275],
              [84.494629000000131, 22.10292000000026],
              [84.490212000000142, 22.095342000000297],
              [84.492897000000127, 22.091011000000204],
              [84.495162, 22.084222000000175],
              [84.506127, 22.08321],
              [84.507730000000308, 22.081270000000355],
              [84.50763600000019, 22.077631000000331],
              [84.503005, 22.065362],
              [84.506996000000228, 22.05003000000033],
              [84.523278000000332, 22.04142],
              [84.517831000000271, 22.027982000000744],
              [84.508949000000115, 22.022779000000121],
              [84.504227000000228, 22.016181],
              [84.501487000000211, 22.007709],
              [84.503823, 21.997031000000327],
              [84.502959, 21.988001000000164],
              [84.497239, 21.974721],
              [84.496872, 21.96699000000012],
              [84.501389000000117, 21.956950000000454],
              [84.504188000000198, 21.9575],
              [84.506203, 21.961440000000263],
              [84.5093, 21.962580000000113],
              [84.512092000000209, 21.970051],
              [84.517929, 21.968451],
              [84.522309, 21.970290000000201],
              [84.523431000000215, 21.962222000000107],
              [84.523346, 21.955241000000335],
              [84.515809000000246, 21.9529],
              [84.513901, 21.94185100000049],
              [84.515267, 21.932810000000465],
              [84.523538, 21.924240000000506],
              [84.515846000000224, 21.919532000000114],
              [84.506057, 21.917460000000339],
              [84.499358000000171, 21.914440000000464],
              [84.49349200000033, 21.91506],
              [84.490121000000201, 21.91201000000023],
              [84.489143, 21.904150000000293],
              [84.491126000000108, 21.9001410000003],
              [84.50853, 21.896601000000597],
              [84.515877000000202, 21.891081000000437],
              [84.52185100000024, 21.884971000000402],
              [84.524695000000108, 21.878610000000201],
              [84.520522000000227, 21.870010000000313],
              [84.52717395474113, 21.863668687135483],
              [84.528721319855293, 21.86219358294624],
              [84.527024651655069, 21.855831077194122],
              [84.520778566514565, 21.850179857305186],
              [84.516317077128789, 21.846015800544816],
              [84.515722211877332, 21.839769715404824],
              [84.515370810405997, 21.833620189654305],
              [84.51512734662586, 21.829359573503773],
              [84.51512734662586, 21.821923757860979],
              [84.516911942380233, 21.814487942217504],
              [84.521958, 21.809650000000598],
              [84.526840000000433, 21.807450000000465],
              [84.527525973329645, 21.806966908193541],
              [84.530295534552849, 21.805016464525117],
              [84.541335000000146, 21.79724200000032],
              [84.54854807016828, 21.793354449735713],
              [84.556185962167291, 21.789237937851563],
              [84.557060476361116, 21.78876661041317],
              [84.558648000000488, 21.787911000000573],
              [84.560383332885166, 21.785789930704137],
              [84.557897389421029, 21.778356764089491],
              [84.555993820616081, 21.773407485197364],
              [84.55942147809354, 21.771279973660281],
              [84.56151417014965, 21.769981061348965],
              [84.57274522609724, 21.766364280620106],
              [84.594255553589832, 21.762176429249845],
              [84.607070000000462, 21.760990000000444],
              [84.610012488967797, 21.760601424368808],
              [84.603339530096648, 21.752907879803381],
              [84.600484176889637, 21.740534682573294],
              [84.59858060808493, 21.730065054147641],
              [84.590966332866216, 21.726257916538312],
              [84.586207410854783, 21.717691856917323],
              [84.59049044066505, 21.706746336290276],
              [84.594773470475886, 21.695800815663457],
              [84.590876700759537, 21.691904045947691],
              [84.58811097965949, 21.689138324847132],
              [84.575737782429073, 21.684855295036638],
              [84.563840477400092, 21.681999941829638],
              [84.554351294956788, 21.684821050123666],
              [84.546232465956834, 21.687234756042468],
              [84.537666406335774, 21.682475834030804],
              [84.528148562312637, 21.679620480823811],
              [84.505617430564797, 21.680839320819356],
              [84.502201080361985, 21.683923953277137],
              [84.498692884453234, 21.68178507826428],
              [84.491395804193104, 21.677336198257986],
              [84.494072697824819, 21.672279843621023],
              [84.495137814544563, 21.668551935102183],
              [84.497641889333565, 21.65978767334013],
              [84.499479748195981, 21.647710315101218],
              [84.499723917713567, 21.646105772556663],
              [84.504482839725242, 21.632721304399176],
              [84.510134059614003, 21.625582921381689],
              [84.511627379139142, 21.625003934675526],
              [84.520951, 21.621389000000132],
              [84.530314720502275, 21.619836071193955],
              [84.535118400175435, 21.61903940361594],
              [84.5449336768244, 21.621716297247069],
              [84.546718272578772, 21.61903940361594],
              [84.550287464087589, 21.608331829089135],
              [84.554451520847792, 21.60000371556907],
              [84.562779634368027, 21.59167560204855],
              [84.57110774788849, 21.587214112662874],
              [84.577056400403052, 21.572045048750166],
              [84.574974372023107, 21.568773289867291],
              [84.561155282230786, 21.573414471057951],
              [84.548404104546734, 21.577696990884075],
              [84.536308130678364, 21.58364492115356],
              [84.529764612912274, 21.584537219031056],
              [84.526195421403457, 21.580075729645156],
              [84.521436499391811, 21.581562892773483],
              [84.508349463859901, 21.589593573668019],
              [84.503887974473784, 21.588106410539236],
              [84.503887974473784, 21.583347488528258],
              [84.500318782965039, 21.583942353779314],
              [84.497344456707694, 21.583347488528258],
              [84.500021350339438, 21.57650653813652],
              [84.501581821308861, 21.570459713129818],
              [84.502400811345282, 21.567286126738502],
              [84.502698243970869, 21.558363147966695],
              [84.497939321959194, 21.555686254335107],
              [84.495961529018686, 21.555303455701729],
              [84.48871891056163, 21.553901658581022],
              [84.483067690672868, 21.552117062826703],
              [84.478011336035351, 21.54854787131762],
              [84.471765250895132, 21.546763275563301],
              [84.47265754877246, 21.543194084054672],
              [84.476524172906778, 21.539327459920056],
              [84.480390797041167, 21.535460835785891],
              [84.478011336035351, 21.53129677902529],
              [84.474739577152405, 21.531891644277032],
              [84.469683222515116, 21.533973672657108],
              [84.461949974246096, 21.536650566288696],
              [84.448565506088386, 21.538137729417478],
              [84.44678091033397, 21.535758268411197],
              [84.44529374720517, 21.533676240031124],
              [84.439939959942052, 21.531891644277032],
              [84.433693874801833, 21.53129677902529],
              [84.431016981170373, 21.528322452768403],
              [84.429827250667444, 21.523860963382496],
              [84.430719548544502, 21.518804608744855],
              [84.428934952790115, 21.51315338885615],
              [84.422094002398453, 21.51077392785032],
              [84.412873591000945, 21.508097034218732],
              [84.401729781956845, 21.489438094164594],
              [84.393163722335814, 21.483727387750598],
              [84.390375699299327, 21.479127149740403],
              [84.383645878312436, 21.468022945112576],
              [84.379362848501884, 21.453746179077363],
              [84.379362848501884, 21.446092246174882],
              [84.379362848501884, 21.444664569571383],
              [84.379362848501884, 21.435186383231663],
              [84.36984500447879, 21.418054263989685],
              [84.358423591650691, 21.407584635564032],
              [84.350333424230811, 21.392356085126945],
              [84.350917622137601, 21.371686809206491],
              [84.362814927166866, 21.369783240401823],
              [84.379947046408958, 21.373114485809534],
              [84.400236957495778, 21.379272116773105],
              [84.408670472917763, 21.376588725502412],
              [84.413442232929043, 21.377384018837571],
              [84.419378047443772, 21.378373321256497],
              [84.426516430461319, 21.38301327021804],
              [84.429414594079944, 21.38692624668624],
              [84.432561465081946, 21.388336912997143],
              [84.43969984809921, 21.389288697399476],
              [84.447314123317909, 21.391668158405306],
              [84.454813702098846, 21.391293179466395],
              [84.456831967341344, 21.391192266204136],
              [84.464446242559774, 21.392144050606472],
              [84.465390304806519, 21.392079534694396],
              [84.468931058943596, 21.391837564438212],
              [84.475890000000135, 21.391362],
              [84.480102, 21.388482],
              [84.485458000808975, 21.382712745186605],
              [84.486835766959047, 21.381228674463951],
              [84.486585712111818, 21.373977083895166],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Subarnapur",
          Dist_Code: "392",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [83.834710000000115, 21.092661000000131],
              [83.837769000000122, 21.09309],
              [83.84472, 21.101990000000168],
              [83.852966, 21.119699000000136],
              [83.855500000000106, 21.13013],
              [83.866736, 21.153701],
              [83.867769833646079, 21.155129527722632],
              [83.869277674273548, 21.157213027467485],
              [83.880477, 21.172688],
              [83.888495, 21.174010000000177],
              [83.900276000000119, 21.172611],
              [83.927804000000137, 21.155059000000158],
              [83.935058000000112, 21.151340000000115],
              [83.944077, 21.14796],
              [83.944847, 21.143680000000128],
              [83.954324, 21.141660000000112],
              [83.960732, 21.138652000000143],
              [83.967590000000129, 21.134068],
              [83.979057000000168, 21.13042],
              [83.979843000000159, 21.125401000000121],
              [83.978286000000111, 21.11385],
              [83.981247000000138, 21.110509000000203],
              [83.984711, 21.108620000000197],
              [83.987686, 21.097472],
              [83.986359000000135, 21.093272],
              [83.985466, 21.08609000000018],
              [83.986389, 21.08225],
              [83.984688000000105, 21.078681000000181],
              [83.983964, 21.074800000000206],
              [83.986619000000161, 21.07387],
              [83.988846, 21.07196],
              [83.992141, 21.066629],
              [83.993844, 21.066061000000158],
              [84.010728000000128, 21.05563],
              [84.013230000000178, 21.050730000000154],
              [84.020446, 21.051190000000183],
              [84.028427000000121, 21.050199],
              [84.035051000000152, 21.045369000000104],
              [84.041336000000101, 21.039571000000191],
              [84.048217000000122, 21.04489000000012],
              [84.063736, 21.046351000000183],
              [84.074548, 21.044929000000131],
              [84.083642, 21.04242],
              [84.107308, 21.03414],
              [84.128563000000128, 21.031501],
              [84.141067000000177, 21.030942000000145],
              [84.141404000000165, 21.022899000000105],
              [84.140381, 21.008490000000158],
              [84.148773, 20.996780000000111],
              [84.151704, 20.98755],
              [84.149003, 20.980619000000154],
              [84.149422000000101, 20.978321000000104],
              [84.152396000000167, 20.975272],
              [84.154053000000118, 20.970901],
              [84.161903, 20.971491],
              [84.16735, 20.969121],
              [84.18776600000011, 20.971840000000153],
              [84.205933000000115, 20.959070000000107],
              [84.208183000000119, 20.948900000000148],
              [84.213539, 20.93894],
              [84.220971, 20.930601],
              [84.229103000000165, 20.92395],
              [84.234833000000137, 20.921220000000115],
              [84.258889000000167, 20.920131],
              [84.268386, 20.918891000000137],
              [84.276030000000148, 20.92217],
              [84.268539000000132, 20.913432],
              [84.264054000000144, 20.909380000000166],
              [84.266586000000174, 20.904489000000122],
              [84.260307, 20.900051],
              [84.259659, 20.894251000000164],
              [84.261970000000176, 20.89057],
              [84.260696, 20.884309000000197],
              [84.249442, 20.8899],
              [84.240692000000166, 20.89336900000017],
              [84.232178, 20.895630000000207],
              [84.223038, 20.897490000000111],
              [84.210961, 20.896749],
              [84.19934, 20.893091],
              [84.189004, 20.888501000000129],
              [84.175293000000167, 20.879382000000188],
              [84.153342000000109, 20.869901000000191],
              [84.14428, 20.865071],
              [84.134011, 20.857931000000114],
              [84.123039, 20.848871],
              [84.105927, 20.840650000000206],
              [84.089479000000125, 20.836742000000179],
              [84.073402, 20.834941000000178],
              [84.053612, 20.829931],
              [84.047996000000111, 20.823361],
              [84.039916, 20.8218],
              [84.031449, 20.822251],
              [84.020072000000184, 20.831422000000195],
              [84.007416, 20.833970000000132],
              [83.993607000000154, 20.835281],
              [83.984237, 20.837241],
              [83.963066, 20.835661],
              [83.9477, 20.83531000000016],
              [83.940200000000104, 20.836851000000134],
              [83.933501, 20.83616000000017],
              [83.927742000000165, 20.833991],
              [83.915902000000173, 20.827561000000109],
              [83.897767, 20.814199000000137],
              [83.891609000000102, 20.811240000000108],
              [83.883896, 20.80933900000019],
              [83.875397, 20.808902],
              [83.862602, 20.809540000000137],
              [83.844818, 20.818570000000133],
              [83.838081, 20.818992000000204],
              [83.82945200000016, 20.816852],
              [83.822318000000152, 20.813611000000144],
              [83.815422000000112, 20.809321000000121],
              [83.799370000000167, 20.803300000000199],
              [83.781036, 20.797771000000118],
              [83.774085000000113, 20.79411],
              [83.768731, 20.789249],
              [83.756232000000168, 20.770220000000162],
              [83.758979, 20.761220000000147],
              [83.759132000000122, 20.754891000000153],
              [83.758156, 20.74884],
              [83.754981, 20.743169000000133],
              [83.753609, 20.73718],
              [83.753356, 20.726901000000105],
              [83.754851000000116, 20.724519000000154],
              [83.75228, 20.710639000000125],
              [83.749573, 20.706391],
              [83.747597000000141, 20.705482000000128],
              [83.740372, 20.69895],
              [83.737060000000142, 20.692582000000179],
              [83.734145000000169, 20.676482000000185],
              [83.732238000000152, 20.669891000000174],
              [83.720963, 20.651379],
              [83.717521000000119, 20.643539],
              [83.711532, 20.6352],
              [83.711739000000122, 20.628451000000151],
              [83.72605900000012, 20.619891000000102],
              [83.727638, 20.617270000000129],
              [83.727707, 20.607301],
              [83.72432000000012, 20.601161],
              [83.717583, 20.5948],
              [83.711548, 20.590681000000181],
              [83.705581, 20.58445000000011],
              [83.701814000000113, 20.577472],
              [83.685258, 20.561251000000134],
              [83.68187800000014, 20.555510000000133],
              [83.676750000000183, 20.552691000000145],
              [83.67056200000016, 20.551510000000118],
              [83.665901000000176, 20.549441000000169],
              [83.645364000000185, 20.534911000000189],
              [83.64071, 20.532320000000194],
              [83.634796, 20.530610000000134],
              [83.622552, 20.528981000000154],
              [83.615724, 20.526070000000168],
              [83.604187, 20.523091],
              [83.599107, 20.524840000000207],
              [83.59099500000012, 20.530321000000182],
              [83.588272, 20.536921],
              [83.588340000000159, 20.544980000000173],
              [83.589821000000128, 20.55169],
              [83.593003000000166, 20.56149],
              [83.595191, 20.564519000000185],
              [83.595886000000149, 20.568041000000104],
              [83.59398800000011, 20.570730000000193],
              [83.59355900000017, 20.572831000000118],
              [83.594658000000138, 20.578841000000178],
              [83.594079000000164, 20.584359],
              [83.590972000000178, 20.594009000000192],
              [83.58862300000014, 20.59867000000019],
              [83.590797, 20.60135],
              [83.59670200000015, 20.605311],
              [83.599938, 20.613341000000101],
              [83.603608000000108, 20.614031000000178],
              [83.615279000000143, 20.625691],
              [83.616752000000162, 20.63458],
              [83.619247, 20.636141000000119],
              [83.622276000000156, 20.639530000000203],
              [83.621207000000169, 20.645032000000178],
              [83.622566000000148, 20.652811],
              [83.62539600000018, 20.657490000000106],
              [83.63021, 20.660899],
              [83.63292, 20.666100000000192],
              [83.633888000000113, 20.670472000000128],
              [83.633057, 20.675151000000195],
              [83.639511000000127, 20.680051],
              [83.643707, 20.682091000000121],
              [83.646018000000126, 20.684290000000139],
              [83.650886000000156, 20.695472],
              [83.654487, 20.698911000000173],
              [83.658998, 20.701081000000155],
              [83.661842, 20.706881],
              [83.663369, 20.717531000000175],
              [83.662973000000164, 20.721992000000167],
              [83.666909, 20.727742000000202],
              [83.670578, 20.737471000000134],
              [83.668420000000182, 20.741212],
              [83.663032, 20.741971000000145],
              [83.651549000000131, 20.741239000000171],
              [83.646264, 20.747160000000175],
              [83.64507200000017, 20.751550000000119],
              [83.652069, 20.756461],
              [83.651718000000102, 20.765031000000189],
              [83.648881, 20.768281000000112],
              [83.643067, 20.76980100000014],
              [83.633980000000108, 20.765920000000158],
              [83.630493, 20.767121],
              [83.631097000000111, 20.779221],
              [83.629052, 20.792239],
              [83.624207, 20.794532],
              [83.618233000000131, 20.79416000000014],
              [83.612708, 20.795852000000192],
              [83.610443, 20.79894],
              [83.597716, 20.796551],
              [83.592308, 20.796601000000116],
              [83.590332000000132, 20.798110000000118],
              [83.593552, 20.801260000000177],
              [83.594193, 20.804259000000165],
              [83.591057, 20.81104200000021],
              [83.590127, 20.817832000000173],
              [83.603868000000119, 20.813829],
              [83.610963, 20.813100000000126],
              [83.61695, 20.81142],
              [83.619003, 20.816081],
              [83.618415, 20.82218],
              [83.612442, 20.82781000000011],
              [83.599419, 20.831819000000159],
              [83.586410000000157, 20.83776],
              [83.582200000000142, 20.838421000000206],
              [83.568359, 20.842770000000137],
              [83.56662, 20.848329000000202],
              [83.568306, 20.859859],
              [83.572587, 20.869021000000199],
              [83.579331000000124, 20.875161],
              [83.587485000000115, 20.8802],
              [83.59665700000015, 20.888590000000189],
              [83.609841000000173, 20.895580000000162],
              [83.61371600000011, 20.899261],
              [83.614723000000126, 20.904320000000151],
              [83.613663, 20.908181],
              [83.61071, 20.91015],
              [83.608369, 20.913232000000161],
              [83.611152000000104, 20.919611],
              [83.610017000000127, 20.923652000000111],
              [83.607017, 20.925610000000116],
              [83.604125, 20.929042000000205],
              [83.610336, 20.931989000000151],
              [83.613007, 20.942769000000162],
              [83.619637000000111, 20.94926],
              [83.624177, 20.957009000000138],
              [83.629410000000149, 20.96242],
              [83.630547, 20.964492],
              [83.631019, 20.9683090000002],
              [83.634568, 20.975821],
              [83.633941, 20.978041],
              [83.628861000000185, 20.98056],
              [83.618698, 20.981202000000106],
              [83.590469, 20.977332000000157],
              [83.584618, 20.97596000000015],
              [83.572869000000125, 20.971170000000139],
              [83.568154, 20.970889000000167],
              [83.540458, 20.976409],
              [83.529167000000186, 20.980730000000104],
              [83.525803, 20.98086],
              [83.511857, 20.977501000000128],
              [83.506364000000119, 20.97785],
              [83.502221000000176, 20.978711],
              [83.49717, 20.982112],
              [83.488824000000122, 20.990159000000112],
              [83.482171000000136, 20.992881],
              [83.467949, 20.992071],
              [83.463708000000153, 20.993521],
              [83.460396, 20.996851000000103],
              [83.454078, 21.005110000000112],
              [83.443528, 21.015141000000135],
              [83.442979000000136, 21.019309],
              [83.452285, 21.045410000000114],
              [83.45218, 21.05101],
              [83.45517, 21.052601000000205],
              [83.458801, 21.05604],
              [83.466292, 21.0524],
              [83.473718000000119, 21.04458],
              [83.477202, 21.045590000000111],
              [83.485993000000164, 21.037839],
              [83.488769, 21.037050000000132],
              [83.491830000000135, 21.037611000000194],
              [83.493127000000172, 21.039571000000191],
              [83.492532000000125, 21.043521000000162],
              [83.490615000000147, 21.04735],
              [83.490531000000132, 21.057770000000168],
              [83.492568000000105, 21.059260000000162],
              [83.495720000000148, 21.059459000000114],
              [83.508269000000141, 21.056409000000194],
              [83.513046, 21.060288000000124],
              [83.517564, 21.060872000000124],
              [83.520821, 21.062392000000152],
              [83.524369, 21.065879000000159],
              [83.530801, 21.065749],
              [83.535888, 21.067721000000173],
              [83.544936000000149, 21.072951],
              [83.549713000000153, 21.07915],
              [83.556671000000136, 21.081120000000162],
              [83.561761000000146, 21.083802],
              [83.587709000000174, 21.10227],
              [83.592522000000116, 21.106550000000194],
              [83.600875000000116, 21.122340000000115],
              [83.606637, 21.125009000000144],
              [83.633713, 21.126819000000175],
              [83.648133000000129, 21.126012],
              [83.659707000000111, 21.122222000000129],
              [83.674231000000162, 21.12066000000021],
              [83.677406000000119, 21.11618],
              [83.681342000000186, 21.11303],
              [83.687432, 21.113791000000155],
              [83.698860000000124, 21.118089000000108],
              [83.711037000000132, 21.116950000000195],
              [83.715126, 21.11847],
              [83.718353, 21.12139],
              [83.720138000000119, 21.12453900000019],
              [83.728074, 21.128589],
              [83.733674, 21.12825],
              [83.741821, 21.136550000000106],
              [83.746644000000146, 21.137150000000183],
              [83.756791, 21.14006900000015],
              [83.76297, 21.150882],
              [83.775161000000125, 21.150421000000101],
              [83.778342, 21.147971],
              [83.78105900000017, 21.142171000000126],
              [83.779548, 21.130921000000107],
              [83.78495, 21.123940000000172],
              [83.789688, 21.115409],
              [83.792619000000101, 21.11181],
              [83.800874, 21.105670000000199],
              [83.80870000000013, 21.103982000000141],
              [83.815681, 21.099002000000208],
              [83.819978000000148, 21.097001000000198],
              [83.823411212500773, 21.09619019627581],
              [83.830856000000139, 21.094432],
              [83.834710000000115, 21.092661000000131],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          REMARKS_2: null,
          Country: "India",
          State_Name: "Orissa",
          State_Code: "21",
          Dist_Name: "Sundargarh",
          Dist_Code: "374",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [85.277749, 21.95128],
              [85.283122299349344, 21.950268665094935],
              [85.296459456382181, 21.945574431912856],
              [85.307404977008943, 21.949857461723351],
              [85.320729958641692, 21.947478000717521],
              [85.332151371469635, 21.944622647510464],
              [85.341193323291776, 21.943670863108249],
              [85.344222138427853, 21.943670863108249],
              [85.350711167315097, 21.943670863108249],
              [85.363560256746638, 21.939863725498807],
              [85.373078100769973, 21.946526216315302],
              [85.376409346178022, 21.946526216315302],
              [85.376409346178022, 21.939863725498807],
              [85.375457561775804, 21.933677126883701],
              [85.375457561775804, 21.928442312670878],
              [85.37260220856875, 21.922731606256995],
              [85.36976734687866, 21.916071705414989],
              [85.371078000000324, 21.905702],
              [85.370580474489572, 21.904683900672403],
              [85.370021539814715, 21.903540138182901],
              [85.369826000000131, 21.90314],
              [85.362198000000134, 21.893761],
              [85.364288, 21.88916],
              [85.360778, 21.877942],
              [85.354217, 21.874781000000151],
              [85.354697000000144, 21.871022000000202],
              [85.353043, 21.859661],
              [85.35408000000011, 21.847871000000104],
              [85.350609000000119, 21.842549000000126],
              [85.346442000000124, 21.839771000000152],
              [85.342597000000168, 21.829759],
              [85.339708, 21.825711000000123],
              [85.337547000000129, 21.823199],
              [85.333078000000157, 21.820581],
              [85.329071, 21.822650000000174],
              [85.317039, 21.816499000000189],
              [85.311248000000134, 21.814609000000125],
              [85.305657, 21.815751],
              [85.302947, 21.816802],
              [85.297601, 21.821980000000163],
              [85.291221, 21.822919],
              [85.289544, 21.824111],
              [85.288192000000137, 21.829410000000106],
              [85.285683000000162, 21.832719000000164],
              [85.279427, 21.831881000000116],
              [85.275855, 21.829679000000162],
              [85.272988000000154, 21.825640000000131],
              [85.270301, 21.821599],
              [85.268143, 21.814969],
              [85.258721, 21.80996],
              [85.251266, 21.807881000000119],
              [85.23783000000013, 21.799499],
              [85.235259, 21.799631000000197],
              [85.234229, 21.80268],
              [85.234008000000102, 21.80738],
              [85.230605, 21.810489],
              [85.224664, 21.81808],
              [85.223718000000119, 21.81651],
              [85.221138000000138, 21.80547000000012],
              [85.207787, 21.786560000000115],
              [85.20588600000012, 21.77931000000012],
              [85.205758000000159, 21.771271],
              [85.20440700000016, 21.768521],
              [85.201141000000106, 21.767659000000148],
              [85.198372000000106, 21.76391000000012],
              [85.201790000000116, 21.745971000000164],
              [85.203454000000164, 21.741889000000121],
              [85.208108000000138, 21.74115],
              [85.209662, 21.739621],
              [85.209289000000112, 21.736891000000124],
              [85.207367, 21.734251000000135],
              [85.202401, 21.731229000000209],
              [85.195541, 21.72364],
              [85.1836, 21.713172],
              [85.181153, 21.706291],
              [85.180688000000117, 21.70385],
              [85.187867000000139, 21.688110000000162],
              [85.186814000000169, 21.68249],
              [85.182358000000107, 21.67465900000013],
              [85.184097000000108, 21.664859000000202],
              [85.18794200000012, 21.658862000000109],
              [85.185196000000118, 21.654931000000143],
              [85.177451000000175, 21.64999],
              [85.179131, 21.646899],
              [85.178819, 21.644171000000139],
              [85.177695000000128, 21.64242100000012],
              [85.188621000000168, 21.638851000000155],
              [85.191001, 21.635811000000153],
              [85.189506, 21.633760000000105],
              [85.18615800000012, 21.632611],
              [85.184549, 21.630560000000166],
              [85.185570000000141, 21.624851000000145],
              [85.185219, 21.619641000000165],
              [85.181198, 21.619160000000189],
              [85.170486000000139, 21.616101],
              [85.164529000000172, 21.617970000000124],
              [85.162781000000138, 21.616489000000168],
              [85.162796000000171, 21.611741],
              [85.160866000000155, 21.60922],
              [85.148324000000159, 21.600282000000156],
              [85.148873000000137, 21.596412000000207],
              [85.144187, 21.589631000000164],
              [85.131180000000128, 21.59256],
              [85.124382000000182, 21.59331],
              [85.113877, 21.591689],
              [85.107277000000167, 21.588799],
              [85.101593, 21.58835],
              [85.096428000000103, 21.591161],
              [85.093178000000108, 21.594342000000207],
              [85.088927000000112, 21.596920000000178],
              [85.081787000000176, 21.599060000000119],
              [85.078147000000101, 21.597601],
              [85.070633, 21.597120000000182],
              [85.062157000000113, 21.593111000000128],
              [85.049637000000175, 21.585422],
              [85.045601, 21.584551],
              [85.03044, 21.60226],
              [85.033859000000106, 21.613781],
              [85.033898000000178, 21.617589],
              [85.030898, 21.618699],
              [85.02729000000015, 21.621411],
              [85.025032, 21.624611000000179],
              [85.023986, 21.627599000000142],
              [85.024537, 21.630861000000202],
              [85.026946000000109, 21.636632],
              [85.023858, 21.643221],
              [85.024407, 21.659019000000164],
              [85.021317000000167, 21.667361],
              [85.003257000000119, 21.672471],
              [84.993988, 21.677850000000202],
              [84.98739, 21.6733480000002],
              [84.981004, 21.677041000000198],
              [84.977088, 21.671739000000109],
              [84.97377, 21.669059],
              [84.967955000000103, 21.671489],
              [84.964156000000145, 21.676772000000138],
              [84.957597000000163, 21.6786],
              [84.953567000000106, 21.678670000000178],
              [84.950577000000152, 21.673861],
              [84.950821000000118, 21.665720000000185],
              [84.948692, 21.66056],
              [84.93618, 21.655710000000106],
              [84.919647, 21.664501],
              [84.910781, 21.666201],
              [84.902314000000146, 21.664840000000193],
              [84.895379, 21.65489900000011],
              [84.878381, 21.653062000000197],
              [84.8594140000001, 21.648241],
              [84.852882000000164, 21.64859000000018],
              [84.851884, 21.655161000000131],
              [84.83821800000014, 21.653809000000187],
              [84.826592, 21.65513100000015],
              [84.817443447248451, 21.657380396633751],
              [84.815078, 21.657962000000104],
              [84.811701699847035, 21.658228378619519],
              [84.807872049505292, 21.655994415920073],
              [84.80281569486786, 21.650938061282655],
              [84.794785013973225, 21.643204813013707],
              [84.792405552967381, 21.631307507984552],
              [84.788041282027194, 21.630885159184],
              [84.783185141569774, 21.630415210107568],
              [84.769388519855895, 21.628046809750511],
              [84.762358909116344, 21.626840069946237],
              [84.760693286412263, 21.635644075667805],
              [84.755458472199379, 21.644686027489961],
              [84.750461604087178, 21.652776194909841],
              [84.747606250880196, 21.656583332519112],
              [84.745060468469703, 21.656424221118407],
              [84.744812, 21.65716000000014],
              [84.74514, 21.663179],
              [84.742332, 21.664590000000139],
              [84.737961, 21.662470000000209],
              [84.738296, 21.668471],
              [84.742576000000142, 21.677471],
              [84.739404, 21.680140000000105],
              [84.733207000000149, 21.682679],
              [84.724532, 21.690900000000109],
              [84.719589000000127, 21.698870000000166],
              [84.71723200000018, 21.706061],
              [84.71408000000018, 21.711041000000186],
              [84.707291, 21.706462],
              [84.700043, 21.703501000000184],
              [84.691353000000134, 21.702779000000131],
              [84.685197000000102, 21.709689],
              [84.678437000000116, 21.72446],
              [84.671852000000101, 21.73241],
              [84.674378, 21.743152000000173],
              [84.671089, 21.750039000000125],
              [84.665077000000139, 21.755461],
              [84.657692, 21.759700000000116],
              [84.648133000000129, 21.762889000000197],
              [84.639382000000111, 21.763550000000176],
              [84.632866, 21.762319000000101],
              [84.627822, 21.756651],
              [84.614553028882227, 21.759846786633258],
              [84.613128000000273, 21.76019000000036],
              [84.611380333101096, 21.760420791271084],
              [84.610012488968025, 21.760601424368868],
              [84.607070000000348, 21.760990000000273],
              [84.594255553589889, 21.762176429249898],
              [84.572745226097169, 21.766364280620106],
              [84.561514170149721, 21.769981061349021],
              [84.559421478093583, 21.771279973659713],
              [84.555993820616123, 21.773407485197364],
              [84.557897389420916, 21.778356764089491],
              [84.560383332885166, 21.785789930703626],
              [84.558648000000488, 21.787911000000516],
              [84.557060476360817, 21.788766610413113],
              [84.541335000000103, 21.797242000000203],
              [84.527525973329531, 21.806966908193086],
              [84.52684000000032, 21.807450000000351],
              [84.521958, 21.809650000000143],
              [84.516911942380233, 21.814487942217447],
              [84.51512734662586, 21.821923757860869],
              [84.51512734662586, 21.829359573503886],
              [84.515370810405813, 21.833620189654248],
              [84.515722211877332, 21.839769715404593],
              [84.516317077128789, 21.846015800544698],
              [84.520778566514693, 21.850179857304902],
              [84.527024651655026, 21.855831077193947],
              [84.528721319855421, 21.862193582945899],
              [84.520522000000355, 21.870010000000313],
              [84.522727346674898, 21.874554927247285],
              [84.52469500000015, 21.87861],
              [84.521851000000183, 21.884971],
              [84.515877, 21.891081000000206],
              [84.50853, 21.896601],
              [84.49112600000015, 21.900141],
              [84.489143, 21.904150000000126],
              [84.490121000000144, 21.912010000000116],
              [84.49349200000016, 21.91506],
              [84.499358000000171, 21.914440000000123],
              [84.506057, 21.91746],
              [84.515846000000167, 21.919532],
              [84.523538, 21.92424],
              [84.515267, 21.932810000000185],
              [84.513901, 21.941851000000209],
              [84.515809000000147, 21.95290000000011],
              [84.523346000000103, 21.955241],
              [84.523431000000173, 21.962222000000164],
              [84.522309, 21.970290000000144],
              [84.517929, 21.968451],
              [84.512092, 21.970051],
              [84.5093, 21.962580000000113],
              [84.506203, 21.96144],
              [84.504188000000156, 21.9575],
              [84.501389, 21.95695],
              [84.496872, 21.96699000000012],
              [84.497239, 21.974721],
              [84.502959, 21.988001],
              [84.503823000000153, 21.997031],
              [84.501487000000139, 22.007709000000201],
              [84.504227000000171, 22.016181],
              [84.508949, 22.022779],
              [84.517831, 22.027982000000176],
              [84.523278000000147, 22.04142],
              [84.506996000000171, 22.05003],
              [84.503005, 22.065362],
              [84.507636000000147, 22.077631000000164],
              [84.507730000000137, 22.081270000000124],
              [84.506127, 22.08321],
              [84.49516200000015, 22.084222000000118],
              [84.492897000000127, 22.091011000000204],
              [84.490212, 22.095342],
              [84.494629, 22.102920000000204],
              [84.494340000000179, 22.109940000000162],
              [84.489806, 22.132560000000179],
              [84.484672, 22.140510000000173],
              [84.482048, 22.14935],
              [84.478737, 22.153781],
              [84.476127, 22.16256],
              [84.471382, 22.185671],
              [84.435761, 22.176060000000117],
              [84.41436, 22.169379000000159],
              [84.405517, 22.163540000000179],
              [84.402946000000128, 22.160671000000143],
              [84.398956, 22.159499000000146],
              [84.380333000000149, 22.14538],
              [84.377311, 22.1443200000001],
              [84.359497000000118, 22.146160000000119],
              [84.340553000000156, 22.132501000000101],
              [84.333512, 22.128241],
              [84.319154, 22.121520000000142],
              [84.308852000000158, 22.12095],
              [84.296342, 22.114680000000131],
              [84.292426, 22.113570000000145],
              [84.271262, 22.118222000000113],
              [84.272377, 22.110612000000167],
              [84.272056000000163, 22.104951000000195],
              [84.265633, 22.10294],
              [84.262818, 22.10280100000011],
              [84.261148, 22.101370000000198],
              [84.264359, 22.08963900000014],
              [84.263076, 22.079009],
              [84.259698000000114, 22.073499000000194],
              [84.262948, 22.059101000000105],
              [84.266747000000152, 22.05483],
              [84.26081, 22.039610000000206],
              [84.262773, 22.011000000000191],
              [84.262428, 22.004391000000108],
              [84.258408000000117, 22.004261000000149],
              [84.255418000000176, 22.003251],
              [84.251922000000121, 21.997241000000198],
              [84.2491, 21.994062],
              [84.247491000000124, 21.9893],
              [84.240013000000118, 21.979669],
              [84.235444, 21.97638],
              [84.226341, 21.971870000000131],
              [84.220107000000141, 21.972209000000131],
              [84.215538, 21.973761],
              [84.200493000000151, 21.974479000000141],
              [84.196411, 21.981011],
              [84.192306, 21.98378],
              [84.171448000000154, 21.99214],
              [84.164902, 21.996049000000195],
              [84.158042000000123, 21.99625],
              [84.152816, 21.99508],
              [84.149438, 21.995089000000117],
              [84.147339, 21.996161000000196],
              [84.142159, 21.99529],
              [84.140000000000143, 21.995769000000106],
              [84.138619000000105, 21.997300000000102],
              [84.125343000000129, 22.000110000000113],
              [84.12117, 22.000999],
              [84.117621, 22.003231],
              [84.114921, 22.008140000000136],
              [84.114403, 22.008140000000136],
              [84.109298, 22.006150000000158],
              [84.106217, 22.000491000000178],
              [84.106018, 21.99733],
              [84.10517, 21.995399],
              [84.103188, 21.990351000000143],
              [84.098410000000158, 21.994440000000104],
              [84.095001000000167, 21.99369],
              [84.091309, 21.994570000000177],
              [84.087952000000129, 21.996131],
              [84.086707000000132, 21.996072000000137],
              [84.08348, 21.987591],
              [84.067772, 21.988211000000202],
              [84.065949000000145, 21.98673],
              [84.066689, 21.979311000000106],
              [84.079147, 21.977649],
              [84.080779000000106, 21.968572000000101],
              [84.08252, 21.964082000000186],
              [84.081962000000132, 21.957951],
              [84.07489, 21.953452000000134],
              [84.072937000000181, 21.947291],
              [84.072953, 21.939841000000168],
              [84.07177, 21.93415],
              [84.060258, 21.93239],
              [84.056183, 21.935720000000114],
              [84.053017, 21.934619000000108],
              [84.049104000000156, 21.935809000000173],
              [84.044808000000131, 21.940741],
              [84.04234400000017, 21.945450000000104],
              [84.03071600000014, 21.946742],
              [84.022317000000129, 21.949860000000111],
              [84.013123, 21.940402],
              [84.009139000000104, 21.932411],
              [84.000207, 21.92061],
              [83.99373700000011, 21.915901000000183],
              [83.974022, 21.903302000000107],
              [83.971412000000129, 21.904141],
              [83.965706000000168, 21.910192000000162],
              [83.959907, 21.923009000000143],
              [83.954278, 21.93841],
              [83.950431, 21.93979100000012],
              [83.930108000000175, 21.941760000000155],
              [83.920768, 21.93926],
              [83.911599000000109, 21.941379],
              [83.901878000000167, 21.940892],
              [83.889740000000174, 21.943431000000199],
              [83.888137, 21.937961],
              [83.873681, 21.921061000000115],
              [83.847366000000179, 21.91982100000018],
              [83.858010000000121, 21.907771],
              [83.854240000000104, 21.905731000000166],
              [83.848480000000137, 21.9003],
              [83.841607, 21.899270000000108],
              [83.833472, 21.892009],
              [83.827882, 21.893039],
              [83.822899, 21.875129000000182],
              [83.81536000000014, 21.88248000000015],
              [83.80951600000013, 21.880271],
              [83.808037000000155, 21.867531000000149],
              [83.804252000000162, 21.85833],
              [83.807328000000126, 21.852302],
              [83.793587, 21.86599],
              [83.781510000000182, 21.85514100000017],
              [83.775512, 21.853400000000185],
              [83.761741000000129, 21.83632],
              [83.753798000000174, 21.833221000000144],
              [83.738777, 21.81718],
              [83.72693600000018, 21.801411000000193],
              [83.724671, 21.792021],
              [83.717927000000131, 21.786941],
              [83.714821000000185, 21.78344],
              [83.712806, 21.78358100000019],
              [83.707687, 21.785641000000105],
              [83.688661000000181, 21.78829],
              [83.684303, 21.79046],
              [83.68376100000016, 21.795781000000144],
              [83.679863, 21.8007290000001],
              [83.675622000000118, 21.80353000000019],
              [83.66893700000017, 21.805780000000194],
              [83.661767, 21.805780000000194],
              [83.650383000000133, 21.809351000000103],
              [83.644477000000151, 21.809971],
              [83.640717, 21.81249],
              [83.636102000000136, 21.813800000000125],
              [83.624282, 21.834971000000163],
              [83.622399, 21.840701000000131],
              [83.622513, 21.845542000000133],
              [83.612549, 21.84344],
              [83.605912000000146, 21.843030000000109],
              [83.606186, 21.836329],
              [83.605399000000119, 21.832519000000154],
              [83.60134, 21.82962],
              [83.593133, 21.828471],
              [83.585769, 21.822800000000139],
              [83.57769, 21.826570000000171],
              [83.5735320000001, 21.829661],
              [83.574898000000161, 21.832601000000178],
              [83.579483, 21.837120000000137],
              [83.584472, 21.843602000000196],
              [83.585938, 21.847629000000147],
              [83.584053, 21.852792000000129],
              [83.571518, 21.871870000000165],
              [83.573302, 21.876369000000118],
              [83.578109, 21.879790000000177],
              [83.576705000000103, 21.886160000000181],
              [83.579887000000141, 21.889251000000165],
              [83.583335000000133, 21.890960000000174],
              [83.583198000000138, 21.894069000000169],
              [83.581512, 21.897431000000147],
              [83.583253000000113, 21.898570000000117],
              [83.592636000000184, 21.900751],
              [83.599312, 21.906],
              [83.600479, 21.910841],
              [83.587768, 21.926121],
              [83.553360000000154, 21.932181000000181],
              [83.553971, 21.936281000000118],
              [83.557717000000181, 21.943911000000121],
              [83.549492, 21.950389000000197],
              [83.535172, 21.963501000000115],
              [83.534477, 21.976250000000157],
              [83.535446000000135, 21.979651000000153],
              [83.540109000000129, 21.9853300000002],
              [83.540834, 21.993232000000145],
              [83.543395, 21.994369],
              [83.546639000000184, 21.998280000000186],
              [83.544968000000139, 21.99939],
              [83.546737000000164, 22.003351],
              [83.548562000000146, 22.006702000000185],
              [83.538858000000147, 22.014371000000207],
              [83.533996, 22.022280000000187],
              [83.53267700000012, 22.028631],
              [83.532449000000142, 22.034049000000145],
              [83.534149000000113, 22.043439],
              [83.538368, 22.055379000000183],
              [83.543008000000142, 22.059391000000172],
              [83.550958000000136, 22.055642],
              [83.565628000000146, 22.05679],
              [83.58351, 22.054951000000123],
              [83.5859540000001, 22.055571],
              [83.590569, 22.059341],
              [83.600319000000113, 22.065510000000184],
              [83.589181, 22.07635200000021],
              [83.583068, 22.080491000000162],
              [83.573701, 22.088801],
              [83.564826, 22.093972],
              [83.55892100000014, 22.095490000000204],
              [83.557266000000183, 22.099980000000123],
              [83.559167000000102, 22.103861],
              [83.565758000000102, 22.11285],
              [83.567306000000116, 22.113709],
              [83.592536, 22.139981],
              [83.602334, 22.151839000000159],
              [83.605942000000113, 22.157610000000144],
              [83.611840000000186, 22.177142000000114],
              [83.619270000000128, 22.196360000000194],
              [83.626281, 22.205859000000139],
              [83.645751, 22.224589000000144],
              [83.654572, 22.22389],
              [83.657441, 22.22479],
              [83.66462, 22.23196],
              [83.672736, 22.237439],
              [83.679047000000182, 22.240632000000115],
              [83.693, 22.24550000000016],
              [83.700432, 22.245881],
              [83.718987000000112, 22.243251],
              [83.745650000000168, 22.24122],
              [83.7528, 22.242861000000115],
              [83.756850000000142, 22.250380000000174],
              [83.761803000000143, 22.254150000000205],
              [83.765839000000128, 22.256019],
              [83.771316000000112, 22.257340000000166],
              [83.774719000000161, 22.267339],
              [83.778557, 22.274509000000187],
              [83.788628, 22.280250000000187],
              [83.790786000000111, 22.28464200000013],
              [83.793647, 22.287692000000103],
              [83.797517000000127, 22.289490000000168],
              [83.797989000000129, 22.289962000000113],
              [83.804787, 22.28988],
              [83.815987000000163, 22.291202],
              [83.819442, 22.292451000000195],
              [83.820809000000153, 22.296040000000168],
              [83.820108000000104, 22.305082],
              [83.820657, 22.310251],
              [83.822487000000123, 22.315638],
              [83.825204, 22.319629],
              [83.829406, 22.323941000000158],
              [83.843033, 22.326350000000154],
              [83.84758, 22.33084],
              [83.85331, 22.338801],
              [83.861007000000114, 22.343781000000142],
              [83.864143, 22.343619],
              [83.867149, 22.341021],
              [83.871949, 22.338931000000166],
              [83.8969740000001, 22.33969],
              [83.905343000000116, 22.352611000000135],
              [83.915542, 22.359671],
              [83.919296, 22.359781000000108],
              [83.924027000000123, 22.35749],
              [83.929581, 22.356282000000128],
              [83.94323800000015, 22.358459000000146],
              [83.952316, 22.361210000000195],
              [83.956612, 22.361062],
              [83.966989, 22.357850000000209],
              [83.978202, 22.365109],
              [83.985368, 22.366372000000123],
              [83.992973, 22.369239000000157],
              [83.997399, 22.368539000000165],
              [84.00118900000011, 22.369670000000152],
              [84.004212, 22.367660000000111],
              [84.001679000000124, 22.375851000000118],
              [84.001663, 22.380370000000134],
              [84.008986, 22.391399000000145],
              [84.009948, 22.396090000000125],
              [84.012489000000173, 22.398900000000136],
              [84.014443000000185, 22.404092],
              [84.018752, 22.406781],
              [84.022164, 22.410161000000183],
              [84.025993000000184, 22.419091],
              [84.023988, 22.42218100000013],
              [84.032708, 22.42603100000019],
              [84.040008000000157, 22.4329],
              [84.041398, 22.43793],
              [84.039513, 22.448722000000199],
              [84.041557000000111, 22.464110000000112],
              [84.038727, 22.468881000000177],
              [84.034652, 22.469899],
              [84.023826, 22.470711],
              [84.021683, 22.472060000000106],
              [84.015489, 22.482421],
              [84.013023000000132, 22.485240000000143],
              [83.99707800000013, 22.49076000000013],
              [83.992980000000145, 22.493981000000186],
              [83.990448000000114, 22.494391],
              [83.980691000000135, 22.498731000000131],
              [83.976096, 22.502211],
              [83.973847, 22.509139000000115],
              [83.974457, 22.51398],
              [83.97657, 22.518390000000117],
              [83.980103, 22.522012000000128],
              [83.985849, 22.525481],
              [83.992980000000145, 22.527379000000106],
              [83.994293, 22.528811],
              [84.002502, 22.520861],
              [84.009636, 22.520291000000153],
              [84.015541, 22.521681],
              [84.019149000000183, 22.521071],
              [84.024726000000129, 22.516212],
              [84.033065000000164, 22.512070000000161],
              [84.050658, 22.512360000000164],
              [84.057587000000154, 22.510151000000175],
              [84.060479, 22.505021],
              [84.066689, 22.502240000000192],
              [84.069001000000114, 22.499549000000108],
              [84.067093000000156, 22.49812200000019],
              [84.071640000000158, 22.494191000000168],
              [84.079209, 22.488851000000121],
              [84.087753000000177, 22.48493],
              [84.099876000000151, 22.48034],
              [84.10291200000016, 22.481291],
              [84.103477000000154, 22.479331],
              [84.102119, 22.477311],
              [84.106116, 22.47384900000014],
              [84.117836, 22.47142],
              [84.12558, 22.473592],
              [84.129142, 22.473489],
              [84.130692, 22.470011],
              [84.134927000000161, 22.470950000000123],
              [84.137436000000122, 22.467101000000124],
              [84.137520000000137, 22.457189000000138],
              [84.135223000000138, 22.449050000000167],
              [84.133103, 22.44531000000017],
              [84.135879, 22.420682],
              [84.142295000000146, 22.415399000000146],
              [84.1524900000001, 22.400931000000124],
              [84.175163, 22.388940000000101],
              [84.183440000000118, 22.38368],
              [84.194107, 22.37181],
              [84.226129000000114, 22.374121000000169],
              [84.240462000000122, 22.374481000000113],
              [84.246559000000147, 22.373702000000147],
              [84.251411000000118, 22.370411000000153],
              [84.260888000000165, 22.3537],
              [84.266166, 22.3478290000001],
              [84.27324800000018, 22.345092000000133],
              [84.285019000000133, 22.342111],
              [84.289222, 22.33732],
              [84.314614000000148, 22.33892000000014],
              [84.318748, 22.340499],
              [84.323967, 22.33892000000014],
              [84.333991, 22.342911000000125],
              [84.338388000000108, 22.342099],
              [84.344963000000163, 22.344050000000205],
              [84.353286000000111, 22.345110000000201],
              [84.359093000000129, 22.345042],
              [84.361717000000141, 22.348529],
              [84.367417000000145, 22.34957],
              [84.372002, 22.349051000000141],
              [84.377586, 22.345910000000114],
              [84.387863, 22.34642000000019],
              [84.394493, 22.34385200000019],
              [84.41911200000014, 22.350771000000115],
              [84.426086, 22.348811000000179],
              [84.425843000000128, 22.352029000000126],
              [84.431442000000146, 22.360011],
              [84.427192, 22.361980000000127],
              [84.426941, 22.364651000000148],
              [84.442077, 22.37302],
              [84.447852, 22.379080000000151],
              [84.455651, 22.375222000000118],
              [84.472809, 22.382691000000129],
              [84.477593, 22.38368],
              [84.480209000000158, 22.387240000000126],
              [84.475724000000113, 22.390189],
              [84.475961, 22.393539],
              [84.474479000000116, 22.401731],
              [84.47667, 22.40598100000016],
              [84.481269, 22.405692],
              [84.501792000000179, 22.415319],
              [84.505829, 22.416201],
              [84.521012, 22.414890000000121],
              [84.526626, 22.420021],
              [84.540656, 22.420590000000111],
              [84.543298000000135, 22.417199000000206],
              [84.572158000000101, 22.423011],
              [84.589074000000139, 22.425372000000145],
              [84.593956000000148, 22.428841000000141],
              [84.595305, 22.424939],
              [84.613648000000154, 22.42758],
              [84.625520000000137, 22.427590000000173],
              [84.632102000000131, 22.428649],
              [84.661605000000108, 22.413919],
              [84.66935, 22.416299000000144],
              [84.672821000000155, 22.414931000000134],
              [84.681502, 22.414920000000102],
              [84.691489, 22.412511000000105],
              [84.711327, 22.413901000000173],
              [84.726144, 22.416641000000194],
              [84.74385, 22.41475100000013],
              [84.752693, 22.44201200000014],
              [84.778053, 22.443541000000149],
              [84.791284, 22.442819],
              [84.801246, 22.44371000000012],
              [84.807794, 22.446862000000117],
              [84.810469000000111, 22.441251],
              [84.810479, 22.435229],
              [84.812692000000183, 22.43161],
              [84.828422000000145, 22.429171000000103],
              [84.831627000000111, 22.429921000000146],
              [84.832543, 22.426379000000161],
              [84.835747000000126, 22.427551000000157],
              [84.839469, 22.434030000000117],
              [84.841370000000126, 22.434869000000102],
              [84.847802000000158, 22.43442],
              [84.855346000000154, 22.431979],
              [84.863717000000165, 22.434530000000102],
              [84.871247, 22.438222],
              [84.875252000000131, 22.441180000000195],
              [84.876526000000155, 22.44325],
              [84.8778, 22.442511000000192],
              [84.87947, 22.4322],
              [84.881501, 22.429440000000163],
              [84.881989000000118, 22.426249],
              [84.880250000000146, 22.417591000000122],
              [84.893799, 22.418010000000145],
              [84.907706, 22.419640000000182],
              [84.916397, 22.42338],
              [84.919868, 22.425992000000118],
              [84.918152000000177, 22.42857],
              [84.917397, 22.434379],
              [84.925338000000167, 22.43661],
              [84.931366000000125, 22.439649000000198],
              [84.940772, 22.447429000000167],
              [84.947281000000132, 22.451081000000151],
              [84.952446000000108, 22.45277],
              [84.953362, 22.44552],
              [84.952439, 22.43945],
              [84.954581000000175, 22.438901],
              [84.957282, 22.441859],
              [84.960243, 22.443719000000151],
              [84.97779, 22.45093],
              [84.994134, 22.458271000000131],
              [85.000497, 22.45836],
              [85.021577, 22.467110000000154],
              [85.028106, 22.468202000000129],
              [85.031564000000145, 22.469781000000175],
              [85.033310000000185, 22.476922],
              [85.035445, 22.477291000000204],
              [85.03733, 22.47508],
              [85.042237, 22.476940000000123],
              [85.046722, 22.477391000000122],
              [85.051399, 22.479419],
              [85.06249200000012, 22.47841],
              [85.073197000000135, 22.472869],
              [85.073639000000114, 22.466681],
              [85.070938, 22.461161000000171],
              [85.071107, 22.455901000000146],
              [85.060486, 22.449510000000199],
              [85.057038, 22.44471],
              [85.058152, 22.439731],
              [85.062897, 22.436082000000106],
              [85.063691, 22.423221000000179],
              [85.068092, 22.418070000000167],
              [85.074592, 22.413459],
              [85.077263000000116, 22.408310000000135],
              [85.077201000000159, 22.40303],
              [85.080681000000112, 22.395461000000118],
              [85.083077000000145, 22.378440000000122],
              [85.07788, 22.369159000000135],
              [85.07504300000015, 22.36097],
              [85.075492000000139, 22.355779],
              [85.074058000000136, 22.348590000000165],
              [85.079902000000146, 22.34439],
              [85.082161, 22.341329000000137],
              [85.092957000000169, 22.341092],
              [85.090461, 22.324871000000137],
              [85.085908, 22.316981000000165],
              [85.087959000000168, 22.314082],
              [85.095124, 22.312391000000158],
              [85.101228, 22.314330000000208],
              [85.107728000000151, 22.31523100000015],
              [85.114037, 22.314212],
              [85.112184, 22.305070000000164],
              [85.114837, 22.30038],
              [85.114456000000118, 22.29049000000014],
              [85.108359000000149, 22.289472],
              [85.105294, 22.29114],
              [85.098573000000144, 22.28792],
              [85.082352, 22.277709],
              [85.070512, 22.272159],
              [85.06942, 22.267581000000174],
              [85.069901000000115, 22.260290000000165],
              [85.074318000000162, 22.250941],
              [85.072066000000163, 22.245719000000175],
              [85.068108, 22.24344],
              [85.069482, 22.230650000000189],
              [85.06253700000012, 22.216159],
              [85.058800000000176, 22.205951],
              [85.046921000000154, 22.185792000000159],
              [85.049605, 22.17931],
              [85.04779100000016, 22.174300000000184],
              [85.041451000000151, 22.170660000000105],
              [85.033225, 22.160842],
              [85.028022000000178, 22.157359000000209],
              [85.025399, 22.154002],
              [85.026199000000119, 22.14845],
              [85.030313, 22.142461000000132],
              [85.031151, 22.137360000000108],
              [85.027352000000164, 22.122561000000129],
              [85.024291, 22.117942000000195],
              [85.023742, 22.111991],
              [85.019494000000108, 22.108390000000149],
              [84.99363, 22.097949000000138],
              [84.985863000000137, 22.092570000000187],
              [84.983467000000104, 22.091490000000185],
              [84.980500000000163, 22.091260000000201],
              [84.979821000000101, 22.08468],
              [84.98104, 22.082421000000174],
              [84.987426000000127, 22.076739],
              [84.993598000000119, 22.077209000000206],
              [85.00232, 22.079942],
              [85.007202, 22.083130000000207],
              [85.009019000000109, 22.090651],
              [85.014069000000163, 22.09371],
              [85.019952, 22.103371000000202],
              [85.027122000000119, 22.101140000000154],
              [85.031181, 22.102480000000178],
              [85.035133, 22.108130000000124],
              [85.043899, 22.110701],
              [85.069450000000103, 22.107129],
              [85.076233000000144, 22.10297],
              [85.084098, 22.100440000000155],
              [85.09543700000016, 22.099451],
              [85.099006, 22.096121000000206],
              [85.099708, 22.084539],
              [85.104478000000185, 22.082781000000121],
              [85.10897, 22.080021],
              [85.110283, 22.075862000000136],
              [85.113296, 22.07108],
              [85.118882, 22.0664720000002],
              [85.125396, 22.069120000000108],
              [85.135064, 22.07114],
              [85.140839000000128, 22.073551],
              [85.148910000000157, 22.072639],
              [85.155549, 22.070460000000136],
              [85.157807, 22.066980000000108],
              [85.158965, 22.061921000000208],
              [85.163749000000138, 22.053000000000164],
              [85.167207, 22.04869],
              [85.170808000000122, 22.048191000000198],
              [85.16983, 22.0531],
              [85.164367000000112, 22.06523],
              [85.169609, 22.066100000000116],
              [85.172462, 22.06819],
              [85.176749, 22.06672],
              [85.179131, 22.064790000000126],
              [85.183457, 22.054930000000176],
              [85.186996000000164, 22.052731000000101],
              [85.192323, 22.051152],
              [85.210747000000126, 22.043181],
              [85.214608, 22.037281],
              [85.213897, 22.027161],
              [85.213838000000109, 22.016281000000156],
              [85.21488800000013, 22.010711],
              [85.218353000000121, 22.006670000000206],
              [85.222129, 22.003449000000156],
              [85.230943000000181, 22.000270000000164],
              [85.227310000000131, 21.996940000000162],
              [85.230371, 21.992929000000114],
              [85.239312, 21.986121000000132],
              [85.246536000000134, 21.97901],
              [85.256387, 21.97153],
              [85.259361, 21.96851],
              [85.262398358159913, 21.963952453353549],
              [85.263862261290726, 21.961755871174653],
              [85.266404000000179, 21.957942],
              [85.268646, 21.955829000000161],
              [85.273407000000162, 21.953181],
              [85.277749, 21.95128],
            ],
          ],
        },
      },
    ],
  };